var _defineProperty = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _objectWithoutProperties = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;

var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _assertThisInitialized = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/assertThisInitialized.js").default;

var _toConsumableArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _possibleConstructorReturn = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js").default;

var _wrapNativeSuper = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/wrapNativeSuper.js").default;

var _regeneratorRuntime = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;

var _createForOfIteratorHelper = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var _slicedToArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _get = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/get.js").default;

var _getPrototypeOf = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/getPrototypeOf.js").default;

var _inherits = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/inherits.js").default;

var _createSuper = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createSuper.js").default;

var _classCallCheck = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createClass.js").default;

var _excluded = ["group"],
    _excluded2 = ["children", "isHtml"],
    _excluded3 = ["className"],
    _excluded4 = ["layout"],
    _excluded5 = ["clientIds", "direction", "orientation"],
    _excluded6 = ["isEnabled", "onToggle", "isOpen", "innerRef"],
    _excluded7 = ["isDisabled", "__experimentalFeatures"],
    _excluded8 = ["clientIds", "__experimentalSelectBlock", "children"],
    _excluded9 = ["clientIds"],
    _excluded10 = ["focusOnMount", "isFixed"],
    _excluded11 = ["children", "__unstableContentRef"],
    _excluded12 = ["onChange", "values"],
    _excluded13 = ["onChange", "values"],
    _excluded14 = ["isLinked"],
    _excluded15 = ["onChange", "value"],
    _excluded16 = ["children"],
    _excluded17 = ["className", "colors", "gradients", "disableCustomColors", "disableCustomGradients", "children", "settings", "title", "showTitle", "__experimentalHasMultipleOrigins", "__experimentalIsRenderedInSidebar", "enableAlpha"],
    _excluded18 = ["value", "tagName"],
    _excluded19 = ["value", "onChange", "fontFamilies"],
    _excluded20 = ["contentRef", "children", "head", "tabIndex"],
    _excluded21 = ["className", "isFirst", "item", "onSelect", "onHover", "isDraggable"],
    _excluded22 = ["isFirst", "as", "children"],
    _excluded23 = ["onModalClose"],
    _excluded24 = ["onClick"],
    _excluded25 = ["Slot"],
    _excluded26 = ["__experimentalGroup", "bubblesVirtually", "label"],
    _excluded27 = ["onClick", "onToggleExpanded", "block", "isSelected", "position", "siblingBlockCount", "level"],
    _excluded28 = ["blocks", "onSelect", "__experimentalFeatures", "__experimentalPersistentListViewFeatures", "__experimentalHideContainerBlockActions", "showNestedBlocks", "showBlockMovers"],
    _excluded29 = ["isSelected", "position", "level", "rowCount", "children", "className", "path"],
    _excluded30 = ["children", "focusOnMount", "__experimentalInitialIndex", "__experimentalOnIndexChange"],
    _excluded31 = ["colorSettings"],
    _excluded32 = ["value", "onChange"],
    _excluded33 = ["__experimentalVersion"],
    _excluded34 = ["className", "onChange"],
    _excluded35 = ["useSubRegistry", "registry"],
    _excluded36 = ["children", "tagName", "value", "onChange", "isSelected", "multiline", "inlineToolbar", "wrapperClassName", "autocompleters", "onReplace", "placeholder", "allowedFormats", "formattingControls", "withoutInteractiveFormatting", "onRemove", "onMerge", "onSplit", "__unstableOnSplitAtEnd", "__unstableOnSplitMiddle", "identifier", "preserveWhiteSpace", "__unstablePastePlainText", "__unstableEmbedURLOnPaste", "__unstableDisableFormats", "disableLineBreaks", "unstableOnFocus", "__unstableAllowPrefixTransformations"],
    _excluded37 = ["value", "tagName", "multiline"],
    _excluded38 = ["name", "shortcutType", "shortcutCharacter"],
    _excluded39 = ["units"],
    _excluded40 = ["additionalControls", "children", "renderSettings", "position", "focusOnMount"],
    _excluded41 = ["autocompleteRef", "className", "onChangeInputValue", "value"],
    _excluded42 = ["className", "linkClassName", "onEditLinkClick", "url", "urlLabel"],
    _excluded43 = ["children"],
    _excluded44 = ["innerBlocks"],
    _excluded45 = ["innerBlocks"],
    _excluded46 = ["icon", "size"];

/*! For license information please see wp-blockEditor.js.LICENSE.txt */
!function webpackUniversalModuleDefinition(l, s) {
  "object" == typeof exports && "object" == typeof module ? module.exports = s() : "function" == typeof define && define.amd ? define([], s) : "object" == typeof exports ? exports["@wordpress/block-editor"] = s() : (l.wp = l.wp || {}, l.wp.blockEditor = s());
}(self, function () {
  return function () {
    var l = {
      5221: function _(l) {
        function _extends() {
          return l.exports = _extends = Object.assign || function (l) {
            for (var s = 1; s < arguments.length; s++) {
              var c = arguments[s];

              for (var m in c) {
                Object.prototype.hasOwnProperty.call(c, m) && (l[m] = c[m]);
              }
            }

            return l;
          }, l.exports.__esModule = !0, l.exports.default = l.exports, _extends.apply(this, arguments);
        }

        l.exports = _extends, l.exports.__esModule = !0, l.exports.default = l.exports;
      },
      8424: function _(l) {
        l.exports = function _interopRequireDefault(l) {
          return l && l.__esModule ? l : {
            default: l
          };
        }, l.exports.__esModule = !0, l.exports.default = l.exports;
      },
      3822: function _(l, s, c) {
        "use strict";

        c.d(s, {
          rS: function rS() {
            return AnimatedObject;
          },
          eC: function eC() {
            return AnimatedString;
          },
          iG: function iG() {
            return AnimatedValue;
          },
          Ld: function Ld() {
            return createHost;
          },
          ys: function ys() {
            return getAnimated;
          },
          sb: function sb() {
            return getAnimatedType;
          },
          He: function He() {
            return getPayload;
          },
          f3: function f3() {
            return setAnimated;
          }
        });
        var m = c(2446),
            v = c(9497);

        var _ = Symbol.for("Animated:node"),
            getAnimated = function getAnimated(l) {
          return l && l[_];
        },
            setAnimated = function setAnimated(l, s) {
          return (0, m.dE)(l, _, s);
        },
            getPayload = function getPayload(l) {
          return l && l[_] && l[_].getPayload();
        };

        var Animated = /*#__PURE__*/function () {
          function Animated() {
            _classCallCheck(this, Animated);

            this.payload = void 0, setAnimated(this, this);
          }

          _createClass(Animated, [{
            key: "getPayload",
            value: function getPayload() {
              return this.payload || [];
            }
          }]);

          return Animated;
        }();

        var AnimatedValue = /*#__PURE__*/function (_Animated) {
          _inherits(AnimatedValue, _Animated);

          var _super = _createSuper(AnimatedValue);

          function AnimatedValue(l) {
            var _this;

            _classCallCheck(this, AnimatedValue);

            _this = _super.call(this), _this.done = !0, _this.elapsedTime = void 0, _this.lastPosition = void 0, _this.lastVelocity = void 0, _this.v0 = void 0, _this.durationProgress = 0, _this._value = l, m.is.num(_this._value) && (_this.lastPosition = _this._value);
            return _this;
          }

          _createClass(AnimatedValue, [{
            key: "getPayload",
            value: function getPayload() {
              return [this];
            }
          }, {
            key: "getValue",
            value: function getValue() {
              return this._value;
            }
          }, {
            key: "setValue",
            value: function setValue(l, s) {
              return m.is.num(l) && (this.lastPosition = l, s && (l = Math.round(l / s) * s, this.done && (this.lastPosition = l))), this._value !== l && (this._value = l, !0);
            }
          }, {
            key: "reset",
            value: function reset() {
              var l = this.done;
              this.done = !1, m.is.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, l && (this.lastVelocity = null), this.v0 = null);
            }
          }], [{
            key: "create",
            value: function create(l) {
              return new AnimatedValue(l);
            }
          }]);

          return AnimatedValue;
        }(Animated);

        var AnimatedString = /*#__PURE__*/function (_AnimatedValue) {
          _inherits(AnimatedString, _AnimatedValue);

          var _super2 = _createSuper(AnimatedString);

          function AnimatedString(l) {
            var _this2;

            _classCallCheck(this, AnimatedString);

            _this2 = _super2.call(this, 0), _this2._string = null, _this2._toString = void 0, _this2._toString = (0, m.mD)({
              output: [l, l]
            });
            return _this2;
          }

          _createClass(AnimatedString, [{
            key: "getValue",
            value: function getValue() {
              var l = this._string;
              return null == l ? this._string = this._toString(this._value) : l;
            }
          }, {
            key: "setValue",
            value: function setValue(l) {
              if (m.is.str(l)) {
                if (l == this._string) return !1;
                this._string = l, this._value = 1;
              } else {
                if (!_get(_getPrototypeOf(AnimatedString.prototype), "setValue", this).call(this, l)) return !1;
                this._string = null;
              }

              return !0;
            }
          }, {
            key: "reset",
            value: function reset(l) {
              l && (this._toString = (0, m.mD)({
                output: [this.getValue(), l]
              })), this._value = 0, _get(_getPrototypeOf(AnimatedString.prototype), "reset", this).call(this);
            }
          }], [{
            key: "create",
            value: function create(l) {
              return new AnimatedString(l);
            }
          }]);

          return AnimatedString;
        }(AnimatedValue);

        var k = {
          dependencies: null
        };

        var AnimatedObject = /*#__PURE__*/function (_Animated2) {
          _inherits(AnimatedObject, _Animated2);

          var _super3 = _createSuper(AnimatedObject);

          function AnimatedObject(l) {
            var _this3;

            _classCallCheck(this, AnimatedObject);

            _this3 = _super3.call(this), _this3.source = l, _this3.setValue(l);
            return _this3;
          }

          _createClass(AnimatedObject, [{
            key: "getValue",
            value: function getValue(l) {
              var s = {};
              return (0, m.rU)(this.source, function (c, v) {
                var k;
                (k = c) && k[_] === k ? s[v] = c.getValue(l) : (0, m.j$)(c) ? s[v] = (0, m.je)(c) : l || (s[v] = c);
              }), s;
            }
          }, {
            key: "setValue",
            value: function setValue(l) {
              this.source = l, this.payload = this._makePayload(l);
            }
          }, {
            key: "reset",
            value: function reset() {
              this.payload && (0, m.S6)(this.payload, function (l) {
                return l.reset();
              });
            }
          }, {
            key: "_makePayload",
            value: function _makePayload(l) {
              if (l) {
                var _s = new Set();

                return (0, m.rU)(l, this._addToPayload, _s), Array.from(_s);
              }
            }
          }, {
            key: "_addToPayload",
            value: function _addToPayload(l) {
              var _this4 = this;

              k.dependencies && (0, m.j$)(l) && k.dependencies.add(l);
              var s = getPayload(l);
              s && (0, m.S6)(s, function (l) {
                return _this4.add(l);
              });
            }
          }]);

          return AnimatedObject;
        }(Animated);

        var AnimatedArray = /*#__PURE__*/function (_AnimatedObject) {
          _inherits(AnimatedArray, _AnimatedObject);

          var _super4 = _createSuper(AnimatedArray);

          function AnimatedArray(l) {
            _classCallCheck(this, AnimatedArray);

            return _super4.call(this, l);
          }

          _createClass(AnimatedArray, [{
            key: "getValue",
            value: function getValue() {
              return this.source.map(function (l) {
                return l.getValue();
              });
            }
          }, {
            key: "setValue",
            value: function setValue(l) {
              var s = this.getPayload();
              return l.length == s.length ? s.map(function (s, c) {
                return s.setValue(l[c]);
              }).some(Boolean) : (_get(_getPrototypeOf(AnimatedArray.prototype), "setValue", this).call(this, l.map(makeAnimated)), !0);
            }
          }], [{
            key: "create",
            value: function create(l) {
              return new AnimatedArray(l);
            }
          }]);

          return AnimatedArray;
        }(AnimatedObject);

        function makeAnimated(l) {
          return ((0, m.Df)(l) ? AnimatedString : AnimatedValue).create(l);
        }

        function getAnimatedType(l) {
          var s = getAnimated(l);
          return s ? s.constructor : m.is.arr(l) ? AnimatedArray : (0, m.Df)(l) ? AnimatedString : AnimatedValue;
        }

        function _extends() {
          return _extends = Object.assign || function (l) {
            for (var s = 1; s < arguments.length; s++) {
              var c = arguments[s];

              for (var m in c) {
                Object.prototype.hasOwnProperty.call(c, m) && (l[m] = c[m]);
              }
            }

            return l;
          }, _extends.apply(this, arguments);
        }

        var withAnimated = function withAnimated(l, s) {
          var c = !m.is.fun(l) || l.prototype && l.prototype.isReactComponent;
          return (0, v.forwardRef)(function (_, y) {
            var E = (0, v.useRef)(null),
                w = c && (0, v.useCallback)(function (l) {
              E.current = function updateRef(l, s) {
                l && (m.is.fun(l) ? l(s) : l.current = s);
                return s;
              }(y, l);
            }, [y]),
                _getAnimatedState = function getAnimatedState(l, s) {
              var c = new Set();
              k.dependencies = c, l.style && (l = _extends({}, l, {
                style: s.createAnimatedStyle(l.style)
              }));
              return l = new AnimatedObject(l), k.dependencies = null, [l, c];
            }(_, s),
                _getAnimatedState2 = _slicedToArray(_getAnimatedState, 2),
                C = _getAnimatedState2[0],
                S = _getAnimatedState2[1],
                B = (0, m.NW)(),
                callback = function callback() {
              var l = E.current;
              if (c && !l) return;
              !1 === (!!l && s.applyAnimatedValues(l, C.getValue(!0))) && B();
            },
                P = new PropsObserver(callback, S),
                O = (0, v.useRef)();

            (0, m.bt)(function () {
              var l = O.current;
              O.current = P, (0, m.S6)(S, function (l) {
                return (0, m.UI)(l, P);
              }), l && ((0, m.S6)(l.deps, function (s) {
                return (0, m.iL)(s, l);
              }), m.Wn.cancel(l.update));
            }), (0, v.useEffect)(callback, []), (0, m.tf)(function () {
              return function () {
                var l = O.current;
                (0, m.S6)(l.deps, function (s) {
                  return (0, m.iL)(s, l);
                });
              };
            });
            var L = s.getComponentProps(C.getValue());
            return v.createElement(l, _extends({}, L, {
              ref: w
            }));
          });
        };

        var PropsObserver = /*#__PURE__*/function () {
          function PropsObserver(l, s) {
            _classCallCheck(this, PropsObserver);

            this.update = l, this.deps = s;
          }

          _createClass(PropsObserver, [{
            key: "eventObserved",
            value: function eventObserved(l) {
              "change" == l.type && m.Wn.write(this.update);
            }
          }]);

          return PropsObserver;
        }();

        var y = Symbol.for("AnimatedComponent"),
            createHost = function createHost(l) {
          var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              _ref$applyAnimatedVal = _ref.applyAnimatedValues,
              s = _ref$applyAnimatedVal === void 0 ? function () {
            return !1;
          } : _ref$applyAnimatedVal,
              _ref$createAnimatedSt = _ref.createAnimatedStyle,
              c = _ref$createAnimatedSt === void 0 ? function (l) {
            return new AnimatedObject(l);
          } : _ref$createAnimatedSt,
              _ref$getComponentProp = _ref.getComponentProps,
              v = _ref$getComponentProp === void 0 ? function (l) {
            return l;
          } : _ref$getComponentProp;

          var _ = {
            applyAnimatedValues: s,
            createAnimatedStyle: c,
            getComponentProps: v
          },
              animated = function animated(l) {
            var s = getDisplayName(l) || "Anonymous";
            return (l = m.is.str(l) ? animated[l] || (animated[l] = withAnimated(l, _)) : l[y] || (l[y] = withAnimated(l, _))).displayName = "Animated(".concat(s, ")"), l;
          };

          return (0, m.rU)(l, function (s, c) {
            m.is.arr(l) && (c = getDisplayName(s)), animated[c] = animated(s);
          }), {
            animated: animated
          };
        },
            getDisplayName = function getDisplayName(l) {
          return m.is.str(l) ? l : l && m.is.str(l.displayName) ? l.displayName : m.is.fun(l) && l.name || null;
        };
      },
      5423: function _(l, s, c) {
        "use strict";

        c.r(s), c.d(s, {
          Globals: function Globals() {
            return m.OH;
          },
          createInterpolator: function createInterpolator() {
            return m.mD;
          },
          BailSignal: function BailSignal() {
            return _BailSignal;
          },
          Controller: function Controller() {
            return _Controller;
          },
          FrameValue: function FrameValue() {
            return _FrameValue;
          },
          Interpolation: function Interpolation() {
            return _Interpolation;
          },
          Spring: function Spring() {
            return _Spring;
          },
          SpringContext: function SpringContext() {
            return _SpringContext;
          },
          SpringRef: function SpringRef() {
            return _SpringRef;
          },
          SpringValue: function SpringValue() {
            return _SpringValue;
          },
          Trail: function Trail() {
            return _Trail;
          },
          Transition: function Transition() {
            return _Transition;
          },
          config: function config() {
            return S;
          },
          easings: function easings() {
            return R;
          },
          inferTo: function inferTo() {
            return _inferTo;
          },
          interpolate: function interpolate() {
            return _interpolate;
          },
          to: function to() {
            return _to;
          },
          update: function update() {
            return J;
          },
          useChain: function useChain() {
            return _useChain;
          },
          useSpring: function useSpring() {
            return _useSpring;
          },
          useSpringRef: function useSpringRef() {
            return _useSpringRef;
          },
          useSprings: function useSprings() {
            return _useSprings;
          },
          useTrail: function useTrail() {
            return _useTrail;
          },
          useTransition: function useTransition() {
            return _useTransition;
          }
        });

        var m = c(2446),
            v = c(9497),
            _ = c(3822),
            k = c(1025),
            y = {};

        var _loop = function _loop(_l2) {
          ["default", "Globals", "createInterpolator", "BailSignal", "Controller", "FrameValue", "Interpolation", "Spring", "SpringContext", "SpringRef", "SpringValue", "Trail", "Transition", "config", "easings", "inferTo", "interpolate", "to", "update", "useChain", "useSpring", "useSpringRef", "useSprings", "useTrail", "useTransition"].indexOf(_l2) < 0 && (y[_l2] = function () {
            return k[_l2];
          });
        };

        for (var _l2 in k) {
          _loop(_l2);
        }

        c.d(s, y);
        var E = c(5419);
        y = {};

        var _loop2 = function _loop2(_l3) {
          ["default", "Globals", "createInterpolator", "BailSignal", "Controller", "FrameValue", "Interpolation", "Spring", "SpringContext", "SpringRef", "SpringValue", "Trail", "Transition", "config", "easings", "inferTo", "interpolate", "to", "update", "useChain", "useSpring", "useSpringRef", "useSprings", "useTrail", "useTransition"].indexOf(_l3) < 0 && (y[_l3] = function () {
            return E[_l3];
          });
        };

        for (var _l3 in E) {
          _loop2(_l3);
        }

        function _extends() {
          return _extends = Object.assign || function (l) {
            for (var s = 1; s < arguments.length; s++) {
              var c = arguments[s];

              for (var m in c) {
                Object.prototype.hasOwnProperty.call(c, m) && (l[m] = c[m]);
              }
            }

            return l;
          }, _extends.apply(this, arguments);
        }

        function callProp(l) {
          for (var _len = arguments.length, s = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            s[_key - 1] = arguments[_key];
          }

          return m.is.fun(l) ? l.apply(void 0, s) : l;
        }

        c.d(s, y);

        var matchProp = function matchProp(l, s) {
          return !0 === l || !!(s && l && (m.is.fun(l) ? l(s) : (0, m.qo)(l).includes(s)));
        },
            resolveProp = function resolveProp(l, s) {
          return m.is.obj(l) ? s && l[s] : l;
        },
            getDefaultProp = function getDefaultProp(l, s) {
          return !0 === l.default ? l[s] : l.default ? l.default[s] : void 0;
        },
            noopTransform = function noopTransform(l) {
          return l;
        },
            getDefaultProps = function getDefaultProps(l) {
          var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noopTransform;
          var c = w;
          l.default && !0 !== l.default && (l = l.default, c = Object.keys(l));
          var v = {};

          var _iterator = _createForOfIteratorHelper(c),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _2 = _step.value;

              var _c = s(l[_2], _2);

              m.is.und(_c) || (v[_2] = _c);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return v;
        },
            w = ["config", "onProps", "onStart", "onChange", "onPause", "onResume", "onRest"],
            C = {
          config: 1,
          from: 1,
          to: 1,
          ref: 1,
          loop: 1,
          reset: 1,
          pause: 1,
          cancel: 1,
          reverse: 1,
          immediate: 1,
          default: 1,
          delay: 1,
          onProps: 1,
          onStart: 1,
          onChange: 1,
          onPause: 1,
          onResume: 1,
          onRest: 1,
          onResolve: 1,
          items: 1,
          trail: 1,
          sort: 1,
          expires: 1,
          initial: 1,
          enter: 1,
          update: 1,
          leave: 1,
          children: 1,
          onDestroyed: 1,
          keys: 1,
          callId: 1,
          parentId: 1
        };

        function _inferTo(l) {
          var s = function getForwardProps(l) {
            var s = {};
            var c = 0;
            if ((0, m.rU)(l, function (l, m) {
              C[m] || (s[m] = l, c++);
            }), c) return s;
          }(l);

          if (s) {
            var _c2 = {
              to: s
            };
            return (0, m.rU)(l, function (l, m) {
              return m in s || (_c2[m] = l);
            }), _c2;
          }

          return _extends({}, l);
        }

        function computeGoal(l) {
          return l = (0, m.je)(l), m.is.arr(l) ? l.map(computeGoal) : (0, m.Df)(l) ? m.OH.createStringInterpolator({
            range: [0, 1],
            output: [l, l]
          })(1) : l;
        }

        function hasProps(l) {
          for (var _s2 in l) {
            return !0;
          }

          return !1;
        }

        function isAsyncTo(l) {
          return m.is.fun(l) || m.is.arr(l) && m.is.obj(l[0]);
        }

        function detachRefs(l, s) {
          var c;
          null == (c = l.ref) || c.delete(l), null == s || s.delete(l);
        }

        function replaceRef(l, s) {
          var c;
          s && l.ref !== s && (null == (c = l.ref) || c.delete(l), s.add(l), l.ref = s);
        }

        function _useChain(l, s) {
          var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e3;
          (0, m.bt)(function () {
            if (s) {
              var _v = 0;
              (0, m.S6)(l, function (l, _) {
                var k = l.current;

                if (k.length) {
                  var _y = c * s[_];

                  isNaN(_y) ? _y = _v : _v = _y, (0, m.S6)(k, function (l) {
                    (0, m.S6)(l.queue, function (l) {
                      var s = l.delay;

                      l.delay = function (l) {
                        return _y + callProp(s || 0, l);
                      };
                    });
                  }), l.start();
                }
              });
            } else {
              var _s3 = Promise.resolve();

              (0, m.S6)(l, function (l) {
                var c = l.current;

                if (c.length) {
                  var _v2 = c.map(function (l) {
                    var s = l.queue;
                    return l.queue = [], s;
                  });

                  _s3 = _s3.then(function () {
                    return (0, m.S6)(c, function (l, s) {
                      return (0, m.S6)(_v2[s] || [], function (s) {
                        return l.queue.push(s);
                      });
                    }), Promise.all(l.start());
                  });
                }
              });
            }
          });
        }

        var S = {
          default: {
            tension: 170,
            friction: 26
          },
          gentle: {
            tension: 120,
            friction: 14
          },
          wobbly: {
            tension: 180,
            friction: 12
          },
          stiff: {
            tension: 210,
            friction: 20
          },
          slow: {
            tension: 280,
            friction: 60
          },
          molasses: {
            tension: 280,
            friction: 120
          }
        },
            B = 1.70158,
            P = 1.525 * B,
            O = B + 1,
            L = 2 * Math.PI / 3,
            V = 2 * Math.PI / 4.5,
            bounceOut = function bounceOut(l) {
          var s = 7.5625,
              c = 2.75;
          return l < 1 / c ? s * l * l : l < 2 / c ? s * (l -= 1.5 / c) * l + .75 : l < 2.5 / c ? s * (l -= 2.25 / c) * l + .9375 : s * (l -= 2.625 / c) * l + .984375;
        },
            R = {
          linear: function linear(l) {
            return l;
          },
          easeInQuad: function easeInQuad(l) {
            return l * l;
          },
          easeOutQuad: function easeOutQuad(l) {
            return 1 - (1 - l) * (1 - l);
          },
          easeInOutQuad: function easeInOutQuad(l) {
            return l < .5 ? 2 * l * l : 1 - Math.pow(-2 * l + 2, 2) / 2;
          },
          easeInCubic: function easeInCubic(l) {
            return l * l * l;
          },
          easeOutCubic: function easeOutCubic(l) {
            return 1 - Math.pow(1 - l, 3);
          },
          easeInOutCubic: function easeInOutCubic(l) {
            return l < .5 ? 4 * l * l * l : 1 - Math.pow(-2 * l + 2, 3) / 2;
          },
          easeInQuart: function easeInQuart(l) {
            return l * l * l * l;
          },
          easeOutQuart: function easeOutQuart(l) {
            return 1 - Math.pow(1 - l, 4);
          },
          easeInOutQuart: function easeInOutQuart(l) {
            return l < .5 ? 8 * l * l * l * l : 1 - Math.pow(-2 * l + 2, 4) / 2;
          },
          easeInQuint: function easeInQuint(l) {
            return l * l * l * l * l;
          },
          easeOutQuint: function easeOutQuint(l) {
            return 1 - Math.pow(1 - l, 5);
          },
          easeInOutQuint: function easeInOutQuint(l) {
            return l < .5 ? 16 * l * l * l * l * l : 1 - Math.pow(-2 * l + 2, 5) / 2;
          },
          easeInSine: function easeInSine(l) {
            return 1 - Math.cos(l * Math.PI / 2);
          },
          easeOutSine: function easeOutSine(l) {
            return Math.sin(l * Math.PI / 2);
          },
          easeInOutSine: function easeInOutSine(l) {
            return -(Math.cos(Math.PI * l) - 1) / 2;
          },
          easeInExpo: function easeInExpo(l) {
            return 0 === l ? 0 : Math.pow(2, 10 * l - 10);
          },
          easeOutExpo: function easeOutExpo(l) {
            return 1 === l ? 1 : 1 - Math.pow(2, -10 * l);
          },
          easeInOutExpo: function easeInOutExpo(l) {
            return 0 === l ? 0 : 1 === l ? 1 : l < .5 ? Math.pow(2, 20 * l - 10) / 2 : (2 - Math.pow(2, -20 * l + 10)) / 2;
          },
          easeInCirc: function easeInCirc(l) {
            return 1 - Math.sqrt(1 - Math.pow(l, 2));
          },
          easeOutCirc: function easeOutCirc(l) {
            return Math.sqrt(1 - Math.pow(l - 1, 2));
          },
          easeInOutCirc: function easeInOutCirc(l) {
            return l < .5 ? (1 - Math.sqrt(1 - Math.pow(2 * l, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * l + 2, 2)) + 1) / 2;
          },
          easeInBack: function easeInBack(l) {
            return O * l * l * l - B * l * l;
          },
          easeOutBack: function easeOutBack(l) {
            return 1 + O * Math.pow(l - 1, 3) + B * Math.pow(l - 1, 2);
          },
          easeInOutBack: function easeInOutBack(l) {
            return l < .5 ? Math.pow(2 * l, 2) * (7.189819 * l - P) / 2 : (Math.pow(2 * l - 2, 2) * ((P + 1) * (2 * l - 2) + P) + 2) / 2;
          },
          easeInElastic: function easeInElastic(l) {
            return 0 === l ? 0 : 1 === l ? 1 : -Math.pow(2, 10 * l - 10) * Math.sin((10 * l - 10.75) * L);
          },
          easeOutElastic: function easeOutElastic(l) {
            return 0 === l ? 0 : 1 === l ? 1 : Math.pow(2, -10 * l) * Math.sin((10 * l - .75) * L) + 1;
          },
          easeInOutElastic: function easeInOutElastic(l) {
            return 0 === l ? 0 : 1 === l ? 1 : l < .5 ? -Math.pow(2, 20 * l - 10) * Math.sin((20 * l - 11.125) * V) / 2 : Math.pow(2, -20 * l + 10) * Math.sin((20 * l - 11.125) * V) / 2 + 1;
          },
          easeInBounce: function easeInBounce(l) {
            return 1 - bounceOut(1 - l);
          },
          easeOutBounce: bounceOut,
          easeInOutBounce: function easeInOutBounce(l) {
            return l < .5 ? (1 - bounceOut(1 - 2 * l)) / 2 : (1 + bounceOut(2 * l - 1)) / 2;
          }
        },
            A = _extends({}, S.default, {
          mass: 1,
          damping: 1,
          easing: R.linear,
          clamp: !1
        });

        var AnimationConfig = /*#__PURE__*/_createClass(function AnimationConfig() {
          _classCallCheck(this, AnimationConfig);

          this.tension = void 0, this.friction = void 0, this.frequency = void 0, this.damping = void 0, this.mass = void 0, this.velocity = 0, this.restVelocity = void 0, this.precision = void 0, this.progress = void 0, this.duration = void 0, this.easing = void 0, this.clamp = void 0, this.bounce = void 0, this.decay = void 0, this.round = void 0, Object.assign(this, A);
        });

        function sanitizeConfig(l, s) {
          if (m.is.und(s.decay)) {
            var _c3 = !m.is.und(s.tension) || !m.is.und(s.friction);

            !_c3 && m.is.und(s.frequency) && m.is.und(s.damping) && m.is.und(s.mass) || (l.duration = void 0, l.decay = void 0), _c3 && (l.frequency = void 0);
          } else l.duration = void 0;
        }

        var z = [];

        var Animation = /*#__PURE__*/_createClass(function Animation() {
          _classCallCheck(this, Animation);

          this.changed = !1, this.values = z, this.toValues = null, this.fromValues = z, this.to = void 0, this.from = void 0, this.config = new AnimationConfig(), this.immediate = !1;
        });

        function scheduleProps(l, _ref2) {
          var s = _ref2.key,
              c = _ref2.props,
              v = _ref2.defaultProps,
              _ = _ref2.state,
              k = _ref2.actions;
          return new Promise(function (y, E) {
            var w;
            var C,
                S,
                B = matchProp(null != (w = c.cancel) ? w : null == v ? void 0 : v.cancel, s);
            if (B) onStart();else {
              m.is.und(c.pause) || (_.paused = matchProp(c.pause, s));

              var _l4 = null == v ? void 0 : v.pause;

              !0 !== _l4 && (_l4 = _.paused || matchProp(_l4, s)), C = callProp(c.delay || 0, s), _l4 ? (_.resumeQueue.add(onResume), k.pause()) : (k.resume(), onResume());
            }

            function onPause() {
              _.resumeQueue.add(onResume), _.timeouts.delete(S), S.cancel(), C = S.time - m.Wn.now();
            }

            function onResume() {
              C > 0 && !m.OH.skipAnimation ? (_.delayed = !0, S = m.Wn.setTimeout(onStart, C), _.pauseQueue.add(onPause), _.timeouts.add(S)) : onStart();
            }

            function onStart() {
              _.delayed && (_.delayed = !1), _.pauseQueue.delete(onPause), _.timeouts.delete(S), l <= (_.cancelId || 0) && (B = !0);

              try {
                k.start(_extends({}, c, {
                  callId: l,
                  cancel: B
                }), y);
              } catch (l) {
                E(l);
              }
            }
          });
        }

        var getCombinedResult = function getCombinedResult(l, s) {
          return 1 == s.length ? s[0] : s.some(function (l) {
            return l.cancelled;
          }) ? getCancelledResult(l.get()) : s.every(function (l) {
            return l.noop;
          }) ? getNoopResult(l.get()) : getFinishedResult(l.get(), s.every(function (l) {
            return l.finished;
          }));
        },
            getNoopResult = function getNoopResult(l) {
          return {
            value: l,
            noop: !0,
            finished: !0,
            cancelled: !1
          };
        },
            getFinishedResult = function getFinishedResult(l, s) {
          var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          return {
            value: l,
            finished: s,
            cancelled: c
          };
        },
            getCancelledResult = function getCancelledResult(l) {
          return {
            value: l,
            cancelled: !0,
            finished: !1
          };
        };

        function runAsync(l, s, c, v) {
          var _ = s.callId,
              k = s.parentId,
              y = s.onRest,
              E = c.asyncTo,
              w = c.promise;
          return k || l !== E || s.reset ? c.promise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            var C, S, B, P, bailIfEnded, animate, O, _s4;

            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    c.asyncId = _, c.asyncTo = l;
                    C = getDefaultProps(s, function (l, s) {
                      return "onRest" === s ? void 0 : l;
                    });
                    P = new Promise(function (l, s) {
                      return S = l, B = s;
                    }), bailIfEnded = function bailIfEnded(l) {
                      var s = _ <= (c.cancelId || 0) && getCancelledResult(v) || _ !== c.asyncId && getFinishedResult(v, !1);
                      if (s) throw l.result = s, B(l), l;
                    }, animate = function animate(l, s) {
                      var k = new _BailSignal(),
                          y = new SkipAniamtionSignal();
                      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                        var E, w;
                        return _regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                if (!m.OH.skipAnimation) {
                                  _context.next = 2;
                                  break;
                                }

                                throw stopAsync(c), y.result = getFinishedResult(v, !1), B(y), y;

                              case 2:
                                bailIfEnded(k);
                                E = m.is.obj(l) ? _extends({}, l) : _extends({}, s, {
                                  to: l
                                });
                                E.parentId = _, (0, m.rU)(C, function (l, s) {
                                  m.is.und(E[s]) && (E[s] = l);
                                });
                                _context.next = 7;
                                return v.start(E);

                              case 7:
                                w = _context.sent;
                                bailIfEnded(k);
                                _context.t0 = c.paused;

                                if (!_context.t0) {
                                  _context.next = 13;
                                  break;
                                }

                                _context.next = 13;
                                return new Promise(function (l) {
                                  c.resumeQueue.add(l);
                                });

                              case 13:
                                return _context.abrupt("return", w);

                              case 14:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee);
                      }))();
                    };

                    if (!m.OH.skipAnimation) {
                      _context3.next = 5;
                      break;
                    }

                    return _context3.abrupt("return", (stopAsync(c), getFinishedResult(v, !1)));

                  case 5:
                    _context3.prev = 5;
                    _s4 = m.is.arr(l) ? function () {
                      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(l) {
                        var _iterator2, _step2, _s5;

                        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                _iterator2 = _createForOfIteratorHelper(l);
                                _context2.prev = 1;

                                _iterator2.s();

                              case 3:
                                if ((_step2 = _iterator2.n()).done) {
                                  _context2.next = 9;
                                  break;
                                }

                                _s5 = _step2.value;
                                _context2.next = 7;
                                return animate(_s5);

                              case 7:
                                _context2.next = 3;
                                break;

                              case 9:
                                _context2.next = 14;
                                break;

                              case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2["catch"](1);

                                _iterator2.e(_context2.t0);

                              case 14:
                                _context2.prev = 14;

                                _iterator2.f();

                                return _context2.finish(14);

                              case 17:
                              case "end":
                                return _context2.stop();
                            }
                          }
                        }, _callee2, null, [[1, 11, 14, 17]]);
                      }));

                      return function (_x) {
                        return _ref5.apply(this, arguments);
                      };
                    }()(l) : Promise.resolve(l(animate, v.stop.bind(v)));
                    _context3.next = 9;
                    return Promise.all([_s4.then(S), P]);

                  case 9:
                    O = getFinishedResult(v.get(), !0, !1);
                    _context3.next = 21;
                    break;

                  case 12:
                    _context3.prev = 12;
                    _context3.t0 = _context3["catch"](5);

                    if (!(_context3.t0 instanceof _BailSignal)) {
                      _context3.next = 18;
                      break;
                    }

                    O = _context3.t0.result;
                    _context3.next = 21;
                    break;

                  case 18:
                    if (_context3.t0 instanceof SkipAniamtionSignal) {
                      _context3.next = 20;
                      break;
                    }

                    throw _context3.t0;

                  case 20:
                    O = _context3.t0.result;

                  case 21:
                    _context3.prev = 21;
                    _ == c.asyncId && (c.asyncId = k, c.asyncTo = k ? E : void 0, c.promise = k ? w : void 0);
                    return _context3.finish(21);

                  case 24:
                    return _context3.abrupt("return", (m.is.fun(y) && m.Wn.batchedUpdates(function () {
                      y(O, v, v.item);
                    }), O));

                  case 25:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[5, 12, 21, 24]]);
          }))() : w;
        }

        function stopAsync(l, s) {
          (0, m.yl)(l.timeouts, function (l) {
            return l.cancel();
          }), l.pauseQueue.clear(), l.resumeQueue.clear(), l.asyncId = l.asyncTo = l.promise = void 0, s && (l.cancelId = s);
        }

        var _BailSignal = /*#__PURE__*/function (_Error) {
          _inherits(_BailSignal, _Error);

          var _super5 = _createSuper(_BailSignal);

          function _BailSignal() {
            var _this5;

            _classCallCheck(this, _BailSignal);

            _this5 = _super5.call(this, "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."), _this5.result = void 0;
            return _this5;
          }

          return _createClass(_BailSignal);
        }( /*#__PURE__*/_wrapNativeSuper(Error));

        var SkipAniamtionSignal = /*#__PURE__*/function (_Error2) {
          _inherits(SkipAniamtionSignal, _Error2);

          var _super6 = _createSuper(SkipAniamtionSignal);

          function SkipAniamtionSignal() {
            var _this6;

            _classCallCheck(this, SkipAniamtionSignal);

            _this6 = _super6.call(this, "SkipAnimationSignal"), _this6.result = void 0;
            return _this6;
          }

          return _createClass(SkipAniamtionSignal);
        }( /*#__PURE__*/_wrapNativeSuper(Error));

        var isFrameValue = function isFrameValue(l) {
          return l instanceof _FrameValue;
        };

        var D = 1;

        var _FrameValue = /*#__PURE__*/function (_m$B) {
          _inherits(_FrameValue, _m$B);

          var _super7 = _createSuper(_FrameValue);

          function _FrameValue() {
            var _this7;

            _classCallCheck(this, _FrameValue);

            for (var _len2 = arguments.length, l = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              l[_key2] = arguments[_key2];
            }

            _this7 = _super7.call.apply(_super7, [this].concat(l)), _this7.id = D++, _this7.key = void 0, _this7._priority = 0;
            return _this7;
          }

          _createClass(_FrameValue, [{
            key: "priority",
            get: function get() {
              return this._priority;
            },
            set: function set(l) {
              this._priority != l && (this._priority = l, this._onPriorityChange(l));
            }
          }, {
            key: "get",
            value: function get() {
              var l = (0, _.ys)(this);
              return l && l.getValue();
            }
          }, {
            key: "to",
            value: function to() {
              for (var _len3 = arguments.length, l = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                l[_key3] = arguments[_key3];
              }

              return m.OH.to(this, l);
            }
          }, {
            key: "interpolate",
            value: function interpolate() {
              for (var _len4 = arguments.length, l = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                l[_key4] = arguments[_key4];
              }

              return (0, m.LW)(), m.OH.to(this, l);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              return this.get();
            }
          }, {
            key: "observerAdded",
            value: function observerAdded(l) {
              1 == l && this._attach();
            }
          }, {
            key: "observerRemoved",
            value: function observerRemoved(l) {
              0 == l && this._detach();
            }
          }, {
            key: "_attach",
            value: function _attach() {}
          }, {
            key: "_detach",
            value: function _detach() {}
          }, {
            key: "_onChange",
            value: function _onChange(l) {
              var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              (0, m.k0)(this, {
                type: "change",
                parent: this,
                value: l,
                idle: s
              });
            }
          }, {
            key: "_onPriorityChange",
            value: function _onPriorityChange(l) {
              this.idle || m.fT.sort(this), (0, m.k0)(this, {
                type: "priority",
                parent: this,
                priority: l
              });
            }
          }]);

          return _FrameValue;
        }(m.B0);

        var F = Symbol.for("SpringPhase"),
            hasAnimated = function hasAnimated(l) {
          return (1 & l[F]) > 0;
        },
            isAnimating = function isAnimating(l) {
          return (2 & l[F]) > 0;
        },
            isPaused = function isPaused(l) {
          return (4 & l[F]) > 0;
        },
            setActiveBit = function setActiveBit(l, s) {
          return s ? l[F] |= 3 : l[F] &= -3;
        },
            setPausedBit = function setPausedBit(l, s) {
          return s ? l[F] |= 4 : l[F] &= -5;
        };

        var _SpringValue = /*#__PURE__*/function (_FrameValue2) {
          _inherits(_SpringValue, _FrameValue2);

          var _super8 = _createSuper(_SpringValue);

          function _SpringValue(l, s) {
            var _this8;

            _classCallCheck(this, _SpringValue);

            if (_this8 = _super8.call(this), _this8.key = void 0, _this8.animation = new Animation(), _this8.queue = void 0, _this8.defaultProps = {}, _this8._state = {
              paused: !1,
              delayed: !1,
              pauseQueue: new Set(),
              resumeQueue: new Set(),
              timeouts: new Set()
            }, _this8._pendingCalls = new Set(), _this8._lastCallId = 0, _this8._lastToId = 0, _this8._memoizedDuration = 0, !m.is.und(l) || !m.is.und(s)) {
              var _c4 = m.is.obj(l) ? _extends({}, l) : _extends({}, s, {
                from: l
              });

              m.is.und(_c4.default) && (_c4.default = !0), _this8.start(_c4);
            }

            return _possibleConstructorReturn(_this8);
          }

          _createClass(_SpringValue, [{
            key: "idle",
            get: function get() {
              return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
            }
          }, {
            key: "goal",
            get: function get() {
              return (0, m.je)(this.animation.to);
            }
          }, {
            key: "velocity",
            get: function get() {
              var l = (0, _.ys)(this);
              return l instanceof _.iG ? l.lastVelocity || 0 : l.getPayload().map(function (l) {
                return l.lastVelocity || 0;
              });
            }
          }, {
            key: "hasAnimated",
            get: function get() {
              return hasAnimated(this);
            }
          }, {
            key: "isAnimating",
            get: function get() {
              return isAnimating(this);
            }
          }, {
            key: "isPaused",
            get: function get() {
              return isPaused(this);
            }
          }, {
            key: "isDelayed",
            get: function get() {
              return this._state.delayed;
            }
          }, {
            key: "advance",
            value: function advance(l) {
              var _this9 = this;

              var s = !0,
                  c = !1;
              var v = this.animation;
              var k = v.config,
                  y = v.toValues;
              var E = (0, _.He)(v.to);
              !E && (0, m.j$)(v.to) && (y = (0, m.qo)((0, m.je)(v.to))), v.values.forEach(function (w, C) {
                if (w.done) return;
                var S = w.constructor == _.eC ? 1 : E ? E[C].lastPosition : y[C];
                var B = v.immediate,
                    P = S;

                if (!B) {
                  if (P = w.lastPosition, k.tension <= 0) return void (w.done = !0);

                  var _s6 = w.elapsedTime += l;

                  var _c5 = v.fromValues[C],
                      _3 = null != w.v0 ? w.v0 : w.v0 = m.is.arr(k.velocity) ? k.velocity[C] : k.velocity;

                  var _y2;

                  if (m.is.und(k.duration)) {
                    if (k.decay) {
                      var _l5 = !0 === k.decay ? .998 : k.decay,
                          _m = Math.exp(-(1 - _l5) * _s6);

                      P = _c5 + _3 / (1 - _l5) * (1 - _m), B = Math.abs(w.lastPosition - P) < .1, _y2 = _3 * _m;
                    } else {
                      _y2 = null == w.lastVelocity ? _3 : w.lastVelocity;

                      var _s7 = k.precision || (_c5 == S ? .005 : Math.min(1, .001 * Math.abs(S - _c5))),
                          _v3 = k.restVelocity || _s7 / 10,
                          _E = k.clamp ? 0 : k.bounce,
                          _C = !m.is.und(_E),
                          O = _c5 == S ? w.v0 > 0 : _c5 < S;

                      var _L,
                          _V = !1;

                      var _R = 1,
                          _A = Math.ceil(l / _R);

                      for (var _l6 = 0; _l6 < _A && (_L = Math.abs(_y2) > _v3, _L || (B = Math.abs(S - P) <= _s7, !B)); ++_l6) {
                        _C && (_V = P == S || P > S == O, _V && (_y2 = -_y2 * _E, P = S));
                        _y2 += (1e-6 * -k.tension * (P - S) + .001 * -k.friction * _y2) / k.mass * _R, P += _y2 * _R;
                      }
                    }
                  } else {
                    var _m2 = 1;
                    k.duration > 0 && (_this9._memoizedDuration !== k.duration && (_this9._memoizedDuration = k.duration, w.durationProgress > 0 && (w.elapsedTime = k.duration * w.durationProgress, _s6 = w.elapsedTime += l)), _m2 = (k.progress || 0) + _s6 / _this9._memoizedDuration, _m2 = _m2 > 1 ? 1 : _m2 < 0 ? 0 : _m2, w.durationProgress = _m2), P = _c5 + k.easing(_m2) * (S - _c5), _y2 = (P - w.lastPosition) / l, B = 1 == _m2;
                  }
                  w.lastVelocity = _y2, Number.isNaN(P) && (console.warn("Got NaN while animating:", _this9), B = !0);
                }

                E && !E[C].done && (B = !1), B ? w.done = !0 : s = !1, w.setValue(P, k.round) && (c = !0);
              });
              var w = (0, _.ys)(this),
                  C = w.getValue();

              if (s) {
                var _l7 = (0, m.je)(v.to);

                C === _l7 && !c || k.decay ? c && k.decay && this._onChange(C) : (w.setValue(_l7), this._onChange(_l7)), this._stop();
              } else c && this._onChange(C);
            }
          }, {
            key: "set",
            value: function set(l) {
              var _this10 = this;

              return m.Wn.batchedUpdates(function () {
                _this10._stop(), _this10._focus(l), _this10._set(l);
              }), this;
            }
          }, {
            key: "pause",
            value: function pause() {
              this._update({
                pause: !0
              });
            }
          }, {
            key: "resume",
            value: function resume() {
              this._update({
                pause: !1
              });
            }
          }, {
            key: "finish",
            value: function finish() {
              var _this11 = this;

              if (isAnimating(this)) {
                var _this$animation = this.animation,
                    _l8 = _this$animation.to,
                    _s8 = _this$animation.config;
                m.Wn.batchedUpdates(function () {
                  _this11._onStart(), _s8.decay || _this11._set(_l8, !1), _this11._stop();
                });
              }

              return this;
            }
          }, {
            key: "update",
            value: function update(l) {
              return (this.queue || (this.queue = [])).push(l), this;
            }
          }, {
            key: "start",
            value: function start(l, s) {
              var _this12 = this;

              var c;
              return m.is.und(l) ? (c = this.queue || [], this.queue = []) : c = [m.is.obj(l) ? l : _extends({}, s, {
                to: l
              })], Promise.all(c.map(function (l) {
                return _this12._update(l);
              })).then(function (l) {
                return getCombinedResult(_this12, l);
              });
            }
          }, {
            key: "stop",
            value: function stop(l) {
              var _this13 = this;

              var s = this.animation.to;
              return this._focus(this.get()), stopAsync(this._state, l && this._lastCallId), m.Wn.batchedUpdates(function () {
                return _this13._stop(s, l);
              }), this;
            }
          }, {
            key: "reset",
            value: function reset() {
              this._update({
                reset: !0
              });
            }
          }, {
            key: "eventObserved",
            value: function eventObserved(l) {
              "change" == l.type ? this._start() : "priority" == l.type && (this.priority = l.priority + 1);
            }
          }, {
            key: "_prepareNode",
            value: function _prepareNode(l) {
              var _ref6;

              var s = this.key || "";
              var c = l.to,
                  v = l.from;
              c = m.is.obj(c) ? c[s] : c, (null == c || isAsyncTo(c)) && (c = void 0), v = m.is.obj(v) ? v[s] : v, null == v && (v = void 0);
              var k = {
                to: c,
                from: v
              };
              return hasAnimated(this) || (l.reverse && (_ref6 = [v, c], c = _ref6[0], v = _ref6[1], _ref6), v = (0, m.je)(v), m.is.und(v) ? (0, _.ys)(this) || this._set(c) : this._set(v)), k;
            }
          }, {
            key: "_update",
            value: function _update(l, s) {
              var _this14 = this;

              var c = _extends({}, l);

              var v = this.key,
                  _ = this.defaultProps;
              c.default && Object.assign(_, getDefaultProps(c, function (l, s) {
                return /^on/.test(s) ? resolveProp(l, v) : l;
              })), mergeActiveFn(this, c, "onProps"), sendEvent(this, "onProps", c, this);

              var k = this._prepareNode(c);

              if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
              var y = this._state;
              return scheduleProps(++this._lastCallId, {
                key: v,
                props: c,
                defaultProps: _,
                state: y,
                actions: {
                  pause: function pause() {
                    isPaused(_this14) || (setPausedBit(_this14, !0), (0, m.bl)(y.pauseQueue), sendEvent(_this14, "onPause", getFinishedResult(_this14, checkFinished(_this14, _this14.animation.to)), _this14));
                  },
                  resume: function resume() {
                    isPaused(_this14) && (setPausedBit(_this14, !1), isAnimating(_this14) && _this14._resume(), (0, m.bl)(y.resumeQueue), sendEvent(_this14, "onResume", getFinishedResult(_this14, checkFinished(_this14, _this14.animation.to)), _this14));
                  },
                  start: this._merge.bind(this, k)
                }
              }).then(function (l) {
                if (c.loop && l.finished && (!s || !l.noop)) {
                  var _l9 = createLoopUpdate(c);

                  if (_l9) return _this14._update(_l9, !0);
                }

                return l;
              });
            }
          }, {
            key: "_merge",
            value: function _merge(l, s, c) {
              var _ref7,
                  _this15 = this;

              if (s.cancel) return this.stop(!0), c(getCancelledResult(this));
              var v = !m.is.und(l.to),
                  k = !m.is.und(l.from);

              if (v || k) {
                if (!(s.callId > this._lastToId)) return c(getCancelledResult(this));
                this._lastToId = s.callId;
              }

              var y = this.key,
                  E = this.defaultProps,
                  w = this.animation,
                  C = w.to,
                  S = w.from;
              var _l$to = l.to,
                  B = _l$to === void 0 ? C : _l$to,
                  _l$from = l.from,
                  P = _l$from === void 0 ? S : _l$from;
              !k || v || s.default && !m.is.und(B) || (B = P), s.reverse && (_ref7 = [P, B], B = _ref7[0], P = _ref7[1], _ref7);
              var O = !(0, m.Xy)(P, S);
              O && (w.from = P), P = (0, m.je)(P);
              var L = !(0, m.Xy)(B, C);
              L && this._focus(B);
              var V = isAsyncTo(s.to),
                  R = w.config,
                  z = R.decay,
                  D = R.velocity;
              (v || k) && (R.velocity = 0), s.config && !V && function mergeConfig(l, s, c) {
                c && (sanitizeConfig(c = _extends({}, c), s), s = _extends({}, c, s)), sanitizeConfig(l, s), Object.assign(l, s);

                for (var _s9 in A) {
                  null == l[_s9] && (l[_s9] = A[_s9]);
                }

                var v = l.mass,
                    _ = l.frequency,
                    k = l.damping;
                return m.is.und(_) || (_ < .01 && (_ = .01), k < 0 && (k = 0), l.tension = Math.pow(2 * Math.PI / _, 2) * v, l.friction = 4 * Math.PI * k * v / _), l;
              }(R, callProp(s.config, y), s.config !== E.config ? callProp(E.config, y) : void 0);
              var F = (0, _.ys)(this);
              if (!F || m.is.und(B)) return c(getFinishedResult(this, !0));
              var U = m.is.und(s.reset) ? k && !s.default : !m.is.und(P) && matchProp(s.reset, y),
                  W = U ? P : this.get(),
                  K = computeGoal(B),
                  $ = m.is.num(K) || m.is.arr(K) || (0, m.Df)(K),
                  q = !V && (!$ || matchProp(E.immediate || s.immediate, y));

              if (L) {
                var _l10 = (0, _.sb)(B);

                if (_l10 !== F.constructor) {
                  if (!q) throw Error("Cannot animate between ".concat(F.constructor.name, " and ").concat(_l10.name, ", as the \"to\" prop suggests"));
                  F = this._set(K);
                }
              }

              var Y = F.constructor;
              var Z = (0, m.j$)(B),
                  X = !1;

              if (!Z) {
                var _l11 = U || !hasAnimated(this) && O;

                (L || _l11) && (X = (0, m.Xy)(computeGoal(W), K), Z = !X), ((0, m.Xy)(w.immediate, q) || q) && (0, m.Xy)(R.decay, z) && (0, m.Xy)(R.velocity, D) || (Z = !0);
              }

              if (X && isAnimating(this) && (w.changed && !U ? Z = !0 : Z || this._stop(C)), !V && ((Z || (0, m.j$)(C)) && (w.values = F.getPayload(), w.toValues = (0, m.j$)(B) ? null : Y == _.eC ? [1] : (0, m.qo)(K)), w.immediate != q && (w.immediate = q, q || U || this._set(C)), Z)) {
                var _l12 = w.onRest;
                (0, m.S6)(G, function (l) {
                  return mergeActiveFn(_this15, s, l);
                });

                var _v4 = getFinishedResult(this, checkFinished(this, C));

                (0, m.bl)(this._pendingCalls, _v4), this._pendingCalls.add(c), w.changed && m.Wn.batchedUpdates(function () {
                  w.changed = !U, null == _l12 || _l12(_v4, _this15), U ? callProp(E.onRest, _v4) : null == w.onStart || w.onStart(_v4, _this15);
                });
              }

              U && this._set(W), V ? c(runAsync(s.to, s, this._state, this)) : Z ? this._start() : isAnimating(this) && !L ? this._pendingCalls.add(c) : c(getNoopResult(W));
            }
          }, {
            key: "_focus",
            value: function _focus(l) {
              var s = this.animation;
              l !== s.to && ((0, m.Ll)(this) && this._detach(), s.to = l, (0, m.Ll)(this) && this._attach());
            }
          }, {
            key: "_attach",
            value: function _attach() {
              var l = 0;
              var s = this.animation.to;
              (0, m.j$)(s) && ((0, m.UI)(s, this), isFrameValue(s) && (l = s.priority + 1)), this.priority = l;
            }
          }, {
            key: "_detach",
            value: function _detach() {
              var l = this.animation.to;
              (0, m.j$)(l) && (0, m.iL)(l, this);
            }
          }, {
            key: "_set",
            value: function _set(l) {
              var _this16 = this;

              var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
              var c = (0, m.je)(l);

              if (!m.is.und(c)) {
                var _l13 = (0, _.ys)(this);

                if (!_l13 || !(0, m.Xy)(c, _l13.getValue())) {
                  var _v5 = (0, _.sb)(c);

                  _l13 && _l13.constructor == _v5 ? _l13.setValue(c) : (0, _.f3)(this, _v5.create(c)), _l13 && m.Wn.batchedUpdates(function () {
                    _this16._onChange(c, s);
                  });
                }
              }

              return (0, _.ys)(this);
            }
          }, {
            key: "_onStart",
            value: function _onStart() {
              var l = this.animation;
              l.changed || (l.changed = !0, sendEvent(this, "onStart", getFinishedResult(this, checkFinished(this, l.to)), this));
            }
          }, {
            key: "_onChange",
            value: function _onChange(l, s) {
              s || (this._onStart(), callProp(this.animation.onChange, l, this)), callProp(this.defaultProps.onChange, l, this), _get(_getPrototypeOf(_SpringValue.prototype), "_onChange", this).call(this, l, s);
            }
          }, {
            key: "_start",
            value: function _start() {
              var l = this.animation;
              (0, _.ys)(this).reset((0, m.je)(l.to)), l.immediate || (l.fromValues = l.values.map(function (l) {
                return l.lastPosition;
              })), isAnimating(this) || (setActiveBit(this, !0), isPaused(this) || this._resume());
            }
          }, {
            key: "_resume",
            value: function _resume() {
              m.OH.skipAnimation ? this.finish() : m.fT.start(this);
            }
          }, {
            key: "_stop",
            value: function _stop(l, s) {
              if (isAnimating(this)) {
                setActiveBit(this, !1);
                var _c6 = this.animation;
                (0, m.S6)(_c6.values, function (l) {
                  l.done = !0;
                }), _c6.toValues && (_c6.onChange = _c6.onPause = _c6.onResume = void 0), (0, m.k0)(this, {
                  type: "idle",
                  parent: this
                });

                var _v6 = s ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, null != l ? l : _c6.to));

                (0, m.bl)(this._pendingCalls, _v6), _c6.changed && (_c6.changed = !1, sendEvent(this, "onRest", _v6, this));
              }
            }
          }]);

          return _SpringValue;
        }(_FrameValue);

        function checkFinished(l, s) {
          var c = computeGoal(s),
              v = computeGoal(l.get());
          return (0, m.Xy)(v, c);
        }

        function createLoopUpdate(l) {
          var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : l.loop;
          var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : l.to;
          var m = callProp(s);

          if (m) {
            var _v7 = !0 !== m && _inferTo(m),
                _4 = (_v7 || l).reverse,
                _k = !_v7 || _v7.reset;

            return createUpdate(_extends({}, l, {
              loop: s,
              default: !1,
              pause: void 0,
              to: !_4 || isAsyncTo(c) ? c : void 0,
              from: _k ? l.from : void 0,
              reset: _k
            }, _v7));
          }
        }

        function createUpdate(l) {
          var _l14 = l = _inferTo(l),
              s = _l14.to,
              c = _l14.from,
              v = new Set();

          return m.is.obj(s) && findDefined(s, v), m.is.obj(c) && findDefined(c, v), l.keys = v.size ? Array.from(v) : null, l;
        }

        function declareUpdate(l) {
          var s = createUpdate(l);
          return m.is.und(s.default) && (s.default = getDefaultProps(s)), s;
        }

        function findDefined(l, s) {
          (0, m.rU)(l, function (l, c) {
            return null != l && s.add(c);
          });
        }

        var G = ["onStart", "onRest", "onChange", "onPause", "onResume"];

        function mergeActiveFn(l, s, c) {
          l.animation[c] = s[c] !== getDefaultProp(s, c) ? resolveProp(s[c], l.key) : void 0;
        }

        function sendEvent(l, s) {
          var _m3, _ref8;

          var m, v, _, k;

          for (var _len5 = arguments.length, c = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
            c[_key5 - 2] = arguments[_key5];
          }

          null == (m = (v = l.animation)[s]) || (_m3 = m).call.apply(_m3, [v].concat(c)), null == (_ = (k = l.defaultProps)[s]) || (_ref8 = _).call.apply(_ref8, [k].concat(c));
        }

        var U = ["onStart", "onChange", "onRest"];
        var W = 1;

        var _Controller = /*#__PURE__*/function () {
          function _Controller(l, s) {
            _classCallCheck(this, _Controller);

            this.id = W++, this.springs = {}, this.queue = [], this.ref = void 0, this._flush = void 0, this._initialProps = void 0, this._lastAsyncId = 0, this._active = new Set(), this._changed = new Set(), this._started = !1, this._item = void 0, this._state = {
              paused: !1,
              pauseQueue: new Set(),
              resumeQueue: new Set(),
              timeouts: new Set()
            }, this._events = {
              onStart: new Map(),
              onChange: new Map(),
              onRest: new Map()
            }, this._onFrame = this._onFrame.bind(this), s && (this._flush = s), l && this.start(_extends({
              default: !0
            }, l));
          }

          _createClass(_Controller, [{
            key: "idle",
            get: function get() {
              return !this._state.asyncTo && Object.values(this.springs).every(function (l) {
                return l.idle && !l.isDelayed && !l.isPaused;
              });
            }
          }, {
            key: "item",
            get: function get() {
              return this._item;
            },
            set: function set(l) {
              this._item = l;
            }
          }, {
            key: "get",
            value: function get() {
              var l = {};
              return this.each(function (s, c) {
                return l[c] = s.get();
              }), l;
            }
          }, {
            key: "set",
            value: function set(l) {
              for (var _s10 in l) {
                var _c7 = l[_s10];
                m.is.und(_c7) || this.springs[_s10].set(_c7);
              }
            }
          }, {
            key: "update",
            value: function update(l) {
              return l && this.queue.push(createUpdate(l)), this;
            }
          }, {
            key: "start",
            value: function start(l) {
              var s = this.queue;
              return l ? s = (0, m.qo)(l).map(createUpdate) : this.queue = [], this._flush ? this._flush(this, s) : (prepareKeys(this, s), flushUpdateQueue(this, s));
            }
          }, {
            key: "stop",
            value: function stop(l, s) {
              if (l !== !!l && (s = l), s) {
                var _c8 = this.springs;
                (0, m.S6)((0, m.qo)(s), function (s) {
                  return _c8[s].stop(!!l);
                });
              } else stopAsync(this._state, this._lastAsyncId), this.each(function (s) {
                return s.stop(!!l);
              });

              return this;
            }
          }, {
            key: "pause",
            value: function pause(l) {
              if (m.is.und(l)) this.start({
                pause: !0
              });else {
                var _s11 = this.springs;
                (0, m.S6)((0, m.qo)(l), function (l) {
                  return _s11[l].pause();
                });
              }
              return this;
            }
          }, {
            key: "resume",
            value: function resume(l) {
              if (m.is.und(l)) this.start({
                pause: !1
              });else {
                var _s12 = this.springs;
                (0, m.S6)((0, m.qo)(l), function (l) {
                  return _s12[l].resume();
                });
              }
              return this;
            }
          }, {
            key: "each",
            value: function each(l) {
              (0, m.rU)(this.springs, l);
            }
          }, {
            key: "_onFrame",
            value: function _onFrame() {
              var _this17 = this;

              var _this$_events = this._events,
                  l = _this$_events.onStart,
                  s = _this$_events.onChange,
                  c = _this$_events.onRest,
                  v = this._active.size > 0,
                  _ = this._changed.size > 0;

              (v && !this._started || _ && !this._started) && (this._started = !0, (0, m.yl)(l, function (_ref9) {
                var _ref10 = _slicedToArray(_ref9, 2),
                    l = _ref10[0],
                    s = _ref10[1];

                s.value = _this17.get(), l(s, _this17, _this17._item);
              }));
              var k = !v && this._started,
                  y = _ || k && c.size ? this.get() : null;
              _ && s.size && (0, m.yl)(s, function (_ref11) {
                var _ref12 = _slicedToArray(_ref11, 2),
                    l = _ref12[0],
                    s = _ref12[1];

                s.value = y, l(s, _this17, _this17._item);
              }), k && (this._started = !1, (0, m.yl)(c, function (_ref13) {
                var _ref14 = _slicedToArray(_ref13, 2),
                    l = _ref14[0],
                    s = _ref14[1];

                s.value = y, l(s, _this17, _this17._item);
              }));
            }
          }, {
            key: "eventObserved",
            value: function eventObserved(l) {
              if ("change" == l.type) this._changed.add(l.parent), l.idle || this._active.add(l.parent);else {
                if ("idle" != l.type) return;

                this._active.delete(l.parent);
              }
              m.Wn.onFrame(this._onFrame);
            }
          }]);

          return _Controller;
        }();

        function flushUpdateQueue(l, s) {
          return Promise.all(s.map(function (s) {
            return flushUpdate(l, s);
          })).then(function (s) {
            return getCombinedResult(l, s);
          });
        }

        function flushUpdate(_x2, _x3, _x4) {
          return _flushUpdate.apply(this, arguments);
        }

        function _flushUpdate() {
          _flushUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(l, s, c) {
            var v, _, k, y, E, w, C, S, B, P, O, L, _c11;

            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    v = s.keys, _ = s.to, k = s.from, y = s.loop, E = s.onRest, w = s.onResolve, C = m.is.obj(s.default) && s.default;
                    y && (s.loop = !1), !1 === _ && (s.to = null), !1 === k && (s.from = null);
                    S = m.is.arr(_) || m.is.fun(_) ? _ : void 0;
                    S ? (s.to = void 0, s.onRest = void 0, C && (C.onRest = void 0)) : (0, m.S6)(U, function (c) {
                      var v = s[c];

                      if (m.is.fun(v)) {
                        var _m8 = l._events[c];
                        s[c] = function (_ref21) {
                          var l = _ref21.finished,
                              s = _ref21.cancelled;

                          var c = _m8.get(v);

                          c ? (l || (c.finished = !1), s && (c.cancelled = !0)) : _m8.set(v, {
                            value: null,
                            finished: l || !1,
                            cancelled: s || !1
                          });
                        }, C && (C[c] = s[c]);
                      }
                    });
                    B = l._state;
                    s.pause === !B.paused ? (B.paused = s.pause, (0, m.bl)(s.pause ? B.pauseQueue : B.resumeQueue)) : B.paused && (s.pause = !0);
                    P = (v || Object.keys(l.springs)).map(function (c) {
                      return l.springs[c].start(s);
                    }), O = !0 === s.cancel || !0 === getDefaultProp(s, "cancel");
                    (S || O && B.asyncId) && P.push(scheduleProps(++l._lastAsyncId, {
                      props: s,
                      state: B,
                      actions: {
                        pause: m.ZT,
                        resume: m.ZT,
                        start: function start(s, c) {
                          O ? (stopAsync(B, l._lastAsyncId), c(getCancelledResult(l))) : (s.onRest = E, c(runAsync(S, s, B, l)));
                        }
                      }
                    }));
                    _context4.t0 = B.paused;

                    if (!_context4.t0) {
                      _context4.next = 12;
                      break;
                    }

                    _context4.next = 12;
                    return new Promise(function (l) {
                      B.resumeQueue.add(l);
                    });

                  case 12:
                    _context4.t1 = getCombinedResult;
                    _context4.t2 = l;
                    _context4.next = 16;
                    return Promise.all(P);

                  case 16:
                    _context4.t3 = _context4.sent;
                    L = (0, _context4.t1)(_context4.t2, _context4.t3);

                    if (!(y && L.finished && (!c || !L.noop))) {
                      _context4.next = 22;
                      break;
                    }

                    _c11 = createLoopUpdate(s, y, _);

                    if (!_c11) {
                      _context4.next = 22;
                      break;
                    }

                    return _context4.abrupt("return", (prepareKeys(l, [_c11]), flushUpdate(l, _c11, !0)));

                  case 22:
                    return _context4.abrupt("return", (w && m.Wn.batchedUpdates(function () {
                      return w(L, l, l.item);
                    }), L));

                  case 23:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));
          return _flushUpdate.apply(this, arguments);
        }

        function getSprings(l, s) {
          var c = _extends({}, l.springs);

          return s && (0, m.S6)((0, m.qo)(s), function (l) {
            m.is.und(l.keys) && (l = createUpdate(l)), m.is.obj(l.to) || (l = _extends({}, l, {
              to: void 0
            })), prepareSprings(c, l, function (l) {
              return createSpring(l);
            });
          }), setSprings(l, c), c;
        }

        function setSprings(l, s) {
          (0, m.rU)(s, function (s, c) {
            l.springs[c] || (l.springs[c] = s, (0, m.UI)(s, l));
          });
        }

        function createSpring(l, s) {
          var c = new _SpringValue();
          return c.key = l, s && (0, m.UI)(c, s), c;
        }

        function prepareSprings(l, s, c) {
          s.keys && (0, m.S6)(s.keys, function (m) {
            (l[m] || (l[m] = c(m)))._prepareNode(s);
          });
        }

        function prepareKeys(l, s) {
          (0, m.S6)(s, function (s) {
            prepareSprings(l.springs, s, function (s) {
              return createSpring(s, l);
            });
          });
        }

        function _objectWithoutPropertiesLoose(l, s) {
          if (null == l) return {};

          var c,
              m,
              v = {},
              _ = Object.keys(l);

          for (m = 0; m < _.length; m++) {
            c = _[m], s.indexOf(c) >= 0 || (v[c] = l[c]);
          }

          return v;
        }

        var K = ["children"],
            _SpringContext = function _SpringContext(l) {
          var s = l.children,
              c = _objectWithoutPropertiesLoose(l, K);

          var _ = (0, v.useContext)($),
              k = c.pause || !!_.pause,
              y = c.immediate || !!_.immediate;

          c = (0, m.Pr)(function () {
            return {
              pause: k,
              immediate: y
            };
          }, [k, y]);
          var E = $.Provider;
          return v.createElement(E, {
            value: c
          }, s);
        },
            $ = function makeContext(l, s) {
          return Object.assign(l, v.createContext(s)), l.Provider._context = l, l.Consumer._context = l, l;
        }(_SpringContext, {});

        _SpringContext.Provider = $.Provider, _SpringContext.Consumer = $.Consumer;

        var _SpringRef = function _SpringRef() {
          var l = [],
              s = function SpringRef(s) {
            (0, m.ZR)();
            var v = [];
            return (0, m.S6)(l, function (l, _) {
              if (m.is.und(s)) v.push(l.start());else {
                var _m4 = c(s, l, _);

                _m4 && v.push(l.start(_m4));
              }
            }), v;
          };

          s.current = l, s.add = function (s) {
            l.includes(s) || l.push(s);
          }, s.delete = function (s) {
            var c = l.indexOf(s);
            ~c && l.splice(c, 1);
          }, s.pause = function () {
            var _arguments = arguments;
            return (0, m.S6)(l, function (l) {
              return l.pause.apply(l, _toConsumableArray(_arguments));
            }), this;
          }, s.resume = function () {
            var _arguments2 = arguments;
            return (0, m.S6)(l, function (l) {
              return l.resume.apply(l, _toConsumableArray(_arguments2));
            }), this;
          }, s.set = function (s) {
            (0, m.S6)(l, function (l) {
              return l.set(s);
            });
          }, s.start = function (s) {
            var _this18 = this;

            var c = [];
            return (0, m.S6)(l, function (l, v) {
              if (m.is.und(s)) c.push(l.start());else {
                var _m5 = _this18._getProps(s, l, v);

                _m5 && c.push(l.start(_m5));
              }
            }), c;
          }, s.stop = function () {
            var _arguments3 = arguments;
            return (0, m.S6)(l, function (l) {
              return l.stop.apply(l, _toConsumableArray(_arguments3));
            }), this;
          }, s.update = function (s) {
            var _this19 = this;

            return (0, m.S6)(l, function (l, c) {
              return l.update(_this19._getProps(s, l, c));
            }), this;
          };

          var c = function _getProps(l, s, c) {
            return m.is.fun(l) ? l(c, s) : l;
          };

          return s._getProps = c, s;
        };

        function _useSprings(l, s, c) {
          var _arguments4 = arguments;

          var _ = m.is.fun(s) && s;

          _ && !c && (c = []);
          var k = (0, v.useMemo)(function () {
            return _ || 3 == _arguments4.length ? _SpringRef() : void 0;
          }, []),
              y = (0, v.useRef)(0),
              E = (0, m.NW)(),
              w = (0, v.useMemo)(function () {
            return {
              ctrls: [],
              queue: [],
              flush: function flush(l, s) {
                var c = getSprings(l, s);
                return y.current > 0 && !w.queue.length && !Object.keys(c).some(function (s) {
                  return !l.springs[s];
                }) ? flushUpdateQueue(l, s) : new Promise(function (m) {
                  setSprings(l, c), w.queue.push(function () {
                    m(flushUpdateQueue(l, s));
                  }), E();
                });
              }
            };
          }, []),
              C = (0, v.useRef)(_toConsumableArray(w.ctrls)),
              S = [],
              B = (0, m.zH)(l) || 0;

          function declareUpdates(l, c) {
            for (var _m6 = l; _m6 < c; _m6++) {
              var _l15 = C.current[_m6] || (C.current[_m6] = new _Controller(null, w.flush)),
                  _c9 = _ ? _(_m6, _l15) : s[_m6];

              _c9 && (S[_m6] = declareUpdate(_c9));
            }
          }

          (0, v.useMemo)(function () {
            (0, m.S6)(C.current.slice(l, B), function (l) {
              detachRefs(l, k), l.stop(!0);
            }), C.current.length = l, declareUpdates(B, l);
          }, [l]), (0, v.useMemo)(function () {
            declareUpdates(0, Math.min(B, l));
          }, c);
          var P = C.current.map(function (l, s) {
            return getSprings(l, S[s]);
          }),
              O = (0, v.useContext)(_SpringContext),
              L = (0, m.zH)(O),
              V = O !== L && hasProps(O);
          (0, m.bt)(function () {
            y.current++, w.ctrls = C.current;
            var l = w.queue;
            l.length && (w.queue = [], (0, m.S6)(l, function (l) {
              return l();
            })), (0, m.S6)(C.current, function (l, s) {
              null == k || k.add(l), V && l.start({
                default: O
              });
              var c = S[s];
              c && (replaceRef(l, c.ref), l.ref ? l.queue.push(c) : l.start(c));
            });
          }), (0, m.tf)(function () {
            return function () {
              (0, m.S6)(w.ctrls, function (l) {
                return l.stop(!0);
              });
            };
          });
          var R = P.map(function (l) {
            return _extends({}, l);
          });
          return k ? [R, k] : R;
        }

        function _useSpring(l, s) {
          var c = m.is.fun(l),
              _useSprings2 = _useSprings(1, c ? l : [l], c ? s || [] : s),
              _useSprings3 = _slicedToArray(_useSprings2, 2),
              _useSprings3$ = _slicedToArray(_useSprings3[0], 1),
              v = _useSprings3$[0],
              _ = _useSprings3[1];

          return c || 2 == arguments.length ? [v, _] : v;
        }

        var initSpringRef = function initSpringRef() {
          return _SpringRef();
        },
            _useSpringRef = function _useSpringRef() {
          return (0, v.useState)(initSpringRef)[0];
        };

        function _useTrail(l, s, c) {
          var v;

          var _ = m.is.fun(s) && s;

          _ && !c && (c = []);
          var k,
              y = !0;

          var E = _useSprings(l, function (l, c) {
            var m = _ ? _(l, c) : s;
            return k = m.ref, y = y && m.reverse, m;
          }, c || [{}]),
              w = null != (v = k) ? v : E[1];

          return (0, m.bt)(function () {
            (0, m.S6)(w.current, function (l, s) {
              var c = w.current[s + (y ? 1 : -1)];
              c ? l.start({
                to: c.springs
              }) : l.start();
            });
          }, c), _ || 3 == arguments.length ? (w._getProps = function (l, s, c) {
            var v = m.is.fun(l) ? l(c, s) : l;

            if (v) {
              var _l16 = w.current[c + (v.reverse ? 1 : -1)];
              return _l16 && (v.to = _l16.springs), v;
            }
          }, E) : (w.start = function (l) {
            var s = [];
            return (0, m.S6)(w.current, function (c, v) {
              var _ = m.is.fun(l) ? l(v, c) : l,
                  k = w.current[v + (y ? 1 : -1)];

              k ? s.push(c.start(_extends({}, _, {
                to: k.springs
              }))) : s.push(c.start(_extends({}, _)));
            }), s;
          }, E[0]);
        }

        var q;

        function _useTransition(l, s, c) {
          var _arguments5 = arguments;

          var _ = m.is.fun(s) && s,
              _ref15 = _ ? _() : s,
              k = _ref15.reset,
              y = _ref15.sort,
              _ref15$trail = _ref15.trail,
              E = _ref15$trail === void 0 ? 0 : _ref15$trail,
              _ref15$expires = _ref15.expires,
              w = _ref15$expires === void 0 ? !0 : _ref15$expires,
              _ref15$exitBeforeEnte = _ref15.exitBeforeEnter,
              C = _ref15$exitBeforeEnte === void 0 ? !1 : _ref15$exitBeforeEnte,
              S = _ref15.onDestroyed,
              B = _ref15.ref,
              P = _ref15.config,
              O = (0, v.useMemo)(function () {
            return _ || 3 == _arguments5.length ? _SpringRef() : void 0;
          }, []),
              L = (0, m.qo)(l),
              V = [],
              R = (0, v.useRef)(null),
              A = k ? null : R.current;

          (0, m.bt)(function () {
            R.current = V;
          }), (0, m.tf)(function () {
            return function () {
              (0, m.S6)(R.current, function (l) {
                l.expired && clearTimeout(l.expirationId), detachRefs(l.ctrl, O), l.ctrl.stop(!0);
              });
            };
          });
          var z = getKeys(L, _ ? _() : s, A),
              D = k && R.current || [];
          (0, m.bt)(function () {
            return (0, m.S6)(D, function (_ref16) {
              var l = _ref16.ctrl,
                  s = _ref16.item,
                  c = _ref16.key;
              detachRefs(l, O), callProp(S, s, c);
            });
          });
          var F = [];

          if (A && (0, m.S6)(A, function (l, s) {
            l.expired ? (clearTimeout(l.expirationId), D.push(l)) : ~(s = F[s] = z.indexOf(l.key)) && (V[s] = l);
          }), (0, m.S6)(L, function (l, s) {
            V[s] || (V[s] = {
              key: z[s],
              item: l,
              phase: q.MOUNT,
              ctrl: new _Controller()
            }, V[s].ctrl.item = l);
          }), F.length) {
            var _l17 = -1;

            var _ref17 = _ ? _() : s,
                _c10 = _ref17.leave;

            (0, m.S6)(F, function (s, m) {
              var v = A[m];
              ~s ? (_l17 = V.indexOf(v), V[_l17] = _extends({}, v, {
                item: L[s]
              })) : _c10 && V.splice(++_l17, 0, v);
            });
          }

          m.is.fun(y) && V.sort(function (l, s) {
            return y(l.item, s.item);
          });
          var G = -E;
          var U = (0, m.NW)(),
              W = getDefaultProps(s),
              K = new Map(),
              $ = (0, v.useRef)(new Map()),
              Y = (0, v.useRef)(!1);
          (0, m.S6)(V, function (l, c) {
            var v = l.key,
                k = l.phase,
                y = _ ? _() : s;
            var S,
                O,
                L = callProp(y.delay || 0, v);
            if (k == q.MOUNT) S = y.enter, O = q.ENTER;else {
              var _l18 = z.indexOf(v) < 0;

              if (k != q.LEAVE) {
                if (_l18) S = y.leave, O = q.LEAVE;else {
                  if (!(S = y.update)) return;
                  O = q.UPDATE;
                }
              } else {
                if (_l18) return;
                S = y.enter, O = q.ENTER;
              }
            }

            if (S = callProp(S, l.item, c), S = m.is.obj(S) ? _inferTo(S) : {
              to: S
            }, !S.config) {
              var _s13 = P || W.config;

              S.config = callProp(_s13, l.item, c, O);
            }

            G += E;

            var V = _extends({}, W, {
              delay: L + G,
              ref: B,
              immediate: y.immediate,
              reset: !1
            }, S);

            if (O == q.ENTER && m.is.und(V.from)) {
              var _v8 = _ ? _() : s,
                  _k2 = m.is.und(_v8.initial) || A ? _v8.from : _v8.initial;

              V.from = callProp(_k2, l.item, c);
            }

            var D = V.onResolve;

            V.onResolve = function (l) {
              callProp(D, l);
              var s = R.current,
                  c = s.find(function (l) {
                return l.key === v;
              });

              if (c && (!l.cancelled || c.phase == q.UPDATE) && c.ctrl.idle) {
                var _l19 = s.every(function (l) {
                  return l.ctrl.idle;
                });

                if (c.phase == q.LEAVE) {
                  var _s14 = callProp(w, c.item);

                  if (!1 !== _s14) {
                    var _m7 = !0 === _s14 ? 0 : _s14;

                    if (c.expired = !0, !_l19 && _m7 > 0) return void (_m7 <= 2147483647 && (c.expirationId = setTimeout(U, _m7)));
                  }
                }

                _l19 && s.some(function (l) {
                  return l.expired;
                }) && ($.current.delete(c), C && (Y.current = !0), U());
              }
            };

            var F = getSprings(l.ctrl, V);
            O === q.LEAVE && C ? $.current.set(l, {
              phase: O,
              springs: F,
              payload: V
            }) : K.set(l, {
              phase: O,
              springs: F,
              payload: V
            });
          });
          var Z = (0, v.useContext)(_SpringContext),
              X = (0, m.zH)(Z),
              Q = Z !== X && hasProps(Z);
          (0, m.bt)(function () {
            Q && (0, m.S6)(V, function (l) {
              l.ctrl.start({
                default: Z
              });
            });
          }, [Z]), (0, m.S6)(K, function (l, s) {
            if ($.current.size) {
              var _l20 = V.findIndex(function (l) {
                return l.key === s.key;
              });

              V.splice(_l20, 1);
            }
          }), (0, m.bt)(function () {
            (0, m.S6)($.current.size ? $.current : K, function (_ref18, c) {
              var l = _ref18.phase,
                  s = _ref18.payload;
              var m = c.ctrl;
              c.phase = l, null == O || O.add(m), Q && l == q.ENTER && m.start({
                default: Z
              }), s && (replaceRef(m, s.ref), m.ref && !Y.current ? m.update(s) : (m.start(s), Y.current && (Y.current = !1)));
            });
          }, k ? void 0 : c);

          var renderTransitions = function renderTransitions(l) {
            return v.createElement(v.Fragment, null, V.map(function (s, c) {
              var _ref19 = K.get(s) || s.ctrl,
                  _ = _ref19.springs,
                  k = l(_extends({}, _), s.item, s, c);

              return k && k.type ? v.createElement(k.type, _extends({}, k.props, {
                key: m.is.str(s.key) || m.is.num(s.key) ? s.key : s.ctrl.id,
                ref: k.ref
              })) : k;
            }));
          };

          return O ? [renderTransitions, O] : renderTransitions;
        }

        !function (l) {
          l.MOUNT = "mount", l.ENTER = "enter", l.UPDATE = "update", l.LEAVE = "leave";
        }(q || (q = {}));
        var Y = 1;

        function getKeys(l, _ref20, v) {
          var s = _ref20.key,
              _ref20$keys = _ref20.keys,
              c = _ref20$keys === void 0 ? s : _ref20$keys;

          if (null === c) {
            var _s15 = new Set();

            return l.map(function (l) {
              var c = v && v.find(function (c) {
                return c.item === l && c.phase !== q.LEAVE && !_s15.has(c);
              });
              return c ? (_s15.add(c), c.key) : Y++;
            });
          }

          return m.is.und(c) ? l : m.is.fun(c) ? l.map(c) : (0, m.qo)(c);
        }

        var Z = ["children"];

        function _Spring(l) {
          var s = l.children;
          return s(_useSpring(_objectWithoutPropertiesLoose(l, Z)));
        }

        var X = ["items", "children"];

        function _Trail(l) {
          var s = l.items,
              c = l.children,
              v = _objectWithoutPropertiesLoose(l, X);

          var _ = _useTrail(s.length, v);

          return s.map(function (l, s) {
            var v = c(l, s);
            return m.is.fun(v) ? v(_[s]) : v;
          });
        }

        var Q = ["items", "children"];

        function _Transition(l) {
          var s = l.items,
              c = l.children;
          return _useTransition(s, _objectWithoutPropertiesLoose(l, Q))(c);
        }

        var _Interpolation = /*#__PURE__*/function (_FrameValue3) {
          _inherits(_Interpolation, _FrameValue3);

          var _super9 = _createSuper(_Interpolation);

          function _Interpolation(l, s) {
            var _this20;

            _classCallCheck(this, _Interpolation);

            _this20 = _super9.call(this), _this20.key = void 0, _this20.idle = !0, _this20.calc = void 0, _this20._active = new Set(), _this20.source = l, _this20.calc = (0, m.mD).apply(void 0, _toConsumableArray(s));

            var c = _this20._get(),
                v = (0, _.sb)(c);

            (0, _.f3)(_assertThisInitialized(_this20), v.create(c));
            return _this20;
          }

          _createClass(_Interpolation, [{
            key: "advance",
            value: function advance(l) {
              var s = this._get(),
                  c = this.get();

              (0, m.Xy)(s, c) || ((0, _.ys)(this).setValue(s), this._onChange(s, this.idle)), !this.idle && checkIdle(this._active) && becomeIdle(this);
            }
          }, {
            key: "_get",
            value: function _get() {
              var l = m.is.arr(this.source) ? this.source.map(m.je) : (0, m.qo)((0, m.je)(this.source));
              return this.calc.apply(this, _toConsumableArray(l));
            }
          }, {
            key: "_start",
            value: function _start() {
              var _this21 = this;

              this.idle && !checkIdle(this._active) && (this.idle = !1, (0, m.S6)((0, _.He)(this), function (l) {
                l.done = !1;
              }), m.OH.skipAnimation ? (m.Wn.batchedUpdates(function () {
                return _this21.advance();
              }), becomeIdle(this)) : m.fT.start(this));
            }
          }, {
            key: "_attach",
            value: function _attach() {
              var _this22 = this;

              var l = 1;
              (0, m.S6)((0, m.qo)(this.source), function (s) {
                (0, m.j$)(s) && (0, m.UI)(s, _this22), isFrameValue(s) && (s.idle || _this22._active.add(s), l = Math.max(l, s.priority + 1));
              }), this.priority = l, this._start();
            }
          }, {
            key: "_detach",
            value: function _detach() {
              var _this23 = this;

              (0, m.S6)((0, m.qo)(this.source), function (l) {
                (0, m.j$)(l) && (0, m.iL)(l, _this23);
              }), this._active.clear(), becomeIdle(this);
            }
          }, {
            key: "eventObserved",
            value: function eventObserved(l) {
              "change" == l.type ? l.idle ? this.advance() : (this._active.add(l.parent), this._start()) : "idle" == l.type ? this._active.delete(l.parent) : "priority" == l.type && (this.priority = (0, m.qo)(this.source).reduce(function (l, s) {
                return Math.max(l, (isFrameValue(s) ? s.priority : 0) + 1);
              }, 0));
            }
          }]);

          return _Interpolation;
        }(_FrameValue);

        function isIdle(l) {
          return !1 !== l.idle;
        }

        function checkIdle(l) {
          return !l.size || Array.from(l).every(isIdle);
        }

        function becomeIdle(l) {
          l.idle || (l.idle = !0, (0, m.S6)((0, _.He)(l), function (l) {
            l.done = !0;
          }), (0, m.k0)(l, {
            type: "idle",
            parent: l
          }));
        }

        var _to = function _to(l) {
          for (var _len6 = arguments.length, s = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
            s[_key6 - 1] = arguments[_key6];
          }

          return new _Interpolation(l, s);
        },
            _interpolate = function _interpolate(l) {
          for (var _len7 = arguments.length, s = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
            s[_key7 - 1] = arguments[_key7];
          }

          return (0, m.LW)(), new _Interpolation(l, s);
        };

        m.OH.assign({
          createStringInterpolator: m.qS,
          to: function to(l, s) {
            return new _Interpolation(l, s);
          }
        });
        var J = m.fT.advance;
      },
      2446: function _(l, s, c) {
        "use strict";

        c.d(s, {
          B0: function B0() {
            return FluidValue;
          },
          OH: function OH() {
            return D;
          },
          UI: function UI() {
            return addFluidObserver;
          },
          k0: function k0() {
            return callFluidObservers;
          },
          O9: function O9() {
            return $;
          },
          mD: function mD() {
            return createInterpolator;
          },
          qS: function qS() {
            return createStringInterpolator;
          },
          dE: function dE() {
            return defineHidden;
          },
          ZR: function ZR() {
            return deprecateDirectCall;
          },
          LW: function LW() {
            return deprecateInterpolate;
          },
          S6: function S6() {
            return each;
          },
          rU: function rU() {
            return eachProp;
          },
          yl: function yl() {
            return flush;
          },
          bl: function bl() {
            return flushCalls;
          },
          fT: function fT() {
            return K;
          },
          Ll: function Ll() {
            return getFluidObservers;
          },
          je: function je() {
            return getFluidValue;
          },
          j$: function j$() {
            return hasFluidValue;
          },
          is: function is() {
            return O;
          },
          Df: function Df() {
            return isAnimatedString;
          },
          Xy: function Xy() {
            return isEqual;
          },
          ZT: function ZT() {
            return noop;
          },
          Wn: function Wn() {
            return raf;
          },
          iL: function iL() {
            return removeFluidObserver;
          },
          qo: function qo() {
            return toArray;
          },
          NW: function NW() {
            return useForceUpdate;
          },
          bt: function bt() {
            return ge;
          },
          Pr: function Pr() {
            return useMemoOne;
          },
          tf: function tf() {
            return useOnce;
          },
          zH: function zH() {
            return usePrev;
          }
        });
        var m = makeQueue();

        var raf = function raf(l) {
          return schedule(l, m);
        };

        var v = makeQueue();

        raf.write = function (l) {
          return schedule(l, v);
        };

        var _ = makeQueue();

        raf.onStart = function (l) {
          return schedule(l, _);
        };

        var k = makeQueue();

        raf.onFrame = function (l) {
          return schedule(l, k);
        };

        var y = makeQueue();

        raf.onFinish = function (l) {
          return schedule(l, y);
        };

        var E = [];

        raf.setTimeout = function (l, s) {
          var c = raf.now() + s,
              cancel = function cancel() {
            var l = E.findIndex(function (l) {
              return l.cancel == cancel;
            });
            ~l && E.splice(l, 1), S -= ~l ? 1 : 0;
          },
              m = {
            time: c,
            handler: l,
            cancel: cancel
          };

          return E.splice(findTimeout(c), 0, m), S += 1, start(), m;
        };

        var findTimeout = function findTimeout(l) {
          return ~(~E.findIndex(function (s) {
            return s.time > l;
          }) || ~E.length);
        };

        raf.cancel = function (l) {
          _.delete(l), k.delete(l), m.delete(l), v.delete(l), y.delete(l);
        }, raf.sync = function (l) {
          B = !0, raf.batchedUpdates(l), B = !1;
        }, raf.throttle = function (l) {
          var s;

          function queuedFn() {
            try {
              l.apply(void 0, _toConsumableArray(s));
            } finally {
              s = null;
            }
          }

          function throttled() {
            for (var _len8 = arguments.length, l = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
              l[_key8] = arguments[_key8];
            }

            s = l, raf.onStart(queuedFn);
          }

          return throttled.handler = l, throttled.cancel = function () {
            _.delete(queuedFn), s = null;
          }, throttled;
        };
        var w = "undefined" != typeof window ? window.requestAnimationFrame : function () {};
        raf.use = function (l) {
          return w = l;
        }, raf.now = "undefined" != typeof performance ? function () {
          return performance.now();
        } : Date.now, raf.batchedUpdates = function (l) {
          return l();
        }, raf.catch = console.error, raf.frameLoop = "always", raf.advance = function () {
          "demand" !== raf.frameLoop ? console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand") : update();
        };
        var C = -1,
            S = 0,
            B = !1;

        function schedule(l, s) {
          B ? (s.delete(l), l(0)) : (s.add(l), start());
        }

        function start() {
          C < 0 && (C = 0, "demand" !== raf.frameLoop && w(loop));
        }

        function loop() {
          ~C && (w(loop), raf.batchedUpdates(update));
        }

        function update() {
          var l = C;
          C = raf.now();
          var s = findTimeout(C);
          s && (eachSafely(E.splice(0, s), function (l) {
            return l.handler();
          }), S -= s), _.flush(), m.flush(l ? Math.min(64, C - l) : 16.667), k.flush(), v.flush(), y.flush(), S || function stop() {
            C = -1;
          }();
        }

        function makeQueue() {
          var l = new Set(),
              s = l;
          return {
            add: function add(c) {
              S += s != l || l.has(c) ? 0 : 1, l.add(c);
            },
            delete: function _delete(c) {
              return S -= s == l && l.has(c) ? 1 : 0, l.delete(c);
            },
            flush: function flush(c) {
              s.size && (l = new Set(), S -= s.size, eachSafely(s, function (s) {
                return s(c) && l.add(s);
              }), S += l.size, s = l);
            }
          };
        }

        function eachSafely(l, s) {
          l.forEach(function (l) {
            try {
              s(l);
            } catch (l) {
              raf.catch(l);
            }
          });
        }

        var P = c(9497);

        function noop() {}

        var defineHidden = function defineHidden(l, s, c) {
          return Object.defineProperty(l, s, {
            value: c,
            writable: !0,
            configurable: !0
          });
        },
            O = {
          arr: Array.isArray,
          obj: function obj(l) {
            return !!l && "Object" === l.constructor.name;
          },
          fun: function fun(l) {
            return "function" == typeof l;
          },
          str: function str(l) {
            return "string" == typeof l;
          },
          num: function num(l) {
            return "number" == typeof l;
          },
          und: function und(l) {
            return void 0 === l;
          }
        };

        function isEqual(l, s) {
          if (O.arr(l)) {
            if (!O.arr(s) || l.length !== s.length) return !1;

            for (var _c12 = 0; _c12 < l.length; _c12++) {
              if (l[_c12] !== s[_c12]) return !1;
            }

            return !0;
          }

          return l === s;
        }

        var each = function each(l, s) {
          return l.forEach(s);
        };

        function eachProp(l, s, c) {
          if (O.arr(l)) for (var _m9 = 0; _m9 < l.length; _m9++) {
            s.call(c, l[_m9], "".concat(_m9));
          } else for (var _m10 in l) {
            l.hasOwnProperty(_m10) && s.call(c, l[_m10], _m10);
          }
        }

        var toArray = function toArray(l) {
          return O.und(l) ? [] : O.arr(l) ? l : [l];
        };

        function flush(l, s) {
          if (l.size) {
            var _c13 = Array.from(l);

            l.clear(), each(_c13, s);
          }
        }

        var flushCalls = function flushCalls(l) {
          for (var _len9 = arguments.length, s = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
            s[_key9 - 1] = arguments[_key9];
          }

          return flush(l, function (l) {
            return l.apply(void 0, s);
          });
        },
            isSSR = function isSSR() {
          return "undefined" == typeof window || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
        };

        var L,
            V,
            R = null,
            A = !1,
            z = noop;
        var D = Object.freeze({
          __proto__: null,

          get createStringInterpolator() {
            return L;
          },

          get to() {
            return V;
          },

          get colors() {
            return R;
          },

          get skipAnimation() {
            return A;
          },

          get willAdvance() {
            return z;
          },

          assign: function assign(l) {
            l.to && (V = l.to), l.now && (raf.now = l.now), void 0 !== l.colors && (R = l.colors), null != l.skipAnimation && (A = l.skipAnimation), l.createStringInterpolator && (L = l.createStringInterpolator), l.requestAnimationFrame && raf.use(l.requestAnimationFrame), l.batchedUpdates && (raf.batchedUpdates = l.batchedUpdates), l.willAdvance && (z = l.willAdvance), l.frameLoop && (raf.frameLoop = l.frameLoop);
          }
        });
        var F = new Set();
        var G = [],
            U = [],
            W = 0;
        var K = {
          get idle() {
            return !F.size && !G.length;
          },

          start: function start(l) {
            W > l.priority ? (F.add(l), raf.onStart(flushStartQueue)) : (startSafely(l), raf(advance));
          },
          advance: advance,
          sort: function sort(l) {
            if (W) raf.onFrame(function () {
              return K.sort(l);
            });else {
              var _s16 = G.indexOf(l);

              ~_s16 && (G.splice(_s16, 1), startUnsafely(l));
            }
          },
          clear: function clear() {
            G = [], F.clear();
          }
        };

        function flushStartQueue() {
          F.forEach(startSafely), F.clear(), raf(advance);
        }

        function startSafely(l) {
          G.includes(l) || startUnsafely(l);
        }

        function startUnsafely(l) {
          G.splice(function findIndex(l, s) {
            var c = l.findIndex(s);
            return c < 0 ? l.length : c;
          }(G, function (s) {
            return s.priority > l.priority;
          }), 0, l);
        }

        function advance(l) {
          var s = U;

          for (var _c14 = 0; _c14 < G.length; _c14++) {
            var _m11 = G[_c14];
            W = _m11.priority, _m11.idle || (z(_m11), _m11.advance(l), _m11.idle || s.push(_m11));
          }

          return W = 0, U = G, U.length = 0, G = s, G.length > 0;
        }

        var $ = {
          transparent: 0,
          aliceblue: 4042850303,
          antiquewhite: 4209760255,
          aqua: 16777215,
          aquamarine: 2147472639,
          azure: 4043309055,
          beige: 4126530815,
          bisque: 4293182719,
          black: 255,
          blanchedalmond: 4293643775,
          blue: 65535,
          blueviolet: 2318131967,
          brown: 2771004159,
          burlywood: 3736635391,
          burntsienna: 3934150143,
          cadetblue: 1604231423,
          chartreuse: 2147418367,
          chocolate: 3530104575,
          coral: 4286533887,
          cornflowerblue: 1687547391,
          cornsilk: 4294499583,
          crimson: 3692313855,
          cyan: 16777215,
          darkblue: 35839,
          darkcyan: 9145343,
          darkgoldenrod: 3095792639,
          darkgray: 2846468607,
          darkgreen: 6553855,
          darkgrey: 2846468607,
          darkkhaki: 3182914559,
          darkmagenta: 2332068863,
          darkolivegreen: 1433087999,
          darkorange: 4287365375,
          darkorchid: 2570243327,
          darkred: 2332033279,
          darksalmon: 3918953215,
          darkseagreen: 2411499519,
          darkslateblue: 1211993087,
          darkslategray: 793726975,
          darkslategrey: 793726975,
          darkturquoise: 13554175,
          darkviolet: 2483082239,
          deeppink: 4279538687,
          deepskyblue: 12582911,
          dimgray: 1768516095,
          dimgrey: 1768516095,
          dodgerblue: 512819199,
          firebrick: 2988581631,
          floralwhite: 4294635775,
          forestgreen: 579543807,
          fuchsia: 4278255615,
          gainsboro: 3705462015,
          ghostwhite: 4177068031,
          gold: 4292280575,
          goldenrod: 3668254975,
          gray: 2155905279,
          green: 8388863,
          greenyellow: 2919182335,
          grey: 2155905279,
          honeydew: 4043305215,
          hotpink: 4285117695,
          indianred: 3445382399,
          indigo: 1258324735,
          ivory: 4294963455,
          khaki: 4041641215,
          lavender: 3873897215,
          lavenderblush: 4293981695,
          lawngreen: 2096890111,
          lemonchiffon: 4294626815,
          lightblue: 2916673279,
          lightcoral: 4034953471,
          lightcyan: 3774873599,
          lightgoldenrodyellow: 4210742015,
          lightgray: 3553874943,
          lightgreen: 2431553791,
          lightgrey: 3553874943,
          lightpink: 4290167295,
          lightsalmon: 4288707327,
          lightseagreen: 548580095,
          lightskyblue: 2278488831,
          lightslategray: 2005441023,
          lightslategrey: 2005441023,
          lightsteelblue: 2965692159,
          lightyellow: 4294959359,
          lime: 16711935,
          limegreen: 852308735,
          linen: 4210091775,
          magenta: 4278255615,
          maroon: 2147483903,
          mediumaquamarine: 1724754687,
          mediumblue: 52735,
          mediumorchid: 3126187007,
          mediumpurple: 2473647103,
          mediumseagreen: 1018393087,
          mediumslateblue: 2070474495,
          mediumspringgreen: 16423679,
          mediumturquoise: 1221709055,
          mediumvioletred: 3340076543,
          midnightblue: 421097727,
          mintcream: 4127193855,
          mistyrose: 4293190143,
          moccasin: 4293178879,
          navajowhite: 4292783615,
          navy: 33023,
          oldlace: 4260751103,
          olive: 2155872511,
          olivedrab: 1804477439,
          orange: 4289003775,
          orangered: 4282712319,
          orchid: 3664828159,
          palegoldenrod: 4008225535,
          palegreen: 2566625535,
          paleturquoise: 2951671551,
          palevioletred: 3681588223,
          papayawhip: 4293907967,
          peachpuff: 4292524543,
          peru: 3448061951,
          pink: 4290825215,
          plum: 3718307327,
          powderblue: 2967529215,
          purple: 2147516671,
          rebeccapurple: 1714657791,
          red: 4278190335,
          rosybrown: 3163525119,
          royalblue: 1097458175,
          saddlebrown: 2336560127,
          salmon: 4202722047,
          sandybrown: 4104413439,
          seagreen: 780883967,
          seashell: 4294307583,
          sienna: 2689740287,
          silver: 3233857791,
          skyblue: 2278484991,
          slateblue: 1784335871,
          slategray: 1887473919,
          slategrey: 1887473919,
          snow: 4294638335,
          springgreen: 16744447,
          steelblue: 1182971135,
          tan: 3535047935,
          teal: 8421631,
          thistle: 3636451583,
          tomato: 4284696575,
          turquoise: 1088475391,
          violet: 4001558271,
          wheat: 4125012991,
          white: 4294967295,
          whitesmoke: 4126537215,
          yellow: 4294902015,
          yellowgreen: 2597139199
        },
            q = "[-+]?\\d*\\.?\\d+",
            Y = q + "%";

        function call() {
          for (var _len10 = arguments.length, l = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
            l[_key10] = arguments[_key10];
          }

          return "\\(\\s*(" + l.join(")\\s*,\\s*(") + ")\\s*\\)";
        }

        var Z = new RegExp("rgb" + call(q, q, q)),
            X = new RegExp("rgba" + call(q, q, q, q)),
            Q = new RegExp("hsl" + call(q, Y, Y)),
            J = new RegExp("hsla" + call(q, Y, Y, q)),
            ee = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            te = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            ne = /^#([0-9a-fA-F]{6})$/,
            oe = /^#([0-9a-fA-F]{8})$/;

        function hue2rgb(l, s, c) {
          return c < 0 && (c += 1), c > 1 && (c -= 1), c < 1 / 6 ? l + 6 * (s - l) * c : c < .5 ? s : c < 2 / 3 ? l + (s - l) * (2 / 3 - c) * 6 : l;
        }

        function hslToRgb(l, s, c) {
          var m = c < .5 ? c * (1 + s) : c + s - c * s,
              v = 2 * c - m,
              _ = hue2rgb(v, m, l + 1 / 3),
              k = hue2rgb(v, m, l),
              y = hue2rgb(v, m, l - 1 / 3);

          return Math.round(255 * _) << 24 | Math.round(255 * k) << 16 | Math.round(255 * y) << 8;
        }

        function parse255(l) {
          var s = parseInt(l, 10);
          return s < 0 ? 0 : s > 255 ? 255 : s;
        }

        function parse360(l) {
          return (parseFloat(l) % 360 + 360) % 360 / 360;
        }

        function parse1(l) {
          var s = parseFloat(l);
          return s < 0 ? 0 : s > 1 ? 255 : Math.round(255 * s);
        }

        function parsePercentage(l) {
          var s = parseFloat(l);
          return s < 0 ? 0 : s > 100 ? 1 : s / 100;
        }

        function colorToRgba(l) {
          var s = function normalizeColor(l) {
            var s;
            return "number" == typeof l ? l >>> 0 === l && l >= 0 && l <= 4294967295 ? l : null : (s = ne.exec(l)) ? parseInt(s[1] + "ff", 16) >>> 0 : R && void 0 !== R[l] ? R[l] : (s = Z.exec(l)) ? (parse255(s[1]) << 24 | parse255(s[2]) << 16 | parse255(s[3]) << 8 | 255) >>> 0 : (s = X.exec(l)) ? (parse255(s[1]) << 24 | parse255(s[2]) << 16 | parse255(s[3]) << 8 | parse1(s[4])) >>> 0 : (s = ee.exec(l)) ? parseInt(s[1] + s[1] + s[2] + s[2] + s[3] + s[3] + "ff", 16) >>> 0 : (s = oe.exec(l)) ? parseInt(s[1], 16) >>> 0 : (s = te.exec(l)) ? parseInt(s[1] + s[1] + s[2] + s[2] + s[3] + s[3] + s[4] + s[4], 16) >>> 0 : (s = Q.exec(l)) ? (255 | hslToRgb(parse360(s[1]), parsePercentage(s[2]), parsePercentage(s[3]))) >>> 0 : (s = J.exec(l)) ? (hslToRgb(parse360(s[1]), parsePercentage(s[2]), parsePercentage(s[3])) | parse1(s[4])) >>> 0 : null;
          }(l);

          return null === s ? l : (s = s || 0, "rgba(".concat((4278190080 & s) >>> 24, ", ").concat((16711680 & s) >>> 16, ", ").concat((65280 & s) >>> 8, ", ").concat((255 & s) / 255, ")"));
        }

        var createInterpolator = function createInterpolator(l, s, c) {
          if (O.fun(l)) return l;
          if (O.arr(l)) return createInterpolator({
            range: l,
            output: s,
            extrapolate: c
          });
          if (O.str(l.output[0])) return L(l);

          var m = l,
              v = m.output,
              _ = m.range || [0, 1],
              k = m.extrapolateLeft || m.extrapolate || "extend",
              y = m.extrapolateRight || m.extrapolate || "extend",
              E = m.easing || function (l) {
            return l;
          };

          return function (l) {
            var s = function findRange(l, s) {
              for (var c = 1; c < s.length - 1 && !(s[c] >= l); ++c) {
                ;
              }

              return c - 1;
            }(l, _);

            return function interpolate(l, s, c, m, v, _, k, y, E) {
              var w = E ? E(l) : l;

              if (w < s) {
                if ("identity" === k) return w;
                "clamp" === k && (w = s);
              }

              if (w > c) {
                if ("identity" === y) return w;
                "clamp" === y && (w = c);
              }

              if (m === v) return m;
              if (s === c) return l <= s ? m : v;
              s === -1 / 0 ? w = -w : c === 1 / 0 ? w -= s : w = (w - s) / (c - s);
              w = _(w), m === -1 / 0 ? w = -w : v === 1 / 0 ? w += m : w = w * (v - m) + m;
              return w;
            }(l, _[s], _[s + 1], v[s], v[s + 1], E, k, y, m.map);
          };
        };

        function _extends() {
          return _extends = Object.assign || function (l) {
            for (var s = 1; s < arguments.length; s++) {
              var c = arguments[s];

              for (var m in c) {
                Object.prototype.hasOwnProperty.call(c, m) && (l[m] = c[m]);
              }
            }

            return l;
          }, _extends.apply(this, arguments);
        }

        var re = Symbol.for("FluidValue.get"),
            le = Symbol.for("FluidValue.observers"),
            hasFluidValue = function hasFluidValue(l) {
          return Boolean(l && l[re]);
        },
            getFluidValue = function getFluidValue(l) {
          return l && l[re] ? l[re]() : l;
        },
            getFluidObservers = function getFluidObservers(l) {
          return l[le] || null;
        };

        function callFluidObservers(l, s) {
          var c = l[le];
          c && c.forEach(function (l) {
            !function callFluidObserver(l, s) {
              l.eventObserved ? l.eventObserved(s) : l(s);
            }(l, s);
          });
        }

        var FluidValue = /*#__PURE__*/_createClass(function FluidValue(l) {
          _classCallCheck(this, FluidValue);

          if (this[re] = void 0, this[le] = void 0, !l && !(l = this.get)) throw Error("Unknown getter");
          setFluidGetter(this, l);
        });

        var setFluidGetter = function setFluidGetter(l, s) {
          return setHidden(l, re, s);
        };

        function addFluidObserver(l, s) {
          if (l[re]) {
            var _c15 = l[le];
            _c15 || setHidden(l, le, _c15 = new Set()), _c15.has(s) || (_c15.add(s), l.observerAdded && l.observerAdded(_c15.size, s));
          }

          return s;
        }

        function removeFluidObserver(l, s) {
          var c = l[le];

          if (c && c.has(s)) {
            var _m12 = c.size - 1;

            _m12 ? c.delete(s) : l[le] = null, l.observerRemoved && l.observerRemoved(_m12, s);
          }
        }

        var setHidden = function setHidden(l, s, c) {
          return Object.defineProperty(l, s, {
            value: c,
            writable: !0,
            configurable: !0
          });
        },
            ie = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
            ae = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi,
            se = new RegExp("(".concat(ie.source, ")(%|[a-z]+)"), "i"),
            ce = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi,
            ue = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/,
            variableToRgba = function variableToRgba(l) {
          var _parseCSSVariable = parseCSSVariable(l),
              _parseCSSVariable2 = _slicedToArray(_parseCSSVariable, 2),
              s = _parseCSSVariable2[0],
              c = _parseCSSVariable2[1];

          if (!s || isSSR()) return l;
          var m = window.getComputedStyle(document.documentElement).getPropertyValue(s);
          if (m) return m.trim();

          if (c && c.startsWith("--")) {
            var _s17 = window.getComputedStyle(document.documentElement).getPropertyValue(c);

            return _s17 || l;
          }

          return c && ue.test(c) ? variableToRgba(c) : c || l;
        },
            parseCSSVariable = function parseCSSVariable(l) {
          var s = ue.exec(l);
          if (!s) return [,];

          var _s18 = _slicedToArray(s, 3),
              c = _s18[1],
              m = _s18[2];

          return [c, m];
        };

        var de;

        var rgbaRound = function rgbaRound(l, s, c, m, v) {
          return "rgba(".concat(Math.round(s), ", ").concat(Math.round(c), ", ").concat(Math.round(m), ", ").concat(v, ")");
        },
            createStringInterpolator = function createStringInterpolator(l) {
          de || (de = R ? new RegExp("(".concat(Object.keys(R).join("|"), ")(?!\\w)"), "g") : /^\b$/);
          var s = l.output.map(function (l) {
            return getFluidValue(l).replace(ue, variableToRgba).replace(ae, colorToRgba).replace(de, colorToRgba);
          }),
              c = s.map(function (l) {
            return l.match(ie).map(Number);
          }),
              m = c[0].map(function (l, s) {
            return c.map(function (l) {
              if (!(s in l)) throw Error('The arity of each "output" value must be equal');
              return l[s];
            });
          }).map(function (s) {
            return createInterpolator(_extends({}, l, {
              output: s
            }));
          });
          return function (l) {
            var c;
            var v = !se.test(s[0]) && (null == (c = s.find(function (l) {
              return se.test(l);
            })) ? void 0 : c.replace(ie, ""));
            var _ = 0;
            return s[0].replace(ie, function () {
              return "".concat(m[_++](l)).concat(v || "");
            }).replace(ce, rgbaRound);
          };
        },
            pe = "react-spring: ",
            once = function once(l) {
          var s = l;
          var c = !1;
          if ("function" != typeof s) throw new TypeError("".concat(pe, "once requires a function parameter"));
          return function () {
            c || (s.apply(void 0, arguments), c = !0);
          };
        },
            me = once(console.warn);

        function deprecateInterpolate() {
          me("".concat(pe, "The \"interpolate\" function is deprecated in v9 (use \"to\" instead)"));
        }

        var fe = once(console.warn);

        function deprecateDirectCall() {
          fe("".concat(pe, "Directly calling start instead of using the api object is deprecated in v9 (use \".start\" instead), this will be removed in later 0.X.0 versions"));
        }

        function isAnimatedString(l) {
          return O.str(l) && ("#" == l[0] || /\d/.test(l) || !isSSR() && ue.test(l) || l in (R || {}));
        }

        var useOnce = function useOnce(l) {
          return (0, P.useEffect)(l, he);
        },
            he = [];

        function useForceUpdate() {
          var l = (0, P.useState)()[1],
              s = (0, P.useState)(makeMountedRef)[0];
          return useOnce(s.unmount), function () {
            s.current && l({});
          };
        }

        function makeMountedRef() {
          var l = {
            current: !0,
            unmount: function unmount() {
              return function () {
                l.current = !1;
              };
            }
          };
          return l;
        }

        function useMemoOne(l, s) {
          var _ref22 = (0, P.useState)(function () {
            return {
              inputs: s,
              result: l()
            };
          }),
              _ref23 = _slicedToArray(_ref22, 1),
              c = _ref23[0],
              m = (0, P.useRef)(),
              v = m.current;

          var _ = v;

          if (_) {
            Boolean(s && _.inputs && function areInputsEqual(l, s) {
              if (l.length !== s.length) return !1;

              for (var _c16 = 0; _c16 < l.length; _c16++) {
                if (l[_c16] !== s[_c16]) return !1;
              }

              return !0;
            }(s, _.inputs)) || (_ = {
              inputs: s,
              result: l()
            });
          } else _ = c;

          return (0, P.useEffect)(function () {
            m.current = _, v == c && (c.inputs = c.result = void 0);
          }, [_]), _.result;
        }

        function usePrev(l) {
          var s = (0, P.useRef)();
          return (0, P.useEffect)(function () {
            s.current = l;
          }), s.current;
        }

        var ge = "undefined" != typeof window && window.document && window.document.createElement ? P.useLayoutEffect : P.useEffect;
      },
      1025: function _() {},
      5419: function _() {},
      5029: function _(l, s, c) {
        "use strict";

        c.r(s), c.d(s, {
          a: function a() {
            return A;
          },
          animated: function animated() {
            return A;
          }
        });
        var m = c(5423),
            v = {};

        var _loop3 = function _loop3(_l21) {
          ["default", "a", "animated"].indexOf(_l21) < 0 && (v[_l21] = function () {
            return m[_l21];
          });
        };

        for (var _l21 in m) {
          _loop3(_l21);
        }

        c.d(s, v);

        var _ = c(7137),
            k = c(2446),
            y = c(3822);

        function _objectWithoutPropertiesLoose(l, s) {
          if (null == l) return {};

          var c,
              m,
              v = {},
              _ = Object.keys(l);

          for (m = 0; m < _.length; m++) {
            c = _[m], s.indexOf(c) >= 0 || (v[c] = l[c]);
          }

          return v;
        }

        var E = ["style", "children", "scrollTop", "scrollLeft"],
            w = /^--/;

        function dangerousStyleValue(l, s) {
          return null == s || "boolean" == typeof s || "" === s ? "" : "number" != typeof s || 0 === s || w.test(l) || S.hasOwnProperty(l) && S[l] ? ("" + s).trim() : s + "px";
        }

        var C = {};
        var S = {
          animationIterationCount: !0,
          borderImageOutset: !0,
          borderImageSlice: !0,
          borderImageWidth: !0,
          boxFlex: !0,
          boxFlexGroup: !0,
          boxOrdinalGroup: !0,
          columnCount: !0,
          columns: !0,
          flex: !0,
          flexGrow: !0,
          flexPositive: !0,
          flexShrink: !0,
          flexNegative: !0,
          flexOrder: !0,
          gridRow: !0,
          gridRowEnd: !0,
          gridRowSpan: !0,
          gridRowStart: !0,
          gridColumn: !0,
          gridColumnEnd: !0,
          gridColumnSpan: !0,
          gridColumnStart: !0,
          fontWeight: !0,
          lineClamp: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          tabSize: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
          fillOpacity: !0,
          floodOpacity: !0,
          stopOpacity: !0,
          strokeDasharray: !0,
          strokeDashoffset: !0,
          strokeMiterlimit: !0,
          strokeOpacity: !0,
          strokeWidth: !0
        };
        var B = ["Webkit", "Ms", "Moz", "O"];
        S = Object.keys(S).reduce(function (l, s) {
          return B.forEach(function (c) {
            return l[function (l, s) {
              return l + s.charAt(0).toUpperCase() + s.substring(1);
            }(c, s)] = l[s];
          }), l;
        }, S);

        var P = ["x", "y", "z"],
            O = /^(matrix|translate|scale|rotate|skew)/,
            L = /^(translate)/,
            V = /^(rotate|skew)/,
            addUnit = function addUnit(l, s) {
          return k.is.num(l) && 0 !== l ? l + s : l;
        },
            isValueIdentity = function isValueIdentity(l, s) {
          return k.is.arr(l) ? l.every(function (l) {
            return isValueIdentity(l, s);
          }) : k.is.num(l) ? l === s : parseFloat(l) === s;
        };

        var AnimatedStyle = /*#__PURE__*/function (_y$rS) {
          _inherits(AnimatedStyle, _y$rS);

          var _super10 = _createSuper(AnimatedStyle);

          function AnimatedStyle(l) {
            var _this24;

            _classCallCheck(this, AnimatedStyle);

            var s = l.x,
                c = l.y,
                m = l.z,
                v = _objectWithoutPropertiesLoose(l, P);

            var _ = [],
                y = [];
            (s || c || m) && (_.push([s || 0, c || 0, m || 0]), y.push(function (l) {
              return ["translate3d(".concat(l.map(function (l) {
                return addUnit(l, "px");
              }).join(","), ")"), isValueIdentity(l, 0)];
            })), (0, k.rU)(v, function (l, s) {
              if ("transform" === s) _.push([l || ""]), y.push(function (l) {
                return [l, "" === l];
              });else if (O.test(s)) {
                if (delete v[s], k.is.und(l)) return;

                var _c17 = L.test(s) ? "px" : V.test(s) ? "deg" : "";

                _.push((0, k.qo)(l)), y.push("rotate3d" === s ? function (_ref24) {
                  var _ref25 = _slicedToArray(_ref24, 4),
                      l = _ref25[0],
                      s = _ref25[1],
                      m = _ref25[2],
                      v = _ref25[3];

                  return ["rotate3d(".concat(l, ",").concat(s, ",").concat(m, ",").concat(addUnit(v, _c17), ")"), isValueIdentity(v, 0)];
                } : function (l) {
                  return ["".concat(s, "(").concat(l.map(function (l) {
                    return addUnit(l, _c17);
                  }).join(","), ")"), isValueIdentity(l, s.startsWith("scale") ? 1 : 0)];
                });
              }
            }), _.length && (v.transform = new FluidTransform(_, y)), _this24 = _super10.call(this, v);
            return _this24;
          }

          return _createClass(AnimatedStyle);
        }(y.rS);

        var FluidTransform = /*#__PURE__*/function (_k$B) {
          _inherits(FluidTransform, _k$B);

          var _super11 = _createSuper(FluidTransform);

          function FluidTransform(l, s) {
            var _this25;

            _classCallCheck(this, FluidTransform);

            _this25 = _super11.call(this), _this25._value = null, _this25.inputs = l, _this25.transforms = s;
            return _this25;
          }

          _createClass(FluidTransform, [{
            key: "get",
            value: function get() {
              return this._value || (this._value = this._get());
            }
          }, {
            key: "_get",
            value: function _get() {
              var _this26 = this;

              var l = "",
                  s = !0;
              return (0, k.S6)(this.inputs, function (c, m) {
                var v = (0, k.je)(c[0]),
                    _this26$transforms$m = _this26.transforms[m](k.is.arr(v) ? v : c.map(k.je)),
                    _this26$transforms$m2 = _slicedToArray(_this26$transforms$m, 2),
                    _ = _this26$transforms$m2[0],
                    y = _this26$transforms$m2[1];

                l += " " + _, s = s && y;
              }), s ? "none" : l;
            }
          }, {
            key: "observerAdded",
            value: function observerAdded(l) {
              var _this27 = this;

              1 == l && (0, k.S6)(this.inputs, function (l) {
                return (0, k.S6)(l, function (l) {
                  return (0, k.j$)(l) && (0, k.UI)(l, _this27);
                });
              });
            }
          }, {
            key: "observerRemoved",
            value: function observerRemoved(l) {
              var _this28 = this;

              0 == l && (0, k.S6)(this.inputs, function (l) {
                return (0, k.S6)(l, function (l) {
                  return (0, k.j$)(l) && (0, k.iL)(l, _this28);
                });
              });
            }
          }, {
            key: "eventObserved",
            value: function eventObserved(l) {
              "change" == l.type && (this._value = null), (0, k.k0)(this, l);
            }
          }]);

          return FluidTransform;
        }(k.B0);

        var R = ["scrollTop", "scrollLeft"];
        m.Globals.assign({
          batchedUpdates: _.unstable_batchedUpdates,
          createStringInterpolator: k.qS,
          colors: k.O9
        });
        var A = (0, y.Ld)(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"], {
          applyAnimatedValues: function applyAnimatedValues(l, s) {
            if (!l.nodeType || !l.setAttribute) return !1;

            var c = "filter" === l.nodeName || l.parentNode && "filter" === l.parentNode.nodeName,
                m = s,
                v = m.style,
                _ = m.children,
                k = m.scrollTop,
                y = m.scrollLeft,
                S = _objectWithoutPropertiesLoose(m, E),
                B = Object.values(S),
                P = Object.keys(S).map(function (s) {
              return c || l.hasAttribute(s) ? s : C[s] || (C[s] = s.replace(/([A-Z])/g, function (l) {
                return "-" + l.toLowerCase();
              }));
            });

            void 0 !== _ && (l.textContent = _);

            for (var _s19 in v) {
              if (v.hasOwnProperty(_s19)) {
                var _c18 = dangerousStyleValue(_s19, v[_s19]);

                w.test(_s19) ? l.style.setProperty(_s19, _c18) : l.style[_s19] = _c18;
              }
            }

            P.forEach(function (s, c) {
              l.setAttribute(s, B[c]);
            }), void 0 !== k && (l.scrollTop = k), void 0 !== y && (l.scrollLeft = y);
          },
          createAnimatedStyle: function createAnimatedStyle(l) {
            return new AnimatedStyle(l);
          },
          getComponentProps: function getComponentProps(l) {
            return _objectWithoutPropertiesLoose(l, R);
          }
        }).animated;
      },
      5251: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            k = c(8467),
            y = c(6700),
            E = c(8026),
            w = m(c(8081)),
            C = m(c(2006)),
            S = c(8486);

        var B = function createBlockCompleter() {
          return {
            name: "blocks",
            className: "block-editor-autocompleters__block",
            triggerPrefix: "/",
            useItems: function useItems(l) {
              var _ref26 = (0, k.useSelect)(function (l) {
                var _l22 = l(S.store),
                    s = _l22.getSelectedBlockClientId,
                    c = _l22.getBlockName,
                    m = _l22.getBlockInsertionPoint,
                    v = s();

                return {
                  selectedBlockName: v ? c(v) : null,
                  rootClientId: m().rootClientId
                };
              }, []),
                  s = _ref26.rootClientId,
                  c = _ref26.selectedBlockName,
                  _ref27 = (0, w.default)(s, _.noop),
                  _ref28 = _slicedToArray(_ref27, 3),
                  m = _ref28[0],
                  y = _ref28[1],
                  B = _ref28[2],
                  P = (0, v.useMemo)(function () {
                return (l.trim() ? (0, E.searchBlockItems)(m, y, B, l) : (0, _.orderBy)(m, ["frecency"], ["desc"])).filter(function (l) {
                  return l.name !== c;
                }).slice(0, 9);
              }, [l, c, m, y, B]);

              return [(0, v.useMemo)(function () {
                return P.map(function (l) {
                  var s = l.title,
                      c = l.icon,
                      m = l.isDisabled;
                  return {
                    key: "block-".concat(l.id),
                    value: l,
                    label: (0, v.createElement)(v.Fragment, null, (0, v.createElement)(C.default, {
                      key: "icon",
                      icon: c,
                      showColors: !0
                    }), s),
                    isDisabled: m
                  };
                });
              }, [P])];
            },
            allowContext: function allowContext(l, s) {
              return !(/\S/.test(l) || /\S/.test(s));
            },
            getOptionCompletion: function getOptionCompletion(l) {
              var s = l.name,
                  c = l.initialAttributes,
                  m = l.innerBlocks;
              return {
                action: "replace",
                value: (0, y.createBlock)(s, c, (0, y.createBlocksFromInnerBlocksTemplate)(m))
              };
            }
          };
        }();

        s.default = B;
      },
      7916: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.AlignmentControl = function AlignmentControl(l) {
          return (0, v.createElement)(k.default, (0, _.default)({}, l, {
            isToolbar: !1
          }));
        }, s.AlignmentToolbar = function AlignmentToolbar(l) {
          return (0, v.createElement)(k.default, (0, _.default)({}, l, {
            isToolbar: !0
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(4452));
      },
      4452: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = c(6756),
            E = c(4892),
            w = c(2614);

        var C = [{
          icon: w.alignLeft,
          title: (0, y.__)("Align text left"),
          align: "left"
        }, {
          icon: w.alignCenter,
          title: (0, y.__)("Align text center"),
          align: "center"
        }, {
          icon: w.alignRight,
          title: (0, y.__)("Align text right"),
          align: "right"
        }],
            S = {
          position: "bottom right",
          isAlternate: !0
        };

        var B = function AlignmentUI(l) {
          var s = l.value,
              c = l.onChange,
              _l$alignmentControls = l.alignmentControls,
              m = _l$alignmentControls === void 0 ? C : _l$alignmentControls,
              _l$label = l.label,
              B = _l$label === void 0 ? (0, y.__)("Align") : _l$label,
              _l$describedBy = l.describedBy,
              P = _l$describedBy === void 0 ? (0, y.__)("Change text alignment") : _l$describedBy,
              _l$isCollapsed = l.isCollapsed,
              O = _l$isCollapsed === void 0 ? !0 : _l$isCollapsed,
              L = l.isToolbar;

          function applyOrUnset(l) {
            return function () {
              return c(s === l ? void 0 : l);
            };
          }

          var V = (0, k.find)(m, function (l) {
            return l.align === s;
          }),
              R = L ? E.ToolbarGroup : E.ToolbarDropdownMenu,
              A = L ? {
            isCollapsed: O
          } : {};
          return (0, v.createElement)(R, (0, _.default)({
            icon: function setIcon() {
              return V ? V.icon : (0, y.isRTL)() ? w.alignRight : w.alignLeft;
            }(),
            label: B,
            toggleProps: {
              describedBy: P
            },
            popoverProps: S,
            controls: m.map(function (l) {
              var c = l.align,
                  m = s === c;
              return _objectSpread(_objectSpread({}, l), {}, {
                isActive: m,
                role: O ? "menuitemradio" : void 0,
                onClick: applyOrUnset(c)
              });
            })
          }, A));
        };

        s.default = B;
      },
      9640: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0, s.useBlockEditorAutocompleteProps = function useBlockEditorAutocompleteProps(l) {
          return (0, E.__unstableUseAutocompleteProps)(_objectSpread(_objectSpread({}, l), {}, {
            completers: useCompleters(l)
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = c(1149),
            E = c(4892),
            w = c(6700),
            C = c(7310),
            S = m(c(5251));

        var B = [];

        function useCompleters(l) {
          var _l$completers = l.completers,
              s = _l$completers === void 0 ? B : _l$completers;

          var _ref29 = (0, C.useBlockEditContext)(),
              c = _ref29.name;

          return (0, v.useMemo)(function () {
            var l = s;
            return (c === (0, w.getDefaultBlockName)() || (0, w.getBlockSupport)(c, "__experimentalSlashInserter", !1)) && (l = l.concat([S.default])), (0, y.hasFilter)("editor.Autocomplete.completers") && (l === s && (l = l.map(k.clone)), l = (0, y.applyFilters)("editor.Autocomplete.completers", l, c)), l;
          }, [s, c]);
        }

        var P = function BlockEditorAutocomplete(l) {
          return (0, v.createElement)(E.Autocomplete, (0, _.default)({}, l, {
            completers: useCompleters(l)
          }));
        };

        s.default = P;
      },
      1550: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockActions(l) {
          var s = l.clientIds,
              c = l.children,
              E = l.__experimentalUpdateSelection;

          var _ref30 = (0, v.useSelect)(y.store),
              w = _ref30.canInsertBlockType,
              C = _ref30.getBlockRootClientId,
              S = _ref30.getBlocksByClientId,
              B = _ref30.canMoveBlocks,
              P = _ref30.canRemoveBlocks,
              _ref31 = (0, v.useSelect)(_.store),
              O = _ref31.getDefaultBlockName,
              L = _ref31.getGroupingBlockName,
              V = S(s),
              R = C(s[0]),
              A = (0, m.every)(V, function (l) {
            return !!l && (0, _.hasBlockSupport)(l.name, "multiple", !0) && w(l.name, R);
          }),
              z = w(O(), R),
              D = B(s, R),
              F = P(s, R),
              _ref32 = (0, v.useDispatch)(y.store),
              G = _ref32.removeBlocks,
              U = _ref32.replaceBlocks,
              W = _ref32.duplicateBlocks,
              K = _ref32.insertAfterBlock,
              $ = _ref32.insertBeforeBlock,
              q = _ref32.flashBlock,
              Y = _ref32.setBlockMovingClientId,
              Z = _ref32.setNavigationMode,
              X = _ref32.selectBlock,
              Q = (0, k.useNotifyCopy)();

          return c({
            canDuplicate: A,
            canInsertDefaultBlock: z,
            canMove: D,
            canRemove: F,
            rootClientId: R,
            blocks: V,
            onDuplicate: function onDuplicate() {
              return W(s, E);
            },
            onRemove: function onRemove() {
              return G(s, E);
            },
            onInsertBefore: function onInsertBefore() {
              $((0, m.first)((0, m.castArray)(s)));
            },
            onInsertAfter: function onInsertAfter() {
              K((0, m.last)((0, m.castArray)(s)));
            },
            onMoveTo: function onMoveTo() {
              Z(!0), X(s[0]), Y(s[0]);
            },
            onGroup: function onGroup() {
              if (!V.length) return;
              var l = L(),
                  c = (0, _.switchToBlockType)(V, l);
              c && U(s, c);
            },
            onUngroup: function onUngroup() {
              if (!V.length) return;
              var l = V[0].innerBlocks;
              l.length && U(s, l);
            },
            onCopy: function onCopy() {
              var l = V.map(function (l) {
                var s = l.clientId;
                return s;
              });
              1 === V.length && q(l[0]), Q("copy", l);
            }
          });
        };

        var m = c(4793),
            v = c(8467),
            _ = c(6700),
            k = c(303),
            y = c(8486);
      },
      6899: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockAlignmentControl = function BlockAlignmentControl(l) {
          return (0, v.createElement)(k.default, (0, _.default)({}, l, {
            isToolbar: !1
          }));
        }, s.BlockAlignmentToolbar = function BlockAlignmentToolbar(l) {
          return (0, v.createElement)(k.default, (0, _.default)({}, l, {
            isToolbar: !0
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2391));
      },
      2391: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(6756),
            E = c(4892),
            w = c(2614),
            C = m(c(2856));

        var S = {
          none: {
            icon: w.alignNone,
            title: (0, y.__)("None")
          },
          left: {
            icon: w.positionLeft,
            title: (0, y.__)("Align left")
          },
          center: {
            icon: w.positionCenter,
            title: (0, y.__)("Align center")
          },
          right: {
            icon: w.positionRight,
            title: (0, y.__)("Align right")
          },
          wide: {
            icon: w.stretchWide,
            title: (0, y.__)("Wide width")
          },
          full: {
            icon: w.stretchFullWidth,
            title: (0, y.__)("Full width")
          }
        },
            B = {
          isAlternate: !0
        };

        var P = function BlockAlignmentUI(l) {
          var s = l.value,
              c = l.onChange,
              m = l.controls,
              w = l.isToolbar,
              _l$isCollapsed2 = l.isCollapsed,
              P = _l$isCollapsed2 === void 0 ? !0 : _l$isCollapsed2;
          var O = (0, C.default)(m);
          if (!!!O.length) return null;

          function onChangeAlignment(l) {
            c([s, "none"].includes(l) ? void 0 : l);
          }

          var L = S[s],
              V = S.none,
              R = w ? E.ToolbarGroup : E.ToolbarDropdownMenu,
              A = {
            popoverProps: B,
            icon: L ? L.icon : V.icon,
            label: (0, y.__)("Align"),
            toggleProps: {
              describedBy: (0, y.__)("Change alignment")
            }
          },
              z = w || v.Platform.isNative ? {
            isCollapsed: w ? P : void 0,
            controls: O.map(function (l) {
              var c = l.name;
              return _objectSpread(_objectSpread({}, S[c]), {}, {
                isActive: s === c || !s && "none" === c,
                role: P ? "menuitemradio" : void 0,
                onClick: function onClick() {
                  return onChangeAlignment(c);
                }
              });
            })
          } : {
            children: function children(l) {
              var c = l.onClose;
              return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(E.MenuGroup, {
                className: "block-editor-block-alignment-control__menu-group"
              }, O.map(function (l) {
                var m = l.name,
                    _ = l.info;
                var _S$m = S[m],
                    y = _S$m.icon,
                    w = _S$m.title,
                    C = m === s || !s && "none" === m;
                return (0, v.createElement)(E.MenuItem, {
                  key: m,
                  icon: y,
                  iconPosition: "left",
                  className: (0, k.default)("components-dropdown-menu__menu-item", {
                    "is-active": C
                  }),
                  isSelected: C,
                  onClick: function onClick() {
                    onChangeAlignment(m), c();
                  },
                  role: "menuitemradio",
                  info: _
                }, w);
              })));
            }
          };
          return (0, v.createElement)(R, (0, _.default)({}, A, z));
        };

        s.default = P;
      },
      2856: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useAvailableAlignments() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : y;
          l.includes("none") || (l = ["none"].concat(_toConsumableArray(l)));

          var _ref33 = (0, m.useSelect)(function (l) {
            var _l23 = l(_.store),
                s = _l23.getSettings,
                c = s();

            return {
              wideControlsEnabled: c.alignWide,
              themeSupportsLayout: c.supportsLayout
            };
          }, []),
              _ref33$wideControlsEn = _ref33.wideControlsEnabled,
              s = _ref33$wideControlsEn === void 0 ? !1 : _ref33$wideControlsEn,
              c = _ref33.themeSupportsLayout,
              w = (0, v.useLayout)(),
              C = (0, k.getLayoutType)(null == w ? void 0 : w.type),
              S = C.getAlignments(w);

          if (c) {
            var _s20 = S.filter(function (s) {
              var c = s.name;
              return l.includes(c);
            });

            return 1 === _s20.length && "none" === _s20[0].name ? [] : _s20;
          }

          if ("default" !== C.name) return [];
          var _w$alignments = w.alignments,
              B = _w$alignments === void 0 ? y : _w$alignments,
              P = l.filter(function (l) {
            return (w.alignments || s || !E.includes(l)) && B.includes(l);
          }).map(function (l) {
            return {
              name: l
            };
          });
          if (1 === P.length && "none" === P[0].name) return [];
          return P;
        };

        var m = c(8467),
            v = c(7189),
            _ = c(8486),
            k = c(6633);

        var y = ["none", "left", "center", "right", "wide", "full"],
            E = ["wide", "full"];
      },
      5641: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(4793),
            _ = c(6756),
            k = c(9880),
            y = c(4892);

        var E = function BlockAlignmentMatrixControl(l) {
          var _l$label2 = l.label,
              s = _l$label2 === void 0 ? (0, _.__)("Change matrix alignment") : _l$label2,
              _l$onChange = l.onChange,
              c = _l$onChange === void 0 ? v.noop : _l$onChange,
              _l$value = l.value,
              E = _l$value === void 0 ? "center" : _l$value,
              w = l.isDisabled,
              C = (0, m.createElement)(y.__experimentalAlignmentMatrixControl.Icon, {
            value: E
          }),
              S = "block-editor-block-alignment-matrix-control",
              B = "".concat(S, "__popover");
          return (0, m.createElement)(y.Dropdown, {
            position: "bottom right",
            className: S,
            popoverProps: {
              className: B,
              isAlternate: !0
            },
            renderToggle: function renderToggle(l) {
              var c = l.onToggle,
                  v = l.isOpen;
              return (0, m.createElement)(y.ToolbarButton, {
                onClick: c,
                "aria-haspopup": "true",
                "aria-expanded": v,
                onKeyDown: function onKeyDown(l) {
                  v || l.keyCode !== k.DOWN || (l.preventDefault(), c());
                },
                label: s,
                icon: C,
                showTooltip: !0,
                disabled: w
              });
            },
            renderContent: function renderContent() {
              return (0, m.createElement)(y.__experimentalAlignmentMatrixControl, {
                hasFocusBorder: !1,
                onChange: c,
                value: E
              });
            }
          });
        };

        s.default = E;
      },
      3527: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4892),
            k = c(8467),
            y = c(6756),
            E = c(2614),
            w = m(c(6147)),
            C = c(8486);

        var S = function BlockBreadcrumb(l) {
          var s = l.rootLabelText;

          var _ref34 = (0, k.useDispatch)(C.store),
              c = _ref34.selectBlock,
              m = _ref34.clearSelectedBlock,
              _ref35 = (0, k.useSelect)(function (l) {
            var _l24 = l(C.store),
                s = _l24.getSelectionStart,
                c = _l24.getSelectedBlockClientId,
                m = _l24.getBlockParents,
                v = c();

            return {
              parents: m(v),
              clientId: v,
              hasSelection: !!s().clientId
            };
          }, []),
              S = _ref35.clientId,
              B = _ref35.parents,
              P = _ref35.hasSelection,
              O = s || (0, y.__)("Document");

          return (0, v.createElement)("ul", {
            className: "block-editor-block-breadcrumb",
            role: "list",
            "aria-label": (0, y.__)("Block breadcrumb")
          }, (0, v.createElement)("li", {
            className: P ? void 0 : "block-editor-block-breadcrumb__current",
            "aria-current": P ? void 0 : "true"
          }, P && (0, v.createElement)(_.Button, {
            className: "block-editor-block-breadcrumb__button",
            variant: "tertiary",
            onClick: m
          }, O), !P && O, !!S && (0, v.createElement)(E.Icon, {
            icon: E.chevronRightSmall,
            className: "block-editor-block-breadcrumb__separator"
          })), B.map(function (l) {
            return (0, v.createElement)("li", {
              key: l
            }, (0, v.createElement)(_.Button, {
              className: "block-editor-block-breadcrumb__button",
              variant: "tertiary",
              onClick: function onClick() {
                return c(l);
              }
            }, (0, v.createElement)(w.default, {
              clientId: l
            })), (0, v.createElement)(E.Icon, {
              icon: E.chevronRightSmall,
              className: "block-editor-block-breadcrumb__separator"
            }));
          }), !!S && (0, v.createElement)("li", {
            className: "block-editor-block-breadcrumb__current",
            "aria-current": "true"
          }, (0, v.createElement)(w.default, {
            clientId: S
          })));
        };

        s.default = S;
      },
      5939: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(3703)),
            k = m(c(2006));

        var y = function BlockCard(l) {
          var _y3;

          var s = l.title,
              c = l.icon,
              m = l.description,
              y = l.blockType;
          return y && ((0, _.default)("`blockType` property in `BlockCard component`", {
            since: "5.7",
            alternative: "`title, icon and description` properties"
          }), (_y3 = y, s = _y3.title, c = _y3.icon, m = _y3.description, _y3)), (0, v.createElement)("div", {
            className: "block-editor-block-card"
          }, (0, v.createElement)(k.default, {
            icon: c,
            showColors: !0
          }), (0, v.createElement)("div", {
            className: "block-editor-block-card__content"
          }, (0, v.createElement)("h2", {
            className: "block-editor-block-card__title"
          }, s), (0, v.createElement)("span", {
            className: "block-editor-block-card__description"
          }, m)));
        };

        s.default = y;
      },
      6980: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockView(l) {
          var s = l.title,
              c = l.rawContent,
              k = l.renderedContent,
              y = l.action,
              E = l.actionText,
              w = l.className;
          return (0, m.createElement)("div", {
            className: w
          }, (0, m.createElement)("div", {
            className: "block-editor-block-compare__content"
          }, (0, m.createElement)("h2", {
            className: "block-editor-block-compare__heading"
          }, s), (0, m.createElement)("div", {
            className: "block-editor-block-compare__html"
          }, c), (0, m.createElement)("div", {
            className: "block-editor-block-compare__preview edit-post-visual-editor"
          }, (0, m.createElement)(m.RawHTML, null, (0, _.safeHTML)(k)))), (0, m.createElement)("div", {
            className: "block-editor-block-compare__action"
          }, (0, m.createElement)(v.Button, {
            variant: "secondary",
            tabIndex: "0",
            onClick: y
          }, E)));
        };

        var m = c(1753),
            v = c(4892),
            _ = c(5480);
      },
      3968: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(4793),
            y = c(6727),
            E = c(6756),
            w = c(6700),
            C = m(c(6980));

        var S = function BlockCompare(l) {
          var s = l.block,
              c = l.onKeep,
              m = l.onConvert,
              S = l.convertor,
              B = l.convertButtonText;

          var P = function getConvertedContent(l) {
            return (0, k.castArray)(l).map(function (l) {
              return (0, w.getSaveContent)(l.name, l.attributes, l.innerBlocks);
            }).join("");
          }(S(s)),
              O = function getDifference(l, s) {
            return (0, y.diffChars)(l, s).map(function (l, s) {
              var c = (0, _.default)({
                "block-editor-block-compare__added": l.added,
                "block-editor-block-compare__removed": l.removed
              });
              return (0, v.createElement)("span", {
                key: s,
                className: c
              }, l.value);
            });
          }(s.originalContent, P);

          return (0, v.createElement)("div", {
            className: "block-editor-block-compare__wrapper"
          }, (0, v.createElement)(C.default, {
            title: (0, E.__)("Current"),
            className: "block-editor-block-compare__current",
            action: c,
            actionText: (0, E.__)("Convert to HTML"),
            rawContent: s.originalContent,
            renderedContent: s.originalContent
          }), (0, v.createElement)(C.default, {
            title: (0, E.__)("After Conversion"),
            className: "block-editor-block-compare__converted",
            action: m,
            actionText: B,
            rawContent: O,
            renderedContent: P
          }));
        };

        s.default = S;
      },
      3082: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockContentOverlay(l) {
          var s = l.clientId,
              _l$tagName = l.tagName,
              c = _l$tagName === void 0 ? "div" : _l$tagName,
              m = l.wrapperProps,
              w = l.className;

          var _ref36 = (0, v.useState)(!0),
              _ref37 = _slicedToArray(_ref36, 2),
              C = _ref37[0],
              S = _ref37[1],
              _ref38 = (0, v.useState)(!1),
              _ref39 = _slicedToArray(_ref38, 2),
              B = _ref39[0],
              P = _ref39[1],
              _ref40 = (0, k.useSelect)(function (l) {
            var _l25 = l(y.store),
                c = _l25.isBlockSelected,
                m = _l25.hasSelectedInnerBlock,
                v = _l25.isDraggingBlocks,
                _ = _l25.isBlockHighlighted;

            return {
              isParentSelected: c(s),
              hasChildSelected: m(s, !0),
              isDraggingBlocks: v(),
              isParentHighlighted: _(s)
            };
          }, [s]),
              O = _ref40.isParentSelected,
              L = _ref40.hasChildSelected,
              V = _ref40.isDraggingBlocks,
              R = _ref40.isParentHighlighted,
              A = (0, E.default)("block-editor-block-content-overlay", null == m ? void 0 : m.className, w, {
            "overlay-active": C,
            "parent-highlighted": R,
            "is-dragging-blocks": V
          });

          return (0, v.useEffect)(function () {
            O || L || C || S(!0), O && !B && C && S(!1), L && C && S(!1);
          }, [O, L, C, B]), (0, v.createElement)(c, (0, _.default)({}, m, {
            className: A,
            onMouseEnter: function onMouseEnter() {
              return P(!0);
            },
            onMouseLeave: function onMouseLeave() {
              return P(!1);
            },
            onMouseUp: C ? function () {
              return S(!1);
            } : void 0
          }), null == m ? void 0 : m.children);
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(8467),
            y = c(8486),
            E = m(c(2703));
      },
      5038: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockContextProvider = function BlockContextProvider(l) {
          var s = l.value,
              c = l.children;

          var _ = (0, m.useContext)(v),
              k = (0, m.useMemo)(function () {
            return _objectSpread(_objectSpread({}, _), s);
          }, [_, s]);

          return (0, m.createElement)(v.Provider, {
            value: k,
            children: c
          });
        }, s.default = void 0;
        var m = c(1753);
        var v = (0, m.createContext)({});
        var _ = v;
        s.default = _;
      },
      5454: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockControlsFill(l) {
          var _l$group = l.group,
              s = _l$group === void 0 ? "default" : _l$group,
              c = l.controls,
              m = l.children,
              _l$__experimentalShar = l.__experimentalShareWithChildBlocks,
              E = _l$__experimentalShar === void 0 ? !1 : _l$__experimentalShar;
          var w = (0, y.default)(s, E);
          if (!w) return null;
          return (0, v.createElement)(k.__experimentalStyleProvider, {
            document: document
          }, (0, v.createElement)(w, null, function (l) {
            var y = (0, _.isEmpty)(l) ? null : l;
            return (0, v.createElement)(k.__experimentalToolbarContext.Provider, {
              value: y
            }, "default" === s && (0, v.createElement)(k.ToolbarGroup, {
              controls: c
            }), m);
          }));
        };

        var v = c(1753),
            _ = c(4793),
            k = c(4892),
            y = m(c(423));
      },
      1281: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(4892);
        var v = {
          default: (0, m.createSlotFill)("BlockControls"),
          block: (0, m.createSlotFill)("BlockControlsBlock"),
          inline: (0, m.createSlotFill)("BlockFormatControls"),
          other: (0, m.createSlotFill)("BlockControlsOther"),
          parent: (0, m.createSlotFill)("BlockControlsParent")
        };
        s.default = v;
      },
      423: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useBlockControlsFill(l, s) {
          var c = (0, w.default)(),
              _ref41 = (0, E.useBlockEditContext)(),
              m = _ref41.clientId,
              C = (0, _.useSelect)(function (l) {
            var _l26 = l(y.store),
                c = _l26.getBlockName,
                _ = _l26.hasSelectedInnerBlock,
                _l27 = l(v.store),
                k = _l27.hasBlockSupport;

            return s && k(c(m), "__experimentalExposeControlsToChildren", !1) && _(m);
          }, [s, m]);

          var S;
          if (c) return null === (S = k.default[l]) || void 0 === S ? void 0 : S.Fill;
          if (C) return k.default.parent.Fill;
          return null;
        };

        var v = c(6700),
            _ = c(8467),
            k = m(c(1281)),
            y = c(8486),
            E = c(7310),
            w = m(c(7706));
      },
      915: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.BlockFormatControls = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(5454)),
            y = m(c(2812));

        var E = k.default;
        E.Slot = y.default;

        var BlockFormatControls = function BlockFormatControls(l) {
          return (0, v.createElement)(k.default, (0, _.default)({
            group: "inline"
          }, l));
        };

        s.BlockFormatControls = BlockFormatControls, BlockFormatControls.Slot = function (l) {
          return (0, v.createElement)(y.default, (0, _.default)({
            group: "inline"
          }, l));
        };
        var w = E;
        s.default = w;
      },
      2812: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockControlsSlot(l) {
          var _l$group2 = l.group,
              s = _l$group2 === void 0 ? "default" : _l$group2,
              c = _objectWithoutProperties(l, _excluded);

          var m = (0, v.useContext)(k.__experimentalToolbarContext),
              E = y.default[s].Slot,
              w = (0, k.__experimentalUseSlot)(E.__unstableName);
          if (!Boolean(w.fills && w.fills.length)) return null;
          if ("default" === s) return (0, v.createElement)(E, (0, _.default)({}, c, {
            bubblesVirtually: !0,
            fillProps: m
          }));
          return (0, v.createElement)(k.ToolbarGroup, null, (0, v.createElement)(E, (0, _.default)({}, c, {
            bubblesVirtually: !0,
            fillProps: m
          })));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = m(c(1281));
      },
      6117: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockDraggableChip(l) {
          var s = l.count,
              c = l.icon;
          return (0, v.createElement)("div", {
            className: "block-editor-block-draggable-chip-wrapper"
          }, (0, v.createElement)("div", {
            className: "block-editor-block-draggable-chip"
          }, (0, v.createElement)(k.Flex, {
            justify: "center",
            className: "block-editor-block-draggable-chip__content"
          }, (0, v.createElement)(k.FlexItem, null, c ? (0, v.createElement)(E.default, {
            icon: c
          }) : (0, _.sprintf)((0, _._n)("%d block", "%d blocks", s), s)), (0, v.createElement)(k.FlexItem, null, (0, v.createElement)(E.default, {
            icon: y.dragHandle
          })))));
        };

        var v = c(1753),
            _ = c(6756),
            k = c(4892),
            y = c(2614),
            E = m(c(2006));
      },
      566: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(6700),
            k = c(4892),
            y = c(8467),
            E = m(c(6117)),
            w = m(c(9650)),
            C = c(8486);

        var _default = function _default(l) {
          var s = l.children,
              c = l.clientIds,
              m = l.cloneClassname,
              S = l.onDragStart,
              B = l.onDragEnd;

          var _ref42 = (0, y.useSelect)(function (l) {
            var s;

            var _l28 = l(C.store),
                m = _l28.getBlockRootClientId,
                v = _l28.getTemplateLock,
                k = _l28.getBlockName,
                y = m(c[0]),
                E = y ? v(y) : null,
                w = k(c[0]);

            return {
              srcRootClientId: y,
              isDraggable: "all" !== E,
              icon: null === (s = (0, _.getBlockType)(w)) || void 0 === s ? void 0 : s.icon
            };
          }, [c]),
              P = _ref42.srcRootClientId,
              O = _ref42.isDraggable,
              L = _ref42.icon,
              V = (0, v.useRef)(!1),
              _ref43 = (0, w.default)(),
              _ref44 = _slicedToArray(_ref43, 3),
              R = _ref44[0],
              A = _ref44[1],
              z = _ref44[2],
              _ref45 = (0, y.useDispatch)(C.store),
              D = _ref45.startDraggingBlocks,
              F = _ref45.stopDraggingBlocks;

          if ((0, v.useEffect)(function () {
            return function () {
              V.current && F();
            };
          }, []), !O) return s({
            isDraggable: !1
          });
          var G = {
            type: "block",
            srcClientIds: c,
            srcRootClientId: P
          };
          return (0, v.createElement)(k.Draggable, {
            cloneClassname: m,
            __experimentalTransferDataType: "wp-blocks",
            transferData: G,
            onDragStart: function onDragStart(l) {
              D(c), V.current = !0, R(l), S && S();
            },
            onDragOver: A,
            onDragEnd: function onDragEnd() {
              F(), V.current = !1, z(), B && B();
            },
            __experimentalDragComponent: (0, v.createElement)(E.default, {
              count: c.length,
              icon: L
            })
          }, function (l) {
            var c = l.onDraggableStart,
                m = l.onDraggableEnd;
            return s({
              draggable: !0,
              onDragStart: c,
              onDragEnd: m
            });
          });
        };

        s.default = _default;
      },
      9650: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useScrollWhenDragging() {
          var l = (0, v.useRef)(null),
              s = (0, v.useRef)(null),
              c = (0, v.useRef)(null),
              _ = (0, v.useRef)(null);

          (0, v.useEffect)(function () {
            return function () {
              _.current && (clearInterval(_.current), _.current = null);
            };
          }, []);
          var k = (0, v.useCallback)(function (v) {
            l.current = v.clientY, c.current = (0, m.getScrollContainer)(v.target), _.current = setInterval(function () {
              if (c.current && s.current) {
                var _l29 = c.current.scrollTop + s.current;

                c.current.scroll({
                  top: _l29
                });
              }
            }, 25);
          }, []),
              y = (0, v.useCallback)(function (m) {
            if (!c.current) return;

            var v = c.current.offsetHeight,
                _ = l.current - c.current.offsetTop,
                k = m.clientY - c.current.offsetTop;

            if (m.clientY > _) {
              var _l30 = Math.max(v - _ - 50, 0),
                  _c19 = Math.max(k - _ - 50, 0) / _l30;

              s.current = 25 * _c19;
            } else if (m.clientY < _) {
              var _l31 = Math.max(_ - 50, 0),
                  _c20 = Math.max(_ - k - 50, 0) / _l31;

              s.current = -25 * _c20;
            } else s.current = 0;
          }, []);
          return [k, y, function () {
            l.current = null, c.current = null, _.current && (clearInterval(_.current), _.current = null);
          }];
        };
        var m = c(5480),
            v = c(1753);
      },
      7310: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.DEFAULT_BLOCK_EDIT_CONTEXT = s.BlockEditContextProvider = void 0, s.useBlockEditContext = function useBlockEditContext() {
          return (0, m.useContext)(_);
        };
        var m = c(1753);
        var v = {
          name: "",
          isSelected: !1
        };
        s.DEFAULT_BLOCK_EDIT_CONTEXT = v;

        var _ = (0, m.createContext)(v),
            k = _.Provider;

        s.BlockEditContextProvider = k;
      },
      1265: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.Edit = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(4793),
            E = c(4892),
            w = c(6700),
            C = m(c(5038));

        var S = {},
            Edit = function Edit(l) {
          var _l$attributes = l.attributes,
              s = _l$attributes === void 0 ? {} : _l$attributes,
              c = l.name,
              m = (0, w.getBlockType)(c),
              E = (0, v.useContext)(C.default),
              B = (0, v.useMemo)(function () {
            return m && m.usesContext ? (0, y.pick)(E, m.usesContext) : S;
          }, [m, E]);
          if (!m) return null;
          var P = m.edit || m.save;
          if (m.apiVersion > 1) return (0, v.createElement)(P, (0, _.default)({}, l, {
            context: B
          }));
          var O = (0, w.hasBlockSupport)(m, "className", !0) ? (0, w.getBlockDefaultClassName)(c) : null,
              L = (0, k.default)(O, s.className);
          return (0, v.createElement)(P, (0, _.default)({}, l, {
            context: B,
            className: L
          }));
        };

        s.Edit = Edit;
        var B = (0, E.withFilters)("editor.BlockEdit")(Edit);
        s.default = B;
      },
      5490: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockEdit(l) {
          var s = l.name,
              c = l.isSelected,
              m = l.clientId,
              y = {
            name: s,
            isSelected: c,
            clientId: m
          };
          return (0, v.createElement)(k.BlockEditContextProvider, {
            value: (0, v.useMemo)(function () {
              return y;
            }, Object.values(y))
          }, (0, v.createElement)(_.default, l));
        }, Object.defineProperty(s, "useBlockEditContext", {
          enumerable: !0,
          get: function get() {
            return k.useBlockEditContext;
          }
        });

        var v = c(1753),
            _ = m(c(1265)),
            k = c(7310);
      },
      2068: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6756),
            _ = c(4892),
            k = c(2614);

        var y = function BlockFullHeightAlignmentControl(l) {
          var s = l.isActive,
              _l$label3 = l.label,
              c = _l$label3 === void 0 ? (0, v.__)("Toggle full height") : _l$label3,
              y = l.onToggle,
              E = l.isDisabled;
          return (0, m.createElement)(_.ToolbarButton, {
            isActive: s,
            icon: k.fullscreen,
            label: c,
            onClick: function onClick() {
              return y(!s);
            },
            disabled: E
          });
        };

        s.default = y;
      },
      2006: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(4892),
            y = c(2614);

        var E = (0, v.memo)(function BlockIcon(l) {
          var s;
          var c = l.icon,
              _l$showColors = l.showColors,
              m = _l$showColors === void 0 ? !1 : _l$showColors,
              E = l.className;
          "block-default" === (null === (s = c) || void 0 === s ? void 0 : s.src) && (c = {
            src: y.blockDefault
          });
          var w = (0, v.createElement)(k.Icon, {
            icon: c && c.src ? c.src : c
          }),
              C = m ? {
            backgroundColor: c && c.background,
            color: c && c.foreground
          } : {};
          return (0, v.createElement)("span", {
            style: C,
            className: (0, _.default)("block-editor-block-icon", E, {
              "has-colors": m
            })
          }, w);
        });
        s.default = E;
      },
      1404: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(6756),
            k = c(6700),
            y = c(4892),
            E = c(8467),
            w = m(c(39)),
            C = m(c(5939)),
            S = function _interopRequireWildcard(l, s) {
          if (!s && l && l.__esModule) return l;
          if (null === l || "object" != typeof l && "function" != typeof l) return {
            default: l
          };

          var c = _getRequireWildcardCache(s);

          if (c && c.has(l)) return c.get(l);
          var m = {},
              v = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var _ in l) {
            if ("default" !== _ && Object.prototype.hasOwnProperty.call(l, _)) {
              var k = v ? Object.getOwnPropertyDescriptor(l, _) : null;
              k && (k.get || k.set) ? Object.defineProperty(m, _, k) : m[_] = l[_];
            }
          }

          m.default = l, c && c.set(l, m);
          return m;
        }(c(5071)),
            B = m(c(6551)),
            P = m(c(3627)),
            O = m(c(8542)),
            L = m(c(5045)),
            V = m(c(139)),
            R = c(8486);

        function _getRequireWildcardCache(l) {
          if ("function" != typeof WeakMap) return null;
          var s = new WeakMap(),
              c = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(l) {
            return l ? c : s;
          })(l);
        }

        var BlockInspectorSingleBlock = function BlockInspectorSingleBlock(l) {
          var s = l.clientId,
              c = l.blockName,
              m = l.hasBlockStyles,
              E = l.bubblesVirtually;
          var P = (0, V.default)(s);
          return (0, v.createElement)("div", {
            className: "block-editor-block-inspector"
          }, (0, v.createElement)(C.default, P), (0, v.createElement)(L.default, {
            blockClientId: s
          }), m && (0, v.createElement)("div", null, (0, v.createElement)(y.PanelBody, {
            title: (0, _.__)("Styles")
          }, (0, v.createElement)(B.default, {
            clientId: s
          }), (0, k.hasBlockSupport)(c, "defaultStylePicker", !0) && (0, v.createElement)(O.default, {
            blockName: c
          }))), (0, v.createElement)(S.default.Slot, {
            bubblesVirtually: E
          }), (0, v.createElement)(S.default.Slot, {
            __experimentalGroup: "typography",
            bubblesVirtually: E,
            label: (0, _.__)("Typography")
          }), (0, v.createElement)(S.default.Slot, {
            __experimentalGroup: "dimensions",
            bubblesVirtually: E,
            label: (0, _.__)("Dimensions")
          }), (0, v.createElement)(S.default.Slot, {
            __experimentalGroup: "border",
            label: (0, _.__)("Border")
          }), (0, v.createElement)("div", null, (0, v.createElement)(AdvancedControls, {
            bubblesVirtually: E
          })), (0, v.createElement)(w.default, {
            key: "back"
          }));
        },
            AdvancedControls = function AdvancedControls(l) {
          var s = l.bubblesVirtually;
          var c = (0, y.__experimentalUseSlot)(S.InspectorAdvancedControls.slotName);
          return Boolean(c.fills && c.fills.length) ? (0, v.createElement)(y.PanelBody, {
            className: "block-editor-block-inspector__advanced",
            title: (0, _.__)("Advanced"),
            initialOpen: !1
          }, (0, v.createElement)(S.default.Slot, {
            __experimentalGroup: "advanced",
            bubblesVirtually: s
          })) : null;
        };

        var _default = function _default(l) {
          var _l$showNoBlockSelecte = l.showNoBlockSelectedMessage,
              s = _l$showNoBlockSelecte === void 0 ? !0 : _l$showNoBlockSelecte,
              _l$bubblesVirtually = l.bubblesVirtually,
              c = _l$bubblesVirtually === void 0 ? !0 : _l$bubblesVirtually;

          var _ref46 = (0, E.useSelect)(function (l) {
            var _l32 = l(R.store),
                s = _l32.getSelectedBlockClientId,
                c = _l32.getSelectedBlockCount,
                m = _l32.getBlockName,
                _l33 = l(k.store),
                v = _l33.getBlockStyles,
                _ = s(),
                y = _ && m(_),
                E = y && (0, k.getBlockType)(y),
                w = y && v(y);

            return {
              count: c(),
              selectedBlockClientId: _,
              selectedBlockName: y,
              blockType: E,
              hasBlockStyles: w && w.length > 0
            };
          }, []),
              m = _ref46.count,
              y = _ref46.hasBlockStyles,
              w = _ref46.selectedBlockName,
              C = _ref46.selectedBlockClientId,
              B = _ref46.blockType;

          if (m > 1) return (0, v.createElement)("div", {
            className: "block-editor-block-inspector"
          }, (0, v.createElement)(P.default, null), (0, v.createElement)(S.default.Slot, null), (0, v.createElement)(S.default.Slot, {
            __experimentalGroup: "typography",
            label: (0, _.__)("Typography")
          }), (0, v.createElement)(S.default.Slot, {
            __experimentalGroup: "dimensions",
            label: (0, _.__)("Dimensions")
          }), (0, v.createElement)(S.default.Slot, {
            __experimentalGroup: "border",
            label: (0, _.__)("Border")
          }));
          var O = w === (0, k.getUnregisteredTypeHandlerName)();
          return B && C && !O ? (0, v.createElement)(BlockInspectorSingleBlock, {
            clientId: C,
            blockName: B.name,
            hasBlockStyles: y,
            bubblesVirtually: c
          }) : s ? (0, v.createElement)("span", {
            className: "block-editor-block-inspector__no-blocks"
          }, (0, _.__)("No block selected.")) : null;
        };

        s.default = _default;
      },
      9575: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            k = m(c(2703)),
            y = c(8467),
            E = c(6700),
            w = m(c(4546)),
            C = m(c(6403)),
            S = c(8486);

        var B = (0, y.withSelect)(function (l, s) {
          var c = s.rootClientId;

          var _l34 = l(S.store),
              m = _l34.getBlockOrder,
              v = _l34.canInsertBlockType,
              _ = _l34.getTemplateLock,
              k = _l34.getSelectedBlockClientId;

          return {
            isLocked: !!_(c),
            blockClientIds: m(c),
            canInsertDefaultBlock: v((0, E.getDefaultBlockName)(), c),
            selectedBlockClientId: k()
          };
        })(function BlockListAppender(l) {
          var s,
              c = l.blockClientIds,
              m = l.rootClientId,
              y = l.canInsertDefaultBlock,
              E = l.isLocked,
              S = l.renderAppender,
              B = l.className,
              P = l.selectedBlockClientId,
              _l$tagName2 = l.tagName,
              O = _l$tagName2 === void 0 ? "div" : _l$tagName2;
          if (E || !1 === S) return null;
          if (S) s = (0, v.createElement)(S, null);else {
            var _l35 = !m,
                _k3 = P === m,
                _E2 = P && !c.includes(P);

            if (!_l35 && !_k3 && (!P || _E2)) return null;
            s = y ? (0, v.createElement)(w.default, {
              rootClientId: m,
              lastBlockClientId: (0, _.last)(c)
            }) : (0, v.createElement)(C.default, {
              rootClientId: m,
              className: "block-list-appender__toggle"
            });
          }
          return (0, v.createElement)(O, {
            tabIndex: -1,
            className: (0, k.default)("block-list-appender wp-block", B),
            "data-block": !0
          }, s);
        });
        s.default = B;
      },
      3571: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(1753);

        var BlockCrashBoundary = /*#__PURE__*/function (_m$Component) {
          _inherits(BlockCrashBoundary, _m$Component);

          var _super12 = _createSuper(BlockCrashBoundary);

          function BlockCrashBoundary() {
            var _this29;

            _classCallCheck(this, BlockCrashBoundary);

            _this29 = _super12.apply(this, arguments), _this29.state = {
              hasError: !1
            };
            return _this29;
          }

          _createClass(BlockCrashBoundary, [{
            key: "componentDidCatch",
            value: function componentDidCatch() {
              this.setState({
                hasError: !0
              });
            }
          }, {
            key: "render",
            value: function render() {
              return this.state.hasError ? this.props.fallback : this.props.children;
            }
          }]);

          return BlockCrashBoundary;
        }(m.Component);

        var v = BlockCrashBoundary;
        s.default = v;
      },
      1829: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(6756),
            k = m(c(4578));

        var y = (0, v.createElement)(k.default, {
          className: "block-editor-block-list__block-crash-warning"
        }, (0, _.__)("This block has encountered an error and cannot be previewed."));

        s.default = function () {
          return y;
        };
      },
      3815: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(6770)),
            k = c(8467),
            y = c(6700),
            E = c(8486);

        var w = function BlockHTML(l) {
          var s = l.clientId;

          var _ref47 = (0, v.useState)(""),
              _ref48 = _slicedToArray(_ref47, 2),
              c = _ref48[0],
              m = _ref48[1],
              w = (0, k.useSelect)(function (l) {
            return l(E.store).getBlock(s);
          }, [s]),
              _ref49 = (0, k.useDispatch)(E.store),
              C = _ref49.updateBlock;

          return (0, v.useEffect)(function () {
            m((0, y.getBlockContent)(w));
          }, [w]), (0, v.createElement)(_.default, {
            className: "block-editor-block-list__block-html-textarea",
            value: c,
            onBlur: function onBlur() {
              var l = (0, y.getBlockType)(w.name);
              if (!l) return;

              var v = (0, y.getBlockAttributes)(l, c, w.attributes),
                  _ = c || (0, y.getSaveContent)(l, v),
                  k = !c || (0, y.isValidBlockContent)(l, v, _);

              C(s, {
                attributes: v,
                originalContent: _,
                isValid: k
              }), c || m({
                content: _
              });
            },
            onChange: function onChange(l) {
              return m(l.target.value);
            }
          });
        };

        s.default = w;
      },
      8835: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockInvalidWarning = BlockInvalidWarning, s.default = void 0;

        var v = c(1753),
            _ = c(6756),
            k = c(4892),
            y = c(6700),
            E = c(3200),
            w = c(8467),
            C = m(c(4578)),
            S = m(c(3968)),
            B = c(8486);

        function BlockInvalidWarning(l) {
          var s = l.convertToHTML,
              c = l.convertToBlocks,
              m = l.convertToClassic,
              E = l.attemptBlockRecovery,
              w = l.block;

          var B = !!(0, y.getBlockType)("core/html"),
              _ref50 = (0, v.useState)(!1),
              _ref51 = _slicedToArray(_ref50, 2),
              P = _ref51[0],
              O = _ref51[1],
              L = (0, v.useCallback)(function () {
            return O(!0);
          }, []),
              V = (0, v.useCallback)(function () {
            return O(!1);
          }, []),
              R = (0, v.useMemo)(function () {
            return [{
              title: (0, _._x)("Resolve", "imperative verb"),
              onClick: L
            }, B && {
              title: (0, _.__)("Convert to HTML"),
              onClick: s
            }, {
              title: (0, _.__)("Convert to Classic Block"),
              onClick: m
            }].filter(Boolean);
          }, [L, s, m]);

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(C.default, {
            actions: [(0, v.createElement)(k.Button, {
              key: "recover",
              onClick: E,
              variant: "primary"
            }, (0, _.__)("Attempt Block Recovery"))],
            secondaryActions: R
          }, (0, _.__)("This block contains unexpected or invalid content.")), P && (0, v.createElement)(k.Modal, {
            title: (0, _.__)("Resolve Block"),
            onRequestClose: V,
            className: "block-editor-block-compare"
          }, (0, v.createElement)(S.default, {
            block: w,
            onKeep: s,
            onConvert: c,
            convertor: blockToBlocks,
            convertButtonText: (0, _.__)("Convert to Blocks")
          })));
        }

        var blockToBlocks = function blockToBlocks(l) {
          return (0, y.rawHandler)({
            HTML: l.originalContent
          });
        };

        var P = (0, E.compose)([(0, w.withSelect)(function (l, s) {
          var c = s.clientId;
          return {
            block: l(B.store).getBlock(c)
          };
        }), (0, w.withDispatch)(function (l, s) {
          var c = s.block;

          var _l36 = l(B.store),
              m = _l36.replaceBlock;

          return {
            convertToClassic: function convertToClassic() {
              m(c.clientId, function (l) {
                return (0, y.createBlock)("core/freeform", {
                  content: l.originalContent
                });
              }(c));
            },
            convertToHTML: function convertToHTML() {
              m(c.clientId, function (l) {
                return (0, y.createBlock)("core/html", {
                  content: l.originalContent
                });
              }(c));
            },
            convertToBlocks: function convertToBlocks() {
              m(c.clientId, blockToBlocks(c));
            },
            attemptBlockRecovery: function attemptBlockRecovery() {
              m(c.clientId, function (l) {
                var s = l.name,
                    c = l.attributes,
                    m = l.innerBlocks;
                return (0, y.createBlock)(s, c, m);
              }(c));
            }
          };
        })])(BlockInvalidWarning);
        s.default = P;
      },
      4418: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.BlockListBlockContext = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(4793),
            y = c(6700),
            E = c(4892),
            w = c(8467),
            C = c(3200),
            S = c(5480),
            B = m(c(5490)),
            P = m(c(8835)),
            O = m(c(1829)),
            L = m(c(3571)),
            V = m(c(3815)),
            R = c(2885),
            A = c(8486);

        var z = (0, v.createContext)();

        function Block(l) {
          var s = l.children,
              c = l.isHtml,
              m = _objectWithoutProperties(l, _excluded2);

          return (0, v.createElement)("div", (0, R.useBlockProps)(m, {
            __unstableIsHtml: c
          }), s);
        }

        s.BlockListBlockContext = z;
        var D = (0, w.withSelect)(function (l, s) {
          var c = s.clientId,
              m = s.rootClientId;

          var _l37 = l(A.store),
              v = _l37.isBlockSelected,
              _ = _l37.getBlockMode,
              k = _l37.isSelectionEnabled,
              y = _l37.getTemplateLock,
              E = _l37.__unstableGetBlockWithoutInnerBlocks,
              w = _l37.canRemoveBlock,
              C = _l37.canMoveBlock,
              S = E(c),
              B = v(c),
              P = y(m),
              O = w(c, m),
              L = C(c, m),
              _ref52 = S || {},
              V = _ref52.name,
              R = _ref52.attributes,
              z = _ref52.isValid;

          return {
            mode: _(c),
            isSelectionEnabled: k(),
            isLocked: !!P,
            canRemove: O,
            canMove: L,
            block: S,
            name: V,
            attributes: R,
            isValid: z,
            isSelected: B
          };
        }),
            F = (0, w.withDispatch)(function (l, s, c) {
          var m = c.select;

          var _l38 = l(A.store),
              v = _l38.updateBlockAttributes,
              _ = _l38.insertBlocks,
              k = _l38.mergeBlocks,
              E = _l38.replaceBlocks,
              w = _l38.toggleSelection,
              C = _l38.__unstableMarkLastChangeAsPersistent;

          return {
            setAttributes: function setAttributes(l) {
              var _m13 = m(A.store),
                  c = _m13.getMultiSelectedBlockClientIds,
                  _ = c(),
                  k = s.clientId,
                  y = _.length ? _ : [k];

              v(y, l);
            },
            onInsertBlocks: function onInsertBlocks(l, c) {
              var m = s.rootClientId;

              _(l, c, m);
            },
            onInsertBlocksAfter: function onInsertBlocksAfter(l) {
              var c = s.clientId,
                  v = s.rootClientId,
                  _m14 = m(A.store),
                  k = _m14.getBlockIndex,
                  y = k(c);

              _(l, y + 1, v);
            },
            onMerge: function onMerge(l) {
              var c = s.clientId,
                  _m15 = m(A.store),
                  v = _m15.getPreviousBlockClientId,
                  _ = _m15.getNextBlockClientId;

              if (l) {
                var _l39 = _(c);

                _l39 && k(c, _l39);
              } else {
                var _l40 = v(c);

                _l40 && k(_l40, c);
              }
            },
            onReplace: function onReplace(l, c, m) {
              l.length && !(0, y.isUnmodifiedDefaultBlock)(l[l.length - 1]) && C(), E([s.clientId], l, c, m);
            },
            toggleSelection: function toggleSelection(l) {
              w(l);
            }
          };
        });
        var G = (0, C.compose)(C.pure, D, F, (0, C.ifCondition)(function (l) {
          var s = l.block;
          return !!s;
        }), (0, E.withFilters)("editor.BlockListBlock"))(function BlockListBlock(l) {
          var s = l.mode,
              c = l.isLocked,
              m = l.canRemove,
              E = l.clientId,
              C = l.isSelected,
              R = l.isSelectionEnabled,
              D = l.className,
              F = l.name,
              G = l.isValid,
              U = l.attributes,
              W = l.wrapperProps,
              K = l.setAttributes,
              $ = l.onReplace,
              q = l.onInsertBlocksAfter,
              Y = l.onMerge,
              Z = l.toggleSelection;

          var _ref53 = (0, w.useDispatch)(A.store),
              X = _ref53.removeBlock,
              Q = (0, v.useCallback)(function () {
            return X(E);
          }, [E]);

          var J = (0, v.createElement)(B.default, {
            name: F,
            isSelected: C,
            attributes: U,
            setAttributes: K,
            insertBlocksAfter: c ? void 0 : q,
            onReplace: m ? $ : void 0,
            onRemove: m ? Q : void 0,
            mergeBlocks: m ? Y : void 0,
            clientId: E,
            isSelectionEnabled: R,
            toggleSelection: Z
          });
          var ee = (0, y.getBlockType)(F);
          null != ee && ee.getEditWrapperProps && (W = function mergeWrapperProps(l, s) {
            var c = _objectSpread(_objectSpread({}, l), s);

            return l && s && l.className && s.className && (c.className = (0, _.default)(l.className, s.className)), l && s && l.style && s.style && (c.style = _objectSpread(_objectSpread({}, l.style), s.style)), c;
          }(W, ee.getEditWrapperProps(U)));
          var te = W && !!W["data-align"];
          var ne;
          if (te && (J = (0, v.createElement)("div", {
            className: "wp-block",
            "data-align": W["data-align"]
          }, J)), G) ne = "html" === s ? (0, v.createElement)(v.Fragment, null, (0, v.createElement)("div", {
            style: {
              display: "none"
            }
          }, J), (0, v.createElement)(Block, {
            isHtml: !0
          }, (0, v.createElement)(V.default, {
            clientId: E
          }))) : (null == ee ? void 0 : ee.apiVersion) > 1 ? J : (0, v.createElement)(Block, W, J);else {
            var _l41 = (0, y.getSaveContent)(ee, U);

            ne = (0, v.createElement)(Block, {
              className: "has-warning"
            }, (0, v.createElement)(P.default, {
              clientId: E
            }), (0, v.createElement)(v.RawHTML, null, (0, S.safeHTML)(_l41)));
          }
          var oe = {
            clientId: E,
            className: D,
            wrapperProps: (0, k.omit)(W, ["data-align"]),
            isAligned: te
          },
              re = (0, v.useMemo)(function () {
            return oe;
          }, Object.values(oe));
          return (0, v.createElement)(z.Provider, {
            value: re
          }, (0, v.createElement)(L.default, {
            fallback: (0, v.createElement)(Block, {
              className: "has-warning"
            }, (0, v.createElement)(O.default, null))
          }, ne));
        });
        s.default = G;
      },
      9476: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockListItems = function BlockListItems(l) {
          return (0, v.createElement)(k.AsyncModeProvider, {
            value: !1
          }, (0, v.createElement)(Items, l));
        }, s.IntersectionObserver = void 0, s.default = BlockList;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(8467),
            y = c(3200),
            E = m(c(4418)),
            w = m(c(9575)),
            C = c(4430),
            S = c(8486),
            B = c(6572),
            P = c(7189),
            O = m(c(9017)),
            L = c(5920),
            V = c(1337),
            R = c(7310);

        var A = (0, v.createContext)(),
            z = (0, v.createContext)();

        function Root(l) {
          var s = l.className,
              c = _objectWithoutProperties(l, _excluded3);

          var _ref54 = (0, v.useState)(),
              _ref55 = _slicedToArray(_ref54, 2),
              m = _ref55[0],
              E = _ref55[1],
              w = (0, y.useViewportMatch)("medium"),
              _ref56 = (0, k.useSelect)(function (l) {
            var _l42 = l(S.store),
                s = _l42.getSettings,
                c = _l42.isNavigationMode,
                _s21 = s(),
                m = _s21.outlineMode,
                v = _s21.focusMode;

            return {
              isOutlineMode: m,
              isFocusMode: v,
              isNavigationMode: c()
            };
          }, []),
              B = _ref56.isOutlineMode,
              P = _ref56.isFocusMode,
              O = _ref56.isNavigationMode,
              R = (0, V.useInnerBlocksProps)({
            ref: (0, y.useMergeRefs)([(0, L.useBlockSelectionClearer)(), (0, C.useInBetweenInserter)(), E]),
            className: (0, _.default)("is-root-container", s, {
              "is-outline-mode": B,
              "is-focus-mode": P && w,
              "is-navigate-mode": O
            })
          }, c);

          return (0, v.createElement)(A.Provider, {
            value: m
          }, (0, v.createElement)("div", R));
        }

        function BlockList(l) {
          return (0, B.usePreParsePatterns)(), (0, v.createElement)(O.default, null, (0, v.createElement)(R.BlockEditContextProvider, {
            value: R.DEFAULT_BLOCK_EDIT_CONTEXT
          }, (0, v.createElement)(Root, l)));
        }

        function Items(l) {
          var s = l.placeholder,
              c = l.rootClientId,
              m = l.renderAppender,
              _ = l.__experimentalAppenderTagName,
              _l$__experimentalLayo = l.__experimentalLayout,
              y = _l$__experimentalLayo === void 0 ? P.defaultLayout : _l$__experimentalLayo;

          var _ref57 = (0, v.useState)(new Set()),
              _ref58 = _slicedToArray(_ref57, 2),
              C = _ref58[0],
              B = _ref58[1],
              O = (0, v.useMemo)(function () {
            var _window = window,
                l = _window.IntersectionObserver;
            if (l) return new l(function (l) {
              B(function (s) {
                var c = new Set(s);

                var _iterator3 = _createForOfIteratorHelper(l),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var _s22 = _step3.value;

                    var _l43 = _s22.target.getAttribute("data-block");

                    c[_s22.isIntersecting ? "add" : "delete"](_l43);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                return c;
              });
            });
          }, [B]),
              _ref59 = (0, k.useSelect)(function (l) {
            var _l44 = l(S.store),
                s = _l44.getBlockOrder,
                m = _l44.getSelectedBlockClientIds;

            return {
              order: s(c),
              selectedBlocks: m()
            };
          }, [c]),
              L = _ref59.order,
              V = _ref59.selectedBlocks;

          return (0, v.createElement)(P.LayoutProvider, {
            value: y
          }, (0, v.createElement)(z.Provider, {
            value: O
          }, L.map(function (l) {
            return (0, v.createElement)(k.AsyncModeProvider, {
              key: l,
              value: !C.has(l) && !V.includes(l)
            }, (0, v.createElement)(E.default, {
              rootClientId: c,
              clientId: l
            }));
          })), L.length < 1 && s, (0, v.createElement)(w.default, {
            tagName: _,
            rootClientId: c,
            renderAppender: m
          }));
        }

        s.IntersectionObserver = z, BlockList.__unstableElementContext = A;
      },
      7189: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.LayoutProvider = void 0, s.LayoutStyle = function LayoutStyle(l) {
          var _l$layout = l.layout,
              s = _l$layout === void 0 ? {} : _l$layout,
              c = _objectWithoutProperties(l, _excluded4);

          var m = (0, k.getLayoutType)(s.type);
          if (m) return (0, v.createElement)(m.save, (0, _.default)({
            layout: s
          }, c));
          return null;
        }, s.defaultLayout = void 0, s.useLayout = function useLayout() {
          return (0, v.useContext)(E);
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(6633);

        var y = {
          type: "default"
        };
        s.defaultLayout = y;
        var E = (0, v.createContext)(y),
            w = E.Provider;
        s.LayoutProvider = w;
      },
      2885: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useBlockProps = useBlockProps;

        var v = m(c(2703)),
            _ = c(1753),
            k = c(6756),
            y = c(6700),
            E = c(3200),
            w = c(8467),
            C = (m(c(2793)), m(c(9322))),
            S = c(4418),
            B = c(631),
            P = c(8792),
            O = c(7310),
            L = c(7914),
            V = c(618),
            R = c(9451),
            A = c(7642),
            z = c(9816),
            D = c(7301),
            F = c(8290),
            G = c(8439),
            U = c(8882),
            W = c(6584),
            K = c(9317),
            $ = c(8486);

        function useBlockProps() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              _ref60 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              s = _ref60.__unstableIsHtml;

          var _ref61 = (0, _.useContext)(S.BlockListBlockContext),
              c = _ref61.clientId,
              m = _ref61.className,
              _ref61$wrapperProps = _ref61.wrapperProps,
              q = _ref61$wrapperProps === void 0 ? {} : _ref61$wrapperProps,
              Y = _ref61.isAligned,
              _ref62 = (0, w.useSelect)(function (l) {
            var _l45 = l($.store),
                s = _l45.getBlockIndex,
                m = _l45.getBlockMode,
                v = _l45.getBlockName,
                _ = _l45.isTyping,
                k = _l45.getGlobalBlockCount,
                E = _l45.isBlockSelected,
                w = _l45.isBlockMultiSelected,
                C = _l45.isAncestorMultiSelected,
                S = _l45.isFirstMultiSelectedBlock,
                B = E(c),
                P = w(c) || C(c),
                O = v(c),
                L = (0, y.getBlockType)(O);

            return {
              index: s(c),
              mode: m(c),
              name: O,
              blockApiVersion: (null == L ? void 0 : L.apiVersion) || 1,
              blockTitle: null == L ? void 0 : L.title,
              isPartOfSelection: B || P,
              adjustScrolling: B || S(c),
              enableAnimation: !_() && k() <= 200
            };
          }, [c]),
              Z = _ref62.index,
              X = _ref62.mode,
              Q = _ref62.name,
              J = _ref62.blockApiVersion,
              ee = _ref62.blockTitle,
              te = _ref62.isPartOfSelection,
              ne = _ref62.adjustScrolling,
              oe = _ref62.enableAnimation,
              re = (0, k.sprintf)((0, k.__)("Block: %s"), ee),
              le = "html" !== X || s ? "" : "-visual",
              ie = (0, E.useMergeRefs)([l.ref, (0, B.useFocusFirstElement)(c), (0, G.useScrollIntoView)(c), (0, U.useBlockRefProvider)(c), (0, z.useFocusHandler)(c), (0, W.useMultiSelection)(c), (0, D.useEventHandlers)(c), (0, F.useNavModeExit)(c), (0, P.useIsHovered)(), (0, K.useIntersectionObserver)(), (0, C.default)({
            isSelected: te,
            adjustScrolling: ne,
            enableAnimation: oe,
            triggerAnimationOnChange: Z
          })]),
              ae = (0, O.useBlockEditContext)();

          return J < 2 && c === ae.clientId && "undefined" != typeof process && process.env, _objectSpread(_objectSpread(_objectSpread({}, q), l), {}, {
            ref: ie,
            id: "block-".concat(c).concat(le),
            tabIndex: 0,
            role: "document",
            "aria-label": re,
            "data-block": c,
            "data-type": Q,
            "data-title": ee,
            className: (0, v.default)((0, v.default)("block-editor-block-list__block", {
              "wp-block": !Y
            }), m, l.className, q.className, (0, L.useBlockClassNames)(c), (0, V.useBlockDefaultClassName)(c), (0, R.useBlockCustomClassName)(c), (0, A.useBlockMovingModeClassNames)(c)),
            style: _objectSpread(_objectSpread({}, q.style), l.style)
          });
        }

        useBlockProps.save = y.__unstableGetBlockProps;
      },
      7914: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useBlockClassNames = function useBlockClassNames(l) {
          return (0, _.useSelect)(function (s) {
            var _s23 = s(y.store),
                c = _s23.isBlockBeingDragged,
                m = _s23.isBlockHighlighted,
                _ = _s23.isBlockSelected,
                E = _s23.isBlockMultiSelected,
                w = _s23.getBlockName,
                C = _s23.getSettings,
                S = _s23.hasSelectedInnerBlock,
                B = _s23.isTyping,
                P = _s23.__experimentalGetActiveBlockIdByBlockNames,
                _C2 = C(),
                O = _C2.__experimentalSpotlightEntityBlocks,
                L = _C2.outlineMode,
                V = c(l),
                R = _(l),
                A = w(l),
                z = S(l, !0),
                D = P(O);

            return (0, v.default)({
              "is-selected": R,
              "is-highlighted": m(l),
              "is-multi-selected": E(l),
              "is-reusable": (0, k.isReusableBlock)((0, k.getBlockType)(A)),
              "is-dragging": V,
              "has-child-selected": z,
              "has-active-entity": D,
              "is-active-entity": D === l,
              "remove-outline": R && L && B()
            });
          }, [l]);
        };

        var v = m(c(2703)),
            _ = c(8467),
            k = c(6700),
            y = c(8486);
      },
      9451: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useBlockCustomClassName = function useBlockCustomClassName(l) {
          return (0, m.useSelect)(function (s) {
            var _s24 = s(_.store),
                c = _s24.getBlockName,
                m = _s24.getBlockAttributes,
                k = m(l);

            if (null == k || !k.className) return;
            var y = (0, v.getBlockType)(c(l));
            return (null == y ? void 0 : y.apiVersion) > 1 ? k.className : void 0;
          }, [l]);
        };

        var m = c(8467),
            v = c(6700),
            _ = c(8486);
      },
      618: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useBlockDefaultClassName = function useBlockDefaultClassName(l) {
          return (0, m.useSelect)(function (s) {
            var c = s(_.store).getBlockName(l),
                m = (0, v.getBlockType)(c);
            if ((null == m ? void 0 : m.apiVersion) > 1) return (0, v.getBlockDefaultClassName)(c);
          }, [l]);
        };

        var m = c(8467),
            v = c(6700),
            _ = c(8486);
      },
      7642: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useBlockMovingModeClassNames = function useBlockMovingModeClassNames(l) {
          return (0, _.useSelect)(function (s) {
            var _s25 = s(k.store),
                c = _s25.hasBlockMovingClientId,
                m = _s25.canInsertBlockType,
                _ = _s25.getBlockName,
                y = _s25.getBlockRootClientId,
                E = _s25.isBlockSelected;

            if (!E(l)) return;
            var w = c();
            return w ? (0, v.default)("is-block-moving-mode", {
              "can-insert-moving-block": m(_(w), y(l))
            }) : void 0;
          }, [l]);
        };

        var v = m(c(2703)),
            _ = c(8467),
            k = c(8486);
      },
      8882: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.__unstableUseBlockElement = function useBlockElement(l) {
          var _ref63 = (0, m.useContext)(_.BlockRefs),
              s = _ref63.callbacks,
              c = useBlockRef(l),
              _ref64 = (0, m.useState)(null),
              _ref65 = _slicedToArray(_ref64, 2),
              v = _ref65[0],
              k = _ref65[1];

          return (0, m.useLayoutEffect)(function () {
            if (l) return s.set(k, l), function () {
              s.delete(k);
            };
          }, [l]), c.current || v;
        }, s.__unstableUseBlockRef = useBlockRef, s.useBlockRefProvider = function useBlockRefProvider(l) {
          var _ref66 = (0, m.useContext)(_.BlockRefs),
              s = _ref66.refs,
              c = _ref66.callbacks,
              k = (0, m.useRef)();

          return (0, m.useLayoutEffect)(function () {
            return s.set(k, l), function () {
              s.delete(k);
            };
          }, [l]), (0, v.useRefEffect)(function (s) {
            k.current = s, c.forEach(function (c, m) {
              l === c && m(s);
            });
          }, [l]);
        };

        var m = c(1753),
            v = c(3200),
            _ = c(2169);

        function useBlockRef(l) {
          var _ref67 = (0, m.useContext)(_.BlockRefs),
              s = _ref67.refs,
              c = (0, m.useRef)();

          return c.current = l, (0, m.useMemo)(function () {
            return {
              get current() {
                var l = null;

                var _iterator4 = _createForOfIteratorHelper(s.entries()),
                    _step4;

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var _step4$value = _slicedToArray(_step4.value, 2),
                        _m16 = _step4$value[0],
                        _v9 = _step4$value[1];

                    _v9 === c.current && _m16.current && (l = _m16.current);
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                return l;
              }

            };
          }, []);
        }
      },
      631: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useFocusFirstElement = function useFocusFirstElement(l) {
          var s = (0, v.useRef)(),
              c = function useInitialPosition(l) {
            return (0, k.useSelect)(function (s) {
              var _s26 = s(E.store),
                  c = _s26.getSelectedBlocksInitialCaretPosition,
                  m = _s26.isMultiSelecting,
                  v = _s26.isNavigationMode,
                  _ = _s26.isBlockSelected;

              if (_(l) && !m() && !v()) return c();
            }, [l]);
          }(l);

          return (0, v.useEffect)(function () {
            if (null == c) return;
            if (!s.current) return;
            var l = s.current.ownerDocument;
            if (s.current.contains(l.activeElement)) return;

            var v = _.focus.tabbable.find(s.current).filter(function (l) {
              return (0, _.isTextField)(l);
            }),
                k = -1 === c,
                E = (k ? m.last : m.first)(v) || s.current;

            (0, y.isInsideRootBlock)(s.current, E) ? (0, _.placeCaretAtHorizontalEdge)(E, k) : s.current.focus();
          }, [c]), s;
        };

        var m = c(4793),
            v = c(1753),
            _ = c(5480),
            k = c(8467),
            y = c(9040),
            E = c(8486);
      },
      9816: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useFocusHandler = function useFocusHandler(l) {
          var _ref68 = (0, m.useSelect)(k.store),
              s = _ref68.isBlockSelected,
              _ref69 = (0, m.useDispatch)(k.store),
              c = _ref69.selectBlock,
              y = _ref69.selectionChange;

          return (0, v.useRefEffect)(function (m) {
            function onFocus(v) {
              s(l) ? v.target.isContentEditable || y(l) : (0, _.isInsideRootBlock)(m, v.target) && c(l);
            }

            return m.addEventListener("focusin", onFocus), function () {
              m.removeEventListener("focusin", onFocus);
            };
          }, [s, c]);
        };

        var m = c(8467),
            v = c(3200),
            _ = c(9040),
            k = c(8486);
      },
      9317: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useIntersectionObserver = function useIntersectionObserver() {
          var l = (0, v.useContext)(_.IntersectionObserver);
          return (0, m.useRefEffect)(function (s) {
            if (l) return l.observe(s), function () {
              l.unobserve(s);
            };
          }, [l]);
        };

        var m = c(3200),
            v = c(1753),
            _ = c(9476);
      },
      8792: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useIsHovered = function useIsHovered() {
          var l = (0, m.useSelect)(function (l) {
            var _l46 = l(_.store),
                s = _l46.isNavigationMode,
                c = _l46.getSettings;

            return s() || c().outlineMode;
          }, []);
          return (0, v.useRefEffect)(function (s) {
            if (l) return s.addEventListener("mouseout", listener), s.addEventListener("mouseover", listener), function () {
              s.removeEventListener("mouseout", listener), s.removeEventListener("mouseover", listener), s.classList.remove("is-hovered");
            };
          }, [l]);
        };

        var m = c(8467),
            v = c(3200),
            _ = c(8486);

        function listener(l) {
          if (l.defaultPrevented) return;
          var s = "mouseover" === l.type ? "add" : "remove";
          l.preventDefault(), l.currentTarget.classList[s]("is-hovered");
        }
      },
      6584: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useMultiSelection = function useMultiSelection(l) {
          var _ref70 = (0, m.useDispatch)(_.store),
              s = _ref70.startMultiSelect,
              c = _ref70.stopMultiSelect,
              y = _ref70.multiSelect,
              E = _ref70.selectBlock,
              _ref71 = (0, m.useSelect)(_.store),
              w = _ref71.isSelectionEnabled,
              C = _ref71.isBlockSelected,
              S = _ref71.getBlockParents,
              B = _ref71.getBlockSelectionStart,
              P = _ref71.hasMultiSelection;

          return (0, v.useRefEffect)(function (m) {
            var v = m.ownerDocument,
                _ = v.defaultView;
            var O, L;

            function onSelectionChange(s) {
              var c = s.isSelectionEnd;

              var v = _.getSelection();

              if (!v.rangeCount || v.isCollapsed) return void toggleRichText(m, !0);
              var w = (0, k.getBlockClientId)(v.focusNode);

              if (l === w) {
                if (E(l), c && (toggleRichText(m, !0), v.rangeCount)) {
                  var _v$getRangeAt = v.getRangeAt(0),
                      _l47 = _v$getRangeAt.commonAncestorContainer;

                  O.contains(_l47) && O.focus();
                }
              } else {
                var _s27 = [].concat(_toConsumableArray(S(l)), [l]),
                    _c21 = [].concat(_toConsumableArray(S(w)), [w]),
                    _m17 = Math.min(_s27.length, _c21.length) - 1;

                y(_s27[_m17], _c21[_m17]);
              }
            }

            function onSelectionEnd() {
              v.removeEventListener("selectionchange", onSelectionChange), _.removeEventListener("mouseup", onSelectionEnd), L = _.requestAnimationFrame(function () {
                onSelectionChange({
                  isSelectionEnd: !0
                }), c();
              });
            }

            function onMouseLeave(c) {
              var k = c.buttons;
              1 === k && w() && C(l) && (O = v.activeElement, s(), v.addEventListener("selectionchange", onSelectionChange), _.addEventListener("mouseup", onSelectionEnd), toggleRichText(m, !1));
            }

            function onMouseDown(s) {
              if (w() && 0 === s.button) if (s.shiftKey) {
                var _c22 = B(),
                    _v10 = S(_c22);

                if (_c22 && _c22 !== l && (null == _v10 || !_v10.includes(l))) {
                  var _5 = [].concat(_toConsumableArray(_v10), [_c22]),
                      _k4 = [].concat(_toConsumableArray(S(l)), [l]),
                      _E3 = Math.min(_5.length, _k4.length) - 1,
                      _w = _5[_E3],
                      _C3 = _k4[_E3];

                  _w !== _C3 && (toggleRichText(m, !1), y(_w, _C3), s.preventDefault());
                }
              } else P() && E(l);
            }

            return m.addEventListener("mousedown", onMouseDown), m.addEventListener("mouseleave", onMouseLeave), function () {
              m.removeEventListener("mousedown", onMouseDown), m.removeEventListener("mouseleave", onMouseLeave), v.removeEventListener("selectionchange", onSelectionChange), _.removeEventListener("mouseup", onSelectionEnd), _.cancelAnimationFrame(L);
            };
          }, [l, s, c, y, E, w, C, S]);
        };

        var m = c(8467),
            v = c(3200),
            _ = c(8486),
            k = c(9040);

        function toggleRichText(l, s) {
          Array.from(l.closest(".is-root-container").querySelectorAll(".rich-text")).forEach(function (l) {
            s ? l.setAttribute("contenteditable", !0) : l.removeAttribute("contenteditable");
          });
        }
      },
      8290: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useNavModeExit = function useNavModeExit(l) {
          var _ref72 = (0, m.useSelect)(_.store),
              s = _ref72.isNavigationMode,
              c = _ref72.isBlockSelected,
              _ref73 = (0, m.useDispatch)(_.store),
              k = _ref73.setNavigationMode,
              y = _ref73.selectBlock;

          return (0, v.useRefEffect)(function (m) {
            function onMouseDown(m) {
              s() && !m.defaultPrevented && (m.preventDefault(), c(l) ? k(!1) : y(l));
            }

            return m.addEventListener("mousedown", onMouseDown), function () {
              m.addEventListener("mousedown", onMouseDown);
            };
          }, [l, s, c, k]);
        };

        var m = c(8467),
            v = c(3200),
            _ = c(8486);
      },
      8439: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useScrollIntoView = function useScrollIntoView(l) {
          var s = (0, _.useRef)(),
              c = (0, k.useSelect)(function (s) {
            var _s28 = s(E.store),
                c = _s28.isBlockSelected,
                m = _s28.getBlockSelectionEnd;

            return c(l) || m() === l;
          }, [l]);
          return (0, _.useEffect)(function () {
            if (!c) return;
            var l = s.current;
            if (!l) return;
            if (l.contains(l.ownerDocument.activeElement)) return;
            var m = (0, y.getScrollContainer)(l) || l.ownerDocument.defaultView;
            m && (0, v.default)(l, m, {
              onlyScrollIfNeeded: !0
            });
          }, [c]), s;
        };

        var v = m(c(3745)),
            _ = c(1753),
            k = c(8467),
            y = c(5480),
            E = c(8486);
      },
      7301: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useEventHandlers = function useEventHandlers(l) {
          var s = (0, _.useSelect)(function (s) {
            return s(y.store).isBlockSelected(l);
          }, [l]),
              _ref74 = (0, _.useSelect)(y.store),
              c = _ref74.getBlockRootClientId,
              E = _ref74.getBlockIndex,
              _ref75 = (0, _.useDispatch)(y.store),
              w = _ref75.insertDefaultBlock,
              C = _ref75.removeBlock;

          return (0, k.useRefEffect)(function (_) {
            if (s) return _.addEventListener("keydown", onKeyDown), _.addEventListener("dragstart", onDragStart), function () {
              _.removeEventListener("keydown", onKeyDown), _.removeEventListener("dragstart", onDragStart);
            };

            function onKeyDown(s) {
              var k = s.keyCode,
                  y = s.target;
              k !== v.ENTER && k !== v.BACKSPACE && k !== v.DELETE || y !== _ || (0, m.isTextField)(y) || (s.preventDefault(), k === v.ENTER ? w({}, c(l), E(l) + 1) : C(l));
            }

            function onDragStart(l) {
              l.preventDefault();
            }
          }, [l, s, c, E, w, C]);
        };

        var m = c(5480),
            v = c(9880),
            _ = c(8467),
            k = c(3200),
            y = c(8486);
      },
      4430: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useInBetweenInserter = function useInBetweenInserter() {
          var l = (0, _.useContext)(y.InsertionPointOpenRef),
              s = (0, v.useSelect)(function (l) {
            return l(k.store).getSettings().hasReducedUI;
          }, []),
              _ref76 = (0, v.useSelect)(k.store),
              c = _ref76.getBlockListSettings,
              E = _ref76.getBlockRootClientId,
              w = _ref76.getBlockIndex,
              C = _ref76.isBlockInsertionPointVisible,
              S = _ref76.isMultiSelecting,
              B = _ref76.getSelectedBlockClientIds,
              P = _ref76.getTemplateLock,
              _ref77 = (0, v.useDispatch)(k.store),
              O = _ref77.showInsertionPoint,
              L = _ref77.hideInsertionPoint;

          return (0, m.useRefEffect)(function (m) {
            if (!s) return m.addEventListener("mousemove", onMouseMove), function () {
              m.removeEventListener("mousemove", onMouseMove);
            };

            function onMouseMove(s) {
              var m, v;
              if (l.current) return;
              if (S()) return;
              if (!s.target.classList.contains("block-editor-block-list__layout")) return void (C() && L());

              var _;

              if (!s.target.classList.contains("is-root-container")) {
                _ = (s.target.getAttribute("data-block") ? s.target : s.target.closest("[data-block]")).getAttribute("data-block");
              }

              if (P(_)) return;
              var k = (null === (m = c(_)) || void 0 === m ? void 0 : m.orientation) || "vertical",
                  y = s.target.getBoundingClientRect(),
                  E = s.clientY - y.top,
                  V = s.clientX - y.left;
              var R = Array.from(s.target.children).find(function (l) {
                return l.classList.contains("wp-block") && "vertical" === k && l.offsetTop > E || l.classList.contains("wp-block") && "horizontal" === k && l.offsetLeft > V;
              });
              if (!R) return;
              if (!R.id && (R = R.firstElementChild, !R)) return;
              if (null === (v = R.parentElement) || void 0 === v ? void 0 : v.closest(".block-editor-block-content-overlay.overlay-active")) return;
              var A = R.id.slice("block-".length);
              if (!A) return;
              if (B().includes(A)) return;
              var z = R.getBoundingClientRect();
              if ("horizontal" === k && (s.clientY > z.bottom || s.clientY < z.top) || "vertical" === k && (s.clientX > z.right || s.clientX < z.left)) return void (C() && L());
              var D = w(A);
              0 !== D ? O(_, D, {
                __unstableWithInserter: !0
              }) : C() && L();
            }
          }, [l, c, E, w, C, S, O, L, B]);
        };

        var m = c(3200),
            v = c(8467),
            _ = c(1753),
            k = c(8486),
            y = c(2638);
      },
      8855: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockMoverUpButton = s.BlockMoverDownButton = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(4793),
            E = c(6700),
            w = c(4892),
            C = c(3200),
            S = c(8467),
            B = c(6756),
            P = c(2614),
            O = c(9799),
            L = c(8486);

        var getArrowIcon = function getArrowIcon(l, s) {
          return "up" === l ? "horizontal" === s ? (0, B.isRTL)() ? P.chevronRight : P.chevronLeft : P.chevronUp : "down" === l ? "horizontal" === s ? (0, B.isRTL)() ? P.chevronLeft : P.chevronRight : P.chevronDown : null;
        },
            getMovementDirectionLabel = function getMovementDirectionLabel(l, s) {
          return "up" === l ? "horizontal" === s ? (0, B.isRTL)() ? (0, B.__)("Move right") : (0, B.__)("Move left") : (0, B.__)("Move up") : "down" === l ? "horizontal" === s ? (0, B.isRTL)() ? (0, B.__)("Move left") : (0, B.__)("Move right") : (0, B.__)("Move down") : null;
        },
            V = (0, v.forwardRef)(function (l, s) {
          var c = l.clientIds,
              m = l.direction,
              B = l.orientation,
              P = _objectWithoutProperties(l, _excluded5);

          var R = (0, C.useInstanceId)(V),
              A = (0, y.castArray)(c).length,
              _ref78 = (0, S.useSelect)(function (l) {
            var _l48 = l(L.store),
                s = _l48.getBlockIndex,
                v = _l48.getBlockRootClientId,
                _ = _l48.getBlockOrder,
                k = _l48.getBlock,
                w = _l48.getBlockListSettings,
                C = (0, y.castArray)(c),
                S = (0, y.first)(C),
                P = v(S),
                O = s(S),
                V = s((0, y.last)(C)),
                R = _(P),
                A = k(S),
                z = 0 === O,
                D = V === R.length - 1,
                _ref80 = w(P) || {},
                F = _ref80.orientation;

            return {
              blockType: A ? (0, E.getBlockType)(A.name) : null,
              isDisabled: "up" === m ? z : D,
              rootClientId: P,
              firstIndex: O,
              isFirst: z,
              isLast: D,
              orientation: B || F
            };
          }, [c, m]),
              z = _ref78.blockType,
              D = _ref78.isDisabled,
              F = _ref78.rootClientId,
              G = _ref78.isFirst,
              U = _ref78.isLast,
              W = _ref78.firstIndex,
              _ref78$orientation = _ref78.orientation,
              K = _ref78$orientation === void 0 ? "vertical" : _ref78$orientation,
              _ref79 = (0, S.useDispatch)(L.store),
              $ = _ref79.moveBlocksDown,
              q = _ref79.moveBlocksUp,
              Y = "up" === m ? q : $,
              Z = "block-editor-block-mover-button__description-".concat(R);

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.Button, (0, _.default)({
            ref: s,
            className: (0, k.default)("block-editor-block-mover-button", "is-".concat(m, "-button")),
            icon: getArrowIcon(m, K),
            label: getMovementDirectionLabel(m, K),
            "aria-describedby": Z
          }, P, {
            onClick: D ? null : function (l) {
              Y(c, F), P.onClick && P.onClick(l);
            },
            "aria-disabled": D
          })), (0, v.createElement)("span", {
            id: Z,
            className: "block-editor-block-mover-button__description"
          }, (0, O.getBlockMoverDescription)(A, z && z.title, W, G, U, "up" === m ? -1 : 1, K)));
        }),
            R = (0, v.forwardRef)(function (l, s) {
          return (0, v.createElement)(V, (0, _.default)({
            direction: "up",
            ref: s
          }, l));
        });

        s.BlockMoverUpButton = R;
        var A = (0, v.forwardRef)(function (l, s) {
          return (0, v.createElement)(V, (0, _.default)({
            direction: "down",
            ref: s
          }, l));
        });
        s.BlockMoverDownButton = A;
      },
      7547: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = m(c(2703)),
            E = c(2614),
            w = c(4892),
            C = c(6700),
            S = c(8467),
            B = c(6756),
            P = m(c(566)),
            O = c(8855),
            L = c(8486);

        var V = (0, S.withSelect)(function (l, s) {
          var c;
          var m = s.clientIds;

          var _l49 = l(L.store),
              v = _l49.getBlock,
              _ = _l49.getBlockIndex,
              y = _l49.getBlockListSettings,
              E = _l49.canMoveBlocks,
              w = _l49.getBlockOrder,
              S = _l49.getBlockRootClientId,
              B = (0, k.castArray)(m),
              P = (0, k.first)(B),
              O = v(P),
              V = S((0, k.first)(B)),
              R = _(P),
              A = 0 === R,
              z = _((0, k.last)(B)) === w(V).length - 1;

          return {
            blockType: O ? (0, C.getBlockType)(O.name) : null,
            canMove: E(m, V),
            rootClientId: V,
            firstIndex: R,
            isFirst: A,
            isLast: z,
            orientation: null === (c = y(V)) || void 0 === c ? void 0 : c.orientation
          };
        })(function BlockMover(l) {
          var s = l.isFirst,
              c = l.isLast,
              m = l.clientIds,
              k = l.canMove,
              C = l.isHidden,
              S = l.rootClientId,
              L = l.orientation,
              V = l.hideDragHandle;

          var _ref81 = (0, v.useState)(!1),
              _ref82 = _slicedToArray(_ref81, 2),
              R = _ref82[0],
              A = _ref82[1],
              onFocus = function onFocus() {
            return A(!0);
          },
              onBlur = function onBlur() {
            return A(!1);
          };

          if (!k || s && c && !S) return null;
          var z = (0, B.__)("Drag");
          return (0, v.createElement)("div", {
            className: (0, y.default)("block-editor-block-mover", {
              "is-visible": R || !C,
              "is-horizontal": "horizontal" === L
            })
          }, !V && (0, v.createElement)(P.default, {
            clientIds: m,
            cloneClassname: "block-editor-block-mover__drag-clone"
          }, function (l) {
            return (0, v.createElement)(w.Button, (0, _.default)({
              icon: E.dragHandle,
              className: "block-editor-block-mover__drag-handle",
              "aria-hidden": "true",
              label: z,
              tabIndex: "-1"
            }, l));
          }), (0, v.createElement)(w.ToolbarGroup, {
            className: "block-editor-block-mover__move-button-container"
          }, (0, v.createElement)(w.ToolbarItem, {
            onFocus: onFocus,
            onBlur: onBlur
          }, function (l) {
            return (0, v.createElement)(O.BlockMoverUpButton, (0, _.default)({
              clientIds: m
            }, l));
          }), (0, v.createElement)(w.ToolbarItem, {
            onFocus: onFocus,
            onBlur: onBlur
          }, function (l) {
            return (0, v.createElement)(O.BlockMoverDownButton, (0, _.default)({
              clientIds: m
            }, l));
          })));
        });
        s.default = V;
      },
      9799: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getBlockMoverDescription = function getBlockMoverDescription(l, s, c, v, _, k, y) {
          var E = c + 1,
              getMovementDirection = function getMovementDirection(l) {
            return "up" === l ? "horizontal" === y ? (0, m.isRTL)() ? "right" : "left" : "up" : "down" === l ? "horizontal" === y ? (0, m.isRTL)() ? "left" : "right" : "down" : null;
          };

          if (l > 1) return getMultiBlockMoverDescription(l, c, v, _, k);
          if (v && _) return (0, m.sprintf)((0, m.__)("Block %s is the only block, and cannot be moved"), s);

          if (k > 0 && !_) {
            var _l50 = getMovementDirection("down");

            if ("down" === _l50) return (0, m.sprintf)((0, m.__)("Move %1$s block from position %2$d down to position %3$d"), s, E, E + 1);
            if ("left" === _l50) return (0, m.sprintf)((0, m.__)("Move %1$s block from position %2$d left to position %3$d"), s, E, E + 1);
            if ("right" === _l50) return (0, m.sprintf)((0, m.__)("Move %1$s block from position %2$d right to position %3$d"), s, E, E + 1);
          }

          if (k > 0 && _) {
            var _l51 = getMovementDirection("down");

            if ("down" === _l51) return (0, m.sprintf)((0, m.__)("Block %1$s is at the end of the content and can’t be moved down"), s);
            if ("left" === _l51) return (0, m.sprintf)((0, m.__)("Block %1$s is at the end of the content and can’t be moved left"), s);
            if ("right" === _l51) return (0, m.sprintf)((0, m.__)("Block %1$s is at the end of the content and can’t be moved right"), s);
          }

          if (k < 0 && !v) {
            var _l52 = getMovementDirection("up");

            if ("up" === _l52) return (0, m.sprintf)((0, m.__)("Move %1$s block from position %2$d up to position %3$d"), s, E, E - 1);
            if ("left" === _l52) return (0, m.sprintf)((0, m.__)("Move %1$s block from position %2$d left to position %3$d"), s, E, E - 1);
            if ("right" === _l52) return (0, m.sprintf)((0, m.__)("Move %1$s block from position %2$d right to position %3$d"), s, E, E - 1);
          }

          if (k < 0 && v) {
            var _l53 = getMovementDirection("up");

            if ("up" === _l53) return (0, m.sprintf)((0, m.__)("Block %1$s is at the beginning of the content and can’t be moved up"), s);
            if ("left" === _l53) return (0, m.sprintf)((0, m.__)("Block %1$s is at the beginning of the content and can’t be moved left"), s);
            if ("right" === _l53) return (0, m.sprintf)((0, m.__)("Block %1$s is at the beginning of the content and can’t be moved right"), s);
          }
        }, s.getMultiBlockMoverDescription = getMultiBlockMoverDescription;
        var m = c(6756);

        function getMultiBlockMoverDescription(l, s, c, v, _) {
          var k = s + 1;
          return _ < 0 && c ? (0, m.__)("Blocks cannot be moved up as they are already at the top") : _ > 0 && v ? (0, m.__)("Blocks cannot be moved down as they are already at the bottom") : _ < 0 && !c ? (0, m.sprintf)((0, m._n)("Move %1$d block from position %2$d up by one place", "Move %1$d blocks from position %2$d up by one place", l), l, k) : _ > 0 && !v ? (0, m.sprintf)((0, m._n)("Move %1$d block from position %2$d down by one place", "Move %1$d blocks from position %2$d down by one place", l), l, k) : void 0;
        }
      },
      9851: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = c(6756),
            E = c(8467),
            w = c(2614),
            C = m(c(609)),
            S = c(8486);

        function BlockNavigationDropdownToggle(l) {
          var s = l.isEnabled,
              c = l.onToggle,
              m = l.isOpen,
              E = l.innerRef,
              C = _objectWithoutProperties(l, _excluded6);

          return (0, v.createElement)(k.Button, (0, _.default)({}, C, {
            ref: E,
            icon: w.listView,
            "aria-expanded": m,
            "aria-haspopup": "true",
            onClick: s ? c : void 0,
            label: (0, y.__)("List view"),
            className: "block-editor-block-navigation",
            "aria-disabled": !s
          }));
        }

        var B = (0, v.forwardRef)(function BlockNavigationDropdown(l, s) {
          var c = l.isDisabled,
              m = l.__experimentalFeatures,
              w = _objectWithoutProperties(l, _excluded7);

          var B = (0, E.useSelect)(function (l) {
            return !!l(S.store).getBlockCount();
          }, []) && !c;
          return (0, v.createElement)(k.Dropdown, {
            contentClassName: "block-editor-block-navigation__popover",
            position: "bottom right",
            renderToggle: function renderToggle(l) {
              var c = l.isOpen,
                  m = l.onToggle;
              return (0, v.createElement)(BlockNavigationDropdownToggle, (0, _.default)({}, w, {
                innerRef: s,
                isOpen: c,
                onToggle: m,
                isEnabled: B
              }));
            },
            renderContent: function renderContent() {
              return (0, v.createElement)("div", {
                className: "block-editor-block-navigation__container"
              }, (0, v.createElement)("p", {
                className: "block-editor-block-navigation__label"
              }, (0, y.__)("List view")), (0, v.createElement)(C.default, {
                showNestedBlocks: !0,
                __experimentalFeatures: m
              }));
            }
          });
        });
        s.default = B;
      },
      2111: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockParentSelector() {
          var _ref83 = (0, E.useDispatch)(P.store),
              l = _ref83.selectBlock,
              s = _ref83.toggleBlockHighlight,
              _ref84 = (0, E.useSelect)(function (l) {
            var _l54 = l(P.store),
                s = _l54.getBlockName,
                c = _l54.getBlockParents,
                m = _l54.getSelectedBlockClientId,
                v = _l54.getSettings,
                _l55 = l(k.store),
                _ = _l55.hasBlockSupport,
                y = c(m()),
                E = y[y.length - 1],
                w = s(E),
                C = (0, k.getBlockType)(w),
                S = v();

            return {
              firstParentClientId: E,
              shouldHide: !_(C, "__experimentalParentSelector", !0),
              hasReducedUI: S.hasReducedUI
            };
          }, []),
              c = _ref84.firstParentClientId,
              m = _ref84.shouldHide,
              O = _ref84.hasReducedUI,
              L = (0, C.default)(c),
              V = (0, v.useRef)(),
              _ref85 = (0, B.useShowMoversGestures)({
            ref: V,
            onChange: function onChange(l) {
              l && O || s(c, l);
            }
          }),
              R = _ref85.gestures;

          if (m || void 0 === c) return null;
          return (0, v.createElement)("div", (0, _.default)({
            className: "block-editor-block-parent-selector",
            key: c,
            ref: V
          }, R), (0, v.createElement)(y.ToolbarButton, {
            className: "block-editor-block-parent-selector__button",
            onClick: function onClick() {
              return l(c);
            },
            label: (0, w.sprintf)((0, w.__)("Select %s"), L.title),
            showTooltip: !0,
            icon: (0, v.createElement)(S.default, {
              icon: L.icon
            })
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(6700),
            y = c(4892),
            E = c(8467),
            w = c(6756),
            C = m(c(139)),
            S = m(c(2006)),
            B = c(9306),
            P = c(8486);
      },
      6540: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.VIEWMODES = void 0;
        s.VIEWMODES = {
          carousel: "carousel",
          grid: "grid"
        };
      },
      2634: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(8467),
            y = c(6700),
            E = c(4892),
            w = c(3200),
            C = c(6756),
            S = c(8486),
            B = m(c(8958)),
            P = m(c(8847)),
            O = m(c(454)),
            L = c(6540);

        var SetupContent = function SetupContent(l) {
          var s = l.viewMode,
              c = l.activeSlide,
              m = l.patterns,
              k = l.onBlockPatternSelect;
          var y = (0, E.__unstableUseCompositeState)(),
              w = "block-editor-block-pattern-setup__container";

          if (s === L.VIEWMODES.carousel) {
            var _l56 = new Map([[c, "active-slide"], [c - 1, "previous-slide"], [c + 1, "next-slide"]]);

            return (0, v.createElement)("div", {
              className: w
            }, (0, v.createElement)("ul", {
              className: "carousel-container"
            }, m.map(function (s, c) {
              return (0, v.createElement)(BlockPatternSlide, {
                className: _l56.get(c) || "",
                key: s.name,
                pattern: s
              });
            })));
          }

          return (0, v.createElement)(E.__unstableComposite, (0, _.default)({}, y, {
            role: "listbox",
            className: w,
            "aria-label": (0, C.__)("Patterns list")
          }), m.map(function (l) {
            return (0, v.createElement)(BlockPattern, {
              key: l.name,
              pattern: l,
              onSelect: k,
              composite: y
            });
          }));
        };

        function BlockPattern(l) {
          var s = l.pattern,
              c = l.onSelect,
              m = l.composite;
          var k = "block-editor-block-pattern-setup-list",
              y = s.blocks,
              C = s.title,
              S = s.description,
              _s$viewportWidth = s.viewportWidth,
              P = _s$viewportWidth === void 0 ? 700 : _s$viewportWidth,
              O = (0, w.useInstanceId)(BlockPattern, "".concat(k, "__item-description"));
          return (0, v.createElement)("div", {
            className: "".concat(k, "__list-item"),
            "aria-label": s.title,
            "aria-describedby": s.description ? O : void 0
          }, (0, v.createElement)(E.__unstableCompositeItem, (0, _.default)({
            role: "option",
            as: "div"
          }, m, {
            className: "".concat(k, "__item"),
            onClick: function onClick() {
              return c(y);
            }
          }), (0, v.createElement)(B.default, {
            blocks: y,
            viewportWidth: P
          }), (0, v.createElement)("div", {
            className: "".concat(k, "__item-title")
          }, C)), !!S && (0, v.createElement)(E.VisuallyHidden, {
            id: O
          }, S));
        }

        function BlockPatternSlide(l) {
          var s = l.className,
              c = l.pattern;
          var m = c.blocks,
              _ = c.title,
              k = c.description,
              y = (0, w.useInstanceId)(BlockPatternSlide, "block-editor-block-pattern-setup-list__item-description");
          return (0, v.createElement)("li", {
            className: "pattern-slide ".concat(s),
            "aria-label": _,
            "aria-describedby": k ? y : void 0
          }, (0, v.createElement)(B.default, {
            blocks: m,
            __experimentalLive: !0
          }), !!k && (0, v.createElement)(E.VisuallyHidden, {
            id: y
          }, k));
        }

        var _default = function _default(l) {
          var s = l.clientId,
              c = l.blockName,
              m = l.filterPatternsFn,
              _ = l.startBlankComponent,
              E = l.onBlockPatternSelect;

          var _ref86 = (0, v.useState)(L.VIEWMODES.carousel),
              _ref87 = _slicedToArray(_ref86, 2),
              w = _ref87[0],
              C = _ref87[1],
              _ref88 = (0, v.useState)(0),
              _ref89 = _slicedToArray(_ref88, 2),
              B = _ref89[0],
              V = _ref89[1],
              _ref90 = (0, v.useState)(!1),
              _ref91 = _slicedToArray(_ref90, 2),
              R = _ref91[0],
              A = _ref91[1],
              _ref92 = (0, k.useDispatch)(S.store),
              z = _ref92.replaceBlock,
              D = (0, O.default)(s, c, m);

          if (null == D || !D.length || R) return _;

          var F = E || function (l) {
            var c = l.map(function (l) {
              return (0, y.cloneBlock)(l);
            });
            z(s, c);
          };

          return (0, v.createElement)("div", {
            className: "block-editor-block-pattern-setup view-mode-".concat(w)
          }, (0, v.createElement)(P.default, {
            viewMode: w,
            setViewMode: C,
            activeSlide: B,
            totalSlides: D.length,
            handleNext: function handleNext() {
              V(function (l) {
                return l + 1;
              });
            },
            handlePrevious: function handlePrevious() {
              V(function (l) {
                return l - 1;
              });
            },
            onBlockPatternSelect: function onBlockPatternSelect() {
              F(D[B].blocks);
            },
            onStartBlank: function onStartBlank() {
              A(!0);
            }
          }), (0, v.createElement)(SetupContent, {
            viewMode: w,
            activeSlide: B,
            patterns: D,
            onBlockPatternSelect: F
          }));
        };

        s.default = _default;
      },
      8847: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6756),
            _ = c(4892),
            k = c(2614),
            y = c(6540);

        var Actions = function Actions(l) {
          var s = l.onStartBlank,
              c = l.onBlockPatternSelect;
          return (0, m.createElement)("div", {
            className: "block-editor-block-pattern-setup__actions"
          }, (0, m.createElement)(_.Button, {
            onClick: s
          }, (0, v.__)("Start blank")), (0, m.createElement)(_.Button, {
            variant: "primary",
            onClick: c
          }, (0, v.__)("Choose")));
        },
            CarouselNavigation = function CarouselNavigation(l) {
          var s = l.handlePrevious,
              c = l.handleNext,
              y = l.activeSlide,
              E = l.totalSlides;
          return (0, m.createElement)("div", {
            className: "block-editor-block-pattern-setup__navigation"
          }, (0, m.createElement)(_.Button, {
            icon: k.chevronLeft,
            label: (0, v.__)("Previous pattern"),
            onClick: s,
            disabled: 0 === y
          }), (0, m.createElement)(_.Button, {
            icon: k.chevronRight,
            label: (0, v.__)("Next pattern"),
            onClick: c,
            disabled: y === E - 1
          }));
        };

        var _default = function _default(l) {
          var s = l.viewMode,
              c = l.setViewMode,
              E = l.handlePrevious,
              w = l.handleNext,
              C = l.activeSlide,
              S = l.totalSlides,
              B = l.onBlockPatternSelect,
              P = l.onStartBlank;
          var O = s === y.VIEWMODES.carousel,
              L = (0, m.createElement)("div", {
            className: "block-editor-block-pattern-setup__display-controls"
          }, (0, m.createElement)(_.Button, {
            icon: k.stretchFullWidth,
            label: (0, v.__)("Carousel view"),
            onClick: function onClick() {
              return c(y.VIEWMODES.carousel);
            },
            isPressed: O
          }), (0, m.createElement)(_.Button, {
            icon: k.grid,
            label: (0, v.__)("Grid view"),
            onClick: function onClick() {
              return c(y.VIEWMODES.grid);
            },
            isPressed: s === y.VIEWMODES.grid
          }));
          return (0, m.createElement)("div", {
            className: "block-editor-block-pattern-setup__toolbar"
          }, O && (0, m.createElement)(CarouselNavigation, {
            handlePrevious: E,
            handleNext: w,
            activeSlide: C,
            totalSlides: S
          }), L, O && (0, m.createElement)(Actions, {
            onBlockPatternSelect: B,
            onStartBlank: P
          }));
        };

        s.default = _default;
      },
      454: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(8467),
            v = c(8486);

        var _ = function usePatternsSetup(l, s, c) {
          return (0, m.useSelect)(function (m) {
            var _m18 = m(v.store),
                _ = _m18.getBlockRootClientId,
                k = _m18.__experimentalGetPatternsByBlockTypes,
                y = _m18.__experimentalGetAllowedPatterns,
                E = _(l);

            return c ? y(E).filter(c) : k(s, E);
          }, [l, s, c]);
        };

        s.default = _;
      },
      5511: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = c(3200),
            E = c(6756),
            w = m(c(8958)),
            C = m(c(3157));

        function BlockPattern(l) {
          var s = l.isDraggable,
              c = l.pattern,
              m = l.onClick,
              E = l.composite;
          var S = c.blocks,
              B = c.viewportWidth,
              P = "block-editor-block-patterns-list__item-description-".concat((0, y.useInstanceId)(BlockPattern));
          return (0, v.createElement)(C.default, {
            isEnabled: s,
            blocks: S
          }, function (l) {
            var s = l.draggable,
                y = l.onDragStart,
                C = l.onDragEnd;
            return (0, v.createElement)("div", {
              className: "block-editor-block-patterns-list__list-item",
              "aria-label": c.title,
              "aria-describedby": c.description ? P : void 0,
              draggable: s,
              onDragStart: y,
              onDragEnd: C
            }, (0, v.createElement)(k.__unstableCompositeItem, (0, _.default)({
              role: "option",
              as: "div"
            }, E, {
              className: "block-editor-block-patterns-list__item",
              onClick: function onClick() {
                return m(c, S);
              }
            }), (0, v.createElement)(w.default, {
              blocks: S,
              viewportWidth: B
            }), (0, v.createElement)("div", {
              className: "block-editor-block-patterns-list__item-title"
            }, c.title), !!c.description && (0, v.createElement)(k.VisuallyHidden, {
              id: P
            }, c.description)));
          });
        }

        function BlockPatternPlaceholder() {
          return (0, v.createElement)("div", {
            className: "block-editor-block-patterns-list__item is-placeholder"
          });
        }

        var S = function BlockPatternList(l) {
          var s = l.isDraggable,
              c = l.blockPatterns,
              m = l.shownPatterns,
              y = l.onClickPattern,
              w = l.orientation,
              _l$label4 = l.label,
              C = _l$label4 === void 0 ? (0, E.__)("Block Patterns") : _l$label4;
          var S = (0, k.__unstableUseCompositeState)({
            orientation: w
          });
          return (0, v.createElement)(k.__unstableComposite, (0, _.default)({}, S, {
            role: "listbox",
            className: "block-editor-block-patterns-list",
            "aria-label": C
          }), c.map(function (l) {
            return m.includes(l) ? (0, v.createElement)(BlockPattern, {
              key: l.name,
              pattern: l,
              onClick: y,
              isDraggable: s,
              composite: S
            }) : (0, v.createElement)(BlockPatternPlaceholder, {
              key: l.name
            });
          }));
        };

        s.default = S;
      },
      1510: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4892),
            k = c(3200),
            y = c(8467),
            E = m(c(9476)),
            w = m(c(9821)),
            C = m(c(2489)),
            S = c(8486);

        var B;
        var P = 2e3;

        var O = function AutoBlockPreview(l) {
          var s = l.viewportWidth,
              c = l.__experimentalPadding;

          var _ref93 = (0, k.useResizeObserver)(),
              _ref94 = _slicedToArray(_ref93, 2),
              m = _ref94[0],
              O = _ref94[1].width,
              _ref95 = (0, k.useResizeObserver)(),
              _ref96 = _slicedToArray(_ref95, 2),
              L = _ref96[0],
              V = _ref96[1].height,
              R = (0, y.useSelect)(function (l) {
            return l(S.store).getSettings().styles;
          }, []),
              A = (0, v.useMemo)(function () {
            return R ? [].concat(_toConsumableArray(R), [{
              css: "body{height:auto;overflow:hidden;}",
              __unstableType: "presets"
            }]) : R;
          }, [R]);

          B = B || (0, k.pure)(E.default);
          var z = O / s;
          return (0, v.createElement)("div", {
            className: "block-editor-block-preview__container"
          }, m, (0, v.createElement)(_.Disabled, {
            className: "block-editor-block-preview__content",
            style: {
              transform: "scale(".concat(z, ")"),
              height: V * z,
              maxHeight: V > P ? P * z : void 0
            }
          }, (0, v.createElement)(w.default, {
            head: (0, v.createElement)(C.default, {
              styles: A
            }),
            contentRef: (0, k.useRefEffect)(function (l) {
              var s = l.ownerDocument.documentElement;
              s.classList.add("block-editor-block-preview__content-iframe"), s.style.position = "absolute", s.style.width = "100%", l.style.padding = c + "px";
            }, []),
            "aria-hidden": !0,
            tabIndex: -1,
            style: {
              position: "absolute",
              width: s,
              height: V,
              pointerEvents: "none",
              maxHeight: P
            }
          }, L, (0, v.createElement)(B, {
            renderAppender: !1
          }))));
        };

        s.default = O;
      },
      8958: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockPreview = BlockPreview, s.default = void 0, s.useBlockPreview = function useBlockPreview(l) {
          var s = l.blocks,
              _l$props = l.props,
              c = _l$props === void 0 ? {} : _l$props,
              m = l.__experimentalLayout;
          var C = (0, E.useSelect)(function (l) {
            return l(B.store).getSettings();
          }, []),
              S = (0, y.__experimentalUseDisabled)(),
              O = (0, y.useMergeRefs)([c.ref, S]),
              L = (0, v.useMemo)(function () {
            return _objectSpread(_objectSpread({}, C), {}, {
              __experimentalBlockPatterns: []
            });
          }, [C]),
              V = (0, v.useMemo)(function () {
            return (0, _.castArray)(s);
          }, [s]),
              R = (0, v.createElement)(w.default, {
            value: V,
            settings: L
          }, (0, v.createElement)(P.BlockListItems, {
            renderAppender: !1,
            __experimentalLayout: m
          }));
          return _objectSpread(_objectSpread({}, c), {}, {
            ref: O,
            className: (0, k.default)(c.className, "block-editor-block-preview__live-content", "components-disabled"),
            children: null != s && s.length ? R : null
          });
        };

        var v = c(1753),
            _ = c(4793),
            k = m(c(2703)),
            y = c(3200),
            E = c(8467),
            w = m(c(6375)),
            C = m(c(7937)),
            S = m(c(1510)),
            B = c(8486),
            P = c(9476);

        function BlockPreview(l) {
          var s = l.blocks,
              _l$__experimentalPadd = l.__experimentalPadding,
              c = _l$__experimentalPadd === void 0 ? 0 : _l$__experimentalPadd,
              _l$viewportWidth = l.viewportWidth,
              m = _l$viewportWidth === void 0 ? 1200 : _l$viewportWidth,
              _l$__experimentalLive = l.__experimentalLive,
              k = _l$__experimentalLive === void 0 ? !1 : _l$__experimentalLive,
              y = l.__experimentalOnClick;
          var P = (0, E.useSelect)(function (l) {
            return l(B.store).getSettings();
          }, []),
              O = (0, v.useMemo)(function () {
            var l = _objectSpread({}, P);

            return l.__experimentalBlockPatterns = [], l;
          }, [P]),
              L = (0, v.useMemo)(function () {
            return (0, _.castArray)(s);
          }, [s]);
          return s && 0 !== s.length ? (0, v.createElement)(w.default, {
            value: L,
            settings: O
          }, k ? (0, v.createElement)(C.default, {
            onClick: y
          }) : (0, v.createElement)(S.default, {
            viewportWidth: m,
            __experimentalPadding: c
          })) : null;
        }

        var O = (0, v.memo)(BlockPreview);
        s.default = O;
      },
      7937: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LiveBlockPreview(l) {
          var s = l.onClick;
          return (0, v.createElement)("div", {
            tabIndex: 0,
            role: "button",
            onClick: s,
            onKeyPress: s
          }, (0, v.createElement)(_.Disabled, null, (0, v.createElement)(k.default, null)));
        };

        var v = c(1753),
            _ = c(4892),
            k = m(c(9476));
      },
      5920: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockSelectionClearer(l) {
          return (0, v.createElement)("div", (0, _.default)({
            ref: useBlockSelectionClearer()
          }, l));
        }, s.useBlockSelectionClearer = useBlockSelectionClearer;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(8467),
            y = c(3200),
            E = c(8486);

        function useBlockSelectionClearer() {
          var _ref97 = (0, k.useSelect)(E.store),
              l = _ref97.hasSelectedBlock,
              s = _ref97.hasMultiSelection,
              _ref98 = (0, k.useDispatch)(E.store),
              c = _ref98.clearSelectedBlock;

          return (0, y.useRefEffect)(function (m) {
            function onMouseDown(v) {
              (l() || s()) && v.target === m && c();
            }

            return m.addEventListener("mousedown", onMouseDown), function () {
              m.removeEventListener("mousedown", onMouseDown);
            };
          }, [l, s, c]);
        }
      },
      6056: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = c(4892),
            E = c(8467),
            w = c(9438),
            C = c(8486);

        var _ref99 = (0, y.createSlotFill)("BlockSettingsMenuControls"),
            S = _ref99.Fill,
            B = _ref99.Slot;

        function BlockSettingsMenuControls(l) {
          var s = Object.assign({}, l);
          return (0, v.createElement)(y.__experimentalStyleProvider, {
            document: document
          }, (0, v.createElement)(S, s));
        }

        BlockSettingsMenuControls.Slot = function (l) {
          var s = l.fillProps,
              _l$clientIds = l.clientIds,
              c = _l$clientIds === void 0 ? null : _l$clientIds;

          var _ref100 = (0, E.useSelect)(function (l) {
            var _l57 = l(C.store),
                s = _l57.getBlocksByClientId,
                m = _l57.getSelectedBlockClientIds,
                v = null !== c ? c : m();

            return {
              selectedBlocks: (0, k.map)((0, k.compact)(s(v)), function (l) {
                return l.name;
              }),
              selectedClientIds: v
            };
          }, [c]),
              m = _ref100.selectedBlocks,
              S = _ref100.selectedClientIds,
              P = (0, w.useConvertToGroupButtonProps)(),
              O = P.isGroupable,
              L = P.isUngroupable,
              V = O || L;

          return (0, v.createElement)(B, {
            fillProps: _objectSpread(_objectSpread({}, s), {}, {
              selectedBlocks: m,
              selectedClientIds: S
            })
          }, function (l) {
            if ((null == l ? void 0 : l.length) > 0 || V) return (0, v.createElement)(y.MenuGroup, null, l, (0, v.createElement)(w.ConvertToGroupButton, (0, _.default)({}, P, {
              onClose: null == s ? void 0 : s.onClose
            })));
          });
        };

        var P = BlockSettingsMenuControls;
        s.default = P;
      },
      6610: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockConvertButton(l) {
          var s = l.shouldRender,
              c = l.onClick,
              k = l.small;
          if (!s) return null;
          var y = (0, v.__)("Convert to Blocks");
          return (0, m.createElement)(_.MenuItem, {
            onClick: c
          }, !k && y);
        };

        var m = c(1753),
            v = c(6756),
            _ = c(4892);
      },
      3715: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(6700),
            _ = c(3200),
            k = c(8467),
            y = m(c(6610)),
            E = c(8486),
            w = (0, _.compose)((0, k.withSelect)(function (l, s) {
          var c = s.clientId;
          var m = l(E.store).getBlock(c);
          return {
            block: m,
            shouldRender: m && "core/html" === m.name
          };
        }), (0, k.withDispatch)(function (l, s) {
          var c = s.block;
          return {
            onClick: function onClick() {
              return l(E.store).replaceBlocks(c.clientId, (0, v.rawHandler)({
                HTML: (0, v.getBlockContent)(c)
              }));
            }
          };
        }))(y.default);

        s.default = w;
      },
      9269: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockModeToggle = BlockModeToggle, s.default = void 0;

        var m = c(1753),
            v = c(4793),
            _ = c(6756),
            k = c(4892),
            y = c(6700),
            E = c(8467),
            w = c(3200),
            C = c(8486);

        function BlockModeToggle(l) {
          var s = l.blockType,
              c = l.mode,
              v = l.onToggleMode,
              _l$small = l.small,
              E = _l$small === void 0 ? !1 : _l$small,
              _l$isCodeEditingEnabl = l.isCodeEditingEnabled,
              w = _l$isCodeEditingEnabl === void 0 ? !0 : _l$isCodeEditingEnabl;
          if (!(0, y.hasBlockSupport)(s, "html", !0) || !w) return null;
          var C = "visual" === c ? (0, _.__)("Edit as HTML") : (0, _.__)("Edit visually");
          return (0, m.createElement)(k.MenuItem, {
            onClick: v
          }, !E && C);
        }

        var S = (0, w.compose)([(0, E.withSelect)(function (l, s) {
          var c = s.clientId;

          var _l58 = l(C.store),
              m = _l58.getBlock,
              v = _l58.getBlockMode,
              _ = _l58.getSettings,
              k = m(c),
              E = _().codeEditingEnabled;

          return {
            mode: v(c),
            blockType: k ? (0, y.getBlockType)(k.name) : null,
            isCodeEditingEnabled: E
          };
        }), (0, E.withDispatch)(function (l, s) {
          var _s$onToggle = s.onToggle,
              c = _s$onToggle === void 0 ? v.noop : _s$onToggle,
              m = s.clientId;
          return {
            onToggleMode: function onToggleMode() {
              l(C.store).toggleBlockMode(m), c();
            }
          };
        })])(BlockModeToggle);
        s.default = S;
      },
      272: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockSettingsDropdown = BlockSettingsDropdown, s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = c(6756),
            E = c(4892),
            w = c(8467),
            C = c(2614),
            S = c(6700),
            B = c(2470),
            P = c(3200),
            O = m(c(1550)),
            L = m(c(9269)),
            V = m(c(3715)),
            R = m(c(8123)),
            A = m(c(6056)),
            z = c(8486);

        var D = {
          className: "block-editor-block-settings-menu__popover",
          position: "bottom right",
          isAlternate: !0
        };

        function CopyMenuItem(l) {
          var s = l.blocks,
              c = l.onCopy;
          var m = (0, P.useCopyToClipboard)(function () {
            return (0, S.serialize)(s);
          }, c);
          return (0, v.createElement)(E.MenuItem, {
            ref: m
          }, (0, y.__)("Copy"));
        }

        function BlockSettingsDropdown(l) {
          var s = l.clientIds,
              c = l.__experimentalSelectBlock,
              m = l.children,
              P = _objectWithoutProperties(l, _excluded8);

          var F = (0, k.castArray)(s),
              G = F.length,
              U = F[0],
              _ref101 = (0, w.useSelect)(function (l) {
            var s;

            var _l59 = l(z.store),
                c = _l59.getBlockCount,
                m = _l59.getBlockName,
                _l60 = l(S.store),
                v = _l60.getBlockType;

            return {
              onlyBlock: 1 === c(),
              title: null === (s = v(m(U))) || void 0 === s ? void 0 : s.title
            };
          }, [U]),
              W = _ref101.onlyBlock,
              K = _ref101.title,
              $ = (0, w.useSelect)(function (l) {
            var _l61 = l(B.store),
                s = _l61.getShortcutRepresentation;

            return {
              duplicate: s("core/block-editor/duplicate"),
              remove: s("core/block-editor/remove"),
              insertAfter: s("core/block-editor/insert-after"),
              insertBefore: s("core/block-editor/insert-before")
            };
          }, []),
              q = (0, v.useCallback)(c ? /*#__PURE__*/function () {
            var _ref102 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(l) {
              var s;
              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return l;

                    case 2:
                      s = _context5.sent;
                      s && s[0] && c(s[0]);

                    case 4:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            }));

            return function (_x5) {
              return _ref102.apply(this, arguments);
            };
          }() : k.noop, [c]),
              Y = (0, y.sprintf)((0, y.__)("Remove %s"), K),
              Z = 1 === G ? Y : (0, y.__)("Remove blocks");

          return (0, v.createElement)(O.default, {
            clientIds: s,
            __experimentalUpdateSelection: !c
          }, function (l) {
            var c = l.canDuplicate,
                w = l.canInsertDefaultBlock,
                S = l.canMove,
                B = l.canRemove,
                O = l.onDuplicate,
                z = l.onInsertAfter,
                F = l.onInsertBefore,
                K = l.onRemove,
                Y = l.onCopy,
                X = l.onMoveTo,
                Q = l.blocks;
            return (0, v.createElement)(E.DropdownMenu, (0, _.default)({
              icon: C.moreVertical,
              label: (0, y.__)("Options"),
              className: "block-editor-block-settings-menu",
              popoverProps: D,
              noIcons: !0
            }, P), function (l) {
              var _ = l.onClose;
              return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(E.MenuGroup, null, (0, v.createElement)(R.default.Slot, {
                fillProps: {
                  onClose: _
                }
              }), 1 === G && (0, v.createElement)(V.default, {
                clientId: U
              }), (0, v.createElement)(CopyMenuItem, {
                blocks: Q,
                onCopy: Y
              }), c && (0, v.createElement)(E.MenuItem, {
                onClick: (0, k.flow)(_, O, q),
                shortcut: $.duplicate
              }, (0, y.__)("Duplicate")), w && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(E.MenuItem, {
                onClick: (0, k.flow)(_, F),
                shortcut: $.insertBefore
              }, (0, y.__)("Insert before")), (0, v.createElement)(E.MenuItem, {
                onClick: (0, k.flow)(_, z),
                shortcut: $.insertAfter
              }, (0, y.__)("Insert after"))), S && !W && (0, v.createElement)(E.MenuItem, {
                onClick: (0, k.flow)(_, X)
              }, (0, y.__)("Move to")), 1 === G && (0, v.createElement)(L.default, {
                clientId: U,
                onToggle: _
              })), (0, v.createElement)(A.default.Slot, {
                fillProps: {
                  onClose: _
                },
                clientIds: s
              }), "function" == typeof m ? m({
                onClose: _
              }) : v.Children.map(function (l) {
                return (0, v.cloneElement)(l, {
                  onClose: _
                });
              }), B && (0, v.createElement)(E.MenuGroup, null, (0, v.createElement)(E.MenuItem, {
                onClick: (0, k.flow)(_, K, q),
                shortcut: $.remove
              }, Z)));
            });
          });
        }

        var F = BlockSettingsDropdown;
        s.default = F;
      },
      8123: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(4892);

        var _ref103 = (0, m.createSlotFill)("__unstableBlockSettingsMenuFirstItem"),
            v = _ref103.Fill,
            _ = _ref103.Slot;

        v.Slot = _;
        var k = v;
        s.default = k;
      },
      4311: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockSettingsMenu = BlockSettingsMenu, s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = m(c(272));

        function BlockSettingsMenu(l) {
          var s = l.clientIds,
              c = _objectWithoutProperties(l, _excluded9);

          return (0, v.createElement)(k.ToolbarGroup, null, (0, v.createElement)(k.ToolbarItem, null, function (l) {
            return (0, v.createElement)(y.default, (0, _.default)({
              clientIds: s,
              toggleProps: l
            }, c));
          }));
        }

        var E = BlockSettingsMenu;
        s.default = E;
      },
      6551: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            k = m(c(2703)),
            y = c(8467),
            E = c(9880),
            w = c(6756),
            C = c(6700),
            S = c(2969),
            B = m(c(8958)),
            P = c(8486);

        var O = {};

        function BlockStyleItem(l) {
          var s = l.genericPreviewBlock,
              c = l.viewportWidth,
              m = l.style,
              _ = l.isActive,
              y = l.onBlur,
              w = l.onHover,
              C = l.onSelect,
              S = l.styleClassName,
              P = l.itemRole;
          var O = (0, v.useMemo)(function () {
            return _objectSpread(_objectSpread({}, s), {}, {
              attributes: _objectSpread(_objectSpread({}, s.attributes), {}, {
                className: S
              })
            });
          }, [s, S]);
          return (0, v.createElement)("div", {
            key: m.name,
            className: (0, k.default)("block-editor-block-styles__item", {
              "is-active": _
            }),
            onClick: function onClick() {
              return C();
            },
            onKeyDown: function onKeyDown(l) {
              E.ENTER !== l.keyCode && E.SPACE !== l.keyCode || (l.preventDefault(), C());
            },
            onMouseEnter: w,
            onMouseLeave: y,
            role: P || "button",
            tabIndex: "0",
            "aria-label": m.label || m.name
          }, (0, v.createElement)("div", {
            className: "block-editor-block-styles__item-preview"
          }, (0, v.createElement)(B.default, {
            viewportWidth: c,
            blocks: O
          })), (0, v.createElement)("div", {
            className: "block-editor-block-styles__item-label"
          }, m.label || m.name));
        }

        var L = function BlockStyles(l) {
          var s = l.clientId,
              _l$onSwitch = l.onSwitch,
              c = _l$onSwitch === void 0 ? _.noop : _l$onSwitch,
              _l$onHoverClassName = l.onHoverClassName,
              m = _l$onHoverClassName === void 0 ? _.noop : _l$onHoverClassName,
              k = l.itemRole;

          var _ref104 = (0, y.useSelect)(function (l) {
            var _l62 = l(P.store),
                c = _l62.getBlock,
                m = c(s);

            if (!m) return O;

            var v = (0, C.getBlockType)(m.name),
                _l63 = l(C.store),
                _ = _l63.getBlockStyles;

            return {
              block: m,
              type: v,
              styles: _(m.name),
              className: m.attributes.className || ""
            };
          }, [s]),
              E = _ref104.styles,
              B = _ref104.block,
              L = _ref104.type,
              V = _ref104.className,
              _ref105 = (0, y.useDispatch)(P.store),
              R = _ref105.updateBlockAttributes,
              A = function useGenericPreviewBlock(l, s) {
            return (0, v.useMemo)(function () {
              var c = null == s ? void 0 : s.example,
                  m = null == s ? void 0 : s.name;
              return c && m ? (0, C.getBlockFromExample)(m, {
                attributes: c.attributes,
                innerBlocks: c.innerBlocks
              }) : l ? (0, C.cloneBlock)(l) : void 0;
            }, [null != s && s.example ? null == l ? void 0 : l.name : l, s]);
          }(B, L);

          if (!E || 0 === E.length) return null;
          var z = (0, _.find)(E, "isDefault") ? E : [{
            name: "default",
            label: (0, w._x)("Default", "block style"),
            isDefault: !0
          }].concat(_toConsumableArray(E)),
              D = (0, S.getActiveStyle)(z, V);
          return (0, v.createElement)("div", {
            className: "block-editor-block-styles"
          }, z.map(function (l) {
            var _, y;

            var E = (0, S.replaceActiveStyle)(V, D, l);
            return (0, v.createElement)(BlockStyleItem, {
              genericPreviewBlock: A,
              viewportWidth: null !== (_ = null === (y = L.example) || void 0 === y ? void 0 : y.viewportWidth) && void 0 !== _ ? _ : 500,
              className: V,
              isActive: D === l,
              key: l.name,
              onSelect: function onSelect() {
                R(s, {
                  className: E
                }), m(null), c();
              },
              onBlur: function onBlur() {
                return m(null);
              },
              onHover: function onHover() {
                return m(E);
              },
              style: l,
              styleClassName: E,
              itemRole: k
            });
          }));
        };

        s.default = L;
      },
      2969: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getActiveStyle = function getActiveStyle(l, s) {
          var _iterator5 = _createForOfIteratorHelper(new _.default(s).values()),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _c23 = _step5.value;
              if (-1 === _c23.indexOf("is-style-")) continue;

              var _s29 = _c23.substring(9),
                  _m19 = (0, v.find)(l, {
                name: _s29
              });

              if (_m19) return _m19;
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          return (0, v.find)(l, "isDefault");
        }, s.replaceActiveStyle = function replaceActiveStyle(l, s, c) {
          var m = new _.default(l);
          s && m.remove("is-style-" + s.name);
          return m.add("is-style-" + c.name), m.value;
        };

        var v = c(4793),
            _ = m(c(410));
      },
      4439: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockStylesMenu(l) {
          var s = l.hoveredBlock,
              c = l.onSwitch;

          var m = s.name,
              S = s.clientId,
              _ref106 = (0, v.useState)(),
              _ref107 = _slicedToArray(_ref106, 2),
              B = _ref107[0],
              P = _ref107[1],
              O = (0, y.useSelect)(function (l) {
            return l(E.store).getBlockType(m);
          }, [m]);

          return (0, v.createElement)(k.MenuGroup, {
            label: (0, _.__)("Styles"),
            className: "block-editor-block-switcher__styles__menugroup"
          }, B && (0, v.createElement)(C.default, {
            blocks: O && O.example ? (0, E.getBlockFromExample)(O.name, {
              attributes: _objectSpread(_objectSpread({}, O.example.attributes), {}, {
                className: B
              }),
              innerBlocks: O.example.innerBlocks
            }) : (0, E.cloneBlock)(s, {
              className: B
            })
          }), (0, v.createElement)(w.default, {
            clientId: S,
            onSwitch: c,
            onHoverClassName: P,
            itemRole: "menuitem"
          }));
        };

        var v = c(1753),
            _ = c(6756),
            k = c(4892),
            y = c(8467),
            E = c(6700),
            w = m(c(6551)),
            C = m(c(4041));
      },
      3231: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(6756),
            k = c(4892),
            y = c(6700),
            E = m(c(2006)),
            w = m(c(4041));

        var _default = function _default(l) {
          var s = l.className,
              c = l.possibleBlockTransformations,
              m = l.onSelect,
              C = l.blocks;

          var _ref108 = (0, v.useState)(),
              _ref109 = _slicedToArray(_ref108, 2),
              S = _ref109[0],
              B = _ref109[1];

          return (0, v.createElement)(k.MenuGroup, {
            label: (0, _.__)("Transform to"),
            className: s
          }, S && (0, v.createElement)(w.default, {
            blocks: (0, y.switchToBlockType)(C, S)
          }), c.map(function (l) {
            var s = l.name,
                c = l.icon,
                _ = l.title,
                w = l.isDisabled;
            return (0, v.createElement)(k.MenuItem, {
              key: s,
              className: (0, y.getBlockMenuDefaultClassName)(s),
              onClick: function onClick(l) {
                l.preventDefault(), m(s);
              },
              disabled: w,
              onMouseLeave: function onMouseLeave() {
                return B(null);
              },
              onMouseEnter: function onMouseEnter() {
                return B(s);
              }
            }, (0, v.createElement)(E.default, {
              icon: c,
              showColors: !0
            }), _);
          }));
        };

        s.default = _default;
      },
      9033: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.BlockSwitcherDropdownMenu = s.BlockSwitcher = void 0;

        var v = c(1753),
            _ = c(4793),
            k = c(6756),
            y = c(4892),
            E = c(6700),
            w = c(8467),
            C = c(2614),
            S = c(8486),
            B = m(c(139)),
            P = m(c(2006)),
            O = m(c(6147)),
            L = m(c(3231)),
            V = m(c(4439)),
            R = m(c(8628));

        var BlockSwitcherDropdownMenu = function BlockSwitcherDropdownMenu(l) {
          var s = l.clientIds,
              c = l.blocks;

          var _ref110 = (0, w.useDispatch)(S.store),
              m = _ref110.replaceBlocks,
              A = (0, B.default)(c[0].clientId),
              _ref111 = (0, w.useSelect)(function (l) {
            var m;

            var _l64 = l(S.store),
                v = _l64.getBlockRootClientId,
                k = _l64.getBlockTransformItems,
                y = _l64.__experimentalGetPatternTransformItems,
                _l65 = l(E.store),
                w = _l65.getBlockStyles,
                B = _l65.getBlockType,
                _l66 = l(S.store),
                P = _l66.canRemoveBlocks,
                O = v((0, _.castArray)(s)[0]),
                _c24 = _slicedToArray(c, 1),
                L = _c24[0].name,
                V = 1 === c.length,
                R = V && w(L);

            var z;
            if (V) z = null == A ? void 0 : A.icon;else {
              var D;
              z = 1 === (0, _.uniq)(c.map(function (l) {
                var s = l.name;
                return s;
              })).length ? null === (D = B(L)) || void 0 === D ? void 0 : D.icon : C.stack;
            }
            return {
              possibleBlockTransformations: k(c, O),
              canRemove: P(s, O),
              hasBlockStyles: !(null == R || !R.length),
              icon: z,
              blockTitle: null === (m = B(L)) || void 0 === m ? void 0 : m.title,
              patterns: y(c, O)
            };
          }, [s, c, null == A ? void 0 : A.icon]),
              z = _ref111.possibleBlockTransformations,
              D = _ref111.canRemove,
              F = _ref111.hasBlockStyles,
              G = _ref111.icon,
              U = _ref111.blockTitle,
              W = _ref111.patterns,
              K = 1 === c.length && (0, E.isReusableBlock)(c[0]),
              $ = 1 === c.length && (0, E.isTemplatePart)(c[0]),
              q = !!z.length && D,
              Y = !(null == W || !W.length) && D;

          if (!F && !q) return (0, v.createElement)(y.ToolbarGroup, null, (0, v.createElement)(y.ToolbarButton, {
            disabled: !0,
            className: "block-editor-block-switcher__no-switcher-icon",
            title: U,
            icon: (0, v.createElement)(P.default, {
              icon: G,
              showColors: !0
            })
          }));
          var Z = U,
              X = 1 === c.length ? (0, k.sprintf)((0, k.__)("%s: Change block type or style"), U) : (0, k.sprintf)((0, k._n)("Change type of %d block", "Change type of %d blocks", c.length), c.length),
              Q = F || q || Y;
          return (0, v.createElement)(y.ToolbarGroup, null, (0, v.createElement)(y.ToolbarItem, null, function (l) {
            return (0, v.createElement)(y.DropdownMenu, {
              className: "block-editor-block-switcher",
              label: Z,
              popoverProps: {
                position: "bottom right",
                isAlternate: !0,
                className: "block-editor-block-switcher__popover"
              },
              icon: (0, v.createElement)(v.Fragment, null, (0, v.createElement)(P.default, {
                icon: G,
                className: "block-editor-block-switcher__toggle",
                showColors: !0
              }), (K || $) && (0, v.createElement)("span", {
                className: "block-editor-block-switcher__toggle-text"
              }, (0, v.createElement)(O.default, {
                clientId: s
              }))),
              toggleProps: _objectSpread({
                describedBy: X
              }, l),
              menuProps: {
                orientation: "both"
              }
            }, function (l) {
              var _ = l.onClose;
              return Q && (0, v.createElement)("div", {
                className: "block-editor-block-switcher__container"
              }, Y && (0, v.createElement)(R.default, {
                blocks: c,
                patterns: W,
                onSelect: function onSelect(l) {
                  (function (l) {
                    m(s, l);
                  })(l), _();
                }
              }), q && (0, v.createElement)(L.default, {
                className: "block-editor-block-switcher__transforms__menugroup",
                possibleBlockTransformations: z,
                blocks: c,
                onSelect: function onSelect(l) {
                  (function (l) {
                    m(s, (0, E.switchToBlockType)(c, l));
                  })(l), _();
                }
              }), F && (0, v.createElement)(V.default, {
                hoveredBlock: c[0],
                onSwitch: _
              }));
            });
          }));
        };

        s.BlockSwitcherDropdownMenu = BlockSwitcherDropdownMenu;

        var BlockSwitcher = function BlockSwitcher(l) {
          var s = l.clientIds;
          var c = (0, w.useSelect)(function (l) {
            return l(S.store).getBlocksByClientId(s);
          }, [s]);
          return !c.length || c.some(function (l) {
            return !l;
          }) ? null : (0, v.createElement)(BlockSwitcherDropdownMenu, {
            clientIds: s,
            blocks: c
          });
        };

        s.BlockSwitcher = BlockSwitcher;
        var A = BlockSwitcher;
        s.default = A;
      },
      8628: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(6756),
            y = c(3200),
            E = c(2614),
            w = c(4892),
            C = m(c(8958)),
            S = m(c(1355));

        function PreviewPatternsPopover(l) {
          var s = l.patterns,
              c = l.onSelect;
          return (0, v.createElement)("div", {
            className: "block-editor-block-switcher__popover__preview__parent"
          }, (0, v.createElement)("div", {
            className: "block-editor-block-switcher__popover__preview__container"
          }, (0, v.createElement)(w.Popover, {
            className: "block-editor-block-switcher__preview__popover",
            position: "bottom right"
          }, (0, v.createElement)("div", {
            className: "block-editor-block-switcher__preview"
          }, (0, v.createElement)("div", {
            className: "block-editor-block-switcher__preview-title"
          }, (0, k.__)("Preview")), (0, v.createElement)(BlockPatternsList, {
            patterns: s,
            onSelect: c
          })))));
        }

        function BlockPatternsList(l) {
          var s = l.patterns,
              c = l.onSelect;
          var m = (0, w.__unstableUseCompositeState)();
          return (0, v.createElement)(w.__unstableComposite, (0, _.default)({}, m, {
            role: "listbox",
            className: "block-editor-block-switcher__preview-patterns-container",
            "aria-label": (0, k.__)("Patterns list")
          }), s.map(function (l) {
            return (0, v.createElement)(BlockPattern, {
              key: l.name,
              pattern: l,
              onSelect: c,
              composite: m
            });
          }));
        }

        function BlockPattern(l) {
          var s = l.pattern,
              c = l.onSelect,
              m = l.composite;
          var k = "block-editor-block-switcher__preview-patterns-container",
              E = (0, y.useInstanceId)(BlockPattern, "".concat(k, "-list__item-description"));
          return (0, v.createElement)("div", {
            className: "".concat(k, "-list__list-item"),
            "aria-label": s.title,
            "aria-describedby": s.description ? E : void 0
          }, (0, v.createElement)(w.__unstableCompositeItem, (0, _.default)({
            role: "option",
            as: "div"
          }, m, {
            className: "".concat(k, "-list__item"),
            onClick: function onClick() {
              return c(s.transformedBlocks);
            }
          }), (0, v.createElement)(C.default, {
            blocks: s.transformedBlocks,
            viewportWidth: s.viewportWidth || 500
          }), (0, v.createElement)("div", {
            className: "".concat(k, "-list__item-title")
          }, s.title)), !!s.description && (0, v.createElement)(w.VisuallyHidden, {
            id: E
          }, s.description));
        }

        var B = function PatternTransformationsMenu(l) {
          var s = l.blocks,
              c = l.patterns,
              m = l.onSelect;

          var _ref112 = (0, v.useState)(!1),
              _ref113 = _slicedToArray(_ref112, 2),
              _ = _ref113[0],
              y = _ref113[1],
              C = (0, S.default)(c, s);

          return C.length ? (0, v.createElement)(w.MenuGroup, {
            className: "block-editor-block-switcher__pattern__transforms__menugroup"
          }, _ && (0, v.createElement)(PreviewPatternsPopover, {
            patterns: C,
            onSelect: m
          }), (0, v.createElement)(w.MenuItem, {
            onClick: function onClick(l) {
              l.preventDefault(), y(!_);
            },
            icon: E.chevronRight
          }, (0, k.__)("Patterns"))) : null;
        };

        s.default = B;
      },
      4041: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PreviewBlockPopover(l) {
          var s = l.blocks;
          return (0, v.createElement)("div", {
            className: "block-editor-block-switcher__popover__preview__parent"
          }, (0, v.createElement)("div", {
            className: "block-editor-block-switcher__popover__preview__container"
          }, (0, v.createElement)(k.Popover, {
            className: "block-editor-block-switcher__preview__popover",
            position: "bottom right",
            focusOnMount: !1
          }, (0, v.createElement)("div", {
            className: "block-editor-block-switcher__preview"
          }, (0, v.createElement)("div", {
            className: "block-editor-block-switcher__preview-title"
          }, (0, _.__)("Preview")), (0, v.createElement)(y.default, {
            viewportWidth: 500,
            blocks: s
          })))));
        };

        var v = c(1753),
            _ = c(6756),
            k = c(4892),
            y = m(c(8958));
      },
      1355: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.transformMatchingBlock = s.getPatternTransformedBlocks = s.default = void 0;

        var m = c(1753),
            v = c(6700),
            _ = c(1940);

        var transformMatchingBlock = function transformMatchingBlock(l, s) {
          var c = (0, _.getRetainedBlockAttributes)(s.name, s.attributes);
          l.attributes = _objectSpread(_objectSpread({}, l.attributes), c);
        };

        s.transformMatchingBlock = transformMatchingBlock;

        var getPatternTransformedBlocks = function getPatternTransformedBlocks(l, s) {
          var c = s.map(function (l) {
            return (0, v.cloneBlock)(l);
          }),
              m = new Set();

          var _iterator6 = _createForOfIteratorHelper(l),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _s30 = _step6.value;

              var _l67 = !1;

              var _iterator7 = _createForOfIteratorHelper(c),
                  _step7;

              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var _v11 = _step7.value;

                  var _c25 = (0, _.getMatchingBlockByName)(_v11, _s30.name, m);

                  if (_c25) {
                    _l67 = !0, m.add(_c25.clientId), transformMatchingBlock(_c25, _s30);
                    break;
                  }
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }

              if (!_l67) return;
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          return c;
        };

        s.getPatternTransformedBlocks = getPatternTransformedBlocks;

        var _default = function _default(l, s) {
          return (0, m.useMemo)(function () {
            return l.reduce(function (l, c) {
              var m = getPatternTransformedBlocks(s, c.blocks);
              return m && l.push(_objectSpread(_objectSpread({}, c), {}, {
                transformedBlocks: m
              })), l;
            }, []);
          }, [l, s]);
        };

        s.default = _default;
      },
      1940: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getRetainedBlockAttributes = s.getMatchingBlockByName = void 0;
        var m = c(6700);

        var getMatchingBlockByName = function getMatchingBlockByName(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Set();

          var m = l.clientId,
              v = l.name,
              _l$innerBlocks = l.innerBlocks,
              _ = _l$innerBlocks === void 0 ? [] : _l$innerBlocks;

          if (!c.has(m)) {
            if (v === s) return l;

            var _iterator8 = _createForOfIteratorHelper(_),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _l68 = _step8.value;

                var _m20 = getMatchingBlockByName(_l68, s, c);

                if (_m20) return _m20;
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }
        };

        s.getMatchingBlockByName = getMatchingBlockByName;

        s.getRetainedBlockAttributes = function (l, s) {
          var c = (0, m.__experimentalGetBlockAttributesNamesByRole)(l, "content");
          return null != c && c.length ? c.reduce(function (l, c) {
            return s[c] && (l[c] = s[c]), l;
          }, {}) : s;
        };
      },
      6147: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockTitle(l) {
          var s = l.clientId;

          var _ref114 = (0, _.useSelect)(function (l) {
            if (!s) return {};

            var _l69 = l(E.store),
                c = _l69.getBlockName,
                m = _l69.getBlockAttributes,
                v = _l69.__experimentalGetReusableBlockTitle,
                _ = c(s);

            if (!_) return {};
            var y = (0, k.isReusableBlock)((0, k.getBlockType)(_));
            return {
              attributes: m(s),
              name: _,
              reusableBlockTitle: y && v(m(s).ref)
            };
          }, [s]),
              c = _ref114.attributes,
              m = _ref114.name,
              w = _ref114.reusableBlockTitle,
              C = (0, y.default)(s);

          if (!m || !C) return null;
          var S = (0, k.getBlockType)(m),
              B = S ? (0, k.__experimentalGetBlockLabel)(S, c) : null,
              P = w || B;
          if (P && P !== S.title) return (0, v.truncate)(P, {
            length: 35
          });
          return C.title;
        };

        var v = c(4793),
            _ = c(8467),
            k = c(6700),
            y = m(c(139)),
            E = c(8486);
      },
      6823: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockToolbar(l) {
          var s = l.hideDragHandle;

          var _ref115 = (0, y.useSelect)(function (l) {
            var _l70 = l(R.store),
                s = _l70.getBlockName,
                c = _l70.getBlockMode,
                m = _l70.getSelectedBlockClientIds,
                v = _l70.isBlockValid,
                _ = _l70.getBlockRootClientId,
                k = _l70.getSettings,
                y = m(),
                E = y[0],
                C = _(E),
                S = k();

            return {
              blockClientIds: y,
              blockClientId: E,
              blockType: E && (0, w.getBlockType)(s(E)),
              hasFixedToolbar: S.hasFixedToolbar,
              hasReducedUI: S.hasReducedUI,
              rootClientId: C,
              isValid: y.every(function (l) {
                return v(l);
              }),
              isVisual: y.every(function (l) {
                return "visual" === c(l);
              })
            };
          }, []),
              c = _ref115.blockClientIds,
              m = _ref115.blockClientId,
              A = _ref115.blockType,
              z = _ref115.hasFixedToolbar,
              D = _ref115.hasReducedUI,
              F = _ref115.isValid,
              G = _ref115.isVisual,
              _ref116 = (0, y.useDispatch)(R.store),
              U = _ref116.toggleBlockHighlight,
              W = (0, v.useRef)(),
              _ref117 = (0, V.useShowMoversGestures)({
            ref: W,
            onChange: function onChange(l) {
              l && D || U(m, l);
            }
          }),
              K = _ref117.showMovers,
              $ = _ref117.gestures,
              q = (0, E.useViewportMatch)("medium", "<") || z;

          if (A && !(0, w.hasBlockSupport)(A, "__experimentalToolbar", !0)) return null;
          var Y = q || K;
          if (0 === c.length) return null;
          var Z = F && G,
              X = c.length > 1,
              Q = (0, k.default)("block-editor-block-toolbar", Y && "is-showing-movers");
          return (0, v.createElement)("div", {
            className: Q
          }, !X && !q && (0, v.createElement)(B.default, {
            clientIds: c
          }), (0, v.createElement)("div", (0, _.default)({
            ref: W
          }, $), (Z || X) && (0, v.createElement)(C.ToolbarGroup, {
            className: "block-editor-block-toolbar__block-controls"
          }, (0, v.createElement)(P.default, {
            clientIds: c
          }), (0, v.createElement)(S.default, {
            clientIds: c,
            hideDragHandle: s || D
          }))), Z && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(O.default.Slot, {
            group: "parent",
            className: "block-editor-block-toolbar__slot"
          }), (0, v.createElement)(O.default.Slot, {
            group: "block",
            className: "block-editor-block-toolbar__slot"
          }), (0, v.createElement)(O.default.Slot, {
            className: "block-editor-block-toolbar__slot"
          }), (0, v.createElement)(O.default.Slot, {
            group: "inline",
            className: "block-editor-block-toolbar__slot"
          }), (0, v.createElement)(O.default.Slot, {
            group: "other",
            className: "block-editor-block-toolbar__slot"
          })), (0, v.createElement)(L.default, {
            clientIds: c
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(8467),
            E = c(3200),
            w = c(6700),
            C = c(4892),
            S = m(c(7547)),
            B = m(c(2111)),
            P = m(c(9033)),
            O = m(c(915)),
            L = m(c(4311)),
            V = c(9306),
            R = c(8486);
      },
      9306: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useDebouncedShowMovers = useDebouncedShowMovers, s.useShowMoversGestures = function useShowMoversGestures(l) {
          var s = l.ref,
              _l$debounceTimeout = l.debounceTimeout,
              c = _l$debounceTimeout === void 0 ? y : _l$debounceTimeout,
              _l$onChange2 = l.onChange,
              _ = _l$onChange2 === void 0 ? m.noop : _l$onChange2;

          var _ref118 = (0, v.useState)(!1),
              _ref119 = _slicedToArray(_ref118, 2),
              k = _ref119[0],
              E = _ref119[1],
              _useDebouncedShowMove = useDebouncedShowMovers({
            ref: s,
            debounceTimeout: c,
            isFocused: k,
            onChange: _
          }),
              w = _useDebouncedShowMove.showMovers,
              C = _useDebouncedShowMove.debouncedShowMovers,
              S = _useDebouncedShowMove.debouncedHideMovers,
              B = (0, v.useRef)(!1),
              isFocusedWithin = function isFocusedWithin() {
            return (null == s ? void 0 : s.current) && s.current.contains(s.current.ownerDocument.activeElement);
          };

          return (0, v.useEffect)(function () {
            var l = s.current,
                handleOnFocus = function handleOnFocus() {
              isFocusedWithin() && (E(!0), C());
            },
                handleOnBlur = function handleOnBlur() {
              isFocusedWithin() || (E(!1), S());
            };

            return l && !B.current && (l.addEventListener("focus", handleOnFocus, !0), l.addEventListener("blur", handleOnBlur, !0), B.current = !0), function () {
              l && (l.removeEventListener("focus", handleOnFocus), l.removeEventListener("blur", handleOnBlur));
            };
          }, [s, B, E, C, S]), {
            showMovers: w,
            gestures: {
              onMouseMove: C,
              onMouseLeave: S
            }
          };
        };
        var m = c(4793),
            v = c(1753);
        var _window2 = window,
            _ = _window2.clearTimeout,
            k = _window2.setTimeout,
            y = 200;

        function useDebouncedShowMovers(l) {
          var s = l.ref,
              c = l.isFocused,
              _l$debounceTimeout2 = l.debounceTimeout,
              E = _l$debounceTimeout2 === void 0 ? y : _l$debounceTimeout2,
              _l$onChange3 = l.onChange,
              w = _l$onChange3 === void 0 ? m.noop : _l$onChange3;

          var _ref120 = (0, v.useState)(!1),
              _ref121 = _slicedToArray(_ref120, 2),
              C = _ref121[0],
              S = _ref121[1],
              B = (0, v.useRef)(),
              handleOnChange = function handleOnChange(l) {
            null != s && s.current && S(l), w(l);
          },
              shouldHideMovers = function shouldHideMovers() {
            var l = (null == s ? void 0 : s.current) && s.current.matches(":hover");
            return !c && !l;
          },
              clearTimeoutRef = function clearTimeoutRef() {
            var l = B.current;
            l && _ && _(l);
          };

          return (0, v.useEffect)(function () {
            return function () {
              return clearTimeoutRef();
            };
          }, []), {
            showMovers: C,
            debouncedShowMovers: function debouncedShowMovers(l) {
              l && l.stopPropagation(), clearTimeoutRef(), C || handleOnChange(!0);
            },
            debouncedHideMovers: function debouncedHideMovers(l) {
              l && l.stopPropagation(), clearTimeoutRef(), B.current = k(function () {
                shouldHideMovers() && handleOnChange(!1);
              }, E);
            }
          };
        }
      },
      9017: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockToolsBackCompat(l) {
          var s = l.children;
          var c = (0, v.useContext)(y.InsertionPointOpenRef),
              m = (0, v.useContext)(_.Disabled.Context);
          if (c || m) return s;
          return (0, k.default)('wp.components.Popover.Slot name="block-toolbar"', {
            alternative: "wp.blockEditor.BlockTools"
          }), (0, v.createElement)(y.default, {
            __unstablePopoverSlot: "block-toolbar"
          }, (0, v.createElement)(E.default, {
            __unstablePopoverSlot: "block-toolbar"
          }), s);
        };

        var v = c(1753),
            _ = c(4892),
            k = m(c(3703)),
            y = function _interopRequireWildcard(l, s) {
          if (!s && l && l.__esModule) return l;
          if (null === l || "object" != typeof l && "function" != typeof l) return {
            default: l
          };

          var c = _getRequireWildcardCache(s);

          if (c && c.has(l)) return c.get(l);
          var m = {},
              v = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var _ in l) {
            if ("default" !== _ && Object.prototype.hasOwnProperty.call(l, _)) {
              var k = v ? Object.getOwnPropertyDescriptor(l, _) : null;
              k && (k.get || k.set) ? Object.defineProperty(m, _, k) : m[_] = l[_];
            }
          }

          m.default = l, c && c.set(l, m);
          return m;
        }(c(2638)),
            E = m(c(5714));

        function _getRequireWildcardCache(l) {
          if ("function" != typeof WeakMap) return null;
          var s = new WeakMap(),
              c = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(l) {
            return l ? c : s;
          })(l);
        }
      },
      372: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(6756),
            E = c(6700),
            w = c(8467),
            C = m(c(9375)),
            S = m(c(6823)),
            B = c(8486);

        var P = function BlockContextualToolbar(l) {
          var s = l.focusOnMount,
              c = l.isFixed,
              m = _objectWithoutProperties(l, _excluded10);

          var _ref122 = (0, w.useSelect)(function (l) {
            var _l71 = l(B.store),
                s = _l71.getBlockName,
                c = _l71.getBlockParents,
                m = _l71.getSelectedBlockClientIds,
                _l72 = l(E.store),
                v = _l72.getBlockType,
                _ = m(),
                k = _[0],
                y = c(k),
                w = v(s(y[y.length - 1]));

            return {
              blockType: k && v(s(k)),
              hasParents: y.length,
              showParentSelector: (0, E.hasBlockSupport)(w, "__experimentalParentSelector", !0) && _.length <= 1
            };
          }, []),
              P = _ref122.blockType,
              O = _ref122.hasParents,
              L = _ref122.showParentSelector;

          if (P && !(0, E.hasBlockSupport)(P, "__experimentalToolbar", !0)) return null;
          var V = (0, k.default)("block-editor-block-contextual-toolbar", {
            "has-parent": O && L,
            "is-fixed": c
          });
          return (0, v.createElement)(C.default, (0, _.default)({
            focusOnMount: s,
            className: V,
            "aria-label": (0, y.__)("Block tools")
          }, m), (0, v.createElement)(S.default, {
            hideDragHandle: c
          }));
        };

        s.default = P;
      },
      5714: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function WrappedBlockPopover(l) {
          var s = l.__unstablePopoverSlot,
              c = l.__unstableContentRef;
          var m = (0, w.useSelect)(wrapperSelector, []);
          if (!m) return null;
          var _ = m.clientId,
              k = m.rootClientId,
              y = m.name,
              E = m.isValid,
              C = m.isEmptyDefaultBlock,
              S = m.capturingClientId;
          if (!y) return null;
          return (0, v.createElement)(BlockPopover, {
            clientId: _,
            rootClientId: k,
            isValid: E,
            isEmptyDefaultBlock: C,
            capturingClientId: S,
            __unstablePopoverSlot: s,
            __unstableContentRef: c
          });
        };

        var v = c(1753),
            _ = c(4793),
            k = m(c(2703)),
            y = c(6700),
            E = c(4892),
            w = c(8467),
            C = c(2470),
            S = c(3200),
            B = c(5480),
            P = m(c(9955)),
            O = m(c(372)),
            L = m(c(1517)),
            V = c(8486),
            R = c(8882),
            A = c(2032);

        function selector(l) {
          var _l73 = l(V.store),
              s = _l73.isNavigationMode,
              c = _l73.isMultiSelecting,
              m = _l73.hasMultiSelection,
              v = _l73.isTyping,
              _ = _l73.isCaretWithinFormattedText,
              k = _l73.getSettings,
              y = _l73.getLastMultiSelectedBlockClientId;

          return {
            isNavigationMode: s(),
            isMultiSelecting: c(),
            isTyping: v(),
            isCaretWithinFormattedText: _(),
            hasMultiSelection: m(),
            hasFixedToolbar: k().hasFixedToolbar,
            lastClientId: y()
          };
        }

        function BlockPopover(l) {
          var s = l.clientId,
              c = l.rootClientId,
              m = l.isValid,
              _ = l.isEmptyDefaultBlock,
              y = l.capturingClientId,
              z = l.__unstablePopoverSlot,
              D = l.__unstableContentRef;

          var _ref123 = (0, w.useSelect)(selector, []),
              F = _ref123.isNavigationMode,
              G = _ref123.isMultiSelecting,
              U = _ref123.isTyping,
              W = _ref123.isCaretWithinFormattedText,
              K = _ref123.hasMultiSelection,
              $ = _ref123.hasFixedToolbar,
              q = _ref123.lastClientId,
              Y = (0, w.useSelect)(function (l) {
            var _l74 = l(V.store),
                c = _l74.isBlockInsertionPointVisible,
                m = _l74.getBlockInsertionPoint,
                v = _l74.getBlockOrder;

            if (!c()) return !1;

            var _ = m();

            return v(_.rootClientId)[_.index] === s;
          }, [s]),
              Z = (0, S.useViewportMatch)("medium"),
              _ref124 = (0, v.useState)(!1),
              _ref125 = _slicedToArray(_ref124, 2),
              X = _ref125[0],
              Q = _ref125[1],
              _ref126 = (0, v.useState)(!1),
              _ref127 = _slicedToArray(_ref126, 2),
              J = _ref127[0],
              ee = _ref127[1],
              _ref128 = (0, w.useDispatch)(V.store),
              te = _ref128.stopTyping,
              ne = !U && !F && _ && m,
              oe = F,
              re = !F && !$ && Z && !ne && !G && (!U || W),
              le = !(F || re || $ || _);

          (0, C.useShortcut)("core/block-editor/focus-toolbar", function () {
            Q(!0), te(!0);
          }, {
            isDisabled: !le
          }), (0, v.useEffect)(function () {
            re || Q(!1);
          }, [re]);
          var ie = (0, v.useRef)(),
              ae = (0, R.__unstableUseBlockElement)(s),
              se = (0, R.__unstableUseBlockElement)(q),
              ce = (0, R.__unstableUseBlockElement)(y),
              ue = (0, A.usePopoverScroll)(D);
          if (!(oe || re || X || ne)) return null;
          var de = ae;
          if (!de) return null;
          y && (de = ce);
          var pe = de;

          if (K) {
            if (!se) return null;
            pe = {
              top: de,
              bottom: se
            };
          }

          var me = ne ? "top left right" : "top right left",
              _de = de,
              fe = _de.ownerDocument,
              he = ne ? void 0 : fe.defaultView.frameElement || (0, B.getScrollContainer)(de) || fe.body;
          return (0, v.createElement)(E.Popover, {
            ref: ue,
            noArrow: !0,
            animate: !1,
            position: me,
            focusOnMount: !1,
            anchorRef: pe,
            className: (0, k.default)("block-editor-block-list__block-popover", {
              "is-insertion-point-visible": Y
            }),
            __unstableStickyBoundaryElement: he,
            __unstableSlotName: z || null,
            __unstableBoundaryParent: !0,
            __unstableObserveElement: de,
            shouldAnchorIncludePadding: !0,
            __unstableEditorCanvasWrapper: null == D ? void 0 : D.current
          }, (re || X) && (0, v.createElement)("div", {
            onFocus: function onFocus() {
              ee(!0);
            },
            onBlur: function onBlur() {
              ee(!1);
            },
            tabIndex: -1,
            className: (0, k.default)("block-editor-block-list__block-popover-inserter", {
              "is-visible": J
            })
          }, (0, v.createElement)(L.default, {
            clientId: s,
            rootClientId: c,
            __experimentalIsQuick: !0
          })), (re || X) && (0, v.createElement)(O.default, {
            focusOnMount: X,
            __experimentalInitialIndex: ie.current,
            __experimentalOnIndexChange: function __experimentalOnIndexChange(l) {
              ie.current = l;
            },
            key: s
          }), oe && (0, v.createElement)(P.default, {
            clientId: s,
            rootClientId: c,
            blockElement: de
          }), ne && (0, v.createElement)("div", {
            className: "block-editor-block-list__empty-block-inserter"
          }, (0, v.createElement)(L.default, {
            position: "bottom right",
            rootClientId: c,
            clientId: s,
            __experimentalIsQuick: !0
          })));
        }

        function wrapperSelector(l) {
          var _l75 = l(V.store),
              s = _l75.getSelectedBlockClientId,
              c = _l75.getFirstMultiSelectedBlockClientId,
              m = _l75.getBlockRootClientId,
              v = _l75.getBlock,
              k = _l75.getBlockParents,
              E = _l75.__experimentalGetBlockListSettingsForBlocks,
              w = s() || c();

          if (!w) return;

          var _ref129 = v(w) || {},
              C = _ref129.name,
              _ref129$attributes = _ref129.attributes,
              S = _ref129$attributes === void 0 ? {} : _ref129$attributes,
              B = _ref129.isValid,
              P = k(w),
              O = E(P),
              L = (0, _.find)(P, function (l) {
            var s;
            return null === (s = O[l]) || void 0 === s ? void 0 : s.__experimentalCaptureToolbars;
          });

          return {
            clientId: w,
            rootClientId: m(w),
            name: C,
            isValid: B,
            isEmptyDefaultBlock: C && (0, y.isUnmodifiedDefaultBlock)({
              name: C,
              attributes: S
            }),
            capturingClientId: L
          };
        }
      },
      9955: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(2614),
            E = c(4892),
            w = c(8467),
            C = c(9880),
            S = c(6700),
            B = c(9773),
            P = c(5480),
            O = c(6756),
            L = m(c(6147)),
            V = m(c(2006)),
            R = c(8486),
            A = m(c(566)),
            z = m(c(139));

        var D = function BlockSelectionButton(l) {
          var s = l.clientId,
              c = l.rootClientId,
              m = l.blockElement;

          var D = (0, z.default)(s),
              F = (0, w.useSelect)(function (l) {
            var m;

            var _l76 = l(R.store),
                v = _l76.getBlock,
                _ = _l76.getBlockIndex,
                k = _l76.hasBlockMovingClientId,
                y = _l76.getBlockListSettings,
                E = _(s),
                _v12 = v(s),
                w = _v12.name,
                C = _v12.attributes;

            return {
              index: E,
              name: w,
              attributes: C,
              blockMovingMode: k(),
              orientation: null === (m = y(c)) || void 0 === m ? void 0 : m.orientation
            };
          }, [s, c]),
              G = F.index,
              U = F.name,
              W = F.attributes,
              K = F.blockMovingMode,
              $ = F.orientation,
              _ref130 = (0, w.useDispatch)(R.store),
              q = _ref130.setNavigationMode,
              Y = _ref130.removeBlock,
              Z = (0, v.useRef)(),
              X = (0, S.getBlockType)(U),
              Q = (0, S.__experimentalGetAccessibleBlockLabel)(X, W, G + 1, $);

          (0, v.useEffect)(function () {
            Z.current.focus(), (0, B.speak)(Q);
          }, [Q]);

          var _ref131 = (0, w.useSelect)(R.store),
              J = _ref131.hasBlockMovingClientId,
              ee = _ref131.getBlockIndex,
              te = _ref131.getBlockRootClientId,
              ne = _ref131.getClientIdsOfDescendants,
              oe = _ref131.getSelectedBlockClientId,
              re = _ref131.getMultiSelectedBlocksEndClientId,
              le = _ref131.getPreviousBlockClientId,
              ie = _ref131.getNextBlockClientId,
              ae = _ref131.isNavigationMode,
              _ref132 = (0, w.useDispatch)(R.store),
              se = _ref132.selectBlock,
              ce = _ref132.clearSelectedBlock,
              ue = _ref132.setBlockMovingClientId,
              de = _ref132.moveBlockToPosition,
              pe = (0, k.default)("block-editor-block-list__block-selection-button", {
            "is-block-moving-mode": !!K
          }),
              me = (0, O.__)("Drag");

          return (0, v.createElement)("div", {
            className: pe
          }, (0, v.createElement)(E.Flex, {
            justify: "center",
            className: "block-editor-block-list__block-selection-button__content"
          }, (0, v.createElement)(E.FlexItem, null, (0, v.createElement)(V.default, {
            icon: null == D ? void 0 : D.icon,
            showColors: !0
          })), (0, v.createElement)(E.FlexItem, null, (0, v.createElement)(A.default, {
            clientIds: [s]
          }, function (l) {
            return (0, v.createElement)(E.Button, (0, _.default)({
              icon: y.dragHandle,
              className: "block-selection-button_drag-handle",
              "aria-hidden": "true",
              label: me,
              tabIndex: "-1"
            }, l));
          })), (0, v.createElement)(E.FlexItem, null, (0, v.createElement)(E.Button, {
            ref: Z,
            onClick: function onClick() {
              return q(!1);
            },
            onKeyDown: function onKeyDown(l) {
              var c = l.keyCode,
                  v = c === C.UP,
                  _ = c === C.DOWN,
                  k = c === C.LEFT,
                  y = c === C.RIGHT,
                  E = c === C.TAB,
                  w = c === C.ESCAPE,
                  S = c === C.ENTER,
                  B = c === C.SPACE,
                  O = l.shiftKey;

              if (c === C.BACKSPACE || c === C.DELETE) return Y(s), void l.preventDefault();
              var L = oe(),
                  V = re(),
                  R = le(V || L),
                  A = ie(V || L),
                  z = E && O || v,
                  D = E && !O || _,
                  F = k,
                  G = y;
              var U;
              if (z) U = R;else if (D) U = A;else if (F) {
                var W;
                U = null !== (W = te(L)) && void 0 !== W ? W : L;
              } else if (G) {
                var K;
                U = null !== (K = ne([L])[0]) && void 0 !== K ? K : L;
              }
              var $ = J();

              if (w && ae() && (ce(), l.preventDefault()), w && $ && !l.defaultPrevented && (ue(null), l.preventDefault()), (S || B) && $) {
                var _l77 = te($),
                    _s31 = te(L),
                    _c26 = ee($);

                var _m21 = ee(L);

                _c26 < _m21 && _l77 === _s31 && (_m21 -= 1), de($, _l77, _s31, _m21), se($), ue(null);
              }

              if (D || z || F || G) if (U) l.preventDefault(), se(U);else if (E && L) {
                var _s32;

                D ? (_s32 = P.focus.tabbable.findNext(m), _s32 || (_s32 = m.ownerDocument.defaultView.frameElement, _s32 = P.focus.tabbable.findNext(_s32))) : _s32 = P.focus.tabbable.findPrevious(m), _s32 && (l.preventDefault(), _s32.focus(), ce());
              }
            },
            label: Q,
            className: "block-selection-button_select-button"
          }, (0, v.createElement)(L.default, {
            clientId: s
          })))));
        };

        s.default = D;
      },
      8478: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockTools(l) {
          var s = l.children,
              c = l.__unstableContentRef,
              m = _objectWithoutProperties(l, _excluded11);

          var V = (0, E.useViewportMatch)("medium"),
              R = (0, y.useSelect)(function (l) {
            return l(P.store).getSettings().hasFixedToolbar;
          }, []),
              A = (0, C.__unstableUseShortcutEventMatch)(),
              _ref133 = (0, y.useSelect)(P.store),
              z = _ref133.getSelectedBlockClientIds,
              D = _ref133.getBlockRootClientId,
              _ref134 = (0, y.useDispatch)(P.store),
              F = _ref134.duplicateBlocks,
              G = _ref134.removeBlocks,
              U = _ref134.insertAfterBlock,
              W = _ref134.insertBeforeBlock,
              K = _ref134.clearSelectedBlock,
              $ = _ref134.moveBlocksUp,
              q = _ref134.moveBlocksDown;

          return (0, v.createElement)("div", (0, _.default)({}, m, {
            onKeyDown: function onKeyDown(l) {
              if (A("core/block-editor/move-up", l)) {
                var _s33 = z();

                if (_s33.length) {
                  l.preventDefault();

                  var _c27 = D((0, k.first)(_s33));

                  $(_s33, _c27);
                }
              } else if (A("core/block-editor/move-down", l)) {
                var _s34 = z();

                if (_s34.length) {
                  l.preventDefault();

                  var _c28 = D((0, k.first)(_s34));

                  q(_s34, _c28);
                }
              } else if (A("core/block-editor/duplicate", l)) {
                var _s35 = z();

                _s35.length && (l.preventDefault(), F(_s35));
              } else if (A("core/block-editor/remove", l)) {
                var _s36 = z();

                _s36.length && (l.preventDefault(), G(_s36));
              } else if (A("core/block-editor/insert-after", l)) {
                var _s37 = z();

                _s37.length && (l.preventDefault(), U((0, k.last)(_s37)));
              } else if (A("core/block-editor/insert-before", l)) {
                var _s38 = z();

                _s38.length && (l.preventDefault(), W((0, k.first)(_s38)));
              } else if (A("core/block-editor/delete-multi-selection", l)) {
                if (["INPUT", "TEXTAREA"].includes(l.target.nodeName) || l.defaultPrevented) return;

                var _s39 = z();

                _s39.length > 1 && (l.preventDefault(), G(_s39));
              } else A("core/block-editor/unselect", l) && z().length > 1 && (l.preventDefault(), K(), l.target.ownerDocument.defaultView.getSelection().removeAllRanges());
            }
          }), (0, v.createElement)(S.default, {
            __unstableContentRef: c
          }, (R || !V) && (0, v.createElement)(O.default, {
            isFixed: !0
          }), (0, v.createElement)(B.default, {
            __unstableContentRef: c
          }), (0, v.createElement)(w.Popover.Slot, {
            name: "block-toolbar",
            ref: (0, L.usePopoverScroll)(c)
          }), s, (0, v.createElement)(w.Popover.Slot, {
            name: "__unstable-block-tools-after",
            ref: (0, L.usePopoverScroll)(c)
          })));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = c(8467),
            E = c(3200),
            w = c(4892),
            C = c(2470),
            S = m(c(2638)),
            B = m(c(5714)),
            P = c(8486),
            O = m(c(372)),
            L = c(2032);
      },
      2638: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.InsertionPointOpenRef = void 0, s.default = function InsertionPoint(l) {
          var s = l.children,
              c = l.__unstablePopoverSlot,
              m = l.__unstableContentRef;

          var _ = (0, k.useSelect)(function (l) {
            return l(S.store).isBlockInsertionPointVisible();
          }, []);

          return (0, v.createElement)(O.Provider, {
            value: (0, v.useRef)(!1)
          }, _ && (0, v.createElement)(InsertionPointPopover, {
            __unstablePopoverSlot: c,
            __unstableContentRef: m
          }), s);
        };

        var v = c(1753),
            _ = m(c(2703)),
            k = c(8467),
            y = c(4892),
            E = c(3200),
            w = c(6756),
            C = m(c(1517)),
            S = c(8486),
            B = c(8882),
            P = c(2032);

        var O = (0, v.createContext)();

        function InsertionPointPopover(l) {
          var s = l.__unstablePopoverSlot,
              c = l.__unstableContentRef;

          var _ref135 = (0, k.useDispatch)(S.store),
              m = _ref135.selectBlock,
              L = (0, v.useContext)(O),
              V = (0, v.useRef)(),
              _ref136 = (0, k.useSelect)(function (l) {
            var s;

            var _l78 = l(S.store),
                c = _l78.getBlockOrder,
                m = _l78.getBlockListSettings,
                v = _l78.getBlockInsertionPoint,
                _ = _l78.isBlockBeingDragged,
                k = _l78.getPreviousBlockClientId,
                y = _l78.getNextBlockClientId,
                E = v(),
                w = c(E.rootClientId);

            if (!w.length) return {};
            var C = w[E.index - 1],
                B = w[E.index];

            for (; _(C);) {
              C = k(C);
            }

            for (; _(B);) {
              B = y(B);
            }

            return {
              previousClientId: C,
              nextClientId: B,
              orientation: (null === (s = m(E.rootClientId)) || void 0 === s ? void 0 : s.orientation) || "vertical",
              rootClientId: E.rootClientId,
              isInserterShown: null == E ? void 0 : E.__unstableWithInserter
            };
          }, []),
              R = _ref136.orientation,
              A = _ref136.previousClientId,
              z = _ref136.nextClientId,
              D = _ref136.rootClientId,
              F = _ref136.isInserterShown,
              G = (0, B.__unstableUseBlockElement)(A),
              U = (0, B.__unstableUseBlockElement)(z),
              W = "vertical" === R,
              K = (0, v.useMemo)(function () {
            if (!G && !U) return {};
            var l = G ? G.getBoundingClientRect() : null,
                s = U ? U.getBoundingClientRect() : null;
            if (W) return {
              width: G ? G.offsetWidth : U.offsetWidth,
              height: s && l ? s.top - l.bottom : 0
            };
            var c = 0;
            return l && s && (c = (0, w.isRTL)() ? l.left - s.right : s.left - l.right), {
              width: c,
              height: G ? G.offsetHeight : U.offsetHeight
            };
          }, [G, U]),
              $ = (0, v.useCallback)(function () {
            if (!G && !U) return {};

            var _ref137 = G || U,
                l = _ref137.ownerDocument,
                s = G ? G.getBoundingClientRect() : null,
                c = U ? U.getBoundingClientRect() : null;

            return W ? (0, w.isRTL)() ? {
              top: s ? s.bottom : c.top,
              left: s ? s.right : c.right,
              right: s ? s.left : c.left,
              bottom: c ? c.top : s.bottom,
              ownerDocument: l
            } : {
              top: s ? s.bottom : c.top,
              left: s ? s.left : c.left,
              right: s ? s.right : c.right,
              bottom: c ? c.top : s.bottom,
              ownerDocument: l
            } : (0, w.isRTL)() ? {
              top: s ? s.top : c.top,
              left: s ? s.left : c.right,
              right: c ? c.right : s.left,
              bottom: s ? s.bottom : c.bottom,
              ownerDocument: l
            } : {
              top: s ? s.top : c.top,
              left: s ? s.right : c.left,
              right: c ? c.left : s.right,
              bottom: s ? s.bottom : c.bottom,
              ownerDocument: l
            };
          }, [G, U]),
              q = (0, P.usePopoverScroll)(c),
              Y = (0, E.useReducedMotion)(),
              Z = (0, _.default)("block-editor-block-list__insertion-point", "is-" + R);

          var X = G && U && F,
              Q = {
            start: _objectSpread(_objectSpread({}, W ? {
              height: 0,
              left: "50%",
              right: "50%",
              y: 0
            } : {
              width: 0,
              top: "50%",
              bottom: "50%",
              x: 0
            }), {}, {
              opacity: 0
            }),
            rest: _objectSpread(_objectSpread({}, W ? {
              height: 4,
              left: 0,
              right: 0,
              y: -2
            } : {
              width: 4,
              top: 0,
              bottom: 0,
              x: -2
            }), {}, {
              opacity: 1,
              borderRadius: "2px",
              transition: {
                delay: X ? .4 : 0
              }
            }),
            hover: _objectSpread(_objectSpread({}, W ? {
              height: 4,
              left: 0,
              right: 0,
              y: -2
            } : {
              width: 4,
              top: 0,
              bottom: 0,
              x: -2
            }), {}, {
              opacity: 1,
              borderRadius: "2px",
              transition: {
                delay: .4
              }
            })
          },
              J = {
            start: {
              scale: Y ? 1 : 0
            },
            rest: {
              scale: 1,
              transition: {
                delay: .2
              }
            }
          };
          return (0, v.createElement)(y.Popover, {
            ref: q,
            noArrow: !0,
            animate: !1,
            getAnchorRect: $,
            focusOnMount: !1,
            className: "block-editor-block-list__insertion-point-popover",
            __unstableSlotName: s || null,
            key: z + "--" + D
          }, (0, v.createElement)(y.__unstableMotion.div, {
            layout: !Y,
            initial: Y ? "rest" : "start",
            animate: "rest",
            whileHover: "hover",
            whileTap: "pressed",
            exit: "start",
            ref: V,
            tabIndex: -1,
            onClick: function onClick(l) {
              l.target === V.current && z && m(z, -1);
            },
            onFocus: function onFocus(l) {
              l.target !== V.current && (L.current = !0);
            },
            className: (0, _.default)(Z, {
              "is-with-inserter": X
            }),
            style: K
          }, (0, v.createElement)(y.__unstableMotion.div, {
            variants: Q,
            className: "block-editor-block-list__insertion-point-indicator"
          }), X && (0, v.createElement)(y.__unstableMotion.div, {
            variants: J,
            className: (0, _.default)("block-editor-block-list__insertion-point-inserter")
          }, (0, v.createElement)(C.default, {
            position: "bottom center",
            clientId: z,
            rootClientId: D,
            __experimentalIsQuick: !0,
            onToggle: function onToggle(l) {
              L.current = l;
            },
            onSelectOrClose: function onSelectOrClose() {
              L.current = !1;
            }
          }))));
        }

        s.InsertionPointOpenRef = O;
      },
      2032: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.usePopoverScroll = function usePopoverScroll(l) {
          return (0, m.useRefEffect)(function (s) {
            if (!l) return;

            function onWheel(s) {
              var c = s.deltaX,
                  m = s.deltaY;
              l.current.scrollBy(c, m);
            }

            var c = {
              passive: !0
            };
            return s.addEventListener("wheel", onWheel, c), function () {
              s.removeEventListener("wheel", onWheel, c);
            };
          }, [l]);
        };
        var m = c(3200);
      },
      2706: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(6700),
            k = m(c(4983)),
            y = c(9776);

        var E = function BlockTypesList(l) {
          var _l$items = l.items,
              s = _l$items === void 0 ? [] : _l$items,
              c = l.onSelect,
              _l$onHover = l.onHover,
              m = _l$onHover === void 0 ? function () {} : _l$onHover,
              E = l.children,
              w = l.label,
              _l$isDraggable = l.isDraggable,
              C = _l$isDraggable === void 0 ? !0 : _l$isDraggable;
          return (0, v.createElement)(y.InserterListboxGroup, {
            className: "block-editor-block-types-list",
            "aria-label": w
          }, function chunk(l, s) {
            var c = [];

            for (var _m22 = 0, _v13 = l.length; _m22 < _v13; _m22 += s) {
              c.push(l.slice(_m22, _m22 + s));
            }

            return c;
          }(s, 3).map(function (l, s) {
            return (0, v.createElement)(y.InserterListboxRow, {
              key: s
            }, l.map(function (l, y) {
              return (0, v.createElement)(k.default, {
                key: l.id,
                item: l,
                className: (0, _.getBlockMenuDefaultClassName)(l.id),
                onSelect: c,
                onHover: m,
                isDraggable: C,
                isFirst: 0 === s && 0 === y
              });
            }));
          }), E);
        };

        s.default = E;
      },
      3562: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(6756),
            y = c(4892),
            E = c(2614);

        var w = function BlockVariationPicker(l) {
          var _l$icon = l.icon,
              s = _l$icon === void 0 ? E.layout : _l$icon,
              _l$label5 = l.label,
              c = _l$label5 === void 0 ? (0, k.__)("Choose variation") : _l$label5,
              _l$instructions = l.instructions,
              m = _l$instructions === void 0 ? (0, k.__)("Select a variation to start with.") : _l$instructions,
              w = l.variations,
              C = l.onSelect,
              S = l.allowSkip;
          var B = (0, _.default)("block-editor-block-variation-picker", {
            "has-many-variations": w.length > 4
          });
          return (0, v.createElement)(y.Placeholder, {
            icon: s,
            label: c,
            instructions: m,
            className: B
          }, (0, v.createElement)("ul", {
            className: "block-editor-block-variation-picker__variations",
            role: "list",
            "aria-label": (0, k.__)("Block variations")
          }, w.map(function (l) {
            return (0, v.createElement)("li", {
              key: l.name
            }, (0, v.createElement)(y.Button, {
              variant: "secondary",
              icon: l.icon,
              iconSize: 48,
              onClick: function onClick() {
                return C(l);
              },
              className: "block-editor-block-variation-picker__variation",
              label: l.description || l.title
            }), (0, v.createElement)("span", {
              className: "block-editor-block-variation-picker__variation-label",
              role: "presentation"
            }, l.title));
          })), S && (0, v.createElement)("div", {
            className: "block-editor-block-variation-picker__skip"
          }, (0, v.createElement)(y.Button, {
            variant: "link",
            onClick: function onClick() {
              return C();
            }
          }, (0, k.__)("Skip"))));
        };

        s.default = w;
      },
      5045: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6700),
            _ = c(6756),
            k = c(4892),
            y = c(8467),
            E = c(2614),
            w = c(1686),
            C = c(8486);

        var S = function __experimentalBlockVariationTransforms(l) {
          var s = l.blockClientId;

          var _ref138 = (0, m.useState)(),
              _ref139 = _slicedToArray(_ref138, 2),
              c = _ref139[0],
              S = _ref139[1],
              _ref140 = (0, y.useDispatch)(C.store),
              B = _ref140.updateBlockAttributes,
              _ref141 = (0, y.useSelect)(function (l) {
            var _l79 = l(v.store),
                c = _l79.getBlockVariations,
                _l80 = l(C.store),
                m = _l80.getBlockName,
                _ = _l80.getBlockAttributes,
                k = s && m(s);

            return {
              variations: k && c(k, "transform"),
              blockAttributes: _(s)
            };
          }, [s]),
              P = _ref141.variations,
              O = _ref141.blockAttributes;

          if ((0, m.useEffect)(function () {
            var l;
            S(null === (l = (0, w.__experimentalGetMatchingVariation)(O, P)) || void 0 === l ? void 0 : l.name);
          }, [O, P]), null == P || !P.length) return null;

          var L = P.map(function (l) {
            var s = l.name,
                c = l.title,
                m = l.description;
            return {
              value: s,
              label: c,
              info: m
            };
          }),
              onSelectVariation = function onSelectVariation(l) {
            B(s, _objectSpread({}, P.find(function (s) {
              var c = s.name;
              return c === l;
            }).attributes));
          },
              V = "block-editor-block-variation-transforms";

          return (0, m.createElement)(k.DropdownMenu, {
            className: V,
            label: (0, _.__)("Transform to variation"),
            text: (0, _.__)("Transform to variation"),
            popoverProps: {
              position: "bottom center",
              className: "".concat(V, "__popover")
            },
            icon: E.chevronDown,
            toggleProps: {
              iconPosition: "right"
            }
          }, function () {
            return (0, m.createElement)("div", {
              className: "".concat(V, "__container")
            }, (0, m.createElement)(k.MenuGroup, null, (0, m.createElement)(k.MenuItemsChoice, {
              choices: L,
              value: c,
              onSelect: onSelectVariation
            })));
          });
        };

        s.default = S;
      },
      6838: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.alignTop = s.alignCenter = s.alignBottom = void 0;
        var m = c(1753),
            v = c(4892);

        var _ = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Path, {
          d: "M15 4H9v11h6V4zM4 18.5V20h16v-1.5H4z"
        }));

        s.alignBottom = _;
        var k = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Path, {
          d: "M20 11h-5V4H9v7H4v1.5h5V20h6v-7.5h5z"
        }));
        s.alignCenter = k;
        var y = (0, m.createElement)(v.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(v.Path, {
          d: "M9 20h6V9H9v11zM4 4v1.5h16V4H4z"
        }));
        s.alignTop = y;
      },
      4981: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockVerticalAlignmentControl = function BlockVerticalAlignmentControl(l) {
          return (0, v.createElement)(k.default, (0, _.default)({}, l, {
            isToolbar: !1
          }));
        }, s.BlockVerticalAlignmentToolbar = function BlockVerticalAlignmentToolbar(l) {
          return (0, v.createElement)(k.default, (0, _.default)({}, l, {
            isToolbar: !0
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(6956));
      },
      6956: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(6756),
            y = c(4892),
            E = c(6838);

        var w = {
          top: {
            icon: E.alignTop,
            title: (0, k._x)("Align top", "Block vertical alignment setting")
          },
          center: {
            icon: E.alignCenter,
            title: (0, k._x)("Align middle", "Block vertical alignment setting")
          },
          bottom: {
            icon: E.alignBottom,
            title: (0, k._x)("Align bottom", "Block vertical alignment setting")
          }
        },
            C = ["top", "center", "bottom"],
            S = {
          isAlternate: !0
        };

        var B = function BlockVerticalAlignmentUI(l) {
          var s = l.value,
              c = l.onChange,
              _l$controls = l.controls,
              m = _l$controls === void 0 ? C : _l$controls,
              _l$isCollapsed3 = l.isCollapsed,
              E = _l$isCollapsed3 === void 0 ? !0 : _l$isCollapsed3,
              B = l.isToolbar;
          var P = w[s],
              O = w.top,
              L = B ? y.ToolbarGroup : y.ToolbarDropdownMenu,
              V = B ? {
            isCollapsed: E
          } : {};
          return (0, v.createElement)(L, (0, _.default)({
            popoverProps: S,
            icon: P ? P.icon : O.icon,
            label: (0, k._x)("Change vertical alignment", "Block vertical alignment setting label"),
            controls: m.map(function (l) {
              return _objectSpread(_objectSpread({}, w[l]), {}, {
                isActive: s === l,
                role: E ? "menuitemradio" : void 0,
                onClick: (m = l, function () {
                  return c(s === m ? void 0 : m);
                })
              });
              var m;
            })
          }, V));
        };

        s.default = B;
      },
      3591: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function AllInputControl(l) {
          var s = l.onChange,
              c = l.values,
              m = _objectWithoutProperties(l, _excluded12);

          var w = (0, E.getAllValue)(c),
              C = (0, E.hasDefinedValues)(c) && (0, E.hasMixedValues)(c),
              S = C ? (0, y.__)("Mixed") : null;
          return (0, v.createElement)(k.__experimentalUnitControl, (0, _.default)({}, m, {
            "aria-label": (0, y.__)("Border radius"),
            disableUnits: C,
            isOnly: !0,
            value: w,
            onChange: s,
            placeholder: S
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = c(6756),
            E = c(4673);
      },
      2398: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BorderRadiusControl(l) {
          var s = l.onChange,
              c = l.values;

          var _ref142 = (0, v.useState)(!(0, S.hasDefinedValues)(c) || !(0, S.hasMixedValues)(c)),
              _ref143 = _slicedToArray(_ref142, 2),
              m = _ref143[0],
              O = _ref143[1],
              L = (0, _.__experimentalUseCustomUnits)({
            availableUnits: (0, C.default)("spacing.units") || ["px", "em", "rem"]
          }),
              V = (0, S.getAllUnit)(c),
              R = L && L.find(function (l) {
            return l.value === V;
          }),
              A = (null == R ? void 0 : R.step) || 1,
              _ref144 = (0, _.__experimentalParseUnit)((0, S.getAllValue)(c)),
              _ref145 = _slicedToArray(_ref144, 1),
              z = _ref145[0];

          return (0, v.createElement)("fieldset", {
            className: "components-border-radius-control"
          }, (0, v.createElement)("legend", null, (0, k.__)("Radius")), (0, v.createElement)("div", {
            className: "components-border-radius-control__wrapper"
          }, m ? (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.default, {
            className: "components-border-radius-control__unit-control",
            values: c,
            min: 0,
            onChange: s,
            unit: V,
            units: L
          }), (0, v.createElement)(_.RangeControl, {
            className: "components-border-radius-control__range-control",
            value: z,
            min: 0,
            max: P[V],
            initialPosition: 0,
            withInputField: !1,
            onChange: function onChange(l) {
              s(void 0 !== l ? "".concat(l).concat(V) : void 0);
            },
            step: A
          })) : (0, v.createElement)(E.default, {
            min: 0,
            onChange: s,
            values: c || B,
            units: L
          }), (0, v.createElement)(w.default, {
            onClick: function onClick() {
              return O(!m);
            },
            isLinked: m
          })));
        };

        var v = c(1753),
            _ = c(4892),
            k = c(6756),
            y = m(c(3591)),
            E = m(c(5686)),
            w = m(c(4301)),
            C = m(c(3081)),
            S = c(4673);

        var B = {
          topLeft: null,
          topRight: null,
          bottomLeft: null,
          bottomRight: null
        },
            P = {
          px: 100,
          em: 20,
          rem: 20
        };
      },
      5686: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BoxInputControls(l) {
          var s = l.onChange,
              c = l.values,
              m = _objectWithoutProperties(l, _excluded13);

          var y = "string" != typeof c ? c : {
            topLeft: c,
            topRight: c,
            bottomLeft: c,
            bottomRight: c
          };
          return (0, v.createElement)("div", {
            className: "components-border-radius-control__input-controls-wrapper"
          }, Object.entries(E).map(function (l) {
            var _l81 = _slicedToArray(l, 2),
                c = _l81[0],
                E = _l81[1];

            return (0, v.createElement)(k.__experimentalUnitControl, (0, _.default)({}, m, {
              key: c,
              "aria-label": E,
              value: y[c],
              onChange: (w = c, function (l) {
                s && s(_objectSpread(_objectSpread({}, y), {}, _defineProperty({}, w, l || void 0)));
              })
            }));
            var w;
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = c(6756);

        var E = {
          topLeft: (0, y.__)("Top left"),
          topRight: (0, y.__)("Top right"),
          bottomLeft: (0, y.__)("Bottom left"),
          bottomRight: (0, y.__)("Bottom right")
        };
      },
      4301: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LinkedButton(l) {
          var s = l.isLinked,
              c = _objectWithoutProperties(l, _excluded14);

          var m = s ? (0, E.__)("Unlink Radii") : (0, E.__)("Link Radii");
          return (0, v.createElement)(k.Tooltip, {
            text: m
          }, (0, v.createElement)(k.Button, (0, _.default)({}, c, {
            className: "component-border-radius-control__linked-button",
            isPrimary: s,
            isSecondary: !s,
            isSmall: !0,
            icon: s ? y.link : y.linkOff,
            iconSize: 16,
            "aria-label": m
          })));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = c(2614),
            E = c(6756);
      },
      4673: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getAllUnit = function getAllUnit() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};

          if ("string" == typeof l) {
            var _ref146 = (0, m.__experimentalParseUnit)(l),
                _ref147 = _slicedToArray(_ref146, 2),
                _s40 = _ref147[1];

            return _s40 || "px";
          }

          var s = Object.values(l).map(function (l) {
            var _ref148 = (0, m.__experimentalParseUnit)(l),
                _ref149 = _slicedToArray(_ref148, 2),
                s = _ref149[1];

            return s;
          });
          return mode(s) || "px";
        }, s.getAllValue = getAllValue, s.hasDefinedValues = function hasDefinedValues(l) {
          if (!l) return !1;
          if ("string" == typeof l) return !0;
          return !!Object.values(l).filter(function (l) {
            return !!l || 0 === l;
          }).length;
        }, s.hasMixedValues = function hasMixedValues() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          var s = getAllValue(l),
              c = isNaN(parseFloat(s));
          return c;
        }, s.mode = mode;
        var m = c(4892);

        function mode(l) {
          return _toConsumableArray(l).sort(function (s, c) {
            return l.filter(function (l) {
              return l === c;
            }).length - l.filter(function (l) {
              return l === s;
            }).length;
          }).shift();
        }

        function getAllValue() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          if ("string" == typeof l) return l;

          var s = Object.values(l).map(function (l) {
            return (0, m.__experimentalParseUnit)(l);
          }),
              c = s.map(function (l) {
            return l[0];
          }),
              v = s.map(function (l) {
            return l[1];
          }),
              _ = c.every(function (l) {
            return l === c[0];
          }) ? c[0] : "",
              k = mode(v),
              y = 0 === _ || _ ? "".concat(_).concat(k) : null;

          return y;
        }
      },
      4495: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BorderStyleControl(l) {
          var s = l.onChange,
              c = l.value;
          return (0, m.createElement)("fieldset", {
            className: "components-border-style-control"
          }, (0, m.createElement)("legend", null, (0, _.__)("Style")), (0, m.createElement)("div", {
            className: "components-border-style-control__buttons"
          }, y.map(function (l) {
            return (0, m.createElement)(v.Button, {
              key: l.value,
              icon: l.icon,
              isSmall: !0,
              isPressed: l.value === c,
              onClick: function onClick() {
                return s(l.value === c ? void 0 : l.value);
              },
              "aria-label": l.label
            });
          })));
        };

        var m = c(1753),
            v = c(4892),
            _ = c(6756),
            k = c(2614);

        var y = [{
          label: (0, _.__)("Solid"),
          icon: k.lineSolid,
          value: "solid"
        }, {
          label: (0, _.__)("Dashed"),
          icon: k.lineDashed,
          value: "dashed"
        }, {
          label: (0, _.__)("Dotted"),
          icon: k.lineDotted,
          value: "dotted"
        }];
      },
      6403: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.ButtonBlockerAppender = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(4892),
            y = c(6756),
            E = c(2614),
            w = m(c(3703)),
            C = m(c(1517));

        function ButtonBlockAppender(l, s) {
          var c = l.rootClientId,
              m = l.className,
              w = l.onFocus,
              S = l.tabIndex;
          return (0, v.createElement)(C.default, {
            position: "bottom center",
            rootClientId: c,
            __experimentalIsQuick: !0,
            renderToggle: function renderToggle(l) {
              var c,
                  C = l.onToggle,
                  B = l.disabled,
                  P = l.isOpen,
                  O = l.blockTitle,
                  L = l.hasSingleBlockType;
              c = L ? (0, y.sprintf)((0, y._x)("Add %s", "directly add the only allowed block"), O) : (0, y._x)("Add block", "Generic label for block inserter button");
              var V = !L;
              var R = (0, v.createElement)(k.Button, {
                ref: s,
                onFocus: w,
                tabIndex: S,
                className: (0, _.default)(m, "block-editor-button-block-appender"),
                onClick: C,
                "aria-haspopup": V ? "true" : void 0,
                "aria-expanded": V ? P : void 0,
                disabled: B,
                label: c
              }, !L && (0, v.createElement)(k.VisuallyHidden, {
                as: "span"
              }, c), (0, v.createElement)(E.Icon, {
                icon: E.plus
              }));
              return (V || L) && (R = (0, v.createElement)(k.Tooltip, {
                text: c
              }, R)), R;
            },
            isAppender: !0
          });
        }

        var S = (0, v.forwardRef)(function (l, s) {
          return (0, w.default)("wp.blockEditor.ButtonBlockerAppender", {
            alternative: "wp.blockEditor.ButtonBlockAppender"
          }), ButtonBlockAppender(l, s);
        });
        s.ButtonBlockerAppender = S;
        var B = (0, v.forwardRef)(ButtonBlockAppender);
        s.default = B;
      },
      206: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ColorPaletteControl(l) {
          var s = l.onChange,
              c = l.value,
              m = _objectWithoutProperties(l, _excluded15);

          return (0, v.createElement)(k.default, (0, _.default)({}, m, {
            onColorChange: s,
            colorValue: c,
            gradients: [],
            disableCustomGradients: !0
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(91));
      },
      3391: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(4892),
            _ = (0, m(c(9452)).default)(v.ColorPalette);

        s.default = _;
      },
      9452: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = c(3200),
            E = m(c(3081)),
            w = (0, y.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c = (0, E.default)("color.palette"),
                m = !(0, E.default)("color.custom"),
                y = void 0 === s.colors ? c : s.colors,
                w = void 0 === s.disableCustomColors ? m : s.disableCustomColors,
                C = !(0, k.isEmpty)(y) || !w;
            return (0, v.createElement)(l, (0, _.default)({}, s, {
              colors: y,
              disableCustomColors: w,
              hasColorsToChoose: C
            }));
          };
        }, "withColorContext");

        s.default = w;
      },
      1937: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(4892),
            _ = c(6756),
            k = c(9880);

        var ColorSelectorSVGIcon = function ColorSelectorSVGIcon() {
          return (0, m.createElement)(v.SVG, {
            xmlns: "https://www.w3.org/2000/svg",
            viewBox: "0 0 20 20"
          }, (0, m.createElement)(v.Path, {
            d: "M7.434 5l3.18 9.16H8.538l-.692-2.184H4.628l-.705 2.184H2L5.18 5h2.254zm-1.13 1.904h-.115l-1.148 3.593H7.44L6.304 6.904zM14.348 7.006c1.853 0 2.9.876 2.9 2.374v4.78h-1.79v-.914h-.114c-.362.64-1.123 1.022-2.031 1.022-1.346 0-2.292-.826-2.292-2.108 0-1.27.972-2.006 2.71-2.107l1.696-.102V9.38c0-.584-.42-.914-1.18-.914-.667 0-1.112.228-1.264.647h-1.701c.12-1.295 1.307-2.107 3.066-2.107zm1.079 4.1l-1.416.09c-.793.056-1.18.342-1.18.844 0 .52.45.837 1.091.837.857 0 1.505-.545 1.505-1.256v-.515z"
          }));
        },
            ColorSelectorIcon = function ColorSelectorIcon(l) {
          var s = l.style,
              c = l.className;
          return (0, m.createElement)("div", {
            className: "block-library-colors-selector__icon-container"
          }, (0, m.createElement)("div", {
            className: "".concat(c, " block-library-colors-selector__state-selection"),
            style: s
          }, (0, m.createElement)(ColorSelectorSVGIcon, null)));
        },
            renderToggleComponent = function renderToggleComponent(l) {
          var s = l.TextColor,
              c = l.BackgroundColor;
          return function (l) {
            var y = l.onToggle,
                E = l.isOpen;
            return (0, m.createElement)(v.ToolbarGroup, null, (0, m.createElement)(v.ToolbarButton, {
              className: "components-toolbar__control block-library-colors-selector__toggle",
              label: (0, _.__)("Open Colors Selector"),
              onClick: y,
              onKeyDown: function onKeyDown(l) {
                E || l.keyCode !== k.DOWN || (l.preventDefault(), y());
              },
              icon: (0, m.createElement)(c, null, (0, m.createElement)(s, null, (0, m.createElement)(ColorSelectorIcon, null)))
            }));
          };
        };

        var _default = function _default(l) {
          var s = l.children,
              c = _objectWithoutProperties(l, _excluded16);

          return (0, m.createElement)(v.Dropdown, {
            position: "bottom right",
            className: "block-library-colors-selector",
            contentClassName: "block-library-colors-selector__popover",
            renderToggle: renderToggleComponent(c),
            renderContent: function renderContent() {
              return s;
            }
          });
        };

        s.default = _default;
      },
      91: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(4793),
            E = c(4892),
            w = c(6756),
            C = m(c(3081));

        var S = ["colors", "disableCustomColors", "gradients", "disableCustomGradients"];

        function ColorGradientControlInner(l) {
          var s = l.colors,
              c = l.gradients,
              m = l.disableCustomColors,
              _ = l.disableCustomGradients,
              C = l.__experimentalHasMultipleOrigins,
              S = l.__experimentalIsRenderedInSidebar,
              B = l.className,
              P = l.label,
              O = l.onColorChange,
              L = l.onGradientChange,
              V = l.colorValue,
              R = l.gradientValue,
              A = l.clearable,
              _l$showTitle = l.showTitle,
              z = _l$showTitle === void 0 ? !0 : _l$showTitle,
              D = l.enableAlpha;

          var F = O && (!(0, y.isEmpty)(s) || !m),
              G = L && (!(0, y.isEmpty)(c) || !_),
              _ref150 = (0, v.useState)(R ? "gradient" : !!F && "color"),
              _ref151 = _slicedToArray(_ref150, 2),
              U = _ref151[0],
              W = _ref151[1];

          return F || G ? (0, v.createElement)(E.BaseControl, {
            className: (0, k.default)("block-editor-color-gradient-control", B)
          }, (0, v.createElement)("fieldset", null, (0, v.createElement)(E.__experimentalVStack, {
            spacing: 1
          }, z && (0, v.createElement)("legend", null, (0, v.createElement)("div", {
            className: "block-editor-color-gradient-control__color-indicator"
          }, (0, v.createElement)(E.BaseControl.VisualLabel, null, P))), F && G && (0, v.createElement)(E.__experimentalToggleGroupControl, {
            value: U,
            onChange: W,
            label: (0, w.__)("Select color type"),
            hideLabelFromVision: !0,
            isBlock: !0
          }, (0, v.createElement)(E.__experimentalToggleGroupControlOption, {
            value: "color",
            label: (0, w.__)("Solid")
          }), (0, v.createElement)(E.__experimentalToggleGroupControlOption, {
            value: "gradient",
            label: (0, w.__)("Gradient")
          })), ("color" === U || !G) && (0, v.createElement)(E.ColorPalette, {
            value: V,
            onChange: G ? function (l) {
              O(l), L();
            } : O,
            colors: s,
            disableCustomColors: m,
            __experimentalHasMultipleOrigins: C,
            __experimentalIsRenderedInSidebar: S,
            clearable: A,
            enableAlpha: D
          }), ("gradient" === U || !F) && (0, v.createElement)(E.GradientPicker, {
            value: R,
            onChange: F ? function (l) {
              L(l), O();
            } : L,
            gradients: c,
            disableCustomGradients: _,
            __experimentalHasMultipleOrigins: C,
            __experimentalIsRenderedInSidebar: S,
            clearable: A
          })))) : null;
        }

        function ColorGradientControlSelect(l) {
          var s = {};
          return s.colors = (0, C.default)("color.palette"), s.gradients = (0, C.default)("color.gradients"), s.disableCustomColors = !(0, C.default)("color.custom"), s.disableCustomGradients = !(0, C.default)("color.customGradient"), (0, v.createElement)(ColorGradientControlInner, (0, _.default)({}, s, l));
        }

        var B = function ColorGradientControl(l) {
          return (0, y.every)(S, function (s) {
            return l.hasOwnProperty(s);
          }) ? (0, v.createElement)(ColorGradientControlInner, l) : (0, v.createElement)(ColorGradientControlSelect, l);
        };

        s.default = B;
      },
      8251: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.PanelColorGradientSettingsInner = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(4793),
            E = c(4892),
            w = c(6756),
            C = m(c(91)),
            S = c(4459),
            B = c(5261),
            P = m(c(3081)),
            O = m(c(4916)),
            L = m(c(26));

        var V = (0, w.__)("(%s: color %s)"),
            R = (0, w.__)("(%s: gradient %s)"),
            A = ["colors", "disableCustomColors", "gradients", "disableCustomGradients"],
            Indicators = function Indicators(l) {
          var s = l.colors,
              c = l.gradients,
              m = l.settings;
          return m.map(function (l, m) {
            var _,
                k = l.colorValue,
                y = l.gradientValue,
                C = l.label,
                P = l.colors,
                O = l.gradients;

            if (!k && !y) return null;

            if (k) {
              var _l82 = (0, S.getColorObjectByColorValue)(P || s, k);

              _ = (0, w.sprintf)(V, C.toLowerCase(), _l82 && _l82.name || k);
            } else {
              var _l83 = (0, B.__experimentalGetGradientObjectByGradientValue)(O || c, k);

              _ = (0, w.sprintf)(R, C.toLowerCase(), _l83 && _l83.name || y);
            }

            return (0, v.createElement)(E.ColorIndicator, {
              key: m,
              colorValue: k || y,
              "aria-label": _
            });
          });
        },
            PanelColorGradientSettingsInner = function PanelColorGradientSettingsInner(l) {
          var s = l.className,
              c = l.colors,
              m = l.gradients,
              w = l.disableCustomColors,
              S = l.disableCustomGradients,
              B = l.children,
              P = l.settings,
              O = l.title,
              _l$showTitle2 = l.showTitle,
              L = _l$showTitle2 === void 0 ? !0 : _l$showTitle2,
              V = l.__experimentalHasMultipleOrigins,
              R = l.__experimentalIsRenderedInSidebar,
              A = l.enableAlpha,
              z = _objectWithoutProperties(l, _excluded17);

          if ((0, y.isEmpty)(c) && (0, y.isEmpty)(m) && w && S && (0, y.every)(P, function (l) {
            return (0, y.isEmpty)(l.colors) && (0, y.isEmpty)(l.gradients) && (void 0 === l.disableCustomColors || l.disableCustomColors) && (void 0 === l.disableCustomGradients || l.disableCustomGradients);
          })) return null;
          var D = (0, v.createElement)("span", {
            className: "block-editor-panel-color-gradient-settings__panel-title"
          }, O, (0, v.createElement)(Indicators, {
            colors: c,
            gradients: m,
            settings: P
          }));
          return (0, v.createElement)(E.PanelBody, (0, _.default)({
            className: (0, k.default)("block-editor-panel-color-gradient-settings", s),
            title: L ? D : void 0
          }, z), P.map(function (l, s) {
            return (0, v.createElement)(C.default, (0, _.default)({
              showTitle: L,
              key: s,
              colors: c,
              gradients: m,
              disableCustomColors: w,
              disableCustomGradients: S,
              __experimentalHasMultipleOrigins: V,
              __experimentalIsRenderedInSidebar: R,
              enableAlpha: A
            }, l));
          }), B);
        };

        s.PanelColorGradientSettingsInner = PanelColorGradientSettingsInner;

        var PanelColorGradientSettingsSingleSelect = function PanelColorGradientSettingsSingleSelect(l) {
          var s = (0, O.default)();
          return s.colors = (0, P.default)("color.palette"), s.gradients = (0, P.default)("color.gradients"), (0, v.createElement)(PanelColorGradientSettingsInner, (0, _.default)({}, s, l));
        },
            PanelColorGradientSettingsMultipleSelect = function PanelColorGradientSettingsMultipleSelect(l) {
          var s = (0, L.default)();
          return (0, v.createElement)(PanelColorGradientSettingsInner, (0, _.default)({}, s, l));
        };

        var _default = function _default(l) {
          return (0, y.every)(A, function (s) {
            return l.hasOwnProperty(s);
          }) ? (0, v.createElement)(PanelColorGradientSettingsInner, l) : l.__experimentalHasMultipleOrigins ? (0, v.createElement)(PanelColorGradientSettingsMultipleSelect, l) : (0, v.createElement)(PanelColorGradientSettingsSingleSelect, l);
        };

        s.default = _default;
      },
      4916: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useCommonSingleMultipleSelects() {
          return {
            disableCustomColors: !(0, v.default)("color.custom"),
            disableCustomGradients: !(0, v.default)("color.customGradient")
          };
        };
        var v = m(c(3081));
      },
      26: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useMultipleOriginColorsAndGradients() {
          var l = (0, y.default)(),
              s = (0, k.default)("color.palette.custom"),
              c = (0, k.default)("color.palette.theme"),
              m = (0, k.default)("color.palette.default"),
              E = (0, k.default)("color.defaultPalette");
          l.colors = (0, v.useMemo)(function () {
            var l = [];
            return c && c.length && l.push({
              name: (0, _._x)("Theme", "Indicates this palette comes from the theme."),
              colors: c
            }), E && m && m.length && l.push({
              name: (0, _._x)("Default", "Indicates this palette comes from WordPress."),
              colors: m
            }), s && s.length && l.push({
              name: (0, _._x)("Custom", "Indicates this palette comes from the theme."),
              colors: s
            }), l;
          }, [m, c, s]);
          var w = (0, k.default)("color.gradients.custom"),
              C = (0, k.default)("color.gradients.theme"),
              S = (0, k.default)("color.gradients.default"),
              B = (0, k.default)("color.defaultGradients");
          return l.gradients = (0, v.useMemo)(function () {
            var l = [];
            return C && C.length && l.push({
              name: (0, _._x)("Theme", "Indicates this palette comes from the theme."),
              gradients: C
            }), B && S && S.length && l.push({
              name: (0, _._x)("Default", "Indicates this palette comes from WordPress."),
              gradients: S
            }), w && w.length && l.push({
              name: (0, _._x)("Custom", "Indicates this palette is created by the user."),
              gradients: w
            }), l;
          }, [w, C, S]), l;
        };

        var v = c(1753),
            _ = c(6756),
            k = m(c(3081)),
            y = m(c(4916));
      },
      4459: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), Object.defineProperty(s, "createCustomColorsHOC", {
          enumerable: !0,
          get: function get() {
            return v.createCustomColorsHOC;
          }
        }), Object.defineProperty(s, "getColorClassName", {
          enumerable: !0,
          get: function get() {
            return m.getColorClassName;
          }
        }), Object.defineProperty(s, "getColorObjectByAttributeValues", {
          enumerable: !0,
          get: function get() {
            return m.getColorObjectByAttributeValues;
          }
        }), Object.defineProperty(s, "getColorObjectByColorValue", {
          enumerable: !0,
          get: function get() {
            return m.getColorObjectByColorValue;
          }
        }), Object.defineProperty(s, "withColors", {
          enumerable: !0,
          get: function get() {
            return v.default;
          }
        });

        var m = c(4183),
            v = function _interopRequireWildcard(l, s) {
          if (!s && l && l.__esModule) return l;
          if (null === l || "object" != typeof l && "function" != typeof l) return {
            default: l
          };

          var c = _getRequireWildcardCache(s);

          if (c && c.has(l)) return c.get(l);
          var m = {},
              v = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var _ in l) {
            if ("default" !== _ && Object.prototype.hasOwnProperty.call(l, _)) {
              var k = v ? Object.getOwnPropertyDescriptor(l, _) : null;
              k && (k.get || k.set) ? Object.defineProperty(m, _, k) : m[_] = l[_];
            }
          }

          m.default = l, c && c.set(l, m);
          return m;
        }(c(245));

        function _getRequireWildcardCache(l) {
          if ("function" != typeof WeakMap) return null;
          var s = new WeakMap(),
              c = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(l) {
            return l ? c : s;
          })(l);
        }
      },
      4183: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getColorClassName = function getColorClassName(l, s) {
          if (!l || !s) return;
          return "has-".concat((0, v.kebabCase)(s), "-").concat(l);
        }, s.getColorObjectByColorValue = s.getColorObjectByAttributeValues = void 0, s.getMostReadableColor = function getMostReadableColor(l, s) {
          var c = (0, _.colord)(s);
          return (0, v.maxBy)(l, function (l) {
            var s = l.color;
            return c.contrast(s);
          }).color;
        };

        var v = c(4793),
            _ = c(7270),
            k = m(c(9785)),
            y = m(c(2079));

        (0, _.extend)([k.default, y.default]);

        s.getColorObjectByAttributeValues = function (l, s, c) {
          if (s) {
            var _c29 = (0, v.find)(l, {
              slug: s
            });

            if (_c29) return _c29;
          }

          return {
            color: c
          };
        };

        s.getColorObjectByColorValue = function (l, s) {
          return (0, v.find)(l, {
            color: s
          });
        };
      },
      245: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.createCustomColorsHOC = function createCustomColorsHOC(l) {
          return function () {
            var s = withCustomColorPalette(l);

            for (var c = arguments.length, m = new Array(c), v = 0; v < c; v++) {
              m[v] = arguments[v];
            }

            return (0, y.createHigherOrderComponent)(createColorHOC(m, s), "withCustomColors");
          };
        }, s.default = function withColors() {
          var l = withEditorColorPalette();

          for (var s = arguments.length, c = new Array(s), m = 0; m < s; m++) {
            c[m] = arguments[m];
          }

          return (0, y.createHigherOrderComponent)(createColorHOC(c, l), "withColors");
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = c(3200),
            E = c(4183),
            w = m(c(3081));

        var withCustomColorPalette = function withCustomColorPalette(l) {
          return (0, y.createHigherOrderComponent)(function (s) {
            return function (c) {
              return (0, v.createElement)(s, (0, _.default)({}, c, {
                colors: l
              }));
            };
          }, "withCustomColorPalette");
        },
            withEditorColorPalette = function withEditorColorPalette() {
          return (0, y.createHigherOrderComponent)(function (l) {
            return function (s) {
              var c = (0, w.default)("color.palette.custom"),
                  m = (0, w.default)("color.palette.theme"),
                  k = (0, w.default)("color.palette.default"),
                  y = (0, v.useMemo)(function () {
                return [].concat(_toConsumableArray(c || []), _toConsumableArray(m || []), _toConsumableArray(k || []));
              }, [c, m, k]);
              return (0, v.createElement)(l, (0, _.default)({}, s, {
                colors: y
              }));
            };
          }, "withEditorColorPalette");
        };

        function createColorHOC(l, s) {
          var c = (0, k.reduce)(l, function (l, s) {
            return _objectSpread(_objectSpread({}, l), (0, k.isString)(s) ? _defineProperty({}, s, (0, k.kebabCase)(s)) : s);
          }, {});
          return (0, y.compose)([s, function (l) {
            return /*#__PURE__*/function (_v$Component) {
              _inherits(_class, _v$Component);

              var _super13 = _createSuper(_class);

              function _class(l) {
                var _this30;

                _classCallCheck(this, _class);

                _this30 = _super13.call(this, l), _this30.setters = _this30.createSetters(), _this30.colorUtils = {
                  getMostReadableColor: _this30.getMostReadableColor.bind(_assertThisInitialized(_this30))
                }, _this30.state = {};
                return _this30;
              }

              _createClass(_class, [{
                key: "getMostReadableColor",
                value: function getMostReadableColor(l) {
                  var s = this.props.colors;
                  return (0, E.getMostReadableColor)(s, l);
                }
              }, {
                key: "createSetters",
                value: function createSetters() {
                  var _this31 = this;

                  return (0, k.reduce)(c, function (l, s, c) {
                    var m = (0, k.upperFirst)(c),
                        v = "custom".concat(m);
                    return l["set".concat(m)] = _this31.createSetColor(c, v), l;
                  }, {});
                }
              }, {
                key: "createSetColor",
                value: function createSetColor(l, s) {
                  var _this32 = this;

                  return function (c) {
                    var _this32$props$setAttr;

                    var m = (0, E.getColorObjectByColorValue)(_this32.props.colors, c);

                    _this32.props.setAttributes((_this32$props$setAttr = {}, _defineProperty(_this32$props$setAttr, l, m && m.slug ? m.slug : void 0), _defineProperty(_this32$props$setAttr, s, m && m.slug ? void 0 : c), _this32$props$setAttr));
                  };
                }
              }, {
                key: "render",
                value: function render() {
                  return (0, v.createElement)(l, (0, _.default)({}, this.props, {
                    colors: void 0
                  }, this.state, this.setters, {
                    colorUtils: this.colorUtils
                  }));
                }
              }], [{
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(l, s) {
                  var m = l.attributes,
                      v = l.colors;
                  return (0, k.reduce)(c, function (l, c, _) {
                    var y = (0, E.getColorObjectByAttributeValues)(v, m[_], m["custom".concat((0, k.upperFirst)(_))]),
                        w = s[_];
                    return (null == w ? void 0 : w.color) === y.color && w ? l[_] = w : l[_] = _objectSpread(_objectSpread({}, y), {}, {
                      class: (0, E.getColorClassName)(c, y.slug)
                    }), l;
                  }, {});
                }
              }]);

              return _class;
            }(v.Component);
          }]);
        }
      },
      4346: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(7270),
            k = m(c(9785)),
            y = m(c(2079)),
            E = c(9773),
            w = c(6756),
            C = c(4892);

        function ContrastCheckerMessage(l) {
          var s = l.colordBackgroundColor,
              c = l.colordTextColor,
              m = l.backgroundColor,
              _ = l.textColor;
          var k = s.brightness() < c.brightness() ? (0, w.__)("This color combination may be hard for people to read. Try using a darker background color and/or a brighter text color.") : (0, w.__)("This color combination may be hard for people to read. Try using a brighter background color and/or a darker text color.");
          return (0, v.useEffect)(function () {
            (0, E.speak)((0, w.__)("This color combination may be hard for people to read."));
          }, [m, _]), (0, v.createElement)("div", {
            className: "block-editor-contrast-checker"
          }, (0, v.createElement)(C.Notice, {
            spokenMessage: null,
            status: "warning",
            isDismissible: !1
          }, k));
        }

        (0, _.extend)([k.default, y.default]);

        var S = function ContrastChecker(l) {
          var s = l.backgroundColor,
              c = l.fallbackBackgroundColor,
              m = l.fallbackTextColor,
              k = l.fontSize,
              y = l.isLargeText,
              E = l.textColor;
          if (!s && !c || !E && !m) return null;
          var w = (0, _.colord)(s || c),
              C = (0, _.colord)(E || m);
          return 1 !== w.alpha() || 1 !== C.alpha() || C.isReadable(w, {
            level: "AA",
            size: y || !1 !== y && k >= 24 ? "large" : "small"
          }) ? null : (0, v.createElement)(ContrastCheckerMessage, {
            backgroundColor: s,
            textColor: E,
            colordBackgroundColor: w,
            colordTextColor: C
          });
        };

        s.default = S;
      },
      9438: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.ConvertToGroupButton = function ConvertToGroupButton(l) {
          var s = l.clientIds,
              c = l.isGroupable,
              m = l.isUngroupable,
              C = l.blocksSelection,
              S = l.groupingBlockName,
              _l$onClose = l.onClose,
              B = _l$onClose === void 0 ? function () {} : _l$onClose;

          var _ref153 = (0, E.useDispatch)(w.store),
              P = _ref153.replaceBlocks;

          if (!c && !m) return null;
          return (0, v.createElement)(v.Fragment, null, c && (0, v.createElement)(_.MenuItem, {
            onClick: function onClick() {
              (function () {
                var l = (0, y.switchToBlockType)(C, S);
                l && P(s, l);
              })(), B();
            }
          }, (0, k._x)("Group", "verb")), m && (0, v.createElement)(_.MenuItem, {
            onClick: function onClick() {
              (function () {
                var l = C[0].innerBlocks;
                l.length && P(s, l);
              })(), B();
            }
          }, (0, k._x)("Ungroup", "Ungrouping blocks from within a Group block back into individual blocks within the Editor ")));
        }, Object.defineProperty(s, "useConvertToGroupButtonProps", {
          enumerable: !0,
          get: function get() {
            return C.default;
          }
        });

        var v = c(1753),
            _ = c(4892),
            k = c(6756),
            y = c(6700),
            E = c(8467),
            w = c(8486),
            C = m(c(4891));
      },
      4891: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useConvertToGroupButtonProps() {
          var _ref154 = (0, v.useSelect)(function (l) {
            var s;

            var _l84 = l(_.store),
                c = _l84.getBlockRootClientId,
                v = _l84.getBlocksByClientId,
                k = _l84.canInsertBlockType,
                y = _l84.getSelectedBlockClientIds,
                _l85 = l(m.store),
                E = _l85.getGroupingBlockName,
                w = y(),
                C = E(),
                S = k(C, null != w && w.length ? c(w[0]) : void 0),
                B = v(w),
                P = 1 === B.length && (null === (s = B[0]) || void 0 === s ? void 0 : s.name) === C;

            return {
              clientIds: w,
              isGroupable: S && B.length && !P,
              isUngroupable: P && !!B[0].innerBlocks.length,
              blocksSelection: B,
              groupingBlockName: C
            };
          }, []),
              l = _ref154.clientIds,
              s = _ref154.isGroupable,
              c = _ref154.isUngroupable,
              k = _ref154.blocksSelection,
              y = _ref154.groupingBlockName;

          return {
            clientIds: l,
            isGroupable: s,
            isUngroupable: c,
            blocksSelection: k,
            groupingBlockName: y
          };
        };

        var m = c(6700),
            v = c(8467),
            _ = c(8486);
      },
      303: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0, s.useClipboardHandler = useClipboardHandler, s.useNotifyCopy = useNotifyCopy;

        var m = c(1753),
            v = c(6700),
            _ = c(5480),
            k = c(8467),
            y = c(6756),
            E = c(8448),
            w = c(3200),
            C = c(8945),
            S = c(8486);

        function useNotifyCopy() {
          var _ref155 = (0, k.useSelect)(S.store),
              l = _ref155.getBlockName,
              _ref156 = (0, k.useSelect)(v.store),
              s = _ref156.getBlockType,
              _ref157 = (0, k.useDispatch)(E.store),
              c = _ref157.createSuccessNotice;

          return (0, m.useCallback)(function (m, v) {
            var _ = "";

            if (1 === v.length) {
              var k;

              var _c30 = v[0],
                  _E4 = null === (k = s(l(_c30))) || void 0 === k ? void 0 : k.title;

              _ = "copy" === m ? (0, y.sprintf)((0, y.__)('Copied "%s" to clipboard.'), _E4) : (0, y.sprintf)((0, y.__)('Moved "%s" to clipboard.'), _E4);
            } else _ = "copy" === m ? (0, y.sprintf)((0, y._n)("Copied %d block to clipboard.", "Copied %d blocks to clipboard.", v.length), v.length) : (0, y.sprintf)((0, y._n)("Moved %d block to clipboard.", "Moved %d blocks to clipboard.", v.length), v.length);

            c(_, {
              type: "snackbar"
            });
          }, []);
        }

        function useClipboardHandler() {
          var _ref158 = (0, k.useSelect)(S.store),
              l = _ref158.getBlocksByClientId,
              s = _ref158.getSelectedBlockClientIds,
              c = _ref158.hasMultiSelection,
              m = _ref158.getSettings,
              _ref159 = (0, k.useDispatch)(S.store),
              y = _ref159.flashBlock,
              E = _ref159.removeBlocks,
              B = _ref159.replaceBlocks,
              P = useNotifyCopy();

          return (0, w.useRefEffect)(function (k) {
            function handler(w) {
              var S = s();
              if (0 === S.length) return;

              if (!c()) {
                var _l86 = w.target,
                    _s41 = _l86.ownerDocument;
                if ("copy" === w.type || "cut" === w.type ? (0, _.documentHasUncollapsedSelection)(_s41) : (0, _.documentHasSelection)(_s41)) return;
              }

              if (!k.contains(w.target.ownerDocument.activeElement)) return;
              var O = w.defaultPrevented;

              if (w.preventDefault(), "copy" === w.type || "cut" === w.type) {
                1 === S.length && y(S[0]), P(w.type, S);

                var _s42 = l(S),
                    _c31 = (0, v.serialize)(_s42);

                w.clipboardData.setData("text/plain", _c31), w.clipboardData.setData("text/html", _c31);
              }

              if ("cut" === w.type) E(S);else if ("paste" === w.type) {
                if (O) return;

                var _m23 = m(),
                    _l87 = _m23.__experimentalCanUserUseUnfilteredHTML,
                    _ref160 = (0, C.getPasteEventData)(w),
                    _s43 = _ref160.plainText,
                    _c32 = _ref160.html,
                    _6 = (0, v.pasteHandler)({
                  HTML: _c32,
                  plainText: _s43,
                  mode: "BLOCKS",
                  canUserUseUnfilteredHTML: _l87
                });

                B(S, _6, _6.length - 1, -1);
              }
            }

            return k.ownerDocument.addEventListener("copy", handler), k.ownerDocument.addEventListener("cut", handler), k.ownerDocument.addEventListener("paste", handler), function () {
              k.ownerDocument.removeEventListener("copy", handler), k.ownerDocument.removeEventListener("cut", handler), k.ownerDocument.removeEventListener("paste", handler);
            };
          }, []);
        }

        var B = function CopyHandler(l) {
          var s = l.children;
          return (0, m.createElement)("div", {
            ref: useClipboardHandler()
          }, s);
        };

        s.default = B;
      },
      4546: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.DefaultBlockAppender = DefaultBlockAppender, s.default = s.ZWNBSP = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(6756),
            y = c(3200),
            E = c(6700),
            w = c(3248),
            C = c(8467),
            S = m(c(1517)),
            B = c(8486);

        function DefaultBlockAppender(l) {
          var s = l.isLocked,
              c = l.isVisible,
              m = l.onAppend,
              y = l.showPrompt,
              E = l.placeholder,
              C = l.rootClientId;
          if (s || !c) return null;
          var B = (0, w.decodeEntities)(E) || (0, k.__)("Type / to choose a block");
          return (0, v.createElement)("div", {
            "data-root-client-id": C || "",
            className: (0, _.default)("block-editor-default-block-appender", {
              "has-visible-prompt": y
            })
          }, (0, v.createElement)("p", {
            tabIndex: "0",
            contentEditable: !0,
            suppressContentEditableWarning: !0,
            role: "button",
            "aria-label": (0, k.__)("Add block"),
            className: "block-editor-default-block-appender__content",
            onFocus: m
          }, y ? B : "\uFEFF"), (0, v.createElement)(S.default, {
            rootClientId: C,
            position: "bottom right",
            isAppender: !0,
            __experimentalIsQuick: !0
          }));
        }

        s.ZWNBSP = "\uFEFF";
        var P = (0, y.compose)((0, C.withSelect)(function (l, s) {
          var _l88 = l(B.store),
              c = _l88.getBlockCount,
              m = _l88.getBlockName,
              v = _l88.isBlockValid,
              _ = _l88.getSettings,
              k = _l88.getTemplateLock,
              y = !c(s.rootClientId),
              w = m(s.lastBlockClientId) === (0, E.getDefaultBlockName)(),
              C = v(s.lastBlockClientId),
              _ref161 = _(),
              S = _ref161.bodyPlaceholder;

          return {
            isVisible: y || !w || !C,
            showPrompt: y,
            isLocked: !!k(s.rootClientId),
            placeholder: S
          };
        }), (0, C.withDispatch)(function (l, s) {
          var _l89 = l(B.store),
              c = _l89.insertDefaultBlock,
              m = _l89.startTyping;

          return {
            onAppend: function onAppend() {
              var l = s.rootClientId;
              c(void 0, l), m();
            }
          };
        }))(DefaultBlockAppender);
        s.default = P;
      },
      8542: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function DefaultStylePicker(l) {
          var s = l.blockName;

          var _ref162 = (0, y.useSelect)(function (l) {
            var c, m;

            var _ = l(E.store).getSettings().__experimentalPreferredStyleVariations;

            return {
              preferredStyle: null == _ || null === (c = _.value) || void 0 === c ? void 0 : c[s],
              onUpdatePreferredStyleVariations: null !== (m = null == _ ? void 0 : _.onChange) && void 0 !== m ? m : null,
              styles: l(v.store).getBlockStyles(s)
            };
          }, [s]),
              c = _ref162.preferredStyle,
              w = _ref162.onUpdatePreferredStyleVariations,
              C = _ref162.styles,
              S = (0, m.useMemo)(function () {
            return [{
              label: (0, _.__)("Not set"),
              value: ""
            }].concat(_toConsumableArray(C.map(function (l) {
              var s = l.label,
                  c = l.name;
              return {
                label: s,
                value: c
              };
            })));
          }, [C]),
              B = (0, m.useCallback)(function (l) {
            w(s, l);
          }, [s, w]);

          return w && (0, m.createElement)(k.SelectControl, {
            options: S,
            value: c || "",
            label: (0, _.__)("Default Style"),
            onChange: B
          });
        };

        var m = c(1753),
            v = c(6700),
            _ = c(6756),
            k = c(4892),
            y = c(8467),
            E = c(8486);
      },
      8003: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(4892),
            _ = c(6756),
            k = c(9880);

        var y = function DuotoneControl(l) {
          var s = l.colorPalette,
              c = l.duotonePalette,
              y = l.disableCustomColors,
              E = l.disableCustomDuotone,
              w = l.value,
              C = l.onChange;
          return (0, m.createElement)(v.Dropdown, {
            popoverProps: {
              className: "block-editor-duotone-control__popover",
              headerTitle: (0, _.__)("Duotone"),
              isAlternate: !0
            },
            renderToggle: function renderToggle(l) {
              var s = l.isOpen,
                  c = l.onToggle;
              return (0, m.createElement)(v.ToolbarButton, {
                showTooltip: !0,
                onClick: c,
                "aria-haspopup": "true",
                "aria-expanded": s,
                onKeyDown: function onKeyDown(l) {
                  s || l.keyCode !== k.DOWN || (l.preventDefault(), c());
                },
                label: (0, _.__)("Apply duotone filter"),
                icon: (0, m.createElement)(v.DuotoneSwatch, {
                  values: w
                })
              });
            },
            renderContent: function renderContent() {
              return (0, m.createElement)(v.MenuGroup, {
                label: (0, _.__)("Duotone")
              }, (0, m.createElement)("div", {
                className: "block-editor-duotone-control__description"
              }, (0, _.__)("Create a two-tone color effect without losing your original image.")), (0, m.createElement)(v.DuotonePicker, {
                colorPalette: s,
                duotonePalette: c,
                disableCustomColors: y,
                disableCustomDuotone: E,
                value: w,
                onChange: C
              }));
            }
          });
        };

        s.default = y;
      },
      8342: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(1700));

        var y = (0, v.forwardRef)(function (l, s) {
          return (0, v.createElement)(k.default, (0, _.default)({
            ref: s
          }, l, {
            __unstableDisableFormats: !0,
            preserveWhiteSpace: !0
          }));
        });

        y.Content = function (l) {
          var _l$value2 = l.value,
              s = _l$value2 === void 0 ? "" : _l$value2,
              _l$tagName3 = l.tagName,
              c = _l$tagName3 === void 0 ? "div" : _l$tagName3,
              m = _objectWithoutProperties(l, _excluded18);

          return (0, v.createElement)(c, m, s);
        };

        var E = y;
        s.default = E;
      },
      2489: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function EditorStyles(l) {
          var s = l.styles;
          var c = (0, v.useMemo)(function () {
            return (0, E.default)(s, w);
          }, [s]);
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)("style", {
            ref: useDarkThemeBodyClassName(s)
          }), c.map(function (l, s) {
            return (0, v.createElement)("style", {
              key: s
            }, l);
          }));
        };

        var v = c(1753),
            _ = c(7270),
            k = m(c(9785)),
            y = m(c(2079)),
            E = m(c(216));

        var w = ".editor-styles-wrapper";

        function useDarkThemeBodyClassName(l) {
          return (0, v.useCallback)(function (l) {
            if (!l) return;
            var s = l.ownerDocument,
                c = s.defaultView,
                m = s.body,
                v = s.querySelector(w);
            var k;
            if (v) k = c.getComputedStyle(v, null).getPropertyValue("background-color");else {
              var _l90 = s.createElement("div");

              _l90.classList.add("editor-styles-wrapper"), m.appendChild(_l90), k = c.getComputedStyle(_l90, null).getPropertyValue("background-color"), m.removeChild(_l90);
            }
            var y = (0, _.colord)(k);
            y.luminance() > .5 || 0 === y.alpha() ? m.classList.remove("is-dark-theme") : m.classList.add("is-dark-theme");
          }, [l]);
        }

        (0, _.extend)([k.default, y.default]);
      },
      4601: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function FontAppearanceControl(l) {
          var s = l.onChange,
              _l$hasFontStyles = l.hasFontStyles,
              c = _l$hasFontStyles === void 0 ? !0 : _l$hasFontStyles,
              _l$hasFontWeights = l.hasFontWeights,
              E = _l$hasFontWeights === void 0 ? !0 : _l$hasFontWeights,
              _l$value3 = l.value,
              w = _l$value3.fontStyle,
              C = _l$value3.fontWeight,
              S = c || E,
              B = getFontAppearanceLabel(c, E),
              P = {
            key: "default",
            name: (0, _.__)("Default"),
            style: {
              fontStyle: void 0,
              fontWeight: void 0
            }
          },
              O = (0, m.useMemo)(function () {
            return c && E ? function () {
              var l = [P];
              return k.forEach(function (s) {
                var c = s.name,
                    m = s.value;
                y.forEach(function (s) {
                  var v = s.name,
                      k = s.value;
                  var y = "normal" === m ? v : (0, _.sprintf)((0, _.__)("%1$s %2$s"), v, c);
                  l.push({
                    key: "".concat(m, "-").concat(k),
                    name: y,
                    style: {
                      fontStyle: m,
                      fontWeight: k
                    }
                  });
                });
              }), l;
            }() : c ? function () {
              var l = [P];
              return k.forEach(function (s) {
                var c = s.name,
                    m = s.value;
                l.push({
                  key: m,
                  name: c,
                  style: {
                    fontStyle: m,
                    fontWeight: void 0
                  }
                });
              }), l;
            }() : function () {
              var l = [P];
              return y.forEach(function (s) {
                var c = s.name,
                    m = s.value;
                l.push({
                  key: m,
                  name: c,
                  style: {
                    fontStyle: void 0,
                    fontWeight: m
                  }
                });
              }), l;
            }();
          }, [l.options]),
              L = O.find(function (l) {
            return l.style.fontStyle === w && l.style.fontWeight === C;
          }) || O[0];
          return S && (0, m.createElement)(v.CustomSelectControl, {
            className: "components-font-appearance-control",
            label: B,
            describedBy: L ? c ? E ? (0, _.sprintf)((0, _.__)("Currently selected font appearance: %s"), L.name) : (0, _.sprintf)((0, _.__)("Currently selected font style: %s"), L.name) : (0, _.sprintf)((0, _.__)("Currently selected font weight: %s"), L.name) : (0, _.__)("No selected font appearance"),
            options: O,
            value: L,
            onChange: function onChange(l) {
              var c = l.selectedItem;
              return s(c.style);
            }
          });
        }, s.getFontAppearanceLabel = void 0;

        var m = c(1753),
            v = c(4892),
            _ = c(6756);

        var k = [{
          name: (0, _._x)("Regular", "font style"),
          value: "normal"
        }, {
          name: (0, _._x)("Italic", "font style"),
          value: "italic"
        }],
            y = [{
          name: (0, _._x)("Thin", "font weight"),
          value: "100"
        }, {
          name: (0, _._x)("Extra Light", "font weight"),
          value: "200"
        }, {
          name: (0, _._x)("Light", "font weight"),
          value: "300"
        }, {
          name: (0, _._x)("Regular", "font weight"),
          value: "400"
        }, {
          name: (0, _._x)("Medium", "font weight"),
          value: "500"
        }, {
          name: (0, _._x)("Semi Bold", "font weight"),
          value: "600"
        }, {
          name: (0, _._x)("Bold", "font weight"),
          value: "700"
        }, {
          name: (0, _._x)("Extra Bold", "font weight"),
          value: "800"
        }, {
          name: (0, _._x)("Black", "font weight"),
          value: "900"
        }],
            getFontAppearanceLabel = function getFontAppearanceLabel(l, s) {
          return l ? s ? (0, _.__)("Appearance") : (0, _.__)("Font style") : (0, _.__)("Font weight");
        };

        s.getFontAppearanceLabel = getFontAppearanceLabel;
      },
      1052: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function FontFamilyControl(l) {
          var _l$value4 = l.value,
              s = _l$value4 === void 0 ? "" : _l$value4,
              c = l.onChange,
              m = l.fontFamilies,
              C = _objectWithoutProperties(l, _excluded19);

          var S = (0, w.default)("typography.fontFamilies");
          m || (m = S);
          if ((0, k.isEmpty)(m)) return null;
          var B = [{
            value: "",
            label: (0, E.__)("Default")
          }].concat(_toConsumableArray(m.map(function (l) {
            var s = l.fontFamily,
                c = l.name;
            return {
              value: s,
              label: c || s
            };
          })));
          return (0, v.createElement)(y.SelectControl, (0, _.default)({
            label: (0, E.__)("Font family"),
            options: B,
            value: s,
            onChange: c,
            labelPosition: "top"
          }, C));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = c(4892),
            E = c(6756),
            w = m(c(3081));
      },
      2522: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = m(c(3081));

        var E = function FontSizePicker(l) {
          var s = (0, y.default)("typography.fontSizes"),
              c = !(0, y.default)("typography.customFontSize");
          return (0, v.createElement)(k.FontSizePicker, (0, _.default)({}, l, {
            fontSizes: s,
            disableCustomFontSizes: c
          }));
        };

        s.default = E;
      },
      1184: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), Object.defineProperty(s, "FontSizePicker", {
          enumerable: !0,
          get: function get() {
            return _.default;
          }
        }), Object.defineProperty(s, "getFontSize", {
          enumerable: !0,
          get: function get() {
            return v.getFontSize;
          }
        }), Object.defineProperty(s, "getFontSizeClass", {
          enumerable: !0,
          get: function get() {
            return v.getFontSizeClass;
          }
        }), Object.defineProperty(s, "getFontSizeObjectByValue", {
          enumerable: !0,
          get: function get() {
            return v.getFontSizeObjectByValue;
          }
        }), Object.defineProperty(s, "withFontSizes", {
          enumerable: !0,
          get: function get() {
            return k.default;
          }
        });

        var v = c(8414),
            _ = m(c(2522)),
            k = m(c(3052));
      },
      8414: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getFontSize = void 0, s.getFontSizeClass = function getFontSizeClass(l) {
          if (!l) return;
          return "has-".concat((0, m.kebabCase)(l), "-font-size");
        }, s.getFontSizeObjectByValue = function getFontSizeObjectByValue(l, s) {
          var c = (0, m.find)(l, {
            size: s
          });
          if (c) return c;
          return {
            size: s
          };
        };
        var m = c(4793);

        s.getFontSize = function (l, s, c) {
          if (s) {
            var _c33 = (0, m.find)(l, {
              slug: s
            });

            if (_c33) return _c33;
          }

          return {
            size: c
          };
        };
      },
      3052: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = c(3200),
            E = c(8414),
            w = m(c(3081));

        var C = [];

        s.default = function _default() {
          for (var l = arguments.length, s = new Array(l), c = 0; c < l; c++) {
            s[c] = arguments[c];
          }

          var m = (0, k.reduce)(s, function (l, s) {
            return l[s] = "custom".concat((0, k.upperFirst)(s)), l;
          }, {});
          return (0, y.createHigherOrderComponent)((0, y.compose)([(0, y.createHigherOrderComponent)(function (l) {
            return function (s) {
              var c = (0, w.default)("typography.fontSizes") || C;
              return (0, v.createElement)(l, (0, _.default)({}, s, {
                fontSizes: c
              }));
            };
          }, "withFontSizes"), function (l) {
            return /*#__PURE__*/function (_v$Component2) {
              _inherits(_class2, _v$Component2);

              var _super14 = _createSuper(_class2);

              function _class2(l) {
                var _this33;

                _classCallCheck(this, _class2);

                _this33 = _super14.call(this, l), _this33.setters = _this33.createSetters(), _this33.state = {};
                return _this33;
              }

              _createClass(_class2, [{
                key: "createSetters",
                value: function createSetters() {
                  var _this34 = this;

                  return (0, k.reduce)(m, function (l, s, c) {
                    return l["set".concat((0, k.upperFirst)(c))] = _this34.createSetFontSize(c, s), l;
                  }, {});
                }
              }, {
                key: "createSetFontSize",
                value: function createSetFontSize(l, s) {
                  var _this35 = this;

                  return function (c) {
                    var _this35$props$setAttr;

                    var m = (0, k.find)(_this35.props.fontSizes, {
                      size: Number(c)
                    });

                    _this35.props.setAttributes((_this35$props$setAttr = {}, _defineProperty(_this35$props$setAttr, l, m && m.slug ? m.slug : void 0), _defineProperty(_this35$props$setAttr, s, m && m.slug ? void 0 : c), _this35$props$setAttr));
                  };
                }
              }, {
                key: "render",
                value: function render() {
                  return (0, v.createElement)(l, (0, _.default)({}, this.props, {
                    fontSizes: void 0
                  }, this.state, this.setters));
                }
              }], [{
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(l, s) {
                  var c = l.attributes,
                      v = l.fontSizes;

                  var didAttributesChange = function didAttributesChange(l, m) {
                    return !s[m] || (c[m] ? c[m] !== s[m].slug : s[m].size !== c[l]);
                  };

                  if (!(0, k.some)(m, didAttributesChange)) return null;

                  var _ = (0, k.reduce)((0, k.pickBy)(m, didAttributesChange), function (l, s, m) {
                    var _ = c[m],
                        k = (0, E.getFontSize)(v, _, c[s]);
                    return l[m] = _objectSpread(_objectSpread({}, k), {}, {
                      class: (0, E.getFontSizeClass)(_)
                    }), l;
                  }, {});

                  return _objectSpread(_objectSpread({}, s), _);
                }
              }]);

              return _class2;
            }(v.Component);
          }]), "withFontSizes");
        };
      },
      5261: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        });
        var m = c(2528);
        Object.keys(m).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (l in s && s[l] === m[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return m[l];
            }
          }));
        });
      },
      2528: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.__experimentalGetGradientClass = __experimentalGetGradientClass, s.__experimentalGetGradientObjectByGradientValue = __experimentalGetGradientObjectByGradientValue, s.__experimentalUseGradient = function __experimentalUseGradient() {
          var _ref163 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              _ref163$gradientAttri = _ref163.gradientAttribute,
              l = _ref163$gradientAttri === void 0 ? "gradient" : _ref163$gradientAttri,
              _ref163$customGradien = _ref163.customGradientAttribute,
              s = _ref163$customGradien === void 0 ? "customGradient" : _ref163$customGradien;

          var _ref164 = (0, y.useBlockEditContext)(),
              c = _ref164.clientId,
              m = (0, E.default)("color.gradients.custom"),
              v = (0, E.default)("color.gradients.theme"),
              C = (0, E.default)("color.gradients.default"),
              S = (0, _.useMemo)(function () {
            return [].concat(_toConsumableArray(m || []), _toConsumableArray(v || []), _toConsumableArray(C || []));
          }, [m, v, C]),
              _ref165 = (0, k.useSelect)(function (m) {
            var _m24 = m(w.store),
                v = _m24.getBlockAttributes,
                _ = v(c) || {};

            return {
              customGradient: _[s],
              gradient: _[l]
            };
          }, [c, l, s]),
              B = _ref165.gradient,
              P = _ref165.customGradient,
              _ref166 = (0, k.useDispatch)(w.store),
              O = _ref166.updateBlockAttributes,
              L = (0, _.useCallback)(function (m) {
            var _ref167, _ref168;

            var v = getGradientSlugByValue(S, m);
            O(c, v ? (_ref167 = {}, _defineProperty(_ref167, l, v), _defineProperty(_ref167, s, void 0), _ref167) : (_ref168 = {}, _defineProperty(_ref168, l, void 0), _defineProperty(_ref168, s, m), _ref168));
          }, [S, c, O]),
              V = __experimentalGetGradientClass(B);

          var R;
          R = B ? getGradientValueBySlug(S, B) : P;
          return {
            gradientClass: V,
            gradientValue: R,
            setGradient: L
          };
        }, s.getGradientSlugByValue = getGradientSlugByValue, s.getGradientValueBySlug = getGradientValueBySlug;

        var v = c(4793),
            _ = c(1753),
            k = c(8467),
            y = c(5490),
            E = m(c(3081)),
            w = c(8486);

        function __experimentalGetGradientClass(l) {
          if (l) return "has-".concat(l, "-gradient-background");
        }

        function getGradientValueBySlug(l, s) {
          var c = (0, v.find)(l, ["slug", s]);
          return c && c.gradient;
        }

        function __experimentalGetGradientObjectByGradientValue(l, s) {
          return (0, v.find)(l, ["gradient", s]);
        }

        function getGradientSlugByValue(l, s) {
          var c = __experimentalGetGradientObjectByGradientValue(l, s);

          return c && c.slug;
        }
      },
      9821: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(6756),
            E = c(3200),
            w = c(4892),
            C = c(5920),
            S = c(2678);

        var B = "editor-styles-wrapper";

        function useParsedAssets(l) {
          return (0, v.useMemo)(function () {
            var s = document.implementation.createHTMLDocument("");
            return s.body.innerHTML = l, Array.from(s.body.children);
          }, [l]);
        }

        var P = (0, v.forwardRef)(function Iframe(l, s) {
          var c, m;

          var P = l.contentRef,
              O = l.children,
              L = l.head,
              _l$tabIndex = l.tabIndex,
              V = _l$tabIndex === void 0 ? 0 : _l$tabIndex,
              R = _objectWithoutProperties(l, _excluded20);

          var _ref169 = (0, v.useReducer)(function () {
            return {};
          }),
              _ref170 = _slicedToArray(_ref169, 2),
              A = _ref170[1],
              _ref171 = (0, v.useState)(),
              _ref172 = _slicedToArray(_ref171, 2),
              z = _ref172[0],
              D = _ref172[1],
              _ref173 = (0, v.useState)([]),
              _ref174 = _slicedToArray(_ref173, 2),
              F = _ref174[0],
              G = _ref174[1],
              U = useParsedAssets(null === (c = window.__editorAssets) || void 0 === c ? void 0 : c.styles),
              W = useParsedAssets(null === (m = window.__editorAssets) || void 0 === m ? void 0 : m.scripts),
              K = (0, C.useBlockSelectionClearer)(),
              _ref175 = (0, S.useWritingFlow)(),
              _ref176 = _slicedToArray(_ref175, 3),
              $ = _ref176[0],
              q = _ref176[1],
              Y = _ref176[2],
              Z = (0, E.useRefEffect)(function (l) {
            function setDocumentIfReady() {
              var s = l.contentDocument,
                  c = l.ownerDocument,
                  m = s.readyState,
                  v = s.documentElement;
              return ("interactive" === m || "complete" === m) && (function bubbleEvents(l) {
                var s = l.defaultView,
                    c = s.frameElement;

                function bubbleEvent(l) {
                  var m = Object.getPrototypeOf(l).constructor.name,
                      v = window[m],
                      _ = {};

                  for (var _s44 in l) {
                    _[_s44] = l[_s44];
                  }

                  if (l instanceof s.MouseEvent) {
                    var _l91 = c.getBoundingClientRect();

                    _.clientX += _l91.left, _.clientY += _l91.top;
                  }

                  var k = new v(l.type, _);
                  !c.dispatchEvent(k) && l.preventDefault();
                }

                var m = ["dragover"];

                for (var _i2 = 0, _m25 = m; _i2 < _m25.length; _i2++) {
                  var _s45 = _m25[_i2];
                  l.addEventListener(_s45, bubbleEvent);
                }
              }(s), D(s), K(v), G(Array.from(c.body.classList).filter(function (l) {
                return l.startsWith("admin-color-") || "wp-embed-responsive" === l;
              })), s.dir = c.dir, v.removeChild(s.head), v.removeChild(s.body), !0);
            }

            setDocumentIfReady() || l.addEventListener("load", function () {
              setDocumentIfReady();
            });
          }, []),
              X = (0, E.useRefEffect)(function (l) {
            W.reduce(function (s, c) {
              return s.then(function () {
                return function () {
                  var _loadScript = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(l, s) {
                    var c, m;
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            c = s.id, m = s.src;
                            return _context6.abrupt("return", new Promise(function (s, v) {
                              var _ = l.ownerDocument.createElement("script");

                              _.id = c, m ? (_.src = m, _.onload = function () {
                                return s();
                              }, _.onerror = function () {
                                return v();
                              }) : s(), l.appendChild(_);
                            }));

                          case 2:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  function loadScript(_x6, _x7) {
                    return _loadScript.apply(this, arguments);
                  }

                  return loadScript;
                }()(l, c);
              });
            }, Promise.resolve()).finally(function () {
              A();
            });
          }, []),
              Q = (0, E.useMergeRefs)([P, K, q]);

          return (0, v.useEffect)(function () {
            z && function styleSheetsCompat(l) {
              Array.from(document.styleSheets).forEach(function (s) {
                try {
                  s.cssRules;
                } catch (l) {
                  return;
                }

                var c = s.ownerNode,
                    m = s.cssRules;

                if (m && "LINK" === c.tagName && "wp-reset-editor-styles-css" !== c.id && Array.from(m).find(function (l) {
                  var s = l.selectorText;
                  return s && (s.includes(".".concat(B)) || s.includes(".wp-block"));
                }) && !l.getElementById(c.id)) {
                  l.head.appendChild(c.cloneNode(!0));

                  var _s46 = c.id.replace("-css", "-inline-css"),
                      _m26 = document.getElementById(_s46);

                  _m26 && l.head.appendChild(_m26.cloneNode(!0));
                }
              });
            }(z);
          }, [z]), L = (0, v.createElement)(v.Fragment, null, (0, v.createElement)("style", null, "body{margin:0}"), U.map(function (l) {
            var s = l.tagName,
                c = l.href,
                m = l.id,
                _ = l.rel,
                k = l.media,
                y = l.textContent;
            var E = s.toLowerCase();
            return "style" === E ? (0, v.createElement)(E, {
              id: m,
              key: m
            }, y) : (0, v.createElement)(E, {
              href: c,
              id: m,
              rel: _,
              media: k,
              key: m
            });
          }), L), (0, v.createElement)(v.Fragment, null, V >= 0 && $, (0, v.createElement)("iframe", (0, _.default)({}, R, {
            ref: (0, E.useMergeRefs)([s, Z]),
            tabIndex: V,
            title: (0, y.__)("Editor canvas")
          }), z && (0, v.createPortal)((0, v.createElement)(v.Fragment, null, (0, v.createElement)("head", {
            ref: X
          }, L), (0, v.createElement)("body", {
            ref: Q,
            className: (0, k.default).apply(void 0, [B].concat(_toConsumableArray(F)))
          }, (0, v.createElement)(w.__experimentalStyleProvider, {
            document: z
          }, O))), z.documentElement)), V >= 0 && Y);
        });
        s.default = P;
      },
      8938: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function AspectRatioDropdown(l) {
          var s = l.toggleProps;

          var _ref177 = (0, E.useImageEditingContext)(),
              c = _ref177.isInProgress,
              w = _ref177.aspect,
              C = _ref177.setAspect,
              S = _ref177.defaultAspect;

          return (0, m.createElement)(_.DropdownMenu, {
            icon: v.aspectRatio,
            label: (0, k.__)("Aspect Ratio"),
            popoverProps: y.POPOVER_PROPS,
            toggleProps: s,
            className: "wp-block-image__aspect-ratio"
          }, function (l) {
            var s = l.onClose;
            return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(AspectGroup, {
              isDisabled: c,
              onClick: function onClick(l) {
                C(l), s();
              },
              value: w,
              aspectRatios: [{
                title: (0, k.__)("Original"),
                aspect: S
              }, {
                title: (0, k.__)("Square"),
                aspect: 1
              }]
            }), (0, m.createElement)(AspectGroup, {
              label: (0, k.__)("Landscape"),
              isDisabled: c,
              onClick: function onClick(l) {
                C(l), s();
              },
              value: w,
              aspectRatios: [{
                title: (0, k.__)("16:10"),
                aspect: 1.6
              }, {
                title: (0, k.__)("16:9"),
                aspect: 16 / 9
              }, {
                title: (0, k.__)("4:3"),
                aspect: 4 / 3
              }, {
                title: (0, k.__)("3:2"),
                aspect: 1.5
              }]
            }), (0, m.createElement)(AspectGroup, {
              label: (0, k.__)("Portrait"),
              isDisabled: c,
              onClick: function onClick(l) {
                C(l), s();
              },
              value: w,
              aspectRatios: [{
                title: (0, k.__)("10:16"),
                aspect: .625
              }, {
                title: (0, k.__)("9:16"),
                aspect: 9 / 16
              }, {
                title: (0, k.__)("3:4"),
                aspect: 3 / 4
              }, {
                title: (0, k.__)("2:3"),
                aspect: 2 / 3
              }]
            }));
          });
        };

        var m = c(1753),
            v = c(2614),
            _ = c(4892),
            k = c(6756),
            y = c(9654),
            E = c(146);

        function AspectGroup(l) {
          var s = l.aspectRatios,
              c = l.isDisabled,
              k = l.label,
              y = l.onClick,
              E = l.value;
          return (0, m.createElement)(_.MenuGroup, {
            label: k
          }, s.map(function (l) {
            var s = l.title,
                k = l.aspect;
            return (0, m.createElement)(_.MenuItem, {
              key: k,
              disabled: c,
              onClick: function onClick() {
                y(k);
              },
              role: "menuitemradio",
              isSelected: k === E,
              icon: k === E ? v.check : void 0
            }, s);
          }));
        }
      },
      9654: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.POPOVER_PROPS = s.MIN_ZOOM = s.MAX_ZOOM = void 0;
        s.MIN_ZOOM = 100;
        s.MAX_ZOOM = 300;
        s.POPOVER_PROPS = {
          position: "bottom right",
          isAlternate: !0
        };
      },
      146: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ImageEditingProvider(l) {
          var s = l.id,
              c = l.url,
              m = l.naturalWidth,
              E = l.naturalHeight,
              w = l.isEditing,
              C = l.onFinishEditing,
              S = l.onSaveImage,
              B = l.children;
          var P = (0, k.default)({
            url: c,
            naturalWidth: m,
            naturalHeight: E
          }, w),
              O = (0, _.default)(_objectSpread({
            id: s,
            url: c,
            onSaveImage: S,
            onFinishEditing: C
          }, P)),
              L = (0, v.useMemo)(function () {
            return _objectSpread(_objectSpread({}, P), O);
          }, [P, O]);
          return (0, v.createElement)(y.Provider, {
            value: L
          }, B);
        }, s.useImageEditingContext = void 0;

        var v = c(1753),
            _ = m(c(561)),
            k = m(c(8370));

        var y = (0, v.createContext)({});

        s.useImageEditingContext = function () {
          return (0, v.useContext)(y);
        };
      },
      2320: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ImageCropper(l) {
          var s = l.url,
              c = l.width,
              m = l.height,
              C = l.clientWidth,
              S = l.naturalHeight,
              B = l.naturalWidth;

          var _ref178 = (0, w.useImageEditingContext)(),
              P = _ref178.isInProgress,
              O = _ref178.editedUrl,
              L = _ref178.position,
              V = _ref178.zoom,
              R = _ref178.aspect,
              A = _ref178.setPosition,
              z = _ref178.setCrop,
              D = _ref178.setZoom,
              F = _ref178.rotation;

          var G = m || C * S / B;
          F % 180 == 90 && (G = C * B / S);
          return (0, v.createElement)("div", {
            className: (0, k.default)("wp-block-image__crop-area", {
              "is-applying": P
            }),
            style: {
              width: c || C,
              height: G
            }
          }, (0, v.createElement)(_.default, {
            image: O || s,
            disabled: P,
            minZoom: E.MIN_ZOOM / 100,
            maxZoom: E.MAX_ZOOM / 100,
            crop: L,
            zoom: V / 100,
            aspect: R,
            onCropChange: A,
            onCropComplete: function onCropComplete(l) {
              z(l);
            },
            onZoomChange: function onZoomChange(l) {
              D(100 * l);
            }
          }), P && (0, v.createElement)(y.Spinner, null));
        };

        var v = c(1753),
            _ = m(c(4428)),
            k = m(c(2703)),
            y = c(4892),
            E = c(9654),
            w = c(146);
      },
      3586: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function FormControls() {
          var _ref179 = (0, k.useImageEditingContext)(),
              l = _ref179.isInProgress,
              s = _ref179.apply,
              c = _ref179.cancel;

          return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(v.ToolbarButton, {
            onClick: s,
            disabled: l
          }, (0, _.__)("Apply")), (0, m.createElement)(v.ToolbarButton, {
            onClick: c
          }, (0, _.__)("Cancel")));
        };

        var m = c(1753),
            v = c(4892),
            _ = c(6756),
            k = c(146);
      },
      2645: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), Object.defineProperty(s, "ImageEditingProvider", {
          enumerable: !0,
          get: function get() {
            return B.default;
          }
        }), s.default = function ImageEditor(l) {
          var s = l.url,
              c = l.width,
              m = l.height,
              B = l.clientWidth,
              P = l.naturalHeight,
              O = l.naturalWidth;
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.default, {
            url: s,
            width: c,
            height: m,
            clientWidth: B,
            naturalHeight: P,
            naturalWidth: O
          }), (0, v.createElement)(k.default, null, (0, v.createElement)(_.ToolbarGroup, null, (0, v.createElement)(E.default, null), (0, v.createElement)(_.ToolbarItem, null, function (l) {
            return (0, v.createElement)(w.default, {
              toggleProps: l
            });
          }), (0, v.createElement)(C.default, null)), (0, v.createElement)(_.ToolbarGroup, null, (0, v.createElement)(S.default, null))));
        };

        var v = c(1753),
            _ = c(4892),
            k = m(c(915)),
            y = m(c(2320)),
            E = m(c(671)),
            w = m(c(8938)),
            C = m(c(4292)),
            S = m(c(3586)),
            B = m(c(146));
      },
      4292: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function RotationButton() {
          var _ref180 = (0, y.useImageEditingContext)(),
              l = _ref180.isInProgress,
              s = _ref180.rotateClockwise;

          return (0, m.createElement)(v.ToolbarButton, {
            icon: k.rotateRight,
            label: (0, _.__)("Rotate"),
            onClick: s,
            disabled: l
          });
        };

        var m = c(1753),
            v = c(4892),
            _ = c(6756),
            k = c(2614),
            y = c(146);
      },
      561: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useSaveImage(l) {
          var s = l.crop,
              c = l.rotation,
              m = l.height,
              w = l.width,
              C = l.aspect,
              S = l.url,
              B = l.id,
              P = l.onSaveImage,
              O = l.onFinishEditing;

          var _ref181 = (0, _.useDispatch)(E.store),
              L = _ref181.createErrorNotice,
              _ref182 = (0, k.useState)(!1),
              _ref183 = _slicedToArray(_ref182, 2),
              V = _ref183[0],
              R = _ref183[1],
              A = (0, k.useCallback)(function () {
            R(!1), O();
          }, [R, O]),
              z = (0, k.useCallback)(function () {
            R(!0);
            var l = {};
            (s.width < 99.9 || s.height < 99.9) && (l = s), c > 0 && (l.rotation = c), l.src = S, (0, v.default)({
              path: "/wp/v2/media/".concat(B, "/edit"),
              method: "POST",
              data: l
            }).then(function (l) {
              P({
                id: l.id,
                url: l.source_url,
                height: m && w ? w / C : void 0
              });
            }).catch(function (l) {
              L((0, y.sprintf)((0, y.__)("Could not edit image. %s"), l.message), {
                id: "image-editing-error",
                type: "snackbar"
              });
            }).finally(function () {
              R(!1), O();
            });
          }, [R, s, c, m, w, C, S, P, L, R, O]);

          return (0, k.useMemo)(function () {
            return {
              isInProgress: V,
              apply: z,
              cancel: A
            };
          }, [V, z, A]);
        };

        var v = m(c(507)),
            _ = c(8467),
            k = c(1753),
            y = c(6756),
            E = c(8448);
      },
      8370: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useTransformImage(l, s) {
          var c = function useTransformState(l) {
            var s = l.url,
                c = l.naturalWidth,
                _ = l.naturalHeight;

            var _ref184 = (0, m.useState)(),
                _ref185 = _slicedToArray(_ref184, 2),
                k = _ref185[0],
                y = _ref185[1],
                _ref186 = (0, m.useState)(),
                _ref187 = _slicedToArray(_ref186, 2),
                E = _ref187[0],
                w = _ref187[1],
                _ref188 = (0, m.useState)({
              x: 0,
              y: 0
            }),
                _ref189 = _slicedToArray(_ref188, 2),
                C = _ref189[0],
                S = _ref189[1],
                _ref190 = (0, m.useState)(),
                _ref191 = _slicedToArray(_ref190, 2),
                B = _ref191[0],
                P = _ref191[1],
                _ref192 = (0, m.useState)(),
                _ref193 = _slicedToArray(_ref192, 2),
                O = _ref193[0],
                L = _ref193[1],
                _ref194 = (0, m.useState)(),
                _ref195 = _slicedToArray(_ref194, 2),
                V = _ref195[0],
                R = _ref195[1],
                _ref196 = (0, m.useState)(),
                _ref197 = _slicedToArray(_ref196, 2),
                A = _ref197[0],
                z = _ref197[1],
                D = (0, m.useCallback)(function () {
              S({
                x: 0,
                y: 0
              }), P(100), L(0), R(c / _), z(c / _);
            }, [c, _, S, P, L, R, z]),
                F = (0, m.useCallback)(function () {
              var l = (O + 90) % 360;
              var m = c / _;
              if (O % 180 == 90 && (m = _ / c), 0 === l) return y(), L(l), R(1 / V), void S({
                x: -C.y * m,
                y: C.x * m
              });

              function editImage(s) {
                var c = document.createElement("canvas");
                var v = 0,
                    _ = 0;
                l % 180 ? (c.width = s.target.height, c.height = s.target.width) : (c.width = s.target.width, c.height = s.target.height), 90 !== l && 180 !== l || (v = c.width), 270 !== l && 180 !== l || (_ = c.height);
                var k = c.getContext("2d");
                k.translate(v, _), k.rotate(l * Math.PI / 180), k.drawImage(s.target, 0, 0), c.toBlob(function (s) {
                  y(URL.createObjectURL(s)), L(l), R(1 / V), S({
                    x: -C.y * m,
                    y: C.x * m
                  });
                });
              }

              var k = new window.Image();
              k.src = s, k.onload = editImage;
              var E = (0, v.applyFilters)("media.crossOrigin", void 0, s);
              "string" == typeof E && (k.crossOrigin = E);
            }, [O, c, _, y, L, R, S]);

            return (0, m.useMemo)(function () {
              return {
                editedUrl: k,
                setEditedUrl: y,
                crop: E,
                setCrop: w,
                position: C,
                setPosition: S,
                zoom: B,
                setZoom: P,
                rotation: O,
                setRotation: L,
                rotateClockwise: F,
                aspect: V,
                setAspect: R,
                defaultAspect: A,
                initializeTransformValues: D
              };
            }, [k, y, E, w, C, S, B, P, O, L, F, V, R, A, D]);
          }(l),
              _ = c.initializeTransformValues;

          return (0, m.useEffect)(function () {
            s && _();
          }, [s, _]), c;
        };
        var m = c(1753),
            v = c(1149);
      },
      671: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ZoomDropdown() {
          var _ref198 = (0, E.useImageEditingContext)(),
              l = _ref198.isInProgress,
              s = _ref198.zoom,
              c = _ref198.setZoom;

          return (0, m.createElement)(v.Dropdown, {
            contentClassName: "wp-block-image__zoom",
            popoverProps: y.POPOVER_PROPS,
            renderToggle: function renderToggle(s) {
              var c = s.isOpen,
                  y = s.onToggle;
              return (0, m.createElement)(v.ToolbarButton, {
                icon: k.search,
                label: (0, _.__)("Zoom"),
                onClick: y,
                "aria-expanded": c,
                disabled: l
              });
            },
            renderContent: function renderContent() {
              return (0, m.createElement)(v.RangeControl, {
                label: (0, _.__)("Zoom"),
                min: y.MIN_ZOOM,
                max: y.MAX_ZOOM,
                value: Math.round(s),
                onChange: c
              });
            }
          });
        };

        var m = c(1753),
            v = c(4892),
            _ = c(6756),
            k = c(2614),
            y = c(9654),
            E = c(146);
      },
      987: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ImageSizeControl(l) {
          var s = l.imageWidth,
              c = l.imageHeight,
              _l$imageSizeOptions = l.imageSizeOptions,
              m = _l$imageSizeOptions === void 0 ? [] : _l$imageSizeOptions,
              _l$isResizable = l.isResizable,
              C = _l$isResizable === void 0 ? !0 : _l$isResizable,
              S = l.slug,
              B = l.width,
              P = l.height,
              O = l.onChange,
              _l$onChangeImage = l.onChangeImage,
              L = _l$onChangeImage === void 0 ? _.noop : _l$onChangeImage;

          var _ref199 = (0, E.default)(P, B, c, s, O),
              V = _ref199.currentHeight,
              R = _ref199.currentWidth,
              A = _ref199.updateDimension,
              z = _ref199.updateDimensions;

          return (0, v.createElement)(v.Fragment, null, !(0, _.isEmpty)(m) && (0, v.createElement)(k.SelectControl, {
            label: (0, y.__)("Image size"),
            value: S,
            options: m,
            onChange: L
          }), C && (0, v.createElement)("div", {
            className: "block-editor-image-size-control"
          }, (0, v.createElement)("p", {
            className: "block-editor-image-size-control__row"
          }, (0, y.__)("Image dimensions")), (0, v.createElement)("div", {
            className: "block-editor-image-size-control__row"
          }, (0, v.createElement)(k.TextControl, {
            type: "number",
            className: "block-editor-image-size-control__width",
            label: (0, y.__)("Width"),
            value: R,
            min: 1,
            onChange: function onChange(l) {
              return A("width", l);
            }
          }), (0, v.createElement)(k.TextControl, {
            type: "number",
            className: "block-editor-image-size-control__height",
            label: (0, y.__)("Height"),
            value: V,
            min: 1,
            onChange: function onChange(l) {
              return A("height", l);
            }
          })), (0, v.createElement)("div", {
            className: "block-editor-image-size-control__row"
          }, (0, v.createElement)(k.ButtonGroup, {
            "aria-label": (0, y.__)("Image size presets")
          }, w.map(function (l) {
            var m = Math.round(s * (l / 100)),
                _ = Math.round(c * (l / 100)),
                y = R === m && V === _;

            return (0, v.createElement)(k.Button, {
              key: l,
              isSmall: !0,
              variant: y ? "primary" : void 0,
              isPressed: y,
              onClick: function onClick() {
                return z(_, m);
              }
            }, l, "%");
          })), (0, v.createElement)(k.Button, {
            isSmall: !0,
            onClick: function onClick() {
              return z();
            }
          }, (0, y.__)("Reset")))));
        };

        var v = c(1753),
            _ = c(4793),
            k = c(4892),
            y = c(6756),
            E = m(c(8967));

        var w = [25, 50, 75, 100];
      },
      8967: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useDimensionHandler(l, s, c, v, _) {
          var k, y;

          var _ref200 = (0, m.useState)(null !== (k = null != s ? s : v) && void 0 !== k ? k : ""),
              _ref201 = _slicedToArray(_ref200, 2),
              E = _ref201[0],
              w = _ref201[1],
              _ref202 = (0, m.useState)(null !== (y = null != l ? l : c) && void 0 !== y ? y : ""),
              _ref203 = _slicedToArray(_ref202, 2),
              C = _ref203[0],
              S = _ref203[1];

          (0, m.useEffect)(function () {
            void 0 === s && void 0 !== v && w(v), void 0 === l && void 0 !== c && S(c);
          }, [v, c]), (0, m.useEffect)(function () {
            void 0 !== s && Number.parseInt(s) !== Number.parseInt(E) && w(s), void 0 !== l && Number.parseInt(l) !== Number.parseInt(C) && S(l);
          }, [s, l]);
          return {
            currentHeight: C,
            currentWidth: E,
            updateDimension: function updateDimension(l, s) {
              "width" === l ? w(s) : S(s), _(_defineProperty({}, l, "" === s ? void 0 : parseInt(s, 10)));
            },
            updateDimensions: function updateDimensions(l, s) {
              S(null != l ? l : c), w(null != s ? s : v), _({
                height: l,
                width: s
              });
            }
          };
        };
        var m = c(1753);
      },
      6330: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        });
        var v = {
          AlignmentControl: !0,
          AlignmentToolbar: !0,
          Autocomplete: !0,
          BlockAlignmentControl: !0,
          BlockAlignmentToolbar: !0,
          __experimentalBlockFullHeightAligmentControl: !0,
          __experimentalBlockAlignmentMatrixControl: !0,
          BlockBreadcrumb: !0,
          __experimentalBlockContentOverlay: !0,
          BlockContextProvider: !0,
          BlockControls: !0,
          BlockFormatControls: !0,
          BlockColorsStyleSelector: !0,
          BlockEdit: !0,
          useBlockEditContext: !0,
          BlockIcon: !0,
          BlockNavigationDropdown: !0,
          __experimentalBlockVariationPicker: !0,
          __experimentalBlockPatternSetup: !0,
          __experimentalBlockVariationTransforms: !0,
          BlockVerticalAlignmentToolbar: !0,
          BlockVerticalAlignmentControl: !0,
          __experimentalBorderRadiusControl: !0,
          __experimentalBorderStyleControl: !0,
          ButtonBlockerAppender: !0,
          ButtonBlockAppender: !0,
          ColorPalette: !0,
          ColorPaletteControl: !0,
          ContrastChecker: !0,
          __experimentalDuotoneControl: !0,
          __experimentalFontAppearanceControl: !0,
          __experimentalFontFamilyControl: !0,
          __experimentalLetterSpacingControl: !0,
          __experimentalTextDecorationControl: !0,
          __experimentalTextTransformControl: !0,
          __experimentalColorGradientControl: !0,
          __experimentalPanelColorGradientSettings: !0,
          __experimentalImageEditor: !0,
          __experimentalImageEditingProvider: !0,
          __experimentalImageSizeControl: !0,
          InnerBlocks: !0,
          useInnerBlocksProps: !0,
          InspectorControls: !0,
          InspectorAdvancedControls: !0,
          JustifyToolbar: !0,
          JustifyContentControl: !0,
          __experimentalLinkControl: !0,
          __experimentalLinkControlSearchInput: !0,
          __experimentalLinkControlSearchResults: !0,
          __experimentalLinkControlSearchItem: !0,
          LineHeightControl: !0,
          __experimentalListView: !0,
          MediaReplaceFlow: !0,
          MediaPlaceholder: !0,
          MediaUpload: !0,
          MediaUploadCheck: !0,
          PanelColorSettings: !0,
          PlainText: !0,
          __experimentalResponsiveBlockControl: !0,
          RichText: !0,
          RichTextShortcut: !0,
          RichTextToolbarButton: !0,
          __unstableRichTextInputEvent: !0,
          ToolSelector: !0,
          __experimentalUnitControl: !0,
          URLInput: !0,
          URLInputButton: !0,
          URLPopover: !0,
          __experimentalImageURLInputUI: !0,
          withColorContext: !0,
          __unstableBlockSettingsMenuFirstItem: !0,
          __unstableInserterMenuExtension: !0,
          __experimentalPreviewOptions: !0,
          __experimentalUseResizeCanvas: !0,
          BlockInspector: !0,
          BlockList: !0,
          useBlockProps: !0,
          __experimentalLayoutStyle: !0,
          BlockMover: !0,
          BlockPreview: !0,
          __experimentalUseBlockPreview: !0,
          BlockSelectionClearer: !0,
          __unstableUseBlockSelectionClearer: !0,
          BlockSettingsMenu: !0,
          BlockSettingsMenuControls: !0,
          BlockTitle: !0,
          BlockToolbar: !0,
          BlockTools: !0,
          CopyHandler: !0,
          __unstableUseClipboardHandler: !0,
          DefaultBlockAppender: !0,
          __unstableEditorStyles: !0,
          Inserter: !0,
          __experimentalLibrary: !0,
          BlockEditorKeyboardShortcuts: !0,
          MultiSelectScrollIntoView: !0,
          NavigableToolbar: !0,
          ObserveTyping: !0,
          __unstableUseTypingObserver: !0,
          __unstableUseMouseMoveTypingReset: !0,
          PreserveScrollInReorder: !0,
          SkipToSelectedBlock: !0,
          Typewriter: !0,
          __unstableUseTypewriter: !0,
          Warning: !0,
          WritingFlow: !0,
          __unstableUseCanvasClickRedirect: !0,
          useBlockDisplayInformation: !0,
          __unstableIframe: !0,
          __experimentalUseNoRecursiveRenders: !0,
          BlockEditorProvider: !0,
          useSetting: !0
        };
        Object.defineProperty(s, "AlignmentControl", {
          enumerable: !0,
          get: function get() {
            return E.AlignmentControl;
          }
        }), Object.defineProperty(s, "AlignmentToolbar", {
          enumerable: !0,
          get: function get() {
            return E.AlignmentToolbar;
          }
        }), Object.defineProperty(s, "Autocomplete", {
          enumerable: !0,
          get: function get() {
            return w.default;
          }
        }), Object.defineProperty(s, "BlockAlignmentControl", {
          enumerable: !0,
          get: function get() {
            return C.BlockAlignmentControl;
          }
        }), Object.defineProperty(s, "BlockAlignmentToolbar", {
          enumerable: !0,
          get: function get() {
            return C.BlockAlignmentToolbar;
          }
        }), Object.defineProperty(s, "BlockBreadcrumb", {
          enumerable: !0,
          get: function get() {
            return P.default;
          }
        }), Object.defineProperty(s, "BlockColorsStyleSelector", {
          enumerable: !0,
          get: function get() {
            return R.default;
          }
        }), Object.defineProperty(s, "BlockContextProvider", {
          enumerable: !0,
          get: function get() {
            return L.BlockContextProvider;
          }
        }), Object.defineProperty(s, "BlockControls", {
          enumerable: !0,
          get: function get() {
            return V.default;
          }
        }), Object.defineProperty(s, "BlockEdit", {
          enumerable: !0,
          get: function get() {
            return A.default;
          }
        }), Object.defineProperty(s, "BlockEditorKeyboardShortcuts", {
          enumerable: !0,
          get: function get() {
            return Je.default;
          }
        }), Object.defineProperty(s, "BlockEditorProvider", {
          enumerable: !0,
          get: function get() {
            return pt.default;
          }
        }), Object.defineProperty(s, "BlockFormatControls", {
          enumerable: !0,
          get: function get() {
            return V.BlockFormatControls;
          }
        }), Object.defineProperty(s, "BlockIcon", {
          enumerable: !0,
          get: function get() {
            return z.default;
          }
        }), Object.defineProperty(s, "BlockInspector", {
          enumerable: !0,
          get: function get() {
            return Ae.default;
          }
        }), Object.defineProperty(s, "BlockList", {
          enumerable: !0,
          get: function get() {
            return ze.default;
          }
        }), Object.defineProperty(s, "BlockMover", {
          enumerable: !0,
          get: function get() {
            return He.default;
          }
        }), Object.defineProperty(s, "BlockNavigationDropdown", {
          enumerable: !0,
          get: function get() {
            return D.default;
          }
        }), Object.defineProperty(s, "BlockPreview", {
          enumerable: !0,
          get: function get() {
            return je.default;
          }
        }), Object.defineProperty(s, "BlockSelectionClearer", {
          enumerable: !0,
          get: function get() {
            return Fe.default;
          }
        }), Object.defineProperty(s, "BlockSettingsMenu", {
          enumerable: !0,
          get: function get() {
            return Ge.default;
          }
        }), Object.defineProperty(s, "BlockSettingsMenuControls", {
          enumerable: !0,
          get: function get() {
            return Ue.default;
          }
        }), Object.defineProperty(s, "BlockTitle", {
          enumerable: !0,
          get: function get() {
            return We.default;
          }
        }), Object.defineProperty(s, "BlockToolbar", {
          enumerable: !0,
          get: function get() {
            return Ke.default;
          }
        }), Object.defineProperty(s, "BlockTools", {
          enumerable: !0,
          get: function get() {
            return $e.default;
          }
        }), Object.defineProperty(s, "BlockVerticalAlignmentControl", {
          enumerable: !0,
          get: function get() {
            return W.BlockVerticalAlignmentControl;
          }
        }), Object.defineProperty(s, "BlockVerticalAlignmentToolbar", {
          enumerable: !0,
          get: function get() {
            return W.BlockVerticalAlignmentToolbar;
          }
        }), Object.defineProperty(s, "ButtonBlockAppender", {
          enumerable: !0,
          get: function get() {
            return q.default;
          }
        }), Object.defineProperty(s, "ButtonBlockerAppender", {
          enumerable: !0,
          get: function get() {
            return q.ButtonBlockerAppender;
          }
        }), Object.defineProperty(s, "ColorPalette", {
          enumerable: !0,
          get: function get() {
            return Y.default;
          }
        }), Object.defineProperty(s, "ColorPaletteControl", {
          enumerable: !0,
          get: function get() {
            return Z.default;
          }
        }), Object.defineProperty(s, "ContrastChecker", {
          enumerable: !0,
          get: function get() {
            return X.default;
          }
        }), Object.defineProperty(s, "CopyHandler", {
          enumerable: !0,
          get: function get() {
            return qe.default;
          }
        }), Object.defineProperty(s, "DefaultBlockAppender", {
          enumerable: !0,
          get: function get() {
            return Ye.default;
          }
        }), Object.defineProperty(s, "InnerBlocks", {
          enumerable: !0,
          get: function get() {
            return se.default;
          }
        }), Object.defineProperty(s, "Inserter", {
          enumerable: !0,
          get: function get() {
            return Xe.default;
          }
        }), Object.defineProperty(s, "InspectorAdvancedControls", {
          enumerable: !0,
          get: function get() {
            return ce.InspectorAdvancedControls;
          }
        }), Object.defineProperty(s, "InspectorControls", {
          enumerable: !0,
          get: function get() {
            return ce.default;
          }
        }), Object.defineProperty(s, "JustifyContentControl", {
          enumerable: !0,
          get: function get() {
            return ue.JustifyContentControl;
          }
        }), Object.defineProperty(s, "JustifyToolbar", {
          enumerable: !0,
          get: function get() {
            return ue.JustifyToolbar;
          }
        }), Object.defineProperty(s, "LineHeightControl", {
          enumerable: !0,
          get: function get() {
            return he.default;
          }
        }), Object.defineProperty(s, "MediaPlaceholder", {
          enumerable: !0,
          get: function get() {
            return be.default;
          }
        }), Object.defineProperty(s, "MediaReplaceFlow", {
          enumerable: !0,
          get: function get() {
            return ve.default;
          }
        }), Object.defineProperty(s, "MediaUpload", {
          enumerable: !0,
          get: function get() {
            return _e.default;
          }
        }), Object.defineProperty(s, "MediaUploadCheck", {
          enumerable: !0,
          get: function get() {
            return ke.default;
          }
        }), Object.defineProperty(s, "MultiSelectScrollIntoView", {
          enumerable: !0,
          get: function get() {
            return et.MultiSelectScrollIntoView;
          }
        }), Object.defineProperty(s, "NavigableToolbar", {
          enumerable: !0,
          get: function get() {
            return tt.default;
          }
        }), Object.defineProperty(s, "ObserveTyping", {
          enumerable: !0,
          get: function get() {
            return nt.default;
          }
        }), Object.defineProperty(s, "PanelColorSettings", {
          enumerable: !0,
          get: function get() {
            return ye.default;
          }
        }), Object.defineProperty(s, "PlainText", {
          enumerable: !0,
          get: function get() {
            return Ee.default;
          }
        }), Object.defineProperty(s, "PreserveScrollInReorder", {
          enumerable: !0,
          get: function get() {
            return ot.default;
          }
        }), Object.defineProperty(s, "RichText", {
          enumerable: !0,
          get: function get() {
            return Ce.default;
          }
        }), Object.defineProperty(s, "RichTextShortcut", {
          enumerable: !0,
          get: function get() {
            return Ce.RichTextShortcut;
          }
        }), Object.defineProperty(s, "RichTextToolbarButton", {
          enumerable: !0,
          get: function get() {
            return Ce.RichTextToolbarButton;
          }
        }), Object.defineProperty(s, "SkipToSelectedBlock", {
          enumerable: !0,
          get: function get() {
            return rt.default;
          }
        }), Object.defineProperty(s, "ToolSelector", {
          enumerable: !0,
          get: function get() {
            return Se.default;
          }
        }), Object.defineProperty(s, "Typewriter", {
          enumerable: !0,
          get: function get() {
            return lt.default;
          }
        }), Object.defineProperty(s, "URLInput", {
          enumerable: !0,
          get: function get() {
            return Pe.default;
          }
        }), Object.defineProperty(s, "URLInputButton", {
          enumerable: !0,
          get: function get() {
            return xe.default;
          }
        }), Object.defineProperty(s, "URLPopover", {
          enumerable: !0,
          get: function get() {
            return Ie.default;
          }
        }), Object.defineProperty(s, "Warning", {
          enumerable: !0,
          get: function get() {
            return it.default;
          }
        }), Object.defineProperty(s, "WritingFlow", {
          enumerable: !0,
          get: function get() {
            return at.default;
          }
        }), Object.defineProperty(s, "__experimentalBlockAlignmentMatrixControl", {
          enumerable: !0,
          get: function get() {
            return B.default;
          }
        }), Object.defineProperty(s, "__experimentalBlockContentOverlay", {
          enumerable: !0,
          get: function get() {
            return O.default;
          }
        }), Object.defineProperty(s, "__experimentalBlockFullHeightAligmentControl", {
          enumerable: !0,
          get: function get() {
            return S.default;
          }
        }), Object.defineProperty(s, "__experimentalBlockPatternSetup", {
          enumerable: !0,
          get: function get() {
            return G.default;
          }
        }), Object.defineProperty(s, "__experimentalBlockVariationPicker", {
          enumerable: !0,
          get: function get() {
            return F.default;
          }
        }), Object.defineProperty(s, "__experimentalBlockVariationTransforms", {
          enumerable: !0,
          get: function get() {
            return U.default;
          }
        }), Object.defineProperty(s, "__experimentalBorderRadiusControl", {
          enumerable: !0,
          get: function get() {
            return K.default;
          }
        }), Object.defineProperty(s, "__experimentalBorderStyleControl", {
          enumerable: !0,
          get: function get() {
            return $.default;
          }
        }), Object.defineProperty(s, "__experimentalColorGradientControl", {
          enumerable: !0,
          get: function get() {
            return re.default;
          }
        }), Object.defineProperty(s, "__experimentalDuotoneControl", {
          enumerable: !0,
          get: function get() {
            return Q.default;
          }
        }), Object.defineProperty(s, "__experimentalFontAppearanceControl", {
          enumerable: !0,
          get: function get() {
            return J.default;
          }
        }), Object.defineProperty(s, "__experimentalFontFamilyControl", {
          enumerable: !0,
          get: function get() {
            return ee.default;
          }
        }), Object.defineProperty(s, "__experimentalImageEditingProvider", {
          enumerable: !0,
          get: function get() {
            return ie.ImageEditingProvider;
          }
        }), Object.defineProperty(s, "__experimentalImageEditor", {
          enumerable: !0,
          get: function get() {
            return ie.default;
          }
        }), Object.defineProperty(s, "__experimentalImageSizeControl", {
          enumerable: !0,
          get: function get() {
            return ae.default;
          }
        }), Object.defineProperty(s, "__experimentalImageURLInputUI", {
          enumerable: !0,
          get: function get() {
            return Me.__experimentalImageURLInputUI;
          }
        }), Object.defineProperty(s, "__experimentalLayoutStyle", {
          enumerable: !0,
          get: function get() {
            return De.LayoutStyle;
          }
        }), Object.defineProperty(s, "__experimentalLetterSpacingControl", {
          enumerable: !0,
          get: function get() {
            return te.default;
          }
        }), Object.defineProperty(s, "__experimentalLibrary", {
          enumerable: !0,
          get: function get() {
            return Qe.default;
          }
        }), Object.defineProperty(s, "__experimentalLinkControl", {
          enumerable: !0,
          get: function get() {
            return de.default;
          }
        }), Object.defineProperty(s, "__experimentalLinkControlSearchInput", {
          enumerable: !0,
          get: function get() {
            return pe.default;
          }
        }), Object.defineProperty(s, "__experimentalLinkControlSearchItem", {
          enumerable: !0,
          get: function get() {
            return fe.default;
          }
        }), Object.defineProperty(s, "__experimentalLinkControlSearchResults", {
          enumerable: !0,
          get: function get() {
            return me.default;
          }
        }), Object.defineProperty(s, "__experimentalListView", {
          enumerable: !0,
          get: function get() {
            return ge.default;
          }
        }), Object.defineProperty(s, "__experimentalPanelColorGradientSettings", {
          enumerable: !0,
          get: function get() {
            return le.default;
          }
        }), Object.defineProperty(s, "__experimentalPreviewOptions", {
          enumerable: !0,
          get: function get() {
            return Ve.default;
          }
        }), Object.defineProperty(s, "__experimentalResponsiveBlockControl", {
          enumerable: !0,
          get: function get() {
            return we.default;
          }
        }), Object.defineProperty(s, "__experimentalTextDecorationControl", {
          enumerable: !0,
          get: function get() {
            return ne.default;
          }
        }), Object.defineProperty(s, "__experimentalTextTransformControl", {
          enumerable: !0,
          get: function get() {
            return oe.default;
          }
        }), Object.defineProperty(s, "__experimentalUnitControl", {
          enumerable: !0,
          get: function get() {
            return Be.default;
          }
        }), Object.defineProperty(s, "__experimentalUseBlockPreview", {
          enumerable: !0,
          get: function get() {
            return je.useBlockPreview;
          }
        }), Object.defineProperty(s, "__experimentalUseNoRecursiveRenders", {
          enumerable: !0,
          get: function get() {
            return dt.default;
          }
        }), Object.defineProperty(s, "__experimentalUseResizeCanvas", {
          enumerable: !0,
          get: function get() {
            return Re.default;
          }
        }), Object.defineProperty(s, "__unstableBlockSettingsMenuFirstItem", {
          enumerable: !0,
          get: function get() {
            return Oe.default;
          }
        }), Object.defineProperty(s, "__unstableEditorStyles", {
          enumerable: !0,
          get: function get() {
            return Ze.default;
          }
        }), Object.defineProperty(s, "__unstableIframe", {
          enumerable: !0,
          get: function get() {
            return ut.default;
          }
        }), Object.defineProperty(s, "__unstableInserterMenuExtension", {
          enumerable: !0,
          get: function get() {
            return Le.default;
          }
        }), Object.defineProperty(s, "__unstableRichTextInputEvent", {
          enumerable: !0,
          get: function get() {
            return Ce.__unstableRichTextInputEvent;
          }
        }), Object.defineProperty(s, "__unstableUseBlockSelectionClearer", {
          enumerable: !0,
          get: function get() {
            return Fe.useBlockSelectionClearer;
          }
        }), Object.defineProperty(s, "__unstableUseCanvasClickRedirect", {
          enumerable: !0,
          get: function get() {
            return st.useCanvasClickRedirect;
          }
        }), Object.defineProperty(s, "__unstableUseClipboardHandler", {
          enumerable: !0,
          get: function get() {
            return qe.useClipboardHandler;
          }
        }), Object.defineProperty(s, "__unstableUseMouseMoveTypingReset", {
          enumerable: !0,
          get: function get() {
            return nt.useMouseMoveTypingReset;
          }
        }), Object.defineProperty(s, "__unstableUseTypewriter", {
          enumerable: !0,
          get: function get() {
            return lt.useTypewriter;
          }
        }), Object.defineProperty(s, "__unstableUseTypingObserver", {
          enumerable: !0,
          get: function get() {
            return nt.useTypingObserver;
          }
        }), Object.defineProperty(s, "useBlockDisplayInformation", {
          enumerable: !0,
          get: function get() {
            return ct.default;
          }
        }), Object.defineProperty(s, "useBlockEditContext", {
          enumerable: !0,
          get: function get() {
            return A.useBlockEditContext;
          }
        }), Object.defineProperty(s, "useBlockProps", {
          enumerable: !0,
          get: function get() {
            return Ne.useBlockProps;
          }
        }), Object.defineProperty(s, "useInnerBlocksProps", {
          enumerable: !0,
          get: function get() {
            return se.useInnerBlocksProps;
          }
        }), Object.defineProperty(s, "useSetting", {
          enumerable: !0,
          get: function get() {
            return mt.default;
          }
        }), Object.defineProperty(s, "withColorContext", {
          enumerable: !0,
          get: function get() {
            return Te.default;
          }
        });

        var _ = c(4459);

        Object.keys(_).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (Object.prototype.hasOwnProperty.call(v, l) || l in s && s[l] === _[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return _[l];
            }
          }));
        });
        var k = c(5261);
        Object.keys(k).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (Object.prototype.hasOwnProperty.call(v, l) || l in s && s[l] === k[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return k[l];
            }
          }));
        });
        var y = c(1184);
        Object.keys(y).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (Object.prototype.hasOwnProperty.call(v, l) || l in s && s[l] === y[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return y[l];
            }
          }));
        });

        var E = c(7916),
            w = m(c(9640)),
            C = c(6899),
            S = m(c(2068)),
            B = m(c(5641)),
            P = m(c(3527)),
            O = m(c(3082)),
            L = c(5038),
            V = _interopRequireWildcard(c(915)),
            R = m(c(1937)),
            A = _interopRequireWildcard(c(5490)),
            z = m(c(2006)),
            D = m(c(9851)),
            F = m(c(3562)),
            G = m(c(2634)),
            U = m(c(5045)),
            W = c(4981),
            K = m(c(2398)),
            $ = m(c(4495)),
            q = _interopRequireWildcard(c(6403)),
            Y = m(c(3391)),
            Z = m(c(206)),
            X = m(c(4346)),
            Q = m(c(8003)),
            J = m(c(4601)),
            ee = m(c(1052)),
            te = m(c(9312)),
            ne = m(c(7731)),
            oe = m(c(4286)),
            re = m(c(91)),
            le = m(c(8251)),
            ie = _interopRequireWildcard(c(2645)),
            ae = m(c(987)),
            se = _interopRequireWildcard(c(1337)),
            ce = _interopRequireWildcard(c(5071)),
            ue = c(1630),
            de = m(c(2631)),
            pe = m(c(1609)),
            me = m(c(4581)),
            fe = m(c(2012)),
            he = m(c(1628)),
            ge = m(c(609)),
            ve = m(c(5892)),
            be = m(c(7666)),
            _e = m(c(4625)),
            ke = m(c(2596)),
            ye = m(c(5995)),
            Ee = m(c(2571)),
            we = m(c(554)),
            Ce = _interopRequireWildcard(c(1700)),
            Se = m(c(7436)),
            Be = m(c(6140)),
            Pe = m(c(5852)),
            xe = m(c(6716)),
            Ie = m(c(3390)),
            Me = c(5073),
            Te = m(c(9452)),
            Oe = m(c(8123)),
            Le = m(c(4193)),
            Ve = m(c(5016)),
            Re = m(c(9458)),
            Ae = m(c(1404)),
            ze = m(c(9476)),
            Ne = c(2885),
            De = c(7189),
            He = m(c(7547)),
            je = _interopRequireWildcard(c(8958)),
            Fe = _interopRequireWildcard(c(5920)),
            Ge = m(c(4311)),
            Ue = m(c(6056)),
            We = m(c(6147)),
            Ke = m(c(6823)),
            $e = m(c(8478)),
            qe = _interopRequireWildcard(c(303)),
            Ye = m(c(4546)),
            Ze = m(c(2489)),
            Xe = m(c(1517)),
            Qe = m(c(1330)),
            Je = m(c(5357)),
            et = c(6599),
            tt = m(c(9375)),
            nt = _interopRequireWildcard(c(6472)),
            ot = m(c(9180)),
            rt = m(c(39)),
            lt = _interopRequireWildcard(c(9386)),
            it = m(c(4578)),
            at = m(c(2678)),
            st = c(1228),
            ct = m(c(139)),
            ut = m(c(9821)),
            dt = m(c(7273)),
            pt = m(c(6375)),
            mt = m(c(3081));

        function _getRequireWildcardCache(l) {
          if ("function" != typeof WeakMap) return null;
          var s = new WeakMap(),
              c = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(l) {
            return l ? c : s;
          })(l);
        }

        function _interopRequireWildcard(l, s) {
          if (!s && l && l.__esModule) return l;
          if (null === l || "object" != typeof l && "function" != typeof l) return {
            default: l
          };

          var c = _getRequireWildcardCache(s);

          if (c && c.has(l)) return c.get(l);
          var m = {},
              v = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var _ in l) {
            if ("default" !== _ && Object.prototype.hasOwnProperty.call(l, _)) {
              var k = v ? Object.getOwnPropertyDescriptor(l, _) : null;
              k && (k.get || k.set) ? Object.defineProperty(m, _, k) : m[_] = l[_];
            }
          }

          return m.default = l, c && c.set(l, m), m;
        }
      },
      2811: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.ButtonBlockAppender = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = m(c(6403)),
            y = m(c(8132));

        var ButtonBlockAppender = function ButtonBlockAppender(l) {
          var s = l.clientId,
              c = l.showSeparator,
              m = l.isFloating,
              y = l.onAddBlock,
              E = l.isToggle;
          return (0, v.createElement)(k.default, {
            className: (0, _.default)({
              "block-list-appender__toggle": E
            }),
            rootClientId: s,
            showSeparator: c,
            isFloating: m,
            onAddBlock: y
          });
        };

        s.ButtonBlockAppender = ButtonBlockAppender;
        var E = (0, y.default)(ButtonBlockAppender);
        s.default = E;
      },
      8814: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.DefaultBlockAppender = void 0;

        var v = c(1753),
            _ = c(4793),
            k = c(3200),
            y = c(8467),
            E = m(c(4546)),
            w = m(c(8132)),
            C = c(8486);

        var DefaultBlockAppender = function DefaultBlockAppender(l) {
          var s = l.clientId,
              c = l.lastBlockClientId;
          return (0, v.createElement)(E.default, {
            rootClientId: s,
            lastBlockClientId: c
          });
        };

        s.DefaultBlockAppender = DefaultBlockAppender;
        var S = (0, k.compose)([w.default, (0, y.withSelect)(function (l, s) {
          var c = s.clientId;

          var _l92 = l(C.store),
              m = _l92.getBlockOrder,
              v = m(c);

          return {
            lastBlockClientId: (0, _.last)(v)
          };
        })])(DefaultBlockAppender);
        s.default = S;
      },
      7672: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function getBlockContext(l, s) {
          v.has(s) || v.set(s, new WeakMap());
          var c = v.get(s);

          if (!c.has(l)) {
            var _v14 = (0, m.mapValues)(s.providesContext, function (s) {
              return l[s];
            });

            c.set(l, _v14);
          }

          return c.get(l);
        };
        var m = c(4793);
        var v = new WeakMap();
      },
      1337: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0, s.useInnerBlocksProps = useInnerBlocksProps;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(3200),
            E = c(8467),
            w = c(6700),
            C = m(c(2811)),
            S = m(c(8814)),
            B = m(c(2121)),
            P = m(c(8902)),
            O = m(c(7672)),
            L = c(9476),
            V = c(5038),
            R = c(7310),
            A = m(c(3683)),
            z = c(8486),
            D = m(c(9522));

        function UncontrolledInnerBlocks(l) {
          var s = l.clientId,
              c = l.allowedBlocks,
              m = l.__experimentalDefaultBlock,
              _ = l.__experimentalDirectInsert,
              k = l.template,
              y = l.templateLock,
              C = l.wrapperRef,
              S = l.templateInsertUpdatesSelection,
              R = l.__experimentalCaptureToolbars,
              A = l.__experimentalAppenderTagName,
              D = l.renderAppender,
              F = l.orientation,
              G = l.placeholder,
              U = l.__experimentalLayout;
          (0, B.default)(s, c, m, _, y, R, F, U), (0, P.default)(s, k, y, S);
          var W = (0, E.useSelect)(function (l) {
            var c = l(z.store).getBlock(s),
                m = (0, w.getBlockType)(c.name);
            if (m && m.providesContext) return (0, O.default)(c.attributes, m);
          }, [s]);
          return (0, v.createElement)(V.BlockContextProvider, {
            value: W
          }, (0, v.createElement)(L.BlockListItems, {
            rootClientId: s,
            renderAppender: D,
            __experimentalAppenderTagName: A,
            __experimentalLayout: U,
            wrapperRef: C,
            placeholder: G
          }));
        }

        function ControlledInnerBlocks(l) {
          return (0, A.default)(l), (0, v.createElement)(UncontrolledInnerBlocks, l);
        }

        var F = (0, v.forwardRef)(function (l, s) {
          var c = useInnerBlocksProps({
            ref: s
          }, l);
          return (0, v.createElement)("div", {
            className: "block-editor-inner-blocks"
          }, (0, v.createElement)("div", c));
        });

        function useInnerBlocksProps() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

          var _ref205 = (0, R.useBlockEditContext)(),
              c = _ref205.clientId,
              m = (0, y.useViewportMatch)("medium", "<"),
              _ref206 = (0, E.useSelect)(function (l) {
            if (!c) return {};

            var _l93 = l(z.store),
                s = _l93.getBlockName,
                v = _l93.isBlockSelected,
                _ = _l93.hasSelectedInnerBlock,
                k = _l93.isNavigationMode,
                y = s(c),
                E = k() || m;

            return {
              __experimentalCaptureToolbars: l(w.store).hasBlockSupport(y, "__experimentalExposeControlsToChildren", !1),
              hasOverlay: "core/template" !== y && !v(c) && !_(c, !0) && E
            };
          }, [c, m]),
              C = _ref206.__experimentalCaptureToolbars,
              S = _ref206.hasOverlay,
              B = (0, y.useMergeRefs)([l.ref, (0, D.default)({
            rootClientId: c
          })]),
              P = _objectSpread({
            __experimentalCaptureToolbars: C
          }, s),
              O = P.value && P.onChange ? ControlledInnerBlocks : UncontrolledInnerBlocks;

          return _objectSpread(_objectSpread({}, l), {}, {
            ref: B,
            className: (0, k.default)(l.className, "block-editor-block-list__layout", {
              "has-overlay": S
            }),
            children: c ? (0, v.createElement)(O, (0, _.default)({}, P, {
              clientId: c
            })) : (0, v.createElement)(L.BlockListItems, s)
          });
        }

        useInnerBlocksProps.save = w.__unstableGetInnerBlocksProps, F.DefaultBlockAppender = S.default, F.ButtonBlockAppender = C.default, F.Content = function () {
          return useInnerBlocksProps.save().children;
        };
        var G = F;
        s.default = G;
      },
      8902: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useInnerBlockTemplateSync(l, s, c, E) {
          var _ref207 = (0, _.useSelect)(y.store),
              w = _ref207.getSelectedBlocksInitialCaretPosition,
              _ref208 = (0, _.useDispatch)(y.store),
              C = _ref208.replaceInnerBlocks,
              S = (0, _.useSelect)(function (s) {
            return s(y.store).getBlocks(l);
          }, [l]),
              B = (0, v.useRef)(null);

          (0, v.useLayoutEffect)(function () {
            if (0 === S.length || "all" === c) {
              if (!(0, m.isEqual)(s, B.current)) {
                B.current = s;

                var _c34 = (0, k.synchronizeBlocksWithTemplate)(S, s);

                (0, m.isEqual)(_c34, S) || C(l, _c34, 0 === S.length && E && 0 !== _c34.length, w());
              }
            }
          }, [S, s, c, l]);
        };

        var m = c(4793),
            v = c(1753),
            _ = c(8467),
            k = c(6700),
            y = c(8486);
      },
      2121: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useNestedSettingsUpdate(l, s, c, m, w, C, S, B) {
          var _ref209 = (0, _.useDispatch)(y.store),
              P = _ref209.updateBlockListSettings,
              _ref210 = (0, _.useSelect)(function (s) {
            var c = s(y.store).getBlockRootClientId(l);
            return {
              blockListSettings: s(y.store).getBlockListSettings(l),
              parentLock: s(y.store).getTemplateLock(c)
            };
          }, [l]),
              O = _ref210.blockListSettings,
              L = _ref210.parentLock,
              V = (0, v.useMemo)(function () {
            return s;
          }, s);

          (0, v.useLayoutEffect)(function () {
            var s = {
              allowedBlocks: V,
              templateLock: void 0 === w ? L : w
            };
            if (void 0 !== C && (s.__experimentalCaptureToolbars = C), void 0 !== S) s.orientation = S;else {
              var _l94 = (0, E.getLayoutType)(null == B ? void 0 : B.type);

              s.orientation = _l94.getOrientation(B);
            }
            void 0 !== c && (s.__experimentalDefaultBlock = c), void 0 !== m && (s.__experimentalDirectInsert = m), (0, k.default)(O, s) || P(l, s);
          }, [l, O, V, c, m, w, L, C, S, P, B]);
        };

        var v = c(1753),
            _ = c(8467),
            k = m(c(626)),
            y = c(8486),
            E = c(6633);
      },
      8132: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(3200),
            y = c(7310);

        var E = (0, k.createHigherOrderComponent)(function (l) {
          return function (s) {
            var _ref211 = (0, y.useBlockEditContext)(),
                c = _ref211.clientId;

            return (0, v.createElement)(l, (0, _.default)({}, s, {
              clientId: c
            }));
          };
        }, "withClientId");
        s.default = E;
      },
      3157: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4892),
            k = m(c(6117));

        var _default = function _default(l) {
          var s = l.isEnabled,
              c = l.blocks,
              m = l.icon,
              y = l.children;
          var E = {
            type: "inserter",
            blocks: c
          };
          return (0, v.createElement)(_.Draggable, {
            __experimentalTransferDataType: "wp-blocks",
            transferData: E,
            __experimentalDragComponent: (0, v.createElement)(k.default, {
              count: c.length,
              icon: m
            })
          }, function (l) {
            var c = l.onDraggableStart,
                m = l.onDraggableEnd;
            return y({
              draggable: s,
              onDragStart: s ? c : void 0,
              onDragEnd: s ? m : void 0
            });
          });
        };

        s.default = _default;
      },
      4983: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(6700),
            E = c(9880),
            w = m(c(2006)),
            C = c(9776),
            S = m(c(3157));

        function isAppleOS() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window;
          var s = l.navigator.platform;
          return -1 !== s.indexOf("Mac") || ["iPad", "iPhone"].includes(s);
        }

        var B = (0, v.memo)(function InserterListItem(l) {
          var s = l.className,
              c = l.isFirst,
              m = l.item,
              B = l.onSelect,
              P = l.onHover,
              O = l.isDraggable,
              L = _objectWithoutProperties(l, _excluded21);

          var V = (0, v.useRef)(!1),
              R = m.icon ? {
            backgroundColor: m.icon.background,
            color: m.icon.foreground
          } : {},
              A = (0, v.useMemo)(function () {
            return [(0, y.createBlock)(m.name, m.initialAttributes, (0, y.createBlocksFromInnerBlocksTemplate)(m.innerBlocks))];
          }, [m.name, m.initialAttributes, m.initialAttributes]);
          return (0, v.createElement)(S.default, {
            isEnabled: O && !m.disabled,
            blocks: A,
            icon: m.icon
          }, function (l) {
            var y = l.draggable,
                S = l.onDragStart,
                O = l.onDragEnd;
            return (0, v.createElement)("div", {
              className: "block-editor-block-types-list__list-item",
              draggable: y,
              onDragStart: function onDragStart(l) {
                V.current = !0, S && (P(null), S(l));
              },
              onDragEnd: function onDragEnd(l) {
                V.current = !1, O && O(l);
              }
            }, (0, v.createElement)(C.InserterListboxItem, (0, _.default)({
              isFirst: c,
              className: (0, k.default)("block-editor-block-types-list__item", s),
              disabled: m.isDisabled,
              onClick: function onClick(l) {
                l.preventDefault(), B(m, isAppleOS() ? l.metaKey : l.ctrlKey), P(null);
              },
              onKeyDown: function onKeyDown(l) {
                var s = l.keyCode;
                s === E.ENTER && (l.preventDefault(), B(m, isAppleOS() ? l.metaKey : l.ctrlKey), P(null));
              },
              onFocus: function onFocus() {
                V.current || P(m);
              },
              onMouseEnter: function onMouseEnter() {
                V.current || P(m);
              },
              onMouseLeave: function onMouseLeave() {
                return P(null);
              },
              onBlur: function onBlur() {
                return P(null);
              }
            }, L), (0, v.createElement)("span", {
              className: "block-editor-block-types-list__item-icon",
              style: R
            }, (0, v.createElement)(w.default, {
              icon: m.icon,
              showColors: !0
            })), (0, v.createElement)("span", {
              className: "block-editor-block-types-list__item-title"
            }, m.title)));
          });
        });
        s.default = B;
      },
      1287: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = (0, c(1753).createContext)();
        s.default = m;
      },
      1054: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(6756),
            y = c(9773);

        var E = (0, v.forwardRef)(function InserterListboxGroup(l, s) {
          var _ref212 = (0, v.useState)(!1),
              _ref213 = _slicedToArray(_ref212, 2),
              c = _ref213[0],
              m = _ref213[1];

          return (0, v.useEffect)(function () {
            c && (0, y.speak)((0, k.__)("Use left and right arrow keys to move through blocks"));
          }, [c]), (0, v.createElement)("div", (0, _.default)({
            ref: s,
            role: "listbox",
            "aria-orientation": "horizontal",
            onFocus: function onFocus() {
              m(!0);
            },
            onBlur: function onBlur(l) {
              !l.currentTarget.contains(l.relatedTarget) && m(!1);
            }
          }, l));
        });
        s.default = E;
      },
      9776: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), Object.defineProperty(s, "InserterListboxGroup", {
          enumerable: !0,
          get: function get() {
            return y.default;
          }
        }), Object.defineProperty(s, "InserterListboxItem", {
          enumerable: !0,
          get: function get() {
            return w.default;
          }
        }), Object.defineProperty(s, "InserterListboxRow", {
          enumerable: !0,
          get: function get() {
            return E.default;
          }
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4892),
            k = m(c(1287)),
            y = m(c(1054)),
            E = m(c(271)),
            w = m(c(2108));

        var C = function InserterListbox(l) {
          var s = l.children;
          var c = (0, _.__unstableUseCompositeState)({
            shift: !0,
            wrap: "horizontal"
          });
          return (0, v.createElement)(k.default.Provider, {
            value: c
          }, s);
        };

        s.default = C;
      },
      2108: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = m(c(1287));

        var E = (0, v.forwardRef)(function InserterListboxItem(l, s) {
          var c = l.isFirst,
              m = l.as,
              E = l.children,
              w = _objectWithoutProperties(l, _excluded22);

          var C = (0, v.useContext)(y.default);
          return (0, v.createElement)(k.__unstableCompositeItem, (0, _.default)({
            ref: s,
            state: C,
            role: "option",
            focusable: !0
          }, w), function (l) {
            var s = _objectSpread(_objectSpread({}, l), {}, {
              tabIndex: c ? 0 : l.tabIndex
            });

            return m ? (0, v.createElement)(m, s, E) : "function" == typeof E ? E(s) : (0, v.createElement)(k.Button, s, E);
          });
        });
        s.default = E;
      },
      271: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = m(c(1287));

        var E = (0, v.forwardRef)(function InserterListboxRow(l, s) {
          var c = (0, v.useContext)(y.default);
          return (0, v.createElement)(k.__unstableCompositeGroup, (0, _.default)({
            state: c,
            role: "presentation",
            ref: s
          }, l));
        });
        s.default = E;
      },
      4193: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(4892);

        var _ref214 = (0, m.createSlotFill)("__unstableInserterMenuExtension"),
            v = _ref214.Fill,
            _ = _ref214.Slot;

        v.Slot = _;
        var k = v;
        s.default = k;
      },
      9495: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4892),
            k = c(6756),
            y = m(c(7623)),
            E = m(c(4907));

        function PatternsExplorer(l) {
          var s = l.initialCategory,
              c = l.patternCategories;

          var _ref215 = (0, v.useState)(""),
              _ref216 = _slicedToArray(_ref215, 2),
              m = _ref216[0],
              _ = _ref216[1],
              _ref217 = (0, v.useState)(null == s ? void 0 : s.name),
              _ref218 = _slicedToArray(_ref217, 2),
              k = _ref218[0],
              w = _ref218[1];

          return (0, v.createElement)("div", {
            className: "block-editor-block-patterns-explorer"
          }, (0, v.createElement)(y.default, {
            selectedCategory: k,
            patternCategories: c,
            onClickCategory: w,
            filterValue: m,
            setFilterValue: _
          }), (0, v.createElement)(E.default, {
            filterValue: m,
            selectedCategory: k,
            patternCategories: c
          }));
        }

        var w = function PatternsExplorerModal(l) {
          var s = l.onModalClose,
              c = _objectWithoutProperties(l, _excluded23);

          return (0, v.createElement)(_.Modal, {
            title: (0, k.__)("Patterns"),
            closeLabel: (0, k.__)("Close"),
            onRequestClose: s,
            isFullScreen: !0
          }, (0, v.createElement)(PatternsExplorer, c));
        };

        s.default = w;
      },
      4907: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(6756),
            k = c(3200),
            y = c(4892),
            E = c(9773),
            w = m(c(5511)),
            C = m(c(7977)),
            S = m(c(3982)),
            B = m(c(4671)),
            P = m(c(9776)),
            O = c(8026);

        function PatternsListHeader(l) {
          var s = l.filterValue,
              c = l.filteredBlockPatternsLength;
          return s ? (0, v.createElement)(y.__experimentalHeading, {
            level: 2,
            lineHeight: "48px",
            className: "block-editor-block-patterns-explorer__search-results-count"
          }, (0, _.sprintf)((0, _._n)('%1$d pattern found for "%2$s"', '%1$d patterns found for "%2$s"', c), c, s)) : null;
        }

        var L = function PatternList(l) {
          var s = l.filterValue,
              c = l.selectedCategory,
              m = l.patternCategories;

          var y = (0, k.useDebounce)(E.speak, 500),
              _ref219 = (0, S.default)({
            shouldFocusBlock: !0
          }),
              _ref220 = _slicedToArray(_ref219, 2),
              L = _ref220[0],
              V = _ref220[1],
              _ref221 = (0, B.default)(V, L),
              _ref222 = _slicedToArray(_ref221, 3),
              R = _ref222[0],
              A = _ref222[2],
              z = (0, v.useMemo)(function () {
            return m.map(function (l) {
              return l.name;
            });
          }, [m]),
              D = (0, v.useMemo)(function () {
            return s ? (0, O.searchItems)(R, s) : R.filter(function (l) {
              var s, m;
              return "uncategorized" === c ? !(null !== (s = l.categories) && void 0 !== s && s.length) || l.categories.every(function (l) {
                return !z.includes(l);
              }) : null === (m = l.categories) || void 0 === m ? void 0 : m.includes(c);
            });
          }, [s, c, R]);

          (0, v.useEffect)(function () {
            if (!s) return;
            var l = D.length,
                c = (0, _.sprintf)((0, _._n)("%d result found.", "%d results found.", l), l);
            y(c);
          }, [s, y]);
          var F = (0, k.useAsyncList)(D, {
            step: 2
          }),
              G = !(null == D || !D.length);
          return (0, v.createElement)("div", {
            className: "block-editor-block-patterns-explorer__list"
          }, G && (0, v.createElement)(PatternsListHeader, {
            filterValue: s,
            filteredBlockPatternsLength: D.length
          }), (0, v.createElement)(P.default, null, !G && (0, v.createElement)(C.default, null), G && (0, v.createElement)(w.default, {
            shownPatterns: F,
            blockPatterns: D,
            onClickPattern: A,
            isDraggable: !1
          })));
        };

        s.default = L;
      },
      7623: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(4892),
            _ = c(6756);

        function PatternCategoriesList(l) {
          var s = l.selectedCategory,
              c = l.patternCategories,
              _ = l.onClickCategory;
          var k = "block-editor-block-patterns-explorer__sidebar";
          return (0, m.createElement)("div", {
            className: "".concat(k, "__categories-list")
          }, c.map(function (l) {
            var c = l.name,
                y = l.label;
            return (0, m.createElement)(v.Button, {
              key: c,
              label: y,
              className: "".concat(k, "__categories-list__item"),
              isPressed: s === c,
              onClick: function onClick() {
                _(c);
              }
            }, y);
          }));
        }

        function PatternsExplorerSearch(l) {
          var s = l.filterValue,
              c = l.setFilterValue;
          return (0, m.createElement)("div", {
            className: "block-editor-block-patterns-explorer__search"
          }, (0, m.createElement)(v.SearchControl, {
            onChange: c,
            value: s,
            label: (0, _.__)("Search for patterns"),
            placeholder: (0, _.__)("Search")
          }));
        }

        var k = function PatternExplorerSidebar(l) {
          var s = l.selectedCategory,
              c = l.patternCategories,
              v = l.onClickCategory,
              _ = l.filterValue,
              k = l.setFilterValue;
          return (0, m.createElement)("div", {
            className: "block-editor-block-patterns-explorer__sidebar"
          }, (0, m.createElement)(PatternsExplorerSearch, {
            filterValue: _,
            setFilterValue: k
          }), !_ && (0, m.createElement)(PatternCategoriesList, {
            selectedCategory: s,
            patternCategories: c,
            onClickCategory: v
          }));
        };

        s.default = k;
      },
      7926: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(6756),
            k = c(3200),
            y = m(c(2909)),
            E = m(c(4671)),
            w = m(c(5511)),
            C = m(c(9495));

        function BlockPatternsCategory(l) {
          var s = l.rootClientId,
              c = l.onInsert,
              m = l.selectedCategory,
              _ = l.populatedCategories;

          var _ref223 = (0, E.default)(c, s),
              _ref224 = _slicedToArray(_ref223, 3),
              y = _ref224[0],
              C = _ref224[2],
              S = (0, v.useCallback)(function (l) {
            var s;
            if (null === (s = l.categories) || void 0 === s || !s.length) return 1 / 0;

            var c = _.reduce(function (l, s, c) {
              var m = s.name;
              return l[m] = c, l;
            }, {});

            return Math.min.apply(Math, _toConsumableArray(l.categories.map(function (l) {
              return void 0 !== c[l] ? c[l] : 1 / 0;
            })));
          }, [_]),
              B = (0, v.useMemo)(function () {
            return y.filter(function (l) {
              var s;
              return "uncategorized" === m.name ? S(l) === 1 / 0 : null === (s = l.categories) || void 0 === s ? void 0 : s.includes(m.name);
            });
          }, [y, m]),
              P = (0, v.useMemo)(function () {
            return B.sort(function (l, s) {
              return S(l) - S(s);
            });
          }, [B, S]),
              O = (0, k.useAsyncList)(P);

          return B.length ? (0, v.createElement)("div", {
            className: "block-editor-inserter__panel-content"
          }, (0, v.createElement)(w.default, {
            shownPatterns: O,
            blockPatterns: B,
            onClickPattern: C,
            label: m.label,
            orientation: "vertical",
            isDraggable: !0
          })) : null;
        }

        var S = function BlockPatternsTabs(l) {
          var s = l.rootClientId,
              c = l.onInsert,
              m = l.onClickCategory,
              k = l.selectedCategory;

          var _ref225 = (0, v.useState)(!1),
              _ref226 = _slicedToArray(_ref225, 2),
              w = _ref226[0],
              S = _ref226[1],
              _ref227 = (0, E.default)(),
              _ref228 = _slicedToArray(_ref227, 2),
              B = _ref228[0],
              P = _ref228[1],
              O = (0, v.useCallback)(function (l) {
            return !(!l.categories || !l.categories.length) && l.categories.some(function (l) {
              return P.some(function (s) {
                return s.name === l;
              });
            });
          }, [P]),
              L = (0, v.useMemo)(function () {
            var l = P.filter(function (l) {
              return B.some(function (s) {
                var c;
                return null === (c = s.categories) || void 0 === c ? void 0 : c.includes(l.name);
              });
            }).sort(function (l, s) {
              var c = l.name,
                  m = s.name;
              return [c, m].includes("featured") ? "featured" === c ? -1 : 1 : 0;
            });
            return B.some(function (l) {
              return !O(l);
            }) && !l.find(function (l) {
              return "uncategorized" === l.name;
            }) && l.push({
              name: "uncategorized",
              label: (0, _._x)("Uncategorized")
            }), l;
          }, [B, P]),
              V = k || L[0];

          return (0, v.createElement)(v.Fragment, null, !w && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.default, {
            selectedCategory: V,
            patternCategories: L,
            onClickCategory: m,
            openPatternExplorer: function openPatternExplorer() {
              return S(!0);
            }
          }), (0, v.createElement)(BlockPatternsCategory, {
            rootClientId: s,
            onInsert: c,
            selectedCategory: V,
            populatedCategories: L
          })), w && (0, v.createElement)(C.default, {
            initialCategory: V,
            patternCategories: L,
            onModalClose: function onModalClose() {
              return S(!1);
            }
          }));
        };

        s.default = S;
      },
      459: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockTypesTab = BlockTypesTab, s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            k = c(6756),
            y = c(3200),
            E = m(c(2706)),
            w = m(c(2636)),
            C = m(c(8081)),
            S = m(c(9776));

        var B = [];

        function BlockTypesTab(l) {
          var s = l.rootClientId,
              c = l.onInsert,
              m = l.onHover,
              P = l.showMostUsedBlocks;

          var _ref229 = (0, C.default)(s, c),
              _ref230 = _slicedToArray(_ref229, 4),
              O = _ref230[0],
              L = _ref230[1],
              V = _ref230[2],
              R = _ref230[3],
              A = (0, v.useMemo)(function () {
            return (0, _.orderBy)(O, ["frecency"], ["desc"]).slice(0, 6);
          }, [O]),
              z = (0, v.useMemo)(function () {
            return O.filter(function (l) {
              return !l.category;
            });
          }, [O]),
              D = (0, v.useMemo)(function () {
            return (0, _.flow)(function (l) {
              return l.filter(function (l) {
                return l.category && "reusable" !== l.category;
              });
            }, function (l) {
              return (0, _.groupBy)(l, "category");
            })(O);
          }, [O]),
              F = (0, v.useMemo)(function () {
            var l = _objectSpread({}, V);

            return Object.keys(V).forEach(function (s) {
              l[s] = O.filter(function (l) {
                return function (l) {
                  return l.name.split("/")[0];
                }(l) === s;
              }), 0 === l[s].length && delete l[s];
            }), l;
          }, [O, V]);

          (0, v.useEffect)(function () {
            return function () {
              return m(null);
            };
          }, []);
          var G = (0, y.useAsyncList)(L),
              U = L.length === G.length,
              W = (0, v.useMemo)(function () {
            return Object.entries(V);
          }, [V]),
              K = (0, y.useAsyncList)(U ? W : B);
          return (0, v.createElement)(S.default, null, (0, v.createElement)("div", null, P && !!A.length && (0, v.createElement)(w.default, {
            title: (0, k._x)("Most used", "blocks")
          }, (0, v.createElement)(E.default, {
            items: A,
            onSelect: R,
            onHover: m,
            label: (0, k._x)("Most used", "blocks")
          })), (0, _.map)(G, function (l) {
            var s = D[l.slug];
            return s && s.length ? (0, v.createElement)(w.default, {
              key: l.slug,
              title: l.title,
              icon: l.icon
            }, (0, v.createElement)(E.default, {
              items: s,
              onSelect: R,
              onHover: m,
              label: l.title
            })) : null;
          }), U && z.length > 0 && (0, v.createElement)(w.default, {
            className: "block-editor-inserter__uncategorized-blocks-panel",
            title: (0, k.__)("Uncategorized")
          }, (0, v.createElement)(E.default, {
            items: z,
            onSelect: R,
            onHover: m,
            label: (0, k.__)("Uncategorized")
          })), (0, _.map)(K, function (l) {
            var _l95 = _slicedToArray(l, 2),
                s = _l95[0],
                c = _l95[1];

            var _ = F[s];
            return _ && _.length ? (0, v.createElement)(w.default, {
              key: s,
              title: c.title,
              icon: c.icon
            }, (0, v.createElement)(E.default, {
              items: _,
              onSelect: R,
              onHover: m,
              label: c.title
            })) : null;
          })));
        }

        var P = BlockTypesTab;
        s.default = P;
      },
      8081: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(6700),
            v = c(8467),
            _ = c(1753),
            k = c(8486);

        var _default = function _default(l, s) {
          var _ref231 = (0, v.useSelect)(function (s) {
            var _s47 = s(k.store),
                c = _s47.getInserterItems,
                _s48 = s(m.store),
                v = _s48.getCategories,
                _ = _s48.getCollections;

            return {
              categories: v(),
              collections: _(),
              items: c(l)
            };
          }, [l]),
              c = _ref231.categories,
              y = _ref231.collections,
              E = _ref231.items;

          return [E, c, y, (0, _.useCallback)(function (l, c) {
            var v = l.name,
                _ = l.initialAttributes,
                k = l.innerBlocks;
            var y = (0, m.createBlock)(v, _, (0, m.createBlocksFromInnerBlocksTemplate)(k));
            s(y, void 0, c);
          }, [s])];
        };

        s.default = _default;
      },
      3982: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(4793),
            v = c(8467),
            _ = c(6700),
            k = c(6756),
            y = c(9773),
            E = c(1753),
            w = c(8486);

        var C = function useInsertionPoint(l) {
          var _l$rootClientId = l.rootClientId,
              s = _l$rootClientId === void 0 ? "" : _l$rootClientId,
              c = l.insertionIndex,
              C = l.clientId,
              S = l.isAppender,
              B = l.onSelect,
              _l$shouldFocusBlock = l.shouldFocusBlock,
              P = _l$shouldFocusBlock === void 0 ? !0 : _l$shouldFocusBlock;

          var _ref232 = (0, v.useSelect)(w.store),
              O = _ref232.getSelectedBlock,
              _ref233 = (0, v.useSelect)(function (l) {
            var _l96 = l(w.store),
                m = _l96.getSelectedBlockClientId,
                v = _l96.getBlockRootClientId,
                _ = _l96.getBlockIndex,
                k = _l96.getBlockOrder,
                y = m();

            var E,
                B = s;
            return void 0 !== c ? E = c : C ? E = _(C) : !S && y ? (B = v(y), E = _(y) + 1) : E = k(B).length, {
              destinationRootClientId: B,
              destinationIndex: E
            };
          }, [s, c, C, S]),
              L = _ref233.destinationRootClientId,
              V = _ref233.destinationIndex,
              _ref234 = (0, v.useDispatch)(w.store),
              R = _ref234.replaceBlocks,
              A = _ref234.insertBlocks,
              z = _ref234.showInsertionPoint,
              D = _ref234.hideInsertionPoint,
              F = (0, E.useCallback)(function (l, s) {
            var c = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            var v = O();
            !S && v && (0, _.isUnmodifiedDefaultBlock)(v) ? R(v.clientId, l, null, P || c ? 0 : null, s) : A(l, V, L, !0, P || c ? 0 : null, s);
            var E = (0, k.sprintf)((0, k._n)("%d block added.", "%d blocks added.", (0, m.castArray)(l).length), (0, m.castArray)(l).length);
            (0, y.speak)(E), B && B();
          }, [S, O, R, A, L, V, B, P]),
              G = (0, E.useCallback)(function (l) {
            l ? z(L, V) : D();
          }, [z, D, L, V]);

          return [L, F, G];
        };

        s.default = C;
      },
      4671: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(4793),
            v = c(1753),
            _ = c(6700),
            k = c(8467),
            y = c(6756),
            E = c(8448),
            w = c(8486);

        var _default = function _default(l, s) {
          var _ref235 = (0, k.useSelect)(function (l) {
            var _l97 = l(w.store),
                c = _l97.__experimentalGetAllowedPatterns,
                m = _l97.getSettings;

            return {
              patterns: c(s),
              patternCategories: m().__experimentalBlockPatternCategories
            };
          }, [s]),
              c = _ref235.patternCategories,
              C = _ref235.patterns,
              _ref236 = (0, k.useDispatch)(E.store),
              S = _ref236.createSuccessNotice;

          return [C, c, (0, v.useCallback)(function (s, c) {
            l((0, m.map)(c, function (l) {
              return (0, _.cloneBlock)(l);
            }), s.name), S((0, y.sprintf)((0, y.__)('Block pattern "%s" inserted.'), s.title), {
              type: "snackbar"
            });
          }, [])];
        };

        s.default = _default;
      },
      1517: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = m(c(2703)),
            E = c(9773),
            w = c(6756),
            C = c(4892),
            S = c(8467),
            B = c(3200),
            P = c(6700),
            O = c(2614),
            L = m(c(6079)),
            V = m(c(9099)),
            R = c(8486);

        var defaultRenderToggle = function defaultRenderToggle(l) {
          var s,
              c = l.onToggle,
              m = l.disabled,
              k = l.isOpen,
              y = l.blockTitle,
              E = l.hasSingleBlockType,
              _l$toggleProps = l.toggleProps,
              S = _l$toggleProps === void 0 ? {} : _l$toggleProps;
          s = E ? (0, w.sprintf)((0, w._x)("Add %s", "directly add the only allowed block"), y) : (0, w._x)("Add block", "Generic label for block inserter button");

          var B = S.onClick,
              P = _objectWithoutProperties(S, _excluded24);

          return (0, v.createElement)(C.Button, (0, _.default)({
            icon: O.plus,
            label: s,
            tooltipPosition: "bottom",
            onClick: function handleClick(l) {
              c && c(l), B && B(l);
            },
            className: "block-editor-inserter__toggle",
            "aria-haspopup": !E && "true",
            "aria-expanded": !E && k,
            disabled: m
          }, P));
        };

        var Inserter = /*#__PURE__*/function (_v$Component3) {
          _inherits(Inserter, _v$Component3);

          var _super15 = _createSuper(Inserter);

          function Inserter() {
            var _this36;

            _classCallCheck(this, Inserter);

            _this36 = _super15.apply(this, arguments), _this36.onToggle = _this36.onToggle.bind(_assertThisInitialized(_this36)), _this36.renderToggle = _this36.renderToggle.bind(_assertThisInitialized(_this36)), _this36.renderContent = _this36.renderContent.bind(_assertThisInitialized(_this36));
            return _this36;
          }

          _createClass(Inserter, [{
            key: "onToggle",
            value: function onToggle(l) {
              var s = this.props.onToggle;
              s && s(l);
            }
          }, {
            key: "renderToggle",
            value: function renderToggle(l) {
              var s = l.onToggle,
                  c = l.isOpen;
              var _this$props = this.props,
                  m = _this$props.disabled,
                  v = _this$props.blockTitle,
                  _ = _this$props.hasSingleBlockType,
                  k = _this$props.directInsertBlock,
                  y = _this$props.toggleProps,
                  E = _this$props.hasItems,
                  _this$props$renderTog = _this$props.renderToggle,
                  w = _this$props$renderTog === void 0 ? defaultRenderToggle : _this$props$renderTog;
              return w({
                onToggle: s,
                isOpen: c,
                disabled: m || !E,
                blockTitle: v,
                hasSingleBlockType: _,
                directInsertBlock: k,
                toggleProps: y
              });
            }
          }, {
            key: "renderContent",
            value: function renderContent(l) {
              var s = l.onClose;
              var _this$props2 = this.props,
                  c = _this$props2.rootClientId,
                  m = _this$props2.clientId,
                  _ = _this$props2.isAppender,
                  k = _this$props2.showInserterHelpPanel,
                  y = _this$props2.__experimentalIsQuick;
              return y ? (0, v.createElement)(V.default, {
                onSelect: function onSelect() {
                  s();
                },
                rootClientId: c,
                clientId: m,
                isAppender: _
              }) : (0, v.createElement)(L.default, {
                onSelect: function onSelect() {
                  s();
                },
                rootClientId: c,
                clientId: m,
                isAppender: _,
                showInserterHelpPanel: k
              });
            }
          }, {
            key: "render",
            value: function render() {
              var _this$props3 = this.props,
                  l = _this$props3.position,
                  s = _this$props3.hasSingleBlockType,
                  c = _this$props3.directInsertBlock,
                  m = _this$props3.insertOnlyAllowedBlock,
                  _ = _this$props3.__experimentalIsQuick,
                  k = _this$props3.onSelectOrClose;
              return s || null != c && c.length ? this.renderToggle({
                onToggle: m
              }) : (0, v.createElement)(C.Dropdown, {
                className: "block-editor-inserter",
                contentClassName: (0, y.default)("block-editor-inserter__popover", {
                  "is-quick": _
                }),
                position: l,
                onToggle: this.onToggle,
                expandOnMobile: !0,
                headerTitle: (0, w.__)("Add a block"),
                renderToggle: this.renderToggle,
                renderContent: this.renderContent,
                onClose: k
              });
            }
          }]);

          return Inserter;
        }(v.Component);

        var A = (0, B.compose)([(0, S.withSelect)(function (l, s) {
          var c = s.clientId,
              m = s.rootClientId;

          var _l98 = l(R.store),
              v = _l98.getBlockRootClientId,
              _ = _l98.hasInserterItems,
              y = _l98.__experimentalGetAllowedBlocks,
              E = _l98.__experimentalGetDirectInsertBlock,
              _l99 = l(P.store),
              w = _l99.getBlockVariations;

          m = m || v(c) || void 0;
          var C = y(m),
              S = E(m),
              B = 1 === (0, k.size)(C) && 0 === (0, k.size)(w(C[0].name, "inserter"));
          var O = !1;
          return B && (O = C[0]), {
            hasItems: _(m),
            hasSingleBlockType: B,
            blockTitle: O ? O.title : "",
            allowedBlockType: O,
            directInsertBlock: S,
            rootClientId: m
          };
        }), (0, S.withDispatch)(function (l, s, c) {
          var m = c.select;
          return {
            insertOnlyAllowedBlock: function insertOnlyAllowedBlock() {
              var c = s.rootClientId,
                  v = s.clientId,
                  _ = s.isAppender,
                  k = s.hasSingleBlockType,
                  y = s.allowedBlockType,
                  C = s.directInsertBlock,
                  S = s.onSelectOrClose;
              if (!(k || null != C && C.length)) return;

              var _l100 = l(R.store),
                  B = _l100.insertBlock;

              B(null != C && C.length ? (0, P.createBlock).apply(void 0, _toConsumableArray(C)) : (0, P.createBlock)(y.name), function getInsertionIndex() {
                var _m27 = m(R.store),
                    l = _m27.getBlockIndex,
                    s = _m27.getBlockSelectionEnd,
                    k = _m27.getBlockOrder,
                    y = _m27.getBlockRootClientId;

                if (v) return l(v);
                var E = s();
                return !_ && E && y(E) === c ? l(E) + 1 : k(c).length;
              }(), c), S && S();
              var O = (0, w.sprintf)((0, w.__)("%s block added"), y.title);
              (0, E.speak)(O);
            }
          };
        }), (0, B.ifCondition)(function (l) {
          var s = l.hasItems,
              c = l.isAppender,
              m = l.rootClientId,
              v = l.clientId;
          return s || !c && !m && !v;
        })])(Inserter);
        s.default = A;
      },
      1330: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            k = c(8467),
            y = m(c(6079)),
            E = c(8486);

        var w = function InserterLibrary(l) {
          var s = l.rootClientId,
              c = l.clientId,
              m = l.isAppender,
              w = l.showInserterHelpPanel,
              _l$showMostUsedBlocks = l.showMostUsedBlocks,
              C = _l$showMostUsedBlocks === void 0 ? !1 : _l$showMostUsedBlocks,
              S = l.__experimentalInsertionIndex,
              B = l.__experimentalFilterValue,
              _l$onSelect = l.onSelect,
              P = _l$onSelect === void 0 ? _.noop : _l$onSelect,
              _l$shouldFocusBlock2 = l.shouldFocusBlock,
              O = _l$shouldFocusBlock2 === void 0 ? !1 : _l$shouldFocusBlock2;
          var L = (0, k.useSelect)(function (l) {
            var _l101 = l(E.store),
                m = _l101.getBlockRootClientId;

            return s || m(c) || void 0;
          }, [c, s]);
          return (0, v.createElement)(y.default, {
            onSelect: P,
            rootClientId: L,
            clientId: c,
            isAppender: m,
            showInserterHelpPanel: w,
            showMostUsedBlocks: C,
            __experimentalInsertionIndex: S,
            __experimentalFilterValue: B,
            shouldFocusBlock: O
          });
        };

        s.default = w;
      },
      6079: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4892),
            k = c(6756),
            y = c(8467),
            E = m(c(4275)),
            w = m(c(9757)),
            C = m(c(459)),
            S = m(c(7926)),
            B = m(c(2780)),
            P = m(c(6033)),
            O = m(c(3982)),
            L = m(c(4240)),
            V = c(8486);

        var R = function InserterMenu(l) {
          var s = l.rootClientId,
              c = l.clientId,
              m = l.isAppender,
              R = l.__experimentalInsertionIndex,
              A = l.onSelect,
              z = l.showInserterHelpPanel,
              D = l.showMostUsedBlocks,
              _l$__experimentalFilt = l.__experimentalFilterValue,
              F = _l$__experimentalFilt === void 0 ? "" : _l$__experimentalFilt,
              _l$shouldFocusBlock3 = l.shouldFocusBlock,
              G = _l$shouldFocusBlock3 === void 0 ? !0 : _l$shouldFocusBlock3;

          var _ref237 = (0, v.useState)(F),
              _ref238 = _slicedToArray(_ref237, 2),
              U = _ref238[0],
              W = _ref238[1],
              _ref239 = (0, v.useState)(null),
              _ref240 = _slicedToArray(_ref239, 2),
              K = _ref240[0],
              $ = _ref240[1],
              _ref241 = (0, v.useState)(null),
              _ref242 = _slicedToArray(_ref241, 2),
              q = _ref242[0],
              Y = _ref242[1],
              _ref243 = (0, O.default)({
            rootClientId: s,
            clientId: c,
            isAppender: m,
            insertionIndex: R,
            shouldFocusBlock: G
          }),
              _ref244 = _slicedToArray(_ref243, 3),
              Z = _ref244[0],
              X = _ref244[1],
              Q = _ref244[2],
              _ref245 = (0, y.useSelect)(function (l) {
            var s;

            var _l102 = l(V.store),
                c = _l102.__experimentalGetAllowedPatterns,
                m = _l102.getSettings;

            return {
              showPatterns: !!c(Z).length,
              hasReusableBlocks: !(null === (s = m().__experimentalReusableBlocks) || void 0 === s || !s.length)
            };
          }, [Z]),
              J = _ref245.showPatterns,
              ee = _ref245.hasReusableBlocks,
              te = (0, v.useCallback)(function (l, s, c) {
            X(l, s, c), A();
          }, [X, A]),
              ne = (0, v.useCallback)(function (l, s) {
            X(l, {
              patternName: s
            }), A();
          }, [X, A]),
              oe = (0, v.useCallback)(function (l) {
            Q(!!l), $(l);
          }, [Q, $]),
              re = (0, v.useCallback)(function (l) {
            Y(l);
          }, [Y]),
              le = (0, v.useMemo)(function () {
            return (0, v.createElement)(v.Fragment, null, (0, v.createElement)("div", {
              className: "block-editor-inserter__block-list"
            }, (0, v.createElement)(C.default, {
              rootClientId: Z,
              onInsert: te,
              onHover: oe,
              showMostUsedBlocks: D
            })), z && (0, v.createElement)("div", {
              className: "block-editor-inserter__tips"
            }, (0, v.createElement)(_.VisuallyHidden, {
              as: "h2"
            }, (0, k.__)("A tip for using the block editor")), (0, v.createElement)(E.default, null)));
          }, [Z, te, oe, U, D, z]),
              ie = (0, v.useMemo)(function () {
            return (0, v.createElement)(S.default, {
              rootClientId: Z,
              onInsert: ne,
              onClickCategory: re,
              selectedCategory: q
            });
          }, [Z, ne, re, q]),
              ae = (0, v.useMemo)(function () {
            return (0, v.createElement)(B.default, {
              rootClientId: Z,
              onInsert: te,
              onHover: oe
            });
          }, [Z, te, oe]),
              se = (0, v.useCallback)(function (l) {
            return "blocks" === l.name ? le : "patterns" === l.name ? ie : ae;
          }, [le, ie, ae]);

          return (0, v.createElement)("div", {
            className: "block-editor-inserter__menu"
          }, (0, v.createElement)("div", {
            className: "block-editor-inserter__main-area"
          }, (0, v.createElement)("div", {
            className: "block-editor-inserter__content"
          }, (0, v.createElement)(_.SearchControl, {
            className: "block-editor-inserter__search",
            onChange: function onChange(l) {
              K && $(null), W(l);
            },
            value: U,
            label: (0, k.__)("Search for blocks and patterns"),
            placeholder: (0, k.__)("Search")
          }), !!U && (0, v.createElement)(P.default, {
            filterValue: U,
            onSelect: A,
            onHover: oe,
            rootClientId: s,
            clientId: c,
            isAppender: m,
            __experimentalInsertionIndex: R,
            showBlockDirectory: !0,
            shouldFocusBlock: G
          }), !U && (J || ee) && (0, v.createElement)(L.default, {
            showPatterns: J,
            showReusableBlocks: ee
          }, se), !U && !J && !ee && le)), z && K && (0, v.createElement)(w.default, {
            item: K
          }));
        };

        s.default = R;
      },
      7977: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6756),
            _ = c(2614);

        var k = function InserterNoResults() {
          return (0, m.createElement)("div", {
            className: "block-editor-inserter__no-results"
          }, (0, m.createElement)(_.Icon, {
            className: "block-editor-inserter__no-results-icon",
            icon: _.blockDefault
          }), (0, m.createElement)("p", null, (0, v.__)("No results found.")));
        };

        s.default = k;
      },
      2636: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(1753),
            v = c(4892);

        var _ = function InserterPanel(l) {
          var s = l.title,
              c = l.icon,
              _ = l.children;
          return (0, m.createElement)(m.Fragment, null, (0, m.createElement)("div", {
            className: "block-editor-inserter__panel-header"
          }, (0, m.createElement)("h2", {
            className: "block-editor-inserter__panel-title"
          }, s), (0, m.createElement)(v.Icon, {
            icon: c
          })), (0, m.createElement)("div", {
            className: "block-editor-inserter__panel-content"
          }, _));
        };

        s.default = _;
      },
      2909: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(4892),
            y = c(6756),
            E = c(3200);

        var w = function PatternInserterPanel(l) {
          var s = l.selectedCategory,
              c = l.patternCategories,
              m = l.onClickCategory,
              w = l.openPatternExplorer;
          var C = (0, E.useViewportMatch)("medium", "<"),
              S = (0, _.default)("block-editor-inserter__panel-header", "block-editor-inserter__panel-header-patterns");
          return (0, v.createElement)(k.Flex, {
            justify: "space-between",
            align: "start",
            gap: "4",
            className: S
          }, (0, v.createElement)(k.FlexItem, {
            isBlock: !0
          }, (0, v.createElement)(k.SelectControl, {
            className: "block-editor-inserter__panel-dropdown",
            label: (0, y.__)("Filter patterns"),
            hideLabelFromVision: !0,
            value: s.name,
            onChange: function onChange(l) {
              m(c.find(function (s) {
                return l === s.name;
              }));
            },
            onBlur: function onBlur(l) {
              null != l && l.relatedTarget || l.stopPropagation();
            },
            options: function () {
              var l = [];
              return c.map(function (s) {
                return l.push({
                  value: s.name,
                  label: s.label
                });
              }), l;
            }()
          })), !C && (0, v.createElement)(k.FlexItem, null, (0, v.createElement)(k.Button, {
            variant: "secondary",
            className: "block-editor-inserter__patterns-explorer-expand",
            label: (0, y.__)("Explore all patterns"),
            onClick: function onClick() {
              return w();
            }
          }, (0, y._x)("Explore", "Label for showing all block patterns"))));
        };

        s.default = w;
      },
      9757: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(6700),
            k = c(6756),
            y = m(c(5939)),
            E = m(c(8958));

        var w = function InserterPreviewPanel(l) {
          var s, c;
          var m = l.item;
          var w = m.name,
              C = m.title,
              S = m.icon,
              B = m.description,
              P = m.initialAttributes,
              O = (0, _.getBlockType)(w),
              L = (0, _.isReusableBlock)(m);
          return (0, v.createElement)("div", {
            className: "block-editor-inserter__preview-container"
          }, (0, v.createElement)("div", {
            className: "block-editor-inserter__preview"
          }, L || null != O && O.example ? (0, v.createElement)("div", {
            className: "block-editor-inserter__preview-content"
          }, (0, v.createElement)(E.default, {
            __experimentalPadding: 16,
            viewportWidth: null !== (s = null === (c = O.example) || void 0 === c ? void 0 : c.viewportWidth) && void 0 !== s ? s : 500,
            blocks: O.example ? (0, _.getBlockFromExample)(m.name, {
              attributes: _objectSpread(_objectSpread({}, O.example.attributes), P),
              innerBlocks: O.example.innerBlocks
            }) : (0, _.createBlock)(w, P)
          })) : (0, v.createElement)("div", {
            className: "block-editor-inserter__preview-content-missing"
          }, (0, k.__)("No Preview Available."))), !L && (0, v.createElement)(y.default, {
            title: C,
            icon: S,
            description: B
          }));
        };

        s.default = w;
      },
      9099: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function QuickInserter(l) {
          var s = l.onSelect,
              c = l.rootClientId,
              m = l.clientId,
              O = l.isAppender;

          var _ref246 = (0, v.useState)(""),
              _ref247 = _slicedToArray(_ref246, 2),
              L = _ref247[0],
              V = _ref247[1],
              _ref248 = (0, C.default)({
            onSelect: s,
            rootClientId: c,
            clientId: m,
            isAppender: O
          }),
              _ref249 = _slicedToArray(_ref248, 2),
              R = _ref249[0],
              A = _ref249[1],
              _ref250 = (0, B.default)(R, A),
              _ref251 = _slicedToArray(_ref250, 1),
              z = _ref251[0],
              _ref252 = (0, S.default)(A, R),
              _ref253 = _slicedToArray(_ref252, 1),
              D = _ref253[0],
              F = D.length && !!L,
              G = F && D.length > 6 || z.length > 6,
              _ref254 = (0, E.useSelect)(function (l) {
            var _l103 = l(P.store),
                s = _l103.getSettings,
                c = _l103.getBlockIndex,
                v = _l103.getBlockCount,
                _ = c(m);

            return {
              setInserterIsOpened: s().__experimentalSetIsInserterOpened,
              insertionIndex: -1 === _ ? v() : _
            };
          }, [m, c]),
              U = _ref254.setInserterIsOpened,
              W = _ref254.insertionIndex;

          (0, v.useEffect)(function () {
            U && U(!1);
          }, [U]);
          return (0, v.createElement)("div", {
            className: (0, _.default)("block-editor-inserter__quick-inserter", {
              "has-search": G,
              "has-expand": U
            })
          }, G && (0, v.createElement)(y.SearchControl, {
            className: "block-editor-inserter__search",
            value: L,
            onChange: function onChange(l) {
              V(l);
            },
            label: (0, k.__)("Search for blocks and patterns"),
            placeholder: (0, k.__)("Search")
          }), (0, v.createElement)("div", {
            className: "block-editor-inserter__quick-inserter-results"
          }, (0, v.createElement)(w.default, {
            filterValue: L,
            onSelect: s,
            rootClientId: c,
            clientId: m,
            isAppender: O,
            maxBlockPatterns: F ? 2 : 0,
            maxBlockTypes: 6,
            isDraggable: !1
          })), U && (0, v.createElement)(y.Button, {
            className: "block-editor-inserter__quick-inserter-expand",
            onClick: function onClick() {
              U({
                rootClientId: c,
                insertionIndex: W,
                filterValue: L
              });
            },
            "aria-label": (0, k.__)("Browse all. This will open the main inserter panel in the editor toolbar.")
          }, (0, k.__)("Browse all")));
        };

        var v = c(1753),
            _ = m(c(2703)),
            k = c(6756),
            y = c(4892),
            E = c(8467),
            w = m(c(6033)),
            C = m(c(3982)),
            S = m(c(4671)),
            B = m(c(8081)),
            P = c(8486);
      },
      2780: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.ReusableBlocksTab = ReusableBlocksTab, s.default = void 0;

        var v = c(1753),
            _ = c(6756),
            k = c(904),
            y = m(c(2706)),
            E = m(c(2636)),
            w = m(c(7977)),
            C = m(c(8081));

        function ReusableBlocksList(l) {
          var s = l.onHover,
              c = l.onInsert,
              m = l.rootClientId;

          var _ref255 = (0, C.default)(m, c),
              _ref256 = _slicedToArray(_ref255, 4),
              k = _ref256[0],
              S = _ref256[3],
              B = (0, v.useMemo)(function () {
            return k.filter(function (l) {
              var s = l.category;
              return "reusable" === s;
            });
          }, [k]);

          return 0 === B.length ? (0, v.createElement)(w.default, null) : (0, v.createElement)(E.default, {
            title: (0, _.__)("Reusable blocks")
          }, (0, v.createElement)(y.default, {
            items: B,
            onSelect: S,
            onHover: s,
            label: (0, _.__)("Reusable blocks")
          }));
        }

        function ReusableBlocksTab(l) {
          var s = l.rootClientId,
              c = l.onInsert,
              m = l.onHover;
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(ReusableBlocksList, {
            onHover: m,
            onInsert: c,
            rootClientId: s
          }), (0, v.createElement)("div", {
            className: "block-editor-inserter__manage-reusable-blocks-container"
          }, (0, v.createElement)("a", {
            className: "block-editor-inserter__manage-reusable-blocks",
            href: (0, k.addQueryArgs)("edit.php", {
              post_type: "wp_block"
            })
          }, (0, _.__)("Manage Reusable blocks"))));
        }

        var S = ReusableBlocksTab;
        s.default = S;
      },
      8026: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getItemSearchRank = getItemSearchRank, s.searchItems = s.searchBlockItems = s.getNormalizedSearchTerms = void 0;
        var m = c(4793);

        var defaultGetName = function defaultGetName(l) {
          return l.name || "";
        },
            defaultGetTitle = function defaultGetTitle(l) {
          return l.title;
        },
            defaultGetDescription = function defaultGetDescription(l) {
          return l.description || "";
        },
            defaultGetKeywords = function defaultGetKeywords(l) {
          return l.keywords || [];
        },
            defaultGetCategory = function defaultGetCategory(l) {
          return l.category;
        },
            defaultGetCollection = function defaultGetCollection() {
          return null;
        };

        function normalizeSearchInput() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          return l = (0, m.deburr)(l), l = l.replace(/^\//, ""), l = l.toLowerCase(), l;
        }

        var getNormalizedSearchTerms = function getNormalizedSearchTerms() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          return (0, m.words)(normalizeSearchInput(l));
        };

        s.getNormalizedSearchTerms = getNormalizedSearchTerms;

        var removeMatchingTerms = function removeMatchingTerms(l, s) {
          return (0, m.differenceWith)(l, getNormalizedSearchTerms(s), function (l, s) {
            return s.includes(l);
          });
        };

        s.searchBlockItems = function (l, s, c, v) {
          if (0 === getNormalizedSearchTerms(v).length) return l;
          return searchItems(l, v, {
            getCategory: function getCategory(l) {
              var c;
              return null === (c = (0, m.find)(s, {
                slug: l.category
              })) || void 0 === c ? void 0 : c.title;
            },
            getCollection: function getCollection(l) {
              var s;
              return null === (s = c[l.name.split("/")[0]]) || void 0 === s ? void 0 : s.title;
            }
          });
        };

        var searchItems = function searchItems() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          var m = getNormalizedSearchTerms(s);
          if (0 === m.length) return l;
          var v = l.map(function (l) {
            return [l, getItemSearchRank(l, s, c)];
          }).filter(function (l) {
            var _l104 = _slicedToArray(l, 2),
                s = _l104[1];

            return s > 0;
          });
          return v.sort(function (l, s) {
            var _l105 = _slicedToArray(l, 2),
                c = _l105[1],
                _s49 = _slicedToArray(s, 2),
                m = _s49[1];

            return m - c;
          }), v.map(function (l) {
            var _l106 = _slicedToArray(l, 1),
                s = _l106[0];

            return s;
          });
        };

        function getItemSearchRank(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

          var _c$getName = c.getName,
              v = _c$getName === void 0 ? defaultGetName : _c$getName,
              _c$getTitle = c.getTitle,
              _ = _c$getTitle === void 0 ? defaultGetTitle : _c$getTitle,
              _c$getDescription = c.getDescription,
              k = _c$getDescription === void 0 ? defaultGetDescription : _c$getDescription,
              _c$getKeywords = c.getKeywords,
              y = _c$getKeywords === void 0 ? defaultGetKeywords : _c$getKeywords,
              _c$getCategory = c.getCategory,
              E = _c$getCategory === void 0 ? defaultGetCategory : _c$getCategory,
              _c$getCollection = c.getCollection,
              w = _c$getCollection === void 0 ? defaultGetCollection : _c$getCollection,
              C = v(l),
              S = _(l),
              B = k(l),
              P = y(l),
              O = E(l),
              L = w(l),
              V = normalizeSearchInput(s),
              R = normalizeSearchInput(S);

          var A = 0;
          if (V === R) A += 30;else if (R.startsWith(V)) A += 20;else {
            var _l107 = [C, S, B].concat(_toConsumableArray(P), [O, L]).join(" "),
                _s50 = (0, m.words)(V);

            0 === removeMatchingTerms(_s50, _l107).length && (A += 10);
          }
          return 0 !== A && C.startsWith("core/") && A++, A;
        }

        s.searchItems = searchItems;
      },
      6033: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            k = c(6756),
            y = c(4892),
            E = c(3200),
            w = c(9773),
            C = m(c(2706)),
            S = m(c(5511)),
            B = m(c(4193)),
            P = m(c(2636)),
            O = m(c(7977)),
            L = m(c(3982)),
            V = m(c(4671)),
            R = m(c(8081)),
            A = c(8026),
            z = m(c(9776));

        var D = [];

        var F = function InserterSearchResults(l) {
          var s = l.filterValue,
              c = l.onSelect,
              m = l.onHover,
              F = l.rootClientId,
              G = l.clientId,
              U = l.isAppender,
              W = l.__experimentalInsertionIndex,
              K = l.maxBlockPatterns,
              $ = l.maxBlockTypes,
              _l$showBlockDirectory = l.showBlockDirectory,
              q = _l$showBlockDirectory === void 0 ? !1 : _l$showBlockDirectory,
              _l$isDraggable2 = l.isDraggable,
              Y = _l$isDraggable2 === void 0 ? !0 : _l$isDraggable2,
              _l$shouldFocusBlock4 = l.shouldFocusBlock,
              Z = _l$shouldFocusBlock4 === void 0 ? !0 : _l$shouldFocusBlock4;

          var X = (0, E.useDebounce)(w.speak, 500),
              _ref257 = (0, L.default)({
            onSelect: c,
            rootClientId: F,
            clientId: G,
            isAppender: U,
            insertionIndex: W,
            shouldFocusBlock: Z
          }),
              _ref258 = _slicedToArray(_ref257, 2),
              Q = _ref258[0],
              J = _ref258[1],
              _ref259 = (0, R.default)(Q, J),
              _ref260 = _slicedToArray(_ref259, 4),
              ee = _ref260[0],
              te = _ref260[1],
              ne = _ref260[2],
              oe = _ref260[3],
              _ref261 = (0, V.default)(J, Q),
              _ref262 = _slicedToArray(_ref261, 3),
              re = _ref262[0],
              le = _ref262[2],
              ie = (0, v.useMemo)(function () {
            var l = (0, A.searchBlockItems)((0, _.orderBy)(ee, ["frecency"], ["desc"]), te, ne, s);
            return void 0 !== $ ? l.slice(0, $) : l;
          }, [s, ee, te, ne, $]),
              ae = (0, v.useMemo)(function () {
            var l = (0, A.searchItems)(re, s);
            return void 0 !== K ? l.slice(0, K) : l;
          }, [s, re, K]);

          (0, v.useEffect)(function () {
            if (!s) return;
            var l = ie.length + ae.length,
                c = (0, k.sprintf)((0, k._n)("%d result found.", "%d results found.", l), l);
            X(c);
          }, [s, X]);
          var se = (0, E.useAsyncList)(ie, {
            step: 9
          }),
              ce = (0, E.useAsyncList)(se.length === ie.length ? ae : D),
              ue = !(0, _.isEmpty)(ie) || !(0, _.isEmpty)(ae);
          return (0, v.createElement)(z.default, null, !q && !ue && (0, v.createElement)(O.default, null), !!ie.length && (0, v.createElement)(P.default, {
            title: (0, v.createElement)(y.VisuallyHidden, null, (0, k.__)("Blocks"))
          }, (0, v.createElement)(C.default, {
            items: se,
            onSelect: oe,
            onHover: m,
            label: (0, k.__)("Blocks"),
            isDraggable: Y
          })), !!ie.length && !!ae.length && (0, v.createElement)("div", {
            className: "block-editor-inserter__quick-inserter-separator"
          }), !!ae.length && (0, v.createElement)(P.default, {
            title: (0, v.createElement)(y.VisuallyHidden, null, (0, k.__)("Block Patterns"))
          }, (0, v.createElement)("div", {
            className: "block-editor-inserter__quick-inserter-patterns"
          }, (0, v.createElement)(S.default, {
            shownPatterns: ce,
            blockPatterns: ae,
            onClickPattern: le,
            isDraggable: Y
          }))), q && (0, v.createElement)(B.default.Slot, {
            fillProps: {
              onSelect: oe,
              onHover: m,
              filterValue: s,
              hasItems: ue,
              rootClientId: Q
            }
          }, function (l) {
            return l.length ? l : ue ? null : (0, v.createElement)(O.default, null);
          }));
        };

        s.default = F;
      },
      4240: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(4892),
            _ = c(6756);

        var k = {
          name: "blocks",
          title: (0, _.__)("Blocks")
        },
            y = {
          name: "patterns",
          title: (0, _.__)("Patterns")
        },
            E = {
          name: "reusable",
          title: (0, _.__)("Reusable")
        };

        var w = function InserterTabs(l) {
          var s = l.children,
              _l$showPatterns = l.showPatterns,
              c = _l$showPatterns === void 0 ? !1 : _l$showPatterns,
              _l$showReusableBlocks = l.showReusableBlocks,
              _ = _l$showReusableBlocks === void 0 ? !1 : _l$showReusableBlocks,
              w = l.onSelect;

          var C = (0, m.useMemo)(function () {
            var l = [k];
            return c && l.push(y), _ && l.push(E), l;
          }, [k, c, y, _, E]);
          return (0, m.createElement)(v.TabPanel, {
            className: "block-editor-inserter__tabs",
            tabs: C,
            onSelect: w
          }, s);
        };

        s.default = w;
      },
      4275: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(6756),
            _ = c(4892);

        var k = [(0, m.createInterpolateElement)((0, v.__)("While writing, you can press <kbd>/</kbd> to quickly insert new blocks."), {
          kbd: (0, m.createElement)("kbd", null)
        }), (0, m.createInterpolateElement)((0, v.__)("Indent a list by pressing <kbd>space</kbd> at the beginning of a line."), {
          kbd: (0, m.createElement)("kbd", null)
        }), (0, m.createInterpolateElement)((0, v.__)("Outdent a list by pressing <kbd>backspace</kbd> at the beginning of a line."), {
          kbd: (0, m.createElement)("kbd", null)
        }), (0, v.__)("Drag files into the editor to automatically insert media blocks."), (0, v.__)("Change a block's type by pressing the block icon on the toolbar.")];

        var y = function Tips() {
          var _ref263 = (0, m.useState)(Math.floor(Math.random() * k.length)),
              _ref264 = _slicedToArray(_ref263, 1),
              l = _ref264[0];

          return (0, m.createElement)(_.Tip, null, k[l]);
        };

        s.default = y;
      },
      6152: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockSupportSlotContainer(l) {
          var s = l.Slot,
              c = _objectWithoutProperties(l, _excluded25);

          var m = (0, v.useContext)(k.__experimentalToolsPanelContext);
          return (0, v.createElement)(s, (0, _.default)({}, c, {
            fillProps: m
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892);
      },
      5962: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function BlockSupportToolsPanel(l) {
          var s = l.children,
              c = l.group,
              E = l.label;

          var _ref265 = (0, _.useSelect)(function (l) {
            var _l108 = l(k.store),
                s = _l108.getBlockAttributes,
                c = _l108.getMultiSelectedBlockClientIds,
                m = _l108.getSelectedBlockClientId,
                v = _l108.hasMultiSelection,
                _ = m();

            if (v()) {
              var _l109 = c(),
                  _m28 = _l109.reduce(function (l, c) {
                return l[c] = s(c), l;
              }, {});

              return {
                panelId: _,
                clientIds: _l109,
                attributes: _m28
              };
            }

            return {
              panelId: _,
              clientIds: [_],
              attributes: _defineProperty({}, _, s(_))
            };
          }, []),
              w = _ref265.attributes,
              C = _ref265.clientIds,
              S = _ref265.panelId,
              _ref266 = (0, _.useDispatch)(k.store),
              B = _ref266.updateBlockAttributes;

          return (0, m.createElement)(v.__experimentalToolsPanel, {
            className: "".concat(c, "-block-support-panel"),
            label: E,
            resetAll: function resetAll() {
              var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
              var s = {};
              C.forEach(function (c) {
                var m = w[c].style;
                var v = {
                  style: m
                };
                l.forEach(function (l) {
                  v = _objectSpread(_objectSpread({}, v), l(v));
                }), v = _objectSpread(_objectSpread({}, v), {}, {
                  style: (0, y.cleanEmptyObject)(v.style)
                }), s[c] = v;
              }), B(C, s, !0);
            },
            key: S,
            panelId: S,
            hasInnerWrapper: !0,
            shouldRenderPlaceholderItems: !0
          }, s);
        };

        var m = c(1753),
            v = c(4892),
            _ = c(8467),
            k = c(8486),
            y = c(8241);
      },
      2367: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function InspectorControlsFill(l) {
          var s;
          var _l$__experimentalGrou = l.__experimentalGroup,
              c = _l$__experimentalGrou === void 0 ? "default" : _l$__experimentalGrou,
              m = l.children;
          var w = (0, y.default)(),
              C = null === (s = E.default[c]) || void 0 === s ? void 0 : s.Fill;
          if (!C) return "undefined" != typeof process && process.env, null;
          if (!w) return null;
          return (0, v.createElement)(k.__experimentalStyleProvider, {
            document: document
          }, (0, v.createElement)(C, null, function (l) {
            var s = (0, _.isEmpty)(l) ? null : l;
            return (0, v.createElement)(k.__experimentalToolsPanelContext.Provider, {
              value: s
            }, m);
          }));
        };

        var v = c(1753),
            _ = c(4793),
            k = c(4892),
            y = (m(c(2793)), m(c(7706))),
            E = m(c(2044));
      },
      2044: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = c(4892);
        var v = {
          default: (0, m.createSlotFill)("InspectorControls"),
          advanced: (0, m.createSlotFill)("InspectorAdvancedControls"),
          dimensions: (0, m.createSlotFill)("InspectorControlsDimensions"),
          typography: (0, m.createSlotFill)("InspectorControlsTypography")
        };
        s.default = v;
      },
      5071: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.InspectorAdvancedControls = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2367)),
            y = m(c(3447));

        var E = k.default;
        E.Slot = y.default;

        var InspectorAdvancedControls = function InspectorAdvancedControls(l) {
          return (0, v.createElement)(k.default, (0, _.default)({}, l, {
            __experimentalGroup: "advanced"
          }));
        };

        s.InspectorAdvancedControls = InspectorAdvancedControls, InspectorAdvancedControls.Slot = function (l) {
          return (0, v.createElement)(y.default, (0, _.default)({}, l, {
            __experimentalGroup: "advanced"
          }));
        }, InspectorAdvancedControls.slotName = "InspectorAdvancedControls";
        var w = E;
        s.default = w;
      },
      3447: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function InspectorControlsSlot(l) {
          var s;

          var _l$__experimentalGrou2 = l.__experimentalGroup,
              c = _l$__experimentalGrou2 === void 0 ? "default" : _l$__experimentalGrou2,
              _l$bubblesVirtually2 = l.bubblesVirtually,
              m = _l$bubblesVirtually2 === void 0 ? !0 : _l$bubblesVirtually2,
              C = l.label,
              S = _objectWithoutProperties(l, _excluded26);

          var B = null === (s = w.default[c]) || void 0 === s ? void 0 : s.Slot,
              P = (0, k.__experimentalUseSlot)(null == B ? void 0 : B.__unstableName);
          if (!B || !P) return "undefined" != typeof process && process.env, null;
          if (!Boolean(P.fills && P.fills.length)) return null;
          if (C) return (0, v.createElement)(y.default, {
            group: c,
            label: C
          }, (0, v.createElement)(E.default, (0, _.default)({}, S, {
            bubblesVirtually: m,
            Slot: B
          })));
          return (0, v.createElement)(B, (0, _.default)({}, S, {
            bubblesVirtually: m
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = (m(c(2793)), m(c(5962))),
            E = m(c(6152)),
            w = m(c(2044));
      },
      1630: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.JustifyContentControl = function JustifyContentControl(l) {
          return (0, v.createElement)(k.default, (0, _.default)({}, l, {
            isToolbar: !1
          }));
        }, s.JustifyToolbar = function JustifyToolbar(l) {
          return (0, v.createElement)(k.default, (0, _.default)({}, l, {
            isToolbar: !0
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(1482));
      },
      1482: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = c(2614),
            E = c(6756);

        var w = {
          left: y.justifyLeft,
          center: y.justifyCenter,
          right: y.justifyRight,
          "space-between": y.justifySpaceBetween
        };

        var C = function JustifyContentUI(l) {
          var _l$allowedControls = l.allowedControls,
              s = _l$allowedControls === void 0 ? ["left", "center", "right", "space-between"] : _l$allowedControls,
              _l$isCollapsed4 = l.isCollapsed,
              c = _l$isCollapsed4 === void 0 ? !0 : _l$isCollapsed4,
              m = l.onChange,
              C = l.value,
              S = l.popoverProps,
              B = l.isToolbar;

          var handleClick = function handleClick(l) {
            m(l === C ? void 0 : l);
          },
              P = C ? w[C] : w.left,
              O = [{
            name: "left",
            icon: y.justifyLeft,
            title: (0, E.__)("Justify items left"),
            isActive: "left" === C,
            onClick: function onClick() {
              return handleClick("left");
            }
          }, {
            name: "center",
            icon: y.justifyCenter,
            title: (0, E.__)("Justify items center"),
            isActive: "center" === C,
            onClick: function onClick() {
              return handleClick("center");
            }
          }, {
            name: "right",
            icon: y.justifyRight,
            title: (0, E.__)("Justify items right"),
            isActive: "right" === C,
            onClick: function onClick() {
              return handleClick("right");
            }
          }, {
            name: "space-between",
            icon: y.justifySpaceBetween,
            title: (0, E.__)("Space between items"),
            isActive: "space-between" === C,
            onClick: function onClick() {
              return handleClick("space-between");
            }
          }],
              L = B ? k.ToolbarGroup : k.ToolbarDropdownMenu,
              V = B ? {
            isCollapsed: c
          } : {};

          return (0, v.createElement)(L, (0, _.default)({
            icon: P,
            popoverProps: S,
            label: (0, E.__)("Change items justification"),
            controls: O.filter(function (l) {
              return s.includes(l.name);
            })
          }, V));
        };

        s.default = C;
      },
      5357: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(8467),
            _ = c(2470),
            k = c(6756);

        function KeyboardShortcuts() {
          return null;
        }

        KeyboardShortcuts.Register = function KeyboardShortcutsRegister() {
          var _ref267 = (0, v.useDispatch)(_.store),
              l = _ref267.registerShortcut;

          return (0, m.useEffect)(function () {
            l({
              name: "core/block-editor/duplicate",
              category: "block",
              description: (0, k.__)("Duplicate the selected block(s)."),
              keyCombination: {
                modifier: "primaryShift",
                character: "d"
              }
            }), l({
              name: "core/block-editor/remove",
              category: "block",
              description: (0, k.__)("Remove the selected block(s)."),
              keyCombination: {
                modifier: "access",
                character: "z"
              }
            }), l({
              name: "core/block-editor/insert-before",
              category: "block",
              description: (0, k.__)("Insert a new block before the selected block(s)."),
              keyCombination: {
                modifier: "primaryAlt",
                character: "t"
              }
            }), l({
              name: "core/block-editor/insert-after",
              category: "block",
              description: (0, k.__)("Insert a new block after the selected block(s)."),
              keyCombination: {
                modifier: "primaryAlt",
                character: "y"
              }
            }), l({
              name: "core/block-editor/delete-multi-selection",
              category: "block",
              description: (0, k.__)("Remove multiple selected blocks."),
              keyCombination: {
                character: "del"
              },
              aliases: [{
                character: "backspace"
              }]
            }), l({
              name: "core/block-editor/select-all",
              category: "selection",
              description: (0, k.__)("Select all text when typing. Press again to select all blocks."),
              keyCombination: {
                modifier: "primary",
                character: "a"
              }
            }), l({
              name: "core/block-editor/unselect",
              category: "selection",
              description: (0, k.__)("Clear selection."),
              keyCombination: {
                character: "escape"
              }
            }), l({
              name: "core/block-editor/focus-toolbar",
              category: "global",
              description: (0, k.__)("Navigate to the nearest toolbar."),
              keyCombination: {
                modifier: "alt",
                character: "F10"
              }
            }), l({
              name: "core/block-editor/move-up",
              category: "block",
              description: (0, k.__)("Move the selected block(s) up."),
              keyCombination: {
                modifier: "secondary",
                character: "t"
              }
            }), l({
              name: "core/block-editor/move-down",
              category: "block",
              description: (0, k.__)("Move the selected block(s) down."),
              keyCombination: {
                modifier: "secondary",
                character: "y"
              }
            });
          }, [l]), null;
        };

        var y = KeyboardShortcuts;
        s.default = y;
      },
      9312: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LetterSpacingControl(l) {
          var s = l.value,
              c = l.onChange,
              _l$__unstableInputWid = l.__unstableInputWidth,
              m = _l$__unstableInputWid === void 0 ? "60px" : _l$__unstableInputWid;
          var E = (0, _.__experimentalUseCustomUnits)({
            availableUnits: (0, y.default)("spacing.units") || ["px", "em", "rem"],
            defaultValues: {
              px: "2",
              em: ".2",
              rem: ".2"
            }
          });
          return (0, v.createElement)(_.__experimentalUnitControl, {
            label: (0, k.__)("Letter-spacing"),
            value: s,
            __unstableInputWidth: m,
            units: E,
            onChange: c
          });
        };

        var v = c(1753),
            _ = c(4892),
            k = c(6756),
            y = m(c(3081));
      },
      1628: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LineHeightControl(l) {
          var s = l.value,
              c = l.onChange;
          var E = (0, y.isLineHeightDefined)(s),
              w = E ? s : y.RESET_VALUE;
          return (0, m.createElement)("div", {
            className: "block-editor-line-height-control"
          }, (0, m.createElement)(_.TextControl, {
            autoComplete: "off",
            onKeyDown: function onKeyDown(l) {
              var s = l.keyCode;
              s !== k.ZERO || E || (l.preventDefault(), c("0"));
            },
            onChange: function onChange(l) {
              if (E) return void c(l);
              var s = l;

              switch (l) {
                case "".concat(y.STEP):
                  s = y.BASE_DEFAULT_VALUE + y.STEP;
                  break;

                case "0":
                  s = y.BASE_DEFAULT_VALUE - y.STEP;
              }

              c(s);
            },
            label: (0, v.__)("Line height"),
            placeholder: y.BASE_DEFAULT_VALUE,
            step: y.STEP,
            type: "number",
            value: w,
            min: 0
          }));
        };

        var m = c(1753),
            v = c(6756),
            _ = c(4892),
            k = c(9880),
            y = c(9630);
      },
      9630: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.STEP = s.RESET_VALUE = s.BASE_DEFAULT_VALUE = void 0, s.isLineHeightDefined = function isLineHeightDefined(l) {
          return void 0 !== l && "" !== l;
        };
        s.BASE_DEFAULT_VALUE = 1.5;
        s.STEP = .1;
        s.RESET_VALUE = "";
      },
      8008: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.DEFAULT_LINK_SETTINGS = s.CREATE_TYPE = void 0;
        var m = c(6756);
        s.CREATE_TYPE = "__CREATE__";
        var v = [{
          id: "opensInNewTab",
          title: (0, m.__)("Open in new tab")
        }];
        s.DEFAULT_LINK_SETTINGS = v;
      },
      2631: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            k = m(c(2703)),
            y = c(4892),
            E = c(2614),
            w = c(6756),
            C = c(5480),
            S = c(9880),
            B = m(c(7940)),
            P = m(c(1609)),
            O = m(c(9462)),
            L = m(c(5320)),
            V = c(4566),
            R = c(8008);

        function LinkControl(l) {
          var s, c, m;
          var V = l.searchInputPlaceholder,
              A = l.value,
              _l$settings = l.settings,
              z = _l$settings === void 0 ? R.DEFAULT_LINK_SETTINGS : _l$settings,
              _l$onChange4 = l.onChange,
              D = _l$onChange4 === void 0 ? _.noop : _l$onChange4,
              F = l.onRemove,
              _l$noDirectEntry = l.noDirectEntry,
              G = _l$noDirectEntry === void 0 ? !1 : _l$noDirectEntry,
              _l$showSuggestions = l.showSuggestions,
              U = _l$showSuggestions === void 0 ? !0 : _l$showSuggestions,
              W = l.showInitialSuggestions,
              K = l.forceIsEditingLink,
              $ = l.createSuggestion,
              q = l.withCreateSuggestion,
              _l$inputValue = l.inputValue,
              Y = _l$inputValue === void 0 ? "" : _l$inputValue,
              _l$suggestionsQuery = l.suggestionsQuery,
              Z = _l$suggestionsQuery === void 0 ? {} : _l$suggestionsQuery,
              _l$noURLSuggestion = l.noURLSuggestion,
              X = _l$noURLSuggestion === void 0 ? !1 : _l$noURLSuggestion,
              Q = l.createSuggestionButtonText,
              _l$hasRichPreviews = l.hasRichPreviews,
              J = _l$hasRichPreviews === void 0 ? !1 : _l$hasRichPreviews,
              _l$hasTextControl = l.hasTextControl,
              ee = _l$hasTextControl === void 0 ? !1 : _l$hasTextControl,
              _l$renderControlBotto = l.renderControlBottom,
              te = _l$renderControlBotto === void 0 ? null : _l$renderControlBotto;
          void 0 === q && $ && (q = !0);

          var ne = (0, v.useRef)(!0),
              oe = (0, v.useRef)(),
              re = (0, v.useRef)(),
              _ref268 = (0, v.useState)((null == A ? void 0 : A.url) || ""),
              _ref269 = _slicedToArray(_ref268, 2),
              le = _ref269[0],
              ie = _ref269[1],
              _ref270 = (0, v.useState)((null == A ? void 0 : A.title) || ""),
              _ref271 = _slicedToArray(_ref270, 2),
              ae = _ref271[0],
              se = _ref271[1],
              ce = Y || le,
              _ref272 = (0, v.useState)(void 0 !== K ? K : !A || !A.url),
              _ref273 = _slicedToArray(_ref272, 2),
              ue = _ref273[0],
              de = _ref273[1],
              pe = (0, v.useRef)(!1),
              me = !(null != ce && null !== (s = ce.trim()) && void 0 !== s && s.length);

          function stopEditing() {
            var l;
            pe.current = !(null === (l = oe.current) || void 0 === l || !l.contains(oe.current.ownerDocument.activeElement)), de(!1);
          }

          (0, v.useEffect)(function () {
            void 0 !== K && K !== ue && de(K);
          }, [K]), (0, v.useEffect)(function () {
            if (ne.current) return void (ne.current = !1);
            var l = null != re && re.current ? 1 : 0;
            (C.focus.focusable.find(oe.current)[l] || oe.current).focus(), pe.current = !1;
          }, [ue]), (0, v.useEffect)(function () {
            null != A && A.title && A.title !== ae && se(A.title), null != A && A.url && ie(A.url);
          }, [A]);

          var _ref274 = (0, L.default)($),
              fe = _ref274.createPage,
              he = _ref274.isCreatingPage,
              ge = _ref274.errorMessage,
              handleSubmit = function handleSubmit() {
            ce === (null == A ? void 0 : A.url) && ae === (null == A ? void 0 : A.title) || D({
              url: ce,
              title: ae
            }), stopEditing();
          },
              ve = F && A && !ue && !he,
              be = !(null == z || !z.length),
              _e = (null == A || null === (c = A.url) || void 0 === c || null === (m = c.trim()) || void 0 === m ? void 0 : m.length) > 0 && ee;

          return (0, v.createElement)("div", {
            tabIndex: -1,
            ref: oe,
            className: "block-editor-link-control"
          }, he && (0, v.createElement)("div", {
            className: "block-editor-link-control__loading"
          }, (0, v.createElement)(y.Spinner, null), " ", (0, w.__)("Creating"), "…"), (ue || !A) && !he && (0, v.createElement)(v.Fragment, null, (0, v.createElement)("div", {
            className: (0, k.default)({
              "block-editor-link-control__search-input-wrapper": !0,
              "has-text-control": _e
            })
          }, _e && (0, v.createElement)(y.TextControl, {
            ref: re,
            className: "block-editor-link-control__field block-editor-link-control__text-content",
            label: "Text",
            value: ae,
            onChange: se,
            onKeyDown: function onKeyDown(l) {
              var s = l.keyCode;
              s !== S.ENTER || me || (l.preventDefault(), handleSubmit());
            }
          }), (0, v.createElement)(P.default, {
            currentLink: A,
            className: "block-editor-link-control__field block-editor-link-control__search-input",
            placeholder: V,
            value: ce,
            withCreateSuggestion: q,
            onCreateSuggestion: fe,
            onChange: ie,
            onSelect: function onSelect(l) {
              D(_objectSpread(_objectSpread({}, l), {}, {
                title: ae || (null == l ? void 0 : l.title)
              })), stopEditing();
            },
            showInitialSuggestions: W,
            allowDirectEntry: !G,
            showSuggestions: U,
            suggestionsQuery: Z,
            withURLSuggestion: !X,
            createSuggestionButtonText: Q,
            useLabel: _e
          }, (0, v.createElement)("div", {
            className: "block-editor-link-control__search-actions"
          }, (0, v.createElement)(y.Button, {
            onClick: handleSubmit,
            label: (0, w.__)("Submit"),
            icon: E.keyboardReturn,
            className: "block-editor-link-control__search-submit",
            disabled: me
          })))), ge && (0, v.createElement)(y.Notice, {
            className: "block-editor-link-control__search-error",
            status: "error",
            isDismissible: !1
          }, ge)), A && !ue && !he && (0, v.createElement)(O.default, {
            key: null == A ? void 0 : A.url,
            value: A,
            onEditClick: function onEditClick() {
              return de(!0);
            },
            hasRichPreviews: J,
            hasUnlinkControl: ve,
            onRemove: F
          }), be && (0, v.createElement)("div", {
            className: "block-editor-link-control__tools"
          }, (0, v.createElement)(B.default, {
            value: A,
            settings: z,
            onChange: D
          })), te && te());
        }

        LinkControl.ViewerFill = V.ViewerFill;
        var A = LinkControl;
        s.default = A;
      },
      9603: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function isURLLike(l) {
          var s = (0, m.startsWith)(l, "#");
          return (0, v.isURL)(l) || l && l.includes("www.") || s;
        };
        var m = c(4793),
            v = c(904);
      },
      9462: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LinkPreview(l) {
          var s = l.value,
              c = l.onEditClick,
              _l$hasRichPreviews2 = l.hasRichPreviews,
              m = _l$hasRichPreviews2 === void 0 ? !1 : _l$hasRichPreviews2,
              _l$hasUnlinkControl = l.hasUnlinkControl,
              P = _l$hasUnlinkControl === void 0 ? !1 : _l$hasUnlinkControl,
              O = l.onRemove;

          var L = m ? null == s ? void 0 : s.url : null,
              _ref275 = (0, B.default)(L),
              V = _ref275.richData,
              R = _ref275.isFetching,
              A = V && Object.keys(V).length,
              z = s && (0, E.filterURLForDisplay)((0, E.safeDecodeURI)(s.url), 16) || "",
              D = (null == V ? void 0 : V.title) || (null == s ? void 0 : s.title) || z,
              F = !s.url.length;

          var G;
          G = null != V && V.icon ? (0, v.createElement)("img", {
            src: null == V ? void 0 : V.icon,
            alt: ""
          }) : F ? (0, v.createElement)(w.Icon, {
            icon: w.info,
            size: 32
          }) : (0, v.createElement)(w.Icon, {
            icon: w.globe
          });
          return (0, v.createElement)("div", {
            "aria-label": (0, k.__)("Currently selected"),
            "aria-selected": "true",
            className: (0, _.default)("block-editor-link-control__search-item", {
              "is-current": !0,
              "is-rich": A,
              "is-fetching": !!R,
              "is-preview": !0,
              "is-error": F
            })
          }, (0, v.createElement)("div", {
            className: "block-editor-link-control__search-item-top"
          }, (0, v.createElement)("span", {
            className: "block-editor-link-control__search-item-header"
          }, (0, v.createElement)("span", {
            className: (0, _.default)("block-editor-link-control__search-item-icon", {
              "is-image": null == V ? void 0 : V.icon
            })
          }, G), (0, v.createElement)("span", {
            className: "block-editor-link-control__search-item-details"
          }, F ? (0, v.createElement)("span", {
            className: "block-editor-link-control__search-item-error-notice"
          }, "Link is empty") : (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.ExternalLink, {
            className: "block-editor-link-control__search-item-title",
            href: s.url
          }, (0, C.__unstableStripHTML)(D)), (null == s ? void 0 : s.url) && (0, v.createElement)("span", {
            className: "block-editor-link-control__search-item-info"
          }, z)))), (0, v.createElement)(y.Button, {
            icon: w.edit,
            label: (0, k.__)("Edit"),
            className: "block-editor-link-control__search-item-action",
            onClick: c,
            iconSize: 24
          }), P && (0, v.createElement)(y.Button, {
            icon: w.linkOff,
            label: (0, k.__)("Unlink"),
            className: "block-editor-link-control__search-item-action block-editor-link-control__unlink",
            onClick: O,
            iconSize: 24
          }), (0, v.createElement)(S.ViewerSlot, {
            fillProps: s
          })), (A && ((null == V ? void 0 : V.image) || (null == V ? void 0 : V.description)) || R) && (0, v.createElement)("div", {
            className: "block-editor-link-control__search-item-bottom"
          }, ((null == V ? void 0 : V.image) || R) && (0, v.createElement)("div", {
            "aria-hidden": !(null != V && V.image),
            className: (0, _.default)("block-editor-link-control__search-item-image", {
              "is-placeholder": !(null != V && V.image)
            })
          }, (null == V ? void 0 : V.image) && (0, v.createElement)("img", {
            src: null == V ? void 0 : V.image,
            alt: ""
          })), ((null == V ? void 0 : V.description) || R) && (0, v.createElement)("div", {
            "aria-hidden": !(null != V && V.description),
            className: (0, _.default)("block-editor-link-control__search-item-description", {
              "is-placeholder": !(null != V && V.description)
            })
          }, (null == V ? void 0 : V.description) && (0, v.createElement)(y.__experimentalText, {
            truncate: !0,
            numberOfLines: "2"
          }, V.description))));
        };

        var v = c(1753),
            _ = m(c(2703)),
            k = c(6756),
            y = c(4892),
            E = c(904),
            w = c(2614),
            C = c(5480),
            S = c(4566),
            B = m(c(9267));
      },
      3642: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.LinkControlSearchCreate = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(4793),
            E = c(6756),
            w = c(4892),
            C = c(2614);

        var LinkControlSearchCreate = function LinkControlSearchCreate(l) {
          var s,
              c = l.searchTerm,
              m = l.onClick,
              S = l.itemProps,
              B = l.isSelected,
              P = l.buttonText;
          return c ? (s = P ? (0, y.isFunction)(P) ? P(c) : P : (0, v.createInterpolateElement)((0, E.sprintf)((0, E.__)("Create: <mark>%s</mark>"), c), {
            mark: (0, v.createElement)("mark", null)
          }), (0, v.createElement)(w.Button, (0, _.default)({}, S, {
            className: (0, k.default)("block-editor-link-control__search-create block-editor-link-control__search-item", {
              "is-selected": B
            }),
            onClick: m
          }), (0, v.createElement)(C.Icon, {
            className: "block-editor-link-control__search-item-icon",
            icon: C.plus
          }), (0, v.createElement)("span", {
            className: "block-editor-link-control__search-item-header"
          }, (0, v.createElement)("span", {
            className: "block-editor-link-control__search-item-title"
          }, s)))) : null;
        };

        s.LinkControlSearchCreate = LinkControlSearchCreate;
        var S = LinkControlSearchCreate;
        s.default = S;
      },
      1609: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            k = m(c(2703)),
            y = c(3200),
            E = c(6756),
            w = c(6330),
            C = m(c(4581)),
            S = c(8008),
            B = m(c(2873));

        var noopSearchHandler = function noopSearchHandler() {
          return Promise.resolve([]);
        },
            P = (0, v.forwardRef)(function (l, s) {
          var c = l.value,
              m = l.children,
              _l$currentLink = l.currentLink,
              O = _l$currentLink === void 0 ? {} : _l$currentLink,
              _l$className = l.className,
              L = _l$className === void 0 ? null : _l$className,
              _l$placeholder = l.placeholder,
              V = _l$placeholder === void 0 ? null : _l$placeholder,
              _l$withCreateSuggesti = l.withCreateSuggestion,
              R = _l$withCreateSuggesti === void 0 ? !1 : _l$withCreateSuggesti,
              _l$onCreateSuggestion = l.onCreateSuggestion,
              A = _l$onCreateSuggestion === void 0 ? _.noop : _l$onCreateSuggestion,
              _l$onChange5 = l.onChange,
              z = _l$onChange5 === void 0 ? _.noop : _l$onChange5,
              _l$onSelect2 = l.onSelect,
              D = _l$onSelect2 === void 0 ? _.noop : _l$onSelect2,
              _l$showSuggestions2 = l.showSuggestions,
              F = _l$showSuggestions2 === void 0 ? !0 : _l$showSuggestions2,
              _l$renderSuggestions = l.renderSuggestions,
              G = _l$renderSuggestions === void 0 ? function (l) {
            return (0, v.createElement)(C.default, l);
          } : _l$renderSuggestions,
              _l$fetchSuggestions = l.fetchSuggestions,
              U = _l$fetchSuggestions === void 0 ? null : _l$fetchSuggestions,
              _l$allowDirectEntry = l.allowDirectEntry,
              W = _l$allowDirectEntry === void 0 ? !0 : _l$allowDirectEntry,
              _l$showInitialSuggest = l.showInitialSuggestions,
              K = _l$showInitialSuggest === void 0 ? !1 : _l$showInitialSuggest,
              _l$suggestionsQuery2 = l.suggestionsQuery,
              $ = _l$suggestionsQuery2 === void 0 ? {} : _l$suggestionsQuery2,
              _l$withURLSuggestion = l.withURLSuggestion,
              q = _l$withURLSuggestion === void 0 ? !0 : _l$withURLSuggestion,
              Y = l.createSuggestionButtonText,
              _l$useLabel = l.useLabel,
              Z = _l$useLabel === void 0 ? !1 : _l$useLabel;

          var X = (0, B.default)($, W, R, q),
              Q = F ? U || X : noopSearchHandler,
              J = (0, y.useInstanceId)(P),
              _ref276 = (0, v.useState)(),
              _ref277 = _slicedToArray(_ref276, 2),
              ee = _ref277[0],
              te = _ref277[1],
              onSuggestionSelected = /*#__PURE__*/function () {
            var _ref278 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(l) {
              var s, c;
              return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      s = l;

                      if (!(S.CREATE_TYPE !== l.type)) {
                        _context7.next = 5;
                        break;
                      }

                      (W || s && Object.keys(s).length >= 1) && D(_objectSpread(_objectSpread({}, (0, _.omit)(O, "id", "url")), s), s);
                      _context7.next = 14;
                      break;

                    case 5:
                      _context7.prev = 5;
                      _context7.next = 8;
                      return A(l.title);

                    case 8:
                      s = _context7.sent;
                      null !== (c = s) && void 0 !== c && c.url && D(s);
                      _context7.next = 14;
                      break;

                    case 12:
                      _context7.prev = 12;
                      _context7.t0 = _context7["catch"](5);

                    case 14:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee7, null, [[5, 12]]);
            }));

            return function onSuggestionSelected(_x8) {
              return _ref278.apply(this, arguments);
            };
          }(),
              ne = (0, k.default)(L, {
            "has-no-label": !Z
          });

          return (0, v.createElement)("div", {
            className: "block-editor-link-control__search-input-container"
          }, (0, v.createElement)(w.URLInput, {
            label: Z ? "URL" : void 0,
            className: ne,
            value: c,
            onChange: function onChange(l, s) {
              z(l), te(s);
            },
            placeholder: null != V ? V : (0, E.__)("Search or type url"),
            __experimentalRenderSuggestions: F ? function (l) {
              return G(_objectSpread(_objectSpread({}, l), {}, {
                instanceId: J,
                withCreateSuggestion: R,
                currentInputValue: c,
                createSuggestionButtonText: Y,
                suggestionsQuery: $,
                handleSuggestionClick: function handleSuggestionClick(s) {
                  l.handleSuggestionClick && l.handleSuggestionClick(s), onSuggestionSelected(s);
                }
              }));
            } : null,
            __experimentalFetchLinkSuggestions: Q,
            __experimentalHandleURLSuggestions: !0,
            __experimentalShowInitialSuggestions: K,
            onSubmit: function onSubmit(l, s) {
              var m;
              var v = l || ee;
              v || null != c && null !== (m = c.trim()) && void 0 !== m && m.length ? onSuggestionSelected(v || {
                url: c
              }) : s.preventDefault();
            },
            ref: s
          }), m);
        });

        var O = P;
        s.default = O;
      },
      2012: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.LinkControlSearchItem = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(904),
            E = c(6756),
            w = c(4892),
            C = c(2614);

        var LinkControlSearchItem = function LinkControlSearchItem(l) {
          var s = l.itemProps,
              c = l.suggestion,
              _l$isSelected = l.isSelected,
              m = _l$isSelected === void 0 ? !1 : _l$isSelected,
              S = l.onClick,
              _l$isURL = l.isURL,
              B = _l$isURL === void 0 ? !1 : _l$isURL,
              _l$searchTerm = l.searchTerm,
              P = _l$searchTerm === void 0 ? "" : _l$searchTerm,
              _l$shouldShowType = l.shouldShowType,
              O = _l$shouldShowType === void 0 ? !1 : _l$shouldShowType;
          return (0, v.createElement)(w.Button, (0, _.default)({}, s, {
            onClick: S,
            className: (0, k.default)("block-editor-link-control__search-item", {
              "is-selected": m,
              "is-url": B,
              "is-entity": !B
            })
          }), B && (0, v.createElement)(C.Icon, {
            className: "block-editor-link-control__search-item-icon",
            icon: C.globe
          }), (0, v.createElement)("span", {
            className: "block-editor-link-control__search-item-header"
          }, (0, v.createElement)("span", {
            className: "block-editor-link-control__search-item-title"
          }, (0, v.createElement)(w.TextHighlight, {
            text: c.title,
            highlight: P
          })), (0, v.createElement)("span", {
            "aria-hidden": !B,
            className: "block-editor-link-control__search-item-info"
          }, !B && ((0, y.filterURLForDisplay)((0, y.safeDecodeURI)(c.url)) || ""), B && (0, E.__)("Press ENTER to add this link"))), O && c.type && (0, v.createElement)("span", {
            className: "block-editor-link-control__search-item-type"
          }, "post_tag" === c.type ? "tag" : c.type));
        };

        s.LinkControlSearchItem = LinkControlSearchItem;
        var S = LinkControlSearchItem;
        s.default = S;
      },
      4581: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LinkControlSearchResults(l) {
          var s = l.instanceId,
              c = l.withCreateSuggestion,
              m = l.currentInputValue,
              B = l.handleSuggestionClick,
              P = l.suggestionsListProps,
              O = l.buildSuggestionItemProps,
              L = l.suggestions,
              V = l.selectedSuggestion,
              R = l.isLoading,
              A = l.isInitialSuggestions,
              z = l.createSuggestionButtonText,
              D = l.suggestionsQuery;
          var F = (0, y.default)("block-editor-link-control__search-results", {
            "is-loading": R
          }),
              G = ["url", "mailto", "tel", "internal"],
              U = 1 === L.length && G.includes(L[0].type.toLowerCase()),
              W = c && !U && !A,
              K = !(null != D && D.type),
              $ = "block-editor-link-control-search-results-label-".concat(s),
              q = A ? (0, _.__)("Recently updated") : (0, _.sprintf)((0, _.__)('Search results for "%s"'), m),
              Y = (0, E.createElement)(A ? E.Fragment : k.VisuallyHidden, {}, (0, E.createElement)("span", {
            className: "block-editor-link-control__search-results-label",
            id: $
          }, q));
          return (0, E.createElement)("div", {
            className: "block-editor-link-control__search-results-wrapper"
          }, Y, (0, E.createElement)("div", (0, v.default)({}, P, {
            className: F,
            "aria-labelledby": $
          }), L.map(function (l, s) {
            return W && S.CREATE_TYPE === l.type ? (0, E.createElement)(w.default, {
              searchTerm: m,
              buttonText: z,
              onClick: function onClick() {
                return B(l);
              },
              key: l.type,
              itemProps: O(l, s),
              isSelected: s === V
            }) : S.CREATE_TYPE === l.type ? null : (0, E.createElement)(C.default, {
              key: "".concat(l.id, "-").concat(l.type),
              itemProps: O(l, s),
              suggestion: l,
              index: s,
              onClick: function onClick() {
                B(l);
              },
              isSelected: s === V,
              isURL: G.includes(l.type.toLowerCase()),
              searchTerm: m,
              shouldShowType: K
            });
          })));
        };

        var v = m(c(5221)),
            _ = c(6756),
            k = c(4892),
            y = m(c(2703)),
            E = c(1753),
            w = m(c(3642)),
            C = m(c(2012)),
            S = c(8008);
      },
      7940: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(4793),
            _ = c(6756),
            k = c(4892);

        var _default = function _default(l) {
          var s = l.value,
              _l$onChange6 = l.onChange,
              c = _l$onChange6 === void 0 ? v.noop : _l$onChange6,
              y = l.settings;
          if (!y || !y.length) return null;

          var handleSettingChange = function handleSettingChange(l) {
            return function (m) {
              c(_objectSpread(_objectSpread({}, s), {}, _defineProperty({}, l.id, m)));
            };
          },
              E = y.map(function (l) {
            return (0, m.createElement)(k.ToggleControl, {
              className: "block-editor-link-control__setting",
              key: l.id,
              label: l.title,
              onChange: handleSettingChange(l),
              checked: !!s && !!s[l.id]
            });
          });

          return (0, m.createElement)("fieldset", {
            className: "block-editor-link-control__settings"
          }, (0, m.createElement)(k.VisuallyHidden, {
            as: "legend"
          }, (0, _.__)("Currently selected link settings")), E);
        };

        s.default = _default;
      },
      5320: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useCreatePage(l) {
          var s = (0, v.useRef)(),
              _ref279 = (0, v.useState)(!1),
              _ref280 = _slicedToArray(_ref279, 2),
              c = _ref280[0],
              _ = _ref280[1],
              _ref281 = (0, v.useState)(null),
              _ref282 = _slicedToArray(_ref281, 2),
              k = _ref282[0],
              y = _ref282[1];

          return (0, v.useEffect)(function () {
            return function () {
              s.current && s.current.cancel();
            };
          }, []), {
            createPage: function () {
              var _createPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(c) {
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        _(!0), y(null);
                        _context8.prev = 1;
                        s.current = makeCancelable(Promise.resolve(l(c)));
                        _context8.next = 5;
                        return s.current.promise;

                      case 5:
                        return _context8.abrupt("return", _context8.sent);

                      case 8:
                        _context8.prev = 8;
                        _context8.t0 = _context8["catch"](1);

                        if (!(_context8.t0 && _context8.t0.isCanceled)) {
                          _context8.next = 12;
                          break;
                        }

                        return _context8.abrupt("return");

                      case 12:
                        throw y(_context8.t0.message || (0, m.__)("An unknown error occurred during creation. Please try again.")), _context8.t0;

                      case 13:
                        _context8.prev = 13;

                        _(!1);

                        return _context8.finish(13);

                      case 16:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8, null, [[1, 8, 13, 16]]);
              }));

              function createPage(_x9) {
                return _createPage.apply(this, arguments);
              }

              return createPage;
            }(),
            isCreatingPage: c,
            errorMessage: k
          };
        };
        var m = c(6756),
            v = c(1753);

        var makeCancelable = function makeCancelable(l) {
          var s = !1;
          return {
            promise: new Promise(function (c, m) {
              l.then(function (l) {
                return s ? m({
                  isCanceled: !0
                }) : c(l);
              }, function (l) {
                return m(s ? {
                  isCanceled: !0
                } : l);
              });
            }),
            cancel: function cancel() {
              s = !0;
            }
          };
        };
      },
      9267: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(8486),
            v = c(8467),
            _ = c(1753);

        function reducer(l, s) {
          switch (s.type) {
            case "RESOLVED":
              return _objectSpread(_objectSpread({}, l), {}, {
                isFetching: !1,
                richData: s.richData
              });

            case "ERROR":
              return _objectSpread(_objectSpread({}, l), {}, {
                isFetching: !1,
                richData: null
              });

            case "LOADING":
              return _objectSpread(_objectSpread({}, l), {}, {
                isFetching: !0
              });

            default:
              throw new Error("Unexpected action type ".concat(s.type));
          }
        }

        var k = function useRemoteUrlData(l) {
          var _ref283 = (0, _.useReducer)(reducer, {
            richData: null,
            isFetching: !1
          }),
              _ref284 = _slicedToArray(_ref283, 2),
              s = _ref284[0],
              c = _ref284[1],
              _ref285 = (0, v.useSelect)(function (l) {
            var _l110 = l(m.store),
                s = _l110.getSettings;

            return {
              fetchRichUrlData: s().__experimentalFetchRichUrlData
            };
          }, []),
              k = _ref285.fetchRichUrlData;

          return (0, _.useEffect)(function () {
            if (null != l && l.length && k && "undefined" != typeof AbortController) {
              c({
                type: "LOADING"
              });

              var _s51 = new window.AbortController(),
                  _m29 = _s51.signal;

              return k(l, {
                signal: _m29
              }).then(function (l) {
                c({
                  type: "RESOLVED",
                  richData: l
                });
              }).catch(function () {
                _m29.aborted || c({
                  type: "ERROR"
                });
              }), function () {
                _s51.abort();
              };
            }
          }, [l]), s;
        };

        s.default = k;
      },
      2873: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useSearchHandler(l, s, c, m) {
          var _ref286 = (0, k.useSelect)(function (l) {
            var _l111 = l(C.store),
                s = _l111.getSettings;

            return {
              fetchSearchSuggestions: s().__experimentalFetchLinkSuggestions
            };
          }, []),
              v = _ref286.fetchSearchSuggestions,
              y = s ? handleDirectEntry : handleNoop;

          return (0, _.useCallback)(function (s, _) {
            var k = _.isInitialSuggestions;
            return (0, E.default)(s) ? y(s, {
              isInitialSuggestions: k
            }) : function () {
              var _ref287 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(l, s, c, m, v, _) {
                var k, y;
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        k = s.isInitialSuggestions;
                        _context9.next = 3;
                        return Promise.all([c(l, s), m(l)]);

                      case 3:
                        y = _context9.sent;
                        y = l.includes(" ") || !_ || k ? y[0] : y[0].concat(y[1]);

                        if (!k) {
                          _context9.next = 7;
                          break;
                        }

                        return _context9.abrupt("return", y);

                      case 7:
                        return _context9.abrupt("return", (0, E.default)(l) || !v ? y : y.concat({
                          title: l,
                          url: l,
                          type: w.CREATE_TYPE
                        }));

                      case 8:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              }));

              return function (_x10, _x11, _x12, _x13, _x14, _x15) {
                return _ref287.apply(this, arguments);
              };
            }()(s, _objectSpread(_objectSpread({}, l), {}, {
              isInitialSuggestions: k
            }), v, y, c, m);
          }, [y, v, c]);
        }, s.handleNoop = s.handleDirectEntry = void 0;

        var v = c(904),
            _ = c(1753),
            k = c(8467),
            y = c(4793),
            E = m(c(9603)),
            w = c(8008),
            C = c(8486);

        var handleNoop = function handleNoop() {
          return Promise.resolve([]);
        };

        s.handleNoop = handleNoop;

        var handleDirectEntry = function handleDirectEntry(l) {
          var s = "URL";
          var c = (0, v.getProtocol)(l) || "";
          return c.includes("mailto") && (s = "mailto"), c.includes("tel") && (s = "tel"), (0, y.startsWith)(l, "#") && (s = "internal"), Promise.resolve([{
            id: l,
            title: l,
            url: "URL" === s ? (0, v.prependHTTP)(l) : l,
            type: s
          }]);
        };

        s.handleDirectEntry = handleDirectEntry;
      },
      4566: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = s.ViewerSlot = s.ViewerFill = void 0;
        var m = c(4892);

        var _ref288 = (0, m.createSlotFill)("BlockEditorLinkControlViewer"),
            v = _ref288.Slot,
            _ = _ref288.Fill;

        s.ViewerFill = _, s.ViewerSlot = v;
        var k = v;
        s.default = k;
      },
      5284: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(8467),
            E = m(c(8919)),
            w = m(c(566)),
            C = c(8486);

        var S = (0, v.forwardRef)(function (l, s) {
          var c = l.onClick,
              m = l.onToggleExpanded,
              S = l.block,
              B = l.isSelected,
              P = l.position,
              O = l.siblingBlockCount,
              L = l.level,
              V = _objectWithoutProperties(l, _excluded27);

          var R = S.clientId,
              _ref289 = (0, y.useSelect)(function (l) {
            var _l112 = l(C.store),
                s = _l112.getBlockRootClientId,
                c = _l112.hasBlockMovingClientId,
                m = _l112.getSelectedBlockClientId;

            return {
              rootClientId: s(R) || "",
              blockMovingClientId: c(),
              selectedBlockInBlockEditor: m()
            };
          }, [R]),
              A = _ref289.blockMovingClientId,
              z = _ref289.selectedBlockInBlockEditor,
              D = A && z === R,
              F = (0, k.default)("block-editor-list-view-block-contents", {
            "is-dropping-before": D
          });

          return (0, v.createElement)(w.default, {
            clientIds: [S.clientId]
          }, function (l) {
            var k = l.draggable,
                y = l.onDragStart,
                w = l.onDragEnd;
            return (0, v.createElement)(E.default, (0, _.default)({
              ref: s,
              className: F,
              block: S,
              onClick: c,
              onToggleExpanded: m,
              isSelected: B,
              position: P,
              siblingBlockCount: O,
              level: L,
              draggable: k,
              onDragStart: y,
              onDragEnd: w
            }, V));
          });
        });
        s.default = S;
      },
      8919: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(4892),
            y = c(3200),
            E = c(6756),
            w = m(c(2006)),
            C = m(c(139)),
            S = c(9907),
            B = m(c(6147)),
            P = m(c(5862));

        var O = (0, v.forwardRef)(function ListViewBlockSelectButton(l, s) {
          var c = l.className,
              m = l.block.clientId,
              O = l.isSelected,
              L = l.onClick,
              V = l.onToggleExpanded,
              R = l.position,
              A = l.siblingBlockCount,
              z = l.level,
              D = l.tabIndex,
              F = l.onFocus,
              G = l.onDragStart,
              U = l.onDragEnd,
              W = l.draggable;
          var K = (0, C.default)(m),
              $ = "list-view-block-select-button__".concat((0, y.useInstanceId)(ListViewBlockSelectButton)),
              q = (0, S.getBlockPositionDescription)(R, A, z);
          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.Button, {
            className: (0, _.default)("block-editor-list-view-block-select-button", c),
            onClick: L,
            "aria-describedby": $,
            ref: s,
            tabIndex: D,
            onFocus: F,
            onDragStart: G,
            onDragEnd: U,
            draggable: W
          }, (0, v.createElement)(P.default, {
            onClick: V
          }), (0, v.createElement)(w.default, {
            icon: null == K ? void 0 : K.icon,
            showColors: !0
          }), (0, v.createElement)(B.default, {
            clientId: m
          }), (null == K ? void 0 : K.anchor) && (0, v.createElement)("span", {
            className: "block-editor-list-view-block-select-button__anchor"
          }, K.anchor), O && (0, v.createElement)(k.VisuallyHidden, null, (0, E.__)("(selected block)"))), (0, v.createElement)("div", {
            className: "block-editor-list-view-block-select-button__description",
            id: $
          }, q));
        });
        s.default = O;
      },
      9075: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(4892),
            y = c(2614),
            E = c(8467),
            w = m(c(9131)),
            C = c(8855),
            S = m(c(5284)),
            B = m(c(272)),
            P = c(2338),
            O = c(8486);

        var L = (0, v.memo)(function ListViewBlock(l) {
          var s = l.block,
              c = l.isDragged,
              m = l.isSelected,
              L = l.isBranchSelected,
              V = l.selectBlock,
              R = l.position,
              A = l.level,
              z = l.rowCount,
              D = l.siblingBlockCount,
              F = l.showBlockMovers,
              G = l.path,
              U = l.isExpanded;

          var W = (0, v.useRef)(null),
              _ref290 = (0, v.useState)(!1),
              _ref291 = _slicedToArray(_ref290, 2),
              K = _ref291[0],
              $ = _ref291[1],
              q = s.clientId,
              _ref292 = (0, E.useDispatch)(O.store),
              Y = _ref292.toggleBlockHighlight,
              _ref293 = (0, P.useListViewContext)(),
              Z = _ref293.__experimentalFeatures,
              X = _ref293.__experimentalPersistentListViewFeatures,
              Q = _ref293.__experimentalHideContainerBlockActions,
              J = _ref293.isTreeGridMounted,
              ee = _ref293.expand,
              te = _ref293.collapse,
              ne = F && D > 0,
              oe = (0, _.default)("block-editor-list-view-block__mover-cell", {
            "is-visible": K || m
          }),
              re = (0, _.default)("block-editor-list-view-block__menu-cell", {
            "is-visible": K || m
          });

          (0, v.useEffect)(function () {
            X && !J && m && W.current.focus();
          }, []);
          var le = X ? Y : function () {},
              ie = (0, v.useCallback)(function () {
            $(!0), le(q, !0);
          }, [q, $, le]),
              ae = (0, v.useCallback)(function () {
            $(!1), le(q, !1);
          }, [q, $, le]),
              se = (0, v.useCallback)(function (l) {
            l.stopPropagation(), V(q);
          }, [q, V]),
              ce = (0, v.useCallback)(function (l) {
            l.stopPropagation(), !0 === U ? te(q) : !1 === U && ee(q);
          }, [q, ee, te, U]),
              ue = Z && (!Q || Q && A > 1),
              de = Z && !ue;
          var pe;
          ne ? pe = 2 : de && (pe = 3);
          var me = (0, _.default)({
            "is-selected": m,
            "is-branch-selected": X && L,
            "is-dragging": c,
            "has-single-cell": de
          });
          return (0, v.createElement)(w.default, {
            className: me,
            onMouseEnter: ie,
            onMouseLeave: ae,
            onFocus: ie,
            onBlur: ae,
            level: A,
            position: R,
            rowCount: z,
            path: G,
            id: "list-view-block-".concat(q),
            "data-block": q,
            isExpanded: U
          }, (0, v.createElement)(k.__experimentalTreeGridCell, {
            className: "block-editor-list-view-block__contents-cell",
            colSpan: pe,
            ref: W
          }, function (l) {
            var c = l.ref,
                _ = l.tabIndex,
                k = l.onFocus;
            return (0, v.createElement)("div", {
              className: "block-editor-list-view-block__contents-container"
            }, (0, v.createElement)(S.default, {
              block: s,
              onClick: se,
              onToggleExpanded: ce,
              isSelected: m,
              position: R,
              siblingBlockCount: D,
              level: A,
              ref: c,
              tabIndex: _,
              onFocus: k
            }));
          }), ne && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.__experimentalTreeGridCell, {
            className: oe,
            withoutGridItem: !0
          }, (0, v.createElement)(k.__experimentalTreeGridItem, null, function (l) {
            var s = l.ref,
                c = l.tabIndex,
                m = l.onFocus;
            return (0, v.createElement)(C.BlockMoverUpButton, {
              orientation: "vertical",
              clientIds: [q],
              ref: s,
              tabIndex: c,
              onFocus: m
            });
          }), (0, v.createElement)(k.__experimentalTreeGridItem, null, function (l) {
            var s = l.ref,
                c = l.tabIndex,
                m = l.onFocus;
            return (0, v.createElement)(C.BlockMoverDownButton, {
              orientation: "vertical",
              clientIds: [q],
              ref: s,
              tabIndex: c,
              onFocus: m
            });
          }))), ue && (0, v.createElement)(k.__experimentalTreeGridCell, {
            className: re
          }, function (l) {
            var s = l.ref,
                c = l.tabIndex,
                m = l.onFocus;
            return (0, v.createElement)(B.default, {
              clientIds: [q],
              icon: y.moreVertical,
              toggleProps: {
                ref: s,
                className: "block-editor-list-view-block__menu",
                tabIndex: c,
                onFocus: m
              },
              disableOpenOnArrowDown: !0,
              __experimentalSelectBlock: se
            });
          }));
        });
        s.default = L;
      },
      7239: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            k = c(8467),
            y = m(c(9075)),
            E = c(2338),
            w = c(9907);

        function countBlocks(l, s, c) {
          var m;
          if (null == c ? void 0 : c.includes(l.clientId)) return 0;
          return null === (m = s[l.clientId]) || void 0 === m || m ? 1 + l.innerBlocks.reduce(countReducer(s, c), 0) : 1;
        }

        var countReducer = function countReducer(l, s) {
          return function (c, m) {
            var v;
            if (null == s ? void 0 : s.includes(m.clientId)) return c;
            return (null === (v = l[m.clientId]) || void 0 === v || v) && m.innerBlocks.length > 0 ? c + countBlocks(m, l, s) : c + 1;
          };
        };

        function ListViewBranch(l) {
          var s = l.blocks,
              c = l.selectBlock,
              m = l.showBlockMovers,
              C = l.showNestedBlocks,
              S = l.selectedClientIds,
              _l$level = l.level,
              B = _l$level === void 0 ? 1 : _l$level,
              _l$path = l.path,
              P = _l$path === void 0 ? "" : _l$path,
              _l$isBranchSelected = l.isBranchSelected,
              O = _l$isBranchSelected === void 0 ? !1 : _l$isBranchSelected,
              _l$listPosition = l.listPosition,
              L = _l$listPosition === void 0 ? 0 : _l$listPosition,
              V = l.fixedListWindow,
              _ref294 = (0, E.useListViewContext)(),
              R = _ref294.expandedState,
              A = _ref294.draggedClientIds,
              z = _ref294.__experimentalPersistentListViewFeatures,
              D = (0, _.compact)(s),
              F = D.length;

          var G = L;
          return (0, v.createElement)(v.Fragment, null, D.map(function (l, s) {
            var _;

            var E = l.clientId,
                L = l.innerBlocks;
            s > 0 && (G += countBlocks(D[s - 1], R, A));
            var U = z,
                W = V.itemInView,
                K = !U || W(G),
                $ = s + 1,
                q = P.length > 0 ? "".concat(P, "_").concat($) : "".concat($),
                Y = C && !!L && !!L.length,
                Z = Y ? null === (_ = R[E]) || void 0 === _ || _ : void 0,
                X = !(null == A || !A.includes(E)),
                Q = X || K,
                J = (0, w.isClientIdSelected)(E, S),
                ee = O || J && Y;
            return (0, v.createElement)(k.AsyncModeProvider, {
              key: E,
              value: !J
            }, Q && (0, v.createElement)(y.default, {
              block: l,
              selectBlock: c,
              isSelected: J,
              isBranchSelected: ee,
              isDragged: X,
              level: B,
              position: $,
              rowCount: F,
              siblingBlockCount: F,
              showBlockMovers: m,
              path: q,
              isExpanded: Z,
              listPosition: G
            }), !Q && (0, v.createElement)("tr", null, (0, v.createElement)("td", {
              className: "block-editor-list-view-placeholder"
            })), Y && Z && !X && (0, v.createElement)(ListViewBranch, {
              blocks: L,
              selectBlock: c,
              showBlockMovers: m,
              showNestedBlocks: C,
              level: B + 1,
              path: q,
              listPosition: G + 1,
              fixedListWindow: V,
              isBranchSelected: ee,
              selectedClientIds: S
            }));
          }));
        }

        ListViewBranch.defaultProps = {
          selectBlock: function selectBlock() {}
        };
        var C = (0, v.memo)(ListViewBranch);
        s.default = C;
      },
      2338: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useListViewContext = s.ListViewContext = void 0;
        var m = c(1753);
        var v = (0, m.createContext)({
          __experimentalFeatures: !1,
          __experimentalPersistentListViewFeatures: !1
        });
        s.ListViewContext = v;

        s.useListViewContext = function () {
          return (0, m.useContext)(v);
        };
      },
      4148: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ListViewDropIndicator(l) {
          var s = l.listViewRef,
              c = l.blockDropTarget;

          var _ref295 = c || {},
              _ = _ref295.rootClientId,
              k = _ref295.clientId,
              y = _ref295.dropPosition,
              _ref296 = (0, m.useMemo)(function () {
            if (!s.current) return [];
            return [_ ? s.current.querySelector("[data-block=\"".concat(_, "\"]")) : void 0, k ? s.current.querySelector("[data-block=\"".concat(k, "\"]")) : void 0];
          }, [_, k]),
              _ref297 = _slicedToArray(_ref296, 2),
              E = _ref297[0],
              w = _ref297[1],
              C = w || E,
              S = (0, m.useCallback)(function () {
            if (!E) return 0;
            var l = C.getBoundingClientRect();
            return E.querySelector(".block-editor-block-icon").getBoundingClientRect().right - l.left;
          }, [E, C]),
              B = (0, m.useMemo)(function () {
            if (!C) return {};
            var l = S();
            return {
              width: C.offsetWidth - l
            };
          }, [S, C]),
              P = (0, m.useCallback)(function () {
            if (!C) return {};
            var l = C.ownerDocument,
                s = C.getBoundingClientRect(),
                c = S(),
                m = {
              left: s.left + c,
              right: s.right,
              width: 0,
              height: s.height,
              ownerDocument: l
            };
            return "top" === y ? _objectSpread(_objectSpread({}, m), {}, {
              top: s.top,
              bottom: s.top
            }) : "bottom" === y || "inside" === y ? _objectSpread(_objectSpread({}, m), {}, {
              top: s.bottom,
              bottom: s.bottom
            }) : {};
          }, [C, y, S]);

          if (!C) return null;
          return (0, m.createElement)(v.Popover, {
            noArrow: !0,
            animate: !1,
            getAnchorRect: P,
            focusOnMount: !1,
            className: "block-editor-list-view-drop-indicator"
          }, (0, m.createElement)("div", {
            style: B,
            className: "block-editor-list-view-drop-indicator__line"
          }));
        };
        var m = c(1753),
            v = c(4892);
      },
      5862: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ListViewExpander(l) {
          var s = l.onClick;
          return (0, m.createElement)("span", {
            className: "block-editor-list-view__expander",
            onClick: function onClick(l) {
              return s(l, {
                forceToggle: !0
              });
            },
            "aria-hidden": "true"
          }, (0, m.createElement)(v.Icon, {
            icon: v.chevronRightSmall
          }));
        };
        var m = c(1753),
            v = c(2614);
      },
      609: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(3200),
            y = c(4892),
            E = c(8467),
            w = c(6756),
            C = m(c(7239)),
            S = c(2338),
            B = m(c(4148)),
            P = m(c(986)),
            O = m(c(8773)),
            L = c(8486);

        var noop = function noop() {},
            expanded = function expanded(l, s) {
          switch (s.type) {
            case "expand":
              return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, s.clientId, !0));

            case "collapse":
              return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, s.clientId, !1));

            default:
              return l;
          }
        };

        var V = (0, v.forwardRef)(function ListView(l, s) {
          var c = l.blocks,
              _l$onSelect3 = l.onSelect,
              m = _l$onSelect3 === void 0 ? noop : _l$onSelect3,
              V = l.__experimentalFeatures,
              R = l.__experimentalPersistentListViewFeatures,
              A = l.__experimentalHideContainerBlockActions,
              z = l.showNestedBlocks,
              D = l.showBlockMovers,
              F = _objectWithoutProperties(l, _excluded28);

          var _ref298 = (0, P.default)(c),
              G = _ref298.clientIdsTree,
              U = _ref298.draggedClientIds,
              W = _ref298.selectedClientIds,
              _ref299 = (0, E.useDispatch)(L.store),
              K = _ref299.selectBlock,
              _ref300 = (0, E.useSelect)(function (l) {
            var _l113 = l(L.store),
                s = _l113.getGlobalBlockCount,
                c = _l113.getClientIdsOfDescendants,
                m = (null == U ? void 0 : U.length) > 0 ? c(U).length + 1 : 0;

            return {
              visibleBlockCount: s() - m
            };
          }, [U]),
              $ = _ref300.visibleBlockCount,
              q = (0, v.useCallback)(function (l) {
            K(l), m(l);
          }, [K, m]),
              _ref301 = (0, v.useReducer)(expanded, {}),
              _ref302 = _slicedToArray(_ref301, 2),
              Y = _ref302[0],
              Z = _ref302[1],
              _ref303 = (0, O.default)(),
              X = _ref303.ref,
              Q = _ref303.target,
              J = (0, v.useRef)(),
              ee = (0, k.useMergeRefs)([J, X, s]),
              te = (0, v.useRef)(!1);

          (0, v.useEffect)(function () {
            te.current = !0;
          }, []);

          var _ref304 = (0, k.__experimentalUseFixedWindowList)(J, 36, $, {
            useWindowing: R,
            windowOverscan: 40
          }),
              _ref305 = _slicedToArray(_ref304, 1),
              ne = _ref305[0],
              oe = (0, v.useCallback)(function (l) {
            l && Z({
              type: "expand",
              clientId: l
            });
          }, [Z]),
              re = (0, v.useCallback)(function (l) {
            l && Z({
              type: "collapse",
              clientId: l
            });
          }, [Z]),
              le = (0, v.useCallback)(function (l) {
            var s;
            oe(null == l || null === (s = l.dataset) || void 0 === s ? void 0 : s.block);
          }, [oe]),
              ie = (0, v.useCallback)(function (l) {
            var s;
            re(null == l || null === (s = l.dataset) || void 0 === s ? void 0 : s.block);
          }, [re]),
              ae = (0, v.useMemo)(function () {
            return {
              __experimentalFeatures: V,
              __experimentalPersistentListViewFeatures: R,
              __experimentalHideContainerBlockActions: A,
              isTreeGridMounted: te.current,
              draggedClientIds: U,
              expandedState: Y,
              expand: oe,
              collapse: re
            };
          }, [V, R, A, te.current, U, Y, oe, re]);

          return (0, v.createElement)(E.AsyncModeProvider, {
            value: !0
          }, (0, v.createElement)(B.default, {
            listViewRef: J,
            blockDropTarget: Q
          }), (0, v.createElement)(y.__experimentalTreeGrid, {
            className: "block-editor-list-view-tree",
            "aria-label": (0, w.__)("Block navigation structure"),
            ref: ee,
            onCollapseRow: ie,
            onExpandRow: le
          }, (0, v.createElement)(S.ListViewContext.Provider, {
            value: ae
          }, (0, v.createElement)(C.default, (0, _.default)({
            blocks: G,
            selectBlock: q,
            showNestedBlocks: z,
            showBlockMovers: D,
            fixedListWindow: ne,
            selectedClientIds: W
          }, F)))));
        });
        s.default = V;
      },
      9131: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ListViewLeaf(l) {
          var s = l.isSelected,
              c = l.position,
              m = l.level,
              k = l.rowCount,
              E = l.children,
              S = l.className,
              B = l.path,
              P = _objectWithoutProperties(l, _excluded29);

          var O = (0, w.default)({
            isSelected: s,
            adjustScrolling: !1,
            enableAnimation: !0,
            triggerAnimationOnChange: B
          });
          return (0, v.createElement)(C, (0, _.default)({
            ref: O,
            className: (0, y.default)("block-editor-list-view-leaf", S),
            level: m,
            positionInSet: c,
            setSize: k
          }, P), E);
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(5029),
            y = m(c(2703)),
            E = c(4892),
            w = m(c(9322));

        var C = (0, k.animated)(E.__experimentalTreeGridRow);
      },
      986: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useListViewClientIds(l) {
          return (0, m.useSelect)(function (s) {
            var _s52 = s(v.store),
                c = _s52.getDraggedBlockClientIds,
                m = _s52.getSelectedBlockClientIds,
                _ = _s52.__unstableGetClientIdsTree;

            return {
              selectedClientIds: m(),
              draggedClientIds: c(),
              clientIdsTree: l || _()
            };
          }, [l]);
        };
        var m = c(8467),
            v = c(8486);
      },
      8773: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useListViewDropZone() {
          var _ref306 = (0, v.useSelect)(w.store),
              l = _ref306.getBlockRootClientId,
              s = _ref306.getBlockIndex,
              c = _ref306.getBlockCount,
              m = _ref306.getDraggedBlockClientIds,
              S = _ref306.canInsertBlocks,
              _ref307 = (0, _.useState)(),
              _ref308 = _slicedToArray(_ref307, 2),
              B = _ref308[0],
              P = _ref308[1],
              _ref309 = B || {},
              O = _ref309.rootClientId,
              L = _ref309.blockIndex,
              V = (0, E.default)(O, L),
              R = m(),
              A = (0, k.useThrottle)((0, _.useCallback)(function (m, v) {
            var _ = {
              x: m.clientX,
              y: m.clientY
            },
                k = !(null == R || !R.length),
                E = function getListViewDropTarget(l, s) {
              var c, m, v, _;

              var _iterator9 = _createForOfIteratorHelper(l),
                  _step9;

              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var _k5 = _step9.value;
                  if (_k5.isDraggedBlock) continue;

                  var _E5 = _k5.element.getBoundingClientRect(),
                      _ref310 = (0, y.getDistanceToNearestEdge)(s, _E5, C),
                      _ref311 = _slicedToArray(_ref310, 2),
                      _w2 = _ref311[0],
                      _S = _ref311[1],
                      _B = isPointContainedByRect(s, _E5);

                  if (void 0 === v || _w2 < v || _B) {
                    v = _w2;

                    var _s53 = l.indexOf(_k5),
                        _y4 = l[_s53 - 1];

                    if ("top" === _S && _y4 && _y4.rootClientId === _k5.rootClientId && !_y4.isDraggedBlock ? (m = _y4, c = "bottom", _ = _y4.element.getBoundingClientRect()) : (m = _k5, c = _S, _ = _E5), _B) break;
                  }
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }

              if (!m) return;
              var k = "bottom" === c;
              if (k && m.canInsertDraggedBlocksAsChild && (m.innerBlockCount > 0 || function isNestingGesture(l, s) {
                var c = s.left + s.width / 2;
                return l.x > c;
              }(s, _))) return {
                rootClientId: m.clientId,
                blockIndex: 0,
                dropPosition: "inside"
              };
              if (!m.canInsertDraggedBlocksAsSibling) return;
              var E = k ? 1 : 0;
              return {
                rootClientId: m.rootClientId,
                clientId: m.clientId,
                blockIndex: m.blockIndex + E,
                dropPosition: c
              };
            }(Array.from(v.querySelectorAll("[data-block]")).map(function (m) {
              var v = m.dataset.block,
                  _ = l(v);

              return {
                clientId: v,
                rootClientId: _,
                blockIndex: s(v),
                element: m,
                isDraggedBlock: !!k && R.includes(v),
                innerBlockCount: c(v),
                canInsertDraggedBlocksAsSibling: !k || S(R, _),
                canInsertDraggedBlocksAsChild: !k || S(R, v)
              };
            }), _);

            E && P(E);
          }, [R]), 200);

          return {
            ref: (0, k.__experimentalUseDropZone)({
              onDrop: V,
              onDragOver: function onDragOver(l) {
                A(l, l.currentTarget);
              },
              onDragEnd: function onDragEnd() {
                A.cancel(), P(null);
              }
            }),
            target: B
          };
        };

        var v = c(8467),
            _ = c(1753),
            k = c(3200),
            y = c(4712),
            E = m(c(6507)),
            w = c(8486);

        function isPointContainedByRect(l, s) {
          return s.left <= l.x && s.right >= l.x && s.top <= l.y && s.bottom >= l.y;
        }

        var C = ["top", "bottom"];
      },
      9907: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.isClientIdSelected = s.getBlockPositionDescription = void 0;
        var m = c(4793),
            v = c(6756);

        s.getBlockPositionDescription = function (l, s, c) {
          return (0, v.sprintf)((0, v.__)("Block %1$d of %2$d, Level %3$d"), l, s, c);
        };

        s.isClientIdSelected = function (l, s) {
          return (0, m.isArray)(s) && s.length ? -1 !== s.indexOf(l) : s === l;
        };
      },
      7666: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.MediaPlaceholder = MediaPlaceholder, s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            k = m(c(2703)),
            y = c(4892),
            E = c(6756),
            w = c(8467),
            C = m(c(3703)),
            S = c(2614),
            B = m(c(4625)),
            P = m(c(2596)),
            O = m(c(3390)),
            L = c(8486);

        var InsertFromURLPopover = function InsertFromURLPopover(l) {
          var s = l.src,
              c = l.onChange,
              m = l.onSubmit,
              _ = l.onClose;
          return (0, v.createElement)(O.default, {
            onClose: _
          }, (0, v.createElement)("form", {
            className: "block-editor-media-placeholder__url-input-form",
            onSubmit: m
          }, (0, v.createElement)("input", {
            className: "block-editor-media-placeholder__url-input-field",
            type: "text",
            "aria-label": (0, E.__)("URL"),
            placeholder: (0, E.__)("Paste or type URL"),
            onChange: c,
            value: s
          }), (0, v.createElement)(y.Button, {
            className: "block-editor-media-placeholder__url-input-submit-button",
            icon: S.keyboardReturn,
            label: (0, E.__)("Apply"),
            type: "submit"
          })));
        };

        function MediaPlaceholder(l) {
          var _l$value5 = l.value,
              s = _l$value5 === void 0 ? {} : _l$value5,
              c = l.allowedTypes,
              m = l.className,
              S = l.icon,
              _l$labels = l.labels,
              O = _l$labels === void 0 ? {} : _l$labels,
              V = l.mediaPreview,
              R = l.notices,
              A = l.isAppender,
              z = l.accept,
              D = l.addToGallery,
              _l$multiple = l.multiple,
              F = _l$multiple === void 0 ? !1 : _l$multiple,
              _l$handleUpload = l.handleUpload,
              G = _l$handleUpload === void 0 ? !0 : _l$handleUpload,
              U = l.dropZoneUIOnly,
              W = l.disableDropZone,
              K = l.disableMediaButtons,
              $ = l.onError,
              q = l.onSelect,
              Y = l.onCancel,
              Z = l.onSelectURL,
              X = l.onDoubleClick,
              _l$onFilesPreUpload = l.onFilesPreUpload,
              Q = _l$onFilesPreUpload === void 0 ? _.noop : _l$onFilesPreUpload,
              _l$onHTMLDrop = l.onHTMLDrop,
              J = _l$onHTMLDrop === void 0 ? _.noop : _l$onHTMLDrop,
              ee = l.children,
              te = l.mediaLibraryButton,
              ne = l.placeholder,
              oe = l.style;

          var re = (0, w.useSelect)(function (l) {
            var _l114 = l(L.store),
                s = _l114.getSettings;

            return s().mediaUpload;
          }, []),
              _ref312 = (0, v.useState)(""),
              _ref313 = _slicedToArray(_ref312, 2),
              le = _ref313[0],
              ie = _ref313[1],
              _ref314 = (0, v.useState)(!1),
              _ref315 = _slicedToArray(_ref314, 2),
              ae = _ref315[0],
              se = _ref315[1];

          (0, v.useEffect)(function () {
            var l;
            ie(null !== (l = null == s ? void 0 : s.src) && void 0 !== l ? l : "");
          }, [null == s ? void 0 : s.src]);

          var onChangeSrc = function onChangeSrc(l) {
            ie(l.target.value);
          },
              openURLInput = function openURLInput() {
            se(!0);
          },
              closeURLInput = function closeURLInput() {
            se(!1);
          },
              onSubmitSrc = function onSubmitSrc(l) {
            l.preventDefault(), le && Z && (Z(le), closeURLInput());
          },
              onFilesUpload = function onFilesUpload(l) {
            if (!G) return q(l);
            var m;
            if (Q(l), F) {
              if (D) {
                var _l115 = [];

                m = function m(c) {
                  var m = (null != s ? s : []).filter(function (s) {
                    return s.id ? !_l115.some(function (l) {
                      var c = l.id;
                      return Number(c) === Number(s.id);
                    }) : !_l115.some(function (l) {
                      var c = l.urlSlug;
                      return s.url.includes(c);
                    });
                  });
                  q(m.concat(c)), _l115 = c.map(function (l) {
                    var s = l.url.lastIndexOf("."),
                        c = l.url.slice(0, s);
                    return {
                      id: l.id,
                      urlSlug: c
                    };
                  });
                };
              } else m = q;
            } else m = function m(l) {
              var _l116 = _slicedToArray(l, 1),
                  s = _l116[0];

              return q(s);
            };
            re({
              allowedTypes: c,
              filesList: l,
              onFileChange: m,
              onError: $
            });
          },
              onUpload = function onUpload(l) {
            onFilesUpload(l.target.files);
          },
              ce = null != ne ? ne : function (l) {
            var s = O.instructions,
                _ = O.title;

            if (re || Z || (s = (0, E.__)("To edit this block, you need permission to upload media.")), void 0 === s || void 0 === _) {
              var _l117 = null != c ? c : [],
                  _l118 = _slicedToArray(_l117, 1),
                  _m30 = _l118[0],
                  _v15 = 1 === _l117.length,
                  _k6 = _v15 && "audio" === _m30,
                  _y5 = _v15 && "image" === _m30,
                  _w3 = _v15 && "video" === _m30;

              void 0 === s && re && (s = (0, E.__)("Upload a media file or pick one from your media library."), _k6 ? s = (0, E.__)("Upload an audio file, pick one from your media library, or add one with a URL.") : _y5 ? s = (0, E.__)("Upload an image file, pick one from your media library, or add one with a URL.") : _w3 && (s = (0, E.__)("Upload a video file, pick one from your media library, or add one with a URL."))), void 0 === _ && (_ = (0, E.__)("Media"), _k6 ? _ = (0, E.__)("Audio") : _y5 ? _ = (0, E.__)("Image") : _w3 && (_ = (0, E.__)("Video")));
            }

            var w = (0, k.default)("block-editor-media-placeholder", m, {
              "is-appender": A
            });
            return (0, v.createElement)(y.Placeholder, {
              icon: S,
              label: _,
              instructions: s,
              className: w,
              notices: R,
              onDoubleClick: X,
              preview: V,
              style: oe
            }, l, ee);
          },
              renderDropZone = function renderDropZone() {
            return W ? null : (0, v.createElement)(y.DropZone, {
              onFilesDrop: onFilesUpload,
              onHTMLDrop: J
            });
          },
              renderCancelLink = function renderCancelLink() {
            return Y && (0, v.createElement)(y.Button, {
              className: "block-editor-media-placeholder__cancel-button",
              title: (0, E.__)("Cancel"),
              variant: "link",
              onClick: Y
            }, (0, E.__)("Cancel"));
          },
              renderUrlSelectionUI = function renderUrlSelectionUI() {
            return Z && (0, v.createElement)("div", {
              className: "block-editor-media-placeholder__url-input-container"
            }, (0, v.createElement)(y.Button, {
              className: "block-editor-media-placeholder__button",
              onClick: openURLInput,
              isPressed: ae,
              variant: "tertiary"
            }, (0, E.__)("Insert from URL")), ae && (0, v.createElement)(InsertFromURLPopover, {
              src: le,
              onChange: onChangeSrc,
              onSubmit: onSubmitSrc,
              onClose: closeURLInput
            }));
          };

          return U || K ? (U && (0, C.default)("wp.blockEditor.MediaPlaceholder dropZoneUIOnly prop", {
            since: "5.4",
            alternative: "disableMediaButtons"
          }), (0, v.createElement)(P.default, null, renderDropZone())) : (0, v.createElement)(P.default, {
            fallback: ce(renderUrlSelectionUI())
          }, function () {
            var l = null != te ? te : function (l) {
              var s = l.open;
              return (0, v.createElement)(y.Button, {
                variant: "tertiary",
                onClick: function onClick() {
                  s();
                }
              }, (0, E.__)("Media Library"));
            },
                m = (0, v.createElement)(B.default, {
              addToGallery: D,
              gallery: F && !(!c || 0 === c.length) && c.every(function (l) {
                return "image" === l || l.startsWith("image/");
              }),
              multiple: F,
              onSelect: q,
              allowedTypes: c,
              value: Array.isArray(s) ? s.map(function (l) {
                var s = l.id;
                return s;
              }) : s.id,
              render: l
            });
            if (re && A) return (0, v.createElement)(v.Fragment, null, renderDropZone(), (0, v.createElement)(y.FormFileUpload, {
              onChange: onUpload,
              accept: z,
              multiple: F,
              render: function render(l) {
                var s = l.openFileDialog;
                var c = (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.Button, {
                  variant: "primary",
                  className: (0, k.default)("block-editor-media-placeholder__button", "block-editor-media-placeholder__upload-button"),
                  onClick: s
                }, (0, E.__)("Upload")), m, renderUrlSelectionUI(), renderCancelLink());
                return ce(c);
              }
            }));

            if (re) {
              var _l119 = (0, v.createElement)(v.Fragment, null, renderDropZone(), (0, v.createElement)(y.FormFileUpload, {
                variant: "primary",
                className: (0, k.default)("block-editor-media-placeholder__button", "block-editor-media-placeholder__upload-button"),
                onChange: onUpload,
                accept: z,
                multiple: F
              }, (0, E.__)("Upload")), m, renderUrlSelectionUI(), renderCancelLink());

              return ce(_l119);
            }

            return ce(m);
          }());
        }

        var V = (0, y.withFilters)("editor.MediaPlaceholder")(MediaPlaceholder);
        s.default = V;
      },
      5892: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            k = c(6756),
            y = c(9773),
            E = c(4892),
            w = c(8467),
            C = c(9880),
            S = c(3200),
            B = c(2614),
            P = c(8448),
            O = m(c(4625)),
            L = m(c(2596)),
            V = m(c(2631)),
            R = c(8486);

        var A = (0, S.compose)([(0, w.withDispatch)(function (l) {
          var _l120 = l(P.store),
              s = _l120.createNotice,
              c = _l120.removeNotice;

          return {
            createNotice: s,
            removeNotice: c
          };
        }), (0, E.withFilters)("editor.MediaReplaceFlow")])(function (l) {
          var s = l.mediaURL,
              c = l.mediaId,
              m = l.allowedTypes,
              S = l.accept,
              P = l.onSelect,
              A = l.onSelectURL,
              _l$onFilesUpload = l.onFilesUpload,
              z = _l$onFilesUpload === void 0 ? _.noop : _l$onFilesUpload,
              _l$name = l.name,
              D = _l$name === void 0 ? (0, k.__)("Replace") : _l$name,
              F = l.createNotice,
              G = l.removeNotice,
              U = l.children;

          var _ref316 = (0, v.useState)(s),
              _ref317 = _slicedToArray(_ref316, 2),
              W = _ref317[0],
              K = _ref317[1],
              $ = (0, w.useSelect)(function (l) {
            return l(R.store).getSettings().mediaUpload;
          }, []),
              q = (0, v.createRef)(),
              Y = (0, _.uniqueId)("block-editor/media-replace-flow/error-notice/"),
              onError = function onError(l) {
            var s = document.createElement("div");
            s.innerHTML = (0, v.renderToString)(l);
            var c = s.textContent || s.innerText || "";
            setTimeout(function () {
              F("error", c, {
                speak: !0,
                id: Y,
                isDismissible: !0
              });
            }, 1e3);
          },
              selectMedia = function selectMedia(l) {
            K(l.url), P(l), (0, y.speak)((0, k.__)("The media file has been replaced")), G(Y);
          },
              openOnArrowDown = function openOnArrowDown(l) {
            l.keyCode === C.DOWN && (l.preventDefault(), l.target.click());
          };

          return (0, v.createElement)(E.Dropdown, {
            popoverProps: {
              isAlternate: !0
            },
            contentClassName: "block-editor-media-replace-flow__options",
            renderToggle: function renderToggle(l) {
              var s = l.isOpen,
                  c = l.onToggle;
              return (0, v.createElement)(E.ToolbarButton, {
                ref: q,
                "aria-expanded": s,
                "aria-haspopup": "true",
                onClick: c,
                onKeyDown: openOnArrowDown
              }, D);
            },
            renderContent: function renderContent(l) {
              var s = l.onClose;
              return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(E.NavigableMenu, {
                className: "block-editor-media-replace-flow__media-upload-menu"
              }, (0, v.createElement)(O.default, {
                value: c,
                onSelect: function onSelect(l) {
                  return selectMedia(l);
                },
                allowedTypes: m,
                render: function render(l) {
                  var s = l.open;
                  return (0, v.createElement)(E.MenuItem, {
                    icon: B.media,
                    onClick: s
                  }, (0, k.__)("Open Media Library"));
                }
              }), (0, v.createElement)(L.default, null, (0, v.createElement)(E.FormFileUpload, {
                onChange: function onChange(l) {
                  (function (l) {
                    var s = l.target.files;
                    z(s), $({
                      allowedTypes: m,
                      filesList: s,
                      onFileChange: function onFileChange(l) {
                        var _l121 = _slicedToArray(l, 1),
                            s = _l121[0];

                        selectMedia(s);
                      },
                      onError: onError
                    });
                  })(l);
                },
                accept: S,
                render: function render(l) {
                  var s = l.openFileDialog;
                  return (0, v.createElement)(E.MenuItem, {
                    icon: B.upload,
                    onClick: function onClick() {
                      s();
                    }
                  }, (0, k.__)("Upload"));
                }
              })), U), A && (0, v.createElement)("form", {
                className: "block-editor-media-flow__url-input"
              }, (0, v.createElement)("span", {
                className: "block-editor-media-replace-flow__image-url-label"
              }, (0, k.__)("Current media URL:")), (0, v.createElement)(V.default, {
                value: {
                  url: W
                },
                settings: [],
                showSuggestions: !1,
                onChange: function onChange(l) {
                  var s = l.url;
                  K(s), A(s), q.current.focus();
                }
              })));
            }
          });
        });
        s.default = A;
      },
      2596: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.MediaUploadCheck = MediaUploadCheck, s.default = void 0;
        var m = c(8467),
            v = c(8486);

        function MediaUploadCheck(l) {
          var _l$fallback = l.fallback,
              s = _l$fallback === void 0 ? null : _l$fallback,
              c = l.children;
          return (0, m.useSelect)(function (l) {
            var _l122 = l(v.store),
                s = _l122.getSettings;

            return !!s().mediaUpload;
          }, []) ? c : s;
        }

        var _ = MediaUploadCheck;
        s.default = _;
      },
      4625: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var m = (0, c(4892).withFilters)("editor.MediaUpload")(function () {
          return null;
        });
        s.default = m;
      },
      3627: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(6756),
            k = c(8467),
            y = c(6700),
            E = c(224),
            w = c(2614),
            C = m(c(2006)),
            S = c(8486);

        var B = (0, k.withSelect)(function (l) {
          var _l123 = l(S.store),
              s = _l123.getMultiSelectedBlocks;

          return {
            blocks: s()
          };
        })(function MultiSelectionInspector(l) {
          var s = l.blocks;
          var c = (0, E.count)((0, y.serialize)(s), "words");
          return (0, v.createElement)("div", {
            className: "block-editor-multi-selection-inspector__card"
          }, (0, v.createElement)(C.default, {
            icon: w.stack,
            showColors: !0
          }), (0, v.createElement)("div", {
            className: "block-editor-multi-selection-inspector__card-content"
          }, (0, v.createElement)("div", {
            className: "block-editor-multi-selection-inspector__card-title"
          }, (0, _.sprintf)((0, _._n)("%d block", "%d blocks", s.length), s.length)), (0, v.createElement)("div", {
            className: "block-editor-multi-selection-inspector__card-description"
          }, (0, _.sprintf)((0, _._n)("%d word", "%d words", c), c))));
        });
        s.default = B;
      },
      9375: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = m(c(3703)),
            E = c(5480),
            w = c(2470);

        function getAllToolbarItemsIn(l) {
          return Array.from(l.querySelectorAll("[data-toolbar-item]"));
        }

        function useToolbarFocus(l, s, c, m, _) {
          var _ref318 = (0, v.useState)(s),
              _ref319 = _slicedToArray(_ref318, 1),
              k = _ref319[0],
              _ref320 = (0, v.useState)(m),
              _ref321 = _slicedToArray(_ref320, 1),
              y = _ref321[0],
              C = (0, v.useCallback)(function () {
            !function focusFirstTabbableIn(l) {
              var _E$focus$tabbable$fin = E.focus.tabbable.find(l),
                  _E$focus$tabbable$fin2 = _slicedToArray(_E$focus$tabbable$fin, 1),
                  s = _E$focus$tabbable$fin2[0];

              s && s.focus();
            }(l.current);
          }, []);

          (0, w.useShortcut)("core/block-editor/focus-toolbar", C), (0, v.useEffect)(function () {
            k && C();
          }, [c, k, C]), (0, v.useEffect)(function () {
            var s = 0;
            return y && !k && (s = window.requestAnimationFrame(function () {
              var s = getAllToolbarItemsIn(l.current),
                  c = y || 0;
              s[c] && function hasFocusWithin(l) {
                return l.contains(l.ownerDocument.activeElement);
              }(l.current) && s[c].focus();
            })), function () {
              if (window.cancelAnimationFrame(s), !_ || !l.current) return;
              var c = getAllToolbarItemsIn(l.current).findIndex(function (l) {
                return 0 === l.tabIndex;
              });

              _(c);
            };
          }, [y, k]);
        }

        var C = function NavigableToolbar(l) {
          var s = l.children,
              c = l.focusOnMount,
              m = l.__experimentalInitialIndex,
              w = l.__experimentalOnIndexChange,
              C = _objectWithoutProperties(l, _excluded30);

          var S = (0, v.useRef)(),
              B = function useIsAccessibleToolbar(l) {
            var _ref322 = (0, v.useState)(!0),
                _ref323 = _slicedToArray(_ref322, 2),
                s = _ref323[0],
                c = _ref323[1],
                m = (0, v.useCallback)(function () {
              var s = function hasOnlyToolbarItem(l) {
                return !l.some(function (l) {
                  return !("toolbarItem" in l.dataset);
                });
              }(E.focus.tabbable.find(l.current));

              s || (0, y.default)("Using custom components as toolbar controls", {
                since: "5.6",
                alternative: "ToolbarItem, ToolbarButton or ToolbarDropdownMenu components",
                link: "https://developer.wordpress.org/block-editor/components/toolbar-button/#inside-blockcontrols"
              }), c(s);
            }, []);

            return (0, v.useLayoutEffect)(function () {
              var s = new window.MutationObserver(m);
              return s.observe(l.current, {
                childList: !0,
                subtree: !0
              }), function () {
                return s.disconnect();
              };
            }, [s]), s;
          }(S);

          return useToolbarFocus(S, c, B, m, w), B ? (0, v.createElement)(k.Toolbar, (0, _.default)({
            label: C["aria-label"],
            ref: S
          }, C), s) : (0, v.createElement)(k.NavigableMenu, (0, _.default)({
            orientation: "horizontal",
            role: "toolbar",
            ref: S
          }, C), s);
        };

        s.default = C;
      },
      6472: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0, s.useMouseMoveTypingReset = useMouseMoveTypingReset, s.useTypingObserver = useTypingObserver;

        var m = c(1753),
            v = c(3200),
            _ = c(8467),
            k = c(5480),
            y = c(9880),
            E = c(8486);

        var w = new Set([y.UP, y.RIGHT, y.DOWN, y.LEFT, y.ENTER, y.BACKSPACE]);

        function useMouseMoveTypingReset() {
          var l = (0, _.useSelect)(function (l) {
            return l(E.store).isTyping();
          }, []),
              _ref324 = (0, _.useDispatch)(E.store),
              s = _ref324.stopTyping;

          return (0, v.useRefEffect)(function (c) {
            if (!l) return;
            var m = c.ownerDocument;

            var v, _;

            function stopTypingOnMouseMove(l) {
              var c = l.clientX,
                  m = l.clientY;
              v && _ && (v !== c || _ !== m) && s(), v = c, _ = m;
            }

            return m.addEventListener("mousemove", stopTypingOnMouseMove), function () {
              m.removeEventListener("mousemove", stopTypingOnMouseMove);
            };
          }, [l, s]);
        }

        function useTypingObserver() {
          var l = (0, _.useSelect)(function (l) {
            return l(E.store).isTyping();
          }),
              _ref325 = (0, _.useDispatch)(E.store),
              s = _ref325.startTyping,
              c = _ref325.stopTyping,
              m = useMouseMoveTypingReset(),
              C = (0, v.useRefEffect)(function (m) {
            var v = m.ownerDocument,
                _ = v.defaultView;

            if (l) {
              var stopTypingOnNonTextField = function stopTypingOnNonTextField(s) {
                var m = s.target;
                _l124 = _.setTimeout(function () {
                  (0, k.isTextField)(m) || c();
                });
              };

              var stopTypingOnEscapeKey = function stopTypingOnEscapeKey(l) {
                var s = l.keyCode;
                s !== y.ESCAPE && s !== y.TAB || c();
              };

              var stopTypingOnSelectionUncollapse = function stopTypingOnSelectionUncollapse() {
                var l = _.getSelection();

                l.rangeCount > 0 && l.getRangeAt(0).collapsed || c();
              };

              var _l124;

              return m.addEventListener("focus", stopTypingOnNonTextField), m.addEventListener("keydown", stopTypingOnEscapeKey), v.addEventListener("selectionchange", stopTypingOnSelectionUncollapse), function () {
                _.clearTimeout(_l124), m.removeEventListener("focus", stopTypingOnNonTextField), m.removeEventListener("keydown", stopTypingOnEscapeKey), v.removeEventListener("selectionchange", stopTypingOnSelectionUncollapse);
              };
            }

            function startTypingInTextField(l) {
              var c = l.type,
                  v = l.target;
              (0, k.isTextField)(v) && m.contains(v) && ("keydown" !== c || function isKeyDownEligibleForStartTyping(l) {
                var s = l.keyCode,
                    c = l.shiftKey;
                return !c && w.has(s);
              }(l)) && s();
            }

            return m.addEventListener("keypress", startTypingInTextField), m.addEventListener("keydown", startTypingInTextField), function () {
              m.removeEventListener("keypress", startTypingInTextField), m.removeEventListener("keydown", startTypingInTextField);
            };
          }, [l, s, c]);

          return (0, v.useMergeRefs)([m, C]);
        }

        var C = function ObserveTyping(l) {
          var s = l.children;
          return (0, m.createElement)("div", {
            ref: useTypingObserver()
          }, s);
        };

        s.default = C;
      },
      5995: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(8251));

        var _default = function _default(l) {
          var s = l.colorSettings,
              c = _objectWithoutProperties(l, _excluded31);

          var m = s.map(function (l) {
            var s = l.value,
                c = l.onChange,
                m = _objectWithoutProperties(l, _excluded32);

            return _objectSpread(_objectSpread({}, m), {}, {
              colorValue: s,
              onColorChange: c
            });
          });
          return (0, v.createElement)(k.default, (0, _.default)({
            settings: m,
            gradients: [],
            disableCustomGradients: !0
          }, c));
        };

        s.default = _default;
      },
      2571: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(6770)),
            y = m(c(2703)),
            E = m(c(8342));

        var w = (0, v.forwardRef)(function (l, s) {
          var c = l.__experimentalVersion,
              m = _objectWithoutProperties(l, _excluded33);

          if (2 === c) return (0, v.createElement)(E.default, (0, _.default)({
            ref: s
          }, m));

          var w = m.className,
              C = m.onChange,
              S = _objectWithoutProperties(m, _excluded34);

          return (0, v.createElement)(k.default, (0, _.default)({
            ref: s,
            className: (0, y.default)("block-editor-plain-text", w),
            onChange: function onChange(l) {
              return C(l.target.value);
            }
          }, S));
        });
        s.default = w;
      },
      9180: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PreserveScrollInReorder() {
          return (0, v.default)("PreserveScrollInReorder component", {
            since: "5.4",
            hint: "This behavior is now built-in the block list"
          }), null;
        };
        var v = m(c(3703));
      },
      5016: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function PreviewOptions(l) {
          var s = l.children,
              c = l.className,
              _l$isEnabled = l.isEnabled,
              m = _l$isEnabled === void 0 ? !0 : _l$isEnabled,
              C = l.deviceType,
              S = l.setDeviceType;
          if ((0, k.useViewportMatch)("small", "<")) return null;
          var B = {
            className: (0, _.default)(c, "block-editor-post-preview__dropdown-content"),
            position: "bottom left"
          },
              P = {
            variant: "tertiary",
            className: "block-editor-post-preview__button-toggle",
            disabled: !m,
            children: (0, E.__)("Preview")
          };
          return (0, v.createElement)(y.DropdownMenu, {
            className: "block-editor-post-preview__dropdown",
            popoverProps: B,
            toggleProps: P,
            icon: null
          }, function () {
            return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.MenuGroup, null, (0, v.createElement)(y.MenuItem, {
              className: "block-editor-post-preview__button-resize",
              onClick: function onClick() {
                return S("Desktop");
              },
              icon: "Desktop" === C && w.check
            }, (0, E.__)("Desktop")), (0, v.createElement)(y.MenuItem, {
              className: "block-editor-post-preview__button-resize",
              onClick: function onClick() {
                return S("Tablet");
              },
              icon: "Tablet" === C && w.check
            }, (0, E.__)("Tablet")), (0, v.createElement)(y.MenuItem, {
              className: "block-editor-post-preview__button-resize",
              onClick: function onClick() {
                return S("Mobile");
              },
              icon: "Mobile" === C && w.check
            }, (0, E.__)("Mobile"))), s);
          });
        };

        var v = c(1753),
            _ = m(c(2703)),
            k = c(3200),
            y = c(4892),
            E = c(6756),
            w = c(2614);
      },
      2169: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BlockRefs = void 0, s.BlockRefsProvider = function BlockRefsProvider(l) {
          var s = l.children;
          var c = (0, m.useMemo)(function () {
            return {
              refs: new Map(),
              callbacks: new Map()
            };
          }, []);
          return (0, m.createElement)(v.Provider, {
            value: c
          }, s);
        };
        var m = c(1753);
        var v = (0, m.createContext)();
        s.BlockRefs = v;
      },
      6375: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(8467),
            k = m(c(9266)),
            y = m(c(3683)),
            E = c(8486),
            w = c(2169);

        var C = (0, k.default)(function BlockEditorProvider(l) {
          var s = l.children,
              c = l.settings,
              _ref326 = (0, _.useDispatch)(E.store),
              m = _ref326.updateSettings;

          return (0, v.useEffect)(function () {
            m(c);
          }, [c]), (0, y.default)(l), (0, v.createElement)(w.BlockRefsProvider, null, s);
        });
        s.default = C;
      },
      3683: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useBlockSync(l) {
          var _l$clientId = l.clientId,
              s = _l$clientId === void 0 ? null : _l$clientId,
              c = l.value,
              E = l.selection,
              _l$onChange7 = l.onChange,
              w = _l$onChange7 === void 0 ? m.noop : _l$onChange7,
              _l$onInput = l.onInput,
              C = _l$onInput === void 0 ? m.noop : _l$onInput;

          var S = (0, _.useRegistry)(),
              _S$dispatch = S.dispatch(y.store),
              B = _S$dispatch.resetBlocks,
              P = _S$dispatch.resetSelection,
              O = _S$dispatch.replaceInnerBlocks,
              L = _S$dispatch.setHasControlledInnerBlocks,
              V = _S$dispatch.__unstableMarkNextChangeAsNotPersistent,
              _S$select = S.select(y.store),
              R = _S$select.getBlockName,
              A = _S$select.getBlocks,
              z = (0, _.useSelect)(function (l) {
            return !s || l(y.store).areInnerBlocksControlled(s);
          }, [s]),
              D = (0, v.useRef)({
            incoming: null,
            outgoing: []
          }),
              F = (0, v.useRef)(!1),
              setControlledBlocks = function setControlledBlocks() {
            c && (V(), s ? S.batch(function () {
              L(s, !0);
              var l = c.map(function (l) {
                return (0, k.cloneBlock)(l);
              });
              F.current && (D.current.incoming = l), V(), O(s, l);
            }) : (F.current && (D.current.incoming = c), B(c)));
          },
              G = (0, v.useRef)(C),
              U = (0, v.useRef)(w);

          (0, v.useEffect)(function () {
            G.current = C, U.current = w;
          }, [C, w]), (0, v.useEffect)(function () {
            D.current.outgoing.includes(c) ? (0, m.last)(D.current.outgoing) === c && (D.current.outgoing = []) : A(s) !== c && (D.current.outgoing = [], setControlledBlocks(), E && P(E.selectionStart, E.selectionEnd, E.initialPosition));
          }, [c, s]), (0, v.useEffect)(function () {
            z || (D.current.outgoing = [], setControlledBlocks());
          }, [z]), (0, v.useEffect)(function () {
            var _S$select2 = S.select(y.store),
                l = _S$select2.getSelectionStart,
                c = _S$select2.getSelectionEnd,
                m = _S$select2.getSelectedBlocksInitialCaretPosition,
                v = _S$select2.isLastBlockChangePersistent,
                _ = _S$select2.__unstableIsLastBlockChangeIgnored,
                k = _S$select2.areInnerBlocksControlled;

            var E = A(s),
                w = v(),
                C = !1;
            F.current = !0;
            var B = S.subscribe(function () {
              if (null !== s && null === R(s)) return;
              if (!(!s || k(s))) return;
              var y = v(),
                  S = A(s),
                  B = S !== E;
              if (E = S, B && (D.current.incoming || _())) return D.current.incoming = null, void (w = y);

              if (B || C && !B && y && !w) {
                w = y, D.current.outgoing.push(E);
                (w ? U.current : G.current)(E, {
                  selection: {
                    selectionStart: l(),
                    selectionEnd: c(),
                    initialPosition: m()
                  }
                });
              }

              C = B;
            });
            return function () {
              return B();
            };
          }, [S, s]);
        };

        var m = c(4793),
            v = c(1753),
            _ = c(8467),
            k = c(6700),
            y = c(8486);
      },
      9266: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(8467),
            y = c(3200),
            E = c(8486),
            w = c(8340);

        var C = (0, y.createHigherOrderComponent)(function (l) {
          return (0, k.withRegistry)(function (s) {
            var _s$useSubRegistry = s.useSubRegistry,
                c = _s$useSubRegistry === void 0 ? !0 : _s$useSubRegistry,
                m = s.registry,
                y = _objectWithoutProperties(s, _excluded35);

            if (!c) return (0, v.createElement)(l, (0, _.default)({
              registry: m
            }, y));

            var _ref327 = (0, v.useState)(null),
                _ref328 = _slicedToArray(_ref327, 2),
                C = _ref328[0],
                S = _ref328[1];

            return (0, v.useEffect)(function () {
              var l = (0, k.createRegistry)({}, m);
              l.registerStore(w.STORE_NAME, E.storeConfig), S(l);
            }, [m]), C ? (0, v.createElement)(k.RegistryProvider, {
              value: C
            }, (0, v.createElement)(l, (0, _.default)({
              registry: C
            }, y))) : null;
          });
        }, "withRegistryProvider");
        s.default = C;
      },
      554: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(6756),
            y = c(4892),
            E = m(c(4173));

        var w = function ResponsiveBlockControl(l) {
          var s = l.title,
              c = l.property,
              m = l.toggleLabel,
              w = l.onIsResponsiveChange,
              C = l.renderDefaultControl,
              S = l.renderResponsiveControls,
              _l$isResponsive = l.isResponsive,
              B = _l$isResponsive === void 0 ? !1 : _l$isResponsive,
              _l$defaultLabel = l.defaultLabel,
              P = _l$defaultLabel === void 0 ? {
            id: "all",
            label: (0, k.__)("All")
          } : _l$defaultLabel,
              _l$viewports = l.viewports,
              O = _l$viewports === void 0 ? [{
            id: "small",
            label: (0, k.__)("Small screens")
          }, {
            id: "medium",
            label: (0, k.__)("Medium screens")
          }, {
            id: "large",
            label: (0, k.__)("Large screens")
          }] : _l$viewports;
          if (!s || !c || !C) return null;
          var L = m || (0, k.sprintf)((0, k.__)("Use the same %s on all screensizes."), c),
              V = (0, k.__)("Toggle between using the same value for all screen sizes or using a unique value per screen size."),
              R = C((0, v.createElement)(E.default, {
            property: c,
            viewport: P
          }), P);
          return (0, v.createElement)("fieldset", {
            className: "block-editor-responsive-block-control"
          }, (0, v.createElement)("legend", {
            className: "block-editor-responsive-block-control__title"
          }, s), (0, v.createElement)("div", {
            className: "block-editor-responsive-block-control__inner"
          }, (0, v.createElement)(y.ToggleControl, {
            className: "block-editor-responsive-block-control__toggle",
            label: L,
            checked: !B,
            onChange: w,
            help: V
          }), (0, v.createElement)("div", {
            className: (0, _.default)("block-editor-responsive-block-control__group", {
              "is-responsive": B
            })
          }, !B && R, B && (S ? S(O) : O.map(function (l) {
            return (0, v.createElement)(v.Fragment, {
              key: l.id
            }, C((0, v.createElement)(E.default, {
              property: c,
              viewport: l
            }), l));
          })))));
        };

        s.default = w;
      },
      4173: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ResponsiveBlockControlLabel(l) {
          var s = l.property,
              c = l.viewport,
              y = l.desc;
          var E = (0, v.useInstanceId)(ResponsiveBlockControlLabel),
              w = y || (0, k.sprintf)((0, k._x)("Controls the %1$s property for %2$s viewports.", "Text labelling a interface as controlling a given layout property (eg: margin) for a given screen size."), s, c.label);
          return (0, m.createElement)(m.Fragment, null, (0, m.createElement)("span", {
            "aria-describedby": "rbc-desc-".concat(E)
          }, c.label), (0, m.createElement)(_.VisuallyHidden, {
            as: "span",
            id: "rbc-desc-".concat(E)
          }, w));
        };

        var m = c(1753),
            v = c(3200),
            _ = c(4892),
            k = c(6756);
      },
      1161: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.filePasteHandler = function filePasteHandler(l) {
          return l.filter(function (l) {
            var s = l.type;
            return /^image\/(?:jpe?g|png|gif)$/.test(s);
          }).map(function (l) {
            return "<img src=\"".concat((0, m.createBlobURL)(l), "\">");
          }).join("");
        };
        var m = c(9388);
      },
      2908: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function FormatEdit(l) {
          var s = l.formatTypes,
              c = l.onChange,
              k = l.onFocus,
              y = l.value,
              E = l.forwardedRef;
          return s.map(function (l) {
            var s = l.name,
                w = l.edit;
            if (!w) return null;
            var C = (0, v.getActiveFormat)(y, s);
            var S = void 0 !== C;
            var B = (0, v.getActiveObject)(y),
                P = void 0 !== B && B.type === s;

            if ("core/link" === s && !(0, v.isCollapsed)(y)) {
              var _l125 = y.formats,
                  _s54 = (0, _.find)(_l125[y.start], {
                type: "core/link"
              }),
                  _c35 = (0, _.find)(_l125[y.end - 1], {
                type: "core/link"
              });

              _s54 && _c35 && _s54 === _c35 || (S = !1);
            }

            return (0, m.createElement)(w, {
              key: s,
              isActive: S,
              activeAttributes: S && C.attributes || {},
              isObjectActive: P,
              activeObjectAttributes: P && B.attributes || {},
              value: y,
              onChange: c,
              onFocus: k,
              contentRef: E
            });
          });
        };

        var m = c(1753),
            v = c(7060),
            _ = c(4793);
      },
      5161: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4892),
            k = m(c(915)),
            y = m(c(4532));

        var _default = function _default(l) {
          var s = l.inline,
              c = l.anchorRef;
          return s ? (0, v.createElement)(_.Popover, {
            noArrow: !0,
            position: "top center",
            focusOnMount: !1,
            anchorRef: c,
            className: "block-editor-rich-text__inline-format-toolbar",
            __unstableSlotName: "block-toolbar"
          }, (0, v.createElement)("div", {
            className: "block-editor-rich-text__inline-format-toolbar-group"
          }, (0, v.createElement)(_.ToolbarGroup, null, (0, v.createElement)(y.default, null)))) : (0, v.createElement)(k.default, {
            group: "inline"
          }, (0, v.createElement)(y.default, null));
        };

        s.default = _default;
      },
      4532: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4793),
            k = m(c(2703)),
            y = c(6756),
            E = c(4892),
            w = c(2614);

        var C = {
          position: "bottom right",
          isAlternate: !0
        };

        var _default = function _default() {
          return (0, v.createElement)(v.Fragment, null, ["bold", "italic", "link"].map(function (l) {
            return (0, v.createElement)(E.Slot, {
              name: "RichText.ToolbarControls.".concat(l),
              key: l
            });
          }), (0, v.createElement)(E.Slot, {
            name: "RichText.ToolbarControls"
          }, function (l) {
            if (!l.length) return null;
            var s = l.map(function (l) {
              var _l126 = _slicedToArray(l, 1),
                  s = _l126[0].props;

              return s;
            }).some(function (l) {
              var s = l.isActive;
              return s;
            });
            return (0, v.createElement)(E.ToolbarItem, null, function (c) {
              return (0, v.createElement)(E.DropdownMenu, {
                icon: w.chevronDown,
                label: (0, y.__)("More"),
                toggleProps: _objectSpread(_objectSpread({}, c), {}, {
                  className: (0, k.default)(c.className, {
                    "is-pressed": s
                  }),
                  describedBy: (0, y.__)("Displays more block tools")
                }),
                controls: (0, _.orderBy)(l.map(function (l) {
                  var _l127 = _slicedToArray(l, 1),
                      s = _l127[0].props;

                  return s;
                }), "title"),
                popoverProps: C
              });
            });
          }));
        };

        s.default = _default;
      },
      1700: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), Object.defineProperty(s, "RichTextShortcut", {
          enumerable: !0,
          get: function get() {
            return Q.RichTextShortcut;
          }
        }), Object.defineProperty(s, "RichTextToolbarButton", {
          enumerable: !0,
          get: function get() {
            return J.RichTextToolbarButton;
          }
        }), Object.defineProperty(s, "__unstableRichTextInputEvent", {
          enumerable: !0,
          get: function get() {
            return ee.__unstableRichTextInputEvent;
          }
        }), s.keyboardShortcutContext = s.inputEventContext = s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(4793),
            E = c(8467),
            w = c(6700),
            C = c(3200),
            S = c(7060),
            B = m(c(3703)),
            P = c(9880),
            O = c(4892),
            L = c(9640),
            V = c(5490),
            R = m(c(5161)),
            A = c(8486),
            z = c(1964),
            D = c(6477),
            F = c(8758),
            G = c(2466),
            U = c(7030),
            W = c(6075),
            K = c(7004),
            $ = c(7720),
            q = c(6773),
            Y = c(9295),
            Z = m(c(2908)),
            X = c(1347),
            Q = c(238),
            J = c(8795),
            ee = c(6948);

        var te = (0, v.createContext)();
        s.keyboardShortcutContext = te;
        var ne = (0, v.createContext)();
        s.inputEventContext = ne;
        var oe = (0, v.forwardRef)(function RichTextWrapper(l, s) {
          var c = l.children,
              _l$tagName4 = l.tagName,
              m = _l$tagName4 === void 0 ? "div" : _l$tagName4,
              _l$value6 = l.value,
              Q = _l$value6 === void 0 ? "" : _l$value6,
              J = l.onChange,
              ee = l.isSelected,
              oe = l.multiline,
              re = l.inlineToolbar,
              le = l.wrapperClassName,
              ie = l.autocompleters,
              ae = l.onReplace,
              se = l.placeholder,
              ce = l.allowedFormats,
              ue = l.formattingControls,
              de = l.withoutInteractiveFormatting,
              pe = l.onRemove,
              me = l.onMerge,
              fe = l.onSplit,
              he = l.__unstableOnSplitAtEnd,
              ge = l.__unstableOnSplitMiddle,
              ve = l.identifier,
              be = l.preserveWhiteSpace,
              _e = l.__unstablePastePlainText,
              ke = l.__unstableEmbedURLOnPaste,
              ye = l.__unstableDisableFormats,
              Ee = l.disableLineBreaks,
              we = l.unstableOnFocus,
              Ce = l.__unstableAllowPrefixTransformations,
              Se = _objectWithoutProperties(l, _excluded36);

          var Be = (0, C.useInstanceId)(RichTextWrapper);
          ve = ve || Be, Se = function removeNativeProps(l) {
            return (0, y.omit)(l, ["__unstableMobileNoFocusOnMount", "deleteEnter", "placeholderTextColor", "textAlign", "selectionColor", "tagsToEliminate", "rootTagsToEliminate", "disableEditingMenu", "fontSize", "fontFamily", "fontWeight", "fontStyle", "minWidth", "maxWidth", "setRef"]);
          }(Se);

          var Pe = (0, v.useRef)(),
              _ref329 = (0, V.useBlockEditContext)(),
              xe = _ref329.clientId,
              _ref330 = (0, E.useSelect)(function (l) {
            var _l128 = l(A.store),
                s = _l128.getSelectionStart,
                c = _l128.getSelectionEnd,
                m = _l128.isMultiSelecting,
                v = _l128.hasMultiSelection,
                _ = s(),
                k = c();

            var y;
            return void 0 === ee ? y = _.clientId === xe && _.attributeKey === ve : ee && (y = _.clientId === xe), {
              selectionStart: y ? _.offset : void 0,
              selectionEnd: y ? k.offset : void 0,
              isSelected: y,
              disabled: m() || v()
            };
          }),
              Ie = _ref330.selectionStart,
              Me = _ref330.selectionEnd,
              Te = _ref330.isSelected,
              Oe = _ref330.disabled,
              _ref331 = (0, E.useDispatch)(A.store),
              Le = _ref331.selectionChange,
              Ve = (0, X.getMultilineTag)(oe),
              Re = (0, X.getAllowedFormats)({
            allowedFormats: ce,
            formattingControls: ue,
            disableFormats: ye
          }),
              Ae = !Re || Re.length > 0;

          var ze = Q,
              Ne = J;
          Array.isArray(Q) && (ze = w.children.toHTML(Q), Ne = function Ne(l) {
            return J(w.children.fromDOM((0, S.__unstableCreateElement)(document, l).childNodes));
          });

          var De = (0, v.useCallback)(function (l, s) {
            Le(xe, ve, l, s);
          }, [xe, ve]),
              _ref332 = (0, K.useFormatTypes)({
            clientId: xe,
            identifier: ve,
            withoutInteractiveFormatting: de,
            allowedFormats: Re
          }),
              He = _ref332.formatTypes,
              je = _ref332.prepareHandlers,
              Fe = _ref332.valueHandlers,
              Ge = _ref332.changeHandlers,
              Ue = _ref332.dependencies;

          function removeEditorOnlyFormats(l) {
            return He.forEach(function (s) {
              s.__experimentalCreatePrepareEditableTree && (l = (0, S.removeFormat)(l, s.name, 0, l.text.length));
            }), l.formats;
          }

          var _ref333 = (0, S.__unstableUseRichText)({
            value: ze,
            onChange: function onChange(l, s) {
              var c = s.__unstableFormats,
                  m = s.__unstableText;
              Ne(l), Object.values(Ge).forEach(function (l) {
                l(c, m);
              });
            },
            selectionStart: Ie,
            selectionEnd: Me,
            onSelectionChange: De,
            placeholder: se,
            __unstableIsSelected: Te,
            __unstableMultilineTag: Ve,
            __unstableDisableFormats: ye,
            preserveWhiteSpace: be,
            __unstableDependencies: [].concat(_toConsumableArray(Ue), [m]),
            __unstableAfterParse: function addEditorOnlyFormats(l) {
              return Fe.reduce(function (s, c) {
                return c(s, l.text);
              }, l.formats);
            },
            __unstableBeforeSerialize: removeEditorOnlyFormats,
            __unstableAddInvisibleFormats: function addInvisibleFormats(l) {
              return je.reduce(function (s, c) {
                return c(s, l.text);
              }, l.formats);
            }
          }),
              We = _ref333.value,
              Ke = _ref333.onChange,
              $e = _ref333.ref,
              qe = (0, L.useBlockEditorAutocompleteProps)({
            onReplace: ae,
            completers: ie,
            record: We,
            onChange: Ke
          });

          (0, D.useCaretInFormat)({
            value: We
          }), (0, F.useMarkPersistent)({
            html: ze,
            value: We
          });
          var Ye = (0, v.useRef)(new Set()),
              Ze = (0, v.useRef)(new Set());

          function onFocus() {
            Pe.current.focus();
          }

          var Xe = m,
              Qe = (0, v.createElement)(v.Fragment, null, Te && (0, v.createElement)(te.Provider, {
            value: Ye
          }, (0, v.createElement)(ne.Provider, {
            value: Ze
          }, (0, v.createElement)(O.Popover.__unstableSlotNameProvider, {
            value: "__unstable-block-tools-after"
          }, c && c({
            value: We,
            onChange: Ke,
            onFocus: onFocus
          }), (0, v.createElement)(Z.default, {
            value: We,
            onChange: Ke,
            onFocus: onFocus,
            formatTypes: He,
            forwardedRef: Pe
          })))), Te && Ae && (0, v.createElement)(R.default, {
            inline: re,
            anchorRef: Pe.current
          }), (0, v.createElement)(Xe, (0, _.default)({
            role: "textbox",
            "aria-multiline": !0,
            "aria-label": se
          }, Se, qe, {
            ref: (0, C.useMergeRefs)([qe.ref, Se.ref, $e, (0, U.useInputRules)({
              value: We,
              onChange: Ke,
              __unstableAllowPrefixTransformations: Ce,
              formatTypes: He,
              onReplace: ae
            }), (0, $.useRemoveBrowserShortcuts)(), (0, q.useShortcuts)(Ye), (0, Y.useInputEvents)(Ze), (0, z.useUndoAutomaticChange)(), (0, G.usePasteHandler)({
              isSelected: Te,
              disableFormats: ye,
              onChange: Ke,
              value: We,
              formatTypes: He,
              tagName: m,
              onReplace: ae,
              onSplit: fe,
              onSplitMiddle: ge,
              __unstableEmbedURLOnPaste: ke,
              multilineTag: Ve,
              preserveWhiteSpace: be,
              pastePlainText: _e
            }), (0, W.useEnter)({
              removeEditorOnlyFormats: removeEditorOnlyFormats,
              value: We,
              onReplace: ae,
              onSplit: fe,
              onSplitMiddle: ge,
              multilineTag: Ve,
              onChange: Ke,
              disableLineBreaks: Ee,
              onSplitAtEnd: he
            }), Pe, s]),
            contentEditable: !Oe || void 0,
            suppressContentEditableWarning: !Oe,
            className: (0, k.default)("block-editor-rich-text__editable", Se.className, "rich-text"),
            onFocus: we,
            onKeyDown: function onKeyDown(l) {
              var s = l.keyCode;

              if (!l.defaultPrevented && (s === P.DELETE || s === P.BACKSPACE)) {
                var _c36 = We.start,
                    _m31 = We.end,
                    _v16 = We.text,
                    _7 = s === P.BACKSPACE,
                    _k7 = We.activeFormats && !!We.activeFormats.length;

                if (!(0, S.isCollapsed)(We) || _k7 || _7 && 0 !== _c36 || !_7 && _m31 !== _v16.length) return;
                me && me(!_7), pe && (0, S.isEmpty)(We) && _7 && pe(!_7), l.preventDefault();
              }
            }
          })));
          if (!le) return Qe;
          (0, B.default)("wp.blockEditor.RichText wrapperClassName prop", {
            since: "5.4",
            alternative: "className prop or create your own wrapper div"
          });
          var Je = (0, k.default)("block-editor-rich-text", le);
          return (0, v.createElement)("div", {
            className: Je
          }, Qe);
        });
        oe.Content = function (l) {
          var s = l.value,
              c = l.tagName,
              m = l.multiline,
              _ = _objectWithoutProperties(l, _excluded37);

          Array.isArray(s) && (s = w.children.toHTML(s));
          var k = (0, X.getMultilineTag)(m);
          !s && k && (s = "<".concat(k, "></").concat(k, ">"));
          var E = (0, v.createElement)(v.RawHTML, null, s);
          return c ? (0, v.createElement)(c, (0, y.omit)(_, ["format"]), E) : E;
        }, oe.isEmpty = function (l) {
          return !l || 0 === l.length;
        };
        var re = oe;
        s.default = re;
      },
      6948: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.__unstableRichTextInputEvent = function __unstableRichTextInputEvent(l) {
          var s = l.inputType,
              c = l.onInput;

          var _ = (0, m.useContext)(v.inputEventContext),
              k = (0, m.useRef)();

          return k.current = c, (0, m.useEffect)(function () {
            function callback(l) {
              l.inputType === s && (k.current(), l.preventDefault());
            }

            return _.current.add(callback), function () {
              _.current.delete(callback);
            };
          }, [s]), null;
        };
        var m = c(1753),
            v = c(1700);
      },
      238: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.RichTextShortcut = function RichTextShortcut(l) {
          var s = l.character,
              c = l.type,
              k = l.onUse;
          var y = (0, v.useContext)(_.keyboardShortcutContext),
              E = (0, v.useRef)();
          return E.current = k, (0, v.useEffect)(function () {
            function callback(l) {
              m.isKeyboardEvent[c](l, s) && (E.current(), l.preventDefault());
            }

            return y.current.add(callback), function () {
              y.current.delete(callback);
            };
          }, [s, c]), null;
        };

        var m = c(9880),
            v = c(1753),
            _ = c(1700);
      },
      7907: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.splitValue = function splitValue(l) {
          var s = l.value,
              _l$pastedBlocks = l.pastedBlocks,
              c = _l$pastedBlocks === void 0 ? [] : _l$pastedBlocks,
              v = l.onReplace,
              _ = l.onSplit,
              k = l.onSplitMiddle,
              y = l.multilineTag;
          if (!v || !_) return;

          var E = [],
              _ref334 = (0, m.split)(s),
              _ref335 = _slicedToArray(_ref334, 2),
              w = _ref335[0],
              C = _ref335[1],
              S = c.length > 0;

          var B = -1;
          var P = (0, m.isEmpty)(w) && !(0, m.isEmpty)(C);
          S && (0, m.isEmpty)(w) || (E.push(_((0, m.toHTMLString)({
            value: w,
            multilineTag: y
          }), !P)), B += 1);
          S ? (E.push.apply(E, _toConsumableArray(c)), B += c.length) : k && E.push(k());
          (S || k) && (0, m.isEmpty)(C) || E.push(_((0, m.toHTMLString)({
            value: C,
            multilineTag: y
          }), P));
          v(E, S ? B : 1, S ? -1 : 0);
        };
        var m = c(7060);
      },
      8795: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.RichTextToolbarButton = function RichTextToolbarButton(l) {
          var s,
              c = l.name,
              m = l.shortcutType,
              E = l.shortcutCharacter,
              w = _objectWithoutProperties(l, _excluded38),
              C = "RichText.ToolbarControls";

          c && (C += ".".concat(c));
          m && E && (s = y.displayShortcut[m](E));
          return (0, v.createElement)(k.Fill, {
            name: C
          }, (0, v.createElement)(k.ToolbarButton, (0, _.default)({}, w, {
            shortcut: s
          })));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = c(9880);
      },
      6477: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useCaretInFormat = function useCaretInFormat(l) {
          var s = l.value;

          var c = s.activeFormats && !!s.activeFormats.length,
              _ref336 = (0, v.useSelect)(_.store),
              k = _ref336.isCaretWithinFormattedText,
              _ref337 = (0, v.useDispatch)(_.store),
              y = _ref337.enterFormattedText,
              E = _ref337.exitFormattedText;

          (0, m.useEffect)(function () {
            c ? k() || y() : k() && E();
          }, [c]);
        };

        var m = c(1753),
            v = c(8467),
            _ = c(8486);
      },
      6075: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useEnter = function useEnter(l) {
          var _ref338 = (0, E.useDispatch)(w.store),
              s = _ref338.__unstableMarkAutomaticChange,
              c = (0, m.useRef)(l);

          return c.current = l, (0, v.useRefEffect)(function (l) {
            function onKeyDown(l) {
              if (l.defaultPrevented) return;
              var _c$current = c.current,
                  m = _c$current.removeEditorOnlyFormats,
                  v = _c$current.value,
                  E = _c$current.onReplace,
                  w = _c$current.onSplit,
                  S = _c$current.onSplitMiddle,
                  B = _c$current.multilineTag,
                  P = _c$current.onChange,
                  O = _c$current.disableLineBreaks,
                  L = _c$current.onSplitAtEnd;
              if (l.keyCode !== _.ENTER) return;
              l.preventDefault();

              var V = _objectSpread({}, v);

              V.formats = m(v);
              var R = E && w;

              if (E) {
                var _l129 = (0, y.getBlockTransforms)("from").filter(function (l) {
                  var s = l.type;
                  return "enter" === s;
                }),
                    _c37 = (0, y.findTransform)(_l129, function (l) {
                  return l.regExp.test(V.text);
                });

                _c37 && (E([_c37.transform({
                  content: V.text
                })]), s());
              }

              if (B) l.shiftKey ? O || P((0, k.insert)(V, "\n")) : R && (0, k.__unstableIsEmptyLine)(V) ? (0, C.splitValue)({
                value: V,
                onReplace: E,
                onSplit: w,
                onSplitMiddle: S,
                multilineTag: B
              }) : P((0, k.__unstableInsertLineSeparator)(V));else {
                var _s55 = V.text,
                    _c38 = V.start,
                    _m32 = V.end,
                    _v17 = L && _c38 === _m32 && _m32 === _s55.length;

                l.shiftKey || !R && !_v17 ? O || P((0, k.insert)(V, "\n")) : !R && _v17 ? L() : R && (0, C.splitValue)({
                  value: V,
                  onReplace: E,
                  onSplit: w,
                  onSplitMiddle: S,
                  multilineTag: B
                });
              }
            }

            return l.addEventListener("keydown", onKeyDown), function () {
              l.removeEventListener("keydown", onKeyDown);
            };
          }, []);
        };

        var m = c(1753),
            v = c(3200),
            _ = c(9880),
            k = c(7060),
            y = c(6700),
            E = c(8467),
            w = c(8486),
            C = c(7907);
      },
      7004: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useFormatTypes = function useFormatTypes(l) {
          var s = l.clientId,
              c = l.identifier,
              _ = l.withoutInteractiveFormatting,
              y = l.allowedFormats;
          var E = (0, v.useSelect)(formatTypesSelector, []),
              w = (0, m.useMemo)(function () {
            return E.filter(function (l) {
              var s = l.name,
                  c = l.tagName;
              return !(y && !y.includes(s)) && (!_ || !k.has(c));
            });
          }, [E, y, k]),
              C = (0, v.useSelect)(function (l) {
            return w.reduce(function (m, v) {
              return v.__experimentalGetPropsForEditableTreePreparation && (m[v.name] = v.__experimentalGetPropsForEditableTreePreparation(l, {
                richTextIdentifier: c,
                blockClientId: s
              })), m;
            }, {});
          }, [w, s, c]),
              S = (0, v.useDispatch)(),
              B = [],
              P = [],
              O = [],
              L = [];
          return w.forEach(function (l) {
            if (l.__experimentalCreatePrepareEditableTree) {
              var _m33 = C[l.name],
                  _v18 = l.__experimentalCreatePrepareEditableTree(_m33, {
                richTextIdentifier: c,
                blockClientId: s
              });

              l.__experimentalCreateOnChangeEditableValue ? P.push(_v18) : B.push(_v18);

              for (var _l130 in _m33) {
                L.push(_m33[_l130]);
              }
            }

            if (l.__experimentalCreateOnChangeEditableValue) {
              var _m34 = {};
              l.__experimentalGetPropsForEditableTreeChangeHandler && (_m34 = l.__experimentalGetPropsForEditableTreeChangeHandler(S, {
                richTextIdentifier: c,
                blockClientId: s
              })), O.push(l.__experimentalCreateOnChangeEditableValue(_objectSpread(_objectSpread({}, C[l.name] || {}), _m34), {
                richTextIdentifier: c,
                blockClientId: s
              }));
            }
          }), {
            formatTypes: w,
            prepareHandlers: B,
            valueHandlers: P,
            changeHandlers: O,
            dependencies: L
          };
        };

        var m = c(1753),
            v = c(8467),
            _ = c(7060);

        function formatTypesSelector(l) {
          return l(_.store).getFormatTypes();
        }

        var k = new Set(["a", "audio", "button", "details", "embed", "iframe", "input", "label", "select", "textarea", "video"]);
      },
      9295: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useInputEvents = function useInputEvents(l) {
          return (0, m.useRefEffect)(function (s) {
            function onInput(s) {
              var _iterator10 = _createForOfIteratorHelper(l.current),
                  _step10;

              try {
                for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                  var _c39 = _step10.value;

                  _c39(s);
                }
              } catch (err) {
                _iterator10.e(err);
              } finally {
                _iterator10.f();
              }
            }

            return s.addEventListener("input", onInput), function () {
              s.removeEventListener("input", onInput);
            };
          }, []);
        };
        var m = c(3200);
      },
      7030: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useInputRules = function useInputRules(l) {
          var _ref339 = (0, y.useDispatch)(E.store),
              s = _ref339.__unstableMarkLastChangeAsPersistent,
              c = _ref339.__unstableMarkAutomaticChange,
              w = (0, m.useRef)(l);

          return w.current = l, (0, v.useRefEffect)(function (l) {
            function inputRule() {
              var _w$current = w.current,
                  l = _w$current.value,
                  s = _w$current.onReplace;
              if (!s) return;
              var m = l.start,
                  v = l.text;
              if (" " !== v.slice(m - 1, m)) return;
              var y = v.slice(0, m).trim(),
                  E = (0, k.getBlockTransforms)("from").filter(function (l) {
                var s = l.type;
                return "prefix" === s;
              }),
                  C = (0, k.findTransform)(E, function (l) {
                var s = l.prefix;
                return y === s;
              });
              if (!C) return;
              var S = (0, _.toHTMLString)({
                value: (0, _.slice)(l, m, v.length)
              });
              s([C.transform(S)]), c();
            }

            function onInput(l) {
              var m = l.inputType,
                  v = l.type,
                  _w$current2 = w.current,
                  _ = _w$current2.value,
                  k = _w$current2.onChange,
                  y = _w$current2.__unstableAllowPrefixTransformations,
                  E = _w$current2.formatTypes;
              if ("insertText" !== m && "compositionend" !== v) return;
              y && inputRule && inputRule();
              var C = E.reduce(function (l, s) {
                var c = s.__unstableInputRule;
                return c && (l = c(l)), l;
              }, _);
              C !== _ && (s(), k(_objectSpread(_objectSpread({}, C), {}, {
                activeFormats: _.activeFormats
              })), c());
            }

            return l.addEventListener("input", onInput), l.addEventListener("compositionend", onInput), function () {
              l.removeEventListener("input", onInput), l.removeEventListener("compositionend", onInput);
            };
          }, []);
        };

        var m = c(1753),
            v = c(3200),
            _ = c(7060),
            k = c(6700),
            y = c(8467),
            E = c(8486);
      },
      8758: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useMarkPersistent = function useMarkPersistent(l) {
          var s = l.html,
              c = l.value;

          var k = (0, m.useRef)(),
              y = c.activeFormats && !!c.activeFormats.length,
              _ref340 = (0, v.useDispatch)(_.store),
              E = _ref340.__unstableMarkLastChangeAsPersistent;

          (0, m.useLayoutEffect)(function () {
            if (k.current) {
              if (k.current !== c.text) {
                var _l131 = window.setTimeout(function () {
                  E();
                }, 1e3);

                return k.current = c.text, function () {
                  window.clearTimeout(_l131);
                };
              }

              E();
            } else k.current = c.text;
          }, [s, y]);
        };

        var m = c(1753),
            v = c(8467),
            _ = c(8486);
      },
      2466: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.usePasteHandler = function usePasteHandler(l) {
          var s = (0, m.useRef)(l);
          return s.current = l, (0, v.useRefEffect)(function (l) {
            function _onPaste(l) {
              var _s$current = s.current,
                  c = _s$current.isSelected,
                  m = _s$current.disableFormats,
                  v = _s$current.onChange,
                  B = _s$current.value,
                  P = _s$current.formatTypes,
                  O = _s$current.tagName,
                  L = _s$current.onReplace,
                  V = _s$current.onSplit,
                  R = _s$current.onSplitMiddle,
                  A = _s$current.__unstableEmbedURLOnPaste,
                  z = _s$current.multilineTag,
                  D = _s$current.preserveWhiteSpace,
                  F = _s$current.pastePlainText;
              if (!c) return void l.preventDefault();
              var G = l.clipboardData;
              var U = "",
                  W = "";

              try {
                U = G.getData("text/plain"), W = G.getData("text/html");
              } catch (l) {
                try {
                  W = G.getData("Text");
                } catch (l) {
                  return;
                }
              }

              if (W = function removeWindowsFragments(l) {
                var s = /[\s\S]*<!\x2D\x2DStartFragment\x2D\x2D>/,
                    c = /<!\x2D\x2DEndFragment\x2D\x2D>[\s\S]*/;
                return l.replace(s, "").replace(c, "");
              }(W), W = function removeCharsetMetaTag(l) {
                var s = "<meta charset='utf-8'>";
                if (l.startsWith(s)) return l.slice(s.length);
                return l;
              }(W), l.preventDefault(), window.console.log("Received HTML:\n\n", W), window.console.log("Received plain text:\n\n", U), m) return void v((0, y.insert)(B, U));
              var K = P.reduce(function (l, s) {
                var c = s.__unstablePasteRule;
                return c && l === B && (l = c(B, {
                  html: W,
                  plainText: U
                })), l;
              }, B);
              if (K !== B) return void v(K);

              var $ = _toConsumableArray((0, _.getFilesFromDataTransfer)(G));

              if ("true" === G.getData("rich-text")) {
                var _l132 = G.getData("rich-text-multi-line-tag") || void 0;

                var _s56 = (0, y.create)({
                  html: W,
                  multilineTag: _l132,
                  multilineWrapperTags: "li" === _l132 ? ["ul", "ol"] : void 0,
                  preserveWhiteSpace: D
                });

                return _s56 = adjustLines(_s56, !!z), (0, C.addActiveFormats)(_s56, B.activeFormats), void v((0, y.insert)(B, _s56));
              }

              if (F) return void v((0, y.insert)(B, (0, y.create)({
                text: U
              })));

              if ($ && $.length && !W) {
                var _l133 = (0, k.pasteHandler)({
                  HTML: (0, w.filePasteHandler)($),
                  mode: "BLOCKS",
                  tagName: O,
                  preserveWhiteSpace: D
                });

                return window.console.log("Received items:\n\n", $), void (L && (0, y.isEmpty)(B) ? L(_l133) : (0, S.splitValue)({
                  value: B,
                  pastedBlocks: _l133,
                  onReplace: L,
                  onSplit: V,
                  onSplitMiddle: R,
                  multilineTag: z
                }));
              }

              var q = L && V ? "AUTO" : "INLINE";
              "AUTO" === q && (0, y.isEmpty)(B) && (0, C.isShortcode)(U) && (q = "BLOCKS"), A && (0, y.isEmpty)(B) && (0, E.isURL)(U.trim()) && (q = "BLOCKS");
              var Y = (0, k.pasteHandler)({
                HTML: W,
                plainText: U,
                mode: q,
                tagName: O,
                preserveWhiteSpace: D
              });

              if ("string" == typeof Y) {
                var _l134 = (0, y.create)({
                  html: Y
                });

                _l134 = adjustLines(_l134, !!z), (0, C.addActiveFormats)(_l134, B.activeFormats), v((0, y.insert)(B, _l134));
              } else Y.length > 0 && (L && (0, y.isEmpty)(B) ? L(Y, Y.length - 1, -1) : (0, S.splitValue)({
                value: B,
                pastedBlocks: Y,
                onReplace: L,
                onSplit: V,
                onSplitMiddle: R,
                multilineTag: z
              }));
            }

            return l.addEventListener("paste", _onPaste), function () {
              l.removeEventListener("paste", _onPaste);
            };
          }, []);
        };

        var m = c(1753),
            v = c(3200),
            _ = c(5480),
            k = c(6700),
            y = c(7060),
            E = c(904),
            w = c(1161),
            C = c(1347),
            S = c(7907);

        function adjustLines(l, s) {
          return s ? (0, y.replace)(l, /\n+/g, y.__UNSTABLE_LINE_SEPARATOR) : (0, y.replace)(l, new RegExp(y.__UNSTABLE_LINE_SEPARATOR, "g"), "\n");
        }
      },
      7720: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useRemoveBrowserShortcuts = function useRemoveBrowserShortcuts() {
          return (0, m.useRefEffect)(function (l) {
            function onKeydown(l) {
              (v.isKeyboardEvent.primary(l, "z") || v.isKeyboardEvent.primary(l, "y") || v.isKeyboardEvent.primaryShift(l, "z")) && l.preventDefault();
            }

            return l.addEventListener("keydown", onKeydown), function () {
              l.addEventListener("keydown", onKeydown);
            };
          }, []);
        };
        var m = c(3200),
            v = c(9880);
      },
      6773: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useShortcuts = function useShortcuts(l) {
          return (0, m.useRefEffect)(function (s) {
            function onKeyDown(s) {
              var _iterator11 = _createForOfIteratorHelper(l.current),
                  _step11;

              try {
                for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                  var _c40 = _step11.value;

                  _c40(s);
                }
              } catch (err) {
                _iterator11.e(err);
              } finally {
                _iterator11.f();
              }
            }

            return s.addEventListener("keydown", onKeyDown), function () {
              s.removeEventListener("keydown", onKeyDown);
            };
          }, []);
        };
        var m = c(3200);
      },
      1964: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useUndoAutomaticChange = function useUndoAutomaticChange() {
          var _ref341 = (0, m.useSelect)(k.store),
              l = _ref341.didAutomaticChange,
              s = _ref341.getSettings;

          return (0, v.useRefEffect)(function (c) {
            function onKeyDown(c) {
              var m = c.keyCode;
              c.defaultPrevented || m !== _.DELETE && m !== _.BACKSPACE && m !== _.ESCAPE || l() && (c.preventDefault(), s().__experimentalUndo());
            }

            return c.addEventListener("keydown", onKeyDown), function () {
              c.removeEventListener("keydown", onKeyDown);
            };
          }, []);
        };

        var m = c(8467),
            v = c(3200),
            _ = c(9880),
            k = c(8486);
      },
      1347: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.addActiveFormats = function addActiveFormats(l, s) {
          if (null != s && s.length) {
            var _c41 = l.formats.length;

            for (; _c41--;) {
              l.formats[_c41] = [].concat(_toConsumableArray(s), _toConsumableArray(l.formats[_c41] || []));
            }
          }
        }, s.createLinkInParagraph = function createLinkInParagraph(l, s) {
          var c = (0, v.createElement)("a", {
            href: l
          }, l);
          s((0, y.createBlock)("core/paragraph", {
            content: (0, v.renderToString)(c)
          }));
        }, s.getAllowedFormats = getAllowedFormats, s.getMultilineTag = function getMultilineTag(l) {
          if (!0 !== l && "p" !== l && "li" !== l) return;
          return !0 === l ? "p" : l;
        }, s.isShortcode = void 0;

        var v = c(1753),
            _ = c(2063),
            k = m(c(3703)),
            y = c(6700);

        function getAllowedFormats(l) {
          var s = l.allowedFormats,
              c = l.formattingControls,
              m = l.disableFormats;
          return m ? getAllowedFormats.EMPTY_ARRAY : s || c ? s || ((0, k.default)("wp.blockEditor.RichText formattingControls prop", {
            since: "5.4",
            alternative: "allowedFormats"
          }), c.map(function (l) {
            return "core/".concat(l);
          })) : void 0;
        }

        getAllowedFormats.EMPTY_ARRAY = [];

        s.isShortcode = function (l) {
          return (0, _.regexp)(".*").test(l);
        };
      },
      6599: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.MultiSelectScrollIntoView = function MultiSelectScrollIntoView() {
          return (0, v.default)("wp.blockEditor.MultiSelectScrollIntoView", {
            hint: "This behaviour is now built-in."
          }), null;
        };
        var v = m(c(3703));
      },
      39: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(1753),
            v = c(8467),
            _ = c(6756),
            k = c(4892),
            y = c(8486),
            E = c(8882);

        var w = (0, v.withSelect)(function (l) {
          return {
            selectedBlockClientId: l(y.store).getBlockSelectionStart()
          };
        })(function (l) {
          var s = l.selectedBlockClientId;
          var c = (0, E.__unstableUseBlockRef)(s);
          return s ? (0, m.createElement)(k.Button, {
            variant: "secondary",
            className: "block-editor-skip-to-selected-block",
            onClick: function onClick() {
              c.current.focus();
            }
          }, (0, _.__)("Skip to the selected block")) : null;
        });
        s.default = w;
      },
      7731: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function TextDecorationControl(l) {
          var s = l.value,
              c = l.onChange;
          return (0, m.createElement)("fieldset", {
            className: "block-editor-text-decoration-control"
          }, (0, m.createElement)("legend", null, (0, k.__)("Decoration")), (0, m.createElement)("div", {
            className: "block-editor-text-decoration-control__buttons"
          }, y.map(function (l) {
            return (0, m.createElement)(v.Button, {
              key: l.value,
              icon: l.icon,
              isSmall: !0,
              isPressed: l.value === s,
              onClick: function onClick() {
                return c(l.value === s ? void 0 : l.value);
              },
              "aria-label": l.name
            });
          })));
        };

        var m = c(1753),
            v = c(4892),
            _ = c(2614),
            k = c(6756);

        var y = [{
          name: (0, k.__)("Underline"),
          value: "underline",
          icon: _.formatUnderline
        }, {
          name: (0, k.__)("Strikethrough"),
          value: "line-through",
          icon: _.formatStrikethrough
        }];
      },
      4286: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function TextTransformControl(l) {
          var s = l.value,
              c = l.onChange;
          return (0, m.createElement)("fieldset", {
            className: "block-editor-text-transform-control"
          }, (0, m.createElement)("legend", null, (0, _.__)("Letter case")), (0, m.createElement)("div", {
            className: "block-editor-text-transform-control__buttons"
          }, y.map(function (l) {
            return (0, m.createElement)(v.Button, {
              key: l.value,
              icon: l.icon,
              isSmall: !0,
              isPressed: s === l.value,
              "aria-label": l.name,
              onClick: function onClick() {
                return c(s === l.value ? void 0 : l.value);
              }
            });
          })));
        };

        var m = c(1753),
            v = c(4892),
            _ = c(6756),
            k = c(2614);

        var y = [{
          name: (0, _.__)("Uppercase"),
          value: "uppercase",
          icon: k.formatUppercase
        }, {
          name: (0, _.__)("Lowercase"),
          value: "lowercase",
          icon: k.formatLowercase
        }, {
          name: (0, _.__)("Capitalize"),
          value: "capitalize",
          icon: k.formatCapitalize
        }];
      },
      7436: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = c(6756),
            E = c(8467),
            w = c(2614),
            C = c(8486);

        var S = (0, v.createElement)(k.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, (0, v.createElement)(k.Path, {
          d: "M9.4 20.5L5.2 3.8l14.6 9-2 .3c-.2 0-.4.1-.7.1-.9.2-1.6.3-2.2.5-.8.3-1.4.5-1.8.8-.4.3-.8.8-1.3 1.5-.4.5-.8 1.2-1.2 2l-.3.6-.9 1.9zM7.6 7.1l2.4 9.3c.2-.4.5-.8.7-1.1.6-.8 1.1-1.4 1.6-1.8.5-.4 1.3-.8 2.2-1.1l1.2-.3-8.1-5z"
        }));
        var B = (0, v.forwardRef)(function ToolSelector(l, s) {
          var c = (0, E.useSelect)(function (l) {
            return l(C.store).isNavigationMode();
          }, []),
              _ref342 = (0, E.useDispatch)(C.store),
              m = _ref342.setNavigationMode,
              onSwitchMode = function onSwitchMode(l) {
            m("edit" !== l);
          };

          return (0, v.createElement)(k.Dropdown, {
            renderToggle: function renderToggle(m) {
              var E = m.isOpen,
                  C = m.onToggle;
              return (0, v.createElement)(k.Button, (0, _.default)({}, l, {
                ref: s,
                icon: c ? S : w.edit,
                "aria-expanded": E,
                "aria-haspopup": "true",
                onClick: C,
                label: (0, y.__)("Tools")
              }));
            },
            position: "bottom right",
            renderContent: function renderContent() {
              return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(k.NavigableMenu, {
                role: "menu",
                "aria-label": (0, y.__)("Tools")
              }, (0, v.createElement)(k.MenuItemsChoice, {
                value: c ? "select" : "edit",
                onSelect: onSwitchMode,
                choices: [{
                  value: "edit",
                  label: (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.Icon, {
                    icon: w.edit
                  }), (0, y.__)("Edit"))
                }, {
                  value: "select",
                  label: (0, v.createElement)(v.Fragment, null, S, (0, y.__)("Select"))
                }]
              })), (0, v.createElement)("div", {
                className: "block-editor-tool-selector__help"
              }, (0, y.__)("Tools provide different interactions for selecting, navigating, and editing blocks. Toggle between select and edit by pressing Escape and Enter.")));
            }
          });
        });
        s.default = B;
      },
      9386: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0, s.useTypewriter = useTypewriter;

        var m = c(1753),
            v = c(3200),
            _ = c(5480),
            k = c(8467),
            y = c(9880),
            E = c(8486);

        var w = -1 !== window.navigator.userAgent.indexOf("Trident"),
            C = new Set([y.UP, y.DOWN, y.LEFT, y.RIGHT]);

        function useTypewriter() {
          var l = (0, k.useSelect)(function (l) {
            return l(E.store).hasSelectedBlock();
          }, []);
          return (0, v.useRefEffect)(function (s) {
            if (!l) return;
            var c = s.ownerDocument,
                m = c.defaultView;
            var v, k, y;

            function onScrollResize() {
              v || (v = m.requestAnimationFrame(function () {
                computeCaretRectangle(), v = null;
              }));
            }

            function onKeyDown(l) {
              k && m.cancelAnimationFrame(k), k = m.requestAnimationFrame(function () {
                maintainCaretPosition(l), k = null;
              });
            }

            function maintainCaretPosition(l) {
              var v = l.keyCode;
              if (!isSelectionEligibleForScroll()) return;
              var k = (0, _.computeCaretRect)(m);
              if (!k) return;
              if (!y) return void (y = k);
              if (C.has(v)) return void (y = k);
              var E = k.top - y.top;
              if (0 === E) return;
              var w = (0, _.getScrollContainer)(s);
              if (!w) return;
              var S = w === c.body,
                  B = S ? m.scrollY : w.scrollTop,
                  P = S ? 0 : w.getBoundingClientRect().top,
                  O = S ? y.top / m.innerHeight : (y.top - P) / (m.innerHeight - P);
              if (0 === B && O < .75 && function isLastEditableNode() {
                var l = s.querySelectorAll('[contenteditable="true"]');
                return l[l.length - 1] === c.activeElement;
              }()) return void (y = k);
              var L = S ? m.innerHeight : w.clientHeight;
              y.top + y.height > P + L || y.top < P ? y = k : S ? m.scrollBy(0, E) : w.scrollTop += E;
            }

            function addSelectionChangeListener() {
              c.addEventListener("selectionchange", computeCaretRectOnSelectionChange);
            }

            function computeCaretRectOnSelectionChange() {
              c.removeEventListener("selectionchange", computeCaretRectOnSelectionChange), computeCaretRectangle();
            }

            function computeCaretRectangle() {
              isSelectionEligibleForScroll() && (y = (0, _.computeCaretRect)(m));
            }

            function isSelectionEligibleForScroll() {
              return s.contains(c.activeElement) && c.activeElement.isContentEditable;
            }

            return m.addEventListener("scroll", onScrollResize, !0), m.addEventListener("resize", onScrollResize, !0), s.addEventListener("keydown", onKeyDown), s.addEventListener("keyup", maintainCaretPosition), s.addEventListener("mousedown", addSelectionChangeListener), s.addEventListener("touchstart", addSelectionChangeListener), function () {
              m.removeEventListener("scroll", onScrollResize, !0), m.removeEventListener("resize", onScrollResize, !0), s.removeEventListener("keydown", onKeyDown), s.removeEventListener("keyup", maintainCaretPosition), s.removeEventListener("mousedown", addSelectionChangeListener), s.removeEventListener("touchstart", addSelectionChangeListener), c.removeEventListener("selectionchange", computeCaretRectOnSelectionChange), m.cancelAnimationFrame(v), m.cancelAnimationFrame(k);
            };
          }, [l]);
        }

        var S = w ? function (l) {
          return l.children;
        } : function Typewriter(l) {
          var s = l.children;
          return (0, m.createElement)("div", {
            ref: useTypewriter(),
            className: "block-editor__typewriter"
          }, s);
        };
        s.default = S;
      },
      6140: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function UnitControl(l) {
          var s = l.units,
              c = _objectWithoutProperties(l, _excluded39);

          var m = (0, k.__experimentalUseCustomUnits)({
            availableUnits: (0, y.default)("spacing.units") || ["%", "px", "em", "rem", "vw"],
            units: s
          });
          return (0, v.createElement)(k.__experimentalUnitControl, (0, _.default)({
            units: m
          }, c));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4892),
            y = m(c(3081));
      },
      6716: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(6756),
            k = c(4892),
            y = c(2614),
            E = m(c(5852));

        var URLInputButton = /*#__PURE__*/function (_v$Component4) {
          _inherits(URLInputButton, _v$Component4);

          var _super16 = _createSuper(URLInputButton);

          function URLInputButton() {
            var _this37;

            _classCallCheck(this, URLInputButton);

            _this37 = _super16.apply(this, arguments), _this37.toggle = _this37.toggle.bind(_assertThisInitialized(_this37)), _this37.submitLink = _this37.submitLink.bind(_assertThisInitialized(_this37)), _this37.state = {
              expanded: !1
            };
            return _this37;
          }

          _createClass(URLInputButton, [{
            key: "toggle",
            value: function toggle() {
              this.setState({
                expanded: !this.state.expanded
              });
            }
          }, {
            key: "submitLink",
            value: function submitLink(l) {
              l.preventDefault(), this.toggle();
            }
          }, {
            key: "render",
            value: function render() {
              var _this$props4 = this.props,
                  l = _this$props4.url,
                  s = _this$props4.onChange,
                  c = this.state.expanded,
                  m = l ? (0, _.__)("Edit link") : (0, _.__)("Insert link");
              return (0, v.createElement)("div", {
                className: "block-editor-url-input__button"
              }, (0, v.createElement)(k.Button, {
                icon: y.link,
                label: m,
                onClick: this.toggle,
                className: "components-toolbar__control",
                isPressed: !!l
              }), c && (0, v.createElement)("form", {
                className: "block-editor-url-input__button-modal",
                onSubmit: this.submitLink
              }, (0, v.createElement)("div", {
                className: "block-editor-url-input__button-modal-line"
              }, (0, v.createElement)(k.Button, {
                className: "block-editor-url-input__back",
                icon: y.arrowLeft,
                label: (0, _.__)("Close"),
                onClick: this.toggle
              }), (0, v.createElement)(E.default, {
                value: l || "",
                onChange: s
              }), (0, v.createElement)(k.Button, {
                icon: y.keyboardReturn,
                label: (0, _.__)("Submit"),
                type: "submit"
              }))));
            }
          }]);

          return URLInputButton;
        }(v.Component);

        var w = URLInputButton;
        s.default = w;
      },
      5852: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = m(c(2703)),
            E = m(c(3745)),
            w = c(6756),
            C = c(9880),
            S = c(4892),
            B = c(3200),
            P = c(8467),
            O = c(904),
            L = c(8486);

        var URLInput = /*#__PURE__*/function (_v$Component5) {
          _inherits(URLInput, _v$Component5);

          var _super17 = _createSuper(URLInput);

          function URLInput(l) {
            var _this38;

            _classCallCheck(this, URLInput);

            _this38 = _super17.call(this, l), _this38.onChange = _this38.onChange.bind(_assertThisInitialized(_this38)), _this38.onFocus = _this38.onFocus.bind(_assertThisInitialized(_this38)), _this38.onKeyDown = _this38.onKeyDown.bind(_assertThisInitialized(_this38)), _this38.selectLink = _this38.selectLink.bind(_assertThisInitialized(_this38)), _this38.handleOnClick = _this38.handleOnClick.bind(_assertThisInitialized(_this38)), _this38.bindSuggestionNode = _this38.bindSuggestionNode.bind(_assertThisInitialized(_this38)), _this38.autocompleteRef = l.autocompleteRef || (0, v.createRef)(), _this38.inputRef = (0, v.createRef)(), _this38.updateSuggestions = (0, k.debounce)(_this38.updateSuggestions.bind(_assertThisInitialized(_this38)), 200), _this38.suggestionNodes = [], _this38.isUpdatingSuggestions = !1, _this38.state = {
              suggestions: [],
              showSuggestions: !1,
              selectedSuggestion: null,
              suggestionsListboxId: "",
              suggestionOptionIdPrefix: ""
            };
            return _this38;
          }

          _createClass(URLInput, [{
            key: "componentDidUpdate",
            value: function componentDidUpdate(l) {
              var _this39 = this;

              var _this$state = this.state,
                  s = _this$state.showSuggestions,
                  c = _this$state.selectedSuggestion,
                  _this$props5 = this.props,
                  m = _this$props5.value,
                  _this$props5$__experi = _this$props5.__experimentalShowInitialSuggestions,
                  v = _this$props5$__experi === void 0 ? !1 : _this$props5$__experi;
              s && null !== c && this.suggestionNodes[c] && !this.scrollingIntoView && (this.scrollingIntoView = !0, (0, E.default)(this.suggestionNodes[c], this.autocompleteRef.current, {
                onlyScrollIfNeeded: !0
              }), this.props.setTimeout(function () {
                _this39.scrollingIntoView = !1;
              }, 100)), l.value === m || this.props.disableSuggestions || this.isUpdatingSuggestions || (null != m && m.length ? this.updateSuggestions(m) : v && this.updateSuggestions());
            }
          }, {
            key: "componentDidMount",
            value: function componentDidMount() {
              this.shouldShowInitialSuggestions() && this.updateSuggestions();
            }
          }, {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
              var l, s;
              null === (l = this.suggestionsRequest) || void 0 === l || null === (s = l.cancel) || void 0 === s || s.call(l), delete this.suggestionsRequest;
            }
          }, {
            key: "bindSuggestionNode",
            value: function bindSuggestionNode(l) {
              var _this40 = this;

              return function (s) {
                _this40.suggestionNodes[l] = s;
              };
            }
          }, {
            key: "shouldShowInitialSuggestions",
            value: function shouldShowInitialSuggestions() {
              var l = this.state.suggestions,
                  _this$props6 = this.props,
                  _this$props6$__experi = _this$props6.__experimentalShowInitialSuggestions,
                  s = _this$props6$__experi === void 0 ? !1 : _this$props6$__experi,
                  c = _this$props6.value;
              return !this.isUpdatingSuggestions && s && !(c && c.length) && !(l && l.length);
            }
          }, {
            key: "updateSuggestions",
            value: function updateSuggestions() {
              var _this41 = this;

              var l;
              var s = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
              var _this$props7 = this.props,
                  c = _this$props7.__experimentalFetchLinkSuggestions,
                  m = _this$props7.__experimentalHandleURLSuggestions;
              if (!c) return;
              var v = !(null !== (l = s) && void 0 !== l && l.length);
              if (s = s.trim(), !v && (s.length < 2 || !m && (0, O.isURL)(s))) return void this.setState({
                showSuggestions: !1,
                selectedSuggestion: null,
                loading: !1
              });
              this.isUpdatingSuggestions = !0, this.setState({
                selectedSuggestion: null,
                loading: !0
              });

              var _ = c(s, {
                isInitialSuggestions: v
              });

              _.then(function (l) {
                _this41.suggestionsRequest === _ && (_this41.setState({
                  suggestions: l,
                  loading: !1,
                  showSuggestions: !!l.length
                }), l.length ? _this41.props.debouncedSpeak((0, w.sprintf)((0, w._n)("%d result found, use up and down arrow keys to navigate.", "%d results found, use up and down arrow keys to navigate.", l.length), l.length), "assertive") : _this41.props.debouncedSpeak((0, w.__)("No results."), "assertive"), _this41.isUpdatingSuggestions = !1);
              }).catch(function () {
                _this41.suggestionsRequest === _ && (_this41.setState({
                  loading: !1
                }), _this41.isUpdatingSuggestions = !1);
              }), this.suggestionsRequest = _;
            }
          }, {
            key: "onChange",
            value: function onChange(l) {
              var s = l.target.value;
              this.props.onChange(s), this.props.disableSuggestions || this.updateSuggestions(s);
            }
          }, {
            key: "onFocus",
            value: function onFocus() {
              var l = this.state.suggestions,
                  _this$props8 = this.props,
                  s = _this$props8.disableSuggestions,
                  c = _this$props8.value;
              !c || s || this.isUpdatingSuggestions || l && l.length || this.updateSuggestions(c);
            }
          }, {
            key: "onKeyDown",
            value: function onKeyDown(l) {
              var _this$state2 = this.state,
                  s = _this$state2.showSuggestions,
                  c = _this$state2.selectedSuggestion,
                  m = _this$state2.suggestions,
                  v = _this$state2.loading;

              if (!s || !m.length || v) {
                switch (l.keyCode) {
                  case C.UP:
                    0 !== l.target.selectionStart && (l.preventDefault(), l.target.setSelectionRange(0, 0));
                    break;

                  case C.DOWN:
                    this.props.value.length !== l.target.selectionStart && (l.preventDefault(), l.target.setSelectionRange(this.props.value.length, this.props.value.length));
                    break;

                  case C.ENTER:
                    this.props.onSubmit && this.props.onSubmit(null, l);
                }

                return;
              }

              var _ = this.state.suggestions[this.state.selectedSuggestion];

              switch (l.keyCode) {
                case C.UP:
                  {
                    l.preventDefault();

                    var _s57 = c ? c - 1 : m.length - 1;

                    this.setState({
                      selectedSuggestion: _s57
                    });
                    break;
                  }

                case C.DOWN:
                  {
                    l.preventDefault();

                    var _s58 = null === c || c === m.length - 1 ? 0 : c + 1;

                    this.setState({
                      selectedSuggestion: _s58
                    });
                    break;
                  }

                case C.TAB:
                  null !== this.state.selectedSuggestion && (this.selectLink(_), this.props.speak((0, w.__)("Link selected.")));
                  break;

                case C.ENTER:
                  null !== this.state.selectedSuggestion ? (this.selectLink(_), this.props.onSubmit && this.props.onSubmit(_, l)) : this.props.onSubmit && this.props.onSubmit(null, l);
              }
            }
          }, {
            key: "selectLink",
            value: function selectLink(l) {
              this.props.onChange(l.url, l), this.setState({
                selectedSuggestion: null,
                showSuggestions: !1
              });
            }
          }, {
            key: "handleOnClick",
            value: function handleOnClick(l) {
              this.selectLink(l), this.inputRef.current.focus();
            }
          }, {
            key: "render",
            value: function render() {
              return (0, v.createElement)(v.Fragment, null, this.renderControl(), this.renderSuggestions());
            }
          }, {
            key: "renderControl",
            value: function renderControl() {
              var _this$props9 = this.props,
                  l = _this$props9.label,
                  s = _this$props9.className,
                  c = _this$props9.isFullWidth,
                  m = _this$props9.instanceId,
                  _this$props9$placehol = _this$props9.placeholder,
                  _ = _this$props9$placehol === void 0 ? (0, w.__)("Paste URL or type to search") : _this$props9$placehol,
                  k = _this$props9.__experimentalRenderControl,
                  _this$props9$value = _this$props9.value,
                  E = _this$props9$value === void 0 ? "" : _this$props9$value,
                  _this$state3 = this.state,
                  C = _this$state3.loading,
                  B = _this$state3.showSuggestions,
                  P = _this$state3.selectedSuggestion,
                  O = _this$state3.suggestionsListboxId,
                  L = _this$state3.suggestionOptionIdPrefix,
                  V = {
                id: "url-input-control-".concat(m),
                label: l,
                className: (0, y.default)("block-editor-url-input", s, {
                  "is-full-width": c
                })
              },
                  R = {
                value: E,
                required: !0,
                className: "block-editor-url-input__input",
                type: "text",
                onChange: this.onChange,
                onFocus: this.onFocus,
                placeholder: _,
                onKeyDown: this.onKeyDown,
                role: "combobox",
                "aria-label": (0, w.__)("URL"),
                "aria-expanded": B,
                "aria-autocomplete": "list",
                "aria-owns": O,
                "aria-activedescendant": null !== P ? "".concat(L, "-").concat(P) : void 0,
                ref: this.inputRef
              };

              return k ? k(V, R, C) : (0, v.createElement)(S.BaseControl, V, (0, v.createElement)("input", R), C && (0, v.createElement)(S.Spinner, null));
            }
          }, {
            key: "renderSuggestions",
            value: function renderSuggestions() {
              var _this42 = this;

              var _this$props10 = this.props,
                  l = _this$props10.className,
                  s = _this$props10.__experimentalRenderSuggestions,
                  _this$props10$value = _this$props10.value,
                  c = _this$props10$value === void 0 ? "" : _this$props10$value,
                  _this$props10$__exper = _this$props10.__experimentalShowInitialSuggestions,
                  m = _this$props10$__exper === void 0 ? !1 : _this$props10$__exper,
                  _this$state4 = this.state,
                  E = _this$state4.showSuggestions,
                  w = _this$state4.suggestions,
                  C = _this$state4.selectedSuggestion,
                  B = _this$state4.suggestionsListboxId,
                  P = _this$state4.suggestionOptionIdPrefix,
                  O = _this$state4.loading,
                  L = {
                id: B,
                ref: this.autocompleteRef,
                role: "listbox"
              },
                  buildSuggestionItemProps = function buildSuggestionItemProps(l, s) {
                return {
                  role: "option",
                  tabIndex: "-1",
                  id: "".concat(P, "-").concat(s),
                  ref: _this42.bindSuggestionNode(s),
                  "aria-selected": s === C
                };
              };

              return (0, k.isFunction)(s) && E && w.length ? s({
                suggestions: w,
                selectedSuggestion: C,
                suggestionsListProps: L,
                buildSuggestionItemProps: buildSuggestionItemProps,
                isLoading: O,
                handleSuggestionClick: this.handleOnClick,
                isInitialSuggestions: m && !(c && c.length)
              }) : !(0, k.isFunction)(s) && E && w.length ? (0, v.createElement)(S.Popover, {
                position: "bottom",
                noArrow: !0,
                focusOnMount: !1
              }, (0, v.createElement)("div", (0, _.default)({}, L, {
                className: (0, y.default)("block-editor-url-input__suggestions", "".concat(l, "__suggestions"))
              }), w.map(function (l, s) {
                return (0, v.createElement)(S.Button, (0, _.default)({}, buildSuggestionItemProps(0, s), {
                  key: l.id,
                  className: (0, y.default)("block-editor-url-input__suggestion", {
                    "is-selected": s === C
                  }),
                  onClick: function onClick() {
                    return _this42.handleOnClick(l);
                  }
                }), l.title);
              }))) : null;
            }
          }], [{
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(l, s) {
              var c = l.value,
                  m = l.instanceId,
                  v = l.disableSuggestions,
                  _l$__experimentalShow = l.__experimentalShowInitialSuggestions,
                  _ = _l$__experimentalShow === void 0 ? !1 : _l$__experimentalShow,
                  k = s.showSuggestions,
                  y = k;

              var E = c && c.length;
              return _ || E || (y = !1), !0 === v && (y = !1), {
                showSuggestions: y,
                suggestionsListboxId: "block-editor-url-input-suggestions-".concat(m),
                suggestionOptionIdPrefix: "block-editor-url-input-suggestion-".concat(m)
              };
            }
          }]);

          return URLInput;
        }(v.Component);

        var V = (0, B.compose)(B.withSafeTimeout, S.withSpokenMessages, B.withInstanceId, (0, P.withSelect)(function (l, s) {
          if ((0, k.isFunction)(s.__experimentalFetchLinkSuggestions)) return;

          var _l135 = l(L.store),
              c = _l135.getSettings;

          return {
            __experimentalFetchLinkSuggestions: c().__experimentalFetchLinkSuggestions
          };
        }))(URLInput);
        s.default = V;
      },
      5073: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.__experimentalImageURLInputUI = void 0;

        var v = c(1753),
            _ = c(4793),
            k = c(6756),
            y = c(4892),
            E = c(2614),
            w = m(c(3390));

        var C = "none",
            S = "custom",
            B = "media",
            P = "attachment",
            O = ["noreferrer", "noopener"],
            L = (0, v.createElement)(y.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, v.createElement)(y.Path, {
          d: "M0,0h24v24H0V0z",
          fill: "none"
        }), (0, v.createElement)(y.Path, {
          d: "m19 5v14h-14v-14h14m0-2h-14c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2z"
        }), (0, v.createElement)(y.Path, {
          d: "m14.14 11.86l-3 3.87-2.14-2.59-3 3.86h12l-3.86-5.14z"
        }));

        s.__experimentalImageURLInputUI = function (l) {
          var s = l.linkDestination,
              c = l.onChangeUrl,
              m = l.url,
              _l$mediaType = l.mediaType,
              V = _l$mediaType === void 0 ? "image" : _l$mediaType,
              R = l.mediaUrl,
              A = l.mediaLink,
              z = l.linkTarget,
              D = l.linkClass,
              F = l.rel;

          var _ref343 = (0, v.useState)(!1),
              _ref344 = _slicedToArray(_ref343, 2),
              G = _ref344[0],
              U = _ref344[1],
              W = (0, v.useCallback)(function () {
            U(!0);
          }),
              _ref345 = (0, v.useState)(!1),
              _ref346 = _slicedToArray(_ref345, 2),
              K = _ref346[0],
              $ = _ref346[1],
              _ref347 = (0, v.useState)(null),
              _ref348 = _slicedToArray(_ref347, 2),
              q = _ref348[0],
              Y = _ref348[1],
              Z = (0, v.useRef)(null),
              X = (0, v.useCallback)(function () {
            s !== B && s !== P || Y(""), $(!0);
          }),
              Q = (0, v.useCallback)(function () {
            $(!1);
          }),
              J = (0, v.useCallback)(function () {
            Y(null), Q(), U(!1);
          }),
              removeNewTabRel = function removeNewTabRel(l) {
            var s = l;
            return void 0 === l || (0, _.isEmpty)(s) || (0, _.isEmpty)(s) || ((0, _.each)(O, function (l) {
              var c = new RegExp("\\b" + l + "\\b", "gi");
              s = s.replace(c, "");
            }), s !== l && (s = s.trim()), (0, _.isEmpty)(s) && (s = void 0)), s;
          },
              ee = (0, v.useCallback)(function () {
            return function (l) {
              var s = Z.current;
              s && s.contains(l.target) || (U(!1), Y(null), Q());
            };
          }),
              te = (0, v.useCallback)(function () {
            return function (l) {
              if (q) {
                var s;

                var _l136 = (null === (s = getLinkDestinations().find(function (l) {
                  return l.url === q;
                })) || void 0 === s ? void 0 : s.linkDestination) || S;

                c({
                  href: q,
                  linkDestination: _l136
                });
              }

              Q(), Y(null), l.preventDefault();
            };
          }),
              ne = (0, v.useCallback)(function () {
            c({
              linkDestination: C,
              href: ""
            });
          }),
              getLinkDestinations = function getLinkDestinations() {
            var l = [{
              linkDestination: B,
              title: (0, k.__)("Media File"),
              url: "image" === V ? R : void 0,
              icon: L
            }];
            return "image" === V && A && l.push({
              linkDestination: P,
              title: (0, k.__)("Attachment Page"),
              url: "image" === V ? A : void 0,
              icon: (0, v.createElement)(y.SVG, {
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, (0, v.createElement)(y.Path, {
                d: "M0 0h24v24H0V0z",
                fill: "none"
              }), (0, v.createElement)(y.Path, {
                d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"
              }))
            }), l;
          },
              oe = (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.ToggleControl, {
            label: (0, k.__)("Open in new tab"),
            onChange: function onChange(l) {
              var s = function (l) {
                var s = l ? "_blank" : void 0;
                var c;
                return c = s || F ? removeNewTabRel(F) : void 0, {
                  linkTarget: s,
                  rel: c
                };
              }(l);

              c(s);
            },
            checked: "_blank" === z
          }), (0, v.createElement)(y.TextControl, {
            label: (0, k.__)("Link Rel"),
            value: removeNewTabRel(F) || "",
            onChange: function onChange(l) {
              c({
                rel: l
              });
            }
          }), (0, v.createElement)(y.TextControl, {
            label: (0, k.__)("Link CSS Class"),
            value: D || "",
            onChange: function onChange(l) {
              c({
                linkClass: l
              });
            }
          })),
              re = null !== q ? q : m,
              le = ((0, _.find)(getLinkDestinations(), ["linkDestination", s]) || {}).title;

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.ToolbarButton, {
            icon: E.link,
            className: "components-toolbar__control",
            label: m ? (0, k.__)("Edit link") : (0, k.__)("Insert link"),
            "aria-expanded": G,
            onClick: W
          }), G && (0, v.createElement)(w.default, {
            onFocusOutside: ee(),
            onClose: J,
            renderSettings: function renderSettings() {
              return oe;
            },
            additionalControls: !re && (0, v.createElement)(y.NavigableMenu, null, (0, _.map)(getLinkDestinations(), function (l) {
              return (0, v.createElement)(y.MenuItem, {
                key: l.linkDestination,
                icon: l.icon,
                onClick: function onClick() {
                  Y(null), function (l) {
                    var s = getLinkDestinations();
                    var m;
                    m = l ? ((0, _.find)(s, function (s) {
                      return s.url === l;
                    }) || {
                      linkDestination: S
                    }).linkDestination : C, c({
                      linkDestination: m,
                      href: l
                    });
                  }(l.url), Q();
                }
              }, l.title);
            }))
          }, (!m || K) && (0, v.createElement)(w.default.LinkEditor, {
            className: "block-editor-format-toolbar__link-container-content",
            value: re,
            onChangeInputValue: Y,
            onSubmit: te(),
            autocompleteRef: Z
          }), m && !K && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(w.default.LinkViewer, {
            className: "block-editor-format-toolbar__link-container-content",
            url: m,
            onEditLinkClick: X,
            urlLabel: le
          }), (0, v.createElement)(y.Button, {
            icon: E.close,
            label: (0, k.__)("Remove link"),
            onClick: ne
          }))));
        };
      },
      3390: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(6756),
            y = c(4892),
            E = c(2614),
            w = m(c(7315)),
            C = m(c(6920));

        function URLPopover(l) {
          var s = l.additionalControls,
              c = l.children,
              m = l.renderSettings,
              _l$position = l.position,
              w = _l$position === void 0 ? "bottom center" : _l$position,
              _l$focusOnMount = l.focusOnMount,
              C = _l$focusOnMount === void 0 ? "firstElement" : _l$focusOnMount,
              S = _objectWithoutProperties(l, _excluded40);

          var _ref349 = (0, v.useState)(!1),
              _ref350 = _slicedToArray(_ref349, 2),
              B = _ref350[0],
              P = _ref350[1],
              O = !!m && B;

          return (0, v.createElement)(y.Popover, (0, _.default)({
            className: "block-editor-url-popover",
            focusOnMount: C,
            position: w
          }, S), (0, v.createElement)("div", {
            className: "block-editor-url-popover__input-container"
          }, (0, v.createElement)("div", {
            className: "block-editor-url-popover__row"
          }, c, !!m && (0, v.createElement)(y.Button, {
            className: "block-editor-url-popover__settings-toggle",
            icon: E.chevronDown,
            label: (0, k.__)("Link settings"),
            onClick: function onClick() {
              P(!B);
            },
            "aria-expanded": B
          })), O && (0, v.createElement)("div", {
            className: "block-editor-url-popover__row block-editor-url-popover__settings"
          }, m())), s && !O && (0, v.createElement)("div", {
            className: "block-editor-url-popover__additional-controls"
          }, s));
        }

        URLPopover.LinkEditor = C.default, URLPopover.LinkViewer = w.default;
        var S = URLPopover;
        s.default = S;
      },
      6920: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LinkEditor(l) {
          var s = l.autocompleteRef,
              c = l.className,
              m = l.onChangeInputValue,
              S = l.value,
              B = _objectWithoutProperties(l, _excluded41);

          return (0, v.createElement)("form", (0, _.default)({
            className: (0, k.default)("block-editor-url-popover__link-editor", c)
          }, B), (0, v.createElement)(C.default, {
            value: S,
            onChange: m,
            autocompleteRef: s
          }), (0, v.createElement)(E.Button, {
            icon: w.keyboardReturn,
            label: (0, y.__)("Apply"),
            type: "submit"
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(6756),
            E = c(4892),
            w = c(2614),
            C = m(c(5852));
      },
      7540: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LinkViewerURL(l) {
          var s = l.url,
              c = l.urlLabel,
              m = l.className;
          var E = (0, _.default)(m, "block-editor-url-popover__link-viewer-url");
          if (!s) return (0, v.createElement)("span", {
            className: E
          });
          return (0, v.createElement)(k.ExternalLink, {
            className: E,
            href: s
          }, c || (0, y.filterURLForDisplay)((0, y.safeDecodeURI)(s)));
        };

        var v = c(1753),
            _ = m(c(2703)),
            k = c(4892),
            y = c(904);
      },
      7315: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function LinkViewer(l) {
          var s = l.className,
              c = l.linkClassName,
              m = l.onEditLinkClick,
              S = l.url,
              B = l.urlLabel,
              P = _objectWithoutProperties(l, _excluded42);

          return (0, v.createElement)("div", (0, _.default)({
            className: (0, k.default)("block-editor-url-popover__link-viewer", s)
          }, P), (0, v.createElement)(C.default, {
            url: S,
            urlLabel: B,
            className: c
          }), m && (0, v.createElement)(E.Button, {
            icon: w.edit,
            label: (0, y.__)("Edit"),
            onClick: m
          }));
        };

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(6756),
            E = c(4892),
            w = c(2614),
            C = m(c(7540));
      },
      139: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useBlockDisplayInformation(l) {
          return (0, m.useSelect)(function (s) {
            if (!l) return null;

            var _s59 = s(_.store),
                c = _s59.getBlockName,
                m = _s59.getBlockAttributes,
                _s60 = s(v.store),
                k = _s60.getBlockType,
                y = _s60.getActiveBlockVariation,
                E = c(l),
                w = k(E);

            if (!w) return null;
            var C = m(l),
                S = y(E, C),
                B = {
              title: w.title,
              icon: w.icon,
              description: w.description,
              anchor: null == C ? void 0 : C.anchor
            };
            return S ? {
              title: S.title || w.title,
              icon: S.icon || w.icon,
              description: S.description || w.description
            } : B;
          }, [l]);
        };

        var m = c(8467),
            v = c(6700),
            _ = c(8486);
      },
      9522: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useBlockDropZone() {
          var _ref351 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              _ref351$rootClientId = _ref351.rootClientId,
              l = _ref351$rootClientId === void 0 ? "" : _ref351$rootClientId;

          var _ref352 = (0, _.useState)(null),
              _ref353 = _slicedToArray(_ref352, 2),
              s = _ref353[0],
              c = _ref353[1],
              m = (0, v.useSelect)(function (s) {
            var _s61 = s(C.store),
                c = _s61.getTemplateLock;

            return "all" === c(l);
          }, [l]),
              _ref354 = (0, v.useSelect)(C.store),
              y = _ref354.getBlockListSettings,
              _ref355 = (0, v.useDispatch)(C.store),
              w = _ref355.showInsertionPoint,
              S = _ref355.hideInsertionPoint,
              B = (0, E.default)(l, s),
              P = (0, k.useThrottle)((0, _.useCallback)(function (s, m) {
            var v;

            var _ = getNearestBlockIndex(Array.from(m.children).filter(function (l) {
              return l.classList.contains("wp-block");
            }), {
              x: s.clientX,
              y: s.clientY
            }, null === (v = y(l)) || void 0 === v ? void 0 : v.orientation);

            c(void 0 === _ ? 0 : _), null !== _ && w(l, _);
          }, []), 200);

          return (0, k.__experimentalUseDropZone)({
            isDisabled: m,
            onDrop: B,
            onDragOver: function onDragOver(l) {
              P(l, l.currentTarget);
            },
            onDragLeave: function onDragLeave() {
              P.cancel(), S(), c(null);
            },
            onDragEnd: function onDragEnd() {
              P.cancel(), S(), c(null);
            }
          });
        }, s.getNearestBlockIndex = getNearestBlockIndex;

        var v = c(8467),
            _ = c(1753),
            k = c(3200),
            y = c(6756),
            E = m(c(6507)),
            w = c(4712),
            C = c(8486);

        function getNearestBlockIndex(l, s, c) {
          var m = "horizontal" === c ? ["left", "right"] : ["top", "bottom"],
              v = (0, y.isRTL)();

          var _, k;

          return l.forEach(function (l, c) {
            var y = l.getBoundingClientRect(),
                _ref356 = (0, w.getDistanceToNearestEdge)(s, y, m),
                _ref357 = _slicedToArray(_ref356, 2),
                E = _ref357[0],
                C = _ref357[1];

            if (void 0 === k || E < k) {
              k = E, _ = c + ("bottom" === C || !v && "right" === C || v && "left" === C ? 1 : 0);
            }
          }), _;
        }
      },
      1228: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useCanvasClickRedirect = function useCanvasClickRedirect() {
          return (0, v.useRefEffect)(function (l) {
            function onMouseDown(s) {
              if (s.target !== l) return;

              var c = _.focus.focusable.find(l),
                  v = (0, m.findLast)(c, k);

              if (!v) return;

              var _v$getBoundingClientR = v.getBoundingClientRect(),
                  y = _v$getBoundingClientR.bottom;

              s.clientY < y || ((0, _.placeCaretAtHorizontalEdge)(v, !0), s.preventDefault());
            }

            return l.addEventListener("mousedown", onMouseDown), function () {
              l.addEventListener("mousedown", onMouseDown);
            };
          }, []);
        };

        var m = c(4793),
            v = c(3200),
            _ = c(5480);

        var k = (0, m.overEvery)([_.isTextField, _.focus.tabbable.isTabbableIndex]);
      },
      7706: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useDisplayBlockControls() {
          var _ref358 = (0, v.useBlockEditContext)(),
              l = _ref358.isSelected,
              s = _ref358.clientId,
              c = _ref358.name;

          return (0, m.useSelect)(function (m) {
            if (l) return !0;

            var _m35 = m(_.store),
                v = _m35.getBlockName,
                k = _m35.isFirstMultiSelectedBlock,
                y = _m35.getMultiSelectedBlockClientIds;

            return !!k(s) && y().every(function (l) {
              return v(l) === c;
            });
          }, [s, l, c]);
        };

        var m = c(8467),
            v = c(7310),
            _ = c(8486);
      },
      9322: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var m = c(5029),
            v = c(1753),
            _ = c(3200),
            k = c(5480);

        var counterReducer = function counterReducer(l) {
          return l + 1;
        },
            getAbsolutePosition = function getAbsolutePosition(l) {
          return {
            top: l.offsetTop,
            left: l.offsetLeft
          };
        };

        var y = function useMovingAnimation(l) {
          var s = l.isSelected,
              c = l.adjustScrolling,
              y = l.enableAnimation,
              E = l.triggerAnimationOnChange;

          var w = (0, v.useRef)(),
              C = (0, _.useReducedMotion)() || !y,
              _ref359 = (0, v.useReducer)(counterReducer, 0),
              _ref360 = _slicedToArray(_ref359, 2),
              S = _ref360[0],
              B = _ref360[1],
              _ref361 = (0, v.useReducer)(counterReducer, 0),
              _ref362 = _slicedToArray(_ref361, 2),
              P = _ref362[0],
              O = _ref362[1],
              _ref363 = (0, v.useState)({
            x: 0,
            y: 0
          }),
              _ref364 = _slicedToArray(_ref363, 2),
              L = _ref364[0],
              V = _ref364[1],
              R = (0, v.useMemo)(function () {
            return w.current ? getAbsolutePosition(w.current) : null;
          }, [E]),
              A = (0, v.useMemo)(function () {
            if (!c || !w.current) return function () {};
            var l = (0, k.getScrollContainer)(w.current);
            if (!l) return function () {};
            var s = w.current.getBoundingClientRect();
            return function () {
              var c = w.current.getBoundingClientRect().top - s.top;
              c && (l.scrollTop += c);
            };
          }, [E, c]);

          function onChange(l) {
            var c = l.value,
                m = c.x,
                v = c.y;
            m = Math.round(m), v = Math.round(v), m === onChange.x && v === onChange.y || (!function onFrameChange(l) {
              var c = l.x,
                  m = l.y;
              if (!w.current) return;
              var v = 0 === c && 0 === m;
              w.current.style.transformOrigin = v ? "" : "center", w.current.style.transform = v ? "" : "translate3d(".concat(c, "px,").concat(m, "px,0)"), w.current.style.zIndex = !s || v ? "" : "1", A();
            }({
              x: m,
              y: v
            }), onChange.x = m, onChange.y = v);
          }

          return (0, v.useLayoutEffect)(function () {
            S && O();
          }, [S]), (0, v.useLayoutEffect)(function () {
            if (!R) return;
            if (C) return void A();
            w.current.style.transform = "";
            var l = getAbsolutePosition(w.current);
            B(), V({
              x: Math.round(R.left - l.left),
              y: Math.round(R.top - l.top)
            });
          }, [E]), onChange.x = 0, onChange.y = 0, (0, m.useSpring)({
            from: {
              x: L.x,
              y: L.y
            },
            to: {
              x: 0,
              y: 0
            },
            reset: S !== P,
            config: {
              mass: 5,
              tension: 2e3,
              friction: 200
            },
            immediate: C,
            onChange: onChange
          }), w;
        };

        s.default = y;
      },
      7273: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useNoRecursiveRenders(l) {
          var s;
          var c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";

          var k = (0, m.useContext)(_),
              _ref365 = (0, v.useBlockEditContext)(),
              y = _ref365.name;

          c = c || y;
          var E = Boolean(null === (s = k[c]) || void 0 === s ? void 0 : s.has(l)),
              w = (0, m.useMemo)(function () {
            return addToBlockType(k, c, l);
          }, [k, c, l]),
              C = (0, m.useCallback)(function (l) {
            var s = l.children;
            return (0, m.createElement)(_.Provider, {
              value: w
            }, s);
          }, [w]);
          return [E, C];
        };
        var m = c(1753),
            v = c(7310);

        var _ = (0, m.createContext)({});

        function addToBlockType(l, s, c) {
          var m = _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, s, l[s] ? new Set(l[s]) : new Set()));

          return m[s].add(c), m;
        }
      },
      6507: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useOnBlockDrop(l, s) {
          var c = (0, v.useSelect)(function (l) {
            return l(k.store).getSettings().mediaUpload;
          }, []),
              _ref366 = (0, v.useSelect)(k.store),
              m = _ref366.canInsertBlockType,
              y = _ref366.getBlockIndex,
              E = _ref366.getClientIdsOfDescendants,
              _ref367 = (0, v.useDispatch)(k.store),
              w = _ref367.insertBlocks,
              C = _ref367.moveBlocksToPosition,
              S = _ref367.updateBlockAttributes,
              B = _ref367.clearSelectedBlock,
              P = onBlockDrop(l, s, y, E, C, w, B),
              O = onFilesDrop(l, s, c, S, m, w),
              L = onHTMLDrop(l, s, w);

          return function (l) {
            var s = (0, _.getFilesFromDataTransfer)(l.dataTransfer),
                c = l.dataTransfer.getData("text/html");
            s.length ? O(s) : c ? L(c) : P(l);
          };
        }, s.onBlockDrop = onBlockDrop, s.onFilesDrop = onFilesDrop, s.onHTMLDrop = onHTMLDrop, s.parseDropEvent = parseDropEvent;

        var m = c(6700),
            v = c(8467),
            _ = c(5480),
            k = c(8486);

        function parseDropEvent(l) {
          var s = {
            srcRootClientId: null,
            srcClientIds: null,
            srcIndex: null,
            type: null,
            blocks: null
          };
          if (!l.dataTransfer) return s;

          try {
            s = Object.assign(s, JSON.parse(l.dataTransfer.getData("wp-blocks")));
          } catch (l) {
            return s;
          }

          return s;
        }

        function onBlockDrop(l, s, c, v, _, k, y) {
          return function (E) {
            var _parseDropEvent = parseDropEvent(E),
                w = _parseDropEvent.srcRootClientId,
                C = _parseDropEvent.srcClientIds,
                S = _parseDropEvent.type,
                B = _parseDropEvent.blocks;

            if ("inserter" === S) {
              y();

              var _c42 = B.map(function (l) {
                return (0, m.cloneBlock)(l);
              });

              k(_c42, s, l, !0, null);
            }

            if ("block" === S) {
              var _m36 = c(C[0]);

              if (w === l && _m36 === s) return;
              if (C.includes(l) || v(C).some(function (s) {
                return s === l;
              })) return;

              var _k8 = w === l,
                  _y6 = C.length;

              _(C, w, l, _k8 && _m36 < s ? s - _y6 : s);
            }
          };
        }

        function onFilesDrop(l, s, c, v, _, k) {
          return function (y) {
            if (!c) return;
            var E = (0, m.findTransform)((0, m.getBlockTransforms)("from"), function (s) {
              return "files" === s.type && _(s.blockName, l) && s.isMatch(y);
            });

            if (E) {
              var _c43 = E.transform(y, v);

              k(_c43, s, l);
            }
          };
        }

        function onHTMLDrop(l, s, c) {
          return function (v) {
            var _ = (0, m.pasteHandler)({
              HTML: v,
              mode: "BLOCKS"
            });

            _.length && c(_, s, l);
          };
        }
      },
      9458: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useResizeCanvas(l) {
          var _ref368 = (0, m.useState)(window.innerWidth),
              _ref369 = _slicedToArray(_ref368, 2),
              s = _ref369[0],
              c = _ref369[1];

          (0, m.useEffect)(function () {
            if ("Desktop" === l) return;

            var resizeListener = function resizeListener() {
              return c(window.innerWidth);
            };

            return window.addEventListener("resize", resizeListener), function () {
              window.removeEventListener("resize", resizeListener);
            };
          }, [l]);

          var getCanvasWidth = function getCanvasWidth(l) {
            var c;

            switch (l) {
              case "Tablet":
                c = 780;
                break;

              case "Mobile":
                c = 360;
                break;

              default:
                return null;
            }

            return c < s ? c : s;
          };

          return function (l) {
            var s = "Mobile" === l ? "768px" : "1024px";

            switch (l) {
              case "Tablet":
              case "Mobile":
                return {
                  width: getCanvasWidth(l),
                  margin: (window.innerHeight < 800 ? 36 : 72) + "px auto",
                  height: s,
                  borderRadius: "2px 2px 2px 2px",
                  border: "1px solid #ddd",
                  overflowY: "auto"
                };

              default:
                return null;
            }
          }(l);
        };
        var m = c(1753);
      },
      3081: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useSetting(l) {
          var _ref370 = (0, k.useBlockEditContext)(),
              s = _ref370.name;

          return (0, v.useSelect)(function (c) {
            var v;
            if (E.includes(l)) return void console.warn("Top level useSetting paths are disabled. Please use a subpath to query the information needed.");

            var k = c(y.store).getSettings(),
                S = function (l) {
              return C[l] || l;
            }(l),
                B = "__experimentalFeatures.".concat(S),
                P = "__experimentalFeatures.blocks.".concat(s, ".").concat(S),
                O = null !== (v = (0, m.get)(k, P)) && void 0 !== v ? v : (0, m.get)(k, B);

            var L, V;
            if (void 0 !== O) return _.__EXPERIMENTAL_PATHS_WITH_MERGE[S] ? null !== (L = null !== (V = O.custom) && void 0 !== V ? V : O.theme) && void 0 !== L ? L : O.default : O;
            var R = w[S] ? w[S](k) : void 0;
            return void 0 !== R ? R : "typography.dropCap" === S || void 0;
          }, [s, l]);
        };

        var m = c(4793),
            v = c(8467),
            _ = c(6700),
            k = c(5490),
            y = c(8486);

        var E = ["color", "border", "typography", "spacing"],
            w = {
          "color.palette": function colorPalette(l) {
            return void 0 === l.colors ? void 0 : l.colors;
          },
          "color.gradients": function colorGradients(l) {
            return void 0 === l.gradients ? void 0 : l.gradients;
          },
          "color.custom": function colorCustom(l) {
            return void 0 === l.disableCustomColors ? void 0 : !l.disableCustomColors;
          },
          "color.customGradient": function colorCustomGradient(l) {
            return void 0 === l.disableCustomGradients ? void 0 : !l.disableCustomGradients;
          },
          "typography.fontSizes": function typographyFontSizes(l) {
            return void 0 === l.fontSizes ? void 0 : l.fontSizes;
          },
          "typography.customFontSize": function typographyCustomFontSize(l) {
            return void 0 === l.disableCustomFontSizes ? void 0 : !l.disableCustomFontSizes;
          },
          "typography.lineHeight": function typographyLineHeight(l) {
            return l.enableCustomLineHeight;
          },
          "spacing.units": function spacingUnits(l) {
            if (void 0 !== l.enableCustomUnits) return !0 === l.enableCustomUnits ? ["px", "em", "rem", "vh", "vw", "%"] : l.enableCustomUnits;
          },
          "spacing.padding": function spacingPadding(l) {
            return l.enableCustomSpacing;
          }
        },
            C = {
          "border.customColor": "border.color",
          "border.customStyle": "border.style",
          "border.customWidth": "border.width",
          "typography.customFontStyle": "typography.fontStyle",
          "typography.customFontWeight": "typography.fontWeight",
          "typography.customLetterSpacing": "typography.letterSpacing",
          "typography.customTextDecorations": "typography.textDecoration",
          "typography.customTextTransforms": "typography.textTransform",
          "border.customRadius": "border.radius",
          "spacing.customMargin": "spacing.margin",
          "spacing.customPadding": "spacing.padding",
          "typography.customLineHeight": "typography.lineHeight"
        };
      },
      4578: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(4892),
            y = c(6756),
            E = c(2614);

        var w = function Warning(l) {
          var s = l.className,
              c = l.actions,
              m = l.children,
              w = l.secondaryActions;
          return (0, v.createElement)("div", {
            className: (0, _.default)(s, "block-editor-warning")
          }, (0, v.createElement)("div", {
            className: "block-editor-warning__contents"
          }, (0, v.createElement)("p", {
            className: "block-editor-warning__message"
          }, m), (v.Children.count(c) > 0 || w) && (0, v.createElement)("div", {
            className: "block-editor-warning__actions"
          }, v.Children.count(c) > 0 && v.Children.map(c, function (l, s) {
            return (0, v.createElement)("span", {
              key: s,
              className: "block-editor-warning__action"
            }, l);
          }), w && (0, v.createElement)(k.DropdownMenu, {
            className: "block-editor-warning__secondary",
            icon: E.moreHorizontal,
            label: (0, y.__)("More options"),
            popoverProps: {
              position: "bottom left",
              className: "block-editor-warning__dropdown"
            },
            noIcons: !0
          }, function () {
            return (0, v.createElement)(k.MenuGroup, null, w.map(function (l, s) {
              return (0, v.createElement)(k.MenuItem, {
                onClick: l.onClick,
                key: s
              }, l.title);
            }));
          }))));
        };

        s.default = w;
      },
      2678: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0, s.useWritingFlow = useWritingFlow;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(8467),
            E = c(6756),
            w = c(3200),
            C = m(c(9596)),
            S = m(c(5885)),
            B = m(c(7751)),
            P = m(c(5456)),
            O = c(8486);

        function useWritingFlow() {
          var _ref371 = (0, S.default)(),
              _ref372 = _slicedToArray(_ref371, 3),
              l = _ref372[0],
              s = _ref372[1],
              c = _ref372[2],
              m = (0, y.useSelect)(function (l) {
            return l(O.store).hasMultiSelection();
          }, []);

          return [l, (0, w.useMergeRefs)([s, (0, C.default)(), (0, P.default)(), (0, B.default)(), (0, w.useRefEffect)(function (l) {
            if (l.tabIndex = -1, m) return l.setAttribute("aria-label", (0, E.__)("Multiple selected blocks")), function () {
              l.removeAttribute("aria-label");
            };
          }, [m])]), c];
        }

        var L = (0, v.forwardRef)(function WritingFlow(l, s) {
          var c = l.children,
              m = _objectWithoutProperties(l, _excluded43);

          var _useWritingFlow = useWritingFlow(),
              _useWritingFlow2 = _slicedToArray(_useWritingFlow, 3),
              y = _useWritingFlow2[0],
              E = _useWritingFlow2[1],
              C = _useWritingFlow2[2];

          return (0, v.createElement)(v.Fragment, null, y, (0, v.createElement)("div", (0, _.default)({}, m, {
            ref: (0, w.useMergeRefs)([E, s]),
            className: (0, k.default)(m.className, "block-editor-writing-flow")
          }), c), C);
        });
        s.default = L;
      },
      7751: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useArrowNav() {
          var _ref373 = (0, k.useSelect)(w.store),
              l = _ref373.getSelectedBlockClientId,
              s = _ref373.getMultiSelectedBlocksStartClientId,
              c = _ref373.getMultiSelectedBlocksEndClientId,
              m = _ref373.getPreviousBlockClientId,
              C = _ref373.getNextBlockClientId,
              S = _ref373.getFirstMultiSelectedBlockClientId,
              B = _ref373.getLastMultiSelectedBlockClientId,
              P = _ref373.getSettings,
              O = _ref373.hasMultiSelection,
              _ref374 = (0, k.useDispatch)(w.store),
              L = _ref374.multiSelect,
              V = _ref374.selectBlock;

          return (0, y.useRefEffect)(function (k) {
            var y;

            function onMouseDown() {
              y = null;
            }

            function expandSelection(v) {
              var _ = l(),
                  k = s(),
                  y = c(),
                  E = m(y || _),
                  w = C(y || _),
                  S = v ? E : w;

              S && (k === S ? V(S) : L(k || _, S));
            }

            function moveSelection(l) {
              var s = S(),
                  c = B(),
                  m = l ? s : c;
              m && V(m);
            }

            function onKeyDown(s) {
              var w = s.keyCode,
                  S = s.target,
                  B = w === _.UP,
                  L = w === _.DOWN,
                  V = w === _.LEFT,
                  R = w === _.RIGHT,
                  A = B || V,
                  z = V || R,
                  D = B || L,
                  F = z || D,
                  G = s.shiftKey,
                  U = G || s.ctrlKey || s.altKey || s.metaKey,
                  W = D ? v.isVerticalEdge : v.isHorizontalEdge,
                  K = k.ownerDocument,
                  $ = K.defaultView;

              if (O()) {
                if (F) {
                  (G ? expandSelection : moveSelection)(A), s.preventDefault();
                }

                return;
              }

              if (D ? y || (y = (0, v.computeCaretRect)($)) : y = null, s.defaultPrevented) return;
              if (!F) return;
              if (!isNavigationCandidate(S, w, U)) return;

              var q = (0, v.isRTL)(S) ? !A : A,
                  _P = P(),
                  Y = _P.keepCaretInsideBlock,
                  Z = l();

              if (G) {
                var _l137 = c(),
                    _v19 = m(_l137 || Z),
                    _8 = C(_l137 || Z);

                (A && _v19 || !A && _8) && function isTabbableEdge(l, s) {
                  var c = getClosestTabbable(l, s, k);
                  return !c || !(0, E.isInSameBlock)(l, c);
                }(S, A) && W(S, A) && (expandSelection(A), s.preventDefault());
              } else if (D && (0, v.isVerticalEdge)(S, A) && !Y) {
                var _l138 = getClosestTabbable(S, A, k, !0);

                _l138 && ((0, v.placeCaretAtVerticalEdge)(_l138, A, y), s.preventDefault());
              } else if (z && $.getSelection().isCollapsed && (0, v.isHorizontalEdge)(S, q) && !Y) {
                var _l139 = getClosestTabbable(S, q, k);

                (0, v.placeCaretAtHorizontalEdge)(_l139, A), s.preventDefault();
              }
            }

            return k.addEventListener("mousedown", onMouseDown), k.addEventListener("keydown", onKeyDown), function () {
              k.removeEventListener("mousedown", onMouseDown), k.removeEventListener("keydown", onKeyDown);
            };
          }, []);
        }, s.getClosestTabbable = getClosestTabbable, s.isNavigationCandidate = isNavigationCandidate;

        var m = c(4793),
            v = c(5480),
            _ = c(9880),
            k = c(8467),
            y = c(3200),
            E = c(9040),
            w = c(8486);

        function isNavigationCandidate(l, s, c) {
          if ((s === _.UP || s === _.DOWN) && !c) return !0;
          var m = l.tagName;
          return "INPUT" !== m && "TEXTAREA" !== m;
        }

        function getClosestTabbable(l, s, c, _) {
          var k,
              y = v.focus.focusable.find(c);
          return s && (y = (0, m.reverse)(y)), y = y.slice(y.indexOf(l) + 1), _ && (k = l.getBoundingClientRect()), (0, m.find)(y, function isTabCandidate(l) {
            if (!v.focus.tabbable.isTabbableIndex(l)) return !1;
            if (l.isContentEditable && "true" !== l.contentEditable) return !1;

            if (_) {
              var _s62 = l.getBoundingClientRect();

              if (_s62.left >= k.right || _s62.right <= k.left) return !1;
            }

            return !0;
          });
        }
      },
      9596: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useMultiSelection() {
          var _ref375 = (0, _.useSelect)(selector, []),
              l = _ref375.isMultiSelecting,
              s = _ref375.multiSelectedBlockClientIds,
              c = _ref375.hasMultiSelection,
              k = _ref375.selectedBlockClientId,
              E = (0, y.__unstableUseBlockRef)(k),
              w = (0, y.__unstableUseBlockRef)((0, m.first)(s)),
              C = (0, y.__unstableUseBlockRef)((0, m.last)(s));

          return (0, v.useRefEffect)(function (m) {
            var v = m.ownerDocument,
                _ = v.defaultView;

            if (!c || l) {
              if (!k || l) return;

              var _s63 = _.getSelection();

              if (_s63.rangeCount && !_s63.isCollapsed) {
                var _l140 = E.current,
                    _s63$getRangeAt = _s63.getRangeAt(0),
                    _c44 = _s63$getRangeAt.startContainer,
                    _m37 = _s63$getRangeAt.endContainer;

                !_l140 || _l140.contains(_c44) && _l140.contains(_m37) || _s63.removeAllRanges();
              }

              return;
            }

            var y = s.length;
            if (y < 2) return;
            if (!w.current || !C.current) return;
            m.focus();

            var S = _.getSelection(),
                B = v.createRange(),
                P = getDeepestNode(w.current, "start"),
                O = getDeepestNode(C.current, "end");

            !function toggleRichText(l, s) {
              Array.from(l.querySelectorAll(".rich-text")).forEach(function (l) {
                s ? l.setAttribute("contenteditable", !0) : l.removeAttribute("contenteditable");
              });
            }(m, !1), B.setStartBefore(P), B.setEndAfter(O), S.removeAllRanges(), S.addRange(B);
          }, [c, l, s, k]);
        };

        var m = c(4793),
            v = c(3200),
            _ = c(8467),
            k = c(8486),
            y = c(8882);

        function getDeepestNode(l, s) {
          var c = "start" === s ? "firstChild" : "lastChild",
              m = "start" === s ? "nextSibling" : "previousSibling";

          for (; l[c];) {
            for (l = l[c]; l.nodeType === l.TEXT_NODE && /^[ \t\n]*$/.test(l.data) && l[m];) {
              l = l[m];
            }
          }

          return l;
        }

        function selector(l) {
          var _l141 = l(k.store),
              s = _l141.isMultiSelecting,
              c = _l141.getMultiSelectedBlockClientIds,
              m = _l141.hasMultiSelection,
              v = _l141.getSelectedBlockClientId;

          return {
            isMultiSelecting: s(),
            multiSelectedBlockClientIds: c(),
            hasMultiSelection: m(),
            selectedBlockClientId: v()
          };
        }
      },
      5456: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useSelectAll() {
          var _ref376 = (0, _.useSelect)(E.store),
              l = _ref376.getBlockOrder,
              s = _ref376.getSelectedBlockClientIds,
              c = _ref376.getBlockRootClientId,
              _ref377 = (0, _.useDispatch)(E.store),
              w = _ref377.multiSelect,
              C = (0, k.__unstableUseShortcutEventMatch)();

          return (0, y.useRefEffect)(function (_) {
            function onKeyDown(_) {
              if (!C("core/block-editor/select-all", _)) return;
              if (!(0, v.isEntirelySelected)(_.target)) return;

              var k = s(),
                  _k9 = _slicedToArray(k, 1),
                  y = _k9[0],
                  E = c(y);

              var S = l(E);
              k.length === S.length && (S = l(c(E)));
              var B = (0, m.first)(S),
                  P = (0, m.last)(S);
              B !== P && (w(B, P), _.preventDefault());
            }

            return _.addEventListener("keydown", onKeyDown), function () {
              _.removeEventListener("keydown", onKeyDown);
            };
          }, []);
        };

        var m = c(4793),
            v = c(5480),
            _ = c(8467),
            k = c(2470),
            y = c(3200),
            E = c(8486);
      },
      5885: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function useTabNav() {
          var l = (0, m.useRef)(),
              s = (0, m.useRef)(),
              c = (0, m.useRef)(),
              w = (0, m.useRef)(),
              _ref378 = (0, k.useSelect)(E.store),
              C = _ref378.hasMultiSelection,
              S = _ref378.getSelectedBlockClientId,
              B = _ref378.getBlockCount,
              _ref379 = (0, k.useDispatch)(E.store),
              P = _ref379.setNavigationMode,
              O = (0, k.useSelect)(function (l) {
            return l(E.store).isNavigationMode();
          }, []) ? void 0 : "0",
              L = (0, m.useRef)();

          function onFocusCapture(s) {
            if (L.current) L.current = null;else if (C()) l.current.focus();else if (S()) w.current.focus();else {
              P(!0);

              var _c45 = s.target.compareDocumentPosition(l.current) & s.target.DOCUMENT_POSITION_FOLLOWING ? "findNext" : "findPrevious";

              v.focus.tabbable[_c45](s.target).focus();
            }
          }

          var V = (0, m.createElement)("div", {
            ref: s,
            tabIndex: O,
            onFocus: onFocusCapture
          }),
              R = (0, m.createElement)("div", {
            ref: c,
            tabIndex: O,
            onFocus: onFocusCapture
          }),
              A = (0, y.useRefEffect)(function (m) {
            function onKeyDown(l) {
              if (l.defaultPrevented) return;
              if (l.keyCode === _.ESCAPE && !C()) return l.preventDefault(), void P(!0);
              if (l.keyCode !== _.TAB) return;
              var k = l.shiftKey,
                  y = k ? "findPrevious" : "findNext";
              if (!C() && !S()) return void (l.target === m && P(!0));
              if (isFormElement(l.target) && isFormElement(v.focus.tabbable[y](l.target))) return;
              var E = k ? s : c;
              L.current = !0, E.current.focus({
                preventScroll: !0
              });
            }

            function onFocusOut(l) {
              w.current = l.target;
              var s = m.ownerDocument;
              l.relatedTarget || s.activeElement !== s.body || 0 !== B() || m.focus();
            }

            function preventScrollOnTab(m) {
              var k;
              if (m.keyCode !== _.TAB) return;
              if ("region" === (null === (k = m.target) || void 0 === k ? void 0 : k.getAttribute("role"))) return;
              if (l.current === m.target) return;
              var y = m.shiftKey ? "findPrevious" : "findNext",
                  E = v.focus.tabbable[y](m.target);
              E !== s.current && E !== c.current || (m.preventDefault(), E.focus({
                preventScroll: !0
              }));
            }

            var k = m.ownerDocument,
                y = k.defaultView;
            return y.addEventListener("keydown", preventScrollOnTab), m.addEventListener("keydown", onKeyDown), m.addEventListener("focusout", onFocusOut), function () {
              y.removeEventListener("keydown", preventScrollOnTab), m.removeEventListener("keydown", onKeyDown), m.removeEventListener("focusout", onFocusOut);
            };
          }, []),
              z = (0, y.useMergeRefs)([l, A]);
          return [V, z, R];
        };

        var m = c(1753),
            v = c(5480),
            _ = c(9880),
            k = c(8467),
            y = c(3200),
            E = c(8486);

        function isFormElement(l) {
          var s = l.tagName;
          return "INPUT" === s || "BUTTON" === s || "SELECT" === s || "TEXTAREA" === s;
        }
      },
      2866: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.addAssignedAlign = addAssignedAlign, s.addAttribute = addAttribute, s.getValidAlignments = getValidAlignments, s.withToolbarControls = s.withDataAlign = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(4793),
            E = c(3200),
            w = c(1149),
            C = c(6700),
            S = c(6330),
            B = m(c(2856));

        var P = ["left", "center", "right", "wide", "full"],
            O = ["wide", "full"];

        function getValidAlignments(l) {
          var s,
              c = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
              m = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
          return s = Array.isArray(l) ? P.filter(function (s) {
            return l.includes(s);
          }) : !0 === l ? [].concat(P) : [], !m || !0 === l && !c ? (0, y.without).apply(void 0, [s].concat(O)) : s;
        }

        function addAttribute(l) {
          return (0, y.has)(l.attributes, ["align", "type"]) || (0, C.hasBlockSupport)(l, "align") && (l.attributes = _objectSpread(_objectSpread({}, l.attributes), {}, {
            align: {
              type: "string",
              enum: [].concat(P, [""])
            }
          })), l;
        }

        var L = (0, E.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c = s.name,
                m = getValidAlignments((0, C.getBlockSupport)(c, "align"), (0, C.hasBlockSupport)(c, "alignWide", !0)),
                _ = (0, B.default)(m).map(function (l) {
              var s = l.name;
              return s;
            });

            return (0, v.createElement)(v.Fragment, null, !!_.length && (0, v.createElement)(S.BlockControls, {
              group: "block",
              __experimentalShareWithChildBlocks: !0
            }, (0, v.createElement)(S.BlockAlignmentControl, {
              value: s.attributes.align,
              onChange: function onChange(l) {
                if (!l) {
                  var c, m;

                  var _v20 = (0, C.getBlockType)(s.name);

                  (null == _v20 || null === (c = _v20.attributes) || void 0 === c || null === (m = c.align) || void 0 === m ? void 0 : m.default) && (l = "");
                }

                s.setAttributes({
                  align: l
                });
              },
              controls: _
            })), (0, v.createElement)(l, s));
          };
        }, "withToolbarControls");
        s.withToolbarControls = L;
        var V = (0, E.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c = s.name,
                m = s.attributes,
                k = m.align,
                y = getValidAlignments((0, C.getBlockSupport)(c, "align"), (0, C.hasBlockSupport)(c, "alignWide", !0)),
                E = (0, B.default)(y);
            if (void 0 === k) return (0, v.createElement)(l, s);
            var w = s.wrapperProps;
            return E.some(function (l) {
              return l.name === k;
            }) && (w = _objectSpread(_objectSpread({}, w), {}, {
              "data-align": k
            })), (0, v.createElement)(l, (0, _.default)({}, s, {
              wrapperProps: w
            }));
          };
        });

        function addAssignedAlign(l, s, c) {
          var m = c.align;
          return getValidAlignments((0, C.getBlockSupport)(s, "align"), (0, C.hasBlockSupport)(s, "alignWide", !0)).includes(m) && (l.className = (0, k.default)("align".concat(m), l.className)), l;
        }

        s.withDataAlign = V, (0, w.addFilter)("blocks.registerBlockType", "core/align/addAttribute", addAttribute), (0, w.addFilter)("editor.BlockListBlock", "core/editor/align/with-data-align", V), (0, w.addFilter)("editor.BlockEdit", "core/editor/align/with-toolbar-controls", L), (0, w.addFilter)("blocks.getSaveContent.extraProps", "core/align/addAssignedAlign", addAssignedAlign);
      },
      3599: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.addAttribute = addAttribute, s.addSaveProps = addSaveProps, s.withInspectorControl = void 0;

        var m = c(1753),
            v = c(4793),
            _ = c(1149),
            k = c(4892),
            y = c(6756),
            E = c(6700),
            w = c(3200),
            C = c(6330);

        var S = /[\s#]/g;

        function addAttribute(l) {
          return (0, v.has)(l.attributes, ["anchor", "type"]) || (0, E.hasBlockSupport)(l, "anchor") && (l.attributes = _objectSpread(_objectSpread({}, l.attributes), {}, {
            anchor: {
              type: "string",
              source: "attribute",
              attribute: "id",
              selector: "*"
            }
          })), l;
        }

        var B = (0, w.createHigherOrderComponent)(function (l) {
          return function (s) {
            if ((0, E.hasBlockSupport)(s.name, "anchor") && s.isSelected) {
              var _c46 = "web" === m.Platform.OS,
                  _v21 = (0, m.createElement)(k.TextControl, {
                className: "html-anchor-control",
                label: (0, y.__)("HTML anchor"),
                help: (0, m.createElement)(m.Fragment, null, (0, y.__)("Enter a word or two — without spaces — to make a unique web address just for this block, called an “anchor.” Then, you’ll be able to link directly to this section of your page."), _c46 && (0, m.createElement)(k.ExternalLink, {
                  href: (0, y.__)("https://wordpress.org/support/article/page-jumps/")
                }, (0, y.__)("Learn more about anchors"))),
                value: s.attributes.anchor || "",
                placeholder: _c46 ? null : (0, y.__)("Add an anchor"),
                onChange: function onChange(l) {
                  l = l.replace(S, "-"), s.setAttributes({
                    anchor: l
                  });
                },
                autoCapitalize: "none",
                autoComplete: "off"
              });

              return (0, m.createElement)(m.Fragment, null, (0, m.createElement)(l, s), _c46 && (0, m.createElement)(C.InspectorControls, {
                __experimentalGroup: "advanced"
              }, _v21), !_c46 && "core/heading" === s.name && (0, m.createElement)(C.InspectorControls, null, (0, m.createElement)(k.PanelBody, {
                title: (0, y.__)("Heading settings")
              }, _v21)));
            }

            return (0, m.createElement)(l, s);
          };
        }, "withInspectorControl");

        function addSaveProps(l, s, c) {
          return (0, E.hasBlockSupport)(s, "anchor") && (l.id = "" === c.anchor ? null : c.anchor), l;
        }

        s.withInspectorControl = B, (0, _.addFilter)("blocks.registerBlockType", "core/anchor/attribute", addAttribute), (0, _.addFilter)("editor.BlockEdit", "core/editor/anchor/with-inspector-control", B), (0, _.addFilter)("blocks.getSaveContent.extraProps", "core/anchor/save-props", addSaveProps);
      },
      493: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BorderColorEdit = function BorderColorEdit(l) {
          var _l$attributes2 = l.attributes,
              s = _l$attributes2.borderColor,
              c = _l$attributes2.style,
              m = l.setAttributes,
              k = (0, S.default)(),
              y = k.colors.reduce(function (l, s) {
            return l.concat(s.colors);
          }, []),
              _ref380 = (0, v.useState)(function () {
            var l, m;
            return null === (l = (0, B.getColorObjectByAttributeValues)(y, s, null == c || null === (m = c.border) || void 0 === m ? void 0 : m.color)) || void 0 === l ? void 0 : l.color;
          }),
              _ref381 = _slicedToArray(_ref380, 2),
              w = _ref381[0],
              P = _ref381[1];

          return (0, v.createElement)(C.default, (0, _.default)({
            label: (0, E.__)("Color"),
            colorValue: w,
            onColorChange: function onColorChange(l) {
              P(l);

              var s = (0, B.getColorObjectByColorValue)(y, l),
                  v = _objectSpread(_objectSpread({}, c), {}, {
                border: _objectSpread(_objectSpread({}, null == c ? void 0 : c.border), {}, {
                  color: null != s && s.slug ? void 0 : l
                })
              }),
                  _ = null != s && s.slug ? s.slug : void 0;

              m({
                style: (0, L.cleanEmptyObject)(v),
                borderColor: _
              });
            },
            clearable: !1,
            __experimentalHasMultipleOrigins: !0,
            __experimentalIsRenderedInSidebar: !0
          }, k));
        }, s.withBorderColorPaletteStyles = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(1149),
            E = c(6756),
            w = c(3200),
            C = m(c(91)),
            S = m(c(26)),
            B = c(4459),
            P = m(c(3081)),
            O = c(8068),
            L = c(8241);

        var V = [];

        function addSaveProps(l, s, c) {
          var m;
          if (!(0, O.hasBorderSupport)(s, "color") || (0, O.shouldSkipSerialization)(s)) return l;
          var v = c.borderColor,
              _ = c.style,
              y = (0, B.getColorClassName)("border-color", v),
              E = (0, k.default)(l.className, _defineProperty({
            "has-border-color": v || (null == _ || null === (m = _.border) || void 0 === m ? void 0 : m.color)
          }, y, !!y));
          return l.className = E || void 0, l;
        }

        var R = (0, w.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c, m;
            var k = s.name,
                y = s.attributes,
                E = y.borderColor,
                w = (0, P.default)("color.palette") || V;
            if (!(0, O.hasBorderSupport)(k, "color") || (0, O.shouldSkipSerialization)(k)) return (0, v.createElement)(l, s);
            var C = {
              borderColor: E ? null === (c = (0, B.getColorObjectByAttributeValues)(w, E)) || void 0 === c ? void 0 : c.color : void 0
            };
            var S = s.wrapperProps;
            return S = _objectSpread(_objectSpread({}, s.wrapperProps), {}, {
              style: _objectSpread(_objectSpread({}, C), null === (m = s.wrapperProps) || void 0 === m ? void 0 : m.style)
            }), (0, v.createElement)(l, (0, _.default)({}, s, {
              wrapperProps: S
            }));
          };
        });
        s.withBorderColorPaletteStyles = R, (0, y.addFilter)("blocks.registerBlockType", "core/border/addAttributes", function addAttributes(l) {
          return (0, O.hasBorderSupport)(l, "color") ? l.attributes.borderColor ? l : _objectSpread(_objectSpread({}, l), {}, {
            attributes: _objectSpread(_objectSpread({}, l.attributes), {}, {
              borderColor: {
                type: "string"
              }
            })
          }) : l;
        }), (0, y.addFilter)("blocks.getSaveContent.extraProps", "core/border/addSaveProps", addSaveProps), (0, y.addFilter)("blocks.registerBlockType", "core/border/addEditProps", function addEditProps(l) {
          if (!(0, O.hasBorderSupport)(l, "color") || (0, O.shouldSkipSerialization)(l)) return l;
          var s = l.getEditWrapperProps;
          return l.getEditWrapperProps = function (c) {
            var m = {};
            return s && (m = s(c)), addSaveProps(m, l, c);
          }, l;
        }), (0, y.addFilter)("editor.BlockListBlock", "core/border/with-border-color-palette-styles", R);
      },
      1813: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BorderRadiusEdit = function BorderRadiusEdit(l) {
          var s;
          var c = l.attributes.style,
              m = l.setAttributes;
          return (0, v.createElement)(_.default, {
            values: null == c || null === (s = c.border) || void 0 === s ? void 0 : s.radius,
            onChange: function onChange(l) {
              var s = _objectSpread(_objectSpread({}, c), {}, {
                border: _objectSpread(_objectSpread({}, null == c ? void 0 : c.border), {}, {
                  radius: l
                })
              });

              void 0 !== l && "" !== l || (s = (0, k.cleanEmptyObject)(s)), m({
                style: s
              });
            }
          });
        };

        var v = c(1753),
            _ = m(c(2398)),
            k = c(8241);
      },
      7095: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BorderStyleEdit = void 0;

        var v = c(1753),
            _ = m(c(4495)),
            k = c(8241);

        s.BorderStyleEdit = function (l) {
          var s;
          var c = l.attributes.style,
              m = l.setAttributes;
          return (0, v.createElement)(_.default, {
            value: null == c || null === (s = c.border) || void 0 === s ? void 0 : s.style,
            onChange: function onChange(l) {
              var s = _objectSpread(_objectSpread({}, c), {}, {
                border: _objectSpread(_objectSpread({}, null == c ? void 0 : c.border), {}, {
                  style: l
                })
              });

              m({
                style: (0, k.cleanEmptyObject)(s)
              });
            }
          });
        };
      },
      8884: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BorderWidthEdit = void 0;

        var v = c(1753),
            _ = c(4892),
            k = c(6756),
            y = c(8241),
            E = m(c(3081));

        s.BorderWidthEdit = function (l) {
          var _l$attributes3 = l.attributes,
              s = _l$attributes3.borderColor,
              c = _l$attributes3.style,
              m = l.setAttributes,
              _ref383 = (null == c ? void 0 : c.border) || {},
              w = _ref383.width,
              C = _ref383.color,
              S = _ref383.style,
              _ref384 = (0, v.useState)(),
              _ref385 = _slicedToArray(_ref384, 2),
              B = _ref385[0],
              P = _ref385[1],
              _ref386 = (0, v.useState)(),
              _ref387 = _slicedToArray(_ref386, 2),
              O = _ref387[0],
              L = _ref387[1];

          (0, v.useEffect)(function () {
            "none" !== S && P(S);
          }, [S]), (0, v.useEffect)(function () {
            (s || C) && L({
              name: s || void 0,
              color: C || void 0
            });
          }, [s, C]);
          var V = (0, _.__experimentalUseCustomUnits)({
            availableUnits: (0, E.default)("spacing.units") || ["px", "em", "rem"]
          });
          return (0, v.createElement)(_.__experimentalUnitControl, {
            value: w,
            label: (0, k.__)("Width"),
            min: 0,
            onChange: function onChange(l) {
              var v = _objectSpread(_objectSpread({}, c), {}, {
                border: _objectSpread(_objectSpread({}, null == c ? void 0 : c.border), {}, {
                  width: l
                })
              }),
                  _ = s;

              var k = 0 === parseFloat(l);
              k && (_ = void 0, v.border.color = void 0, v.border.style = "none"), k || "none" !== S || (v.border.style = B), k || void 0 !== s || (_ = null == O ? void 0 : O.name, v.border.color = null == O ? void 0 : O.color), void 0 !== l && "" !== l || (v = (0, y.cleanEmptyObject)(v)), m({
                borderColor: _,
                style: v
              });
            },
            units: V
          });
        };
      },
      8068: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.BORDER_SUPPORT_KEY = void 0, s.BorderPanel = function BorderPanel(l) {
          var s = useIsBorderDisabled(l),
              c = hasBorderSupport(l.name),
              m = (0, w.default)("border.color") && hasBorderSupport(l.name, "color"),
              _ = (0, w.default)("border.radius") && hasBorderSupport(l.name, "radius"),
              O = (0, w.default)("border.style") && hasBorderSupport(l.name, "style"),
              L = (0, w.default)("border.width") && hasBorderSupport(l.name, "width");

          if (s || !c) return null;
          return (0, v.createElement)(E.default, null, (0, v.createElement)(k.PanelBody, {
            className: "block-editor-hooks__border-controls",
            title: (0, y.__)("Border"),
            initialOpen: !1
          }, (L || O) && (0, v.createElement)("div", {
            className: "block-editor-hooks__border-controls-row"
          }, L && (0, v.createElement)(P.BorderWidthEdit, l), O && (0, v.createElement)(B.BorderStyleEdit, l)), m && (0, v.createElement)(C.BorderColorEdit, l), _ && (0, v.createElement)(S.BorderRadiusEdit, l)));
        }, s.hasBorderSupport = hasBorderSupport, s.shouldSkipSerialization = function shouldSkipSerialization(l) {
          var s = (0, _.getBlockSupport)(l, O);
          return null == s ? void 0 : s.__experimentalSkipSerialization;
        };

        var v = c(1753),
            _ = c(6700),
            k = c(4892),
            y = c(6756),
            E = m(c(5071)),
            w = m(c(3081)),
            C = c(493),
            S = c(1813),
            B = c(7095),
            P = c(8884);

        var O = "__experimentalBorder";

        function hasBorderSupport(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "any";
          if ("web" !== v.Platform.OS) return !1;
          var c = (0, _.getBlockSupport)(l, O);
          return !0 === c || ("any" === s ? !!(null != c && c.color || null != c && c.radius || null != c && c.width || null != c && c.style) : !(null == c || !c[s]));
        }

        s.BORDER_SUPPORT_KEY = O;

        var useIsBorderDisabled = function useIsBorderDisabled() {
          return [!(0, w.default)("border.color"), !(0, w.default)("border.radius"), !(0, w.default)("border.style"), !(0, w.default)("border.width")].every(Boolean);
        };
      },
      3798: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function ColorPanel(l) {
          var s = l.settings,
              c = l.clientId,
              _l$enableContrastChec = l.enableContrastChecking,
              m = _l$enableContrastChec === void 0 ? !0 : _l$enableContrastChec,
              _l$showTitle3 = l.showTitle,
              C = _l$showTitle3 === void 0 ? !0 : _l$showTitle3;

          var _ref388 = (0, v.useState)(),
              _ref389 = _slicedToArray(_ref388, 2),
              S = _ref389[0],
              B = _ref389[1],
              _ref390 = (0, v.useState)(),
              _ref391 = _slicedToArray(_ref390, 2),
              P = _ref391[0],
              O = _ref391[1],
              L = (0, w.__unstableUseBlockRef)(c);

          return (0, v.useEffect)(function () {
            if (!m) return;
            if (!L.current) return;
            O(getComputedStyle(L.current).color);
            var l = L.current,
                s = getComputedStyle(l).backgroundColor;

            for (; "rgba(0, 0, 0, 0)" === s && l.parentNode && l.parentNode.nodeType === l.parentNode.ELEMENT_NODE;) {
              l = l.parentNode, s = getComputedStyle(l).backgroundColor;
            }

            B(s);
          }), (0, v.createElement)(E.default, null, (0, v.createElement)(k.default, {
            title: (0, _.__)("Color"),
            initialOpen: !1,
            settings: s,
            showTitle: C,
            __experimentalHasMultipleOrigins: !0,
            __experimentalIsRenderedInSidebar: !0
          }, m && (0, v.createElement)(y.default, {
            backgroundColor: S,
            textColor: P
          })));
        };

        var v = c(1753),
            _ = c(6756),
            k = m(c(8251)),
            y = m(c(4346)),
            E = m(c(5071)),
            w = c(8882);

        function getComputedStyle(l) {
          return l.ownerDocument.defaultView.getComputedStyle(l);
        }
      },
      3429: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.COLOR_SUPPORT_KEY = void 0, s.ColorEdit = function ColorEdit(l) {
          var s, c, m, _, k, E, S, A, z;

          var D = l.name,
              F = l.attributes,
              G = (0, V.default)("color.palette.custom"),
              U = (0, V.default)("color.palette.theme"),
              W = (0, V.default)("color.palette.default"),
              K = (0, v.useMemo)(function () {
            return [].concat(_toConsumableArray(G || []), _toConsumableArray(U || []), _toConsumableArray(W || []));
          }, [G, U, W]),
              $ = (0, V.default)("color.gradients.custom"),
              q = (0, V.default)("color.gradients.theme"),
              Y = (0, V.default)("color.gradients.default"),
              Z = (0, v.useMemo)(function () {
            return [].concat(_toConsumableArray($ || []), _toConsumableArray(q || []), _toConsumableArray(Y || []));
          }, [$, q, Y]),
              X = (0, V.default)("color.custom"),
              Q = (0, V.default)("color.customGradient"),
              J = (0, V.default)("color.background"),
              ee = (0, V.default)("color.link"),
              te = (0, V.default)("color.text"),
              ne = X || !U || (null == U ? void 0 : U.length) > 0,
              oe = Q || !q || (null == q ? void 0 : q.length) > 0,
              re = (0, v.useRef)(F);
          if ((0, v.useEffect)(function () {
            re.current = F;
          }, [F]), !hasColorSupport(D)) return null;

          var le = function (l) {
            if ("web" !== v.Platform.OS) return !1;
            var s = (0, w.getBlockSupport)(l, R);
            return (0, y.isObject)(s) && !!s.link;
          }(D) && ee && ne,
              ie = function (l) {
            var s = (0, w.getBlockSupport)(l, R);
            return s && !1 !== s.text;
          }(D) && te && ne,
              ae = function (l) {
            var s = (0, w.getBlockSupport)(l, R);
            return s && !1 !== s.background;
          }(D) && J && ne,
              se = hasGradientSupport(D) && oe;

          if (!(le || ie || ae || se)) return null;
          var ce = F.style,
              ue = F.textColor,
              de = F.backgroundColor,
              pe = F.gradient;
          var me;
          if (se && pe) me = (0, P.getGradientValueBySlug)(Z, pe);else if (se) {
            var fe;
            me = null == ce || null === (fe = ce.color) || void 0 === fe ? void 0 : fe.gradient;
          }

          var onChangeColor = function onChangeColor(s) {
            return function (c) {
              var m, v;

              var _ = (0, B.getColorObjectByColorValue)(K, c),
                  k = s + "Color",
                  y = _objectSpread(_objectSpread({}, re.current.style), {}, {
                color: _objectSpread(_objectSpread({}, null === (m = re.current) || void 0 === m || null === (v = m.style) || void 0 === v ? void 0 : v.color), {}, _defineProperty({}, s, null != _ && _.slug ? void 0 : c))
              }),
                  E = null != _ && _.slug ? _.slug : void 0,
                  w = _defineProperty({
                style: (0, O.cleanEmptyObject)(y)
              }, k, E);

              l.setAttributes(w), re.current = _objectSpread(_objectSpread({}, re.current), w);
            };
          };

          return (0, v.createElement)(L.default, {
            enableContrastChecking: !("web" !== v.Platform.OS || pe || null != ce && null !== (s = ce.color) && void 0 !== s && s.gradient),
            clientId: l.clientId,
            settings: [].concat(_toConsumableArray(ie ? [{
              label: (0, C.__)("Text color"),
              onColorChange: onChangeColor("text"),
              colorValue: (0, B.getColorObjectByAttributeValues)(K, ue, null == ce || null === (c = ce.color) || void 0 === c ? void 0 : c.text).color
            }] : []), _toConsumableArray(ae || se ? [{
              label: (0, C.__)("Background color"),
              onColorChange: ae ? onChangeColor("background") : void 0,
              colorValue: (0, B.getColorObjectByAttributeValues)(K, de, null == ce || null === (m = ce.color) || void 0 === m ? void 0 : m.background).color,
              gradientValue: me,
              onGradientChange: se ? function (s) {
                var c = (0, P.getGradientSlugByValue)(Z, s);
                var m;

                if (c) {
                  var v, _, k;

                  var _l142 = _objectSpread(_objectSpread({}, null === (v = re.current) || void 0 === v ? void 0 : v.style), {}, {
                    color: _objectSpread(_objectSpread({}, null === (_ = re.current) || void 0 === _ || null === (k = _.style) || void 0 === k ? void 0 : k.color), {}, {
                      gradient: void 0
                    })
                  });

                  m = {
                    style: (0, O.cleanEmptyObject)(_l142),
                    gradient: c
                  };
                } else {
                  var y, E, w;

                  var _l143 = _objectSpread(_objectSpread({}, null === (y = re.current) || void 0 === y ? void 0 : y.style), {}, {
                    color: _objectSpread(_objectSpread({}, null === (E = re.current) || void 0 === E || null === (w = E.style) || void 0 === w ? void 0 : w.color), {}, {
                      gradient: s
                    })
                  });

                  m = {
                    style: (0, O.cleanEmptyObject)(_l143),
                    gradient: void 0
                  };
                }

                l.setAttributes(m), re.current = _objectSpread(_objectSpread({}, re.current), m);
              } : void 0
            }] : []), _toConsumableArray(le ? [{
              label: (0, C.__)("Link Color"),
              onColorChange: function onColorChange(s) {
                var c = (0, B.getColorObjectByColorValue)(K, s),
                    m = null != c && c.slug ? "var:preset|color|".concat(c.slug) : s,
                    v = (0, O.cleanEmptyObject)(function immutableSet(l, s, c) {
                  return (0, y.setWith)(l ? (0, y.clone)(l) : {}, s, c, y.clone);
                }(ce, ["elements", "link", "color", "text"], m));
                l.setAttributes({
                  style: v
                });
              },
              colorValue: getLinkColorFromAttributeValue(K, null == ce || null === (_ = ce.elements) || void 0 === _ || null === (k = _.link) || void 0 === k || null === (E = k.color) || void 0 === E ? void 0 : E.text),
              clearable: !(null == ce || null === (S = ce.elements) || void 0 === S || null === (A = S.link) || void 0 === A || null === (z = A.color) || void 0 === z || !z.text)
            }] : []))
          });
        }, s.addEditProps = addEditProps, s.addSaveProps = addSaveProps, s.withColorPaletteStyles = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(4793),
            E = c(1149),
            w = c(6700),
            C = c(6756),
            S = c(3200),
            B = c(4459),
            P = c(5261),
            O = c(8241),
            L = m(c(3798)),
            V = m(c(3081));

        var R = "color";
        s.COLOR_SUPPORT_KEY = R;

        var hasColorSupport = function hasColorSupport(l) {
          var s = (0, w.getBlockSupport)(l, R);
          return s && (!0 === s.link || !0 === s.gradient || !1 !== s.background || !1 !== s.text);
        },
            shouldSkipSerialization = function shouldSkipSerialization(l) {
          var s = (0, w.getBlockSupport)(l, R);
          return null == s ? void 0 : s.__experimentalSkipSerialization;
        },
            hasGradientSupport = function hasGradientSupport(l) {
          var s = (0, w.getBlockSupport)(l, R);
          return (0, y.isObject)(s) && !!s.gradients;
        };

        function addSaveProps(l, s, c) {
          var _ref392;

          var m, v, _, y, E, w;

          if (!hasColorSupport(s) || shouldSkipSerialization(s)) return l;
          var C = hasGradientSupport(s),
              S = c.backgroundColor,
              O = c.textColor,
              L = c.gradient,
              V = c.style,
              R = (0, B.getColorClassName)("background-color", S),
              A = (0, P.__experimentalGetGradientClass)(L),
              z = (0, B.getColorClassName)("color", O),
              D = (0, k.default)(l.className, z, A, (_ref392 = {}, _defineProperty(_ref392, R, !(C && null != V && null !== (m = V.color) && void 0 !== m && m.gradient || !R)), _defineProperty(_ref392, "has-text-color", O || (null == V || null === (v = V.color) || void 0 === v ? void 0 : v.text)), _defineProperty(_ref392, "has-background", S || (null == V || null === (_ = V.color) || void 0 === _ ? void 0 : _.background) || C && (L || (null == V || null === (y = V.color) || void 0 === y ? void 0 : y.gradient))), _defineProperty(_ref392, "has-link-color", null == V || null === (E = V.elements) || void 0 === E || null === (w = E.link) || void 0 === w ? void 0 : w.color), _ref392));
          return l.className = D || void 0, l;
        }

        function addEditProps(l) {
          if (!hasColorSupport(l) || shouldSkipSerialization(l)) return l;
          var s = l.getEditWrapperProps;
          return l.getEditWrapperProps = function (c) {
            var m = {};
            return s && (m = s(c)), addSaveProps(m, l, c);
          }, l;
        }

        var getLinkColorFromAttributeValue = function getLinkColorFromAttributeValue(l, s) {
          var c = /var:preset\|color\|(.+)/.exec(s);
          return c && c[1] ? (0, B.getColorObjectByAttributeValues)(l, c[1]).color : s;
        };

        var A = (0, S.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c;
            var m = s.name,
                k = s.attributes,
                y = k.backgroundColor,
                E = k.textColor,
                w = (0, V.default)("color.palette.custom") || [],
                C = (0, V.default)("color.palette.theme") || [],
                S = (0, V.default)("color.palette.default") || [],
                P = (0, v.useMemo)(function () {
              return [].concat(_toConsumableArray(w || []), _toConsumableArray(C || []), _toConsumableArray(S || []));
            }, [w, C, S]);
            if (!hasColorSupport(m) || shouldSkipSerialization(m)) return (0, v.createElement)(l, s);
            var O = {};
            var L, R;
            E && (O.color = null === (L = (0, B.getColorObjectByAttributeValues)(P, E)) || void 0 === L ? void 0 : L.color);
            y && (O.backgroundColor = null === (R = (0, B.getColorObjectByAttributeValues)(P, y)) || void 0 === R ? void 0 : R.color);
            var A = s.wrapperProps;
            return A = _objectSpread(_objectSpread({}, s.wrapperProps), {}, {
              style: _objectSpread(_objectSpread({}, O), null === (c = s.wrapperProps) || void 0 === c ? void 0 : c.style)
            }), (0, v.createElement)(l, (0, _.default)({}, s, {
              wrapperProps: A
            }));
          };
        });
        s.withColorPaletteStyles = A, (0, E.addFilter)("blocks.registerBlockType", "core/color/addAttribute", function addAttributes(l) {
          return hasColorSupport(l) ? (l.attributes.backgroundColor || Object.assign(l.attributes, {
            backgroundColor: {
              type: "string"
            }
          }), l.attributes.textColor || Object.assign(l.attributes, {
            textColor: {
              type: "string"
            }
          }), hasGradientSupport(l) && !l.attributes.gradient && Object.assign(l.attributes, {
            gradient: {
              type: "string"
            }
          }), l) : l;
        }), (0, E.addFilter)("blocks.getSaveContent.extraProps", "core/color/addSaveProps", addSaveProps), (0, E.addFilter)("blocks.registerBlockType", "core/color/addEditProps", addEditProps), (0, E.addFilter)("editor.BlockListBlock", "core/color/with-color-palette-styles", A);
      },
      4096: function _(l, s, c) {
        "use strict";

        var m = c(6700);
        (0, c(1149).addFilter)("blocks.registerBlockType", "core/compat/migrateLightBlockWrapper", function migrateLightBlockWrapper(l) {
          var _l$apiVersion = l.apiVersion,
              s = _l$apiVersion === void 0 ? 1 : _l$apiVersion;
          return s < 2 && (0, m.hasBlockSupport)(l, "lightBlockWrapper", !1) && (l.apiVersion = 2), l;
        });
      },
      9870: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.addAttribute = addAttribute, s.addSaveProps = addSaveProps, s.withInspectorControl = void 0;

        var v = c(1753),
            _ = m(c(2703)),
            k = c(1149),
            y = c(4892),
            E = c(6756),
            w = c(6700),
            C = c(3200),
            S = c(6330);

        function addAttribute(l) {
          return (0, w.hasBlockSupport)(l, "customClassName", !0) && (l.attributes = _objectSpread(_objectSpread({}, l.attributes), {}, {
            className: {
              type: "string"
            }
          })), l;
        }

        var B = (0, C.createHigherOrderComponent)(function (l) {
          return function (s) {
            return (0, w.hasBlockSupport)(s.name, "customClassName", !0) && s.isSelected ? (0, v.createElement)(v.Fragment, null, (0, v.createElement)(l, s), (0, v.createElement)(S.InspectorControls, {
              __experimentalGroup: "advanced"
            }, (0, v.createElement)(y.TextControl, {
              autoComplete: "off",
              label: (0, E.__)("Additional CSS class(es)"),
              value: s.attributes.className || "",
              onChange: function onChange(l) {
                s.setAttributes({
                  className: "" !== l ? l : void 0
                });
              },
              help: (0, E.__)("Separate multiple classes with spaces.")
            }))) : (0, v.createElement)(l, s);
          };
        }, "withInspectorControl");

        function addSaveProps(l, s, c) {
          return (0, w.hasBlockSupport)(s, "customClassName", !0) && c.className && (l.className = (0, _.default)(l.className, c.className)), l;
        }

        s.withInspectorControl = B, (0, k.addFilter)("blocks.registerBlockType", "core/custom-class-name/attribute", addAttribute), (0, k.addFilter)("editor.BlockEdit", "core/editor/custom-class-name/with-inspector-control", B), (0, k.addFilter)("blocks.getSaveContent.extraProps", "core/custom-class-name/save-props", addSaveProps);
      },
      4431: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.AXIAL_SIDES = s.ALL_SIDES = void 0, s.DimensionsPanel = function DimensionsPanel(l) {
          var s = (0, w.useIsGapDisabled)(l),
              c = (0, S.useIsPaddingDisabled)(l),
              m = (0, C.useIsMarginDisabled)(l),
              P = useIsDimensionsDisabled(l),
              O = hasDimensionsSupport(l.name);
          if (P || !O) return null;

          var L = (0, y.getBlockSupport)(l.name, [B, "__experimentalDefaultControls"]),
              createResetAllFilter = function createResetAllFilter(l) {
            return function (s) {
              var c;
              return _objectSpread(_objectSpread({}, s), {}, {
                style: _objectSpread(_objectSpread({}, s.style), {}, {
                  spacing: _objectSpread(_objectSpread({}, null === (c = s.style) || void 0 === c ? void 0 : c.spacing), {}, _defineProperty({}, l, void 0))
                })
              });
            };
          };

          return (0, v.createElement)(E.default, {
            __experimentalGroup: "dimensions"
          }, !c && (0, v.createElement)(_.__experimentalToolsPanelItem, {
            hasValue: function hasValue() {
              return (0, S.hasPaddingValue)(l);
            },
            label: (0, k.__)("Padding"),
            onDeselect: function onDeselect() {
              return (0, S.resetPadding)(l);
            },
            resetAllFilter: createResetAllFilter("padding"),
            isShownByDefault: null == L ? void 0 : L.padding,
            panelId: l.clientId
          }, (0, v.createElement)(S.PaddingEdit, l)), !m && (0, v.createElement)(_.__experimentalToolsPanelItem, {
            hasValue: function hasValue() {
              return (0, C.hasMarginValue)(l);
            },
            label: (0, k.__)("Margin"),
            onDeselect: function onDeselect() {
              return (0, C.resetMargin)(l);
            },
            resetAllFilter: createResetAllFilter("margin"),
            isShownByDefault: null == L ? void 0 : L.margin,
            panelId: l.clientId
          }, (0, v.createElement)(C.MarginEdit, l)), !s && (0, v.createElement)(_.__experimentalToolsPanelItem, {
            hasValue: function hasValue() {
              return (0, w.hasGapValue)(l);
            },
            label: (0, k.__)("Block spacing"),
            onDeselect: function onDeselect() {
              return (0, w.resetGap)(l);
            },
            resetAllFilter: createResetAllFilter("blockGap"),
            isShownByDefault: null == L ? void 0 : L.blockGap,
            panelId: l.clientId
          }, (0, v.createElement)(w.GapEdit, l)));
        }, s.SPACING_SUPPORT_KEY = void 0, s.hasDimensionsSupport = hasDimensionsSupport, s.useCustomSides = useCustomSides, s.useIsDimensionsSupportValid = function useIsDimensionsSupportValid(l, s) {
          var c = useCustomSides(l, s);
          if (c && c.some(function (l) {
            return P.includes(l);
          }) && c.some(function (l) {
            return O.includes(l);
          })) return console.warn("The ".concat(s, " support for the \"").concat(l, "\" block can not be configured to support both axial and arbitrary sides.")), !1;
          return !0;
        };

        var v = c(1753),
            _ = c(4892),
            k = c(6756),
            y = c(6700),
            E = m(c(5071)),
            w = c(5416),
            C = c(1582),
            S = c(3093);

        var B = "spacing";
        s.SPACING_SUPPORT_KEY = B;
        var P = ["top", "right", "bottom", "left"];
        s.ALL_SIDES = P;
        var O = ["vertical", "horizontal"];

        function hasDimensionsSupport(l) {
          return "web" === v.Platform.OS && ((0, w.hasGapSupport)(l) || (0, S.hasPaddingSupport)(l) || (0, C.hasMarginSupport)(l));
        }

        s.AXIAL_SIDES = O;

        var useIsDimensionsDisabled = function useIsDimensionsDisabled() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          var s = (0, w.useIsGapDisabled)(l),
              c = (0, S.useIsPaddingDisabled)(l),
              m = (0, C.useIsMarginDisabled)(l);
          return s && c && m;
        };

        function useCustomSides(l, s) {
          var c = (0, y.getBlockSupport)(l, B);
          if (c && "boolean" != typeof c[s]) return c[s];
        }
      },
      5003: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getValuesFromColors = getValuesFromColors;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(7270),
            E = m(c(9785)),
            w = c(6700),
            C = c(4892),
            S = c(3200),
            B = c(1149),
            P = c(6330),
            O = m(c(9476));

        var L = [];

        function getValuesFromColors() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          var s = {
            r: [],
            g: [],
            b: [],
            a: []
          };
          return l.forEach(function (l) {
            var c = (0, y.colord)(l).toRgb();
            s.r.push(c.r / 255), s.g.push(c.g / 255), s.b.push(c.b / 255), s.a.push(c.a);
          }), s;
        }

        function DuotoneFilter(l) {
          var s = l.selector,
              c = l.id,
              m = l.values;

          var _ = "\n".concat(s, " {\n\tfilter: url( #").concat(c, " );\n}\n");

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(C.SVG, {
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            viewBox: "0 0 0 0",
            width: "0",
            height: "0",
            focusable: "false",
            role: "none",
            style: {
              visibility: "hidden",
              position: "absolute",
              left: "-9999px",
              overflow: "hidden"
            }
          }, (0, v.createElement)("defs", null, (0, v.createElement)("filter", {
            id: c
          }, (0, v.createElement)("feColorMatrix", {
            colorInterpolationFilters: "sRGB",
            type: "matrix",
            values: " .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
          }), (0, v.createElement)("feComponentTransfer", {
            colorInterpolationFilters: "sRGB"
          }, (0, v.createElement)("feFuncR", {
            type: "table",
            tableValues: m.r.join(" ")
          }), (0, v.createElement)("feFuncG", {
            type: "table",
            tableValues: m.g.join(" ")
          }), (0, v.createElement)("feFuncB", {
            type: "table",
            tableValues: m.b.join(" ")
          }), (0, v.createElement)("feFuncA", {
            type: "table",
            tableValues: m.a.join(" ")
          })), (0, v.createElement)("feComposite", {
            in2: "SourceGraphic",
            operator: "in"
          })))), (0, v.createElement)("style", {
            dangerouslySetInnerHTML: {
              __html: _
            }
          }));
        }

        function DuotonePanel(l) {
          var s;
          var c = l.attributes,
              m = l.setAttributes;

          var _ = null == c ? void 0 : c.style,
              k = null == _ || null === (s = _.color) || void 0 === s ? void 0 : s.duotone,
              y = (0, P.useSetting)("color.duotone") || L,
              E = (0, P.useSetting)("color.palette") || L,
              w = !(0, P.useSetting)("color.custom"),
              C = !(0, P.useSetting)("color.customDuotone") || 0 === (null == E ? void 0 : E.length) && w;

          return 0 === (null == y ? void 0 : y.length) && C ? null : (0, v.createElement)(P.BlockControls, {
            group: "block",
            __experimentalShareWithChildBlocks: !0
          }, (0, v.createElement)(P.__experimentalDuotoneControl, {
            duotonePalette: y,
            colorPalette: E,
            disableCustomDuotone: C,
            disableCustomColors: w,
            value: k,
            onChange: function onChange(l) {
              var s = _objectSpread(_objectSpread({}, _), {}, {
                color: _objectSpread(_objectSpread({}, null == _ ? void 0 : _.color), {}, {
                  duotone: l
                })
              });

              m({
                style: s
              });
            }
          }));
        }

        (0, y.extend)([E.default]);
        var V = (0, S.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c = (0, w.hasBlockSupport)(s.name, "color.__experimentalDuotone");
            return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(l, s), c && (0, v.createElement)(DuotonePanel, s));
          };
        }, "withDuotoneControls");
        var R = (0, S.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c, m, y;
            var E = (0, w.getBlockSupport)(s.name, "color.__experimentalDuotone"),
                C = null == s || null === (c = s.attributes) || void 0 === c || null === (m = c.style) || void 0 === m || null === (y = m.color) || void 0 === y ? void 0 : y.duotone;
            if (!E || !C) return (0, v.createElement)(l, s);

            var B = "wp-duotone-".concat((0, S.useInstanceId)(l)),
                P = function scopeSelector(l, s) {
              var c = l.split(","),
                  m = s.split(","),
                  v = [];
              return c.forEach(function (l) {
                m.forEach(function (s) {
                  v.push("".concat(l.trim(), " ").concat(s.trim()));
                });
              }), v.join(", ");
            }(".editor-styles-wrapper .".concat(B), E),
                L = (0, k.default)(null == s ? void 0 : s.className, B),
                V = (0, v.useContext)(O.default.__unstableElementContext);

            return (0, v.createElement)(v.Fragment, null, V && (0, v.createPortal)((0, v.createElement)(DuotoneFilter, {
              selector: P,
              id: B,
              values: getValuesFromColors(C)
            }), V), (0, v.createElement)(l, (0, _.default)({}, s, {
              className: L
            })));
          };
        }, "withDuotoneStyles");
        (0, B.addFilter)("blocks.registerBlockType", "core/editor/duotone/add-attributes", function addDuotoneAttributes(l) {
          return (0, w.hasBlockSupport)(l, "color.__experimentalDuotone") ? (l.attributes.style || Object.assign(l.attributes, {
            style: {
              type: "object"
            }
          }), l) : l;
        }), (0, B.addFilter)("editor.BlockEdit", "core/editor/duotone/with-editor-controls", V), (0, B.addFilter)("editor.BlockListBlock", "core/editor/duotone/with-styles", R);
      },
      3735: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.FONT_WEIGHT_SUPPORT_KEY = s.FONT_STYLE_SUPPORT_KEY = void 0, s.FontAppearanceEdit = function FontAppearanceEdit(l) {
          var s, c;
          var m = l.attributes.style,
              _ = l.setAttributes,
              y = !useIsFontStyleDisabled(l),
              w = !useIsFontWeightDisabled(l),
              C = null == m || null === (s = m.typography) || void 0 === s ? void 0 : s.fontStyle,
              S = null == m || null === (c = m.typography) || void 0 === c ? void 0 : c.fontWeight;
          return (0, v.createElement)(k.default, {
            onChange: function onChange(l) {
              _({
                style: (0, E.cleanEmptyObject)(_objectSpread(_objectSpread({}, m), {}, {
                  typography: _objectSpread(_objectSpread({}, null == m ? void 0 : m.typography), {}, {
                    fontStyle: l.fontStyle,
                    fontWeight: l.fontWeight
                  })
                }))
              });
            },
            hasFontStyles: y,
            hasFontWeights: w,
            value: {
              fontStyle: C,
              fontWeight: S
            }
          });
        }, s.hasFontAppearanceValue = function hasFontAppearanceValue(l) {
          var s;

          var _ref393 = (null === (s = l.attributes.style) || void 0 === s ? void 0 : s.typography) || {},
              c = _ref393.fontStyle,
              m = _ref393.fontWeight;

          return !!c || !!m;
        }, s.resetFontAppearance = function resetFontAppearance(l) {
          var _l$attributes4 = l.attributes,
              s = _l$attributes4 === void 0 ? {} : _l$attributes4,
              c = l.setAttributes;
          var m = s.style;
          c({
            style: (0, E.cleanEmptyObject)(_objectSpread(_objectSpread({}, m), {}, {
              typography: _objectSpread(_objectSpread({}, null == m ? void 0 : m.typography), {}, {
                fontStyle: void 0,
                fontWeight: void 0
              })
            }))
          });
        }, s.useIsFontAppearanceDisabled = function useIsFontAppearanceDisabled(l) {
          var s = useIsFontStyleDisabled(l),
              c = useIsFontWeightDisabled(l);
          return s && c;
        }, s.useIsFontStyleDisabled = useIsFontStyleDisabled, s.useIsFontWeightDisabled = useIsFontWeightDisabled;

        var v = c(1753),
            _ = c(6700),
            k = m(c(4601)),
            y = m(c(3081)),
            E = c(8241);

        var w = "typography.__experimentalFontStyle";
        s.FONT_STYLE_SUPPORT_KEY = w;
        var C = "typography.__experimentalFontWeight";

        function useIsFontStyleDisabled() {
          var _ref394 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              l = _ref394.name;

          var s = (0, _.hasBlockSupport)(l, w),
              c = (0, y.default)("typography.fontStyle");
          return !s || !c;
        }

        function useIsFontWeightDisabled() {
          var _ref395 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              l = _ref395.name;

          var s = (0, _.hasBlockSupport)(l, C),
              c = (0, y.default)("typography.fontWeight");
          return !s || !c;
        }

        s.FONT_WEIGHT_SUPPORT_KEY = C;
      },
      4359: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.FONT_FAMILY_SUPPORT_KEY = void 0, s.FontFamilyEdit = function FontFamilyEdit(l) {
          var s;
          var c = l.setAttributes,
              m = l.attributes.fontFamily;
          var k = (0, w.default)("typography.fontFamilies"),
              y = null === (s = (0, _.find)(k, function (l) {
            var s = l.slug;
            return m === s;
          })) || void 0 === s ? void 0 : s.fontFamily;
          return (0, v.createElement)(C.default, {
            className: "block-editor-hooks-font-family-control",
            fontFamilies: k,
            value: y,
            onChange: function onChange(l) {
              var s = (0, _.find)(k, function (s) {
                var c = s.fontFamily;
                return c === l;
              });
              c({
                fontFamily: null == s ? void 0 : s.slug
              });
            }
          });
        }, s.hasFontFamilyValue = function hasFontFamilyValue(l) {
          return !!l.attributes.fontFamily;
        }, s.resetFontFamily = function resetFontFamily(l) {
          var s = l.setAttributes;
          s({
            fontFamily: void 0
          });
        }, s.useIsFontFamilyDisabled = function useIsFontFamilyDisabled(l) {
          var s = l.name;
          var c = (0, w.default)("typography.fontFamilies");
          return !c || 0 === c.length || !(0, y.hasBlockSupport)(s, S);
        };

        var v = c(1753),
            _ = c(4793),
            k = c(1149),
            y = c(6700),
            E = m(c(410)),
            w = m(c(3081)),
            C = m(c(1052));

        var S = "typography.__experimentalFontFamily";

        function addSaveProps(l, s, c) {
          if (!(0, y.hasBlockSupport)(s, S)) return l;
          if ((0, y.hasBlockSupport)(s, "typography.__experimentalSkipSerialization")) return l;
          if (null == c || !c.fontFamily) return l;
          var m = new E.default(l.className);
          m.add("has-".concat((0, _.kebabCase)(null == c ? void 0 : c.fontFamily), "-font-family"));
          var v = m.value;
          return l.className = v || void 0, l;
        }

        s.FONT_FAMILY_SUPPORT_KEY = S, (0, k.addFilter)("blocks.registerBlockType", "core/fontFamily/addAttribute", function addAttributes(l) {
          return (0, y.hasBlockSupport)(l, S) ? (l.attributes.fontFamily || Object.assign(l.attributes, {
            fontFamily: {
              type: "string"
            }
          }), l) : l;
        }), (0, k.addFilter)("blocks.getSaveContent.extraProps", "core/fontFamily/addSaveProps", addSaveProps), (0, k.addFilter)("blocks.registerBlockType", "core/fontFamily/addEditProps", function addEditProps(l) {
          if (!(0, y.hasBlockSupport)(l, S)) return l;
          var s = l.getEditWrapperProps;
          return l.getEditWrapperProps = function (c) {
            var m = {};
            return s && (m = s(c)), addSaveProps(m, l, c);
          }, l;
        });
      },
      3981: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.FONT_SIZE_SUPPORT_KEY = void 0, s.FontSizeEdit = function FontSizeEdit(l) {
          var s, c;
          var _l$attributes5 = l.attributes,
              m = _l$attributes5.fontSize,
              _ = _l$attributes5.style,
              k = l.setAttributes,
              y = (0, S.default)("typography.fontSizes"),
              E = (0, w.getFontSize)(y, m, null == _ || null === (s = _.typography) || void 0 === s ? void 0 : s.fontSize),
              B = (null == E ? void 0 : E.size) || (null == _ || null === (c = _.typography) || void 0 === c ? void 0 : c.fontSize) || m;
          return (0, v.createElement)(w.FontSizePicker, {
            onChange: function onChange(l) {
              var s = (0, w.getFontSizeObjectByValue)(y, l).slug;
              k({
                style: (0, C.cleanEmptyObject)(_objectSpread(_objectSpread({}, _), {}, {
                  typography: _objectSpread(_objectSpread({}, null == _ ? void 0 : _.typography), {}, {
                    fontSize: s ? void 0 : l
                  })
                })),
                fontSize: s
              });
            },
            value: B,
            withReset: !1
          });
        }, s.hasFontSizeValue = function hasFontSizeValue(l) {
          var s;
          var _l$attributes6 = l.attributes,
              c = _l$attributes6.fontSize,
              m = _l$attributes6.style;
          return !!c || !(null == m || null === (s = m.typography) || void 0 === s || !s.fontSize);
        }, s.resetFontSize = function resetFontSize(l) {
          var _l$attributes7 = l.attributes,
              s = _l$attributes7 === void 0 ? {} : _l$attributes7,
              c = l.setAttributes;
          var m = s.style;
          c({
            fontSize: void 0,
            style: (0, C.cleanEmptyObject)(_objectSpread(_objectSpread({}, m), {}, {
              typography: _objectSpread(_objectSpread({}, null == m ? void 0 : m.typography), {}, {
                fontSize: void 0
              })
            }))
          });
        }, s.useIsFontSizeDisabled = function useIsFontSizeDisabled() {
          var _ref396 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              l = _ref396.name;

          var s = (0, S.default)("typography.fontSizes"),
              c = !(null == s || !s.length);
          return !(0, k.hasBlockSupport)(l, B) || !c;
        };

        var v = c(1753),
            _ = c(1149),
            k = c(6700),
            y = m(c(410)),
            E = c(3200),
            w = c(1184),
            C = c(8241),
            S = m(c(3081));

        var B = "typography.fontSize";

        function addSaveProps(l, s, c) {
          if (!(0, k.hasBlockSupport)(s, B)) return l;
          if ((0, k.hasBlockSupport)(s, "typography.__experimentalSkipSerialization")) return l;
          var m = new y.default(l.className);
          m.add((0, w.getFontSizeClass)(c.fontSize));
          var v = m.value;
          return l.className = v || void 0, l;
        }

        s.FONT_SIZE_SUPPORT_KEY = B;
        var P = (0, E.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c, m;

            var _ = (0, S.default)("typography.fontSizes"),
                y = s.name,
                _s$attributes = s.attributes,
                E = _s$attributes.fontSize,
                C = _s$attributes.style,
                P = s.wrapperProps;

            if (!(0, k.hasBlockSupport)(y, B) || (0, k.hasBlockSupport)(y, "typography.__experimentalSkipSerialization") || !E || null != C && null !== (c = C.typography) && void 0 !== c && c.fontSize) return (0, v.createElement)(l, s);

            var O = (0, w.getFontSize)(_, E, null == C || null === (m = C.typography) || void 0 === m ? void 0 : m.fontSize).size,
                L = _objectSpread(_objectSpread({}, s), {}, {
              wrapperProps: _objectSpread(_objectSpread({}, P), {}, {
                style: _objectSpread({
                  fontSize: O
                }, null == P ? void 0 : P.style)
              })
            });

            return (0, v.createElement)(l, L);
          };
        }, "withFontSizeInlineStyles");
        (0, _.addFilter)("blocks.registerBlockType", "core/font/addAttribute", function addAttributes(l) {
          return (0, k.hasBlockSupport)(l, B) ? (l.attributes.fontSize || Object.assign(l.attributes, {
            fontSize: {
              type: "string"
            }
          }), l) : l;
        }), (0, _.addFilter)("blocks.getSaveContent.extraProps", "core/font/addSaveProps", addSaveProps), (0, _.addFilter)("blocks.registerBlockType", "core/font/addEditProps", function addEditProps(l) {
          if (!(0, k.hasBlockSupport)(l, B)) return l;
          var s = l.getEditWrapperProps;
          return l.getEditWrapperProps = function (c) {
            var m = {};
            return s && (m = s(c)), addSaveProps(m, l, c);
          }, l;
        }), (0, _.addFilter)("editor.BlockListBlock", "core/font-size/with-font-size-inline-styles", P);
      },
      5416: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.GapEdit = function GapEdit(l) {
          var s;
          var c = l.clientId,
              m = l.attributes.style,
              k = l.setAttributes,
              C = (0, y.__experimentalUseCustomUnits)({
            availableUnits: (0, w.default)("spacing.units") || ["%", "px", "em", "rem", "vw"]
          }),
              B = (0, E.__unstableUseBlockRef)(c);
          if (useIsGapDisabled(l)) return null;
          return v.Platform.select({
            web: (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.__experimentalUnitControl, {
              label: (0, _.__)("Block spacing"),
              __unstableInputWidth: "80px",
              min: 0,
              onChange: function onChange(l) {
                var s;

                var c = _objectSpread(_objectSpread({}, m), {}, {
                  spacing: _objectSpread(_objectSpread({}, null == m ? void 0 : m.spacing), {}, {
                    blockGap: l
                  })
                });

                k({
                  style: (0, S.cleanEmptyObject)(c)
                });
                var v = (null === (s = window) || void 0 === s ? void 0 : s.navigator.userAgent) && window.navigator.userAgent.includes("Safari") && !window.navigator.userAgent.includes("Chrome ") && !window.navigator.userAgent.includes("Chromium ");

                var _;

                B.current && v && (null === (_ = B.current.parentNode) || void 0 === _ || _.replaceChild(B.current, B.current));
              },
              units: C,
              value: null == m || null === (s = m.spacing) || void 0 === s ? void 0 : s.blockGap
            })),
            native: null
          });
        }, s.hasGapSupport = hasGapSupport, s.hasGapValue = function hasGapValue(l) {
          var s, c;
          return void 0 !== (null === (s = l.attributes.style) || void 0 === s || null === (c = s.spacing) || void 0 === c ? void 0 : c.blockGap);
        }, s.resetGap = function resetGap(l) {
          var _l$attributes8 = l.attributes,
              s = _l$attributes8 === void 0 ? {} : _l$attributes8,
              c = l.setAttributes;
          var m = s.style;
          c({
            style: _objectSpread(_objectSpread({}, m), {}, {
              spacing: _objectSpread(_objectSpread({}, null == m ? void 0 : m.spacing), {}, {
                blockGap: void 0
              })
            })
          });
        }, s.useIsGapDisabled = useIsGapDisabled;

        var v = c(1753),
            _ = c(6756),
            k = c(6700),
            y = c(4892),
            E = c(8882),
            w = m(c(3081)),
            C = c(4431),
            S = c(8241);

        function hasGapSupport(l) {
          var s = (0, k.getBlockSupport)(l, C.SPACING_SUPPORT_KEY);
          return !!(!0 === s || null != s && s.blockGap);
        }

        function useIsGapDisabled() {
          var _ref397 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              l = _ref397.name;

          var s = !(0, w.default)("spacing.blockGap");
          return !hasGapSupport(l) || s;
        }
      },
      1625: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.addGeneratedClassName = addGeneratedClassName;

        var m = c(4793),
            v = c(1149),
            _ = c(6700);

        function addGeneratedClassName(l, s) {
          return (0, _.hasBlockSupport)(s, "className", !0) && ("string" == typeof l.className ? l.className = (0, m.uniq)([(0, _.getBlockDefaultClassName)(s.name)].concat(_toConsumableArray(l.className.split(" ")))).join(" ").trim() : l.className = (0, _.getBlockDefaultClassName)(s.name)), l;
        }

        (0, v.addFilter)("blocks.getSaveContent.extraProps", "core/generated-class-name/save-props", addGeneratedClassName);
      },
      5227: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), Object.defineProperty(s, "getBorderClassesAndStyles", {
          enumerable: !0,
          get: function get() {
            return v.getBorderClassesAndStyles;
          }
        }), Object.defineProperty(s, "getColorClassesAndStyles", {
          enumerable: !0,
          get: function get() {
            return _.getColorClassesAndStyles;
          }
        }), Object.defineProperty(s, "getSpacingClassesAndStyles", {
          enumerable: !0,
          get: function get() {
            return k.getSpacingClassesAndStyles;
          }
        }), Object.defineProperty(s, "useBorderProps", {
          enumerable: !0,
          get: function get() {
            return v.useBorderProps;
          }
        }), Object.defineProperty(s, "useCachedTruthy", {
          enumerable: !0,
          get: function get() {
            return y.useCachedTruthy;
          }
        }), Object.defineProperty(s, "useColorProps", {
          enumerable: !0,
          get: function get() {
            return _.useColorProps;
          }
        }), Object.defineProperty(s, "useCustomSides", {
          enumerable: !0,
          get: function get() {
            return m.useCustomSides;
          }
        }), c(4096), c(2866), c(3455), c(3599), c(9870), c(1625), c(9390), c(3429), c(5003), c(3981), c(493), c(7373);

        var m = c(4431),
            v = c(1123),
            _ = c(1617),
            k = c(6682),
            y = c(1475);
      },
      7373: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.addAttribute = addAttribute, s.withLayoutStyles = s.withInspectorControls = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = m(c(2703)),
            y = c(4793),
            E = c(3200),
            w = c(1149),
            C = c(6700),
            S = c(8467),
            B = c(4892),
            P = c(6756),
            O = c(8486),
            L = c(6330),
            V = m(c(3081)),
            R = c(7189),
            A = m(c(9476)),
            z = c(6633);

        var D = "__experimentalLayout";

        function LayoutPanel(l) {
          var s = l.setAttributes,
              c = l.attributes,
              m = l.name;
          var _ = c.layout,
              k = (0, V.default)("layout"),
              y = (0, S.useSelect)(function (l) {
            var _l144 = l(O.store),
                s = _l144.getSettings;

            return s().supportsLayout;
          }, []),
              E = (0, C.getBlockSupport)(m, D, {}),
              w = E.allowSwitching,
              _E$allowEditing = E.allowEditing,
              R = _E$allowEditing === void 0 ? !0 : _E$allowEditing,
              _E$allowInheriting = E.allowInheriting,
              A = _E$allowInheriting === void 0 ? !0 : _E$allowInheriting,
              F = E.default;
          if (!R) return null;
          var G = _ || F || {},
              _G$inherit = G.inherit,
              U = _G$inherit === void 0 ? !1 : _G$inherit,
              _G$type = G.type,
              W = _G$type === void 0 ? "default" : _G$type;
          if ("default" === W && !y) return null;

          var K = (0, z.getLayoutType)(W),
              onChangeLayout = function onChangeLayout(l) {
            return s({
              layout: l
            });
          };

          return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(L.InspectorControls, null, (0, v.createElement)(B.PanelBody, {
            title: (0, P.__)("Layout")
          }, A && !!k && (0, v.createElement)(B.ToggleControl, {
            label: (0, P.__)("Inherit default layout"),
            checked: !!U,
            onChange: function onChange() {
              return s({
                layout: {
                  inherit: !U
                }
              });
            }
          }), !U && w && (0, v.createElement)(LayoutTypeSwitcher, {
            type: W,
            onChange: function onChange(l) {
              return s({
                layout: {
                  type: l
                }
              });
            }
          }), !U && K && (0, v.createElement)(K.inspectorControls, {
            layout: G,
            onChange: onChangeLayout,
            layoutBlockSupport: E
          }))), !U && K && (0, v.createElement)(K.toolBarControls, {
            layout: G,
            onChange: onChangeLayout,
            layoutBlockSupport: E
          }));
        }

        function LayoutTypeSwitcher(l) {
          var s = l.type,
              c = l.onChange;
          return (0, v.createElement)(B.ButtonGroup, null, (0, z.getLayoutTypes)().map(function (l) {
            var m = l.name,
                _ = l.label;
            return (0, v.createElement)(B.Button, {
              key: m,
              isPressed: s === m,
              onClick: function onClick() {
                return c(m);
              }
            }, _);
          }));
        }

        function addAttribute(l) {
          return (0, y.has)(l.attributes, ["layout", "type"]) || (0, C.hasBlockSupport)(l, D) && (l.attributes = _objectSpread(_objectSpread({}, l.attributes), {}, {
            layout: {
              type: "object"
            }
          })), l;
        }

        var F = (0, E.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c = s.name;
            return [(0, C.hasBlockSupport)(c, D) && (0, v.createElement)(LayoutPanel, (0, _.default)({
              key: "layout"
            }, s)), (0, v.createElement)(l, (0, _.default)({
              key: "edit"
            }, s))];
          };
        }, "withInspectorControls");
        s.withInspectorControls = F;
        var G = (0, E.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c = s.name,
                m = s.attributes,
                y = (0, C.hasBlockSupport)(c, D),
                w = (0, E.useInstanceId)(l),
                S = (0, V.default)("layout") || {},
                B = (0, v.useContext)(A.default.__unstableElementContext),
                P = m.layout,
                _ref398 = (0, C.getBlockSupport)(c, D) || {},
                O = _ref398.default,
                L = null != P && P.inherit ? S : P || O || {},
                z = (0, k.default)(null == s ? void 0 : s.className, _defineProperty({}, "wp-container-".concat(w), y));

            return (0, v.createElement)(v.Fragment, null, y && B && (0, v.createPortal)((0, v.createElement)(R.LayoutStyle, {
              selector: ".wp-container-".concat(w),
              layout: L,
              style: null == m ? void 0 : m.style
            }), B), (0, v.createElement)(l, (0, _.default)({}, s, {
              className: z
            })));
          };
        });
        s.withLayoutStyles = G, (0, w.addFilter)("blocks.registerBlockType", "core/layout/addAttribute", addAttribute), (0, w.addFilter)("editor.BlockListBlock", "core/editor/layout/with-layout-styles", G), (0, w.addFilter)("editor.BlockEdit", "core/editor/layout/with-inspector-controls", F);
      },
      5658: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.LETTER_SPACING_SUPPORT_KEY = void 0, s.LetterSpacingEdit = function LetterSpacingEdit(l) {
          var s;
          var c = l.attributes.style,
              m = l.setAttributes;
          return (0, v.createElement)(k.default, {
            value: null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.letterSpacing,
            onChange: function onChange(l) {
              m({
                style: (0, E.cleanEmptyObject)(_objectSpread(_objectSpread({}, c), {}, {
                  typography: _objectSpread(_objectSpread({}, null == c ? void 0 : c.typography), {}, {
                    letterSpacing: l
                  })
                }))
              });
            },
            __unstableInputWidth: !1
          });
        }, s.hasLetterSpacingValue = function hasLetterSpacingValue(l) {
          var s, c;
          return !(null === (s = l.attributes.style) || void 0 === s || null === (c = s.typography) || void 0 === c || !c.letterSpacing);
        }, s.resetLetterSpacing = function resetLetterSpacing(l) {
          var _l$attributes9 = l.attributes,
              s = _l$attributes9 === void 0 ? {} : _l$attributes9,
              c = l.setAttributes;
          var m = s.style;
          c({
            style: (0, E.cleanEmptyObject)(_objectSpread(_objectSpread({}, m), {}, {
              typography: _objectSpread(_objectSpread({}, null == m ? void 0 : m.typography), {}, {
                letterSpacing: void 0
              })
            }))
          });
        }, s.useIsLetterSpacingDisabled = function useIsLetterSpacingDisabled() {
          var _ref400 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              l = _ref400.name;

          var s = !(0, _.hasBlockSupport)(l, w),
              c = (0, y.default)("typography.letterSpacing");
          return s || !c;
        };

        var v = c(1753),
            _ = c(6700),
            k = m(c(9312)),
            y = m(c(3081)),
            E = c(8241);

        var w = "typography.__experimentalLetterSpacing";
        s.LETTER_SPACING_SUPPORT_KEY = w;
      },
      8311: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.LINE_HEIGHT_SUPPORT_KEY = void 0, s.LineHeightEdit = function LineHeightEdit(l) {
          var s;
          var c = l.attributes.style,
              m = l.setAttributes;
          return (0, v.createElement)(k.default, {
            value: null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.lineHeight,
            onChange: function onChange(l) {
              var s = _objectSpread(_objectSpread({}, c), {}, {
                typography: _objectSpread(_objectSpread({}, null == c ? void 0 : c.typography), {}, {
                  lineHeight: l
                })
              });

              m({
                style: (0, y.cleanEmptyObject)(s)
              });
            }
          });
        }, s.hasLineHeightValue = function hasLineHeightValue(l) {
          var s, c;
          return !(null === (s = l.attributes.style) || void 0 === s || null === (c = s.typography) || void 0 === c || !c.lineHeight);
        }, s.resetLineHeight = function resetLineHeight(l) {
          var _l$attributes10 = l.attributes,
              s = _l$attributes10 === void 0 ? {} : _l$attributes10,
              c = l.setAttributes;
          var m = s.style;
          c({
            style: (0, y.cleanEmptyObject)(_objectSpread(_objectSpread({}, m), {}, {
              typography: _objectSpread(_objectSpread({}, null == m ? void 0 : m.typography), {}, {
                lineHeight: void 0
              })
            }))
          });
        }, s.useIsLineHeightDisabled = function useIsLineHeightDisabled() {
          var _ref401 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              l = _ref401.name;

          var s = !(0, E.default)("typography.lineHeight");
          return !(0, _.hasBlockSupport)(l, w) || s;
        };

        var v = c(1753),
            _ = c(6700),
            k = m(c(1628)),
            y = c(8241),
            E = m(c(3081));

        var w = "typography.lineHeight";
        s.LINE_HEIGHT_SUPPORT_KEY = w;
      },
      3455: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.addAttribute = addAttribute;
        var m = c(4793);

        function addAttribute(l) {
          return (0, m.has)(l.attributes, ["lock", "type"]) || (l.attributes = _objectSpread(_objectSpread({}, l.attributes), {}, {
            lock: {
              type: "object"
            }
          })), l;
        }

        (0, c(1149).addFilter)("blocks.registerBlockType", "core/lock/addAttribute", addAttribute);
      },
      1582: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.MarginEdit = function MarginEdit(l) {
          var s;
          var c = l.name,
              m = l.attributes.style,
              k = l.setAttributes,
              S = (0, y.__experimentalUseCustomUnits)({
            availableUnits: (0, E.default)("spacing.units") || ["%", "px", "em", "rem", "vw"]
          }),
              B = (0, w.useCustomSides)(c, "margin"),
              P = B && B.some(function (l) {
            return w.AXIAL_SIDES.includes(l);
          });
          if (useIsMarginDisabled(l)) return null;
          return v.Platform.select({
            web: (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.__experimentalBoxControl, {
              values: null == m || null === (s = m.spacing) || void 0 === s ? void 0 : s.margin,
              onChange: function onChange(l) {
                var s = _objectSpread(_objectSpread({}, m), {}, {
                  spacing: _objectSpread(_objectSpread({}, null == m ? void 0 : m.spacing), {}, {
                    margin: l
                  })
                });

                k({
                  style: (0, C.cleanEmptyObject)(s)
                });
              },
              onChangeShowVisualizer: function onChangeShowVisualizer(l) {
                var s = _objectSpread(_objectSpread({}, m), {}, {
                  visualizers: {
                    margin: l
                  }
                });

                k({
                  style: (0, C.cleanEmptyObject)(s)
                });
              },
              label: (0, _.__)("Margin"),
              sides: B,
              units: S,
              allowReset: !1,
              splitOnAxis: P
            })),
            native: null
          });
        }, s.hasMarginSupport = hasMarginSupport, s.hasMarginValue = function hasMarginValue(l) {
          var s, c;
          return void 0 !== (null === (s = l.attributes.style) || void 0 === s || null === (c = s.spacing) || void 0 === c ? void 0 : c.margin);
        }, s.resetMargin = function resetMargin(l) {
          var _l$attributes11 = l.attributes,
              s = _l$attributes11 === void 0 ? {} : _l$attributes11,
              c = l.setAttributes;
          var m = s.style;
          c({
            style: (0, C.cleanEmptyObject)(_objectSpread(_objectSpread({}, m), {}, {
              spacing: _objectSpread(_objectSpread({}, null == m ? void 0 : m.spacing), {}, {
                margin: void 0
              })
            }))
          });
        }, s.useIsMarginDisabled = useIsMarginDisabled;

        var v = c(1753),
            _ = c(6756),
            k = c(6700),
            y = c(4892),
            E = m(c(3081)),
            w = c(4431),
            C = c(8241);

        function hasMarginSupport(l) {
          var s = (0, k.getBlockSupport)(l, w.SPACING_SUPPORT_KEY);
          return !!(!0 === s || null != s && s.margin);
        }

        function useIsMarginDisabled() {
          var _ref402 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              l = _ref402.name;

          var s = !(0, E.default)("spacing.margin"),
              c = !(0, w.useIsDimensionsSupportValid)(l, "margin");
          return !hasMarginSupport(l) || s || c;
        }
      },
      3093: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.PaddingEdit = function PaddingEdit(l) {
          var s;
          var c = l.name,
              m = l.attributes.style,
              k = l.setAttributes,
              S = (0, y.__experimentalUseCustomUnits)({
            availableUnits: (0, E.default)("spacing.units") || ["%", "px", "em", "rem", "vw"]
          }),
              B = (0, w.useCustomSides)(c, "padding"),
              P = B && B.some(function (l) {
            return w.AXIAL_SIDES.includes(l);
          });
          if (useIsPaddingDisabled(l)) return null;
          return v.Platform.select({
            web: (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.__experimentalBoxControl, {
              values: null == m || null === (s = m.spacing) || void 0 === s ? void 0 : s.padding,
              onChange: function onChange(l) {
                var s = _objectSpread(_objectSpread({}, m), {}, {
                  spacing: _objectSpread(_objectSpread({}, null == m ? void 0 : m.spacing), {}, {
                    padding: l
                  })
                });

                k({
                  style: (0, C.cleanEmptyObject)(s)
                });
              },
              onChangeShowVisualizer: function onChangeShowVisualizer(l) {
                var s = _objectSpread(_objectSpread({}, m), {}, {
                  visualizers: {
                    padding: l
                  }
                });

                k({
                  style: (0, C.cleanEmptyObject)(s)
                });
              },
              label: (0, _.__)("Padding"),
              sides: B,
              units: S,
              allowReset: !1,
              splitOnAxis: P
            })),
            native: null
          });
        }, s.hasPaddingSupport = hasPaddingSupport, s.hasPaddingValue = function hasPaddingValue(l) {
          var s, c;
          return void 0 !== (null === (s = l.attributes.style) || void 0 === s || null === (c = s.spacing) || void 0 === c ? void 0 : c.padding);
        }, s.resetPadding = function resetPadding(l) {
          var _l$attributes12 = l.attributes,
              s = _l$attributes12 === void 0 ? {} : _l$attributes12,
              c = l.setAttributes;
          var m = s.style;
          c({
            style: (0, C.cleanEmptyObject)(_objectSpread(_objectSpread({}, m), {}, {
              spacing: _objectSpread(_objectSpread({}, null == m ? void 0 : m.spacing), {}, {
                padding: void 0
              })
            }))
          });
        }, s.useIsPaddingDisabled = useIsPaddingDisabled;

        var v = c(1753),
            _ = c(6756),
            k = c(6700),
            y = c(4892),
            E = m(c(3081)),
            w = c(4431),
            C = c(8241);

        function hasPaddingSupport(l) {
          var s = (0, k.getBlockSupport)(l, w.SPACING_SUPPORT_KEY);
          return !!(!0 === s || null != s && s.padding);
        }

        function useIsPaddingDisabled() {
          var _ref403 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              l = _ref403.name;

          var s = !(0, E.default)("spacing.padding"),
              c = !(0, w.useIsDimensionsSupportValid)(l, "padding");
          return !hasPaddingSupport(l) || s || c;
        }
      },
      9390: function _(l, s, c) {
        "use strict";

        var _z;

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.addEditProps = addEditProps, s.addSaveProps = addSaveProps, s.getInlineStyles = getInlineStyles, s.withBlockControls = void 0;

        var v = c(1753),
            _ = m(c(5221)),
            k = c(4793),
            y = m(c(2703)),
            E = c(1149),
            w = c(6700),
            C = c(3200),
            S = m(c(9476)),
            B = c(8068),
            P = c(3429),
            O = c(4617),
            L = c(4431),
            V = m(c(7706));

        var R = [].concat(_toConsumableArray(O.TYPOGRAPHY_SUPPORT_KEYS), [B.BORDER_SUPPORT_KEY, P.COLOR_SUPPORT_KEY, L.SPACING_SUPPORT_KEY]),
            hasStyleSupport = function hasStyleSupport(l) {
          return R.some(function (s) {
            return (0, w.hasBlockSupport)(l, s);
          });
        },
            A = "var:";

        function compileStyleValue(l) {
          if ((0, k.startsWith)(l, A)) {
            return "var(--wp--".concat(l.slice(A.length).split("|").join("--"), ")");
          }

          return l;
        }

        function getInlineStyles() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          var s = ["spacing.blockGap"],
              c = {};
          return Object.keys(w.__EXPERIMENTAL_STYLE_PROPERTY).forEach(function (m) {
            var v = w.__EXPERIMENTAL_STYLE_PROPERTY[m].value,
                _ = w.__EXPERIMENTAL_STYLE_PROPERTY[m].properties;

            if ((0, k.has)(l, v) && "elements" !== (0, k.first)(v)) {
              var _y7 = (0, k.get)(l, v);

              _ && !(0, k.isString)(_y7) ? Object.entries(_).forEach(function (l) {
                var _l145 = _slicedToArray(l, 2),
                    s = _l145[0],
                    m = _l145[1],
                    v = (0, k.get)(_y7, [m]);

                v && (c[s] = compileStyleValue(v));
              }) : s.includes(v.join(".")) || (c[m] = compileStyleValue((0, k.get)(l, v)));
            }
          }), c;
        }

        var z = (_z = {}, _defineProperty(_z, "".concat(B.BORDER_SUPPORT_KEY, ".__experimentalSkipSerialization"), ["border"]), _defineProperty(_z, "".concat(P.COLOR_SUPPORT_KEY, ".__experimentalSkipSerialization"), [P.COLOR_SUPPORT_KEY]), _defineProperty(_z, "".concat(O.TYPOGRAPHY_SUPPORT_KEY, ".__experimentalSkipSerialization"), [O.TYPOGRAPHY_SUPPORT_KEY]), _defineProperty(_z, "".concat(L.SPACING_SUPPORT_KEY, ".__experimentalSkipSerialization"), ["spacing"]), _z),
            D = _objectSpread(_objectSpread({}, z), {}, _defineProperty({}, "".concat(L.SPACING_SUPPORT_KEY), ["spacing.blockGap"]));

        function addSaveProps(l, s, c) {
          var m = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : D;
          if (!hasStyleSupport(s)) return l;
          var v = c.style;
          return (0, k.forEach)(m, function (l, c) {
            (0, w.getBlockSupport)(s, c) && (v = (0, k.omit)(v, l));
          }), l.style = _objectSpread(_objectSpread({}, getInlineStyles(v)), l.style), l;
        }

        function addEditProps(l) {
          if (!hasStyleSupport(l)) return l;
          var s = l.getEditWrapperProps;
          return l.getEditWrapperProps = function (c) {
            var m = {};
            return s && (m = s(c)), addSaveProps(m, l, c, z);
          }, l;
        }

        var F = (0, C.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c = (0, V.default)();
            return (0, v.createElement)(v.Fragment, null, c && (0, v.createElement)(v.Fragment, null, (0, v.createElement)(P.ColorEdit, s), (0, v.createElement)(O.TypographyPanel, s), (0, v.createElement)(B.BorderPanel, s), (0, v.createElement)(L.DimensionsPanel, s)), (0, v.createElement)(l, s));
          };
        }, "withToolbarControls");
        s.withBlockControls = F;
        var G = (0, C.createHigherOrderComponent)(function (l) {
          return function (s) {
            var c, m;

            var E = null === (c = s.attributes.style) || void 0 === c ? void 0 : c.elements,
                B = "wp-elements-".concat((0, C.useInstanceId)(l)),
                P = function compileElementsStyles(l) {
              var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return (0, k.map)(s, function (s, c) {
                var m = getInlineStyles(s);
                return (0, k.isEmpty)(m) ? "" : [".".concat(l, " ").concat(w.__EXPERIMENTAL_ELEMENTS[c], "{")].concat(_toConsumableArray((0, k.map)(m, function (l, s) {
                  return "\t".concat((0, k.kebabCase)(s), ": ").concat(l, ";");
                })), ["}"]).join("\n");
              }).join("\n");
            }(B, null === (m = s.attributes.style) || void 0 === m ? void 0 : m.elements),
                O = (0, v.useContext)(S.default.__unstableElementContext);

            return (0, v.createElement)(v.Fragment, null, E && O && (0, v.createPortal)((0, v.createElement)("style", {
              dangerouslySetInnerHTML: {
                __html: P
              }
            }), O), (0, v.createElement)(l, (0, _.default)({}, s, {
              className: E ? (0, y.default)(s.className, B) : s.className
            })));
          };
        });
        (0, E.addFilter)("blocks.registerBlockType", "core/style/addAttribute", function addAttribute(l) {
          return hasStyleSupport(l) ? (l.attributes.style || Object.assign(l.attributes, {
            style: {
              type: "object"
            }
          }), l) : l;
        }), (0, E.addFilter)("blocks.getSaveContent.extraProps", "core/style/addSaveProps", addSaveProps), (0, E.addFilter)("blocks.registerBlockType", "core/style/addEditProps", addEditProps), (0, E.addFilter)("editor.BlockEdit", "core/style/with-block-controls", F), (0, E.addFilter)("editor.BlockListBlock", "core/editor/with-elements-styles", G);
      },
      8504: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.TEXT_DECORATION_SUPPORT_KEY = void 0, s.TextDecorationEdit = function TextDecorationEdit(l) {
          var s;
          var c = l.attributes.style,
              m = l.setAttributes;
          return (0, v.createElement)(k.default, {
            value: null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.textDecoration,
            onChange: function onChange(l) {
              m({
                style: (0, E.cleanEmptyObject)(_objectSpread(_objectSpread({}, c), {}, {
                  typography: _objectSpread(_objectSpread({}, null == c ? void 0 : c.typography), {}, {
                    textDecoration: l
                  })
                }))
              });
            }
          });
        }, s.hasTextDecorationValue = function hasTextDecorationValue(l) {
          var s, c;
          return !(null === (s = l.attributes.style) || void 0 === s || null === (c = s.typography) || void 0 === c || !c.textDecoration);
        }, s.resetTextDecoration = function resetTextDecoration(l) {
          var _l$attributes13 = l.attributes,
              s = _l$attributes13 === void 0 ? {} : _l$attributes13,
              c = l.setAttributes;
          var m = s.style;
          c({
            style: (0, E.cleanEmptyObject)(_objectSpread(_objectSpread({}, m), {}, {
              typography: _objectSpread(_objectSpread({}, null == m ? void 0 : m.typography), {}, {
                textDecoration: void 0
              })
            }))
          });
        }, s.useIsTextDecorationDisabled = function useIsTextDecorationDisabled() {
          var _ref404 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              l = _ref404.name;

          var s = !(0, _.hasBlockSupport)(l, w),
              c = (0, y.default)("typography.textDecoration");
          return s || !c;
        };

        var v = c(1753),
            _ = c(6700),
            k = m(c(7731)),
            y = m(c(3081)),
            E = c(8241);

        var w = "typography.__experimentalTextDecoration";
        s.TEXT_DECORATION_SUPPORT_KEY = w;
      },
      4687: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.TEXT_TRANSFORM_SUPPORT_KEY = void 0, s.TextTransformEdit = function TextTransformEdit(l) {
          var s;
          var c = l.attributes.style,
              m = l.setAttributes;
          return (0, v.createElement)(k.default, {
            value: null == c || null === (s = c.typography) || void 0 === s ? void 0 : s.textTransform,
            onChange: function onChange(l) {
              m({
                style: (0, E.cleanEmptyObject)(_objectSpread(_objectSpread({}, c), {}, {
                  typography: _objectSpread(_objectSpread({}, null == c ? void 0 : c.typography), {}, {
                    textTransform: l
                  })
                }))
              });
            }
          });
        }, s.hasTextTransformValue = function hasTextTransformValue(l) {
          var s, c;
          return !(null === (s = l.attributes.style) || void 0 === s || null === (c = s.typography) || void 0 === c || !c.textTransform);
        }, s.resetTextTransform = function resetTextTransform(l) {
          var _l$attributes14 = l.attributes,
              s = _l$attributes14 === void 0 ? {} : _l$attributes14,
              c = l.setAttributes;
          var m = s.style;
          c({
            style: (0, E.cleanEmptyObject)(_objectSpread(_objectSpread({}, m), {}, {
              typography: _objectSpread(_objectSpread({}, null == m ? void 0 : m.typography), {}, {
                textTransform: void 0
              })
            }))
          });
        }, s.useIsTextTransformDisabled = function useIsTextTransformDisabled() {
          var _ref405 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              l = _ref405.name;

          var s = !(0, _.hasBlockSupport)(l, w),
              c = (0, y.default)("typography.textTransform");
          return s || !c;
        };

        var v = c(1753),
            _ = c(6700),
            k = m(c(4286)),
            y = m(c(3081)),
            E = c(8241);

        var w = "typography.__experimentalTextTransform";
        s.TEXT_TRANSFORM_SUPPORT_KEY = w;
      },
      4617: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.TYPOGRAPHY_SUPPORT_KEYS = s.TYPOGRAPHY_SUPPORT_KEY = void 0, s.TypographyPanel = function TypographyPanel(l) {
          var s = l.clientId,
              c = (0, B.useIsFontFamilyDisabled)(l),
              m = (0, P.useIsFontSizeDisabled)(l),
              A = (0, S.useIsFontAppearanceDisabled)(l),
              z = (0, C.useIsLineHeightDisabled)(l),
              D = (0, O.useIsTextDecorationDisabled)(l),
              F = (0, L.useIsTextTransformDisabled)(l),
              G = (0, V.useIsLetterSpacingDisabled)(l),
              U = !(0, S.useIsFontStyleDisabled)(l),
              W = !(0, S.useIsFontWeightDisabled)(l),
              K = function useIsTypographyDisabled() {
            var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            var s = [(0, S.useIsFontAppearanceDisabled)(l), (0, P.useIsFontSizeDisabled)(l), (0, C.useIsLineHeightDisabled)(l), (0, B.useIsFontFamilyDisabled)(l), (0, O.useIsTextDecorationDisabled)(l), (0, L.useIsTextTransformDisabled)(l), (0, V.useIsLetterSpacingDisabled)(l)];
            return s.filter(Boolean).length === s.length;
          }(l),
              $ = hasTypographySupport(l.name);

          if (K || !$) return null;

          var q = (0, _.getBlockSupport)(l.name, [R, "__experimentalDefaultControls"]),
              createResetAllFilter = function createResetAllFilter(l) {
            return function (s) {
              var c;
              return _objectSpread(_objectSpread({}, s), {}, {
                style: _objectSpread(_objectSpread({}, s.style), {}, {
                  typography: _objectSpread(_objectSpread({}, null === (c = s.style) || void 0 === c ? void 0 : c.typography), {}, _defineProperty({}, l, void 0))
                })
              });
            };
          };

          return (0, v.createElement)(E.default, {
            __experimentalGroup: "typography"
          }, !c && (0, v.createElement)(k.__experimentalToolsPanelItem, {
            hasValue: function hasValue() {
              return (0, B.hasFontFamilyValue)(l);
            },
            label: (0, y.__)("Font family"),
            onDeselect: function onDeselect() {
              return (0, B.resetFontFamily)(l);
            },
            isShownByDefault: null == q ? void 0 : q.fontFamily,
            resetAllFilter: function resetAllFilter(l) {
              return _objectSpread(_objectSpread({}, l), {}, {
                fontFamily: void 0
              });
            },
            panelId: s
          }, (0, v.createElement)(B.FontFamilyEdit, l)), !m && (0, v.createElement)(k.__experimentalToolsPanelItem, {
            hasValue: function hasValue() {
              return (0, P.hasFontSizeValue)(l);
            },
            label: (0, y.__)("Font size"),
            onDeselect: function onDeselect() {
              return (0, P.resetFontSize)(l);
            },
            isShownByDefault: null == q ? void 0 : q.fontSize,
            resetAllFilter: function resetAllFilter(l) {
              var s;
              return _objectSpread(_objectSpread({}, l), {}, {
                fontSize: void 0,
                style: _objectSpread(_objectSpread({}, l.style), {}, {
                  typography: _objectSpread(_objectSpread({}, null === (s = l.style) || void 0 === s ? void 0 : s.typography), {}, {
                    fontSize: void 0
                  })
                })
              });
            },
            panelId: s
          }, (0, v.createElement)(P.FontSizeEdit, l)), !A && (0, v.createElement)(k.__experimentalToolsPanelItem, {
            className: "single-column",
            hasValue: function hasValue() {
              return (0, S.hasFontAppearanceValue)(l);
            },
            label: (0, w.getFontAppearanceLabel)(U, W),
            onDeselect: function onDeselect() {
              return (0, S.resetFontAppearance)(l);
            },
            isShownByDefault: null == q ? void 0 : q.fontAppearance,
            resetAllFilter: function resetAllFilter(l) {
              var s;
              return _objectSpread(_objectSpread({}, l), {}, {
                style: _objectSpread(_objectSpread({}, l.style), {}, {
                  typography: _objectSpread(_objectSpread({}, null === (s = l.style) || void 0 === s ? void 0 : s.typography), {}, {
                    fontStyle: void 0,
                    fontWeight: void 0
                  })
                })
              });
            },
            panelId: s
          }, (0, v.createElement)(S.FontAppearanceEdit, l)), !z && (0, v.createElement)(k.__experimentalToolsPanelItem, {
            className: "single-column",
            hasValue: function hasValue() {
              return (0, C.hasLineHeightValue)(l);
            },
            label: (0, y.__)("Line height"),
            onDeselect: function onDeselect() {
              return (0, C.resetLineHeight)(l);
            },
            isShownByDefault: null == q ? void 0 : q.lineHeight,
            resetAllFilter: createResetAllFilter("lineHeight"),
            panelId: s
          }, (0, v.createElement)(C.LineHeightEdit, l)), !D && (0, v.createElement)(k.__experimentalToolsPanelItem, {
            className: "single-column",
            hasValue: function hasValue() {
              return (0, O.hasTextDecorationValue)(l);
            },
            label: (0, y.__)("Decoration"),
            onDeselect: function onDeselect() {
              return (0, O.resetTextDecoration)(l);
            },
            isShownByDefault: null == q ? void 0 : q.textDecoration,
            resetAllFilter: createResetAllFilter("textDecoration"),
            panelId: s
          }, (0, v.createElement)(O.TextDecorationEdit, l)), !F && (0, v.createElement)(k.__experimentalToolsPanelItem, {
            className: "single-column",
            hasValue: function hasValue() {
              return (0, L.hasTextTransformValue)(l);
            },
            label: (0, y.__)("Letter case"),
            onDeselect: function onDeselect() {
              return (0, L.resetTextTransform)(l);
            },
            isShownByDefault: null == q ? void 0 : q.textTransform,
            resetAllFilter: createResetAllFilter("textTransform"),
            panelId: s
          }, (0, v.createElement)(L.TextTransformEdit, l)), !G && (0, v.createElement)(k.__experimentalToolsPanelItem, {
            className: "single-column",
            hasValue: function hasValue() {
              return (0, V.hasLetterSpacingValue)(l);
            },
            label: (0, y.__)("Letter-spacing"),
            onDeselect: function onDeselect() {
              return (0, V.resetLetterSpacing)(l);
            },
            isShownByDefault: null == q ? void 0 : q.letterSpacing,
            resetAllFilter: createResetAllFilter("letterSpacing"),
            panelId: s
          }, (0, v.createElement)(V.LetterSpacingEdit, l)));
        }, s.hasTypographySupport = void 0;

        var v = c(1753),
            _ = c(6700),
            k = c(4892),
            y = c(6756),
            E = m(c(5071)),
            w = c(4601),
            C = c(8311),
            S = c(3735),
            B = c(4359),
            P = c(3981),
            O = c(8504),
            L = c(4687),
            V = c(5658);

        var R = "typography";
        s.TYPOGRAPHY_SUPPORT_KEY = R;
        var A = [C.LINE_HEIGHT_SUPPORT_KEY, P.FONT_SIZE_SUPPORT_KEY, S.FONT_STYLE_SUPPORT_KEY, S.FONT_WEIGHT_SUPPORT_KEY, B.FONT_FAMILY_SUPPORT_KEY, O.TEXT_DECORATION_SUPPORT_KEY, L.TEXT_TRANSFORM_SUPPORT_KEY, V.LETTER_SPACING_SUPPORT_KEY];
        s.TYPOGRAPHY_SUPPORT_KEYS = A;

        var hasTypographySupport = function hasTypographySupport(l) {
          return A.some(function (s) {
            return (0, _.hasBlockSupport)(l, s);
          });
        };

        s.hasTypographySupport = hasTypographySupport;
      },
      1123: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getBorderClassesAndStyles = getBorderClassesAndStyles, s.useBorderProps = function useBorderProps(l) {
          var s = (0, y.default)("color.palette") || E,
              c = getBorderClassesAndStyles(l);

          if (l.borderColor) {
            var _m38 = (0, k.getColorObjectByAttributeValues)(s, l.borderColor);

            c.style.borderColor = _m38.color;
          }

          return c;
        };

        var v = m(c(2703)),
            _ = c(9390),
            k = c(4459),
            y = m(c(3081));

        var E = [];

        function getBorderClassesAndStyles(l) {
          var _ref406;

          var s;
          var c = l.borderColor,
              m = l.style;
          var y = (null == m ? void 0 : m.border) || {},
              E = (0, k.getColorClassName)("border-color", c);
          return {
            className: (0, v.default)((_ref406 = {}, _defineProperty(_ref406, E, !!E), _defineProperty(_ref406, "has-border-color", c || (null == m || null === (s = m.border) || void 0 === s ? void 0 : s.color)), _ref406)) || void 0,
            style: (0, _.getInlineStyles)({
              border: y
            })
          };
        }
      },
      1475: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.useCachedTruthy = function useCachedTruthy(l) {
          var _ref407 = (0, m.useState)(l),
              _ref408 = _slicedToArray(_ref407, 2),
              s = _ref408[0],
              c = _ref408[1];

          return (0, m.useEffect)(function () {
            l && c(l);
          }, [l]), s;
        };
        var m = c(1753);
      },
      1617: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getColorClassesAndStyles = getColorClassesAndStyles, s.useColorProps = function useColorProps(l) {
          var s = l.backgroundColor,
              c = l.textColor,
              m = l.gradient,
              v = (0, w.default)("color.palette.custom") || [],
              k = (0, w.default)("color.palette.theme") || [],
              S = (0, w.default)("color.palette.default") || [],
              B = (0, w.default)("color.gradients") || C,
              P = (0, _.useMemo)(function () {
            return [].concat(_toConsumableArray(v || []), _toConsumableArray(k || []), _toConsumableArray(S || []));
          }, [v, k, S]),
              O = (0, _.useMemo)(function () {
            return [].concat(_toConsumableArray((null == B ? void 0 : B.custom) || []), _toConsumableArray((null == B ? void 0 : B.theme) || []), _toConsumableArray((null == B ? void 0 : B.default) || []));
          }, [B]),
              L = getColorClassesAndStyles(l);

          if (s) {
            var _l146 = (0, y.getColorObjectByAttributeValues)(P, s);

            L.style.backgroundColor = _l146.color;
          }

          m && (L.style.background = (0, E.getGradientValueBySlug)(O, m));

          if (c) {
            var _l147 = (0, y.getColorObjectByAttributeValues)(P, c);

            L.style.color = _l147.color;
          }

          return L;
        };

        var v = m(c(2703)),
            _ = c(1753),
            k = c(9390),
            y = c(4459),
            E = c(5261),
            w = m(c(3081));

        function getColorClassesAndStyles(l) {
          var _ref409;

          var s, c, m, _, w, C;

          var S = l.backgroundColor,
              B = l.textColor,
              P = l.gradient,
              O = l.style,
              L = (0, y.getColorClassName)("background-color", S),
              V = (0, y.getColorClassName)("color", B),
              R = (0, E.__experimentalGetGradientClass)(P),
              A = R || (null == O || null === (s = O.color) || void 0 === s ? void 0 : s.gradient),
              z = (0, v.default)(V, R, (_ref409 = {}, _defineProperty(_ref409, L, !A && !!L), _defineProperty(_ref409, "has-text-color", B || (null == O || null === (c = O.color) || void 0 === c ? void 0 : c.text)), _defineProperty(_ref409, "has-background", S || (null == O || null === (m = O.color) || void 0 === m ? void 0 : m.background) || P || (null == O || null === (_ = O.color) || void 0 === _ ? void 0 : _.gradient)), _defineProperty(_ref409, "has-link-color", null == O || null === (w = O.elements) || void 0 === w || null === (C = w.link) || void 0 === C ? void 0 : C.color), _ref409)),
              D = (null == O ? void 0 : O.color) || {};
          return {
            className: z || void 0,
            style: (0, k.getInlineStyles)({
              color: D
            })
          };
        }

        var C = {};
      },
      6682: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getSpacingClassesAndStyles = function getSpacingClassesAndStyles(l) {
          var s = l.style,
              c = (null == s ? void 0 : s.spacing) || {};
          return {
            style: (0, m.getInlineStyles)({
              spacing: c
            })
          };
        };
        var m = c(9390);
      },
      8241: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.cleanEmptyObject = void 0;
        var m = c(4793);

        var cleanEmptyObject = function cleanEmptyObject(l) {
          if (!(0, m.isObject)(l) || Array.isArray(l)) return l;
          var s = (0, m.pickBy)((0, m.mapValues)(l, cleanEmptyObject), m.identity);
          return (0, m.isEmpty)(s) ? void 0 : s;
        };

        s.cleanEmptyObject = cleanEmptyObject;
      },
      7686: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        });
        var m = {
          __experimentalGetBorderClassesAndStyles: !0,
          __experimentalUseBorderProps: !0,
          __experimentalGetColorClassesAndStyles: !0,
          __experimentalUseColorProps: !0,
          __experimentalUseCustomSides: !0,
          __experimentalGetSpacingClassesAndStyles: !0,
          useCachedTruthy: !0,
          storeConfig: !0,
          store: !0,
          SETTINGS_DEFAULTS: !0
        };
        Object.defineProperty(s, "SETTINGS_DEFAULTS", {
          enumerable: !0,
          get: function get() {
            return E.SETTINGS_DEFAULTS;
          }
        }), Object.defineProperty(s, "__experimentalGetBorderClassesAndStyles", {
          enumerable: !0,
          get: function get() {
            return v.getBorderClassesAndStyles;
          }
        }), Object.defineProperty(s, "__experimentalGetColorClassesAndStyles", {
          enumerable: !0,
          get: function get() {
            return v.getColorClassesAndStyles;
          }
        }), Object.defineProperty(s, "__experimentalGetSpacingClassesAndStyles", {
          enumerable: !0,
          get: function get() {
            return v.getSpacingClassesAndStyles;
          }
        }), Object.defineProperty(s, "__experimentalUseBorderProps", {
          enumerable: !0,
          get: function get() {
            return v.useBorderProps;
          }
        }), Object.defineProperty(s, "__experimentalUseColorProps", {
          enumerable: !0,
          get: function get() {
            return v.useColorProps;
          }
        }), Object.defineProperty(s, "__experimentalUseCustomSides", {
          enumerable: !0,
          get: function get() {
            return v.useCustomSides;
          }
        }), Object.defineProperty(s, "store", {
          enumerable: !0,
          get: function get() {
            return y.store;
          }
        }), Object.defineProperty(s, "storeConfig", {
          enumerable: !0,
          get: function get() {
            return y.storeConfig;
          }
        }), Object.defineProperty(s, "useCachedTruthy", {
          enumerable: !0,
          get: function get() {
            return v.useCachedTruthy;
          }
        });

        var v = c(5227),
            _ = c(6330);

        Object.keys(_).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (Object.prototype.hasOwnProperty.call(m, l) || l in s && s[l] === _[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return _[l];
            }
          }));
        });
        var k = c(1686);
        Object.keys(k).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (Object.prototype.hasOwnProperty.call(m, l) || l in s && s[l] === k[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return k[l];
            }
          }));
        });
        var y = c(8486),
            E = c(1822);
      },
      8354: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(6756),
            k = c(2614),
            y = c(4892),
            E = c(6006),
            w = m(c(3081)),
            C = c(6330);

        var S = {
          left: "flex-start",
          right: "flex-end",
          center: "center",
          "space-between": "space-between"
        },
            B = {
          left: "flex-start",
          right: "flex-end",
          center: "center"
        },
            P = ["wrap", "nowrap"];
        var O = {
          name: "flex",
          label: (0, _.__)("Flex"),
          inspectorControls: function FlexLayoutInspectorControls(l) {
            var _l$layout2 = l.layout,
                s = _l$layout2 === void 0 ? {} : _l$layout2,
                c = l.onChange;
            var _s$allowOrientation = s.allowOrientation,
                m = _s$allowOrientation === void 0 ? !0 : _s$allowOrientation;
            return (0, v.createElement)(v.Fragment, null, (0, v.createElement)(y.Flex, null, (0, v.createElement)(y.FlexItem, null, (0, v.createElement)(FlexLayoutJustifyContentControl, {
              layout: s,
              onChange: c
            })), (0, v.createElement)(y.FlexItem, null, m && (0, v.createElement)(OrientationControl, {
              layout: s,
              onChange: c
            }))), (0, v.createElement)(FlexWrapControl, {
              layout: s,
              onChange: c
            }));
          },
          toolBarControls: function FlexLayoutToolbarControls(l) {
            var _l$layout3 = l.layout,
                s = _l$layout3 === void 0 ? {} : _l$layout3,
                c = l.onChange,
                m = l.layoutBlockSupport;
            return null != m && m.allowSwitching ? null : (0, v.createElement)(C.BlockControls, {
              group: "block",
              __experimentalShareWithChildBlocks: !0
            }, (0, v.createElement)(FlexLayoutJustifyContentControl, {
              layout: s,
              onChange: c,
              isToolbar: !0
            }));
          },
          save: function FlexLayoutStyle(l) {
            var s, c;
            var m = l.selector,
                _ = l.layout,
                k = l.style;
            var _$orientation = _.orientation,
                y = _$orientation === void 0 ? "horizontal" : _$orientation,
                C = null !== (0, w.default)("spacing.blockGap"),
                O = null !== (s = null == k || null === (c = k.spacing) || void 0 === c ? void 0 : c.blockGap) && void 0 !== s ? s : "var( --wp--style--block-gap, 0.5em )",
                L = S[_.justifyContent] || S.left,
                V = P.includes(_.flexWrap) ? _.flexWrap : "wrap",
                R = "\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: ".concat(L, ";\n\t\t"),
                A = "\n\t\tflex-direction: column;\n\t\talign-items: ".concat(B[_.justifyContent] || B.left, ";\n\t\t");
            return (0, v.createElement)("style", null, "\n\t\t\t\t".concat((0, E.appendSelectors)(m), " {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tgap: ").concat(C ? O : "0.5em", ";\n\t\t\t\t\tflex-wrap: ").concat(V, ";\n\t\t\t\t\t").concat("horizontal" === y ? R : A, "\n\t\t\t\t}\n\n\t\t\t\t").concat((0, E.appendSelectors)(m, "> *"), " {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t}\n\t\t\t"));
          },
          getOrientation: function getOrientation(l) {
            var _l$orientation = l.orientation,
                s = _l$orientation === void 0 ? "horizontal" : _l$orientation;
            return s;
          },
          getAlignments: function getAlignments() {
            return [];
          }
        };

        function FlexLayoutJustifyContentControl(l) {
          var s = l.layout,
              c = l.onChange,
              _l$isToolbar = l.isToolbar,
              m = _l$isToolbar === void 0 ? !1 : _l$isToolbar;

          var _s$justifyContent = s.justifyContent,
              E = _s$justifyContent === void 0 ? "left" : _s$justifyContent,
              _s$orientation = s.orientation,
              w = _s$orientation === void 0 ? "horizontal" : _s$orientation,
              onJustificationChange = function onJustificationChange(l) {
            c(_objectSpread(_objectSpread({}, s), {}, {
              justifyContent: l
            }));
          },
              S = ["left", "center", "right"];

          if ("horizontal" === w && S.push("space-between"), m) return (0, v.createElement)(C.JustifyContentControl, {
            allowedControls: S,
            value: E,
            onChange: onJustificationChange,
            popoverProps: {
              position: "bottom right",
              isAlternate: !0
            }
          });
          var B = [{
            value: "left",
            icon: k.justifyLeft,
            label: (0, _.__)("Justify items left")
          }, {
            value: "center",
            icon: k.justifyCenter,
            label: (0, _.__)("Justify items center")
          }, {
            value: "right",
            icon: k.justifyRight,
            label: (0, _.__)("Justify items right")
          }];
          return "horizontal" === w && B.push({
            value: "space-between",
            icon: k.justifySpaceBetween,
            label: (0, _.__)("Space between items")
          }), (0, v.createElement)("fieldset", {
            className: "block-editor-hooks__flex-layout-justification-controls"
          }, (0, v.createElement)("legend", null, (0, _.__)("Justification")), (0, v.createElement)("div", null, B.map(function (l) {
            var s = l.value,
                c = l.icon,
                m = l.label;
            return (0, v.createElement)(y.Button, {
              key: s,
              label: m,
              icon: c,
              isPressed: E === s,
              onClick: function onClick() {
                return onJustificationChange(s);
              }
            });
          })));
        }

        function FlexWrapControl(l) {
          var s = l.layout,
              c = l.onChange;
          var _s$flexWrap = s.flexWrap,
              m = _s$flexWrap === void 0 ? "wrap" : _s$flexWrap;
          return (0, v.createElement)(y.ToggleControl, {
            label: (0, _.__)("Allow to wrap to multiple lines"),
            onChange: function onChange(l) {
              c(_objectSpread(_objectSpread({}, s), {}, {
                flexWrap: l ? "wrap" : "nowrap"
              }));
            },
            checked: "wrap" === m
          });
        }

        function OrientationControl(l) {
          var s = l.layout,
              c = l.onChange;
          var _s$orientation2 = s.orientation,
              m = _s$orientation2 === void 0 ? "horizontal" : _s$orientation2;
          return (0, v.createElement)("fieldset", {
            className: "block-editor-hooks__flex-layout-orientation-controls"
          }, (0, v.createElement)("legend", null, (0, _.__)("Orientation")), (0, v.createElement)(y.Button, {
            label: "horizontal",
            icon: k.arrowRight,
            isPressed: "horizontal" === m,
            onClick: function onClick() {
              return c(_objectSpread(_objectSpread({}, s), {}, {
                orientation: "horizontal"
              }));
            }
          }), (0, v.createElement)(y.Button, {
            label: "vertical",
            icon: k.arrowDown,
            isPressed: "vertical" === m,
            onClick: function onClick() {
              return c(_objectSpread(_objectSpread({}, s), {}, {
                orientation: "vertical"
              }));
            }
          }));
        }

        s.default = O;
      },
      3162: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(1753),
            _ = c(4892),
            k = c(6756),
            y = c(2614),
            E = m(c(3081)),
            w = c(6006),
            C = {
          name: "default",
          label: (0, k.__)("Flow"),
          inspectorControls: function DefaultLayoutInspectorControls(l) {
            var s = l.layout,
                c = l.onChange;
            var m = s.wideSize,
                w = s.contentSize,
                C = (0, _.__experimentalUseCustomUnits)({
              availableUnits: (0, E.default)("spacing.units") || ["%", "px", "em", "rem", "vw"]
            });
            return (0, v.createElement)(v.Fragment, null, (0, v.createElement)("div", {
              className: "block-editor-hooks__layout-controls"
            }, (0, v.createElement)("div", {
              className: "block-editor-hooks__layout-controls-unit"
            }, (0, v.createElement)(_.__experimentalUnitControl, {
              label: (0, k.__)("Content"),
              labelPosition: "top",
              __unstableInputWidth: "80px",
              value: w || m || "",
              onChange: function onChange(l) {
                l = 0 > parseFloat(l) ? "0" : l, c(_objectSpread(_objectSpread({}, s), {}, {
                  contentSize: l
                }));
              },
              units: C
            }), (0, v.createElement)(y.Icon, {
              icon: y.positionCenter
            })), (0, v.createElement)("div", {
              className: "block-editor-hooks__layout-controls-unit"
            }, (0, v.createElement)(_.__experimentalUnitControl, {
              label: (0, k.__)("Wide"),
              labelPosition: "top",
              __unstableInputWidth: "80px",
              value: m || w || "",
              onChange: function onChange(l) {
                l = 0 > parseFloat(l) ? "0" : l, c(_objectSpread(_objectSpread({}, s), {}, {
                  wideSize: l
                }));
              },
              units: C
            }), (0, v.createElement)(y.Icon, {
              icon: y.stretchWide
            }))), (0, v.createElement)("div", {
              className: "block-editor-hooks__layout-controls-reset"
            }, (0, v.createElement)(_.Button, {
              variant: "secondary",
              isSmall: !0,
              disabled: !w && !m,
              onClick: function onClick() {
                return c({
                  contentSize: void 0,
                  wideSize: void 0,
                  inherit: !1
                });
              }
            }, (0, k.__)("Reset"))), (0, v.createElement)("p", {
              className: "block-editor-hooks__layout-controls-helptext"
            }, (0, k.__)("Customize the width for all elements that are assigned to the center or wide columns.")));
          },
          toolBarControls: function DefaultLayoutToolbarControls() {
            return null;
          },
          save: function DefaultLayoutStyle(l) {
            var s, c;

            var m = l.selector,
                _l$layout4 = l.layout,
                _ = _l$layout4 === void 0 ? {} : _l$layout4,
                k = l.style;

            var y = _.contentSize,
                C = _.wideSize,
                S = null !== (0, E.default)("spacing.blockGap"),
                B = null !== (s = null == k || null === (c = k.spacing) || void 0 === c ? void 0 : c.blockGap) && void 0 !== s ? s : "var( --wp--style--block-gap )";
            var P = y || C ? "\n\t\t\t\t\t".concat((0, w.appendSelectors)(m, "> *"), " {\n\t\t\t\t\t\tmax-width: ").concat(null != y ? y : C, ";\n\t\t\t\t\t\tmargin-left: auto !important;\n\t\t\t\t\t\tmargin-right: auto !important;\n\t\t\t\t\t}\n\n\t\t\t\t\t").concat((0, w.appendSelectors)(m, '> [data-align="wide"]'), "  {\n\t\t\t\t\t\tmax-width: ").concat(null != C ? C : y, ";\n\t\t\t\t\t}\n\n\t\t\t\t\t").concat((0, w.appendSelectors)(m, '> [data-align="full"]'), " {\n\t\t\t\t\t\tmax-width: none;\n\t\t\t\t\t}\n\t\t\t\t") : "";
            return P += "\n\t\t\t".concat((0, w.appendSelectors)(m, '> [data-align="left"]'), " {\n\t\t\t\tfloat: left;\n\t\t\t\tmargin-right: 2em;\n\t\t\t}\n\n\t\t\t").concat((0, w.appendSelectors)(m, '> [data-align="right"]'), " {\n\t\t\t\tfloat: right;\n\t\t\t\tmargin-left: 2em;\n\t\t\t}\n\n\t\t"), S && (P += "\n\t\t\t\t".concat((0, w.appendSelectors)(m, "> *"), " {\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t\t").concat((0, w.appendSelectors)(m, "> * + *"), " {\n\t\t\t\t\tmargin-top: ").concat(B, ";\n\t\t\t\t}\n\t\t\t")), (0, v.createElement)("style", null, P);
          },
          getOrientation: function getOrientation() {
            return "vertical";
          },
          getAlignments: function getAlignments(l) {
            var s = function getAlignmentsInfo(l) {
              var s = l.contentSize,
                  c = l.wideSize,
                  m = {},
                  v = /^(?!0)\d+(px|em|rem|vw|vh|%)?$/i;
              v.test(s) && (m.none = (0, k.sprintf)((0, k.__)("Max %s wide"), s));
              v.test(c) && (m.wide = (0, k.sprintf)((0, k.__)("Max %s wide"), c));
              return m;
            }(l);

            if (void 0 !== l.alignments) return l.alignments.includes("none") || l.alignments.unshift("none"), l.alignments.map(function (l) {
              return {
                name: l,
                info: s[l]
              };
            });
            var c = l.contentSize,
                m = l.wideSize,
                v = [{
              name: "left"
            }, {
              name: "center"
            }, {
              name: "right"
            }];
            return c && v.unshift({
              name: "full"
            }), m && v.unshift({
              name: "wide",
              info: s.wide
            }), v.unshift({
              name: "none",
              info: s.none
            }), v;
          }
        };

        s.default = C;
      },
      6633: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getLayoutType = function getLayoutType() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default";
          return _.find(function (s) {
            return s.name === l;
          });
        }, s.getLayoutTypes = function getLayoutTypes() {
          return _;
        };
        var v = m(c(8354));
        var _ = [m(c(3162)).default, v.default];
      },
      6006: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.appendSelectors = function appendSelectors(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
          return l.split(",").map(function (l) {
            return ".editor-styles-wrapper ".concat(l, " ").concat(s);
          }).join(",");
        };
      },
      2372: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.__unstableMarkAutomaticChange = void 0, s.__unstableMarkLastChangeAsPersistent = function __unstableMarkLastChangeAsPersistent() {
          return {
            type: "MARK_LAST_CHANGE_AS_PERSISTENT"
          };
        }, s.__unstableMarkNextChangeAsNotPersistent = function __unstableMarkNextChangeAsNotPersistent() {
          return {
            type: "MARK_NEXT_CHANGE_AS_NOT_PERSISTENT"
          };
        }, s.__unstableSaveReusableBlock = function __unstableSaveReusableBlock(l, s) {
          return {
            type: "SAVE_REUSABLE_BLOCK_SUCCESS",
            id: l,
            updatedId: s
          };
        }, s.clearSelectedBlock = function clearSelectedBlock() {
          return {
            type: "CLEAR_SELECTED_BLOCK"
          };
        }, s.duplicateBlocks = void 0, s.enterFormattedText = function enterFormattedText() {
          return {
            type: "ENTER_FORMATTED_TEXT"
          };
        }, s.exitFormattedText = function exitFormattedText() {
          return {
            type: "EXIT_FORMATTED_TEXT"
          };
        }, s.flashBlock = void 0, s.hideInsertionPoint = function hideInsertionPoint() {
          return {
            type: "HIDE_INSERTION_POINT"
          };
        }, s.insertBeforeBlock = s.insertAfterBlock = void 0, s.insertBlock = insertBlock, s.insertBlocks = void 0, s.insertDefaultBlock = function insertDefaultBlock(l, s, c) {
          var m = (0, _.getDefaultBlockName)();
          if (!m) return;
          return insertBlock((0, _.createBlock)(m, l), c, s);
        }, s.mergeBlocks = void 0, s.moveBlockToPosition = function moveBlockToPosition(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
              m = arguments.length > 3 ? arguments[3] : void 0;
          return moveBlocksToPosition([l], s, c, m);
        }, s.multiSelect = s.moveBlocksUp = s.moveBlocksToPosition = s.moveBlocksDown = void 0, s.receiveBlocks = function receiveBlocks(l) {
          return (0, w.default)('wp.data.dispatch( "core/block-editor" ).receiveBlocks', {
            since: "5.9",
            alternative: "resetBlocks or insertBlocks"
          }), {
            type: "RECEIVE_BLOCKS",
            blocks: l
          };
        }, s.removeBlock = function removeBlock(l, s) {
          return removeBlocks([l], s);
        }, s.removeBlocks = void 0, s.replaceBlock = function replaceBlock(l, s) {
          return replaceBlocks(l, s);
        }, s.replaceBlocks = void 0, s.replaceInnerBlocks = function replaceInnerBlocks(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
              m = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
          return {
            type: "REPLACE_INNER_BLOCKS",
            rootClientId: l,
            blocks: s,
            updateSelection: c,
            initialPosition: c ? m : null,
            time: Date.now()
          };
        }, s.resetBlocks = void 0, s.resetSelection = function resetSelection(l, s, c) {
          return {
            type: "RESET_SELECTION",
            selectionStart: l,
            selectionEnd: s,
            initialPosition: c
          };
        }, s.selectBlock = function selectBlock(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          return {
            type: "SELECT_BLOCK",
            initialPosition: s,
            clientId: l
          };
        }, s.selectPreviousBlock = s.selectNextBlock = void 0, s.selectionChange = function selectionChange(l, s, c, m) {
          return {
            type: "SELECTION_CHANGE",
            clientId: l,
            attributeKey: s,
            startOffset: c,
            endOffset: m
          };
        }, s.setBlockMovingClientId = void 0, s.setHasControlledInnerBlocks = function setHasControlledInnerBlocks(l, s) {
          return {
            type: "SET_HAS_CONTROLLED_INNER_BLOCKS",
            hasControlledInnerBlocks: s,
            clientId: l
          };
        }, s.setNavigationMode = void 0, s.setTemplateValidity = function setTemplateValidity(l) {
          return {
            type: "SET_TEMPLATE_VALIDITY",
            isValid: l
          };
        }, s.showInsertionPoint = function showInsertionPoint(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          var m = c.__unstableWithInserter;
          return {
            type: "SHOW_INSERTION_POINT",
            rootClientId: l,
            index: s,
            __unstableWithInserter: m
          };
        }, s.startDraggingBlocks = function startDraggingBlocks() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          return {
            type: "START_DRAGGING_BLOCKS",
            clientIds: l
          };
        }, s.startMultiSelect = function startMultiSelect() {
          return {
            type: "START_MULTI_SELECT"
          };
        }, s.startTyping = function startTyping() {
          return {
            type: "START_TYPING"
          };
        }, s.stopDraggingBlocks = function stopDraggingBlocks() {
          return {
            type: "STOP_DRAGGING_BLOCKS"
          };
        }, s.stopMultiSelect = function stopMultiSelect() {
          return {
            type: "STOP_MULTI_SELECT"
          };
        }, s.stopTyping = function stopTyping() {
          return {
            type: "STOP_TYPING"
          };
        }, s.synchronizeTemplate = void 0, s.toggleBlockHighlight = toggleBlockHighlight, s.toggleBlockMode = function toggleBlockMode(l) {
          return {
            type: "TOGGLE_BLOCK_MODE",
            clientId: l
          };
        }, s.toggleSelection = function toggleSelection() {
          var l = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          return {
            type: "TOGGLE_SELECTION",
            isSelectionEnabled: l
          };
        }, s.updateBlock = function updateBlock(l, s) {
          return {
            type: "UPDATE_BLOCK",
            clientId: l,
            updates: s
          };
        }, s.updateBlockAttributes = function updateBlockAttributes(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return {
            type: "UPDATE_BLOCK_ATTRIBUTES",
            clientIds: (0, v.castArray)(l),
            attributes: s,
            uniqueByBlock: c
          };
        }, s.updateBlockListSettings = function updateBlockListSettings(l, s) {
          return {
            type: "UPDATE_BLOCK_LIST_SETTINGS",
            clientId: l,
            settings: s
          };
        }, s.updateSettings = function updateSettings(l) {
          return {
            type: "UPDATE_SETTINGS",
            settings: l
          };
        }, s.validateBlocksToTemplate = void 0;

        var v = c(4793),
            _ = c(6700),
            k = c(9773),
            y = c(6756),
            E = c(7060),
            w = m(c(3703));

        s.resetBlocks = function (l) {
          return function (s) {
            var c = s.dispatch;
            c({
              type: "RESET_BLOCKS",
              blocks: l
            }), c(validateBlocksToTemplate(l));
          };
        };

        var validateBlocksToTemplate = function validateBlocksToTemplate(l) {
          return function (s) {
            var c = s.select,
                m = s.dispatch;
            var v = c.getTemplate(),
                k = c.getTemplateLock(),
                y = !v || "all" !== k || (0, _.doBlocksMatchTemplate)(l, v);
            if (y !== c.isValidTemplate()) return m.setTemplateValidity(y), y;
          };
        };

        s.validateBlocksToTemplate = validateBlocksToTemplate;

        s.selectPreviousBlock = function (l) {
          return function (s) {
            var c = s.select,
                m = s.dispatch;
            var v = c.getPreviousBlockClientId(l);
            v && m.selectBlock(v, -1);
          };
        };

        s.selectNextBlock = function (l) {
          return function (s) {
            var c = s.select,
                m = s.dispatch;
            var v = c.getNextBlockClientId(l);
            v && m.selectBlock(v);
          };
        };

        function getBlocksWithDefaultStylesApplied(l, s) {
          var c, m;
          var v = null !== (c = null == s || null === (m = s.__experimentalPreferredStyleVariations) || void 0 === m ? void 0 : m.value) && void 0 !== c ? c : {};
          return l.map(function (l) {
            var s;
            var c = l.name;
            if (!(0, _.hasBlockSupport)(c, "defaultStylePicker", !0)) return l;
            if (!v[c]) return l;
            var m = null === (s = l.attributes) || void 0 === s ? void 0 : s.className;
            if (null != m && m.includes("is-style-")) return l;
            var _l$attributes15 = l.attributes,
                k = _l$attributes15 === void 0 ? {} : _l$attributes15,
                y = v[c];
            return _objectSpread(_objectSpread({}, l), {}, {
              attributes: _objectSpread(_objectSpread({}, k), {}, {
                className: "".concat(m || "", " is-style-").concat(y).trim()
              })
            });
          });
        }

        s.multiSelect = function (l, s) {
          return function (c) {
            var m = c.select,
                v = c.dispatch;
            if (m.getBlockRootClientId(l) !== m.getBlockRootClientId(s)) return;
            v({
              type: "MULTI_SELECT",
              start: l,
              end: s
            });

            var _ = m.getSelectedBlockCount();

            (0, k.speak)((0, y.sprintf)((0, y._n)("%s block selected.", "%s blocks selected.", _), _), "assertive");
          };
        };

        var replaceBlocks = function replaceBlocks(l, s, c) {
          var m = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
              _ = arguments.length > 4 ? arguments[4] : void 0;

          return function (k) {
            var y = k.select,
                E = k.dispatch;
            l = (0, v.castArray)(l), s = getBlocksWithDefaultStylesApplied((0, v.castArray)(s), y.getSettings());
            var w = y.getBlockRootClientId((0, v.first)(l));

            for (var _l148 = 0; _l148 < s.length; _l148++) {
              var _c47 = s[_l148];
              if (!y.canInsertBlockType(_c47.name, w)) return;
            }

            E({
              type: "REPLACE_BLOCKS",
              clientIds: l,
              blocks: s,
              time: Date.now(),
              indexToSelect: c,
              initialPosition: m,
              meta: _
            }), E(function (l) {
              var s = l.select,
                  c = l.dispatch;
              if (s.getBlockCount() > 0) return;

              var _s$getSettings = s.getSettings(),
                  m = _s$getSettings.__unstableHasCustomAppender;

              m || c.insertDefaultBlock();
            });
          };
        };

        s.replaceBlocks = replaceBlocks;

        var createOnMove = function createOnMove(l) {
          return function (s, c) {
            return function (m) {
              var _ = m.select,
                  k = m.dispatch;
              _.canMoveBlocks(s, c) && k({
                type: l,
                clientIds: (0, v.castArray)(s),
                rootClientId: c
              });
            };
          };
        },
            C = createOnMove("MOVE_BLOCKS_DOWN");

        s.moveBlocksDown = C;
        var S = createOnMove("MOVE_BLOCKS_UP");
        s.moveBlocksUp = S;

        var moveBlocksToPosition = function moveBlocksToPosition(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
              m = arguments.length > 3 ? arguments[3] : void 0;
          return function (v) {
            var _ = v.select,
                k = v.dispatch;

            if (_.canMoveBlocks(l, s)) {
              if (s !== c) {
                if (!_.canRemoveBlocks(l, s)) return;
                if (!_.canInsertBlocks(l, c)) return;
              }

              k({
                type: "MOVE_BLOCKS_TO_POSITION",
                fromRootClientId: s,
                toRootClientId: c,
                clientIds: l,
                index: m
              });
            }
          };
        };

        function insertBlock(l, s, c, m, v) {
          return insertBlocks([l], s, c, m, 0, v);
        }

        s.moveBlocksToPosition = moveBlocksToPosition;

        var insertBlocks = function insertBlocks(l, s, c) {
          var m = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
              _ = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
              k = arguments.length > 5 ? arguments[5] : void 0;

          return function (y) {
            var E = y.select,
                C = y.dispatch;
            (0, v.isObject)(_) && (k = _, _ = 0, (0, w.default)("meta argument in wp.data.dispatch('core/block-editor')", {
              since: "10.1",
              plugin: "Gutenberg",
              hint: "The meta argument is now the 6th argument of the function"
            })), l = getBlocksWithDefaultStylesApplied((0, v.castArray)(l), E.getSettings());
            var S = [];

            var _iterator12 = _createForOfIteratorHelper(l),
                _step12;

            try {
              for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                var _s64 = _step12.value;
                E.canInsertBlockType(_s64.name, c) && S.push(_s64);
              }
            } catch (err) {
              _iterator12.e(err);
            } finally {
              _iterator12.f();
            }

            S.length && C({
              type: "INSERT_BLOCKS",
              blocks: S,
              index: s,
              rootClientId: c,
              time: Date.now(),
              updateSelection: m,
              initialPosition: m ? _ : null,
              meta: k
            });
          };
        };

        s.insertBlocks = insertBlocks;

        s.synchronizeTemplate = function () {
          return function (l) {
            var s = l.select,
                c = l.dispatch;
            c({
              type: "SYNCHRONIZE_TEMPLATE"
            });
            var m = s.getBlocks(),
                v = s.getTemplate(),
                k = (0, _.synchronizeBlocksWithTemplate)(m, v);
            c.resetBlocks(k);
          };
        };

        s.mergeBlocks = function (l, s) {
          return function (c) {
            var m = c.select,
                k = c.dispatch;
            var y = [l, s];
            k({
              type: "MERGE_BLOCKS",
              blocks: y
            });
            var w = y[0],
                C = y[1],
                S = m.getBlock(w),
                B = (0, _.getBlockType)(S.name);
            if (B && !B.merge) return void k.selectBlock(S.clientId);

            var P = m.getBlock(C),
                O = (0, _.getBlockType)(P.name),
                _m$getSelectionStart = m.getSelectionStart(),
                L = _m$getSelectionStart.clientId,
                V = _m$getSelectionStart.attributeKey,
                R = _m$getSelectionStart.offset,
                A = (L === w ? B : O).attributes[V],
                z = (L === w || L === C) && void 0 !== V && void 0 !== R && !!A;

            A || ("number" == typeof V ? window.console.error("RichText needs an identifier prop that is the block attribute key of the attribute it controls. Its type is expected to be a string, but was " + typeof V) : window.console.error("The RichText identifier prop does not match any attributes defined by the block."));
            var D = (0, _.cloneBlock)(S),
                F = (0, _.cloneBlock)(P);

            if (z) {
              var _l149 = L === w ? D : F,
                  _s65 = _l149.attributes[V],
                  _c48 = A.multiline,
                  _m39 = A.__unstableMultilineWrapperTags,
                  _v22 = A.__unstablePreserveWhiteSpace,
                  _9 = (0, E.insert)((0, E.create)({
                html: _s65,
                multilineTag: _c48,
                multilineWrapperTags: _m39,
                preserveWhiteSpace: _v22
              }), "", R, R);

              _l149.attributes[V] = (0, E.toHTMLString)({
                value: _9,
                multilineTag: _c48,
                preserveWhiteSpace: _v22
              });
            }

            var G = S.name === P.name ? [F] : (0, _.switchToBlockType)(F, S.name);
            if (!G || !G.length) return;
            var U = B.merge(D.attributes, G[0].attributes);

            if (z) {
              var _l150 = (0, v.findKey)(U, function (l) {
                return "string" == typeof l && -1 !== l.indexOf("");
              }),
                  _s66 = U[_l150],
                  _B$attributes$_l = B.attributes[_l150],
                  _c49 = _B$attributes$_l.multiline,
                  _m40 = _B$attributes$_l.__unstableMultilineWrapperTags,
                  _10 = _B$attributes$_l.__unstablePreserveWhiteSpace,
                  _y8 = (0, E.create)({
                html: _s66,
                multilineTag: _c49,
                multilineWrapperTags: _m40,
                preserveWhiteSpace: _10
              }),
                  _w5 = _y8.text.indexOf(""),
                  _C4 = (0, E.remove)(_y8, _w5, _w5 + 1),
                  _P2 = (0, E.toHTMLString)({
                value: _C4,
                multilineTag: _c49,
                preserveWhiteSpace: _10
              });

              U[_l150] = _P2, k.selectionChange(S.clientId, _l150, _w5, _w5);
            }

            k.replaceBlocks([S.clientId, P.clientId], [_objectSpread(_objectSpread({}, S), {}, {
              attributes: _objectSpread(_objectSpread({}, S.attributes), U)
            })].concat(_toConsumableArray(G.slice(1))), 0);
          };
        };

        var removeBlocks = function removeBlocks(l) {
          var s = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          return function (c) {
            var m = c.select,
                _ = c.dispatch;
            if (!l || !l.length) return;
            l = (0, v.castArray)(l);
            var k = m.getBlockRootClientId(l[0]);
            m.canRemoveBlocks(l, k) && (s && _.selectPreviousBlock(l[0]), _({
              type: "REMOVE_BLOCKS",
              clientIds: l
            }), _(function (l) {
              var s = l.select,
                  c = l.dispatch;
              if (s.getBlockCount() > 0) return;

              var _s$getSettings2 = s.getSettings(),
                  m = _s$getSettings2.__unstableHasCustomAppender;

              m || c.insertDefaultBlock();
            }));
          };
        };

        s.removeBlocks = removeBlocks;

        s.__unstableMarkAutomaticChange = function () {
          return function (l) {
            var s = l.dispatch;
            s({
              type: "MARK_AUTOMATIC_CHANGE"
            });
            var _window3 = window,
                _window3$requestIdleC = _window3.requestIdleCallback,
                c = _window3$requestIdleC === void 0 ? function (l) {
              return setTimeout(l, 100);
            } : _window3$requestIdleC;
            c(function () {
              s({
                type: "MARK_AUTOMATIC_CHANGE_FINAL"
              });
            });
          };
        };

        s.setNavigationMode = function () {
          var l = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          return function (s) {
            var c = s.dispatch;
            c({
              type: "SET_NAVIGATION_MODE",
              isNavigationMode: l
            }), l ? (0, k.speak)((0, y.__)("You are currently in navigation mode. Navigate blocks using the Tab key and Arrow keys. Use Left and Right Arrow keys to move between nesting levels. To exit navigation mode and edit the selected block, press Enter.")) : (0, k.speak)((0, y.__)("You are currently in edit mode. To return to the navigation mode, press Escape."));
          };
        };

        s.setBlockMovingClientId = function () {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
          return function (s) {
            var c = s.dispatch;
            c({
              type: "SET_BLOCK_MOVING_MODE",
              hasBlockMovingClientId: l
            }), l && (0, k.speak)((0, y.__)("Use the Tab key and Arrow keys to choose new block location. Use Left and Right Arrow keys to move between nesting levels. Once location is selected press Enter or Space to move the block."));
          };
        };

        s.duplicateBlocks = function (l) {
          var s = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          return function (c) {
            var m = c.select,
                k = c.dispatch;
            if (!l || !l.length) return;
            var y = m.getBlocksByClientId(l);
            if ((0, v.some)(y, function (l) {
              return !l;
            })) return;
            if (y.map(function (l) {
              return l.name;
            }).some(function (l) {
              return !(0, _.hasBlockSupport)(l, "multiple", !0);
            })) return;
            var E = m.getBlockRootClientId(l[0]),
                w = m.getBlockIndex((0, v.last)((0, v.castArray)(l))),
                C = y.map(function (l) {
              return (0, _.__experimentalCloneSanitizedBlock)(l);
            });
            return k.insertBlocks(C, w + 1, E, s), C.length > 1 && s && k.multiSelect((0, v.first)(C).clientId, (0, v.last)(C).clientId), C.map(function (l) {
              return l.clientId;
            });
          };
        };

        s.insertBeforeBlock = function (l) {
          return function (s) {
            var c = s.select,
                m = s.dispatch;
            if (!l) return;
            var v = c.getBlockRootClientId(l);
            if (c.getTemplateLock(v)) return;

            var _ = c.getBlockIndex(l);

            return m.insertDefaultBlock({}, v, _);
          };
        };

        function toggleBlockHighlight(l, s) {
          return {
            type: "TOGGLE_BLOCK_HIGHLIGHT",
            clientId: l,
            isHighlighted: s
          };
        }

        s.insertAfterBlock = function (l) {
          return function (s) {
            var c = s.select,
                m = s.dispatch;
            if (!l) return;
            var v = c.getBlockRootClientId(l);
            if (c.getTemplateLock(v)) return;

            var _ = c.getBlockIndex(l);

            return m.insertDefaultBlock({}, v, _ + 1);
          };
        };

        s.flashBlock = function (l) {
          return /*#__PURE__*/function () {
            var _ref410 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(s) {
              var c;
              return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                  switch (_context10.prev = _context10.next) {
                    case 0:
                      c = s.dispatch;
                      c(toggleBlockHighlight(l, !0));
                      _context10.next = 4;
                      return new Promise(function (l) {
                        return setTimeout(l, 150);
                      });

                    case 4:
                      c(toggleBlockHighlight(l, !1));

                    case 5:
                    case "end":
                      return _context10.stop();
                  }
                }
              }, _callee10);
            }));

            return function (_x16) {
              return _ref410.apply(this, arguments);
            };
          }();
        };
      },
      8105: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.insertAt = insertAt, s.moveTo = function moveTo(l, s, c) {
          var m = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;

          var v = _toConsumableArray(l);

          return v.splice(s, m), insertAt(v, l.slice(s, s + m), c);
        };
        var m = c(4793);

        function insertAt(l, s, c) {
          return [].concat(_toConsumableArray(l.slice(0, c)), _toConsumableArray((0, m.castArray)(s)), _toConsumableArray(l.slice(c)));
        }
      },
      8340: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.STORE_NAME = void 0;
        s.STORE_NAME = "core/block-editor";
      },
      1822: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.SETTINGS_DEFAULTS = s.PREFERENCES_DEFAULTS = void 0;
        var m = c(6756);
        s.PREFERENCES_DEFAULTS = {
          insertUsage: {}
        };
        var v = {
          alignWide: !1,
          supportsLayout: !0,
          colors: [{
            name: (0, m.__)("Black"),
            slug: "black",
            color: "#000000"
          }, {
            name: (0, m.__)("Cyan bluish gray"),
            slug: "cyan-bluish-gray",
            color: "#abb8c3"
          }, {
            name: (0, m.__)("White"),
            slug: "white",
            color: "#ffffff"
          }, {
            name: (0, m.__)("Pale pink"),
            slug: "pale-pink",
            color: "#f78da7"
          }, {
            name: (0, m.__)("Vivid red"),
            slug: "vivid-red",
            color: "#cf2e2e"
          }, {
            name: (0, m.__)("Luminous vivid orange"),
            slug: "luminous-vivid-orange",
            color: "#ff6900"
          }, {
            name: (0, m.__)("Luminous vivid amber"),
            slug: "luminous-vivid-amber",
            color: "#fcb900"
          }, {
            name: (0, m.__)("Light green cyan"),
            slug: "light-green-cyan",
            color: "#7bdcb5"
          }, {
            name: (0, m.__)("Vivid green cyan"),
            slug: "vivid-green-cyan",
            color: "#00d084"
          }, {
            name: (0, m.__)("Pale cyan blue"),
            slug: "pale-cyan-blue",
            color: "#8ed1fc"
          }, {
            name: (0, m.__)("Vivid cyan blue"),
            slug: "vivid-cyan-blue",
            color: "#0693e3"
          }, {
            name: (0, m.__)("Vivid purple"),
            slug: "vivid-purple",
            color: "#9b51e0"
          }],
          fontSizes: [{
            name: (0, m._x)("Small", "font size name"),
            size: 13,
            slug: "small"
          }, {
            name: (0, m._x)("Normal", "font size name"),
            size: 16,
            slug: "normal"
          }, {
            name: (0, m._x)("Medium", "font size name"),
            size: 20,
            slug: "medium"
          }, {
            name: (0, m._x)("Large", "font size name"),
            size: 36,
            slug: "large"
          }, {
            name: (0, m._x)("Huge", "font size name"),
            size: 42,
            slug: "huge"
          }],
          imageDefaultSize: "large",
          imageSizes: [{
            slug: "thumbnail",
            name: (0, m.__)("Thumbnail")
          }, {
            slug: "medium",
            name: (0, m.__)("Medium")
          }, {
            slug: "large",
            name: (0, m.__)("Large")
          }, {
            slug: "full",
            name: (0, m.__)("Full Size")
          }],
          imageEditing: !0,
          maxWidth: 580,
          allowedBlockTypes: !0,
          maxUploadFileSize: 0,
          allowedMimeTypes: null,
          __experimentalCanUserUseUnfilteredHTML: !1,
          __experimentalBlockDirectory: !1,
          __mobileEnablePageTemplates: !1,
          __experimentalBlockPatterns: [],
          __experimentalBlockPatternCategories: [],
          __experimentalSpotlightEntityBlocks: [],
          __unstableGalleryWithImageBlocks: !1,
          gradients: [{
            name: (0, m.__)("Vivid cyan blue to vivid purple"),
            gradient: "linear-gradient(135deg,rgba(6,147,227,1) 0%,rgb(155,81,224) 100%)",
            slug: "vivid-cyan-blue-to-vivid-purple"
          }, {
            name: (0, m.__)("Light green cyan to vivid green cyan"),
            gradient: "linear-gradient(135deg,rgb(122,220,180) 0%,rgb(0,208,130) 100%)",
            slug: "light-green-cyan-to-vivid-green-cyan"
          }, {
            name: (0, m.__)("Luminous vivid amber to luminous vivid orange"),
            gradient: "linear-gradient(135deg,rgba(252,185,0,1) 0%,rgba(255,105,0,1) 100%)",
            slug: "luminous-vivid-amber-to-luminous-vivid-orange"
          }, {
            name: (0, m.__)("Luminous vivid orange to vivid red"),
            gradient: "linear-gradient(135deg,rgba(255,105,0,1) 0%,rgb(207,46,46) 100%)",
            slug: "luminous-vivid-orange-to-vivid-red"
          }, {
            name: (0, m.__)("Very light gray to cyan bluish gray"),
            gradient: "linear-gradient(135deg,rgb(238,238,238) 0%,rgb(169,184,195) 100%)",
            slug: "very-light-gray-to-cyan-bluish-gray"
          }, {
            name: (0, m.__)("Cool to warm spectrum"),
            gradient: "linear-gradient(135deg,rgb(74,234,220) 0%,rgb(151,120,209) 20%,rgb(207,42,186) 40%,rgb(238,44,130) 60%,rgb(251,105,98) 80%,rgb(254,248,76) 100%)",
            slug: "cool-to-warm-spectrum"
          }, {
            name: (0, m.__)("Blush light purple"),
            gradient: "linear-gradient(135deg,rgb(255,206,236) 0%,rgb(152,150,240) 100%)",
            slug: "blush-light-purple"
          }, {
            name: (0, m.__)("Blush bordeaux"),
            gradient: "linear-gradient(135deg,rgb(254,205,165) 0%,rgb(254,45,45) 50%,rgb(107,0,62) 100%)",
            slug: "blush-bordeaux"
          }, {
            name: (0, m.__)("Luminous dusk"),
            gradient: "linear-gradient(135deg,rgb(255,203,112) 0%,rgb(199,81,192) 50%,rgb(65,88,208) 100%)",
            slug: "luminous-dusk"
          }, {
            name: (0, m.__)("Pale ocean"),
            gradient: "linear-gradient(135deg,rgb(255,245,203) 0%,rgb(182,227,212) 50%,rgb(51,167,181) 100%)",
            slug: "pale-ocean"
          }, {
            name: (0, m.__)("Electric grass"),
            gradient: "linear-gradient(135deg,rgb(202,248,128) 0%,rgb(113,206,126) 100%)",
            slug: "electric-grass"
          }, {
            name: (0, m.__)("Midnight"),
            gradient: "linear-gradient(135deg,rgb(2,3,129) 0%,rgb(40,116,252) 100%)",
            slug: "midnight"
          }]
        };
        s.SETTINGS_DEFAULTS = v;
      },
      8486: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.storeConfig = s.store = void 0;

        var v = c(8467),
            _ = m(c(785)),
            k = _interopRequireWildcard(c(3021)),
            y = _interopRequireWildcard(c(2372)),
            E = c(8340);

        function _getRequireWildcardCache(l) {
          if ("function" != typeof WeakMap) return null;
          var s = new WeakMap(),
              c = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(l) {
            return l ? c : s;
          })(l);
        }

        function _interopRequireWildcard(l, s) {
          if (!s && l && l.__esModule) return l;
          if (null === l || "object" != typeof l && "function" != typeof l) return {
            default: l
          };

          var c = _getRequireWildcardCache(s);

          if (c && c.has(l)) return c.get(l);
          var m = {},
              v = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var _ in l) {
            if ("default" !== _ && Object.prototype.hasOwnProperty.call(l, _)) {
              var k = v ? Object.getOwnPropertyDescriptor(l, _) : null;
              k && (k.get || k.set) ? Object.defineProperty(m, _, k) : m[_] = l[_];
            }
          }

          return m.default = l, c && c.set(l, m), m;
        }

        var w = {
          reducer: _.default,
          selectors: k,
          actions: y,
          __experimentalUseThunks: !0
        };
        s.storeConfig = w;
        var C = (0, v.createReduxStore)(E.STORE_NAME, _objectSpread(_objectSpread({}, w), {}, {
          persist: ["preferences"]
        }));
        s.store = C, (0, v.registerStore)(E.STORE_NAME, _objectSpread(_objectSpread({}, w), {}, {
          persist: ["preferences"]
        }));
      },
      785: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.automaticChangeStatus = automaticChangeStatus, s.blocks = s.blockListSettings = void 0, s.blocksMode = blocksMode, s.default = void 0, s.draggedBlocks = draggedBlocks, s.hasBlockMovingClientId = hasBlockMovingClientId, s.hasSameKeys = hasSameKeys, s.highlightedBlock = highlightedBlock, s.initialPosition = initialPosition, s.insertionPoint = insertionPoint, s.isCaretWithinFormattedText = isCaretWithinFormattedText, s.isMultiSelecting = isMultiSelecting, s.isNavigationMode = isNavigationMode, s.isSelectionEnabled = isSelectionEnabled, s.isTyping = isTyping, s.isUpdatingSameBlockAttribute = isUpdatingSameBlockAttribute, s.lastBlockAttributesChange = lastBlockAttributesChange, s.lastBlockInserted = lastBlockInserted, s.preferences = preferences, s.selection = selection, s.settings = settings, s.template = template;

        var m = c(4793),
            v = c(8467),
            _ = c(6700),
            k = c(1822),
            y = c(8105);

        function mapBlockOrder(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";

          var c = _defineProperty({}, s, []);

          return l.forEach(function (l) {
            var m = l.clientId,
                v = l.innerBlocks;
            c[s].push(m), Object.assign(c, mapBlockOrder(v, m));
          }), c;
        }

        function mapBlockParents(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
          return l.reduce(function (l, c) {
            return Object.assign(l, _defineProperty({}, c.clientId, s), mapBlockParents(c.innerBlocks, c.clientId));
          }, {});
        }

        function flattenBlocks(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : m.identity;

          var c = {},
              v = _toConsumableArray(l);

          for (; v.length;) {
            var _v$shift = v.shift(),
                _l151 = _v$shift.innerBlocks,
                _m41 = _objectWithoutProperties(_v$shift, _excluded44);

            v.push.apply(v, _toConsumableArray(_l151)), c[_m41.clientId] = s(_m41);
          }

          return c;
        }

        function getFlattenedBlocksWithoutAttributes(l) {
          return flattenBlocks(l, function (l) {
            return (0, m.omit)(l, "attributes");
          });
        }

        function getFlattenedBlockAttributes(l) {
          return flattenBlocks(l, function (l) {
            return l.attributes;
          });
        }

        function hasSameKeys(l, s) {
          return (0, m.isEqual)((0, m.keys)(l), (0, m.keys)(s));
        }

        function isUpdatingSameBlockAttribute(l, s) {
          return "UPDATE_BLOCK_ATTRIBUTES" === l.type && void 0 !== s && "UPDATE_BLOCK_ATTRIBUTES" === s.type && (0, m.isEqual)(l.clientIds, s.clientIds) && hasSameKeys(l.attributes, s.attributes);
        }

        function buildBlockTree(l, s) {
          var c = {},
              m = _toConsumableArray(s),
              v = _toConsumableArray(s);

          for (; m.length;) {
            var _l152 = m.shift();

            m.push.apply(m, _toConsumableArray(_l152.innerBlocks)), v.push.apply(v, _toConsumableArray(_l152.innerBlocks));
          }

          var _iterator13 = _createForOfIteratorHelper(v),
              _step13;

          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var _l153 = _step13.value;
              c[_l153.clientId] = {};
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }

          var _iterator14 = _createForOfIteratorHelper(v),
              _step14;

          try {
            for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
              var _s67 = _step14.value;
              c[_s67.clientId] = Object.assign(c[_s67.clientId], _objectSpread(_objectSpread({}, l.byClientId[_s67.clientId]), {}, {
                attributes: l.attributes[_s67.clientId],
                innerBlocks: _s67.innerBlocks.map(function (l) {
                  return c[l.clientId];
                })
              }));
            }
          } catch (err) {
            _iterator14.e(err);
          } finally {
            _iterator14.f();
          }

          return c;
        }

        function updateParentInnerBlocksInTree(l, s, c) {
          var m = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];

          var v = new Set([]),
              _ = new Set();

          var _iterator15 = _createForOfIteratorHelper(c),
              _step15;

          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var _s68 = _step15.value;

              var _c51 = m ? _s68 : l.parents[_s68];

              do {
                if (l.controlledInnerBlocks[_c51]) {
                  _.add(_c51);

                  break;
                }

                v.add(_c51), _c51 = l.parents[_c51];
              } while (void 0 !== _c51);
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }

          var _iterator16 = _createForOfIteratorHelper(v),
              _step16;

          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var _l154 = _step16.value;
              s[_l154] = _objectSpread({}, s[_l154]);
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }

          var _iterator17 = _createForOfIteratorHelper(v),
              _step17;

          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              var _c52 = _step17.value;
              s[_c52].innerBlocks = (l.order[_c52] || []).map(function (l) {
                return s[l];
              });
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }

          var _iterator18 = _createForOfIteratorHelper(_),
              _step18;

          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var _c53 = _step18.value;
              s["controlled||" + _c53] = {
                innerBlocks: (l.order[_c53] || []).map(function (l) {
                  return s[l];
                })
              };
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }

          return s;
        }

        var E = (0, m.flow)(v.combineReducers, function (l) {
          return function (s, c) {
            if (s && "SAVE_REUSABLE_BLOCK_SUCCESS" === c.type) {
              var _l155 = c.id,
                  _v23 = c.updatedId;
              if (_l155 === _v23) return s;
              (s = _objectSpread({}, s)).attributes = (0, m.mapValues)(s.attributes, function (c, m) {
                var _ = s.byClientId[m].name;
                return "core/block" === _ && c.ref === _l155 ? _objectSpread(_objectSpread({}, c), {}, {
                  ref: _v23
                }) : c;
              });
            }

            return l(s, c);
          };
        }, function (l) {
          return function () {
            var s = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                c = arguments.length > 1 ? arguments[1] : void 0;
            var v = l(s, c);
            if (v === s) return s;

            switch (v.tree = s.tree ? s.tree : {}, c.type) {
              case "RECEIVE_BLOCKS":
              case "INSERT_BLOCKS":
                {
                  var _l157 = buildBlockTree(v, c.blocks);

                  v.tree = updateParentInnerBlocksInTree(v, _objectSpread(_objectSpread({}, v.tree), _l157), c.rootClientId ? [c.rootClientId] : [""], !0);
                  break;
                }

              case "UPDATE_BLOCK":
                v.tree = updateParentInnerBlocksInTree(v, _objectSpread(_objectSpread({}, v.tree), {}, _defineProperty({}, c.clientId, _objectSpread(_objectSpread(_objectSpread({}, v.tree[c.clientId]), v.byClientId[c.clientId]), {}, {
                  attributes: v.attributes[c.clientId]
                }))), [c.clientId], !1);
                break;

              case "UPDATE_BLOCK_ATTRIBUTES":
                {
                  var _l158 = c.clientIds.reduce(function (l, s) {
                    return l[s] = _objectSpread(_objectSpread({}, v.tree[s]), {}, {
                      attributes: v.attributes[s]
                    }), l;
                  }, {});

                  v.tree = updateParentInnerBlocksInTree(v, _objectSpread(_objectSpread({}, v.tree), _l158), c.clientIds, !1);
                  break;
                }

              case "REPLACE_BLOCKS_AUGMENTED_WITH_CHILDREN":
                {
                  var _l159 = buildBlockTree(v, c.blocks);

                  v.tree = updateParentInnerBlocksInTree(v, _objectSpread(_objectSpread({}, (0, m.omit)(v.tree, c.replacedClientIds.concat(c.replacedClientIds.filter(function (s) {
                    return !_l159[s];
                  }).map(function (l) {
                    return "controlled||" + l;
                  })))), _l159), c.blocks.map(function (l) {
                    return l.clientId;
                  }), !1);
                  var _11 = [];

                  var _iterator19 = _createForOfIteratorHelper(c.clientIds),
                      _step19;

                  try {
                    for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                      var _l160 = _step19.value;
                      void 0 === s.parents[_l160] || "" !== s.parents[_l160] && !v.byClientId[s.parents[_l160]] || _11.push(s.parents[_l160]);
                    }
                  } catch (err) {
                    _iterator19.e(err);
                  } finally {
                    _iterator19.f();
                  }

                  v.tree = updateParentInnerBlocksInTree(v, v.tree, _11, !0);
                  break;
                }

              case "REMOVE_BLOCKS_AUGMENTED_WITH_CHILDREN":
                var _l156 = [];

                var _iterator20 = _createForOfIteratorHelper(c.clientIds),
                    _step20;

                try {
                  for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                    var _m42 = _step20.value;
                    void 0 === s.parents[_m42] || "" !== s.parents[_m42] && !v.byClientId[s.parents[_m42]] || _l156.push(s.parents[_m42]);
                  }
                } catch (err) {
                  _iterator20.e(err);
                } finally {
                  _iterator20.f();
                }

                v.tree = updateParentInnerBlocksInTree(v, (0, m.omit)(v.tree, c.removedClientIds.concat(c.removedClientIds.map(function (l) {
                  return "controlled||" + l;
                }))), _l156, !0);
                break;

              case "MOVE_BLOCKS_TO_POSITION":
                {
                  var _l161 = [];
                  c.fromRootClientId && _l161.push(c.fromRootClientId), c.toRootClientId && _l161.push(c.toRootClientId), c.fromRootClientId && c.fromRootClientId || _l161.push(""), v.tree = updateParentInnerBlocksInTree(v, v.tree, _l161, !0);
                  break;
                }

              case "MOVE_BLOCKS_UP":
              case "MOVE_BLOCKS_DOWN":
                {
                  var _l162 = [c.rootClientId ? c.rootClientId : ""];
                  v.tree = updateParentInnerBlocksInTree(v, v.tree, _l162, !0);
                  break;
                }

              case "SAVE_REUSABLE_BLOCK_SUCCESS":
                {
                  var _l163 = (0, m.keys)((0, m.omitBy)(v.attributes, function (l, s) {
                    return "core/block" !== v.byClientId[s].name || l.ref !== c.updatedId;
                  }));

                  v.tree = updateParentInnerBlocksInTree(v, _objectSpread(_objectSpread({}, v.tree), _l163.reduce(function (l, s) {
                    return l[s] = _objectSpread(_objectSpread({}, v.byClientId[s]), {}, {
                      attributes: v.attributes[s],
                      innerBlocks: v.tree[s].innerBlocks
                    }), l;
                  }, {})), _l163, !1);
                }
            }

            return v;
          };
        }, function (l) {
          return function (s, c) {
            var getAllChildren = function getAllChildren(l) {
              var m = l;

              for (var _v24 = 0; _v24 < m.length; _v24++) {
                var _m43;

                !s.order[m[_v24]] || c.keepControlledInnerBlocks && c.keepControlledInnerBlocks[m[_v24]] || (m === l && (m = _toConsumableArray(m)), (_m43 = m).push.apply(_m43, _toConsumableArray(s.order[m[_v24]])));
              }

              return m;
            };

            if (s) switch (c.type) {
              case "REMOVE_BLOCKS":
                c = _objectSpread(_objectSpread({}, c), {}, {
                  type: "REMOVE_BLOCKS_AUGMENTED_WITH_CHILDREN",
                  removedClientIds: getAllChildren(c.clientIds)
                });
                break;

              case "REPLACE_BLOCKS":
                c = _objectSpread(_objectSpread({}, c), {}, {
                  type: "REPLACE_BLOCKS_AUGMENTED_WITH_CHILDREN",
                  replacedClientIds: getAllChildren(c.clientIds)
                });
            }
            return l(s, c);
          };
        }, function (l) {
          return function (s, c) {
            if ("REPLACE_INNER_BLOCKS" !== c.type) return l(s, c);
            var v = {};

            if (Object.keys(s.controlledInnerBlocks).length) {
              var _l164 = _toConsumableArray(c.blocks);

              for (; _l164.length;) {
                var _l164$shift = _l164.shift(),
                    _c54 = _l164$shift.innerBlocks,
                    _m44 = _objectWithoutProperties(_l164$shift, _excluded45);

                _l164.push.apply(_l164, _toConsumableArray(_c54)), s.controlledInnerBlocks[_m44.clientId] && (v[_m44.clientId] = !0);
              }
            }

            var _ = s;
            s.order[c.rootClientId] && (_ = l(_, {
              type: "REMOVE_BLOCKS",
              keepControlledInnerBlocks: v,
              clientIds: s.order[c.rootClientId]
            }));
            var k = _;
            return c.blocks.length && (k = l(k, _objectSpread(_objectSpread({}, c), {}, {
              type: "INSERT_BLOCKS",
              index: 0
            })), k.order = _objectSpread(_objectSpread({}, k.order), (0, m.reduce)(v, function (l, c, m) {
              return s.order[m] && (l[m] = s.order[m]), l;
            }, {}))), k;
          };
        }, function (l) {
          return function (s, c) {
            if ("RESET_BLOCKS" === c.type) {
              var _l165 = _objectSpread(_objectSpread({}, s), {}, {
                byClientId: getFlattenedBlocksWithoutAttributes(c.blocks),
                attributes: getFlattenedBlockAttributes(c.blocks),
                order: mapBlockOrder(c.blocks),
                parents: mapBlockParents(c.blocks),
                controlledInnerBlocks: {}
              }),
                  _m45 = buildBlockTree(_l165, c.blocks);

              return _l165.tree = _objectSpread(_objectSpread({}, _m45), {}, {
                "": {
                  innerBlocks: c.blocks.map(function (l) {
                    return _m45[l.clientId];
                  })
                }
              }), _l165;
            }

            return l(s, c);
          };
        }, function withPersistentBlockChange(l) {
          var s,
              c = !1;
          return function (m, v) {
            var _ = l(m, v);

            var k = "MARK_LAST_CHANGE_AS_PERSISTENT" === v.type || c;

            if (m === _ && !k) {
              var y;
              c = "MARK_NEXT_CHANGE_AS_NOT_PERSISTENT" === v.type;

              var _l166 = null === (y = null == m ? void 0 : m.isPersistentChange) || void 0 === y || y;

              return m.isPersistentChange === _l166 ? m : _objectSpread(_objectSpread({}, _), {}, {
                isPersistentChange: _l166
              });
            }

            return _ = _objectSpread(_objectSpread({}, _), {}, {
              isPersistentChange: k ? !c : !isUpdatingSameBlockAttribute(v, s)
            }), s = v, c = "MARK_NEXT_CHANGE_AS_NOT_PERSISTENT" === v.type, _;
          };
        }, function withIgnoredBlockChange(l) {
          var s = new Set(["RECEIVE_BLOCKS"]);
          return function (c, m) {
            var v = l(c, m);
            return v !== c && (v.isIgnoredChange = s.has(m.type)), v;
          };
        }, function (l) {
          return function (s, c) {
            if ("SET_HAS_CONTROLLED_INNER_BLOCKS" === c.type) {
              var _m46 = l(s, {
                type: "REPLACE_INNER_BLOCKS",
                rootClientId: c.clientId,
                blocks: []
              });

              return l(_m46, c);
            }

            return l(s, c);
          };
        })({
          byClientId: function byClientId() {
            var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                s = arguments.length > 1 ? arguments[1] : void 0;

            switch (s.type) {
              case "RECEIVE_BLOCKS":
              case "INSERT_BLOCKS":
                return _objectSpread(_objectSpread({}, l), getFlattenedBlocksWithoutAttributes(s.blocks));

              case "UPDATE_BLOCK":
                if (!l[s.clientId]) return l;

                var _c55 = (0, m.omit)(s.updates, "attributes");

                return (0, m.isEmpty)(_c55) ? l : _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, s.clientId, _objectSpread(_objectSpread({}, l[s.clientId]), _c55)));

              case "REPLACE_BLOCKS_AUGMENTED_WITH_CHILDREN":
                return s.blocks ? _objectSpread(_objectSpread({}, (0, m.omit)(l, s.replacedClientIds)), getFlattenedBlocksWithoutAttributes(s.blocks)) : l;

              case "REMOVE_BLOCKS_AUGMENTED_WITH_CHILDREN":
                return (0, m.omit)(l, s.removedClientIds);
            }

            return l;
          },
          attributes: function attributes() {
            var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                s = arguments.length > 1 ? arguments[1] : void 0;

            switch (s.type) {
              case "RECEIVE_BLOCKS":
              case "INSERT_BLOCKS":
                return _objectSpread(_objectSpread({}, l), getFlattenedBlockAttributes(s.blocks));

              case "UPDATE_BLOCK":
                return l[s.clientId] && s.updates.attributes ? _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, s.clientId, _objectSpread(_objectSpread({}, l[s.clientId]), s.updates.attributes))) : l;

              case "UPDATE_BLOCK_ATTRIBUTES":
                {
                  if (s.clientIds.every(function (s) {
                    return !l[s];
                  })) return l;

                  var _c56 = s.clientIds.reduce(function (c, v) {
                    return _objectSpread(_objectSpread({}, c), {}, _defineProperty({}, v, (0, m.reduce)(s.uniqueByBlock ? s.attributes[v] : s.attributes, function (s, c, m) {
                      return c !== s[m] && ((s = function getMutateSafeObject(l, s) {
                        return l === s ? _objectSpread({}, l) : s;
                      }(l[v], s))[m] = c), s;
                    }, l[v])));
                  }, {});

                  return s.clientIds.every(function (s) {
                    return _c56[s] === l[s];
                  }) ? l : _objectSpread(_objectSpread({}, l), _c56);
                }

              case "REPLACE_BLOCKS_AUGMENTED_WITH_CHILDREN":
                return s.blocks ? _objectSpread(_objectSpread({}, (0, m.omit)(l, s.replacedClientIds)), getFlattenedBlockAttributes(s.blocks)) : l;

              case "REMOVE_BLOCKS_AUGMENTED_WITH_CHILDREN":
                return (0, m.omit)(l, s.removedClientIds);
            }

            return l;
          },
          order: function order() {
            var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                s = arguments.length > 1 ? arguments[1] : void 0;

            switch (s.type) {
              case "RECEIVE_BLOCKS":
                {
                  var _c57 = mapBlockOrder(s.blocks);

                  return _objectSpread(_objectSpread(_objectSpread({}, l), (0, m.omit)(_c57, "")), {}, {
                    "": ((null == l ? void 0 : l[""]) || []).concat(_c57[""])
                  });
                }

              case "INSERT_BLOCKS":
                {
                  var _s$rootClientId = s.rootClientId,
                      _c58 = _s$rootClientId === void 0 ? "" : _s$rootClientId,
                      _m47 = l[_c58] || [],
                      _v25 = mapBlockOrder(s.blocks, _c58),
                      _s$index = s.index,
                      _12 = _s$index === void 0 ? _m47.length : _s$index;

                  return _objectSpread(_objectSpread(_objectSpread({}, l), _v25), {}, _defineProperty({}, _c58, (0, y.insertAt)(_m47, _v25[_c58], _12)));
                }

              case "MOVE_BLOCKS_TO_POSITION":
                {
                  var _objectSpread17;

                  var _s$fromRootClientId = s.fromRootClientId,
                      _c59 = _s$fromRootClientId === void 0 ? "" : _s$fromRootClientId,
                      _s$toRootClientId = s.toRootClientId,
                      _v26 = _s$toRootClientId === void 0 ? "" : _s$toRootClientId,
                      _13 = s.clientIds,
                      _s$index2 = s.index,
                      _k10 = _s$index2 === void 0 ? l[_v26].length : _s$index2;

                  if (_c59 === _v26) {
                    var _s69 = l[_v26].indexOf(_13[0]);

                    return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, _v26, (0, y.moveTo)(l[_v26], _s69, _k10, _13.length)));
                  }

                  return _objectSpread(_objectSpread({}, l), {}, (_objectSpread17 = {}, _defineProperty(_objectSpread17, _c59, (0, m.without).apply(void 0, [l[_c59]].concat(_toConsumableArray(_13)))), _defineProperty(_objectSpread17, _v26, (0, y.insertAt)(l[_v26], _13, _k10)), _objectSpread17));
                }

              case "MOVE_BLOCKS_UP":
                {
                  var _c60 = s.clientIds,
                      _s$rootClientId2 = s.rootClientId,
                      _v27 = _s$rootClientId2 === void 0 ? "" : _s$rootClientId2,
                      _14 = (0, m.first)(_c60),
                      _k11 = l[_v27];

                  if (!_k11.length || _14 === (0, m.first)(_k11)) return l;

                  var _E6 = _k11.indexOf(_14);

                  return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, _v27, (0, y.moveTo)(_k11, _E6, _E6 - 1, _c60.length)));
                }

              case "MOVE_BLOCKS_DOWN":
                {
                  var _c61 = s.clientIds,
                      _s$rootClientId3 = s.rootClientId,
                      _v28 = _s$rootClientId3 === void 0 ? "" : _s$rootClientId3,
                      _15 = (0, m.first)(_c61),
                      _k12 = (0, m.last)(_c61),
                      _E7 = l[_v28];

                  if (!_E7.length || _k12 === (0, m.last)(_E7)) return l;

                  var _w6 = _E7.indexOf(_15);

                  return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, _v28, (0, y.moveTo)(_E7, _w6, _w6 + 1, _c61.length)));
                }

              case "REPLACE_BLOCKS_AUGMENTED_WITH_CHILDREN":
                {
                  var _c62 = s.clientIds;
                  if (!s.blocks) return l;

                  var _v29 = mapBlockOrder(s.blocks);

                  return (0, m.flow)([function (l) {
                    return (0, m.omit)(l, s.replacedClientIds);
                  }, function (l) {
                    return _objectSpread(_objectSpread({}, l), (0, m.omit)(_v29, ""));
                  }, function (l) {
                    return (0, m.mapValues)(l, function (l) {
                      return (0, m.reduce)(l, function (l, s) {
                        return s === _c62[0] ? [].concat(_toConsumableArray(l), _toConsumableArray(_v29[""])) : (-1 === _c62.indexOf(s) && l.push(s), l);
                      }, []);
                    });
                  }])(l);
                }

              case "REMOVE_BLOCKS_AUGMENTED_WITH_CHILDREN":
                return (0, m.flow)([function (l) {
                  return (0, m.omit)(l, s.removedClientIds);
                }, function (l) {
                  return (0, m.mapValues)(l, function (l) {
                    return (0, m.without).apply(void 0, [l].concat(_toConsumableArray(s.removedClientIds)));
                  });
                }])(l);
            }

            return l;
          },
          parents: function parents() {
            var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                s = arguments.length > 1 ? arguments[1] : void 0;

            switch (s.type) {
              case "RECEIVE_BLOCKS":
                return _objectSpread(_objectSpread({}, l), mapBlockParents(s.blocks));

              case "INSERT_BLOCKS":
                return _objectSpread(_objectSpread({}, l), mapBlockParents(s.blocks, s.rootClientId || ""));

              case "MOVE_BLOCKS_TO_POSITION":
                return _objectSpread(_objectSpread({}, l), s.clientIds.reduce(function (l, c) {
                  return l[c] = s.toRootClientId || "", l;
                }, {}));

              case "REPLACE_BLOCKS_AUGMENTED_WITH_CHILDREN":
                return _objectSpread(_objectSpread({}, (0, m.omit)(l, s.replacedClientIds)), mapBlockParents(s.blocks, l[s.clientIds[0]]));

              case "REMOVE_BLOCKS_AUGMENTED_WITH_CHILDREN":
                return (0, m.omit)(l, s.removedClientIds);
            }

            return l;
          },
          controlledInnerBlocks: function controlledInnerBlocks() {
            var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                _ref411 = arguments.length > 1 ? arguments[1] : void 0,
                s = _ref411.type,
                c = _ref411.clientId,
                m = _ref411.hasControlledInnerBlocks;

            return "SET_HAS_CONTROLLED_INNER_BLOCKS" === s ? _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, c, m)) : l;
          }
        });

        function isTyping() {
          var l = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              s = arguments.length > 1 ? arguments[1] : void 0;

          switch (s.type) {
            case "START_TYPING":
              return !0;

            case "STOP_TYPING":
              return !1;
          }

          return l;
        }

        function draggedBlocks() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              s = arguments.length > 1 ? arguments[1] : void 0;

          switch (s.type) {
            case "START_DRAGGING_BLOCKS":
              return s.clientIds;

            case "STOP_DRAGGING_BLOCKS":
              return [];
          }

          return l;
        }

        function isCaretWithinFormattedText() {
          var l = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              s = arguments.length > 1 ? arguments[1] : void 0;

          switch (s.type) {
            case "ENTER_FORMATTED_TEXT":
              return !0;

            case "EXIT_FORMATTED_TEXT":
              return !1;
          }

          return l;
        }

        function selectionHelper() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              s = arguments.length > 1 ? arguments[1] : void 0;

          switch (s.type) {
            case "CLEAR_SELECTED_BLOCK":
              return l.clientId ? {} : l;

            case "SELECT_BLOCK":
              return s.clientId === l.clientId ? l : {
                clientId: s.clientId
              };

            case "REPLACE_INNER_BLOCKS":
            case "INSERT_BLOCKS":
              return s.updateSelection && s.blocks.length ? {
                clientId: s.blocks[0].clientId
              } : l;

            case "REMOVE_BLOCKS":
              return s.clientIds && s.clientIds.length && -1 !== s.clientIds.indexOf(l.clientId) ? {} : l;

            case "REPLACE_BLOCKS":
              {
                if (-1 === s.clientIds.indexOf(l.clientId)) return l;

                var _c63 = s.blocks[s.indexToSelect] || s.blocks[s.blocks.length - 1];

                return _c63 ? _c63.clientId === l.clientId ? l : {
                  clientId: _c63.clientId
                } : {};
              }
          }

          return l;
        }

        function selection() {
          var l, s;
          var c = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              m = arguments.length > 1 ? arguments[1] : void 0;

          switch (m.type) {
            case "SELECTION_CHANGE":
              return {
                selectionStart: {
                  clientId: m.clientId,
                  attributeKey: m.attributeKey,
                  offset: m.startOffset
                },
                selectionEnd: {
                  clientId: m.clientId,
                  attributeKey: m.attributeKey,
                  offset: m.endOffset
                }
              };

            case "RESET_SELECTION":
              var _v30 = m.selectionStart,
                  _16 = m.selectionEnd;
              return {
                selectionStart: _v30,
                selectionEnd: _16
              };

            case "MULTI_SELECT":
              var _k13 = m.start,
                  _y9 = m.end;
              return {
                selectionStart: {
                  clientId: _k13
                },
                selectionEnd: {
                  clientId: _y9
                }
              };

            case "RESET_BLOCKS":
              var _E8 = null == c || null === (l = c.selectionStart) || void 0 === l ? void 0 : l.clientId,
                  _w7 = null == c || null === (s = c.selectionEnd) || void 0 === s ? void 0 : s.clientId;

              if (!_E8 && !_w7) return c;
              if (!m.blocks.some(function (l) {
                return l.clientId === _E8;
              })) return {
                selectionStart: {},
                selectionEnd: {}
              };
              if (!m.blocks.some(function (l) {
                return l.clientId === _w7;
              })) return _objectSpread(_objectSpread({}, c), {}, {
                selectionEnd: c.selectionStart
              });
          }

          return {
            selectionStart: selectionHelper(c.selectionStart, m),
            selectionEnd: selectionHelper(c.selectionEnd, m)
          };
        }

        function isMultiSelecting() {
          var l = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              s = arguments.length > 1 ? arguments[1] : void 0;

          switch (s.type) {
            case "START_MULTI_SELECT":
              return !0;

            case "STOP_MULTI_SELECT":
              return !1;
          }

          return l;
        }

        function isSelectionEnabled() {
          var l = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
              s = arguments.length > 1 ? arguments[1] : void 0;
          return "TOGGLE_SELECTION" === s.type ? s.isSelectionEnabled : l;
        }

        function initialPosition() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              s = arguments.length > 1 ? arguments[1] : void 0;
          return "REPLACE_BLOCKS" === s.type && void 0 !== s.initialPosition || ["SELECT_BLOCK", "RESET_SELECTION", "INSERT_BLOCKS", "REPLACE_INNER_BLOCKS"].includes(s.type) ? s.initialPosition : l;
        }

        function blocksMode() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              s = arguments.length > 1 ? arguments[1] : void 0;

          if ("TOGGLE_BLOCK_MODE" === s.type) {
            var _c64 = s.clientId;
            return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, _c64, l[_c64] && "html" === l[_c64] ? "visual" : "html"));
          }

          return l;
        }

        function insertionPoint() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              s = arguments.length > 1 ? arguments[1] : void 0;

          switch (s.type) {
            case "SHOW_INSERTION_POINT":
              var _l167 = s.rootClientId,
                  _c65 = s.index,
                  _m48 = s.__unstableWithInserter;
              return {
                rootClientId: _l167,
                index: _c65,
                __unstableWithInserter: _m48
              };

            case "HIDE_INSERTION_POINT":
              return null;
          }

          return l;
        }

        function template() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            isValid: !0
          },
              s = arguments.length > 1 ? arguments[1] : void 0;
          return "SET_TEMPLATE_VALIDITY" === s.type ? _objectSpread(_objectSpread({}, l), {}, {
            isValid: s.isValid
          }) : l;
        }

        function settings() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : k.SETTINGS_DEFAULTS,
              s = arguments.length > 1 ? arguments[1] : void 0;
          return "UPDATE_SETTINGS" === s.type ? _objectSpread(_objectSpread({}, l), s.settings) : l;
        }

        function preferences() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : k.PREFERENCES_DEFAULTS,
              s = arguments.length > 1 ? arguments[1] : void 0;

          switch (s.type) {
            case "INSERT_BLOCKS":
            case "REPLACE_BLOCKS":
              return s.blocks.reduce(function (l, c) {
                var m = c.attributes,
                    k = c.name,
                    y = (0, v.select)(_.store).getActiveBlockVariation(k, m);
                var E = null != y && y.name ? "".concat(k, "/").concat(y.name) : k;
                var w = {
                  name: E
                };
                return "core/block" === k && (w.ref = m.ref, E += "/" + m.ref), _objectSpread(_objectSpread({}, l), {}, {
                  insertUsage: _objectSpread(_objectSpread({}, l.insertUsage), {}, _defineProperty({}, E, {
                    time: s.time,
                    count: l.insertUsage[E] ? l.insertUsage[E].count + 1 : 1,
                    insert: w
                  }))
                });
              }, l);
          }

          return l;
        }

        s.blocks = E;

        var blockListSettings = function blockListSettings() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              s = arguments.length > 1 ? arguments[1] : void 0;

          switch (s.type) {
            case "REPLACE_BLOCKS":
            case "REMOVE_BLOCKS":
              return (0, m.omit)(l, s.clientIds);

            case "UPDATE_BLOCK_LIST_SETTINGS":
              {
                var _c66 = s.clientId;
                return s.settings ? (0, m.isEqual)(l[_c66], s.settings) ? l : _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, _c66, s.settings)) : l.hasOwnProperty(_c66) ? (0, m.omit)(l, _c66) : l;
              }
          }

          return l;
        };

        function isNavigationMode() {
          var l = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              s = arguments.length > 1 ? arguments[1] : void 0;
          return "INSERT_BLOCKS" !== s.type && ("SET_NAVIGATION_MODE" === s.type ? s.isNavigationMode : l);
        }

        function hasBlockMovingClientId() {
          var l = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              s = arguments.length > 1 ? arguments[1] : void 0;
          return "SET_BLOCK_MOVING_MODE" === s.type ? s.hasBlockMovingClientId : "SET_NAVIGATION_MODE" === s.type ? null : l;
        }

        function lastBlockAttributesChange(l, s) {
          switch (s.type) {
            case "UPDATE_BLOCK":
              if (!s.updates.attributes) break;
              return _defineProperty({}, s.clientId, s.updates.attributes);

            case "UPDATE_BLOCK_ATTRIBUTES":
              return s.clientIds.reduce(function (l, c) {
                return _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, c, s.uniqueByBlock ? s.attributes[c] : s.attributes));
              }, {});
          }

          return null;
        }

        function automaticChangeStatus(l, s) {
          switch (s.type) {
            case "MARK_AUTOMATIC_CHANGE":
              return "pending";

            case "MARK_AUTOMATIC_CHANGE_FINAL":
              return "pending" === l ? "final" : void 0;

            case "SELECTION_CHANGE":
              return "final" !== l ? l : void 0;

            case "START_TYPING":
            case "STOP_TYPING":
              return l;
          }
        }

        function highlightedBlock(l, s) {
          switch (s.type) {
            case "TOGGLE_BLOCK_HIGHLIGHT":
              var _c67 = s.clientId,
                  _m49 = s.isHighlighted;
              return _m49 ? _c67 : l === _c67 ? null : l;

            case "SELECT_BLOCK":
              if (s.clientId !== l) return null;
          }

          return l;
        }

        function lastBlockInserted() {
          var l;
          var s = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              c = arguments.length > 1 ? arguments[1] : void 0;

          switch (c.type) {
            case "INSERT_BLOCKS":
              if (!c.blocks.length) return s;
              return {
                clientId: c.blocks[0].clientId,
                source: null === (l = c.meta) || void 0 === l ? void 0 : l.source
              };

            case "RESET_BLOCKS":
              return {};
          }

          return s;
        }

        s.blockListSettings = blockListSettings;
        var w = (0, v.combineReducers)({
          blocks: E,
          isTyping: isTyping,
          draggedBlocks: draggedBlocks,
          isCaretWithinFormattedText: isCaretWithinFormattedText,
          selection: selection,
          isMultiSelecting: isMultiSelecting,
          isSelectionEnabled: isSelectionEnabled,
          initialPosition: initialPosition,
          blocksMode: blocksMode,
          blockListSettings: blockListSettings,
          insertionPoint: insertionPoint,
          template: template,
          settings: settings,
          preferences: preferences,
          lastBlockAttributesChange: lastBlockAttributesChange,
          isNavigationMode: isNavigationMode,
          hasBlockMovingClientId: hasBlockMovingClientId,
          automaticChangeStatus: automaticChangeStatus,
          highlightedBlock: highlightedBlock,
          lastBlockInserted: lastBlockInserted
        });
        s.default = w;
      },
      3021: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.__experimentalGetDirectInsertBlock = s.__experimentalGetBlockListSettingsForBlocks = s.__experimentalGetAllowedPatterns = s.__experimentalGetAllowedBlocks = s.__experimentalGetActiveBlockIdByBlockNames = void 0, s.__experimentalGetLastBlockAttributeChanges = function __experimentalGetLastBlockAttributeChanges(l) {
          return l.lastBlockAttributesChange;
        }, s.__unstableGetClientIdsTree = s.__unstableGetClientIdWithClientIdsTree = s.__unstableGetBlockWithoutInnerBlocks = s.__experimentalGetReusableBlockTitle = s.__experimentalGetPatternsByBlockTypes = s.__experimentalGetPatternTransformItems = s.__experimentalGetParsedPattern = void 0, s.__unstableIsLastBlockChangeIgnored = function __unstableIsLastBlockChangeIgnored(l) {
          return l.blocks.isIgnoredChange;
        }, s.areInnerBlocksControlled = areInnerBlocksControlled, s.canInsertBlockType = void 0, s.canInsertBlocks = function canInsertBlocks(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          return s.every(function (s) {
            return G(l, getBlockName(l, s), c);
          });
        }, s.canMoveBlock = canMoveBlock, s.canMoveBlocks = function canMoveBlocks(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          return s.every(function (s) {
            return canMoveBlock(l, s, c);
          });
        }, s.canRemoveBlock = canRemoveBlock, s.canRemoveBlocks = function canRemoveBlocks(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          return s.every(function (s) {
            return canRemoveBlock(l, s, c);
          });
        }, s.didAutomaticChange = function didAutomaticChange(l) {
          return !!l.automaticChangeStatus;
        }, s.getAdjacentBlockClientId = getAdjacentBlockClientId, s.getBlock = getBlock, s.getBlockAttributes = getBlockAttributes, s.getBlockCount = function getBlockCount(l, s) {
          return getBlockOrder(l, s).length;
        }, s.getBlockHierarchyRootClientId = function getBlockHierarchyRootClientId(l, s) {
          var c,
              m = s;

          do {
            c = m, m = l.blocks.parents[m];
          } while (m);

          return c;
        }, s.getBlockIndex = getBlockIndex, s.getBlockInsertionPoint = function getBlockInsertionPoint(l) {
          var s, c;
          var m = l.insertionPoint,
              v = l.selection.selectionEnd;
          if (null !== m) return m;
          var _ = v.clientId;
          _ ? (s = getBlockRootClientId(l, _) || void 0, c = getBlockIndex(l, v.clientId) + 1) : c = getBlockOrder(l).length;
          return {
            rootClientId: s,
            index: c
          };
        }, s.getBlockListSettings = getBlockListSettings, s.getBlockMode = function getBlockMode(l, s) {
          return l.blocksMode[s] || "visual";
        }, s.getBlockName = getBlockName, s.getBlockOrder = getBlockOrder, s.getBlockParentsByBlockName = s.getBlockParents = void 0, s.getBlockRootClientId = getBlockRootClientId, s.getBlockSelectionEnd = function getBlockSelectionEnd(l) {
          return l.selection.selectionEnd.clientId;
        }, s.getBlockSelectionStart = function getBlockSelectionStart(l) {
          return l.selection.selectionStart.clientId;
        }, s.getBlockTransformItems = void 0, s.getBlocks = function getBlocks(l, s) {
          var c;
          var m = s && areInnerBlocksControlled(l, s) ? "controlled||" + s : s || "";
          return (null === (c = l.blocks.tree[m]) || void 0 === c ? void 0 : c.innerBlocks) || C;
        }, s.getClientIdsWithDescendants = s.getClientIdsOfDescendants = s.getBlocksByClientId = void 0, s.getDraggedBlockClientIds = function getDraggedBlockClientIds(l) {
          return l.draggedBlocks;
        }, s.getFirstMultiSelectedBlockClientId = getFirstMultiSelectedBlockClientId, s.getInserterItems = s.getGlobalBlockCount = void 0, s.getLastMultiSelectedBlockClientId = getLastMultiSelectedBlockClientId, s.getLowestCommonAncestorWithSelectedBlock = function getLowestCommonAncestorWithSelectedBlock(l, s) {
          var c = getSelectedBlockClientId(l),
              m = [].concat(_toConsumableArray(R(l, s)), [s]),
              v = [].concat(_toConsumableArray(R(l, c)), [c]);

          var _;

          var k = Math.min(m.length, v.length);

          for (var _l168 = 0; _l168 < k && m[_l168] === v[_l168]; _l168++) {
            _ = m[_l168];
          }

          return _;
        }, s.getMultiSelectedBlockClientIds = getMultiSelectedBlockClientIds, s.getMultiSelectedBlocks = void 0, s.getMultiSelectedBlocksEndClientId = function getMultiSelectedBlocksEndClientId(l) {
          var _l$selection = l.selection,
              s = _l$selection.selectionStart,
              c = _l$selection.selectionEnd;
          if (s.clientId === c.clientId) return null;
          return c.clientId || null;
        }, s.getMultiSelectedBlocksStartClientId = function getMultiSelectedBlocksStartClientId(l) {
          var _l$selection2 = l.selection,
              s = _l$selection2.selectionStart,
              c = _l$selection2.selectionEnd;
          if (s.clientId === c.clientId) return null;
          return s.clientId || null;
        }, s.getNextBlockClientId = function getNextBlockClientId(l, s) {
          return getAdjacentBlockClientId(l, s, 1);
        }, s.getPreviousBlockClientId = function getPreviousBlockClientId(l, s) {
          return getAdjacentBlockClientId(l, s, -1);
        }, s.getSelectedBlock = function getSelectedBlock(l) {
          var s = getSelectedBlockClientId(l);
          return s ? getBlock(l, s) : null;
        }, s.getSelectedBlockClientId = getSelectedBlockClientId, s.getSelectedBlockClientIds = void 0, s.getSelectedBlockCount = function getSelectedBlockCount(l) {
          var s = getMultiSelectedBlockClientIds(l).length;
          if (s) return s;
          return l.selection.selectionStart.clientId ? 1 : 0;
        }, s.getSelectedBlocksInitialCaretPosition = function getSelectedBlocksInitialCaretPosition(l) {
          return l.initialPosition;
        }, s.getSelectionEnd = function getSelectionEnd(l) {
          return l.selection.selectionEnd;
        }, s.getSelectionStart = function getSelectionStart(l) {
          return l.selection.selectionStart;
        }, s.getSettings = getSettings, s.getTemplate = function getTemplate(l) {
          return l.settings.template;
        }, s.getTemplateLock = getTemplateLock, s.hasBlockMovingClientId = function hasBlockMovingClientId(l) {
          return l.hasBlockMovingClientId;
        }, s.hasInserterItems = void 0, s.hasMultiSelection = function hasMultiSelection(l) {
          var _l$selection3 = l.selection,
              s = _l$selection3.selectionStart,
              c = _l$selection3.selectionEnd;
          return s.clientId !== c.clientId;
        }, s.hasSelectedBlock = function hasSelectedBlock(l) {
          var _l$selection4 = l.selection,
              s = _l$selection4.selectionStart,
              c = _l$selection4.selectionEnd;
          return !!s.clientId && s.clientId === c.clientId;
        }, s.hasSelectedInnerBlock = function hasSelectedInnerBlock(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return (0, v.some)(getBlockOrder(l, s), function (s) {
            return isBlockSelected(l, s) || isBlockMultiSelected(l, s) || c && hasSelectedInnerBlock(l, s, c);
          });
        }, s.isAncestorBeingDragged = function isAncestorBeingDragged(l, s) {
          if (!isDraggingBlocks(l)) return !1;
          var c = R(l, s);
          return (0, v.some)(c, function (s) {
            return isBlockBeingDragged(l, s);
          });
        }, s.isAncestorMultiSelected = void 0, s.isBlockBeingDragged = isBlockBeingDragged, s.isBlockHighlighted = function isBlockHighlighted(l, s) {
          return l.highlightedBlock === s;
        }, s.isBlockInsertionPointVisible = function isBlockInsertionPointVisible(l) {
          return null !== l.insertionPoint;
        }, s.isBlockMultiSelected = isBlockMultiSelected, s.isBlockSelected = isBlockSelected, s.isBlockValid = function isBlockValid(l, s) {
          var c = l.blocks.byClientId[s];
          return !!c && c.isValid;
        }, s.isBlockWithinSelection = function isBlockWithinSelection(l, s) {
          if (!s) return !1;
          var c = getMultiSelectedBlockClientIds(l),
              m = c.indexOf(s);
          return m > -1 && m < c.length - 1;
        }, s.isCaretWithinFormattedText = function isCaretWithinFormattedText(l) {
          return l.isCaretWithinFormattedText;
        }, s.isDraggingBlocks = isDraggingBlocks, s.isFirstMultiSelectedBlock = function isFirstMultiSelectedBlock(l, s) {
          return getFirstMultiSelectedBlockClientId(l) === s;
        }, s.isLastBlockChangePersistent = function isLastBlockChangePersistent(l) {
          return l.blocks.isPersistentChange;
        }, s.isMultiSelecting = function isMultiSelecting(l) {
          return l.isMultiSelecting;
        }, s.isNavigationMode = function isNavigationMode(l) {
          return l.isNavigationMode;
        }, s.isSelectionEnabled = function isSelectionEnabled(l) {
          return l.isSelectionEnabled;
        }, s.isTyping = function isTyping(l) {
          return l.isTyping;
        }, s.isValidTemplate = function isValidTemplate(l) {
          return l.template.isValid;
        }, s.wasBlockJustInserted = function wasBlockJustInserted(l, s, c) {
          var m = l.lastBlockInserted;
          return m.clientId === s && m.source === c;
        };

        var v = c(4793),
            _ = m(c(8235)),
            k = c(6700),
            y = c(1753),
            E = c(1149),
            w = c(2614);

        var C = [];

        function getBlockName(l, s) {
          var c = l.blocks.byClientId[s],
              m = "core/social-link";

          if ("web" !== y.Platform.OS && (null == c ? void 0 : c.name) === m) {
            var _c68 = l.blocks.attributes[s],
                _v31 = _c68.service;
            return _v31 ? "core/social-link-".concat(_v31) : m;
          }

          return c ? c.name : null;
        }

        function getBlockAttributes(l, s) {
          return l.blocks.byClientId[s] ? l.blocks.attributes[s] : null;
        }

        function getBlock(l, s) {
          return l.blocks.byClientId[s] ? l.blocks.tree[s] : null;
        }

        var S = (0, _.default)(function (l, s) {
          var c = l.blocks.byClientId[s];
          return c ? _objectSpread(_objectSpread({}, c), {}, {
            attributes: getBlockAttributes(l, s)
          }) : null;
        }, function (l, s) {
          return [l.blocks.byClientId[s], l.blocks.attributes[s]];
        });
        s.__unstableGetBlockWithoutInnerBlocks = S;
        var B = (0, _.default)(function (l, s) {
          return {
            clientId: s,
            innerBlocks: P(l, s)
          };
        }, function (l) {
          return [l.blocks.order];
        });
        s.__unstableGetClientIdWithClientIdsTree = B;
        var P = (0, _.default)(function (l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
          return (0, v.map)(getBlockOrder(l, s), function (s) {
            return B(l, s);
          });
        }, function (l) {
          return [l.blocks.order];
        });
        s.__unstableGetClientIdsTree = P;

        var getClientIdsOfDescendants = function getClientIdsOfDescendants(l, s) {
          return (0, v.flatMap)(s, function (s) {
            var c = getBlockOrder(l, s);
            return [].concat(_toConsumableArray(c), _toConsumableArray(getClientIdsOfDescendants(l, c)));
          });
        };

        s.getClientIdsOfDescendants = getClientIdsOfDescendants;
        var O = (0, _.default)(function (l) {
          var s = getBlockOrder(l);
          return [].concat(_toConsumableArray(s), _toConsumableArray(getClientIdsOfDescendants(l, s)));
        }, function (l) {
          return [l.blocks.order];
        });
        s.getClientIdsWithDescendants = O;
        var L = (0, _.default)(function (l, s) {
          var c = O(l);
          return s ? (0, v.reduce)(c, function (c, m) {
            return l.blocks.byClientId[m].name === s ? c + 1 : c;
          }, 0) : c.length;
        }, function (l) {
          return [l.blocks.order, l.blocks.byClientId];
        });
        s.getGlobalBlockCount = L;
        var V = (0, _.default)(function (l, s) {
          return (0, v.map)((0, v.castArray)(s), function (s) {
            return getBlock(l, s);
          });
        }, function (l, s) {
          return (0, v.map)((0, v.castArray)(s), function (s) {
            return l.blocks.tree[s];
          });
        });

        function getSelectedBlockClientId(l) {
          var _l$selection5 = l.selection,
              s = _l$selection5.selectionStart,
              c = _l$selection5.selectionEnd,
              m = s.clientId;
          return m && m === c.clientId ? m : null;
        }

        function getBlockRootClientId(l, s) {
          return void 0 !== l.blocks.parents[s] ? l.blocks.parents[s] : null;
        }

        s.getBlocksByClientId = V;
        var R = (0, _.default)(function (l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          var m = [];
          var v = s;

          for (; l.blocks.parents[v];) {
            v = l.blocks.parents[v], m.push(v);
          }

          return c ? m : m.reverse();
        }, function (l) {
          return [l.blocks.parents];
        });
        s.getBlockParents = R;
        var A = (0, _.default)(function (l, s, c) {
          var m = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];

          var _ = R(l, s, m);

          return (0, v.map)((0, v.filter)((0, v.map)(_, function (s) {
            return {
              id: s,
              name: getBlockName(l, s)
            };
          }), function (l) {
            var s = l.name;
            return Array.isArray(c) ? c.includes(s) : s === c;
          }), function (l) {
            var s = l.id;
            return s;
          });
        }, function (l) {
          return [l.blocks.parents];
        });

        function getAdjacentBlockClientId(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
          if (void 0 === s && (s = getSelectedBlockClientId(l)), void 0 === s && (s = c < 0 ? getFirstMultiSelectedBlockClientId(l) : getLastMultiSelectedBlockClientId(l)), !s) return null;
          var m = getBlockRootClientId(l, s);
          if (null === m) return null;

          var v = l.blocks.order,
              _ = v[m],
              k = _.indexOf(s),
              y = k + 1 * c;

          return y < 0 || y === _.length ? null : _[y];
        }

        s.getBlockParentsByBlockName = A;
        var z = (0, _.default)(function (l) {
          var _l$selection6 = l.selection,
              s = _l$selection6.selectionStart,
              c = _l$selection6.selectionEnd;
          if (void 0 === s.clientId || void 0 === c.clientId) return C;
          if (s.clientId === c.clientId) return [s.clientId];
          var m = getBlockRootClientId(l, s.clientId);
          if (null === m) return C;

          var v = getBlockOrder(l, m),
              _ = v.indexOf(s.clientId),
              k = v.indexOf(c.clientId);

          return _ > k ? v.slice(k, _ + 1) : v.slice(_, k + 1);
        }, function (l) {
          return [l.blocks.order, l.selection.selectionStart.clientId, l.selection.selectionEnd.clientId];
        });

        function getMultiSelectedBlockClientIds(l) {
          var _l$selection7 = l.selection,
              s = _l$selection7.selectionStart,
              c = _l$selection7.selectionEnd;
          return s.clientId === c.clientId ? C : z(l);
        }

        s.getSelectedBlockClientIds = z;
        var D = (0, _.default)(function (l) {
          var s = getMultiSelectedBlockClientIds(l);
          return s.length ? s.map(function (s) {
            return getBlock(l, s);
          }) : C;
        }, function (l) {
          return [].concat(_toConsumableArray(z.getDependants(l)), [l.blocks.byClientId, l.blocks.order, l.blocks.attributes]);
        });

        function getFirstMultiSelectedBlockClientId(l) {
          return (0, v.first)(getMultiSelectedBlockClientIds(l)) || null;
        }

        function getLastMultiSelectedBlockClientId(l) {
          return (0, v.last)(getMultiSelectedBlockClientIds(l)) || null;
        }

        function isBlockMultiSelected(l, s) {
          return -1 !== getMultiSelectedBlockClientIds(l).indexOf(s);
        }

        s.getMultiSelectedBlocks = D;
        var F = (0, _.default)(function (l, s) {
          var c = s,
              m = !1;

          for (; c && !m;) {
            c = getBlockRootClientId(l, c), m = isBlockMultiSelected(l, c);
          }

          return m;
        }, function (l) {
          return [l.blocks.order, l.selection.selectionStart.clientId, l.selection.selectionEnd.clientId];
        });

        function getBlockOrder(l, s) {
          return l.blocks.order[s || ""] || C;
        }

        function getBlockIndex(l, s) {
          return getBlockOrder(l, getBlockRootClientId(l, s)).indexOf(s);
        }

        function isBlockSelected(l, s) {
          var _l$selection8 = l.selection,
              c = _l$selection8.selectionStart,
              m = _l$selection8.selectionEnd;
          return c.clientId === m.clientId && c.clientId === s;
        }

        function isDraggingBlocks(l) {
          return !!l.draggedBlocks.length;
        }

        function isBlockBeingDragged(l, s) {
          return l.draggedBlocks.includes(s);
        }

        function getTemplateLock(l, s) {
          if (!s) return l.settings.templateLock;
          var c = getBlockListSettings(l, s);
          return c ? c.templateLock : null;
        }

        s.isAncestorMultiSelected = F;

        var checkAllowList = function checkAllowList(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          return (0, v.isBoolean)(l) ? l : (0, v.isArray)(l) ? !(!l.includes("core/post-content") || null !== s) || l.includes(s) : c;
        },
            canInsertBlockTypeUnmemoized = function canInsertBlockTypeUnmemoized(l, s) {
          var c,
              m = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          if (s && "object" == typeof s ? (c = s, s = c.name) : c = (0, k.getBlockType)(s), !c) return !1;

          var _getSettings = getSettings(l),
              v = _getSettings.allowedBlockTypes,
              _ = checkAllowList(v, s, !0);

          if (!_) return !1;
          var y = !!getTemplateLock(l, m);
          if (y) return !1;
          var w = getBlockListSettings(l, m);
          if (m && void 0 === w) return !1;
          var C = null == w ? void 0 : w.allowedBlocks,
              S = checkAllowList(C, s),
              B = c.parent,
              P = getBlockName(l, m),
              O = checkAllowList(B, P),
              L = null === S && null === O || !0 === S || !0 === O;
          return L ? (0, E.applyFilters)("blockEditor.__unstableCanInsertBlockType", L, c, m, {
            getBlock: getBlock.bind(null, l),
            getBlockParentsByBlockName: A.bind(null, l)
          }) : L;
        },
            G = (0, _.default)(canInsertBlockTypeUnmemoized, function (l, s, c) {
          return [l.blockListSettings[c], l.blocks.byClientId[c], l.settings.allowedBlockTypes, l.settings.templateLock];
        });

        function canRemoveBlock(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          var m = getBlockAttributes(l, s);
          if (null === m) return !0;

          var v = m.lock,
              _ = !!getTemplateLock(l, c);

          return void 0 === v || void 0 === (null == v ? void 0 : v.remove) ? !_ : !(null != v && v.remove);
        }

        function canMoveBlock(l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          var m = getBlockAttributes(l, s);
          if (null === m) return;

          var v = m.lock,
              _ = "all" === getTemplateLock(l, c);

          return void 0 === v || void 0 === (null == v ? void 0 : v.move) ? !_ : !(null != v && v.move);
        }

        function getInsertUsage(l, s) {
          var c, m;
          return null !== (c = null === (m = l.preferences.insertUsage) || void 0 === m ? void 0 : m[s]) && void 0 !== c ? c : null;
        }

        s.canInsertBlockType = G;

        var canIncludeBlockTypeInInserter = function canIncludeBlockTypeInInserter(l, s, c) {
          return !!(0, k.hasBlockSupport)(s, "inserter", !0) && canInsertBlockTypeUnmemoized(l, s.name, c);
        },
            getItemFromVariation = function getItemFromVariation(l, s) {
          return function (c) {
            var m = "".concat(s.id, "/").concat(c.name),
                _ref413 = getInsertUsage(l, m) || {},
                v = _ref413.time,
                _ref413$count = _ref413.count,
                _ = _ref413$count === void 0 ? 0 : _ref413$count;

            return _objectSpread(_objectSpread({}, s), {}, {
              id: m,
              icon: c.icon || s.icon,
              title: c.title || s.title,
              description: c.description || s.description,
              category: c.category || s.category,
              example: c.hasOwnProperty("example") ? c.example : s.example,
              initialAttributes: _objectSpread(_objectSpread({}, s.initialAttributes), c.attributes),
              innerBlocks: c.innerBlocks,
              keywords: c.keywords || s.keywords,
              frecency: calculateFrecency(v, _)
            });
          };
        },
            calculateFrecency = function calculateFrecency(l, s) {
          if (!l) return s;
          var c = Date.now() - l;

          switch (!0) {
            case c < 36e5:
              return 4 * s;

            case c < 864e5:
              return 2 * s;

            case c < 6048e5:
              return s / 2;

            default:
              return s / 4;
          }
        },
            buildBlockTypeItem = function buildBlockTypeItem(l, s) {
          var _s$buildScope = s.buildScope,
              c = _s$buildScope === void 0 ? "inserter" : _s$buildScope;
          return function (s) {
            var m = s.name;

            var _ = !1;

            (0, k.hasBlockSupport)(s.name, "multiple", !0) || (_ = (0, v.some)(V(l, O(l)), {
              name: s.name
            }));

            var _ref414 = getInsertUsage(l, m) || {},
                y = _ref414.time,
                _ref414$count = _ref414.count,
                E = _ref414$count === void 0 ? 0 : _ref414$count,
                w = {
              id: m,
              name: s.name,
              title: s.title,
              icon: s.icon,
              isDisabled: _,
              frecency: calculateFrecency(y, E)
            };

            if ("transform" === c) return w;
            var C = (0, k.getBlockVariations)(s.name, "inserter");
            return _objectSpread(_objectSpread({}, w), {}, {
              initialAttributes: {},
              description: s.description,
              category: s.category,
              keywords: s.keywords,
              variations: C,
              example: s.example,
              utility: 1
            });
          };
        },
            U = (0, _.default)(function (l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;

          var c = buildBlockTypeItem(l, {
            buildScope: "inserter"
          }),
              m = /^\s*<!--\s+(\/)?wp:([a-z][a-z0-9_-]*\/)?([a-z][a-z0-9_-]*)\s+({(?:(?=([^}]+|}+(?=})|(?!}\s+\/?-->)[^])*)\5|[^]*?)}\s+)?(\/)?-->/,
              buildReusableBlockInserterItem = function buildReusableBlockInserterItem(s) {
            var c = w.symbol;

            if ("web" === y.Platform.OS) {
              var _l169 = ("string" == typeof s.content.raw ? s.content.raw : s.content).match(m);

              if (_l169) {
                var _l170 = _slicedToArray(_l169, 4),
                    _l170$ = _l170[2],
                    _s70 = _l170$ === void 0 ? "core/" : _l170$,
                    _m50 = _l170[3],
                    _v32 = (0, k.getBlockType)(_s70 + _m50);

                _v32 && (c = _v32.icon);
              }
            }

            var v = "core/block/".concat(s.id),
                _ref415 = getInsertUsage(l, v) || {},
                _ = _ref415.time,
                _ref415$count = _ref415.count,
                E = _ref415$count === void 0 ? 0 : _ref415$count,
                C = calculateFrecency(_, E);

            return {
              id: v,
              name: "core/block",
              initialAttributes: {
                ref: s.id
              },
              title: s.title.raw,
              icon: c,
              category: "reusable",
              keywords: [],
              isDisabled: !1,
              utility: 1,
              frecency: C
            };
          },
              v = (0, k.getBlockTypes)().filter(function (c) {
            return canIncludeBlockTypeInInserter(l, c, s);
          }).map(c),
              _ = canInsertBlockTypeUnmemoized(l, "core/block", s) ? getReusableBlocks(l).map(buildReusableBlockInserterItem) : [],
              E = v.reduce(function (s, c) {
            var _c$variations = c.variations,
                m = _c$variations === void 0 ? [] : _c$variations;

            if (m.some(function (l) {
              var s = l.isDefault;
              return s;
            }) || s.push(c), m.length) {
              var _v33 = getItemFromVariation(l, c);

              s.push.apply(s, _toConsumableArray(m.map(_v33)));
            }

            return s;
          }, []),
              groupByType = function groupByType(l, s) {
            var c = l.core,
                m = l.noncore;
            return (s.name.startsWith("core/") ? c : m).push(s), l;
          },
              _E$reduce = E.reduce(groupByType, {
            core: [],
            noncore: []
          }),
              C = _E$reduce.core,
              S = _E$reduce.noncore,
              B = [].concat(_toConsumableArray(C), _toConsumableArray(S));

          return [].concat(B, _toConsumableArray(_));
        }, function (l, s) {
          return [l.blockListSettings[s], l.blocks.byClientId, l.blocks.order, l.preferences.insertUsage, l.settings.allowedBlockTypes, l.settings.templateLock, getReusableBlocks(l), (0, k.getBlockTypes)()];
        });

        s.getInserterItems = U;
        var W = (0, _.default)(function (l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;

          var m = buildBlockTypeItem(l, {
            buildScope: "transform"
          }),
              _ = (0, k.getBlockTypes)().filter(function (s) {
            return canIncludeBlockTypeInInserter(l, s, c);
          }).map(m),
              y = (0, v.mapKeys)(_, function (l) {
            var s = l.name;
            return s;
          }),
              E = (0, k.getPossibleBlockTransformations)(s).reduce(function (l, s) {
            return y[null == s ? void 0 : s.name] && l.push(y[s.name]), l;
          }, []),
              w = (0, v.orderBy)(E, function (l) {
            return y[l.name].frecency;
          }, "desc");

          return w;
        }, function (l, s) {
          return [l.blockListSettings[s], l.blocks.byClientId, l.preferences.insertUsage, l.settings.allowedBlockTypes, l.settings.templateLock, (0, k.getBlockTypes)()];
        });
        s.getBlockTransformItems = W;
        var K = (0, _.default)(function (l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          var c = (0, v.some)((0, k.getBlockTypes)(), function (c) {
            return canIncludeBlockTypeInInserter(l, c, s);
          });
          if (c) return !0;
          var m = canInsertBlockTypeUnmemoized(l, "core/block", s) && getReusableBlocks(l).length > 0;
          return m;
        }, function (l, s) {
          return [l.blockListSettings[s], l.blocks.byClientId, l.settings.allowedBlockTypes, l.settings.templateLock, getReusableBlocks(l), (0, k.getBlockTypes)()];
        });
        s.hasInserterItems = K;
        var $ = (0, _.default)(function (l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          if (s) return (0, v.filter)((0, k.getBlockTypes)(), function (c) {
            return canIncludeBlockTypeInInserter(l, c, s);
          });
        }, function (l, s) {
          return [l.blockListSettings[s], l.blocks.byClientId, l.settings.allowedBlockTypes, l.settings.templateLock, (0, k.getBlockTypes)()];
        });
        s.__experimentalGetAllowedBlocks = $;
        var q = (0, _.default)(function (l) {
          var s, c;
          var m = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          if (!m) return;

          var v = null === (s = l.blockListSettings[m]) || void 0 === s ? void 0 : s.__experimentalDefaultBlock,
              _ = null === (c = l.blockListSettings[m]) || void 0 === c ? void 0 : c.__experimentalDirectInsert;

          return v && _ ? "function" == typeof _ ? _(getBlock(l, m)) ? v : null : v : void 0;
        }, function (l, s) {
          return [l.blockListSettings[s], l.blocks.tree[s]];
        });
        s.__experimentalGetDirectInsertBlock = q;
        var Y = (0, _.default)(function (l, s) {
          var c = l.settings.__experimentalBlockPatterns.find(function (l) {
            var c = l.name;
            return c === s;
          });

          return c ? _objectSpread(_objectSpread({}, c), {}, {
            blocks: (0, k.parse)(c.content)
          }) : null;
        }, function (l) {
          return [l.settings.__experimentalBlockPatterns];
        });
        s.__experimentalGetParsedPattern = Y;
        var Z = (0, _.default)(function (l) {
          var s = l.settings.__experimentalBlockPatterns,
              _getSettings2 = getSettings(l),
              c = _getSettings2.allowedBlockTypes,
              m = s.filter(function (l) {
            var _l$inserter = l.inserter,
                s = _l$inserter === void 0 ? !0 : _l$inserter;
            return !!s;
          }).map(function (s) {
            var c = s.name;
            return Y(l, c);
          }).filter(function (l) {
            var s = l.blocks;
            return function (l, s) {
              if ((0, v.isBoolean)(s)) return s;

              var c = _toConsumableArray(l);

              for (; c.length > 0;) {
                var m;

                var _l171 = c.shift();

                if (!checkAllowList(s, _l171.name || _l171.blockName, !0)) return !1;
                null === (m = _l171.innerBlocks) || void 0 === m || m.forEach(function (l) {
                  c.push(l);
                });
              }

              return !0;
            }(s, c);
          });

          return m;
        }, function (l) {
          return [l.settings.__experimentalBlockPatterns, l.settings.allowedBlockTypes];
        }),
            X = (0, _.default)(function (l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          var c = Z(l),
              m = (0, v.filter)(c, function (c) {
            var m = c.blocks;
            return m.every(function (c) {
              var m = c.name;
              return G(l, m, s);
            });
          });
          return m;
        }, function (l, s) {
          return [l.settings.__experimentalBlockPatterns, l.settings.allowedBlockTypes, l.settings.templateLock, l.blockListSettings[s], l.blocks.byClientId[s]];
        });
        s.__experimentalGetAllowedPatterns = X;
        var Q = (0, _.default)(function (l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          if (!s) return C;
          var m = X(l, c),
              v = Array.isArray(s) ? s : [s];
          return m.filter(function (l) {
            var s, c;
            return null == l || null === (s = l.blockTypes) || void 0 === s || null === (c = s.some) || void 0 === c ? void 0 : c.call(s, function (l) {
              return v.includes(l);
            });
          });
        }, function (l, s) {
          return _toConsumableArray(X.getDependants(l, s));
        });
        s.__experimentalGetPatternsByBlockTypes = Q;
        var J = (0, _.default)(function (l, s) {
          var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          if (!s) return C;
          if (s.some(function (s) {
            var c = s.clientId,
                m = s.innerBlocks;
            return m.length || areInnerBlocksControlled(l, c);
          })) return C;
          var m = Array.from(new Set(s.map(function (l) {
            var s = l.name;
            return s;
          })));
          return Q(l, m, c);
        }, function (l, s) {
          return _toConsumableArray(Q.getDependants(l, s));
        });

        function getBlockListSettings(l, s) {
          return l.blockListSettings[s];
        }

        function getSettings(l) {
          return l.settings;
        }

        s.__experimentalGetPatternTransformItems = J;
        var ee = (0, _.default)(function (l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
          return s.reduce(function (s, c) {
            return l.blockListSettings[c] ? _objectSpread(_objectSpread({}, s), {}, _defineProperty({}, c, l.blockListSettings[c])) : s;
          }, {});
        }, function (l) {
          return [l.blockListSettings];
        });
        s.__experimentalGetBlockListSettingsForBlocks = ee;
        var te = (0, _.default)(function (l, s) {
          var c;
          var m = (0, v.find)(getReusableBlocks(l), function (l) {
            return l.id === s;
          });
          return m ? null === (c = m.title) || void 0 === c ? void 0 : c.raw : null;
        }, function (l) {
          return [getReusableBlocks(l)];
        });

        function getReusableBlocks(l) {
          var s, c;
          return null !== (s = null == l || null === (c = l.settings) || void 0 === c ? void 0 : c.__experimentalReusableBlocks) && void 0 !== s ? s : C;
        }

        function areInnerBlocksControlled(l, s) {
          return !!l.blocks.controlledInnerBlocks[s];
        }

        s.__experimentalGetReusableBlockTitle = te;
        var ne = (0, _.default)(function (l, s) {
          if (!s.length) return null;
          var c = getSelectedBlockClientId(l);
          if (s.includes(getBlockName(l, c))) return c;

          var m = getMultiSelectedBlockClientIds(l),
              _ = A(l, c || m[0], s);

          return _ ? (0, v.last)(_) : null;
        }, function (l, s) {
          return [l.selection.selectionStart.clientId, l.selection.selectionEnd.clientId, s];
        });
        s.__experimentalGetActiveBlockIdByBlockNames = ne;
      },
      8009: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.__experimentalGetMatchingVariation = void 0;
        var m = c(4793);

        s.__experimentalGetMatchingVariation = function (l, s) {
          if (!s || !l) return;
          var c = s.filter(function (s) {
            var c = s.attributes;
            return !(!c || !Object.keys(c).length) && (0, m.isMatch)(l, c);
          });
          return 1 === c.length ? c[0] : void 0;
        };
      },
      9040: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getBlockClientId = function getBlockClientId(l) {
          for (; l && l.nodeType !== l.ELEMENT_NODE;) {
            l = l.parentNode;
          }

          if (!l) return;
          var s = l.closest(c);
          if (!s) return;
          return s.id.slice("block-".length);
        }, s.isInSameBlock = function isInSameBlock(l, s) {
          return l.closest(c) === s.closest(c);
        }, s.isInsideRootBlock = function isInsideRootBlock(l, s) {
          return s.closest([c, m].join(",")) === l;
        };
        var c = ".block-editor-block-list__block",
            m = ".block-list-appender";
      },
      8945: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getPasteEventData = function getPasteEventData(l) {
          var s = l.clipboardData,
              c = "",
              _ = "";

          try {
            c = s.getData("text/plain"), _ = s.getData("text/html");
          } catch (l) {
            try {
              _ = s.getData("Text");
            } catch (l) {
              return;
            }
          }

          var k = (0, v.getFilesFromDataTransfer)(s).filter(function (l) {
            var s = l.type;
            return /^image\/(?:jpe?g|png|gif)$/.test(s);
          });
          k.length && !_ && (_ = k.map(function (l) {
            return "<img src=\"".concat((0, m.createBlobURL)(l), "\">");
          }).join(""), c = "");
          return {
            html: _,
            plainText: c
          };
        };
        var m = c(9388),
            v = c(5480);
      },
      1686: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        });
        var v = {
          transformStyles: !0,
          getPxFromCssUnit: !0
        };
        Object.defineProperty(s, "getPxFromCssUnit", {
          enumerable: !0,
          get: function get() {
            return E.default;
          }
        }), Object.defineProperty(s, "transformStyles", {
          enumerable: !0,
          get: function get() {
            return _.default;
          }
        });

        var _ = m(c(216)),
            k = c(924);

        Object.keys(k).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (Object.prototype.hasOwnProperty.call(v, l) || l in s && s[l] === k[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return k[l];
            }
          }));
        });
        var y = c(8009);
        Object.keys(y).forEach(function (l) {
          "default" !== l && "__esModule" !== l && (Object.prototype.hasOwnProperty.call(v, l) || l in s && s[l] === y[l] || Object.defineProperty(s, l, {
            enumerable: !0,
            get: function get() {
              return y[l];
            }
          }));
        });
        var E = m(c(8970));
      },
      4712: function _(l, s) {
        "use strict";

        function getDistanceFromPointToEdge(l, s, c) {
          var m = "top" === c || "bottom" === c,
              v = l.x,
              _ = l.y,
              k = m ? v : _,
              y = m ? _ : v,
              E = m ? s.left : s.top,
              w = m ? s.right : s.bottom,
              C = s[c];
          var S;
          return S = k >= E && k <= w ? k : k < w ? E : w, Math.sqrt(Math.pow(k - S, 2) + Math.pow(y - C, 2));
        }

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.getDistanceFromPointToEdge = getDistanceFromPointToEdge, s.getDistanceToNearestEdge = function getDistanceToNearestEdge(l, s) {
          var c,
              m,
              v = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ["top", "bottom", "left", "right"];
          return v.forEach(function (v) {
            var _ = getDistanceFromPointToEdge(l, s, v);

            (void 0 === c || _ < c) && (c = _, m = v);
          }), [c, m];
        };
      },
      8970: function _(l, s) {
        "use strict";

        function parseUnit(l) {
          var s = null == l ? void 0 : l.trim().match(/^(0?[-.]?\d+)(r?e[m|x]|v[h|w|min|max]+|p[x|t|c]|[c|m]m|%|in|ch|Q|lh)$/);
          return isNaN(l) || isNaN(parseFloat(l)) ? s ? {
            value: parseFloat(s[1]) || s[1],
            unit: s[2]
          } : {
            value: l,
            unit: void 0
          } : {
            value: parseFloat(l),
            unit: "px"
          };
        }

        function getFunctionUnitValue(l, s) {
          var c = l.split(/[(),]/g).filter(Boolean),
              m = c.slice(1).map(function (l) {
            return parseUnit(getPxFromCssUnit(l, s)).value;
          }).filter(Boolean);

          switch (c[0]) {
            case "min":
              return Math.min.apply(Math, _toConsumableArray(m)) + "px";

            case "max":
              return Math.max.apply(Math, _toConsumableArray(m)) + "px";

            case "clamp":
              return 3 !== m.length ? null : m[1] < m[0] ? m[0] + "px" : m[1] > m[2] ? m[2] + "px" : m[1] + "px";

            case "calc":
              return m[0] + "px";
          }
        }

        function parseUnitFunction(l) {
          for (;;) {
            var _s71 = l,
                _c69 = /(max|min|calc|clamp)\(([^()]*)\)/g.exec(l) || [];

            if (_c69[0]) {
              var _s72 = getFunctionUnitValue(_c69[0]);

              l = l.replace(_c69[0], _s72);
            }

            if (l === _s71 || parseFloat(l)) break;
          }

          return parseUnit(l);
        }

        function isMathExpression(l) {
          for (var _s73 = 0; _s73 < l.length; _s73++) {
            if (["+", "-", "/", "*"].includes(l[_s73])) return !0;
          }

          return !1;
        }

        function evalMathExpression(l) {
          var s = !1;
          var c = l.split(/[+-/*/]/g).filter(Boolean);

          var _iterator21 = _createForOfIteratorHelper(c),
              _step21;

          try {
            for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
              var _m51 = _step21.value;

              var _c70 = parseUnit(getPxFromCssUnit(_m51));

              if (!parseFloat(_c70.value)) {
                s = !0;
                break;
              }

              l = l.replace(_m51, _c70.value);
            }
          } catch (err) {
            _iterator21.e(err);
          } finally {
            _iterator21.f();
          }

          return s ? null : function calculate(l) {
            return Function("'use strict'; return (".concat(l, ")"))();
          }(l).toFixed(0) + "px";
        }

        function convertParsedUnitToPx(l, s) {
          var c = 96,
              m = .01,
              v = Object.assign({}, {
            fontSize: 16,
            lineHeight: 16,
            width: 375,
            height: 812,
            type: "font"
          }, s),
              _ = {
            em: v.fontSize,
            rem: v.fontSize,
            vh: v.height * m,
            vw: v.width * m,
            vmin: (v.width < v.height ? v.width : v.height) * m,
            vmax: (v.width > v.height ? v.width : v.height) * m,
            "%": ("font" === v.type ? v.fontSize : v.width) * m,
            ch: 8,
            ex: 7.15625,
            lh: v.lineHeight
          },
              k = {
            in: c,
            cm: 37.79527559055118,
            mm: 3.7795275590551185,
            pt: 1.3333333333333333,
            pc: 16,
            px: 1,
            Q: .9448818897637794
          };
          return _[l.unit] ? (_[l.unit] * l.value).toFixed(0) + "px" : k[l.unit] ? (k[l.unit] * l.value).toFixed(0) + "px" : null;
        }

        function getPxFromCssUnit(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (Number.isFinite(l)) return l.toFixed(0) + "px";
          if (void 0 === l) return null;
          var c = parseUnit(l);
          return c.unit || (c = parseUnitFunction(l)), isMathExpression(l) && !c.unit ? evalMathExpression(l) : convertParsedUnitToPx(c, s);
        }

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0, s.getPxFromCssUnit = getPxFromCssUnit;
        var c = {};

        function hashOptions(l) {
          var s = "";
          return l.hasOwnProperty("fontSize") && (s = ":" + l.width), l.hasOwnProperty("lineHeight") && (s = ":" + l.lineHeight), l.hasOwnProperty("width") && (s = ":" + l.width), l.hasOwnProperty("height") && (s = ":" + l.height), l.hasOwnProperty("type") && (s = ":" + l.type), s;
        }

        var m = function memoizedGetPxFromCssUnit(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          var m = l + hashOptions(s);
          return c[m] || (c[m] = getPxFromCssUnit(l, s)), c[m];
        };

        s.default = m;
      },
      6572: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.usePreParsePatterns = function usePreParsePatterns() {
          var l = (0, m.useSelect)(function (l) {
            return l(_.store).getSettings().__experimentalBlockPatterns;
          }, []);
          return (0, v.useEffect)(function () {
            if (null == l || !l.length) return;
            var s,
                c = -1;

            var callback = function callback() {
              c++, c >= l.length || ((0, m.select)(_.store).__experimentalGetParsedPattern(l[c].name), s = k(callback));
            };

            return s = k(callback), function () {
              return y(s);
            };
          }, [l]), null;
        };

        var m = c(8467),
            v = c(1753),
            _ = c(8486);

        var k = "undefined" == typeof window ? function (l) {
          setTimeout(function () {
            return l(Date.now());
          }, 0);
        } : window.requestIdleCallback || window.requestAnimationFrame,
            y = "undefined" == typeof window ? clearTimeout : window.cancelIdleCallback || window.cancelAnimationFrame;
      },
      924: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.validateThemeColors = function validateThemeColors(l) {
          if (void 0 === l) l = m.SETTINGS_DEFAULTS.colors;else {
            var _s74 = l.filter(function (l) {
              return l.color;
            });

            0 === _s74.length ? l = m.SETTINGS_DEFAULTS.colors : _s74.length < l.length && (l = _s74);
          }
          return l;
        }, s.validateThemeGradients = function validateThemeGradients(l) {
          if (void 0 === l) l = m.SETTINGS_DEFAULTS.gradients;else {
            var _s75 = l.filter(function (l) {
              return l.gradient;
            });

            0 === _s75.length ? l = m.SETTINGS_DEFAULTS.gradients : _s75.length < l.length && (l = _s75);
          }
          return l;
        };
        var m = c(1822);
      },
      3902: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), Object.defineProperty(s, "parse", {
          enumerable: !0,
          get: function get() {
            return v.default;
          }
        }), Object.defineProperty(s, "stringify", {
          enumerable: !0,
          get: function get() {
            return _.default;
          }
        });

        var v = m(c(7959)),
            _ = m(c(8500));
      },
      7959: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function _default(l, s) {
          s = s || {};
          var m = 1,
              v = 1;

          function updatePosition(l) {
            var s = l.match(/\n/g);
            s && (m += s.length);
            var c = l.lastIndexOf("\n");
            v = ~c ? l.length - c : v + l.length;
          }

          function position() {
            var l = {
              line: m,
              column: v
            };
            return function (s) {
              return s.position = new Position(l), whitespace(), s;
            };
          }

          function Position(l) {
            this.start = l, this.end = {
              line: m,
              column: v
            }, this.source = s.source;
          }

          Position.prototype.content = l;
          var _ = [];

          function error(c) {
            var k = new Error(s.source + ":" + m + ":" + v + ": " + c);
            if (k.reason = c, k.filename = s.source, k.line = m, k.column = v, k.source = l, !s.silent) throw k;

            _.push(k);
          }

          function open() {
            return match(/^{\s*/);
          }

          function close() {
            return match(/^}/);
          }

          function rules() {
            var s;
            var c = [];

            for (whitespace(), comments(c); l.length && "}" !== l.charAt(0) && (s = atrule() || rule());) {
              !1 !== s && (c.push(s), comments(c));
            }

            return c;
          }

          function match(s) {
            var c = s.exec(l);
            if (!c) return;
            var m = c[0];
            return updatePosition(m), l = l.slice(m.length), c;
          }

          function whitespace() {
            match(/^\s*/);
          }

          function comments(l) {
            var s;

            for (l = l || []; s = comment();) {
              !1 !== s && l.push(s);
            }

            return l;
          }

          function comment() {
            var s = position();
            if ("/" !== l.charAt(0) || "*" !== l.charAt(1)) return;
            var c = 2;

            for (; "" !== l.charAt(c) && ("*" !== l.charAt(c) || "/" !== l.charAt(c + 1));) {
              ++c;
            }

            if (c += 2, "" === l.charAt(c - 1)) return error("End of comment missing");
            var m = l.slice(2, c - 2);
            return v += 2, updatePosition(m), l = l.slice(c), v += 2, s({
              type: "comment",
              comment: m
            });
          }

          function selector() {
            var l = match(/^([^{]+)/);
            if (l) return trim(l[0]).replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, "").replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function (l) {
              return l.replace(/,/g, "‌");
            }).split(/\s*(?![^(]*\)),\s*/).map(function (l) {
              return l.replace(/\u200C/g, ",");
            });
          }

          function declaration() {
            var l = position();
            var s = match(/^(\*?[-#\/\*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
            if (!s) return;
            if (s = trim(s[0]), !match(/^:\s*/)) return error("property missing ':'");
            var m = match(/^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^\)]*?\)|[^};])+)/),
                v = l({
              type: "declaration",
              property: s.replace(c, ""),
              value: m ? trim(m[0]).replace(c, "") : ""
            });
            return match(/^[;\s]*/), v;
          }

          function declarations() {
            var l = [];
            if (!open()) return error("missing '{'");
            var s;

            for (comments(l); s = declaration();) {
              !1 !== s && (l.push(s), comments(l));
            }

            return close() ? l : error("missing '}'");
          }

          function keyframe() {
            var l;
            var s = [],
                c = position();

            for (; l = match(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/);) {
              s.push(l[1]), match(/^,\s*/);
            }

            if (s.length) return c({
              type: "keyframe",
              values: s,
              declarations: declarations()
            });
          }

          var k = _compileAtrule("import"),
              y = _compileAtrule("charset"),
              E = _compileAtrule("namespace");

          function _compileAtrule(l) {
            var s = new RegExp("^@" + l + "\\s*([^;]+);");
            return function () {
              var c = position(),
                  m = match(s);
              if (!m) return;
              var v = {
                type: l
              };
              return v[l] = m[1].trim(), c(v);
            };
          }

          function atrule() {
            if ("@" === l[0]) return function atkeyframes() {
              var l = position();
              var s = match(/^@([-\w]+)?keyframes\s*/);
              if (!s) return;
              var c = s[1];
              if (s = match(/^([-\w]+)\s*/), !s) return error("@keyframes missing name");
              var m = s[1];
              if (!open()) return error("@keyframes missing '{'");

              var v,
                  _ = comments();

              for (; v = keyframe();) {
                _.push(v), _ = _.concat(comments());
              }

              return close() ? l({
                type: "keyframes",
                name: m,
                vendor: c,
                keyframes: _
              }) : error("@keyframes missing '}'");
            }() || function atmedia() {
              var l = position(),
                  s = match(/^@media *([^{]+)/);
              if (!s) return;
              var c = trim(s[1]);
              if (!open()) return error("@media missing '{'");
              var m = comments().concat(rules());
              return close() ? l({
                type: "media",
                media: c,
                rules: m
              }) : error("@media missing '}'");
            }() || function atcustommedia() {
              var l = position(),
                  s = match(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
              if (s) return l({
                type: "custom-media",
                name: trim(s[1]),
                media: trim(s[2])
              });
            }() || function atsupports() {
              var l = position(),
                  s = match(/^@supports *([^{]+)/);
              if (!s) return;
              var c = trim(s[1]);
              if (!open()) return error("@supports missing '{'");
              var m = comments().concat(rules());
              return close() ? l({
                type: "supports",
                supports: c,
                rules: m
              }) : error("@supports missing '}'");
            }() || k() || y() || E() || function atdocument() {
              var l = position(),
                  s = match(/^@([-\w]+)?document *([^{]+)/);
              if (!s) return;
              var c = trim(s[1]),
                  m = trim(s[2]);
              if (!open()) return error("@document missing '{'");
              var v = comments().concat(rules());
              return close() ? l({
                type: "document",
                document: m,
                vendor: c,
                rules: v
              }) : error("@document missing '}'");
            }() || function atpage() {
              var l = position();
              if (!match(/^@page */)) return;
              var s = selector() || [];
              if (!open()) return error("@page missing '{'");
              var c,
                  m = comments();

              for (; c = declaration();) {
                m.push(c), m = m.concat(comments());
              }

              return close() ? l({
                type: "page",
                selectors: s,
                declarations: m
              }) : error("@page missing '}'");
            }() || function athost() {
              var l = position();
              if (!match(/^@host\s*/)) return;
              if (!open()) return error("@host missing '{'");
              var s = comments().concat(rules());
              return close() ? l({
                type: "host",
                rules: s
              }) : error("@host missing '}'");
            }() || function atfontface() {
              var l = position();
              if (!match(/^@font-face\s*/)) return;
              if (!open()) return error("@font-face missing '{'");
              var s,
                  c = comments();

              for (; s = declaration();) {
                c.push(s), c = c.concat(comments());
              }

              return close() ? l({
                type: "font-face",
                declarations: c
              }) : error("@font-face missing '}'");
            }();
          }

          function rule() {
            var l = position(),
                s = selector();
            return s ? (comments(), l({
              type: "rule",
              selectors: s,
              declarations: declarations()
            })) : error("selector missing");
          }

          return addParent(function stylesheet() {
            var l = rules();
            return {
              type: "stylesheet",
              stylesheet: {
                source: s.source,
                rules: l,
                parsingErrors: _
              }
            };
          }());
        };
        var c = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

        function trim(l) {
          return l ? l.replace(/^\s+|\s+$/g, "") : "";
        }

        function addParent(l, s) {
          var c = l && "string" == typeof l.type,
              m = c ? l : s;

          for (var _s76 in l) {
            var _c71 = l[_s76];
            Array.isArray(_c71) ? _c71.forEach(function (l) {
              addParent(l, m);
            }) : _c71 && "object" == typeof _c71 && addParent(_c71, m);
          }

          return c && Object.defineProperty(l, "parent", {
            configurable: !0,
            writable: !0,
            enumerable: !1,
            value: s || null
          }), l;
        }
      },
      6721: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var c = Compiler;

        function Compiler(l) {
          this.options = l || {};
        }

        s.default = c, Compiler.prototype.emit = function (l) {
          return l;
        }, Compiler.prototype.visit = function (l) {
          return this[l.type](l);
        }, Compiler.prototype.mapVisit = function (l, s) {
          var c = "";
          s = s || "";

          for (var m = 0, v = l.length; m < v; m++) {
            c += this.visit(l[m]), s && m < v - 1 && (c += this.emit(s));
          }

          return c;
        };
      },
      3236: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = m(c(5153)),
            _ = m(c(6721)),
            k = Compiler;

        function Compiler(l) {
          _.default.call(this, l);
        }

        s.default = k, (0, v.default)(Compiler, _.default), Compiler.prototype.compile = function (l) {
          return l.stylesheet.rules.map(this.visit, this).join("");
        }, Compiler.prototype.comment = function (l) {
          return this.emit("", l.position);
        }, Compiler.prototype.import = function (l) {
          return this.emit("@import " + l.import + ";", l.position);
        }, Compiler.prototype.media = function (l) {
          return this.emit("@media " + l.media, l.position) + this.emit("{") + this.mapVisit(l.rules) + this.emit("}");
        }, Compiler.prototype.document = function (l) {
          var s = "@" + (l.vendor || "") + "document " + l.document;
          return this.emit(s, l.position) + this.emit("{") + this.mapVisit(l.rules) + this.emit("}");
        }, Compiler.prototype.charset = function (l) {
          return this.emit("@charset " + l.charset + ";", l.position);
        }, Compiler.prototype.namespace = function (l) {
          return this.emit("@namespace " + l.namespace + ";", l.position);
        }, Compiler.prototype.supports = function (l) {
          return this.emit("@supports " + l.supports, l.position) + this.emit("{") + this.mapVisit(l.rules) + this.emit("}");
        }, Compiler.prototype.keyframes = function (l) {
          return this.emit("@" + (l.vendor || "") + "keyframes " + l.name, l.position) + this.emit("{") + this.mapVisit(l.keyframes) + this.emit("}");
        }, Compiler.prototype.keyframe = function (l) {
          var s = l.declarations;
          return this.emit(l.values.join(","), l.position) + this.emit("{") + this.mapVisit(s) + this.emit("}");
        }, Compiler.prototype.page = function (l) {
          var s = l.selectors.length ? l.selectors.join(", ") : "";
          return this.emit("@page " + s, l.position) + this.emit("{") + this.mapVisit(l.declarations) + this.emit("}");
        }, Compiler.prototype["font-face"] = function (l) {
          return this.emit("@font-face", l.position) + this.emit("{") + this.mapVisit(l.declarations) + this.emit("}");
        }, Compiler.prototype.host = function (l) {
          return this.emit("@host", l.position) + this.emit("{") + this.mapVisit(l.rules) + this.emit("}");
        }, Compiler.prototype["custom-media"] = function (l) {
          return this.emit("@custom-media " + l.name + " " + l.media + ";", l.position);
        }, Compiler.prototype.rule = function (l) {
          var s = l.declarations;
          return s.length ? this.emit(l.selectors.join(","), l.position) + this.emit("{") + this.mapVisit(s) + this.emit("}") : "";
        }, Compiler.prototype.declaration = function (l) {
          return this.emit(l.property + ":" + l.value, l.position) + this.emit(";");
        };
      },
      997: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = m(c(5153)),
            _ = m(c(6721)),
            k = Compiler;

        function Compiler(l) {
          l = l || {}, _.default.call(this, l), this.indentation = l.indent;
        }

        s.default = k, (0, v.default)(Compiler, _.default), Compiler.prototype.compile = function (l) {
          return this.stylesheet(l);
        }, Compiler.prototype.stylesheet = function (l) {
          return this.mapVisit(l.stylesheet.rules, "\n\n");
        }, Compiler.prototype.comment = function (l) {
          return this.emit(this.indent() + "/*" + l.comment + "*/", l.position);
        }, Compiler.prototype.import = function (l) {
          return this.emit("@import " + l.import + ";", l.position);
        }, Compiler.prototype.media = function (l) {
          return this.emit("@media " + l.media, l.position) + this.emit(" {\n" + this.indent(1)) + this.mapVisit(l.rules, "\n\n") + this.emit(this.indent(-1) + "\n}");
        }, Compiler.prototype.document = function (l) {
          var s = "@" + (l.vendor || "") + "document " + l.document;
          return this.emit(s, l.position) + this.emit("  {\n" + this.indent(1)) + this.mapVisit(l.rules, "\n\n") + this.emit(this.indent(-1) + "\n}");
        }, Compiler.prototype.charset = function (l) {
          return this.emit("@charset " + l.charset + ";", l.position);
        }, Compiler.prototype.namespace = function (l) {
          return this.emit("@namespace " + l.namespace + ";", l.position);
        }, Compiler.prototype.supports = function (l) {
          return this.emit("@supports " + l.supports, l.position) + this.emit(" {\n" + this.indent(1)) + this.mapVisit(l.rules, "\n\n") + this.emit(this.indent(-1) + "\n}");
        }, Compiler.prototype.keyframes = function (l) {
          return this.emit("@" + (l.vendor || "") + "keyframes " + l.name, l.position) + this.emit(" {\n" + this.indent(1)) + this.mapVisit(l.keyframes, "\n") + this.emit(this.indent(-1) + "}");
        }, Compiler.prototype.keyframe = function (l) {
          var s = l.declarations;
          return this.emit(this.indent()) + this.emit(l.values.join(", "), l.position) + this.emit(" {\n" + this.indent(1)) + this.mapVisit(s, "\n") + this.emit(this.indent(-1) + "\n" + this.indent() + "}\n");
        }, Compiler.prototype.page = function (l) {
          var s = l.selectors.length ? l.selectors.join(", ") + " " : "";
          return this.emit("@page " + s, l.position) + this.emit("{\n") + this.emit(this.indent(1)) + this.mapVisit(l.declarations, "\n") + this.emit(this.indent(-1)) + this.emit("\n}");
        }, Compiler.prototype["font-face"] = function (l) {
          return this.emit("@font-face ", l.position) + this.emit("{\n") + this.emit(this.indent(1)) + this.mapVisit(l.declarations, "\n") + this.emit(this.indent(-1)) + this.emit("\n}");
        }, Compiler.prototype.host = function (l) {
          return this.emit("@host", l.position) + this.emit(" {\n" + this.indent(1)) + this.mapVisit(l.rules, "\n\n") + this.emit(this.indent(-1) + "\n}");
        }, Compiler.prototype["custom-media"] = function (l) {
          return this.emit("@custom-media " + l.name + " " + l.media + ";", l.position);
        }, Compiler.prototype.rule = function (l) {
          var s = this.indent(),
              c = l.declarations;
          return c.length ? this.emit(l.selectors.map(function (l) {
            return s + l;
          }).join(",\n"), l.position) + this.emit(" {\n") + this.emit(this.indent(1)) + this.mapVisit(c, "\n") + this.emit(this.indent(-1)) + this.emit("\n" + this.indent() + "}") : "";
        }, Compiler.prototype.declaration = function (l) {
          return this.emit(this.indent()) + this.emit(l.property + ": " + l.value, l.position) + this.emit(";");
        }, Compiler.prototype.indent = function (l) {
          return this.level = this.level || 1, null !== l ? (this.level += l, "") : Array(this.level).join(this.indentation || "  ");
        };
      },
      8500: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = function _default(l, s) {
          var c = (s = s || {}).compress ? new v.default(s) : new _.default(s);
          return c.compile(l);
        };

        var v = m(c(3236)),
            _ = m(c(997));
      },
      216: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = c(4793),
            _ = c(3200),
            k = m(c(5508)),
            y = m(c(8310)),
            E = m(c(2515));

        var _default = function _default(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
          return (0, v.map)(l, function (l) {
            var c = l.css,
                m = l.baseURL;
            var v = [];
            return s && v.push((0, E.default)(s)), m && v.push((0, y.default)(m)), v.length ? (0, k.default)(c, (0, _.compose)(v)) : c;
          });
        };

        s.default = _default;
      },
      8310: function _(l, s) {
        "use strict";

        function isValidURL(l) {
          return 0 !== l.value.indexOf("data:") && 0 !== l.value.indexOf("#") && !function isAbsolutePath(l) {
            return /^\/(?!\/)/.test(l);
          }(l.value) && !function isRemotePath(l) {
            return /^(?:https?:)?\/\//.test(l);
          }(l.value);
        }

        function getResourcePath(l, s) {
          return new URL(l, s).toString();
        }

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var _default = function _default(l) {
          return function (s) {
            if ("declaration" === s.type) {
              var v = function getURLs(l) {
                var s = /url\((\s*)(['"]?)(.+?)\2(\s*)\)/g;
                var c;
                var m = [];

                for (; null !== (c = s.exec(l));) {
                  var _l172 = {
                    source: c[0],
                    before: c[1],
                    quote: c[2],
                    value: c[3],
                    after: c[4]
                  };
                  isValidURL(_l172) && m.push(_l172);
                }

                return m;
              }(s.value).map(function processURL(l) {
                return function (s) {
                  return _objectSpread(_objectSpread({}, s), {}, {
                    newUrl: "url(" + s.before + s.quote + getResourcePath(s.value, l) + s.quote + s.after + ")"
                  });
                };
              }(l));

              return _objectSpread(_objectSpread({}, s), {}, {
                value: (c = s.value, m = v, m.forEach(function (l) {
                  c = c.replace(l.source, l.newUrl);
                }), c)
              });
            }

            var c, m;
            return s;
          };
        };

        s.default = _default;
      },
      2515: function _(l, s) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;
        var c = /^(body|html|:root).*$/;

        var _default = function _default(l) {
          var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
          return function (m) {
            var updateSelector = function updateSelector(m) {
              return s.includes(m.trim()) ? m : m.match(c) ? m.replace(/^(body|html|:root)/, l) : l + " " + m;
            };

            return "rule" === m.type ? _objectSpread(_objectSpread({}, m), {}, {
              selectors: m.selectors.map(updateSelector)
            }) : m;
          };
        };

        s.default = _default;
      },
      5508: function _(l, s, c) {
        "use strict";

        var m = c(8424);
        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = void 0;

        var v = m(c(9004)),
            _ = c(3902);

        var k = function traverseCSS(l, s) {
          try {
            var _c72 = (0, _.parse)(l),
                _m52 = v.default.map(_c72, function (l) {
              if (!l) return l;
              var c = s(l);
              return this.update(c);
            });

            return (0, _.stringify)(_m52);
          } catch (l) {
            return console.warn("Error while traversing the CSS: " + l), null;
          }
        };

        s.default = k;
      },
      9124: function _(l, s, c) {
        "use strict";

        var m,
            v = this && this.__extends || (m = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (l, s) {
          l.__proto__ = s;
        } || function (l, s) {
          for (var c in s) {
            s.hasOwnProperty(c) && (l[c] = s[c]);
          }
        }, function (l, s) {
          function __() {
            this.constructor = l;
          }

          m(l, s), l.prototype = null === s ? Object.create(s) : (__.prototype = s.prototype, new __());
        }),
            _ = this && this.__assign || Object.assign || function (l) {
          for (var s, c = 1, m = arguments.length; c < m; c++) {
            for (var v in s = arguments[c]) {
              Object.prototype.hasOwnProperty.call(s, v) && (l[v] = s[v]);
            }
          }

          return l;
        },
            k = this && this.__rest || function (l, s) {
          var c = {};

          for (var m in l) {
            Object.prototype.hasOwnProperty.call(l, m) && s.indexOf(m) < 0 && (c[m] = l[m]);
          }

          if (null != l && "function" == typeof Object.getOwnPropertySymbols) {
            var v = 0;

            for (m = Object.getOwnPropertySymbols(l); v < m.length; v++) {
              s.indexOf(m[v]) < 0 && (c[m[v]] = l[m[v]]);
            }
          }

          return c;
        };

        s.__esModule = !0;

        var y = c(9497),
            E = c(3074),
            w = c(5581),
            C = c(7792),
            S = "autosize:resized",
            B = function (l) {
          function TextareaAutosizeClass() {
            var s = null !== l && l.apply(this, arguments) || this;
            return s.state = {
              lineHeight: null
            }, s.textarea = null, s.onResize = function (l) {
              s.props.onResize && s.props.onResize(l);
            }, s.updateLineHeight = function () {
              s.textarea && s.setState({
                lineHeight: C(s.textarea)
              });
            }, s.onChange = function (l) {
              var c = s.props.onChange;
              s.currentValue = l.currentTarget.value, c && c(l);
            }, s;
          }

          return v(TextareaAutosizeClass, l), TextareaAutosizeClass.prototype.componentDidMount = function () {
            var l = this,
                s = this.props,
                c = s.maxRows,
                m = s.async;
            "number" == typeof c && this.updateLineHeight(), "number" == typeof c || m ? setTimeout(function () {
              return l.textarea && w(l.textarea);
            }) : this.textarea && w(this.textarea), this.textarea && this.textarea.addEventListener(S, this.onResize);
          }, TextareaAutosizeClass.prototype.componentWillUnmount = function () {
            this.textarea && (this.textarea.removeEventListener(S, this.onResize), w.destroy(this.textarea));
          }, TextareaAutosizeClass.prototype.render = function () {
            var l = this,
                s = this.props,
                c = (s.onResize, s.maxRows),
                m = (s.onChange, s.style),
                v = (s.innerRef, s.children),
                E = k(s, ["onResize", "maxRows", "onChange", "style", "innerRef", "children"]),
                w = this.state.lineHeight,
                C = c && w ? w * c : null;
            return y.createElement("textarea", _({}, E, {
              onChange: this.onChange,
              style: C ? _({}, m, {
                maxHeight: C
              }) : m,
              ref: function ref(s) {
                l.textarea = s, "function" == typeof l.props.innerRef ? l.props.innerRef(s) : l.props.innerRef && (l.props.innerRef.current = s);
              }
            }), v);
          }, TextareaAutosizeClass.prototype.componentDidUpdate = function () {
            this.textarea && w.update(this.textarea);
          }, TextareaAutosizeClass.defaultProps = {
            rows: 1,
            async: !1
          }, TextareaAutosizeClass.propTypes = {
            rows: E.number,
            maxRows: E.number,
            onResize: E.func,
            innerRef: E.any,
            async: E.bool
          }, TextareaAutosizeClass;
        }(y.Component);

        s.TextareaAutosize = y.forwardRef(function (l, s) {
          return y.createElement(B, _({}, l, {
            innerRef: s
          }));
        });
      },
      6770: function _(l, s, c) {
        "use strict";

        s.__esModule = !0;
        var m = c(9124);
        s.default = m.TextareaAutosize;
      },
      2614: function _(l, s, c) {
        "use strict";

        c.r(s), c.d(s, {
          Icon: function Icon() {
            return v;
          },
          addCard: function addCard() {
            return y;
          },
          addSubmenu: function addSubmenu() {
            return w;
          },
          alignCenter: function alignCenter() {
            return S;
          },
          alignJustify: function alignJustify() {
            return P;
          },
          alignJustifyAlt: function alignJustifyAlt() {
            return L;
          },
          alignLeft: function alignLeft() {
            return R;
          },
          alignNone: function alignNone() {
            return z;
          },
          alignRight: function alignRight() {
            return F;
          },
          archive: function archive() {
            return U;
          },
          archiveTitle: function archiveTitle() {
            return K;
          },
          arrowDown: function arrowDown() {
            return q;
          },
          arrowLeft: function arrowLeft() {
            return Z;
          },
          arrowRight: function arrowRight() {
            return Q;
          },
          arrowUp: function arrowUp() {
            return ee;
          },
          aspectRatio: function aspectRatio() {
            return re;
          },
          atSymbol: function atSymbol() {
            return ne;
          },
          audio: function audio() {
            return ie;
          },
          backup: function backup() {
            return se;
          },
          blockDefault: function blockDefault() {
            return ue;
          },
          blockTable: function blockTable() {
            return pe;
          },
          box: function box() {
            return fe;
          },
          brush: function brush() {
            return ge;
          },
          bug: function bug() {
            return be;
          },
          button: function button() {
            return ke;
          },
          buttons: function buttons() {
            return Ee;
          },
          calendar: function calendar() {
            return Ce;
          },
          cancelCircleFilled: function cancelCircleFilled() {
            return Be;
          },
          capturePhoto: function capturePhoto() {
            return xe;
          },
          captureVideo: function captureVideo() {
            return Me;
          },
          category: function category() {
            return Oe;
          },
          chartBar: function chartBar() {
            return Ve;
          },
          check: function check() {
            return Ae;
          },
          chevronDown: function chevronDown() {
            return Ne;
          },
          chevronLeft: function chevronLeft() {
            return He;
          },
          chevronRight: function chevronRight() {
            return Fe;
          },
          chevronRightSmall: function chevronRightSmall() {
            return Ue;
          },
          chevronUp: function chevronUp() {
            return Ke;
          },
          classic: function classic() {
            return qe;
          },
          close: function close() {
            return Ze;
          },
          closeSmall: function closeSmall() {
            return Qe;
          },
          cloud: function cloud() {
            return nt;
          },
          cloudUpload: function cloudUpload() {
            return et;
          },
          code: function code() {
            return rt;
          },
          cog: function cog() {
            return it;
          },
          cogAlt: function cogAlt() {
            return st;
          },
          color: function color() {
            return ut;
          },
          column: function column() {
            return pt;
          },
          columns: function columns() {
            return ft;
          },
          comment: function comment() {
            return gt;
          },
          commentAuthorAvatar: function commentAuthorAvatar() {
            return bt;
          },
          commentAuthorName: function commentAuthorName() {
            return kt;
          },
          commentContent: function commentContent() {
            return Et;
          },
          commentReplyLink: function commentReplyLink() {
            return Ct;
          },
          cover: function cover() {
            return Bt;
          },
          create: function create() {
            return xt;
          },
          crop: function crop() {
            return Mt;
          },
          currencyDollar: function currencyDollar() {
            return Ot;
          },
          currencyEuro: function currencyEuro() {
            return Vt;
          },
          currencyPound: function currencyPound() {
            return At;
          },
          customLink: function customLink() {
            return Mr;
          },
          customPostType: function customPostType() {
            return Nt;
          },
          desktop: function desktop() {
            return Ht;
          },
          download: function download() {
            return Ut;
          },
          dragHandle: function dragHandle() {
            return Ft;
          },
          edit: function edit() {
            return $t;
          },
          external: function external() {
            return Yt;
          },
          file: function file() {
            return Xt;
          },
          flipHorizontal: function flipHorizontal() {
            return Jt;
          },
          flipVertical: function flipVertical() {
            return tn;
          },
          footer: function footer() {
            return ei;
          },
          formatBold: function formatBold() {
            return on;
          },
          formatCapitalize: function formatCapitalize() {
            return ln;
          },
          formatIndent: function formatIndent() {
            return sn;
          },
          formatIndentRTL: function formatIndentRTL() {
            return un;
          },
          formatItalic: function formatItalic() {
            return pn;
          },
          formatListBullets: function formatListBullets() {
            return fn;
          },
          formatListBulletsRTL: function formatListBulletsRTL() {
            return gn;
          },
          formatListNumbered: function formatListNumbered() {
            return bn;
          },
          formatListNumberedRTL: function formatListNumberedRTL() {
            return kn;
          },
          formatLowercase: function formatLowercase() {
            return Cn;
          },
          formatLtr: function formatLtr() {
            return En;
          },
          formatOutdent: function formatOutdent() {
            return Bn;
          },
          formatOutdentRTL: function formatOutdentRTL() {
            return xn;
          },
          formatRtl: function formatRtl() {
            return Mn;
          },
          formatStrikethrough: function formatStrikethrough() {
            return On;
          },
          formatUnderline: function formatUnderline() {
            return Vn;
          },
          formatUppercase: function formatUppercase() {
            return An;
          },
          fullscreen: function fullscreen() {
            return Nn;
          },
          gallery: function gallery() {
            return Hn;
          },
          globe: function globe() {
            return Fn;
          },
          grid: function grid() {
            return Un;
          },
          group: function group() {
            return Kn;
          },
          handle: function handle() {
            return qn;
          },
          header: function header() {
            return ti;
          },
          heading: function heading() {
            return Zn;
          },
          help: function help() {
            return Qn;
          },
          helpFilled: function helpFilled() {
            return eo;
          },
          home: function home() {
            return ao;
          },
          html: function html() {
            return co;
          },
          image: function image() {
            return po;
          },
          inbox: function inbox() {
            return oo;
          },
          info: function info() {
            return fo;
          },
          insertAfter: function insertAfter() {
            return go;
          },
          insertBefore: function insertBefore() {
            return bo;
          },
          institution: function institution() {
            return lo;
          },
          justifyCenter: function justifyCenter() {
            return Eo;
          },
          justifyLeft: function justifyLeft() {
            return ko;
          },
          justifyRight: function justifyRight() {
            return Co;
          },
          justifySpaceBetween: function justifySpaceBetween() {
            return Bo;
          },
          key: function key() {
            return xo;
          },
          keyboardClose: function keyboardClose() {
            return Mo;
          },
          keyboardReturn: function keyboardReturn() {
            return Oo;
          },
          layout: function layout() {
            return Vo;
          },
          lifesaver: function lifesaver() {
            return Ao;
          },
          lineDashed: function lineDashed() {
            return No;
          },
          lineDotted: function lineDotted() {
            return Ho;
          },
          lineSolid: function lineSolid() {
            return Fo;
          },
          link: function link() {
            return Uo;
          },
          linkOff: function linkOff() {
            return Ko;
          },
          list: function list() {
            return qo;
          },
          listView: function listView() {
            return Zo;
          },
          lock: function lock() {
            return Qo;
          },
          login: function login() {
            return er;
          },
          loop: function loop() {
            return nr;
          },
          mapMarker: function mapMarker() {
            return rr;
          },
          media: function media() {
            return ir;
          },
          mediaAndText: function mediaAndText() {
            return sr;
          },
          megaphone: function megaphone() {
            return ur;
          },
          menu: function menu() {
            return pr;
          },
          mobile: function mobile() {
            return fr;
          },
          more: function more() {
            return gr;
          },
          moreHorizontal: function moreHorizontal() {
            return br;
          },
          moreHorizontalMobile: function moreHorizontalMobile() {
            return kr;
          },
          moreVertical: function moreVertical() {
            return Er;
          },
          moveTo: function moveTo() {
            return Cr;
          },
          navigation: function navigation() {
            return Br;
          },
          next: function next() {
            return ol;
          },
          overlayText: function overlayText() {
            return xr;
          },
          page: function page() {
            return Tr;
          },
          pageBreak: function pageBreak() {
            return Ir;
          },
          pages: function pages() {
            return Or;
          },
          paragraph: function paragraph() {
            return Lr;
          },
          payment: function payment() {
            return Vr;
          },
          pencil: function pencil() {
            return Kt;
          },
          people: function people() {
            return Dr;
          },
          percent: function percent() {
            return Rr;
          },
          pin: function pin() {
            return Hr;
          },
          plugins: function plugins() {
            return jr;
          },
          plus: function plus() {
            return Ur;
          },
          plusCircle: function plusCircle() {
            return Gr;
          },
          plusCircleFilled: function plusCircleFilled() {
            return Fr;
          },
          positionCenter: function positionCenter() {
            return Ar;
          },
          positionLeft: function positionLeft() {
            return zr;
          },
          positionRight: function positionRight() {
            return Nr;
          },
          postAuthor: function postAuthor() {
            return Wr;
          },
          postCategories: function postCategories() {
            return Kr;
          },
          postComments: function postComments() {
            return qr;
          },
          postCommentsCount: function postCommentsCount() {
            return Yr;
          },
          postCommentsForm: function postCommentsForm() {
            return Zr;
          },
          postContent: function postContent() {
            return $r;
          },
          postDate: function postDate() {
            return Xr;
          },
          postExcerpt: function postExcerpt() {
            return Qr;
          },
          postFeaturedImage: function postFeaturedImage() {
            return Jr;
          },
          postList: function postList() {
            return el;
          },
          postTitle: function postTitle() {
            return tl;
          },
          preformatted: function preformatted() {
            return rl;
          },
          previous: function previous() {
            return nl;
          },
          pullLeft: function pullLeft() {
            return ll;
          },
          pullRight: function pullRight() {
            return il;
          },
          pullquote: function pullquote() {
            return al;
          },
          queryPagination: function queryPagination() {
            return sl;
          },
          queryPaginationNext: function queryPaginationNext() {
            return cl;
          },
          queryPaginationNumbers: function queryPaginationNumbers() {
            return ul;
          },
          queryPaginationPrevious: function queryPaginationPrevious() {
            return dl;
          },
          quote: function quote() {
            return pl;
          },
          receipt: function receipt() {
            return ml;
          },
          redo: function redo() {
            return fl;
          },
          removeBug: function removeBug() {
            return hl;
          },
          replace: function replace() {
            return gl;
          },
          reset: function reset() {
            return vl;
          },
          resizeCornerNE: function resizeCornerNE() {
            return bl;
          },
          reusableBlock: function reusableBlock() {
            return _l;
          },
          rotateLeft: function rotateLeft() {
            return yl;
          },
          rotateRight: function rotateRight() {
            return El;
          },
          rss: function rss() {
            return wl;
          },
          search: function search() {
            return Cl;
          },
          separator: function separator() {
            return Sl;
          },
          settings: function settings() {
            return Bl;
          },
          share: function share() {
            return Pl;
          },
          shield: function shield() {
            return xl;
          },
          shipping: function shipping() {
            return Dl;
          },
          shortcode: function shortcode() {
            return Il;
          },
          sidebar: function sidebar() {
            return ni;
          },
          siteLogo: function siteLogo() {
            return Ml;
          },
          sparkles: function sparkles() {
            return Tl;
          },
          stack: function stack() {
            return Ol;
          },
          starEmpty: function starEmpty() {
            return Ll;
          },
          starFilled: function starFilled() {
            return Vl;
          },
          starHalf: function starHalf() {
            return Rl;
          },
          store: function store() {
            return Al;
          },
          stretchFullWidth: function stretchFullWidth() {
            return zl;
          },
          stretchWide: function stretchWide() {
            return Hl;
          },
          styles: function styles() {
            return Nl;
          },
          subscript: function subscript() {
            return jl;
          },
          superscript: function superscript() {
            return Fl;
          },
          swatch: function swatch() {
            return Gl;
          },
          symbol: function symbol() {
            return kl;
          },
          symbolFilled: function symbolFilled() {
            return Ql;
          },
          table: function table() {
            return Zl;
          },
          tableColumnAfter: function tableColumnAfter() {
            return Ul;
          },
          tableColumnBefore: function tableColumnBefore() {
            return Wl;
          },
          tableColumnDelete: function tableColumnDelete() {
            return Kl;
          },
          tableRowAfter: function tableRowAfter() {
            return $l;
          },
          tableRowBefore: function tableRowBefore() {
            return ql;
          },
          tableRowDelete: function tableRowDelete() {
            return Yl;
          },
          tablet: function tablet() {
            return ri;
          },
          tag: function tag() {
            return Xl;
          },
          termDescription: function termDescription() {
            return Jl;
          },
          textColor: function textColor() {
            return oi;
          },
          title: function title() {
            return li;
          },
          tool: function tool() {
            return ii;
          },
          trash: function trash() {
            return ai;
          },
          trashFilled: function trashFilled() {
            return si;
          },
          trendingDown: function trendingDown() {
            return ci;
          },
          trendingUp: function trendingUp() {
            return ui;
          },
          typography: function typography() {
            return di;
          },
          undo: function undo() {
            return pi;
          },
          ungroup: function ungroup() {
            return mi;
          },
          update: function update() {
            return fi;
          },
          upload: function upload() {
            return hi;
          },
          verse: function verse() {
            return gi;
          },
          video: function video() {
            return vi;
          },
          warning: function warning() {
            return bi;
          },
          widget: function widget() {
            return _i;
          },
          wordpress: function wordpress() {
            return ki;
          }
        });
        var m = c(1753);

        var v = function Icon(l) {
          var s = l.icon,
              _l$size = l.size,
              c = _l$size === void 0 ? 24 : _l$size,
              v = _objectWithoutProperties(l, _excluded46);

          return (0, m.cloneElement)(s, _objectSpread({
            width: c,
            height: c
          }, v));
        },
            _ = require("@wordpress/primitives"),
            k = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.5 5.5V8H20V5.5h2.5V4H20V1.5h-1.5V4H16v1.5h2.5zM12 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-6h-1.5v6a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5h6V4z"
        })),
            y = k,
            E = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M2 12c0 3.6 2.4 5.5 6 5.5h.5V19l3-2.5-3-2.5v2H8c-2.5 0-4.5-1.5-4.5-4s2-4.5 4.5-4.5h3.5V6H8c-3.6 0-6 2.4-6 6zm19.5-1h-8v1.5h8V11zm0 5h-8v1.5h8V16zm0-10h-8v1.5h8V6z"
        })),
            w = E,
            C = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16.4 4.2H7.6v1.5h8.9V4.2zM4 11.2v1.5h16v-1.5H4zm3.6 8.6h8.9v-1.5H7.6v1.5z"
        })),
            S = C,
            B = (0, m.createElement)(_.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 12.8h16v-1.5H4v1.5zm0 7h12.4v-1.5H4v1.5zM4 4.3v1.5h16V4.3H4z"
        })),
            P = B,
            O = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          clipRule: "evenodd",
          fillRule: "evenodd",
          d: "M4 5h16v2H4V5zm0 4v2h16V9H4zm0 4h16v2H4v-2zm16 6H4v-2h16v2z"
        })),
            L = O,
            V = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 19.8h8.9v-1.5H4v1.5zm8.9-15.6H4v1.5h8.9V4.2zm-8.9 7v1.5h16v-1.5H4z"
        })),
            R = V,
            A = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 15h14V9H5v6zm0 4.8h14v-1.5H5v1.5zM5 4.2v1.5h14V4.2H5z"
        })),
            z = A,
            D = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11.1 19.8H20v-1.5h-8.9v1.5zm0-15.6v1.5H20V4.2h-8.9zM4 12.8h16v-1.5H4v1.5z"
        })),
            F = D,
            G = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 6.2h-5.9l-.6-1.1c-.3-.7-1-1.1-1.8-1.1H5c-1.1 0-2 .9-2 2v11.8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8.2c0-1.1-.9-2-2-2zm.5 11.6c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h5.8c.2 0 .4.1.4.3l1 2H19c.3 0 .5.2.5.5v9.5zM8 12.8h8v-1.5H8v1.5zm0 3h8v-1.5H8v1.5z"
        })),
            U = G,
            W = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          stroke: "#1E1E1E",
          strokeWidth: "1.5",
          d: "M4 19.25h9M4 15.25h16"
        }), (0, m.createElement)(_.Path, {
          d: "M8.994 10.103H6.08L5.417 12H4l2.846-8h1.383l2.845 8H9.657l-.663-1.897zm-.457-1.28l-.994-2.857-1.006 2.857h2z",
          fill: "#1E1E1E"
        })),
            K = W,
            $ = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16.2 13.2l-4 4V4h-1.5v13.3l-4.5-4.1-1 1.1 6.2 5.8 5.8-5.8-1-1.1z"
        })),
            q = $,
            Y = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20 10.8H6.7l4.1-4.5-1.1-1.1-5.8 6.3 5.8 5.8 1.1-1.1-4-3.9H20z"
        })),
            Z = Y,
            X = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14.3 6.7l-1.1 1.1 4 4H4v1.5h13.3l-4.1 4.4 1.1 1.1 5.8-6.3z"
        })),
            Q = X,
            J = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12.5 3.9L6.7 9.7l1.1 1.1 4-4V20h1.4V6.7l4.5 4.1 1.1-1.1z"
        })),
            ee = J,
            te = (0, m.createElement)(_.SVG, {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M12.5939 21C14.1472 21 16.1269 20.5701 17.0711 20.1975L16.6447 18.879C16.0964 19.051 14.3299 19.6242 12.6548 19.6242C7.4467 19.6242 4.67513 16.8726 4.67513 12C4.67513 7.21338 7.50762 4.34713 12.2893 4.34713C17.132 4.34713 19.4162 7.55732 19.4162 10.7675C19.4162 14.035 19.0508 15.4968 17.4975 15.4968C16.5838 15.4968 16.0964 14.7803 16.0964 13.9777V7.5H14.4822V8.30255H14.3909C14.1777 7.67198 12.9898 7.12739 11.467 7.2707C9.18274 7.5 7.4467 9.27707 7.4467 11.8567C7.4467 14.5796 8.81726 16.672 11.467 16.758C13.203 16.8153 14.1168 16.0127 14.4822 15.1815H14.5736C14.7563 16.414 16.401 16.8439 17.467 16.8439C20.6954 16.8439 21 13.5764 21 10.7962C21 6.86943 18.0761 3 12.3807 3C6.50254 3 3 6.3535 3 11.9427C3 17.7325 6.38071 21 12.5939 21ZM11.7107 15.2962C9.73096 15.2962 9.03046 13.6051 9.03046 11.7707C9.03046 10.1083 10.0355 8.67516 11.7716 8.67516C13.599 8.67516 14.5736 9.36306 14.5736 11.7707C14.5736 14.1497 13.7513 15.2962 11.7107 15.2962Z"
        })),
            ne = te,
            oe = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.5 5.5h-13c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2zm.5 11c0 .3-.2.5-.5.5h-13c-.3 0-.5-.2-.5-.5v-9c0-.3.2-.5.5-.5h13c.3 0 .5.2.5.5v9zM6.5 12H8v-2h2V8.5H6.5V12zm9.5 2h-2v1.5h3.5V12H16v2z"
        })),
            re = oe,
            le = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M17.7 4.3c-1.2 0-2.8 0-3.8 1-.6.6-.9 1.5-.9 2.6V14c-.6-.6-1.5-1-2.5-1C8.6 13 7 14.6 7 16.5S8.6 20 10.5 20c1.5 0 2.8-1 3.3-2.3.5-.8.7-1.8.7-2.5V7.9c0-.7.2-1.2.5-1.6.6-.6 1.8-.6 2.8-.6h.3V4.3h-.4z"
        })),
            ie = le,
            ae = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5.5 12h1.75l-2.5 3-2.5-3H4a8 8 0 113.134 6.35l.907-1.194A6.5 6.5 0 105.5 12zm9.53 1.97l-2.28-2.28V8.5a.75.75 0 00-1.5 0V12a.747.747 0 00.218.529l1.282-.84-1.28.842 2.5 2.5a.75.75 0 101.06-1.061z"
        })),
            se = ae,
            ce = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M19 8h-1V6h-5v2h-2V6H6v2H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm.5 10c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5v-8c0-.3.2-.5.5-.5h14c.3 0 .5.2.5.5v8z"
        })),
            ue = ce,
            de = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.5h14c.3 0 .5.2.5.5v3.5h-15V5c0-.3.2-.5.5-.5zm8 5.5h6.5v3.5H13V10zm-1.5 3.5h-7V10h7v3.5zm-7 5.5v-4h7v4.5H5c-.3 0-.5-.2-.5-.5zm14.5.5h-6V15h6.5v4c0 .3-.2.5-.5.5z"
        })),
            pe = de,
            me = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M5 5.5h14a.5.5 0 01.5.5v1.5a.5.5 0 01-.5.5H5a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5zM4 9.232A2 2 0 013 7.5V6a2 2 0 012-2h14a2 2 0 012 2v1.5a2 2 0 01-1 1.732V18a2 2 0 01-2 2H6a2 2 0 01-2-2V9.232zm1.5.268V18a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V9.5h-13z",
          clipRule: "evenodd"
        })),
            fe = me,
            he = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 20h8v-1.5H4V20zM18.9 3.5c-.6-.6-1.5-.6-2.1 0l-7.2 7.2c-.4-.1-.7 0-1.1.1-.5.2-1.5.7-1.9 2.2-.4 1.7-.8 2.2-1.1 2.7-.1.1-.2.3-.3.4l-.6 1.1H6c2 0 3.4-.4 4.7-1.4.8-.6 1.2-1.4 1.3-2.3 0-.3 0-.5-.1-.7L19 5.7c.5-.6.5-1.6-.1-2.2zM9.7 14.7c-.7.5-1.5.8-2.4 1 .2-.5.5-1.2.8-2.3.2-.6.4-1 .8-1.1.5-.1 1 .1 1.3.3.2.2.3.5.2.8 0 .3-.1.9-.7 1.3z"
        })),
            ge = he,
            ve = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.13 5.5l1.926 1.927A4.975 4.975 0 007.025 10H5v1.5h2V13H5v1.5h2.1a5.002 5.002 0 009.8 0H19V13h-2v-1.5h2V10h-2.025a4.979 4.979 0 00-1.167-2.74l1.76-1.76-1.061-1.06-1.834 1.834A4.977 4.977 0 0012 5.5c-1.062 0-2.046.33-2.855.895L7.19 4.44 6.13 5.5zm2.37 5v3a3.5 3.5 0 107 0v-3a3.5 3.5 0 10-7 0z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            be = ve,
            _e = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 6.5H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2zm.5 9c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h14c.3 0 .5.2.5.5v7zM8 12.8h8v-1.5H8v1.5z"
        })),
            ke = _e,
            ye = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M17 3H7c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm.5 6c0 .3-.2.5-.5.5H7c-.3 0-.5-.2-.5-.5V5c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v4zm-8-1.2h5V6.2h-5v1.6zM17 13H7c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm.5 6c0 .3-.2.5-.5.5H7c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v4zm-8-1.2h5v-1.5h-5v1.5z"
        })),
            Ee = ye,
            we = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm.5 16c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V7h15v12zM9 10H7v2h2v-2zm0 4H7v2h2v-2zm4-4h-2v2h2v-2zm4 0h-2v2h2v-2zm-4 4h-2v2h2v-2zm4 0h-2v2h2v-2z"
        })),
            Ce = we,
            Se = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM15.5303 8.46967C15.8232 8.76256 15.8232 9.23744 15.5303 9.53033L13.0607 12L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7626 15.8232 14.4697 15.5303L12 13.0607L9.53033 15.5303C9.23744 15.8232 8.76256 15.8232 8.46967 15.5303C8.17678 15.2374 8.17678 14.7626 8.46967 14.4697L10.9393 12L8.46967 9.53033C8.17678 9.23744 8.17678 8.76256 8.46967 8.46967C8.76256 8.17678 9.23744 8.17678 9.53033 8.46967L12 10.9393L14.4697 8.46967C14.7626 8.17678 15.2374 8.17678 15.5303 8.46967Z"
        })),
            Be = Se,
            Pe = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M12 9.2c-2.2 0-3.9 1.8-3.9 4s1.8 4 3.9 4 4-1.8 4-4-1.8-4-4-4zm0 6.5c-1.4 0-2.4-1.1-2.4-2.5s1.1-2.5 2.4-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zM20.2 8c-.1 0-.3 0-.5-.1l-2.5-.8c-.4-.1-.8-.4-1.1-.8l-1-1.5c-.4-.5-1-.9-1.7-.9h-2.9c-.6.1-1.2.4-1.6 1l-1 1.5c-.3.3-.6.6-1.1.7l-2.5.8c-.2.1-.4.1-.6.1-1 .2-1.7.9-1.7 1.9v8.3c0 1 .9 1.9 2 1.9h16c1.1 0 2-.8 2-1.9V9.9c0-1-.7-1.7-1.8-1.9zm.3 10.1c0 .2-.2.4-.5.4H4c-.3 0-.5-.2-.5-.4V9.9c0-.1.2-.3.5-.4.2 0 .5-.1.8-.2l2.5-.8c.7-.2 1.4-.6 1.8-1.3l1-1.5c.1-.1.2-.2.4-.2h2.9c.2 0 .3.1.4.2l1 1.5c.4.7 1.1 1.1 1.9 1.4l2.5.8c.3.1.6.1.8.2.3 0 .4.2.4.4v8.1z"
        })),
            xe = Pe,
            Ie = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M14 5H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm.5 12c0 .3-.2.5-.5.5H4c-.3 0-.5-.2-.5-.5V7c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v10zm2.5-7v4l5 3V7l-5 3zm3.5 4.4l-2-1.2v-2.3l2-1.2v4.7z"
        })),
            Me = Ie,
            Te = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M6 5.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5zM4 6a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm11-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5zM13 6a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2h-3a2 2 0 01-2-2V6zm5 8.5h-3a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM15 13a2 2 0 00-2 2v3a2 2 0 002 2h3a2 2 0 002-2v-3a2 2 0 00-2-2h-3zm-9 1.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zM4 15a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2H6a2 2 0 01-2-2v-3z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            Oe = Te,
            Le = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M11.25 5h1.5v15h-1.5V5zM6 10h1.5v10H6V10zm12 4h-1.5v6H18v-6z",
          clipRule: "evenodd"
        })),
            Ve = Le,
            Re = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16.7 7.1l-6.3 8.5-3.3-2.5-.9 1.2 4.5 3.4L17.9 8z"
        })),
            Ae = Re,
            ze = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M17.5 11.6L12 16l-5.5-4.4.9-1.2L12 14l4.5-3.6 1 1.2z"
        })),
            Ne = ze,
            De = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14.6 7l-1.2-1L8 12l5.4 6 1.2-1-4.6-5z"
        })),
            He = De,
            je = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10.6 6L9.4 7l4.6 5-4.6 5 1.2 1 5.4-6z"
        })),
            Fe = je,
            Ge = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10.8622 8.04053L14.2805 12.0286L10.8622 16.0167L9.72327 15.0405L12.3049 12.0286L9.72327 9.01672L10.8622 8.04053Z"
        })),
            Ue = Ge,
            We = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M6.5 12.4L12 8l5.5 4.4-.9 1.2L12 10l-4.5 3.6-1-1.2z"
        })),
            Ke = We,
            $e = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M20 6H4c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm.5 11c0 .3-.2.5-.5.5H4c-.3 0-.5-.2-.5-.5V8c0-.3.2-.5.5-.5h16c.3 0 .5.2.5.5v9zM10 10H8v2h2v-2zm-5 2h2v-2H5v2zm8-2h-2v2h2v-2zm-5 6h8v-2H8v2zm6-4h2v-2h-2v2zm3 0h2v-2h-2v2zm0 4h2v-2h-2v2zM5 16h2v-2H5v2z"
        })),
            qe = $e,
            Ye = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M13 11.8l6.1-6.3-1-1-6.1 6.2-6.1-6.2-1 1 6.1 6.3-6.5 6.7 1 1 6.5-6.6 6.5 6.6 1-1z"
        })),
            Ze = Ye,
            Xe = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 13.06l3.712 3.713 1.061-1.06L13.061 12l3.712-3.712-1.06-1.06L12 10.938 8.288 7.227l-1.061 1.06L10.939 12l-3.712 3.712 1.06 1.061L12 13.061z"
        })),
            Qe = Xe,
            Je = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M17.3 10.1c0-2.5-2.1-4.4-4.8-4.4-2.2 0-4.1 1.4-4.6 3.3h-.2C5.7 9 4 10.7 4 12.8c0 2.1 1.7 3.8 3.7 3.8h9c1.8 0 3.2-1.5 3.2-3.3.1-1.6-1.1-2.9-2.6-3.2zm-.5 5.1h-4v-2.4L14 14l1-1-3-3-3 3 1 1 1.2-1.2v2.4H7.7c-1.2 0-2.2-1.1-2.2-2.3s1-2.4 2.2-2.4H9l.3-1.1c.4-1.3 1.7-2.2 3.2-2.2 1.8 0 3.3 1.3 3.3 2.9v1.3l1.3.2c.8.1 1.4.9 1.4 1.8 0 1-.8 1.8-1.7 1.8z"
        })),
            et = Je,
            tt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M17.3 10.1c0-2.5-2.1-4.4-4.8-4.4-2.2 0-4.1 1.4-4.6 3.3h-.2C5.7 9 4 10.7 4 12.8c0 2.1 1.7 3.8 3.7 3.8h9c1.8 0 3.2-1.5 3.2-3.3.1-1.6-1.1-2.9-2.6-3.2zm-.5 5.1h-9c-1.2 0-2.2-1.1-2.2-2.3s1-2.4 2.2-2.4h1.3l.3-1.1c.4-1.3 1.7-2.2 3.2-2.2 1.8 0 3.3 1.3 3.3 2.9v1.3l1.3.2c.8.1 1.4.9 1.4 1.8-.1 1-.9 1.8-1.8 1.8z"
        })),
            nt = tt,
            ot = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M20.8 10.7l-4.3-4.3-1.1 1.1 4.3 4.3c.1.1.1.3 0 .4l-4.3 4.3 1.1 1.1 4.3-4.3c.7-.8.7-1.9 0-2.6zM4.2 11.8l4.3-4.3-1-1-4.3 4.3c-.7.7-.7 1.8 0 2.5l4.3 4.3 1.1-1.1-4.3-4.3c-.2-.1-.2-.3-.1-.4z"
        })),
            rt = ot,
            lt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M10.289 4.836A1 1 0 0111.275 4h1.306a1 1 0 01.987.836l.244 1.466c.787.26 1.503.679 2.108 1.218l1.393-.522a1 1 0 011.216.437l.653 1.13a1 1 0 01-.23 1.273l-1.148.944a6.025 6.025 0 010 2.435l1.149.946a1 1 0 01.23 1.272l-.653 1.13a1 1 0 01-1.216.437l-1.394-.522c-.605.54-1.32.958-2.108 1.218l-.244 1.466a1 1 0 01-.987.836h-1.306a1 1 0 01-.986-.836l-.244-1.466a5.995 5.995 0 01-2.108-1.218l-1.394.522a1 1 0 01-1.217-.436l-.653-1.131a1 1 0 01.23-1.272l1.149-.946a6.026 6.026 0 010-2.435l-1.148-.944a1 1 0 01-.23-1.272l.653-1.131a1 1 0 011.217-.437l1.393.522a5.994 5.994 0 012.108-1.218l.244-1.466zM14.929 12a3 3 0 11-6 0 3 3 0 016 0z",
          clipRule: "evenodd"
        })),
            it = lt,
            at = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          clipRule: "evenodd",
          fillRule: "evenodd",
          d: "M19.867 12c0-.568-.059-1.122-.17-1.656L21.5 8.732l-1.967-3.464-2.283.786a7.813 7.813 0 00-2.813-1.657L13.967 2h-3.934l-.472 2.396a7.813 7.813 0 00-2.81 1.657l-2.284-.785L2.5 8.732l1.804 1.612a8.054 8.054 0 000 3.312L2.5 15.268l1.967 3.464 2.283-.786a7.813 7.813 0 002.813 1.657l.47 2.397h3.934l.472-2.396a7.83 7.83 0 002.81-1.657l2.284.786 1.967-3.464-1.804-1.613c.111-.535.171-1.09.171-1.657V12zM12 16c-2.173 0-3.934-1.79-3.934-4S9.826 8 12 8c2.173 0 3.934 1.79 3.934 4s-1.76 4-3.934 4z"
        })),
            st = at,
            ct = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M17.2 10.9c-.5-1-1.2-2.1-2.1-3.2-.6-.9-1.3-1.7-2.1-2.6L12 4l-1 1.1c-.6.9-1.3 1.7-2 2.6-.8 1.2-1.5 2.3-2 3.2-.6 1.2-1 2.2-1 3 0 3.4 2.7 6.1 6.1 6.1s6.1-2.7 6.1-6.1c0-.8-.3-1.8-1-3zm-5.1 7.6c-2.5 0-4.6-2.1-4.6-4.6 0-.3.1-1 .8-2.3.5-.9 1.1-1.9 2-3.1.7-.9 1.3-1.7 1.8-2.3.7.8 1.3 1.6 1.8 2.3.8 1.1 1.5 2.2 2 3.1.7 1.3.8 2 .8 2.3 0 2.5-2.1 4.6-4.6 4.6z"
        })),
            ut = ct,
            dt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M19 6H6c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM6 17.5c-.3 0-.5-.2-.5-.5V8c0-.3.2-.5.5-.5h3v10H6zm13.5-.5c0 .3-.2.5-.5.5h-3v-10h3c.3 0 .5.2.5.5v9z"
        })),
            pt = dt,
            mt = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 6H6c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-4.1 1.5v10H10v-10h4.9zM5.5 17V8c0-.3.2-.5.5-.5h2.5v10H6c-.3 0-.5-.2-.5-.5zm14 0c0 .3-.2.5-.5.5h-2.6v-10H19c.3 0 .5.2.5.5v9z"
        })),
            ft = mt,
            ht = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12.9c0 .6.5 1.1 1.1 1.1.3 0 .5-.1.8-.3L8.5 17H18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 11c0 .3-.2.5-.5.5H7.9l-2.4 2.4V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v9z"
        })),
            gt = ht,
            vt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7.25 16.4371C6.16445 15.2755 5.5 13.7153 5.5 12C5.5 8.41015 8.41015 5.5 12 5.5C15.5899 5.5 18.5 8.41015 18.5 12C18.5 13.7153 17.8356 15.2755 16.75 16.4371V16C16.75 14.4812 15.5188 13.25 14 13.25L10 13.25C8.48122 13.25 7.25 14.4812 7.25 16V16.4371ZM8.75 17.6304C9.70606 18.1835 10.8161 18.5 12 18.5C13.1839 18.5 14.2939 18.1835 15.25 17.6304V16C15.25 15.3096 14.6904 14.75 14 14.75L10 14.75C9.30964 14.75 8.75 15.3096 8.75 16V17.6304ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z",
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "black"
        })),
            bt = vt,
            _t = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "#FFFFFF"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12.9c0 .6.5 1.1 1.1 1.1.3 0 .5-.1.8-.3L8.5 17H18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 11c0 .3-.2.5-.5.5H7.9l-2.4 2.4V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v9z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }), (0, m.createElement)(_.Path, {
          d: "M15 15V15C15 13.8954 14.1046 13 13 13L11 13C9.89543 13 9 13.8954 9 15V15",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }), (0, m.createElement)(_.Circle, {
          cx: "12",
          cy: "9",
          r: "2",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            kt = _t,
            yt = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.68822 16.625L5.5 17.8145L5.5 5.5L18.5 5.5L18.5 16.625L6.68822 16.625ZM7.31 18.125L19 18.125C19.5523 18.125 20 17.6773 20 17.125L20 5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V19.5247C4 19.8173 4.16123 20.086 4.41935 20.2237C4.72711 20.3878 5.10601 20.3313 5.35252 20.0845L7.31 18.125ZM16 9.99997H8V8.49997H16V9.99997ZM8 14H13V12.5H8V14Z"
        })),
            Et = yt,
            wt = (0, m.createElement)(_.SVG, {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M6.68822 10.625L6.24878 11.0649L5.5 11.8145L5.5 5.5L12.5 5.5V8L14 6.5V5C14 4.44772 13.5523 4 13 4H5C4.44772 4 4 4.44771 4 5V13.5247C4 13.8173 4.16123 14.086 4.41935 14.2237C4.72711 14.3878 5.10601 14.3313 5.35252 14.0845L7.31 12.125H8.375L9.875 10.625H7.31H6.68822ZM14.5605 10.4983L11.6701 13.75H16.9975C17.9963 13.75 18.7796 14.1104 19.3553 14.7048C19.9095 15.2771 20.2299 16.0224 20.4224 16.7443C20.7645 18.0276 20.7543 19.4618 20.7487 20.2544C20.7481 20.345 20.7475 20.4272 20.7475 20.4999L19.2475 20.5001C19.2475 20.4191 19.248 20.3319 19.2484 20.2394V20.2394C19.2526 19.4274 19.259 18.2035 18.973 17.1307C18.8156 16.5401 18.586 16.0666 18.2778 15.7483C17.9909 15.4521 17.5991 15.25 16.9975 15.25H11.8106L14.5303 17.9697L13.4696 19.0303L8.96956 14.5303L13.4394 9.50171L14.5605 10.4983Z"
        })),
            Ct = wt,
            St = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.7 3H5.3C4 3 3 4 3 5.3v13.4C3 20 4 21 5.3 21h13.4c1.3 0 2.3-1 2.3-2.3V5.3C21 4 20 3 18.7 3zm.8 15.7c0 .4-.4.8-.8.8H5.3c-.4 0-.8-.4-.8-.8V5.3c0-.4.4-.8.8-.8h6.2v8.9l2.5-3.1 2.5 3.1V4.5h2.2c.4 0 .8.4.8.8v13.4z"
        })),
            Bt = St,
            Pt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16 11.2h-3.2V8h-1.6v3.2H8v1.6h3.2V16h1.6v-3.2H16z"
        })),
            xt = Pt,
            It = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16.5 7.8v7H18v-7c0-1-.8-1.8-1.8-1.8h-7v1.5h7c.2 0 .3.1.3.3zm-8.7 8.7c-.1 0-.2-.1-.2-.2V2H6v4H2v1.5h4v8.8c0 1 .8 1.8 1.8 1.8h8.8v4H18v-4h4v-1.5H7.8z"
        })),
            Mt = It,
            Tt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M3.25 12a8.75 8.75 0 1117.5 0 8.75 8.75 0 01-17.5 0zM12 4.75a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5zm-1.338 4.877c-.314.22-.412.452-.412.623 0 .171.098.403.412.623.312.218.783.377 1.338.377.825 0 1.605.233 2.198.648.59.414 1.052 1.057 1.052 1.852 0 .795-.461 1.438-1.052 1.852-.41.286-.907.486-1.448.582v.316a.75.75 0 01-1.5 0v-.316a3.64 3.64 0 01-1.448-.582c-.59-.414-1.052-1.057-1.052-1.852a.75.75 0 011.5 0c0 .171.098.403.412.623.312.218.783.377 1.338.377s1.026-.159 1.338-.377c.314-.22.412-.452.412-.623 0-.171-.098-.403-.412-.623-.312-.218-.783-.377-1.338-.377-.825 0-1.605-.233-2.198-.648-.59-.414-1.052-1.057-1.052-1.852 0-.795.461-1.438 1.052-1.852a3.64 3.64 0 011.448-.582V7.5a.75.75 0 011.5 0v.316c.54.096 1.039.296 1.448.582.59.414 1.052 1.057 1.052 1.852a.75.75 0 01-1.5 0c0-.171-.098-.403-.412-.623-.312-.218-.783-.377-1.338-.377s-1.026.159-1.338.377z"
        })),
            Ot = Tt,
            Lt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 3.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM4.75 12a7.25 7.25 0 1114.5 0 7.25 7.25 0 01-14.5 0zm9.195 1.944a2.75 2.75 0 01-4.066-.194h.621a.75.75 0 000-1.5H9.262a2.767 2.767 0 010-.5H11.5a.75.75 0 000-1.5H9.88a2.75 2.75 0 014.066-.194.75.75 0 001.06-1.061 4.25 4.25 0 00-6.88 1.255H7.5a.75.75 0 000 1.5h.258c-.01.166-.01.334 0 .5H7.5a.75.75 0 000 1.5h.626a4.25 4.25 0 006.88 1.255.75.75 0 00-1.06-1.06z"
        })),
            Vt = Lt,
            Rt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M3.25 12a8.75 8.75 0 1117.5 0 8.75 8.75 0 01-17.5 0zM12 4.75a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5zm.25 4c-.787 0-1.425.638-1.425 1.425 0 .058.014.147.069.3.04.113.088.223.147.36a26.094 26.094 0 01.173.415H12.5a.75.75 0 010 1.5h-.953c.002.047.003.095.003.144 0 .617-.236 1.168-.511 1.606h3.386a.75.75 0 010 1.5H9.35a.75.75 0 01-.452-1.349l.007-.005a4.417 4.417 0 00.596-.581c.328-.39.549-.806.549-1.171 0-.05-.002-.097-.004-.144H9.5a.75.75 0 010-1.5h.088a5.875 5.875 0 01-.106-.27 2.382 2.382 0 01-.157-.805 2.925 2.925 0 015.637-1.097.75.75 0 01-1.39.563 1.426 1.426 0 00-1.322-.891zm-3.35 5.9l.45.6-.45-.6z"
        })),
            At = Rt,
            zt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 20h9v-1.5H4V20zm0-5.5V16h16v-1.5H4zm.8-4l.7.7 2-2V12h1V9.2l2 2 .7-.7-2-2H12v-1H9.2l2-2-.7-.7-2 2V4h-1v2.8l-2-2-.7.7 2 2H4v1h2.8l-2 2z"
        })),
            Nt = zt,
            Dt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20.5 16h-.7V8c0-1.1-.9-2-2-2H6.2c-1.1 0-2 .9-2 2v8h-.7c-.8 0-1.5.7-1.5 1.5h20c0-.8-.7-1.5-1.5-1.5zM5.7 8c0-.3.2-.5.5-.5h11.6c.3 0 .5.2.5.5v7.6H5.7V8z"
        })),
            Ht = Dt,
            jt = (0, m.createElement)(_.SVG, {
          width: "18",
          height: "18",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 18 18"
        }, (0, m.createElement)(_.Path, {
          d: "M5 4h2V2H5v2zm6-2v2h2V2h-2zm-6 8h2V8H5v2zm6 0h2V8h-2v2zm-6 6h2v-2H5v2zm6 0h2v-2h-2v2z"
        })),
            Ft = jt,
            Gt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18 11.3l-1-1.1-4 4V3h-1.5v11.3L7 10.2l-1 1.1 6.2 5.8 5.8-5.8zm.5 3.7v3.5h-13V15H4v5h16v-5h-1.5z"
        })),
            Ut = Gt,
            Wt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20.1 5.1L16.9 2 6.2 12.7l-1.3 4.4 4.5-1.3L20.1 5.1zM4 20.8h8v-1.5H4v1.5z"
        })),
            Kt = Wt,
            $t = Kt,
            qt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.2 17c0 .7-.6 1.2-1.2 1.2H7c-.7 0-1.2-.6-1.2-1.2V7c0-.7.6-1.2 1.2-1.2h3.2V4.2H7C5.5 4.2 4.2 5.5 4.2 7v10c0 1.5 1.2 2.8 2.8 2.8h10c1.5 0 2.8-1.2 2.8-2.8v-3.6h-1.5V17zM14.9 3v1.5h3.7l-6.4 6.4 1.1 1.1 6.4-6.4v3.7h1.5V3h-6.3z"
        })),
            Yt = qt,
            Zt = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 6.2h-5.9l-.6-1.1c-.3-.7-1-1.1-1.8-1.1H5c-1.1 0-2 .9-2 2v11.8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8.2c0-1.1-.9-2-2-2zm.5 11.6c0 .3-.2.5-.5.5H5c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h5.8c.2 0 .4.1.4.3l1 2H19c.3 0 .5.2.5.5v9.5z"
        })),
            Xt = Zt,
            Qt = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 6v12c0 1.1.9 2 2 2h3v-1.5H6c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h3V4H6c-1.1 0-2 .9-2 2zm7.2 16h1.5V2h-1.5v20zM15 5.5h1.5V4H15v1.5zm3.5.5H20c0-1.1-.9-2-2-2v1.5c.3 0 .5.2.5.5zm0 10.5H20v-2h-1.5v2zm0-3.5H20v-2h-1.5v2zm-.5 5.5V20c1.1 0 2-.9 2-2h-1.5c0 .3-.2.5-.5.5zM15 20h1.5v-1.5H15V20zm3.5-10.5H20v-2h-1.5v2z"
        })),
            Jt = Qt,
            en = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M2 11.2v1.5h20v-1.5H2zM5.5 6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v3H20V6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3h1.5V6zm2 14h2v-1.5h-2V20zm3.5 0h2v-1.5h-2V20zm7-1.5V20c1.1 0 2-.9 2-2h-1.5c0 .3-.2.5-.5.5zm.5-2H20V15h-1.5v1.5zM5.5 18H4c0 1.1.9 2 2 2v-1.5c-.3 0-.5-.2-.5-.5zm0-3H4v1.5h1.5V15zm9 5h2v-1.5h-2V20z"
        })),
            tn = en,
            nn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14.7 11.3c1-.6 1.5-1.6 1.5-3 0-2.3-1.3-3.4-4-3.4H7v14h5.8c1.4 0 2.5-.3 3.3-1 .8-.7 1.2-1.7 1.2-2.9.1-1.9-.8-3.1-2.6-3.7zm-5.1-4h2.3c.6 0 1.1.1 1.4.4.3.3.5.7.5 1.2s-.2 1-.5 1.2c-.3.3-.8.4-1.4.4H9.6V7.3zm4.6 9c-.4.3-1 .4-1.7.4H9.6v-3.9h2.9c.7 0 1.3.2 1.7.5.4.3.6.8.6 1.5s-.2 1.2-.6 1.5z"
        })),
            on = nn,
            rn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7.1 6.8L3.1 18h1.6l1.1-3h4.3l1.1 3h1.6l-4-11.2H7.1zm-.8 6.8L8 8.9l1.7 4.7H6.3zm14.5-1.5c-.3-.6-.7-1.1-1.2-1.5-.6-.4-1.2-.6-1.9-.6-.5 0-.9.1-1.4.3-.4.2-.8.5-1.1.8V6h-1.4v12h1.3l.2-1c.2.4.6.6 1 .8.4.2.9.3 1.4.3.7 0 1.2-.2 1.8-.5.5-.4 1-.9 1.3-1.5.3-.6.5-1.3.5-2.1-.1-.6-.2-1.3-.5-1.9zm-1.7 4c-.4.5-.9.8-1.6.8s-1.2-.2-1.7-.7c-.4-.5-.7-1.2-.7-2.1 0-.9.2-1.6.7-2.1.4-.5 1-.7 1.7-.7s1.2.3 1.6.8c.4.5.6 1.2.6 2 .1.8-.2 1.4-.6 2z"
        })),
            ln = rn,
            an = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 7.2v1.5h16V7.2H4zm8 8.6h8v-1.5h-8v1.5zm-8-3.5l3 3-3 3 1 1 4-4-4-4-1 1z"
        })),
            sn = an,
            cn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20 5.5H4V4H20V5.5ZM12 12.5H4V11H12V12.5ZM20 20V18.5H4V20H20ZM20.0303 9.03033L17.0607 12L20.0303 14.9697L18.9697 16.0303L15.4697 12.5303L14.9393 12L15.4697 11.4697L18.9697 7.96967L20.0303 9.03033Z"
        })),
            un = cn,
            dn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12.5 5L10 19h1.9l2.5-14z"
        })),
            pn = dn,
            mn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11.1 15.8H20v-1.5h-8.9v1.5zm0-8.6v1.5H20V7.2h-8.9zM6 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        })),
            fn = mn,
            hn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 8.8h8.9V7.2H4v1.6zm0 7h8.9v-1.5H4v1.5zM18 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
        })),
            gn = hn,
            vn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11.1 15.8H20v-1.5h-8.9v1.5zm0-8.6v1.5H20V7.2h-8.9zM5 6.7V10h1V5.3L3.8 6l.4 1 .8-.3zm-.4 5.7c-.3.1-.5.2-.7.3l.1 1.1c.2-.2.5-.4.8-.5.3-.1.6 0 .7.1.2.3 0 .8-.2 1.1-.5.8-.9 1.6-1.4 2.5h2.7v-1h-1c.3-.6.8-1.4.9-2.1.1-.3 0-.8-.2-1.1-.5-.6-1.3-.5-1.7-.4z"
        })),
            bn = vn,
            _n = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M3.8 15.8h8.9v-1.5H3.8v1.5zm0-7h8.9V7.2H3.8v1.6zm14.7-2.1V10h1V5.3l-2.2.7.3 1 .9-.3zm1.2 6.1c-.5-.6-1.2-.5-1.7-.4-.3.1-.5.2-.7.3l.1 1.1c.2-.2.5-.4.8-.5.3-.1.6 0 .7.1.2.3 0 .8-.2 1.1-.5.8-.9 1.6-1.4 2.5H20v-1h-.9c.3-.6.8-1.4.9-2.1 0-.3 0-.8-.3-1.1z"
        })),
            kn = _n,
            yn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5.52 2h7.43c.55 0 1 .45 1 1s-.45 1-1 1h-1v13c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55-.45 1-1 1s-1-.45-1-1v-5.96h-.43C3.02 11.04 1 9.02 1 6.52S3.02 2 5.52 2zM14 14l5-4-5-4v8z"
        })),
            En = yn,
            wn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11 16.8c-.1-.1-.2-.3-.3-.5v-2.6c0-.9-.1-1.7-.3-2.2-.2-.5-.5-.9-.9-1.2-.4-.2-.9-.3-1.6-.3-.5 0-1 .1-1.5.2s-.9.3-1.2.6l.2 1.2c.4-.3.7-.4 1.1-.5.3-.1.7-.2 1-.2.6 0 1 .1 1.3.4.3.2.4.7.4 1.4-1.2 0-2.3.2-3.3.7s-1.4 1.1-1.4 2.1c0 .7.2 1.2.7 1.6.4.4 1 .6 1.8.6.9 0 1.7-.4 2.4-1.2.1.3.2.5.4.7.1.2.3.3.6.4.3.1.6.1 1.1.1h.1l.2-1.2h-.1c-.4.1-.6 0-.7-.1zM9.2 16c-.2.3-.5.6-.9.8-.3.1-.7.2-1.1.2-.4 0-.7-.1-.9-.3-.2-.2-.3-.5-.3-.9 0-.6.2-1 .7-1.3.5-.3 1.3-.4 2.5-.5v2zm10.6-3.9c-.3-.6-.7-1.1-1.2-1.5-.6-.4-1.2-.6-1.9-.6-.5 0-.9.1-1.4.3-.4.2-.8.5-1.1.8V6h-1.4v12h1.3l.2-1c.2.4.6.6 1 .8.4.2.9.3 1.4.3.7 0 1.2-.2 1.8-.5.5-.4 1-.9 1.3-1.5.3-.6.5-1.3.5-2.1-.1-.6-.2-1.3-.5-1.9zm-1.7 4c-.4.5-.9.8-1.6.8s-1.2-.2-1.7-.7c-.4-.5-.7-1.2-.7-2.1 0-.9.2-1.6.7-2.1.4-.5 1-.7 1.7-.7s1.2.3 1.6.8c.4.5.6 1.2.6 2s-.2 1.4-.6 2z"
        })),
            Cn = wn,
            Sn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 7.2v1.5h16V7.2H4zm8 8.6h8v-1.5h-8v1.5zm-4-4.6l-4 4 4 4 1-1-3-3 3-3-1-1z"
        })),
            Bn = Sn,
            Pn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20 5.5H4V4H20V5.5ZM12 12.5H4V11H12V12.5ZM20 20V18.5H4V20H20ZM15.4697 14.9697L18.4393 12L15.4697 9.03033L16.5303 7.96967L20.0303 11.4697L20.5607 12L20.0303 12.5303L16.5303 16.0303L15.4697 14.9697Z"
        })),
            xn = Pn,
            In = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5.52 2h7.43c.55 0 1 .45 1 1s-.45 1-1 1h-1v13c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55-.45 1-1 1s-1-.45-1-1v-5.96h-.43C3.02 11.04 1 9.02 1 6.52S3.02 2 5.52 2zM19 6l-5 4 5 4V6zM5.52 2h7.43c.55 0 1 .45 1 1s-.45 1-1 1h-1v13c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55-.45 1-1 1s-1-.45-1-1v-5.96h-.43C3.02 11.04 1 9.02 1 6.52S3.02 2 5.52 2zM19 6l-5 4 5 4V6z"
        })),
            Mn = In,
            Tn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M9.1 9v-.5c0-.6.2-1.1.7-1.4.5-.3 1.2-.5 2-.5.7 0 1.4.1 2.1.3.7.2 1.4.5 2.1.9l.2-1.9c-.6-.3-1.2-.5-1.9-.7-.8-.1-1.6-.2-2.4-.2-1.5 0-2.7.3-3.6 1-.8.7-1.2 1.5-1.2 2.6V9h2zM20 12H4v1h8.3c.3.1.6.2.8.3.5.2.9.5 1.1.8.3.3.4.7.4 1.2 0 .7-.2 1.1-.8 1.5-.5.3-1.2.5-2.1.5-.8 0-1.6-.1-2.4-.3-.8-.2-1.5-.5-2.2-.8L7 18.1c.5.2 1.2.4 2 .6.8.2 1.6.3 2.4.3 1.7 0 3-.3 3.9-1 .9-.7 1.3-1.6 1.3-2.8 0-.9-.2-1.7-.7-2.2H20v-1z"
        })),
            On = Tn,
            Ln = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7 18v1h10v-1H7zm5-2c1.5 0 2.6-.4 3.4-1.2.8-.8 1.1-2 1.1-3.5V5H15v5.8c0 1.2-.2 2.1-.6 2.8-.4.7-1.2 1-2.4 1s-2-.3-2.4-1c-.4-.7-.6-1.6-.6-2.8V5H7.5v6.2c0 1.5.4 2.7 1.1 3.5.8.9 1.9 1.3 3.4 1.3z"
        })),
            Vn = Ln,
            Rn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.1 6.8L2.1 18h1.6l1.1-3h4.3l1.1 3h1.6l-4-11.2H6.1zm-.8 6.8L7 8.9l1.7 4.7H5.3zm15.1-.7c-.4-.5-.9-.8-1.6-1 .4-.2.7-.5.8-.9.2-.4.3-.9.3-1.4 0-.9-.3-1.6-.8-2-.6-.5-1.3-.7-2.4-.7h-3.5V18h4.2c1.1 0 2-.3 2.6-.8.6-.6 1-1.4 1-2.4-.1-.8-.3-1.4-.6-1.9zm-5.7-4.7h1.8c.6 0 1.1.1 1.4.4.3.2.5.7.5 1.3 0 .6-.2 1.1-.5 1.3-.3.2-.8.4-1.4.4h-1.8V8.2zm4 8c-.4.3-.9.5-1.5.5h-2.6v-3.8h2.6c1.4 0 2 .6 2 1.9.1.6-.1 1-.5 1.4z"
        })),
            An = Rn,
            zn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4.2 9h1.5V5.8H9V4.2H4.2V9zm14 9.2H15v1.5h4.8V15h-1.5v3.2zM15 4.2v1.5h3.2V9h1.5V4.2H15zM5.8 15H4.2v4.8H9v-1.5H5.8V15z"
        })),
            Nn = zn,
            Dn = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M20.2 8v11c0 .7-.6 1.2-1.2 1.2H6v1.5h13c1.5 0 2.7-1.2 2.7-2.8V8h-1.5zM18 16.4V4.6c0-.9-.7-1.6-1.6-1.6H4.6C3.7 3 3 3.7 3 4.6v11.8c0 .9.7 1.6 1.6 1.6h11.8c.9 0 1.6-.7 1.6-1.6zM4.5 4.6c0-.1.1-.1.1-.1h11.8c.1 0 .1.1.1.1V12l-2.3-1.7c-.3-.2-.6-.2-.9 0l-2.9 2.1L8 11.3c-.2-.1-.5-.1-.7 0l-2.9 1.5V4.6zm0 11.8v-1.8l3.2-1.7 2.4 1.2c.2.1.5.1.8-.1l2.8-2 2.8 2v2.5c0 .1-.1.1-.1.1H4.6c0-.1-.1-.2-.1-.2z"
        })),
            Hn = Dn,
            jn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 3.3c-4.8 0-8.8 3.9-8.8 8.8 0 4.8 3.9 8.8 8.8 8.8 4.8 0 8.8-3.9 8.8-8.8s-4-8.8-8.8-8.8zm6.5 5.5h-2.6C15.4 7.3 14.8 6 14 5c2 .6 3.6 2 4.5 3.8zm.7 3.2c0 .6-.1 1.2-.2 1.8h-2.9c.1-.6.1-1.2.1-1.8s-.1-1.2-.1-1.8H19c.2.6.2 1.2.2 1.8zM12 18.7c-1-.7-1.8-1.9-2.3-3.5h4.6c-.5 1.6-1.3 2.9-2.3 3.5zm-2.6-4.9c-.1-.6-.1-1.1-.1-1.8 0-.6.1-1.2.1-1.8h5.2c.1.6.1 1.1.1 1.8s-.1 1.2-.1 1.8H9.4zM4.8 12c0-.6.1-1.2.2-1.8h2.9c-.1.6-.1 1.2-.1 1.8 0 .6.1 1.2.1 1.8H5c-.2-.6-.2-1.2-.2-1.8zM12 5.3c1 .7 1.8 1.9 2.3 3.5H9.7c.5-1.6 1.3-2.9 2.3-3.5zM10 5c-.8 1-1.4 2.3-1.8 3.8H5.5C6.4 7 8 5.6 10 5zM5.5 15.3h2.6c.4 1.5 1 2.8 1.8 3.7-1.8-.6-3.5-2-4.4-3.7zM14 19c.8-1 1.4-2.2 1.8-3.7h2.6C17.6 17 16 18.4 14 19z"
        })),
            Fn = jn,
            Gn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7.8 16.5H5c-.3 0-.5-.2-.5-.5v-6.2h6.8v6.7zm0-8.3H4.5V5c0-.3.2-.5.5-.5h6.2v6.7zm8.3 7.8c0 .3-.2.5-.5.5h-6.2v-6.8h6.8V19zm0-7.8h-6.8V4.5H19c.3 0 .5.2.5.5v6.2z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            Un = Gn,
            Wn = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4h-7c-1.1 0-2 .9-2 2v3H6c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2v-3h3c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-4.5 14c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h3V13c0 1.1.9 2 2 2h2.5v3zm0-4.5H11c-.3 0-.5-.2-.5-.5v-2.5H13c.3 0 .5.2.5.5v2.5zm5-.5c0 .3-.2.5-.5.5h-3V11c0-1.1-.9-2-2-2h-2.5V6c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7z"
        })),
            Kn = Wn,
            $n = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M7 16.5h10V15H7v1.5zm0-9V9h10V7.5H7z"
        })),
            qn = $n,
            Yn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.2 5.2v13.4l5.8-4.8 5.8 4.8V5.2z"
        })),
            Zn = Yn,
            Xn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 4.75a7.25 7.25 0 100 14.5 7.25 7.25 0 000-14.5zM3.25 12a8.75 8.75 0 1117.5 0 8.75 8.75 0 01-17.5 0zM12 8.75a1.5 1.5 0 01.167 2.99c-.465.052-.917.44-.917 1.01V14h1.5v-.845A3 3 0 109 10.25h1.5a1.5 1.5 0 011.5-1.5zM11.25 15v1.5h1.5V15h-1.5z"
        })),
            Qn = Xn,
            Jn = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "24",
          height: "24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-1 16v-2h2v2h-2zm2-3v-1.141A3.991 3.991 0 0016 10a4 4 0 00-8 0h2c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2a1 1 0 00-1 1v2h2z"
        })),
            eo = Jn,
            no = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M6 5.5h12a.5.5 0 01.5.5v7H14a2 2 0 11-4 0H5.5V6a.5.5 0 01.5-.5zm-.5 9V18a.5.5 0 00.5.5h12a.5.5 0 00.5-.5v-3.5h-3.337a3.5 3.5 0 01-6.326 0H5.5zM4 13V6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2v-5z",
          clipRule: "evenodd"
        })),
            oo = no,
            ro = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M18.646 9H20V8l-1-.5L12 4 5 7.5 4 8v1h14.646zm-3-1.5L12 5.677 8.354 7.5h7.292zm-7.897 9.44v-6.5h-1.5v6.5h1.5zm5-6.5v6.5h-1.5v-6.5h1.5zm5 0v6.5h-1.5v-6.5h1.5zm2.252 8.81c0 .414-.334.75-.748.75H4.752a.75.75 0 010-1.5h14.5a.75.75 0 01.749.75z",
          clipRule: "evenodd"
        })),
            lo = ro,
            io = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 4L4 7.9V20h16V7.9L12 4zm6.5 14.5H14V13h-4v5.5H5.5V8.8L12 5.7l6.5 3.1v9.7z"
        })),
            ao = io,
            so = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M4.8 11.4H2.1V9H1v6h1.1v-2.6h2.7V15h1.1V9H4.8v2.4zm1.9-1.3h1.7V15h1.1v-4.9h1.7V9H6.7v1.1zM16.2 9l-1.5 2.7L13.3 9h-.9l-.8 6h1.1l.5-4 1.5 2.8 1.5-2.8.5 4h1.1L17 9h-.8zm3.8 5V9h-1.1v6h3.6v-1H20z"
        })),
            co = so,
            uo = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.5h14c.3 0 .5.2.5.5v8.4l-3-2.9c-.3-.3-.8-.3-1 0L11.9 14 9 12c-.3-.2-.6-.2-.8 0l-3.6 2.6V5c-.1-.3.1-.5.4-.5zm14 15H5c-.3 0-.5-.2-.5-.5v-2.4l4.1-3 3 1.9c.3.2.7.2.9-.1L16 12l3.5 3.4V19c0 .3-.2.5-.5.5z"
        })),
            po = uo,
            mo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 3.2c-4.8 0-8.8 3.9-8.8 8.8 0 4.8 3.9 8.8 8.8 8.8 4.8 0 8.8-3.9 8.8-8.8 0-4.8-4-8.8-8.8-8.8zm0 16c-4 0-7.2-3.3-7.2-7.2C4.8 8 8 4.8 12 4.8s7.2 3.3 7.2 7.2c0 4-3.2 7.2-7.2 7.2zM11 17h2v-6h-2v6zm0-8h2V7h-2v2z"
        })),
            fo = mo,
            ho = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M9 12h2v-2h2V8h-2V6H9v2H7v2h2v2zm1 4c3.9 0 7-3.1 7-7s-3.1-7-7-7-7 3.1-7 7 3.1 7 7 7zm0-12c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5zM3 19h14v-2H3v2z"
        })),
            go = ho,
            vo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11 8H9v2H7v2h2v2h2v-2h2v-2h-2V8zm-1-4c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zM3 1v2h14V1H3z"
        })),
            bo = vo,
            _o = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M9 9v6h11V9H9zM4 20h1.5V4H4v16z"
        })),
            ko = _o,
            yo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20 9h-7.2V4h-1.6v5H4v6h7.2v5h1.6v-5H20z"
        })),
            Eo = yo,
            wo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 15h11V9H4v6zM18.5 4v16H20V4h-1.5z"
        })),
            Co = wo,
            So = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M9 15h6V9H9v6zm-5 5h1.5V4H4v16zM18.5 4v16H20V4h-1.5z"
        })),
            Bo = So,
            Po = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M9 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM9 16a4.002 4.002 0 003.8-2.75H15V16h2.5v-2.75H19v-2.5h-6.2A4.002 4.002 0 005 12a4 4 0 004 4z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            xo = Po,
            Io = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18,0 L2,0 C0.9,0 0.01,0.9 0.01,2 L0,12 C0,13.1 0.9,14 2,14 L18,14 C19.1,14 20,13.1 20,12 L20,2 C20,0.9 19.1,0 18,0 Z M18,12 L2,12 L2,2 L18,2 L18,12 Z M9,3 L11,3 L11,5 L9,5 L9,3 Z M9,6 L11,6 L11,8 L9,8 L9,6 Z M6,3 L8,3 L8,5 L6,5 L6,3 Z M6,6 L8,6 L8,8 L6,8 L6,6 Z M3,6 L5,6 L5,8 L3,8 L3,6 Z M3,3 L5,3 L5,5 L3,5 L3,3 Z M6,9 L14,9 L14,11 L6,11 L6,9 Z M12,6 L14,6 L14,8 L12,8 L12,6 Z M12,3 L14,3 L14,5 L12,5 L12,3 Z M15,6 L17,6 L17,8 L15,8 L15,6 Z M15,3 L17,3 L17,5 L15,5 L15,3 Z M10,20 L14,16 L6,16 L10,20 Z"
        })),
            Mo = Io,
            To = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.734 16.106l2.176-2.38-1.093-1.028-3.846 4.158 3.846 4.157 1.093-1.027-2.176-2.38h2.811c1.125 0 2.25.03 3.374 0 1.428-.001 3.362-.25 4.963-1.277 1.66-1.065 2.868-2.906 2.868-5.859 0-2.479-1.327-4.896-3.65-5.93-1.82-.813-3.044-.8-4.806-.788l-.567.002v1.5c.184 0 .368 0 .553-.002 1.82-.007 2.704-.014 4.21.657 1.854.827 2.76 2.657 2.76 4.561 0 2.472-.973 3.824-2.178 4.596-1.258.807-2.864 1.04-4.163 1.04h-.02c-1.115.03-2.229 0-3.344 0H6.734z"
        })),
            Oo = To,
            Lo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18 5.5H6a.5.5 0 00-.5.5v3h13V6a.5.5 0 00-.5-.5zm.5 5H10v8h8a.5.5 0 00.5-.5v-7.5zm-10 0h-3V18a.5.5 0 00.5.5h2.5v-8zM6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
        })),
            Vo = Lo,
            Ro = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M17.375 15.656A6.47 6.47 0 0018.5 12a6.47 6.47 0 00-.943-3.374l-1.262.813c.448.749.705 1.625.705 2.561a4.977 4.977 0 01-.887 2.844l1.262.813zm-1.951 1.87l-.813-1.261A4.976 4.976 0 0112 17c-.958 0-1.852-.27-2.613-.736l-.812 1.261A6.47 6.47 0 0012 18.5a6.47 6.47 0 003.424-.974zm-8.8-1.87A6.47 6.47 0 015.5 12c0-1.235.344-2.39.943-3.373l1.261.812A4.977 4.977 0 007 12c0 1.056.328 2.036.887 2.843l-1.262.813zm2.581-7.803A4.977 4.977 0 0112 7c1.035 0 1.996.314 2.794.853l.812-1.262A6.47 6.47 0 0012 5.5a6.47 6.47 0 00-3.607 1.092l.812 1.261zM12 20a8 8 0 100-16 8 8 0 000 16zm0-4.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
          clipRule: "evenodd"
        })),
            Ao = Ro,
            zo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          fill: "none"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M5 11.25h3v1.5H5v-1.5zm5.5 0h3v1.5h-3v-1.5zm8.5 0h-3v1.5h3v-1.5z",
          clipRule: "evenodd"
        })),
            No = zo,
            Do = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          fill: "none"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M5.25 11.25h1.5v1.5h-1.5v-1.5zm3 0h1.5v1.5h-1.5v-1.5zm4.5 0h-1.5v1.5h1.5v-1.5zm1.5 0h1.5v1.5h-1.5v-1.5zm4.5 0h-1.5v1.5h1.5v-1.5z",
          clipRule: "evenodd"
        })),
            Ho = Do,
            jo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          fill: "none"
        }, (0, m.createElement)(_.Path, {
          d: "M5 11.25h14v1.5H5z"
        })),
            Fo = jo,
            Go = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M15.6 7.2H14v1.5h1.6c2 0 3.7 1.7 3.7 3.7s-1.7 3.7-3.7 3.7H14v1.5h1.6c2.8 0 5.2-2.3 5.2-5.2 0-2.9-2.3-5.2-5.2-5.2zM4.7 12.4c0-2 1.7-3.7 3.7-3.7H10V7.2H8.4c-2.9 0-5.2 2.3-5.2 5.2 0 2.9 2.3 5.2 5.2 5.2H10v-1.5H8.4c-2 0-3.7-1.7-3.7-3.7zm4.6.9h5.3v-1.5H9.3v1.5z"
        })),
            Uo = Go,
            Wo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M15.6 7.3h-.7l1.6-3.5-.9-.4-3.9 8.5H9v1.5h2l-1.3 2.8H8.4c-2 0-3.7-1.7-3.7-3.7s1.7-3.7 3.7-3.7H10V7.3H8.4c-2.9 0-5.2 2.3-5.2 5.2 0 2.9 2.3 5.2 5.2 5.2H9l-1.4 3.2.9.4 5.7-12.5h1.4c2 0 3.7 1.7 3.7 3.7s-1.7 3.7-3.7 3.7H14v1.5h1.6c2.9 0 5.2-2.3 5.2-5.2 0-2.9-2.4-5.2-5.2-5.2z"
        })),
            Ko = Wo,
            $o = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M4 4v1.5h16V4H4zm8 8.5h8V11h-8v1.5zM4 20h16v-1.5H4V20zm4-8c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z"
        })),
            qo = $o,
            Yo = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M13.8 5.2H3v1.5h10.8V5.2zm-3.6 12v1.5H21v-1.5H10.2zm7.2-6H6.6v1.5h10.8v-1.5z"
        })),
            Zo = Yo,
            Xo = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M8 5C8 3.34315 9.34315 2 11 2H13C14.6569 2 16 3.34315 16 5V9H18C19.2624 9 20 9.9804 20 11V19C20 20.0196 19.2624 21 18 21H6C4.73763 21 4 20.0196 4 19V11C4 9.9804 4.73763 9 6 9H8V5ZM9.5 9H14.5V5C14.5 4.17157 13.8284 3.5 13 3.5H11C10.1716 3.5 9.5 4.17157 9.5 5V9Z"
        })),
            Qo = Xo,
            Jo = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11 14.5l1.1 1.1 3-3 .5-.5-.6-.6-3-3-1 1 1.7 1.7H5v1.5h7.7L11 14.5zM16.8 5h-7c-1.1 0-2 .9-2 2v1.5h1.5V7c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5h-7c-.3 0-.5-.2-.5-.5v-1.5H7.8V17c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2z"
        })),
            er = Jo,
            tr = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18.1823 11.6392C18.1823 13.0804 17.0139 14.2487 15.5727 14.2487C14.3579 14.2487 13.335 13.4179 13.0453 12.2922L13.0377 12.2625L13.0278 12.2335L12.3985 10.377L12.3942 10.3785C11.8571 8.64997 10.246 7.39405 8.33961 7.39405C5.99509 7.39405 4.09448 9.29465 4.09448 11.6392C4.09448 13.9837 5.99509 15.8843 8.33961 15.8843C8.88499 15.8843 9.40822 15.781 9.88943 15.5923L9.29212 14.0697C8.99812 14.185 8.67729 14.2487 8.33961 14.2487C6.89838 14.2487 5.73003 13.0804 5.73003 11.6392C5.73003 10.1979 6.89838 9.02959 8.33961 9.02959C9.55444 9.02959 10.5773 9.86046 10.867 10.9862L10.8772 10.9836L11.4695 12.7311C11.9515 14.546 13.6048 15.8843 15.5727 15.8843C17.9172 15.8843 19.8178 13.9837 19.8178 11.6392C19.8178 9.29465 17.9172 7.39404 15.5727 7.39404C15.0287 7.39404 14.5066 7.4968 14.0264 7.6847L14.6223 9.20781C14.9158 9.093 15.2358 9.02959 15.5727 9.02959C17.0139 9.02959 18.1823 10.1979 18.1823 11.6392Z"
        })),
            nr = tr,
            or = (0, m.createElement)(_.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 9c-.8 0-1.5.7-1.5 1.5S11.2 12 12 12s1.5-.7 1.5-1.5S12.8 9 12 9zm0-5c-3.6 0-6.5 2.8-6.5 6.2 0 .8.3 1.8.9 3.1.5 1.1 1.2 2.3 2 3.6.7 1 3 3.8 3.2 3.9l.4.5.4-.5c.2-.2 2.6-2.9 3.2-3.9.8-1.2 1.5-2.5 2-3.6.6-1.3.9-2.3.9-3.1C18.5 6.8 15.6 4 12 4zm4.3 8.7c-.5 1-1.1 2.2-1.9 3.4-.5.7-1.7 2.2-2.4 3-.7-.8-1.9-2.3-2.4-3-.8-1.2-1.4-2.3-1.9-3.3-.6-1.4-.7-2.2-.7-2.5 0-2.6 2.2-4.7 5-4.7s5 2.1 5 4.7c0 .2-.1 1-.7 2.4z"
        })),
            rr = or,
            lr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.7 3H5.3C4 3 3 4 3 5.3v13.4C3 20 4 21 5.3 21h13.4c1.3 0 2.3-1 2.3-2.3V5.3C21 4 20 3 18.7 3zm.8 15.7c0 .4-.4.8-.8.8H5.3c-.4 0-.8-.4-.8-.8V5.3c0-.4.4-.8.8-.8h13.4c.4 0 .8.4.8.8v13.4zM10 15l5-3-5-3v6z"
        })),
            ir = lr,
            ar = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M3 18h8V6H3v12zM14 7.5V9h7V7.5h-7zm0 5.3h7v-1.5h-7v1.5zm0 3.7h7V15h-7v1.5z"
        })),
            sr = ar,
            cr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M6.863 13.644L5 13.25h-.5a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5H5L18 6.5h2V16h-2l-3.854-.815.026.008a3.75 3.75 0 01-7.31-1.549zm1.477.313a2.251 2.251 0 004.356.921l-4.356-.921zm-2.84-3.28L18.157 8h.343v6.5h-.343L5.5 11.823v-1.146z",
          clipRule: "evenodd"
        })),
            ur = cr,
            dr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 5v1.5h14V5H5zm0 7.8h14v-1.5H5v1.5zM5 19h14v-1.5H5V19z"
        })),
            pr = dr,
            mr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M15 4H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H9c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h6c.3 0 .5.2.5.5v12zm-4.5-.5h2V16h-2v1.5z"
        })),
            fr = mr,
            hr = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M4 9v1.5h16V9H4zm12 5.5h4V13h-4v1.5zm-6 0h4V13h-4v1.5zm-6 0h4V13H4v1.5z"
        })),
            gr = hr,
            vr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11 13h2v-2h-2v2zm-6 0h2v-2H5v2zm12-2v2h2v-2h-2z"
        })),
            br = vr,
            _r = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M7.5 12C7.5 11.1716 6.82843 10.5 6 10.5C5.17157 10.5 4.5 11.1716 4.5 12C4.5 12.8284 5.17157 13.5 6 13.5C6.82843 13.5 7.5 12.8284 7.5 12Z"
        }), (0, m.createElement)(_.Path, {
          d: "M13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12Z"
        }), (0, m.createElement)(_.Path, {
          d: "M19.5 12C19.5 11.1716 18.8284 10.5 18 10.5C17.1716 10.5 16.5 11.1716 16.5 12C16.5 12.8284 17.1716 13.5 18 13.5C18.8284 13.5 19.5 12.8284 19.5 12Z"
        })),
            kr = _r,
            yr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M13 19h-2v-2h2v2zm0-6h-2v-2h2v2zm0-6h-2V5h2v2z"
        })),
            Er = yr,
            wr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M19.75 9c0-1.257-.565-2.197-1.39-2.858-.797-.64-1.827-1.017-2.815-1.247-1.802-.42-3.703-.403-4.383-.396L11 4.5V6l.177-.001c.696-.006 2.416-.02 4.028.356.887.207 1.67.518 2.216.957.52.416.829.945.829 1.688 0 .592-.167.966-.407 1.23-.255.281-.656.508-1.236.674-1.19.34-2.82.346-4.607.346h-.077c-1.692 0-3.527 0-4.942.404-.732.209-1.424.545-1.935 1.108-.526.579-.796 1.33-.796 2.238 0 1.257.565 2.197 1.39 2.858.797.64 1.827 1.017 2.815 1.247 1.802.42 3.703.403 4.383.396L13 19.5h.714V22L18 18.5 13.714 15v3H13l-.177.001c-.696.006-2.416.02-4.028-.356-.887-.207-1.67-.518-2.216-.957-.52-.416-.829-.945-.829-1.688 0-.592.167-.966.407-1.23.255-.281.656-.508 1.237-.674 1.189-.34 2.819-.346 4.606-.346h.077c1.692 0 3.527 0 4.941-.404.732-.209 1.425-.545 1.936-1.108.526-.579.796-1.33.796-2.238z"
        })),
            Cr = wr,
            Sr = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M12 4c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14.5c-3.6 0-6.5-2.9-6.5-6.5S8.4 5.5 12 5.5s6.5 2.9 6.5 6.5-2.9 6.5-6.5 6.5zM9 16l4.5-3L15 8.4l-4.5 3L9 16z"
        })),
            Br = Sr,
            Pr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12-9.8c.4 0 .8-.3.9-.7l1.1-3h3.6l.5 1.7h1.9L13 9h-2.2l-3.4 9.5H6c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v12H20V6c0-1.1-.9-2-2-2zm-6 7l1.4 3.9h-2.7L12 11z"
        })),
            xr = Pr,
            Ir = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7.8 6c0-.7.6-1.2 1.2-1.2h6c.7 0 1.2.6 1.2 1.2v3h1.5V6c0-1.5-1.2-2.8-2.8-2.8H9C7.5 3.2 6.2 4.5 6.2 6v3h1.5V6zm8.4 11c0 .7-.6 1.2-1.2 1.2H9c-.7 0-1.2-.6-1.2-1.2v-3H6.2v3c0 1.5 1.2 2.8 2.8 2.8h6c1.5 0 2.8-1.2 2.8-2.8v-3h-1.5v3zM4 11v1h16v-1H4z"
        })),
            Mr = (0, m.createElement)(_.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12.5 14.5h-1V16h1c2.2 0 4-1.8 4-4s-1.8-4-4-4h-1v1.5h1c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5zm-4 1.5v-1.5h-1C6.1 14.5 5 13.4 5 12s1.1-2.5 2.5-2.5h1V8h-1c-2.2 0-4 1.8-4 4s1.8 4 4 4h1zm-1-3.2h5v-1.5h-5v1.5zM18 4H9c-1.1 0-2 .9-2 2v.5h1.5V6c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v12c0 .3-.2.5-.5.5H9c-.3 0-.5-.2-.5-.5v-.5H7v.5c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"
        })),
            Tr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7 5.5h10a.5.5 0 01.5.5v12a.5.5 0 01-.5.5H7a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5zM17 4H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2zm-1 3.75H8v1.5h8v-1.5zM8 11h8v1.5H8V11zm6 3.25H8v1.5h6v-1.5z"
        })),
            Or = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7 13.8h6v-1.5H7v1.5zM18 16V4c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2zM5.5 16V4c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v12c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5zM7 10.5h8V9H7v1.5zm0-3.3h8V5.8H7v1.4zM20.2 6v13c0 .7-.6 1.2-1.2 1.2H8v1.5h11c1.5 0 2.7-1.2 2.7-2.8V6h-1.5z"
        })),
            Lr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.3 4H9.9v-.1l-.9.2c-2.3.4-4 2.4-4 4.8s1.7 4.4 4 4.8l.7.1V20h1.5V5.5h2.9V20h1.5V5.5h2.7V4z"
        })),
            Vr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M5.5 9.5v-2h13v2h-13zm0 3v4h13v-4h-13zM4 7a1 1 0 011-1h14a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V7z",
          clipRule: "evenodd"
        })),
            Rr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M6.5 8a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM8 5a3 3 0 100 6 3 3 0 000-6zm6.5 11a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm1.5-3a3 3 0 100 6 3 3 0 000-6zM5.47 17.41a.75.75 0 001.06 1.06L18.47 6.53a.75.75 0 10-1.06-1.06L5.47 17.41z",
          clipRule: "evenodd"
        })),
            Ar = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7 9v6h10V9H7zM5 19.8h14v-1.5H5v1.5zM5 4.3v1.5h14V4.3H5z"
        })),
            zr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 9v6h14V9H4zm8-4.8H4v1.5h8V4.2zM4 19.8h8v-1.5H4v1.5z"
        })),
            Nr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6 15h14V9H6v6zm6-10.8v1.5h8V4.2h-8zm0 15.6h8v-1.5h-8v1.5z"
        })),
            Dr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M15.5 9.5a1 1 0 100-2 1 1 0 000 2zm0 1.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-2.25 6v-2a2.75 2.75 0 00-2.75-2.75h-4A2.75 2.75 0 003.75 15v2h1.5v-2c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v2h1.5zm7-2v2h-1.5v-2c0-.69-.56-1.25-1.25-1.25H15v-1.5h2.5A2.75 2.75 0 0120.25 15zM9.5 8.5a1 1 0 11-2 0 1 1 0 012 0zm1.5 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
          fillRule: "evenodd"
        })),
            Hr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10.44 3.02l1.82-1.82 6.36 6.35-1.83 1.82c-1.05-.68-2.48-.57-3.41.36l-.75.75c-.92.93-1.04 2.35-.35 3.41l-1.83 1.82-2.41-2.41-2.8 2.79c-.42.42-3.38 2.71-3.8 2.29s1.86-3.39 2.28-3.81l2.79-2.79L4.1 9.36l1.83-1.82c1.05.69 2.48.57 3.4-.36l.75-.75c.93-.92 1.05-2.35.36-3.41z"
        })),
            jr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10.5 4v4h3V4H15v4h1.5a1 1 0 011 1v4l-3 4v2a1 1 0 01-1 1h-3a1 1 0 01-1-1v-2l-3-4V9a1 1 0 011-1H9V4h1.5zm.5 12.5v2h2v-2l3-4v-3H8v3l3 4z"
        })),
            Fr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M2 12C2 6.44444 6.44444 2 12 2C17.5556 2 22 6.44444 22 12C22 17.5556 17.5556 22 12 22C6.44444 22 2 17.5556 2 12ZM13 11V7H11V11H7V13H11V17H13V13H17V11H13Z"
        })),
            Gr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm1-11H9v3H6v2h3v3h2v-3h3V9h-3V6zM10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm1-11H9v3H6v2h3v3h2v-3h3V9h-3V6z"
        })),
            Ur = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18 11.2h-5.2V6h-1.6v5.2H6v1.6h5.2V18h1.6v-5.2H18z"
        })),
            Wr = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M10 4.5a1 1 0 11-2 0 1 1 0 012 0zm1.5 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm2.25 7.5v-1A2.75 2.75 0 0011 8.25H7A2.75 2.75 0 004.25 11v1h1.5v-1c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1h1.5zM4 20h9v-1.5H4V20zm16-4H4v-1.5h16V16z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            Kr = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M20 4H4v1.5h16V4zm-2 9h-3c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-3c0-1.1-.9-2-2-2zm.5 5c0 .3-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v3zM4 9.5h9V8H4v1.5zM9 13H6c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-3c0-1.1-.9-2-2-2zm.5 5c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v3z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            $r = (0, m.createElement)(_.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 20h16v-1.5H4V20zm0-4.8h16v-1.5H4v1.5zm0-6.4v1.5h16V8.8H4zM16 4H4v1.5h12V4z"
        })),
            qr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14 10.1V4c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v8.3c0 .3.2.7.6.8.1.1.2.1.3.1.2 0 .5-.1.6-.3l1.8-1.8H13c.6 0 1-.4 1-1zm-1.5-.5H6.7l-1.2 1.2V4.5h7v5.1zM19 12h-8c-.6 0-1 .4-1 1v6.1c0 .6.4 1 1 1h5.7l1.8 1.8c.1.2.4.3.6.3.1 0 .2 0 .3-.1.4-.1.6-.5.6-.8V13c0-.6-.4-1-1-1zm-.5 7.8l-1.2-1.2h-5.8v-5.1h7v6.3z"
        })),
            Yr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M13 8H4v1.5h9V8zM4 4v1.5h16V4H4zm9 8H5c-.6 0-1 .4-1 1v8.3c0 .3.2.7.6.8.1.1.2.1.3.1.2 0 .5-.1.6-.3l1.8-1.8H13c.6 0 1-.4 1-1V13c0-.6-.4-1-1-1zm-2.2 6.6H7l1.6-2.2c.3-.4.5-.7.6-.9.1-.2.2-.4.2-.5 0-.2-.1-.3-.1-.4-.1-.1-.2-.1-.4-.1s-.4 0-.6.1c-.3.1-.5.3-.7.4l-.2.2-.2-1.2.1-.1c.3-.2.5-.3.8-.4.3-.1.6-.1.9-.1.3 0 .6.1.9.2.2.1.4.3.6.5.1.2.2.5.2.7 0 .3-.1.6-.2.9-.1.3-.4.7-.7 1.1l-.5.6h1.6v1.2z"
        })),
            Zr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M13 8H4v1.5h9V8zM4 4v1.5h16V4H4zm9 8H5c-.6 0-1 .4-1 1v8.3c0 .3.2.7.6.8.1.1.2.1.3.1.2 0 .5-.1.6-.3l1.8-1.8H13c.6 0 1-.4 1-1V13c0-.6-.4-1-1-1zm-.5 6.6H6.7l-1.2 1.2v-6.3h7v5.1z"
        })),
            Xr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11.696 13.972c.356-.546.599-.958.728-1.235a1.79 1.79 0 00.203-.783c0-.264-.077-.47-.23-.618-.148-.153-.354-.23-.618-.23-.295 0-.569.07-.82.212a3.413 3.413 0 00-.738.571l-.147-1.188c.289-.234.59-.41.903-.526.313-.117.66-.175 1.041-.175.375 0 .695.08.959.24.264.153.46.362.59.626.135.265.203.556.203.876 0 .362-.08.734-.24 1.115-.154.381-.427.87-.82 1.466l-.756 1.152H14v1.106h-4l1.696-2.609z"
        }), (0, m.createElement)(_.Path, {
          d: "M19.5 7h-15v12a.5.5 0 00.5.5h14a.5.5 0 00.5-.5V7zM3 7V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"
        })),
            Qr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12.75 9.333c0 .521-.102.977-.327 1.354-.23.386-.555.628-.893.774-.545.234-1.183.227-1.544.222l-.12-.001v-1.5h.123c.414.001.715.002.948-.099a.395.395 0 00.199-.166c.05-.083.114-.253.114-.584V7.2H8.8V4h3.95v5.333zM7.95 9.333c0 .521-.102.977-.327 1.354-.23.386-.555.628-.893.774-.545.234-1.183.227-1.544.222l-.12-.001v-1.5h.123c.414.001.715.002.948-.099a.394.394 0 00.198-.166c.05-.083.115-.253.115-.584V7.2H4V4h3.95v5.333zM13 20H4v-1.5h9V20zM20 16H4v-1.5h16V16z"
        })),
            Jr = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M19 3H5c-.6 0-1 .4-1 1v7c0 .5.4 1 1 1h14c.5 0 1-.4 1-1V4c0-.6-.4-1-1-1zM5.5 10.5v-.4l1.8-1.3 1.3.8c.3.2.7.2.9-.1L11 8.1l2.4 2.4H5.5zm13 0h-2.9l-4-4c-.3-.3-.8-.3-1.1 0L8.9 8l-1.2-.8c-.3-.2-.6-.2-.9 0l-1.3 1V4.5h13v6zM4 20h9v-1.5H4V20zm0-4h16v-1.5H4V16z"
        })),
            el = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v12zM7 11h2V9H7v2zm0 4h2v-2H7v2zm3-4h7V9h-7v2zm0 4h7v-2h-7v2z"
        })),
            tl = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M4 14.5h16V16H4zM4 18.5h9V20H4zM4 4h3c2 0 3 .86 3 2.583 0 .891-.253 1.554-.76 1.988-.505.435-1.24.652-2.204.652H5.542V12H4V4zm2.855 4c.53 0 .924-.114 1.18-.343.266-.228.398-.579.398-1.051 0-.473-.132-.82-.397-1.04-.265-.229-.67-.343-1.217-.343H5.542V8h1.313z"
        })),
            nl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11.6 7l-1.1-1L5 12l5.5 6 1.1-1L7 12l4.6-5zm6 0l-1.1-1-5.5 6 5.5 6 1.1-1-4.6-5 4.6-5z"
        })),
            ol = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.6 6L5.4 7l4.5 5-4.5 5 1.1 1 5.5-6-5.4-6zm6 0l-1.1 1 4.5 5-4.5 5 1.1 1 5.5-6-5.5-6z"
        })),
            rl = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v12zM7 16.5h6V15H7v1.5zm4-4h6V11h-6v1.5zM9 11H7v1.5h2V11zm6 5.5h2V15h-2v1.5z"
        })),
            ll = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 18h6V6H4v12zm9-9.5V10h7V8.5h-7zm0 7h7V14h-7v1.5z"
        })),
            il = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14 6v12h6V6h-6zM4 10h7V8.5H4V10zm0 5.5h7V14H4v1.5z"
        })),
            al = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18 8H6c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm.5 6c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v4zM4 4v1.5h16V4H4zm0 16h16v-1.5H4V20z"
        })),
            sl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Rect, {
          x: "4",
          y: "10.5",
          width: "6",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, m.createElement)(_.Rect, {
          x: "12",
          y: "10.5",
          width: "3",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, m.createElement)(_.Rect, {
          x: "17",
          y: "10.5",
          width: "3",
          height: "3",
          rx: "1.5",
          fill: "#000"
        })),
            cl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Rect, {
          x: "6",
          y: "10.5",
          width: "3",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, m.createElement)(_.Rect, {
          x: "11",
          y: "10.5",
          width: "3",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, m.createElement)(_.Path, {
          d: "M16.5 9.5L19 12l-2.5 2.5",
          stroke: "#1E1E1E",
          strokeWidth: "1.5"
        })),
            ul = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Rect, {
          x: "4",
          y: "10.5",
          width: "6",
          height: "3",
          rx: "1.5",
          fill: "#000"
        }), (0, m.createElement)(_.Path, {
          d: "M13.5 14v-4l-1.5.5",
          stroke: "#1E1E1E"
        }), (0, m.createElement)(_.Path, {
          d: "M19.266 9.805c-.473-.611-1.22-.51-1.702-.367a3.854 3.854 0 00-.718.307l.13 1.082c.192-.17.47-.422.782-.515.34-.1.578.025.668.141.21.27-.034.835-.16 1.055-.49.85-.93 1.594-1.45 2.492H19.5v-1h-.914c.277-.574.814-1.443.914-2.106.052-.343.02-.762-.234-1.09z",
          fill: "#1E1E1E"
        })),
            dl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Rect, {
          x: "18",
          y: "13.5",
          width: "3",
          height: "3",
          rx: "1.5",
          transform: "rotate(-180 18 13.5)",
          fill: "#000"
        }), (0, m.createElement)(_.Rect, {
          x: "13",
          y: "13.5",
          width: "3",
          height: "3",
          rx: "1.5",
          transform: "rotate(-180 13 13.5)",
          fill: "#000"
        }), (0, m.createElement)(_.Path, {
          d: "M7.5 14.5L5 12l2.5-2.5",
          stroke: "#1E1E1E",
          strokeWidth: "1.5"
        })),
            pl = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M13 6v6h5.2v4c0 .8-.2 1.4-.5 1.7-.6.6-1.6.6-2.5.5h-.3v1.5h.5c1 0 2.3-.1 3.3-1 .6-.6 1-1.6 1-2.8V6H13zm-9 6h5.2v4c0 .8-.2 1.4-.5 1.7-.6.6-1.6.6-2.5.5h-.3v1.5h.5c1 0 2.3-.1 3.3-1 .6-.6 1-1.6 1-2.8V6H4v6z"
        })),
            ml = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M16.83 6.342l.602.3.625-.25.443-.176v12.569l-.443-.178-.625-.25-.603.301-1.444.723-2.41-.804-.475-.158-.474.158-2.41.803-1.445-.722-.603-.3-.625.25-.443.177V6.215l.443.178.625.25.603-.301 1.444-.722 2.41.803.475.158.474-.158 2.41-.803 1.445.722zM20 4l-1.5.6-1 .4-2-1-3 1-3-1-2 1-1-.4L5 4v17l1.5-.6 1-.4 2 1 3-1 3 1 2-1 1 .4 1.5.6V4zm-3.5 6.25v-1.5h-8v1.5h8zm0 3v-1.5h-8v1.5h8zm-8 3v-1.5h8v1.5h-8z",
          clipRule: "evenodd"
        })),
            fl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M15.6 6.5l-1.1 1 2.9 3.3H8c-.9 0-1.7.3-2.3.9-1.4 1.5-1.4 4.2-1.4 5.6v.2h1.5v-.3c0-1.1 0-3.5 1-4.5.3-.3.7-.5 1.3-.5h9.2L14.5 15l1.1 1.1 4.6-4.6-4.6-5z"
        })),
            hl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M8.45474 21.2069L16.4547 3.7069L15.5453 3.29114L14.2837 6.05081C13.5991 5.69873 12.8228 5.49999 12 5.49999C10.9385 5.49999 9.95431 5.83076 9.1448 6.39485L7.18994 4.44L6.12928 5.50066L8.05556 7.42694C7.49044 8.15127 7.12047 9.0353 7.02469 9.99999H5V11.5H7V13H5V14.5H7.10002C7.35089 15.7359 8.0576 16.8062 9.03703 17.5279L7.54526 20.7911L8.45474 21.2069ZM9.68024 16.1209C8.95633 15.4796 8.5 14.5431 8.5 13.5V10.5C8.5 8.567 10.067 6.99999 12 6.99999C12.6003 6.99999 13.1653 7.15111 13.659 7.41738L9.68024 16.1209ZM15.3555 9.50155L16.1645 7.73191C16.6053 8.39383 16.8926 9.16683 16.9753 9.99999H19V11.5H17V13H19V14.5H16.9C16.4367 16.7822 14.419 18.5 12 18.5C11.7508 18.5 11.5058 18.4818 11.2664 18.4466L11.928 16.9993C11.9519 16.9998 11.9759 17 12 17C13.933 17 15.5 15.433 15.5 13.5V10.5C15.5 10.1531 15.4495 9.81794 15.3555 9.50155Z"
        })),
            gl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16 10h4c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1zm-8 4H4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1zm10-2.6L14.5 15l1.1 1.1 1.7-1.7c-.1 1.1-.3 2.3-.9 2.9-.3.3-.7.5-1.3.5h-4.5v1.5H15c.9 0 1.7-.3 2.3-.9 1-1 1.3-2.7 1.4-4l1.8 1.8 1.1-1.1-3.6-3.7zM6.8 9.7c.1-1.1.3-2.3.9-2.9.4-.4.8-.6 1.3-.6h4.5V4.8H9c-.9 0-1.7.3-2.3.9-1 1-1.3 2.7-1.4 4L3.5 8l-1 1L6 12.6 9.5 9l-1-1-1.7 1.7z"
        })),
            vl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7 11.5h10V13H7z"
        })),
            bl = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M12.5 4.2v1.6h4.7L5.8 17.2V12H4.2v7.8H12v-1.6H6.8L18.2 6.8v4.7h1.6V4.2z"
        })),
            _l = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M7 7.2h8.2L13.5 9l1.1 1.1 3.6-3.6-3.5-4-1.1 1 1.9 2.3H7c-.9 0-1.7.3-2.3.9-1.4 1.5-1.4 4.2-1.4 5.6v.2h1.5v-.3c0-1.1 0-3.5 1-4.5.3-.3.7-.5 1.2-.5zm13.8 4V11h-1.5v.3c0 1.1 0 3.5-1 4.5-.3.3-.7.5-1.3.5H8.8l1.7-1.7-1.1-1.1L5.9 17l3.5 4 1.1-1-1.9-2.3H17c.9 0 1.7-.3 2.3-.9 1.5-1.4 1.5-4.2 1.5-5.6z"
        })),
            kl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M21.3 10.8l-5.6-5.6c-.7-.7-1.8-.7-2.5 0l-5.6 5.6c-.7.7-.7 1.8 0 2.5l5.6 5.6c.3.3.8.5 1.2.5s.9-.2 1.2-.5l5.6-5.6c.8-.7.8-1.9.1-2.5zm-1 1.4l-5.6 5.6c-.1.1-.3.1-.4 0l-5.6-5.6c-.1-.1-.1-.3 0-.4l5.6-5.6s.1-.1.2-.1.1 0 .2.1l5.6 5.6c.1.1.1.3 0 .4zm-16.6-.4L10 5.5l-1-1-6.3 6.3c-.7.7-.7 1.8 0 2.5L9 19.5l1.1-1.1-6.3-6.3c-.2 0-.2-.2-.1-.3z"
        })),
            yl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 4V2.2L9 4.8l3 2.5V5.5c3.6 0 6.5 2.9 6.5 6.5 0 2.9-1.9 5.3-4.5 6.2v.2l-.1-.2c-.4.1-.7.2-1.1.2l.2 1.5c.3 0 .6-.1 1-.2 3.5-.9 6-4 6-7.7 0-4.4-3.6-8-8-8zm-7.9 7l1.5.2c.1-1.2.5-2.3 1.2-3.2l-1.1-.9C4.8 8.2 4.3 9.6 4.1 11zm1.5 1.8l-1.5.2c.1.7.3 1.4.5 2 .3.7.6 1.3 1 1.8l1.2-.8c-.3-.5-.6-1-.8-1.5s-.4-1.1-.4-1.7zm1.5 5.5c1.1.9 2.4 1.4 3.8 1.6l.2-1.5c-1.1-.1-2.2-.5-3.1-1.2l-.9 1.1z"
        })),
            El = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M15.1 4.8l-3-2.5V4c-4.4 0-8 3.6-8 8 0 3.7 2.5 6.9 6 7.7.3.1.6.1 1 .2l.2-1.5c-.4 0-.7-.1-1.1-.2l-.1.2v-.2c-2.6-.8-4.5-3.3-4.5-6.2 0-3.6 2.9-6.5 6.5-6.5v1.8l3-2.5zM20 11c-.2-1.4-.7-2.7-1.6-3.8l-1.2.8c.7.9 1.1 2 1.3 3.1L20 11zm-1.5 1.8c-.1.5-.2 1.1-.4 1.6s-.5 1-.8 1.5l1.2.9c.4-.5.8-1.1 1-1.8s.5-1.3.5-2l-1.5-.2zm-5.6 5.6l.2 1.5c1.4-.2 2.7-.7 3.8-1.6l-.9-1.1c-.9.7-2 1.1-3.1 1.2z"
        })),
            wl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 10.2h-.8v1.5H5c1.9 0 3.8.8 5.1 2.1 1.4 1.4 2.1 3.2 2.1 5.1v.8h1.5V19c0-2.3-.9-4.5-2.6-6.2-1.6-1.6-3.8-2.6-6.1-2.6zm10.4-1.6C12.6 5.8 8.9 4.2 5 4.2h-.8v1.5H5c3.5 0 6.9 1.4 9.4 3.9s3.9 5.8 3.9 9.4v.8h1.5V19c0-3.9-1.6-7.6-4.4-10.4zM4 20h3v-3H4v3z"
        })),
            Cl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M13.5 6C10.5 6 8 8.5 8 11.5c0 1.1.3 2.1.9 3l-3.4 3 1 1.1 3.4-2.9c1 .9 2.2 1.4 3.6 1.4 3 0 5.5-2.5 5.5-5.5C19 8.5 16.5 6 13.5 6zm0 9.5c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
        })),
            Sl = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M20.2 7v4H3.8V7H2.2v9h1.6v-3.5h16.4V16h1.6V7z"
        })),
            Bl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14.5 13.8c-1.1 0-2.1.7-2.4 1.8H4V17h8.1c.3 1 1.3 1.8 2.4 1.8s2.1-.7 2.4-1.8H20v-1.5h-3.1c-.3-1-1.3-1.7-2.4-1.7zM11.9 7c-.3-1-1.3-1.8-2.4-1.8S7.4 6 7.1 7H4v1.5h3.1c.3 1 1.3 1.8 2.4 1.8s2.1-.7 2.4-1.8H20V7h-8.1z"
        })),
            Pl = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M9 11.8l6.1-4.5c.1.4.4.7.9.7h2c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-2c-.6 0-1 .4-1 1v.4l-6.4 4.8c-.2-.1-.4-.2-.6-.2H6c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.2 0 .4-.1.6-.2l6.4 4.8v.4c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1h-2c-.5 0-.8.3-.9.7L9 12.2v-.4z"
        })),
            xl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 3.176l6.75 3.068v4.574c0 3.9-2.504 7.59-6.035 8.755a2.283 2.283 0 01-1.43 0c-3.53-1.164-6.035-4.856-6.035-8.755V6.244L12 3.176zM6.75 7.21v3.608c0 3.313 2.145 6.388 5.005 7.33.159.053.331.053.49 0 2.86-.942 5.005-4.017 5.005-7.33V7.21L12 4.824 6.75 7.21z",
          fillRule: "evenodd",
          clipRule: "evenodd"
        })),
            Il = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M16 4.2v1.5h2.5v12.5H16v1.5h4V4.2h-4zM4.2 19.8h4v-1.5H5.8V5.8h2.5V4.2h-4l-.1 15.6zm5.1-3.1l1.4.6 4-10-1.4-.6-4 10z"
        })),
            Ml = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12 3c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 1.5c4.1 0 7.5 3.4 7.5 7.5v.1c-1.4-.8-3.3-1.7-3.4-1.8-.2-.1-.5-.1-.8.1l-2.9 2.1L9 11.3c-.2-.1-.4 0-.6.1l-3.7 2.2c-.1-.5-.2-1-.2-1.5 0-4.2 3.4-7.6 7.5-7.6zm0 15c-3.1 0-5.7-1.9-6.9-4.5l3.7-2.2 3.5 1.2c.2.1.5 0 .7-.1l2.9-2.1c.8.4 2.5 1.2 3.5 1.9-.9 3.3-3.9 5.8-7.4 5.8z"
        })),
            Tl = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M10 11c-1.588-.479-4-.91-4-.91s2-.241 4-.454c1.8-.191 3.365-.502 4-3.181C14.635 3.775 15 1 15 1s.365 2.775 1 5.455c.635 2.679 2 2.969 4 3.181 2 .213 4 .455 4 .455s-2.412.43-4 .909c-1.588.479-3 1-4 4.546-.746 2.643-.893 4.948-1 5.454-.107-.506-.167-2.5-1-5.454C13 12 11.588 11.479 10 11zM7.333 3.5C6.803 3.333 6 3.182 6 3.182s.667-.085 1.333-.16c.6-.066 1.122-.175 1.334-1.113C8.878.971 9 0 9 0s.122.971.333 1.91c.212.937.667 1.038 1.334 1.113.666.074 1.333.159 1.333.159s-.804.15-1.333.318c-.53.167-1 .35-1.334 1.59C9.085 6.017 9.036 6.824 9 7c-.036-.177-.056-.875-.333-1.91-.334-1.24-.804-1.423-1.334-1.59zM2.444 18C1.474 17.713 0 17.454 0 17.454s1.222-.145 2.444-.272c1.1-.115 2.057-.302 2.445-1.91C5.277 13.666 5.5 12 5.5 12s.223 1.665.611 3.273c.388 1.607 1.222 1.781 2.445 1.909 1.222.127 2.444.273 2.444.273s-1.474.258-2.444.545c-.971.287-1.834.6-2.445 2.727-.456 1.586-.546 2.97-.611 3.273-.065-.304-.102-1.5-.611-3.273C4.278 18.6 3.415 18.287 2.444 18z",
          fill: "#F0C930"
        })),
            Ol = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20.2 8v11c0 .7-.6 1.2-1.2 1.2H6v1.5h13c1.5 0 2.7-1.2 2.7-2.8V8zM18 16.4V4.6c0-.9-.7-1.6-1.6-1.6H4.6C3.7 3 3 3.7 3 4.6v11.8c0 .9.7 1.6 1.6 1.6h11.8c.9 0 1.6-.7 1.6-1.6zm-13.5 0V4.6c0-.1.1-.1.1-.1h11.8c.1 0 .1.1.1.1v11.8c0 .1-.1.1-.1.1H4.6l-.1-.1z"
        })),
            Ll = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M9.706 8.646a.25.25 0 01-.188.137l-4.626.672a.25.25 0 00-.139.427l3.348 3.262a.25.25 0 01.072.222l-.79 4.607a.25.25 0 00.362.264l4.138-2.176a.25.25 0 01.233 0l4.137 2.175a.25.25 0 00.363-.263l-.79-4.607a.25.25 0 01.072-.222l3.347-3.262a.25.25 0 00-.139-.427l-4.626-.672a.25.25 0 01-.188-.137l-2.069-4.192a.25.25 0 00-.448 0L9.706 8.646zM12 7.39l-.948 1.921a1.75 1.75 0 01-1.317.957l-2.12.308 1.534 1.495c.412.402.6.982.503 1.55l-.362 2.11 1.896-.997a1.75 1.75 0 011.629 0l1.895.997-.362-2.11a1.75 1.75 0 01.504-1.55l1.533-1.495-2.12-.308a1.75 1.75 0 01-1.317-.957L12 7.39z",
          clipRule: "evenodd"
        })),
            Vl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M11.776 4.454a.25.25 0 01.448 0l2.069 4.192a.25.25 0 00.188.137l4.626.672a.25.25 0 01.139.426l-3.348 3.263a.25.25 0 00-.072.222l.79 4.607a.25.25 0 01-.362.263l-4.138-2.175a.25.25 0 00-.232 0l-4.138 2.175a.25.25 0 01-.363-.263l.79-4.607a.25.25 0 00-.071-.222L4.754 9.881a.25.25 0 01.139-.426l4.626-.672a.25.25 0 00.188-.137l2.069-4.192z"
        })),
            Rl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M9.518 8.783a.25.25 0 00.188-.137l2.069-4.192a.25.25 0 01.448 0l2.07 4.192a.25.25 0 00.187.137l4.626.672a.25.25 0 01.139.427l-3.347 3.262a.25.25 0 00-.072.222l.79 4.607a.25.25 0 01-.363.264l-4.137-2.176a.25.25 0 00-.233 0l-4.138 2.175a.25.25 0 01-.362-.263l.79-4.607a.25.25 0 00-.072-.222L4.753 9.882a.25.25 0 01.14-.427l4.625-.672zM12 14.533c.28 0 .559.067.814.2l1.895.997-.362-2.11a1.75 1.75 0 01.504-1.55l1.533-1.495-2.12-.308a1.75 1.75 0 01-1.317-.957L12 7.39v7.143z"
        })),
            Al = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M19.75 11H21V8.667L19.875 4H4.125L3 8.667V11h1.25v8.75h15.5V11zm-1.5 0H5.75v7.25H10V13h4v5.25h4.25V11zm-5.5-5.5h2.067l.486 3.24.028.76H12.75v-4zm-3.567 0h2.067v4H8.669l.028-.76.486-3.24zm7.615 3.1l-.464-3.1h2.36l.806 3.345V9.5h-2.668l-.034-.9zM7.666 5.5h-2.36L4.5 8.845V9.5h2.668l.034-.9.464-3.1z",
          clipRule: "evenodd"
        })),
            zl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 4v11h14V4H5zm3 15.8h8v-1.5H8v1.5z"
        })),
            Nl = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M12 4c-4.4 0-8 3.6-8 8v.1c0 4.1 3.2 7.5 7.2 7.9h.8c4.4 0 8-3.6 8-8s-3.6-8-8-8zm0 15V5c3.9 0 7 3.1 7 7s-3.1 7-7 7z"
        })),
            Dl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M3 6.75C3 5.784 3.784 5 4.75 5H15V7.313l.05.027 5.056 2.73.394.212v3.468a1.75 1.75 0 01-1.75 1.75h-.012a2.5 2.5 0 11-4.975 0H9.737a2.5 2.5 0 11-4.975 0H3V6.75zM13.5 14V6.5H4.75a.25.25 0 00-.25.25V14h.965a2.493 2.493 0 011.785-.75c.7 0 1.332.287 1.785.75H13.5zm4.535 0h.715a.25.25 0 00.25-.25v-2.573l-4-2.16v4.568a2.487 2.487 0 011.25-.335c.7 0 1.332.287 1.785.75zM6.282 15.5a1.002 1.002 0 00.968 1.25 1 1 0 10-.968-1.25zm9 0a1 1 0 101.937.498 1 1 0 00-1.938-.498z"
        })),
            Hl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 9v6h14V9H5zm11-4.8H8v1.5h8V4.2zM8 19.8h8v-1.5H8v1.5z"
        })),
            jl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16.9 18.3l.8-1.2c.4-.6.7-1.2.9-1.6.2-.4.3-.8.3-1.2 0-.3-.1-.7-.2-1-.1-.3-.4-.5-.6-.7-.3-.2-.6-.3-1-.3s-.8.1-1.1.2c-.3.1-.7.3-1 .6l.2 1.3c.3-.3.5-.5.8-.6s.6-.2.9-.2c.3 0 .5.1.7.2.2.2.2.4.2.7 0 .3-.1.5-.2.8-.1.3-.4.7-.8 1.3L15 19.4h4.3v-1.2h-2.4zM14.1 7.2h-2L9.5 11 6.9 7.2h-2l3.6 5.3L4.7 18h2l2.7-4 2.7 4h2l-3.8-5.5 3.8-5.3z"
        })),
            Fl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M16.9 10.3l.8-1.3c.4-.6.7-1.2.9-1.6.2-.4.3-.8.3-1.2 0-.3-.1-.7-.2-1-.2-.2-.4-.4-.7-.6-.3-.2-.6-.3-1-.3s-.8.1-1.1.2c-.3.1-.7.3-1 .6l.1 1.3c.3-.3.5-.5.8-.6s.6-.2.9-.2c.3 0 .5.1.7.2.2.2.2.4.2.7 0 .3-.1.5-.2.8-.1.3-.4.7-.8 1.3l-1.8 2.8h4.3v-1.2h-2.2zm-2.8-3.1h-2L9.5 11 6.9 7.2h-2l3.6 5.3L4.7 18h2l2.7-4 2.7 4h2l-3.8-5.5 3.8-5.3z"
        })),
            Gl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 17.7c.4.5.8.9 1.2 1.2l1.1-1.4c-.4-.3-.7-.6-1-1L5 17.7zM5 6.3l1.4 1.1c.3-.4.6-.7 1-1L6.3 5c-.5.4-.9.8-1.3 1.3zm.1 7.8l-1.7.5c.2.6.4 1.1.7 1.6l1.5-.8c-.2-.4-.4-.8-.5-1.3zM4.8 12v-.7L3 11.1v1.8l1.7-.2c.1-.2.1-.5.1-.7zm3 7.9c.5.3 1.1.5 1.6.7l.5-1.7c-.5-.1-.9-.3-1.3-.5l-.8 1.5zM19 6.3c-.4-.5-.8-.9-1.2-1.2l-1.1 1.4c.4.3.7.6 1 1L19 6.3zm-.1 3.6l1.7-.5c-.2-.6-.4-1.1-.7-1.6l-1.5.8c.2.4.4.8.5 1.3zM5.6 8.6l-1.5-.8c-.3.5-.5 1-.7 1.6l1.7.5c.1-.5.3-.9.5-1.3zm2.2-4.5l.8 1.5c.4-.2.8-.4 1.3-.5l-.5-1.7c-.6.2-1.1.4-1.6.7zm8.8 13.5l1.1 1.4c.5-.4.9-.8 1.2-1.2l-1.4-1.1c-.2.3-.5.6-.9.9zm1.8-2.2l1.5.8c.3-.5.5-1.1.7-1.6l-1.7-.5c-.1.5-.3.9-.5 1.3zm2.6-4.3l-1.7.2v1.4l1.7.2V12v-.9zM11.1 3l.2 1.7h1.4l.2-1.7h-1.8zm3 2.1c.5.1.9.3 1.3.5l.8-1.5c-.5-.3-1.1-.5-1.6-.7l-.5 1.7zM12 19.2h-.7l-.2 1.8h1.8l-.2-1.7c-.2-.1-.5-.1-.7-.1zm2.1-.3l.5 1.7c.6-.2 1.1-.4 1.6-.7l-.8-1.5c-.4.2-.8.4-1.3.5z"
        })),
            Ul = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14.08 12.864V9.216h3.648V7.424H14.08V3.776h-1.728v3.648H8.64v1.792h3.712v3.648zM0 17.92V0h20.48v17.92H0zM6.4 1.28H1.28v3.84H6.4V1.28zm0 5.12H1.28v3.84H6.4V6.4zm0 5.12H1.28v3.84H6.4v-3.84zM19.2 1.28H7.68v14.08H19.2V1.28z"
        })),
            Wl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.4 3.776v3.648H2.752v1.792H6.4v3.648h1.728V9.216h3.712V7.424H8.128V3.776zM0 17.92V0h20.48v17.92H0zM12.8 1.28H1.28v14.08H12.8V1.28zm6.4 0h-5.12v3.84h5.12V1.28zm0 5.12h-5.12v3.84h5.12V6.4zm0 5.12h-5.12v3.84h5.12v-3.84z"
        })),
            Kl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.4 9.98L7.68 8.7v-.256L6.4 7.164V9.98zm6.4-1.532l1.28-1.28V9.92L12.8 8.64v-.192zm7.68 9.472V0H0v17.92h20.48zm-1.28-2.56h-5.12v-1.024l-.256.256-1.024-1.024v1.792H7.68v-1.792l-1.024 1.024-.256-.256v1.024H1.28V1.28H6.4v2.368l.704-.704.576.576V1.216h5.12V3.52l.96-.96.32.32V1.216h5.12V15.36zm-5.76-2.112l-3.136-3.136-3.264 3.264-1.536-1.536 3.264-3.264L5.632 5.44l1.536-1.536 3.136 3.136 3.2-3.2 1.536 1.536-3.2 3.2 3.136 3.136-1.536 1.536z"
        })),
            $l = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M13.824 10.176h-2.88v-2.88H9.536v2.88h-2.88v1.344h2.88v2.88h1.408v-2.88h2.88zM0 17.92V0h20.48v17.92H0zM6.4 1.28H1.28v3.84H6.4V1.28zm6.4 0H7.68v3.84h5.12V1.28zm6.4 0h-5.12v3.84h5.12V1.28zm0 5.056H1.28v9.024H19.2V6.336z"
        })),
            ql = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.656 6.464h2.88v2.88h1.408v-2.88h2.88V5.12h-2.88V2.24H9.536v2.88h-2.88zM0 17.92V0h20.48v17.92H0zm7.68-2.56h5.12v-3.84H7.68v3.84zm-6.4 0H6.4v-3.84H1.28v3.84zM19.2 1.28H1.28v9.024H19.2V1.28zm0 10.24h-5.12v3.84h5.12v-3.84zM6.656 6.464h2.88v2.88h1.408v-2.88h2.88V5.12h-2.88V2.24H9.536v2.88h-2.88zM0 17.92V0h20.48v17.92H0zm7.68-2.56h5.12v-3.84H7.68v3.84zm-6.4 0H6.4v-3.84H1.28v3.84zM19.2 1.28H1.28v9.024H19.2V1.28zm0 10.24h-5.12v3.84h5.12v-3.84z"
        })),
            Yl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M17.728 11.456L14.592 8.32l3.2-3.2-1.536-1.536-3.2 3.2L9.92 3.648 8.384 5.12l3.2 3.2-3.264 3.264 1.536 1.536 3.264-3.264 3.136 3.136 1.472-1.536zM0 17.92V0h20.48v17.92H0zm19.2-6.4h-.448l-1.28-1.28H19.2V6.4h-1.792l1.28-1.28h.512V1.28H1.28v3.84h6.208l1.28 1.28H1.28v3.84h7.424l-1.28 1.28H1.28v3.84H19.2v-3.84z"
        })),
            Zl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4 6v11.5h16V6H4zm1.5 1.5h6V11h-6V7.5zm0 8.5v-3.5h6V16h-6zm13 0H13v-3.5h5.5V16zM13 11V7.5h5.5V11H13z"
        })),
            Xl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20.1 11.2l-6.7-6.7c-.1-.1-.3-.2-.5-.2H5c-.4-.1-.8.3-.8.7v7.8c0 .2.1.4.2.5l6.7 6.7c.2.2.5.4.7.5s.6.2.9.2c.3 0 .6-.1.9-.2.3-.1.5-.3.8-.5l5.6-5.6c.4-.4.7-1 .7-1.6.1-.6-.2-1.2-.6-1.6zM19 13.4L13.4 19c-.1.1-.2.1-.3.2-.2.1-.4.1-.6 0-.1 0-.2-.1-.3-.2l-6.5-6.5V5.8h6.8l6.5 6.5c.2.2.2.4.2.6 0 .1 0 .3-.2.5zM9 8c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
        })),
            Ql = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M21.3 10.8l-5.6-5.6c-.7-.7-1.8-.7-2.5 0l-5.6 5.6c-.7.7-.7 1.8 0 2.5l5.6 5.6c.3.3.8.5 1.2.5s.9-.2 1.2-.5l5.6-5.6c.8-.7.8-1.9.1-2.5zm-17.6 1L10 5.5l-1-1-6.3 6.3c-.7.7-.7 1.8 0 2.5L9 19.5l1.1-1.1-6.3-6.3c-.2 0-.2-.2-.1-.3z"
        })),
            Jl = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          stroke: "#1E1E1E",
          strokeWidth: "1.5",
          d: "M9 19.25h6M4 19.25h4M12 15.25h8M4 15.25h7"
        }), (0, m.createElement)(_.Path, {
          d: "M8.994 10.103H6.08L5.417 12H4l2.846-8h1.383l2.845 8H9.657l-.663-1.897zm-.457-1.28l-.994-2.857-1.006 2.857h2z",
          fill: "#1E1E1E"
        })),
            ei = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          d: "M18 5.5h-8v8h8.5V6a.5.5 0 00-.5-.5zm-9.5 8h-3V6a.5.5 0 01.5-.5h2.5v8zM6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
        })),
            ti = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.5 10.5H10v8h8a.5.5 0 00.5-.5v-7.5zm-10 0h-3V18a.5.5 0 00.5.5h2.5v-8zM6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
        })),
            ni = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18 5.5H6a.5.5 0 00-.5.5v3h13V6a.5.5 0 00-.5-.5zm.5 5H10v8h8a.5.5 0 00.5-.5v-7.5zM6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2z"
        })),
            oi = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M12.9 6h-2l-4 11h1.9l1.1-3h4.2l1.1 3h1.9L12.9 6zm-2.5 6.5l1.5-4.9 1.7 4.9h-3.2z"
        })),
            ri = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M17 4H7c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H7c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v12zm-7.5-.5h4V16h-4v1.5z"
        })),
            li = (0, m.createElement)(_.SVG, {
          xmlns: "https://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M5 4v3h5.5v12h3V7H19V4H5z"
        })),
            ii = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M14.103 7.128l2.26-2.26a4 4 0 00-5.207 4.804L5.828 15a2 2 0 102.828 2.828l5.329-5.328a4 4 0 004.804-5.208l-2.261 2.26-1.912-.512-.513-1.912zm-7.214 9.64a.5.5 0 11.707-.707.5.5 0 01-.707.707z"
        })),
            ai = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20 5h-5.7c0-1.3-1-2.3-2.3-2.3S9.7 3.7 9.7 5H4v2h1.5v.3l1.7 11.1c.1 1 1 1.7 2 1.7h5.7c1 0 1.8-.7 2-1.7l1.7-11.1V7H20V5zm-3.2 2l-1.7 11.1c0 .1-.1.2-.3.2H9.1c-.1 0-.3-.1-.3-.2L7.2 7h9.6z"
        })),
            si = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19 5v2H5V5h3V4a2 2 0 012-2h4a2 2 0 012 2v1h3zM6.187 8h11.625l-.695 11.125A2 2 0 0115.121 21H8.879a2 2 0 01-1.996-1.875L6.187 8zM14 5h-4V4h4v1z"
        })),
            ci = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M4.195 8.245a.75.75 0 011.06-.05l5.004 4.55 4.025-3.521L19 13.939V10.75h1.5v5.75h-5.75V15h3.19l-3.724-3.723-3.975 3.478-5.995-5.45a.75.75 0 01-.051-1.06z"
        })),
            ui = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M3.445 16.505a.75.75 0 001.06.05l5.005-4.55 4.024 3.521 4.716-4.715V14h1.5V8.25H14v1.5h3.19l-3.724 3.723L9.49 9.995l-5.995 5.45a.75.75 0 00-.05 1.06z"
        })),
            di = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6.9 7L3 17.8h1.7l1-2.8h4.1l1 2.8h1.7L8.6 7H6.9zm-.7 6.6l1.5-4.3 1.5 4.3h-3zM21.6 17c-.1.1-.2.2-.3.2-.1.1-.2.1-.4.1s-.3-.1-.4-.2c-.1-.1-.1-.3-.1-.6V12c0-.5 0-1-.1-1.4-.1-.4-.3-.7-.5-1-.2-.2-.5-.4-.9-.5-.4 0-.8-.1-1.3-.1s-1 .1-1.4.2c-.4.1-.7.3-1 .4-.2.2-.4.3-.6.5-.1.2-.2.4-.2.7 0 .3.1.5.2.8.2.2.4.3.8.3.3 0 .6-.1.8-.3.2-.2.3-.4.3-.7 0-.3-.1-.5-.2-.7-.2-.2-.4-.3-.6-.4.2-.2.4-.3.7-.4.3-.1.6-.1.8-.1.3 0 .6 0 .8.1.2.1.4.3.5.5.1.2.2.5.2.9v1.1c0 .3-.1.5-.3.6-.2.2-.5.3-.9.4-.3.1-.7.3-1.1.4-.4.1-.8.3-1.1.5-.3.2-.6.4-.8.7-.2.3-.3.7-.3 1.2 0 .6.2 1.1.5 1.4.3.4.9.5 1.6.5.5 0 1-.1 1.4-.3.4-.2.8-.6 1.1-1.1 0 .4.1.7.3 1 .2.3.6.4 1.2.4.4 0 .7-.1.9-.2.2-.1.5-.3.7-.4h-.3zm-3-.9c-.2.4-.5.7-.8.8-.3.2-.6.2-.8.2-.4 0-.6-.1-.9-.3-.2-.2-.3-.6-.3-1.1 0-.5.1-.9.3-1.2s.5-.5.8-.7c.3-.2.7-.3 1-.5.3-.1.6-.3.7-.6v3.4z"
        })),
            pi = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.3 11.7c-.6-.6-1.4-.9-2.3-.9H6.7l2.9-3.3-1.1-1-4.5 5L8.5 16l1-1-2.7-2.7H16c.5 0 .9.2 1.3.5 1 1 1 3.4 1 4.5v.3h1.5v-.2c0-1.5 0-4.3-1.5-5.7z"
        })),
            mi = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18 4h-7c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 9c0 .3-.2.5-.5.5h-7c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v7zm-5 5c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5v-7c0-.3.2-.5.5-.5h1V9H6c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2v-1h-1.5v1z"
        })),
            fi = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10.2 3.28c3.53 0 6.43 2.61 6.92 6h2.08l-3.5 4-3.5-4h2.32c-.45-1.97-2.21-3.45-4.32-3.45-1.45 0-2.73.71-3.54 1.78L4.95 5.66C6.23 4.2 8.11 3.28 10.2 3.28zm-.4 13.44c-3.52 0-6.43-2.61-6.92-6H.8l3.5-4c1.17 1.33 2.33 2.67 3.5 4H5.48c.45 1.97 2.21 3.45 4.32 3.45 1.45 0 2.73-.71 3.54-1.78l1.71 1.95c-1.28 1.46-3.15 2.38-5.25 2.38z"
        })),
            hi = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M18.5 15v3.5H13V6.7l4.5 4.1 1-1.1-6.2-5.8-5.8 5.8 1 1.1 4-4v11.7h-6V15H4v5h16v-5z"
        })),
            gi = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M17.8 2l-.9.3c-.1 0-3.6 1-5.2 2.1C10 5.5 9.3 6.5 8.9 7.1c-.6.9-1.7 4.7-1.7 6.3l-.9 2.3c-.2.4 0 .8.4 1 .1 0 .2.1.3.1.3 0 .6-.2.7-.5l.6-1.5c.3 0 .7-.1 1.2-.2.7-.1 1.4-.3 2.2-.5.8-.2 1.6-.5 2.4-.8.7-.3 1.4-.7 1.9-1.2s.8-1.2 1-1.9c.2-.7.3-1.6.4-2.4.1-.8.1-1.7.2-2.5 0-.8.1-1.5.2-2.1V2zm-1.9 5.6c-.1.8-.2 1.5-.3 2.1-.2.6-.4 1-.6 1.3-.3.3-.8.6-1.4.9-.7.3-1.4.5-2.2.8-.6.2-1.3.3-1.8.4L15 7.5c.3-.3.6-.7 1-1.1 0 .4 0 .8-.1 1.2zM6 20h8v-1.5H6V20z"
        })),
            vi = (0, m.createElement)(_.SVG, {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, (0, m.createElement)(_.Path, {
          d: "M18.7 3H5.3C4 3 3 4 3 5.3v13.4C3 20 4 21 5.3 21h13.4c1.3 0 2.3-1 2.3-2.3V5.3C21 4 20 3 18.7 3zm.8 15.7c0 .4-.4.8-.8.8H5.3c-.4 0-.8-.4-.8-.8V5.3c0-.4.4-.8.8-.8h13.4c.4 0 .8.4.8.8v13.4zM10 15l5-3-5-3v6z"
        })),
            bi = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm1.13 9.38l.35-6.46H8.52l.35 6.46h2.26zm-.09 3.36c.24-.23.37-.55.37-.96 0-.42-.12-.74-.36-.97s-.59-.35-1.06-.35-.82.12-1.07.35-.37.55-.37.97c0 .41.13.73.38.96.26.23.61.34 1.06.34s.8-.11 1.05-.34z"
        })),
            _i = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M6 3H8V5H16V3H18V5C19.1046 5 20 5.89543 20 7V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V7C4 5.89543 4.89543 5 6 5V3ZM18 6.5H6C5.72386 6.5 5.5 6.72386 5.5 7V8H18.5V7C18.5 6.72386 18.2761 6.5 18 6.5ZM18.5 9.5H5.5V19C5.5 19.2761 5.72386 19.5 6 19.5H18C18.2761 19.5 18.5 19.2761 18.5 19V9.5ZM11 11H13V13H11V11ZM7 11V13H9V11H7ZM15 13V11H17V13H15Z"
        })),
            ki = (0, m.createElement)(_.SVG, {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "-2 -2 24 24"
        }, (0, m.createElement)(_.Path, {
          d: "M20 10c0-5.51-4.49-10-10-10C4.48 0 0 4.49 0 10c0 5.52 4.48 10 10 10 5.51 0 10-4.48 10-10zM7.78 15.37L4.37 6.22c.55-.02 1.17-.08 1.17-.08.5-.06.44-1.13-.06-1.11 0 0-1.45.11-2.37.11-.18 0-.37 0-.58-.01C4.12 2.69 6.87 1.11 10 1.11c2.33 0 4.45.87 6.05 2.34-.68-.11-1.65.39-1.65 1.58 0 .74.45 1.36.9 2.1.35.61.55 1.36.55 2.46 0 1.49-1.4 5-1.4 5l-3.03-8.37c.54-.02.82-.17.82-.17.5-.05.44-1.25-.06-1.22 0 0-1.44.12-2.38.12-.87 0-2.33-.12-2.33-.12-.5-.03-.56 1.2-.06 1.22l.92.08 1.26 3.41zM17.41 10c.24-.64.74-1.87.43-4.25.7 1.29 1.05 2.71 1.05 4.25 0 3.29-1.73 6.24-4.4 7.78.97-2.59 1.94-5.2 2.92-7.78zM6.1 18.09C3.12 16.65 1.11 13.53 1.11 10c0-1.3.23-2.48.72-3.59C3.25 10.3 4.67 14.2 6.1 18.09zm4.03-6.63l2.58 6.98c-.86.29-1.76.45-2.71.45-.79 0-1.57-.11-2.29-.33.81-2.38 1.62-4.74 2.42-7.1z"
        }));
      },
      5581: function _(l, s) {
        var c, m, v;
        m = [l, s], c = function c(l, s) {
          "use strict";

          var c,
              m,
              v = "function" == typeof Map ? new Map() : (c = [], m = [], {
            has: function has(l) {
              return c.indexOf(l) > -1;
            },
            get: function get(l) {
              return m[c.indexOf(l)];
            },
            set: function set(l, s) {
              -1 === c.indexOf(l) && (c.push(l), m.push(s));
            },
            delete: function _delete(l) {
              var s = c.indexOf(l);
              s > -1 && (c.splice(s, 1), m.splice(s, 1));
            }
          }),
              _ = function createEvent(l) {
            return new Event(l, {
              bubbles: !0
            });
          };

          try {
            new Event("test");
          } catch (l) {
            _ = function createEvent(l) {
              var s = document.createEvent("Event");
              return s.initEvent(l, !0, !1), s;
            };
          }

          function assign(l) {
            if (l && l.nodeName && "TEXTAREA" === l.nodeName && !v.has(l)) {
              var s = null,
                  c = null,
                  m = null,
                  k = function pageResize() {
                l.clientWidth !== c && update();
              },
                  y = function (s) {
                window.removeEventListener("resize", k, !1), l.removeEventListener("input", update, !1), l.removeEventListener("keyup", update, !1), l.removeEventListener("autosize:destroy", y, !1), l.removeEventListener("autosize:update", update, !1), Object.keys(s).forEach(function (c) {
                  l.style[c] = s[c];
                }), v.delete(l);
              }.bind(l, {
                height: l.style.height,
                resize: l.style.resize,
                overflowY: l.style.overflowY,
                overflowX: l.style.overflowX,
                wordWrap: l.style.wordWrap
              });

              l.addEventListener("autosize:destroy", y, !1), "onpropertychange" in l && "oninput" in l && l.addEventListener("keyup", update, !1), window.addEventListener("resize", k, !1), l.addEventListener("input", update, !1), l.addEventListener("autosize:update", update, !1), l.style.overflowX = "hidden", l.style.wordWrap = "break-word", v.set(l, {
                destroy: y,
                update: update
              }), init();
            }

            function init() {
              var c = window.getComputedStyle(l, null);
              "vertical" === c.resize ? l.style.resize = "none" : "both" === c.resize && (l.style.resize = "horizontal"), s = "content-box" === c.boxSizing ? -(parseFloat(c.paddingTop) + parseFloat(c.paddingBottom)) : parseFloat(c.borderTopWidth) + parseFloat(c.borderBottomWidth), isNaN(s) && (s = 0), update();
            }

            function changeOverflow(s) {
              var c = l.style.width;
              l.style.width = "0px", l.offsetWidth, l.style.width = c, l.style.overflowY = s;
            }

            function getParentOverflows(l) {
              for (var s = []; l && l.parentNode && l.parentNode instanceof Element;) {
                l.parentNode.scrollTop && s.push({
                  node: l.parentNode,
                  scrollTop: l.parentNode.scrollTop
                }), l = l.parentNode;
              }

              return s;
            }

            function resize() {
              if (0 !== l.scrollHeight) {
                var m = getParentOverflows(l),
                    v = document.documentElement && document.documentElement.scrollTop;
                l.style.height = "", l.style.height = l.scrollHeight + s + "px", c = l.clientWidth, m.forEach(function (l) {
                  l.node.scrollTop = l.scrollTop;
                }), v && (document.documentElement.scrollTop = v);
              }
            }

            function update() {
              resize();
              var s = Math.round(parseFloat(l.style.height)),
                  c = window.getComputedStyle(l, null),
                  v = "content-box" === c.boxSizing ? Math.round(parseFloat(c.height)) : l.offsetHeight;

              if (v < s ? "hidden" === c.overflowY && (changeOverflow("scroll"), resize(), v = "content-box" === c.boxSizing ? Math.round(parseFloat(window.getComputedStyle(l, null).height)) : l.offsetHeight) : "hidden" !== c.overflowY && (changeOverflow("hidden"), resize(), v = "content-box" === c.boxSizing ? Math.round(parseFloat(window.getComputedStyle(l, null).height)) : l.offsetHeight), m !== v) {
                m = v;

                var k = _("autosize:resized");

                try {
                  l.dispatchEvent(k);
                } catch (l) {}
              }
            }
          }

          function destroy(l) {
            var s = v.get(l);
            s && s.destroy();
          }

          function update(l) {
            var s = v.get(l);
            s && s.update();
          }

          var k = null;
          "undefined" == typeof window || "function" != typeof window.getComputedStyle ? ((k = function autosize(l) {
            return l;
          }).destroy = function (l) {
            return l;
          }, k.update = function (l) {
            return l;
          }) : ((k = function autosize(l, s) {
            return l && Array.prototype.forEach.call(l.length ? l : [l], function (l) {
              return assign(l, s);
            }), l;
          }).destroy = function (l) {
            return l && Array.prototype.forEach.call(l.length ? l : [l], destroy), l;
          }, k.update = function (l) {
            return l && Array.prototype.forEach.call(l.length ? l : [l], update), l;
          }), s.default = k, l.exports = s.default;
        }, void 0 === (v = "function" == typeof c ? c.apply(s, m) : c) || (l.exports = v);
      },
      2703: function _(l, s) {
        var c;
        !function () {
          "use strict";

          var m = {}.hasOwnProperty;

          function classNames() {
            for (var l = [], s = 0; s < arguments.length; s++) {
              var c = arguments[s];

              if (c) {
                var v = typeof c;
                if ("string" === v || "number" === v) l.push(c);else if (Array.isArray(c)) {
                  if (c.length) {
                    var _ = classNames.apply(null, c);

                    _ && l.push(_);
                  }
                } else if ("object" === v) if (c.toString === Object.prototype.toString) for (var k in c) {
                  m.call(c, k) && c[k] && l.push(k);
                } else l.push(c.toString());
              }
            }

            return l.join(" ");
          }

          l.exports ? (classNames.default = classNames, l.exports = classNames) : void 0 === (c = function () {
            return classNames;
          }.apply(s, [])) || (l.exports = c);
        }();
      },
      7270: function _(l, s) {
        Object.defineProperty(s, "__esModule", {
          value: !0
        });

        var c = {
          grad: .9,
          turn: 360,
          rad: 360 / (2 * Math.PI)
        },
            t = function t(l) {
          return "string" == typeof l ? l.length > 0 : "number" == typeof l;
        },
            n = function n(l, s, c) {
          return void 0 === s && (s = 0), void 0 === c && (c = Math.pow(10, s)), Math.round(c * l) / c + 0;
        },
            e = function e(l, s, c) {
          return void 0 === s && (s = 0), void 0 === c && (c = 1), l > c ? c : l > s ? l : s;
        },
            u = function u(l) {
          return (l = isFinite(l) ? l % 360 : 0) > 0 ? l : l + 360;
        },
            o = function o(l) {
          return {
            r: e(l.r, 0, 255),
            g: e(l.g, 0, 255),
            b: e(l.b, 0, 255),
            a: e(l.a)
          };
        },
            a = function a(l) {
          return {
            r: n(l.r),
            g: n(l.g),
            b: n(l.b),
            a: n(l.a, 3)
          };
        },
            m = /^#([0-9a-f]{3,8})$/i,
            i = function i(l) {
          var s = l.toString(16);
          return s.length < 2 ? "0" + s : s;
        },
            h = function h(l) {
          var s = l.r,
              c = l.g,
              m = l.b,
              v = l.a,
              _ = Math.max(s, c, m),
              k = _ - Math.min(s, c, m),
              y = k ? _ === s ? (c - m) / k : _ === c ? 2 + (m - s) / k : 4 + (s - c) / k : 0;

          return {
            h: 60 * (y < 0 ? y + 6 : y),
            s: _ ? k / _ * 100 : 0,
            v: _ / 255 * 100,
            a: v
          };
        },
            b = function b(l) {
          var s = l.h,
              c = l.s,
              m = l.v,
              v = l.a;
          s = s / 360 * 6, c /= 100, m /= 100;

          var _ = Math.floor(s),
              k = m * (1 - c),
              y = m * (1 - (s - _) * c),
              E = m * (1 - (1 - s + _) * c),
              w = _ % 6;

          return {
            r: 255 * [m, y, k, k, E, m][w],
            g: 255 * [E, m, m, y, k, k][w],
            b: 255 * [k, k, E, m, m, y][w],
            a: v
          };
        },
            d = function d(l) {
          return {
            h: u(l.h),
            s: e(l.s, 0, 100),
            l: e(l.l, 0, 100),
            a: e(l.a)
          };
        },
            g = function g(l) {
          return {
            h: n(l.h),
            s: n(l.s),
            l: n(l.l),
            a: n(l.a, 3)
          };
        },
            f = function f(l) {
          return b((c = (s = l).s, {
            h: s.h,
            s: (c *= ((m = s.l) < 50 ? m : 100 - m) / 100) > 0 ? 2 * c / (m + c) * 100 : 0,
            v: m + c,
            a: s.a
          }));
          var s, c, m;
        },
            p = function p(l) {
          return {
            h: (s = h(l)).h,
            s: (v = (200 - (c = s.s)) * (m = s.v) / 100) > 0 && v < 200 ? c * m / 100 / (v <= 100 ? v : 200 - v) * 100 : 0,
            l: v / 2,
            a: s.a
          };
          var s, c, m, v;
        },
            v = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,
            _ = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,
            k = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,
            y = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i,
            E = {
          string: [[function (l) {
            var s = m.exec(l);
            return s ? (l = s[1]).length <= 4 ? {
              r: parseInt(l[0] + l[0], 16),
              g: parseInt(l[1] + l[1], 16),
              b: parseInt(l[2] + l[2], 16),
              a: 4 === l.length ? n(parseInt(l[3] + l[3], 16) / 255, 2) : 1
            } : 6 === l.length || 8 === l.length ? {
              r: parseInt(l.substr(0, 2), 16),
              g: parseInt(l.substr(2, 2), 16),
              b: parseInt(l.substr(4, 2), 16),
              a: 8 === l.length ? n(parseInt(l.substr(6, 2), 16) / 255, 2) : 1
            } : null : null;
          }, "hex"], [function (l) {
            var s = k.exec(l) || y.exec(l);
            return s ? s[2] !== s[4] || s[4] !== s[6] ? null : o({
              r: Number(s[1]) / (s[2] ? 100 / 255 : 1),
              g: Number(s[3]) / (s[4] ? 100 / 255 : 1),
              b: Number(s[5]) / (s[6] ? 100 / 255 : 1),
              a: void 0 === s[7] ? 1 : Number(s[7]) / (s[8] ? 100 : 1)
            }) : null;
          }, "rgb"], [function (l) {
            var s = v.exec(l) || _.exec(l);

            if (!s) return null;
            var m,
                k,
                y = d({
              h: (m = s[1], k = s[2], void 0 === k && (k = "deg"), Number(m) * (c[k] || 1)),
              s: Number(s[3]),
              l: Number(s[4]),
              a: void 0 === s[5] ? 1 : Number(s[5]) / (s[6] ? 100 : 1)
            });
            return f(y);
          }, "hsl"]],
          object: [[function (l) {
            var s = l.r,
                c = l.g,
                m = l.b,
                v = l.a,
                _ = void 0 === v ? 1 : v;

            return t(s) && t(c) && t(m) ? o({
              r: Number(s),
              g: Number(c),
              b: Number(m),
              a: Number(_)
            }) : null;
          }, "rgb"], [function (l) {
            var s = l.h,
                c = l.s,
                m = l.l,
                v = l.a,
                _ = void 0 === v ? 1 : v;

            if (!t(s) || !t(c) || !t(m)) return null;
            var k = d({
              h: Number(s),
              s: Number(c),
              l: Number(m),
              a: Number(_)
            });
            return f(k);
          }, "hsl"], [function (l) {
            var s = l.h,
                c = l.s,
                m = l.v,
                v = l.a,
                _ = void 0 === v ? 1 : v;

            if (!t(s) || !t(c) || !t(m)) return null;

            var k = function (l) {
              return {
                h: u(l.h),
                s: e(l.s, 0, 100),
                v: e(l.v, 0, 100),
                a: e(l.a)
              };
            }({
              h: Number(s),
              s: Number(c),
              v: Number(m),
              a: Number(_)
            });

            return b(k);
          }, "hsv"]]
        },
            N = function N(l, s) {
          for (var c = 0; c < s.length; c++) {
            var m = s[c][0](l);
            if (m) return [m, s[c][1]];
          }

          return [null, void 0];
        },
            x = function x(l) {
          return "string" == typeof l ? N(l.trim(), E.string) : "object" == typeof l && null !== l ? N(l, E.object) : [null, void 0];
        },
            M = function M(l, s) {
          var c = p(l);
          return {
            h: c.h,
            s: e(c.s + 100 * s, 0, 100),
            l: c.l,
            a: c.a
          };
        },
            I = function I(l) {
          return (299 * l.r + 587 * l.g + 114 * l.b) / 1e3 / 255;
        },
            H = function H(l, s) {
          var c = p(l);
          return {
            h: c.h,
            s: c.s,
            l: e(c.l + 100 * s, 0, 100),
            a: c.a
          };
        },
            w = function () {
          function r(l) {
            this.parsed = x(l)[0], this.rgba = this.parsed || {
              r: 0,
              g: 0,
              b: 0,
              a: 1
            };
          }

          return r.prototype.isValid = function () {
            return null !== this.parsed;
          }, r.prototype.brightness = function () {
            return n(I(this.rgba), 2);
          }, r.prototype.isDark = function () {
            return I(this.rgba) < .5;
          }, r.prototype.isLight = function () {
            return I(this.rgba) >= .5;
          }, r.prototype.toHex = function () {
            return s = (l = a(this.rgba)).r, c = l.g, m = l.b, _ = (v = l.a) < 1 ? i(n(255 * v)) : "", "#" + i(s) + i(c) + i(m) + _;

            var l, s, c, m, v, _;
          }, r.prototype.toRgb = function () {
            return a(this.rgba);
          }, r.prototype.toRgbString = function () {
            return s = (l = a(this.rgba)).r, c = l.g, m = l.b, (v = l.a) < 1 ? "rgba(" + s + ", " + c + ", " + m + ", " + v + ")" : "rgb(" + s + ", " + c + ", " + m + ")";
            var l, s, c, m, v;
          }, r.prototype.toHsl = function () {
            return g(p(this.rgba));
          }, r.prototype.toHslString = function () {
            return s = (l = g(p(this.rgba))).h, c = l.s, m = l.l, (v = l.a) < 1 ? "hsla(" + s + ", " + c + "%, " + m + "%, " + v + ")" : "hsl(" + s + ", " + c + "%, " + m + "%)";
            var l, s, c, m, v;
          }, r.prototype.toHsv = function () {
            return l = h(this.rgba), {
              h: n(l.h),
              s: n(l.s),
              v: n(l.v),
              a: n(l.a, 3)
            };
            var l;
          }, r.prototype.invert = function () {
            return j({
              r: 255 - (l = this.rgba).r,
              g: 255 - l.g,
              b: 255 - l.b,
              a: l.a
            });
            var l;
          }, r.prototype.saturate = function (l) {
            return void 0 === l && (l = .1), j(M(this.rgba, l));
          }, r.prototype.desaturate = function (l) {
            return void 0 === l && (l = .1), j(M(this.rgba, -l));
          }, r.prototype.grayscale = function () {
            return j(M(this.rgba, -1));
          }, r.prototype.lighten = function (l) {
            return void 0 === l && (l = .1), j(H(this.rgba, l));
          }, r.prototype.darken = function (l) {
            return void 0 === l && (l = .1), j(H(this.rgba, -l));
          }, r.prototype.rotate = function (l) {
            return void 0 === l && (l = 15), this.hue(this.hue() + l);
          }, r.prototype.alpha = function (l) {
            return "number" == typeof l ? j({
              r: (s = this.rgba).r,
              g: s.g,
              b: s.b,
              a: l
            }) : n(this.rgba.a, 3);
            var s;
          }, r.prototype.hue = function (l) {
            var s = p(this.rgba);
            return "number" == typeof l ? j({
              h: l,
              s: s.s,
              l: s.l,
              a: s.a
            }) : n(s.h);
          }, r.prototype.isEqual = function (l) {
            return this.toHex() === j(l).toHex();
          }, r;
        }(),
            j = function j(l) {
          return l instanceof w ? l : new w(l);
        },
            C = [];

        s.Colord = w, s.colord = j, s.extend = function (l) {
          l.forEach(function (l) {
            C.indexOf(l) < 0 && (l(w, E), C.push(l));
          });
        }, s.getFormat = function (l) {
          return x(l)[1];
        }, s.random = function () {
          return new w({
            r: 255 * Math.random(),
            g: 255 * Math.random(),
            b: 255 * Math.random()
          });
        };
      },
      2079: function _(l) {
        var o = function o(l) {
          var s = l / 255;
          return s < .04045 ? s / 12.92 : Math.pow((s + .055) / 1.055, 2.4);
        },
            t = function t(l) {
          return .2126 * o(l.r) + .7152 * o(l.g) + .0722 * o(l.b);
        };

        l.exports = function (l) {
          l.prototype.luminance = function () {
            return l = t(this.rgba), void 0 === (s = 2) && (s = 0), void 0 === c && (c = Math.pow(10, s)), Math.round(c * l) / c + 0;
            var l, s, c;
          }, l.prototype.contrast = function (s) {
            void 0 === s && (s = "#FFF");

            var c,
                m,
                v,
                _,
                k,
                y,
                E,
                w = s instanceof l ? s : new l(s);

            return _ = this.rgba, k = w.toRgb(), c = (y = t(_)) > (E = t(k)) ? (y + .05) / (E + .05) : (E + .05) / (y + .05), void 0 === (m = 2) && (m = 0), void 0 === v && (v = Math.pow(10, m)), Math.floor(v * c) / v + 0;
          }, l.prototype.isReadable = function (l, s) {
            return void 0 === l && (l = "#FFF"), void 0 === s && (s = {}), this.contrast(l) >= (k = void 0 === (_ = (c = s).size) ? "normal" : _, "AAA" === (v = void 0 === (m = c.level) ? "AA" : m) && "normal" === k ? 7 : "AA" === v && "large" === k ? 3 : 4.5);

            var c, m, v, _, k;
          };
        };
      },
      9785: function _(l) {
        l.exports = function (l, s) {
          var c = {
            white: "#ffffff",
            bisque: "#ffe4c4",
            blue: "#0000ff",
            cadetblue: "#5f9ea0",
            chartreuse: "#7fff00",
            chocolate: "#d2691e",
            coral: "#ff7f50",
            antiquewhite: "#faebd7",
            aqua: "#00ffff",
            azure: "#f0ffff",
            whitesmoke: "#f5f5f5",
            papayawhip: "#ffefd5",
            plum: "#dda0dd",
            blanchedalmond: "#ffebcd",
            black: "#000000",
            gold: "#ffd700",
            goldenrod: "#daa520",
            gainsboro: "#dcdcdc",
            cornsilk: "#fff8dc",
            cornflowerblue: "#6495ed",
            burlywood: "#deb887",
            aquamarine: "#7fffd4",
            beige: "#f5f5dc",
            crimson: "#dc143c",
            cyan: "#00ffff",
            darkblue: "#00008b",
            darkcyan: "#008b8b",
            darkgoldenrod: "#b8860b",
            darkkhaki: "#bdb76b",
            darkgray: "#a9a9a9",
            darkgreen: "#006400",
            darkgrey: "#a9a9a9",
            peachpuff: "#ffdab9",
            darkmagenta: "#8b008b",
            darkred: "#8b0000",
            darkorchid: "#9932cc",
            darkorange: "#ff8c00",
            darkslateblue: "#483d8b",
            gray: "#808080",
            darkslategray: "#2f4f4f",
            darkslategrey: "#2f4f4f",
            deeppink: "#ff1493",
            deepskyblue: "#00bfff",
            wheat: "#f5deb3",
            firebrick: "#b22222",
            floralwhite: "#fffaf0",
            ghostwhite: "#f8f8ff",
            darkviolet: "#9400d3",
            magenta: "#ff00ff",
            green: "#008000",
            dodgerblue: "#1e90ff",
            grey: "#808080",
            honeydew: "#f0fff0",
            hotpink: "#ff69b4",
            blueviolet: "#8a2be2",
            forestgreen: "#228b22",
            lawngreen: "#7cfc00",
            indianred: "#cd5c5c",
            indigo: "#4b0082",
            fuchsia: "#ff00ff",
            brown: "#a52a2a",
            maroon: "#800000",
            mediumblue: "#0000cd",
            lightcoral: "#f08080",
            darkturquoise: "#00ced1",
            lightcyan: "#e0ffff",
            ivory: "#fffff0",
            lightyellow: "#ffffe0",
            lightsalmon: "#ffa07a",
            lightseagreen: "#20b2aa",
            linen: "#faf0e6",
            mediumaquamarine: "#66cdaa",
            lemonchiffon: "#fffacd",
            lime: "#00ff00",
            khaki: "#f0e68c",
            mediumseagreen: "#3cb371",
            limegreen: "#32cd32",
            mediumspringgreen: "#00fa9a",
            lightskyblue: "#87cefa",
            lightblue: "#add8e6",
            midnightblue: "#191970",
            lightpink: "#ffb6c1",
            mistyrose: "#ffe4e1",
            moccasin: "#ffe4b5",
            mintcream: "#f5fffa",
            lightslategray: "#778899",
            lightslategrey: "#778899",
            navajowhite: "#ffdead",
            navy: "#000080",
            mediumvioletred: "#c71585",
            powderblue: "#b0e0e6",
            palegoldenrod: "#eee8aa",
            oldlace: "#fdf5e6",
            paleturquoise: "#afeeee",
            mediumturquoise: "#48d1cc",
            mediumorchid: "#ba55d3",
            rebeccapurple: "#663399",
            lightsteelblue: "#b0c4de",
            mediumslateblue: "#7b68ee",
            thistle: "#d8bfd8",
            tan: "#d2b48c",
            orchid: "#da70d6",
            mediumpurple: "#9370db",
            purple: "#800080",
            pink: "#ffc0cb",
            skyblue: "#87ceeb",
            springgreen: "#00ff7f",
            palegreen: "#98fb98",
            red: "#ff0000",
            yellow: "#ffff00",
            slateblue: "#6a5acd",
            lavenderblush: "#fff0f5",
            peru: "#cd853f",
            palevioletred: "#db7093",
            violet: "#ee82ee",
            teal: "#008080",
            slategray: "#708090",
            slategrey: "#708090",
            aliceblue: "#f0f8ff",
            darkseagreen: "#8fbc8f",
            darkolivegreen: "#556b2f",
            greenyellow: "#adff2f",
            seagreen: "#2e8b57",
            seashell: "#fff5ee",
            tomato: "#ff6347",
            silver: "#c0c0c0",
            sienna: "#a0522d",
            lavender: "#e6e6fa",
            lightgreen: "#90ee90",
            orange: "#ffa500",
            orangered: "#ff4500",
            steelblue: "#4682b4",
            royalblue: "#4169e1",
            turquoise: "#40e0d0",
            yellowgreen: "#9acd32",
            salmon: "#fa8072",
            saddlebrown: "#8b4513",
            sandybrown: "#f4a460",
            rosybrown: "#bc8f8f",
            darksalmon: "#e9967a",
            lightgoldenrodyellow: "#fafad2",
            snow: "#fffafa",
            lightgrey: "#d3d3d3",
            lightgray: "#d3d3d3",
            dimgray: "#696969",
            dimgrey: "#696969",
            olivedrab: "#6b8e23",
            olive: "#808000"
          },
              m = {};

          for (var v in c) {
            m[c[v]] = v;
          }

          var _ = {};
          l.prototype.toName = function (s) {
            if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
            var v,
                k,
                y = m[this.toHex()];
            if (y) return y;

            if (null == s ? void 0 : s.closest) {
              var E = this.toRgb(),
                  w = 1 / 0,
                  C = "black";
              if (!_.length) for (var S in c) {
                _[S] = new l(c[S]).toRgb();
              }

              for (var B in c) {
                var P = (v = E, k = _[B], Math.pow(v.r - k.r, 2) + Math.pow(v.g - k.g, 2) + Math.pow(v.b - k.b, 2));
                P < w && (w = P, C = B);
              }

              return C;
            }
          }, s.string.push([function (s) {
            var m = s.toLowerCase(),
                v = "transparent" === m ? "#0000" : c[m];
            return v ? new l(v).toRgb() : null;
          }, "name"]);
        };
      },
      3147: function _(l) {
        l.exports = function (l, s, c) {
          return ((c = window.getComputedStyle) ? c(l) : l.currentStyle)[s.replace(/-(\w)/gi, function (l, s) {
            return s.toUpperCase();
          })];
        };
      },
      3114: function _(l, s) {
        "use strict";

        function Diff() {}

        function buildValues(l, s, c, m, v) {
          for (var _ = 0, k = s.length, y = 0, E = 0; _ < k; _++) {
            var w = s[_];

            if (w.removed) {
              if (w.value = l.join(m.slice(E, E + w.count)), E += w.count, _ && s[_ - 1].added) {
                var C = s[_ - 1];
                s[_ - 1] = s[_], s[_] = C;
              }
            } else {
              if (!w.added && v) {
                var S = c.slice(y, y + w.count);
                S = S.map(function (l, s) {
                  var c = m[E + s];
                  return c.length > l.length ? c : l;
                }), w.value = l.join(S);
              } else w.value = l.join(c.slice(y, y + w.count));

              y += w.count, w.added || (E += w.count);
            }
          }

          var B = s[k - 1];
          return k > 1 && "string" == typeof B.value && (B.added || B.removed) && l.equals("", B.value) && (s[k - 2].value += B.value, s.pop()), s;
        }

        function clonePath(l) {
          return {
            newPos: l.newPos,
            components: l.components.slice(0)
          };
        }

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.default = Diff, Diff.prototype = {
          diff: function diff(l, s) {
            var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                m = c.callback;
            "function" == typeof c && (m = c, c = {}), this.options = c;
            var v = this;

            function done(l) {
              return m ? (setTimeout(function () {
                m(void 0, l);
              }, 0), !0) : l;
            }

            l = this.castInput(l), s = this.castInput(s), l = this.removeEmpty(this.tokenize(l));
            var _ = (s = this.removeEmpty(this.tokenize(s))).length,
                k = l.length,
                y = 1,
                E = _ + k,
                w = [{
              newPos: -1,
              components: []
            }],
                C = this.extractCommon(w[0], s, l, 0);
            if (w[0].newPos + 1 >= _ && C + 1 >= k) return done([{
              value: this.join(s),
              count: s.length
            }]);

            function execEditLength() {
              for (var c = -1 * y; c <= y; c += 2) {
                var m = void 0,
                    E = w[c - 1],
                    C = w[c + 1],
                    S = (C ? C.newPos : 0) - c;
                E && (w[c - 1] = void 0);
                var B = E && E.newPos + 1 < _,
                    P = C && 0 <= S && S < k;

                if (B || P) {
                  if (!B || P && E.newPos < C.newPos ? (m = clonePath(C), v.pushComponent(m.components, void 0, !0)) : ((m = E).newPos++, v.pushComponent(m.components, !0, void 0)), S = v.extractCommon(m, s, l, c), m.newPos + 1 >= _ && S + 1 >= k) return done(buildValues(v, m.components, s, l, v.useLongestToken));
                  w[c] = m;
                } else w[c] = void 0;
              }

              y++;
            }

            if (m) !function exec() {
              setTimeout(function () {
                if (y > E) return m();
                execEditLength() || exec();
              }, 0);
            }();else for (; y <= E;) {
              var S = execEditLength();
              if (S) return S;
            }
          },
          pushComponent: function pushComponent(l, s, c) {
            var m = l[l.length - 1];
            m && m.added === s && m.removed === c ? l[l.length - 1] = {
              count: m.count + 1,
              added: s,
              removed: c
            } : l.push({
              count: 1,
              added: s,
              removed: c
            });
          },
          extractCommon: function extractCommon(l, s, c, m) {
            for (var v = s.length, _ = c.length, k = l.newPos, y = k - m, E = 0; k + 1 < v && y + 1 < _ && this.equals(s[k + 1], c[y + 1]);) {
              k++, y++, E++;
            }

            return E && l.components.push({
              count: E
            }), l.newPos = k, y;
          },
          equals: function equals(l, s) {
            return this.options.comparator ? this.options.comparator(l, s) : l === s || this.options.ignoreCase && l.toLowerCase() === s.toLowerCase();
          },
          removeEmpty: function removeEmpty(l) {
            for (var s = [], c = 0; c < l.length; c++) {
              l[c] && s.push(l[c]);
            }

            return s;
          },
          castInput: function castInput(l) {
            return l;
          },
          tokenize: function tokenize(l) {
            return l.split("");
          },
          join: function join(l) {
            return l.join("");
          }
        };
      },
      6727: function _(l, s, c) {
        "use strict";

        Object.defineProperty(s, "__esModule", {
          value: !0
        }), s.diffChars = function diffChars(l, s, c) {
          return m.diff(l, s, c);
        }, s.characterDiff = void 0;
        var m = new (function _interopRequireDefault(l) {
          return l && l.__esModule ? l : {
            default: l
          };
        }(c(3114)).default)();
        s.characterDiff = m;
      },
      5462: function _(l, s, c) {
        "use strict";

        var m = c(4930);

        l.exports = function scrollIntoView(l, s, c) {
          c = c || {}, 9 === s.nodeType && (s = m.getWindow(s));
          var v = c.allowHorizontalScroll,
              _ = c.onlyScrollIfNeeded,
              k = c.alignWithTop,
              y = c.alignWithLeft,
              E = c.offsetTop || 0,
              w = c.offsetLeft || 0,
              C = c.offsetBottom || 0,
              S = c.offsetRight || 0;
          v = void 0 === v || v;
          var B = m.isWindow(s),
              P = m.offset(l),
              O = m.outerHeight(l),
              L = m.outerWidth(l),
              V = void 0,
              R = void 0,
              A = void 0,
              z = void 0,
              D = void 0,
              F = void 0,
              G = void 0,
              U = void 0,
              W = void 0,
              K = void 0;
          B ? (G = s, K = m.height(G), W = m.width(G), U = {
            left: m.scrollLeft(G),
            top: m.scrollTop(G)
          }, D = {
            left: P.left - U.left - w,
            top: P.top - U.top - E
          }, F = {
            left: P.left + L - (U.left + W) + S,
            top: P.top + O - (U.top + K) + C
          }, z = U) : (V = m.offset(s), R = s.clientHeight, A = s.clientWidth, z = {
            left: s.scrollLeft,
            top: s.scrollTop
          }, D = {
            left: P.left - (V.left + (parseFloat(m.css(s, "borderLeftWidth")) || 0)) - w,
            top: P.top - (V.top + (parseFloat(m.css(s, "borderTopWidth")) || 0)) - E
          }, F = {
            left: P.left + L - (V.left + A + (parseFloat(m.css(s, "borderRightWidth")) || 0)) + S,
            top: P.top + O - (V.top + R + (parseFloat(m.css(s, "borderBottomWidth")) || 0)) + C
          }), D.top < 0 || F.top > 0 ? !0 === k ? m.scrollTop(s, z.top + D.top) : !1 === k ? m.scrollTop(s, z.top + F.top) : D.top < 0 ? m.scrollTop(s, z.top + D.top) : m.scrollTop(s, z.top + F.top) : _ || ((k = void 0 === k || !!k) ? m.scrollTop(s, z.top + D.top) : m.scrollTop(s, z.top + F.top)), v && (D.left < 0 || F.left > 0 ? !0 === y ? m.scrollLeft(s, z.left + D.left) : !1 === y ? m.scrollLeft(s, z.left + F.left) : D.left < 0 ? m.scrollLeft(s, z.left + D.left) : m.scrollLeft(s, z.left + F.left) : _ || ((y = void 0 === y || !!y) ? m.scrollLeft(s, z.left + D.left) : m.scrollLeft(s, z.left + F.left)));
        };
      },
      3745: function _(l, s, c) {
        "use strict";

        l.exports = c(5462);
      },
      4930: function _(l) {
        "use strict";

        var s = Object.assign || function (l) {
          for (var s = 1; s < arguments.length; s++) {
            var c = arguments[s];

            for (var m in c) {
              Object.prototype.hasOwnProperty.call(c, m) && (l[m] = c[m]);
            }
          }

          return l;
        },
            c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (l) {
          return typeof l;
        } : function (l) {
          return l && "function" == typeof Symbol && l.constructor === Symbol ? "symbol" : typeof l;
        };

        function getScroll(l, s) {
          var c = l["page" + (s ? "Y" : "X") + "Offset"],
              m = "scroll" + (s ? "Top" : "Left");

          if ("number" != typeof c) {
            var v = l.document;
            "number" != typeof (c = v.documentElement[m]) && (c = v.body[m]);
          }

          return c;
        }

        function getScrollLeft(l) {
          return getScroll(l);
        }

        function getScrollTop(l) {
          return getScroll(l, !0);
        }

        function getOffset(l) {
          var s = function getClientPosition(l) {
            var s,
                c = void 0,
                m = void 0,
                v = l.ownerDocument,
                _ = v.body,
                k = v && v.documentElement;
            return c = (s = l.getBoundingClientRect()).left, m = s.top, {
              left: c -= k.clientLeft || _.clientLeft || 0,
              top: m -= k.clientTop || _.clientTop || 0
            };
          }(l),
              c = l.ownerDocument,
              m = c.defaultView || c.parentWindow;

          return s.left += getScrollLeft(m), s.top += getScrollTop(m), s;
        }

        var m = new RegExp("^(" + /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source + ")(?!px)[a-z%]+$", "i"),
            v = /^(top|right|bottom|left)$/;

        var _ = void 0;

        function each(l, s) {
          for (var c = 0; c < l.length; c++) {
            s(l[c]);
          }
        }

        function isBorderBoxFn(l) {
          return "border-box" === _(l, "boxSizing");
        }

        "undefined" != typeof window && (_ = window.getComputedStyle ? function _getComputedStyle(l, s, c) {
          var m = "",
              v = l.ownerDocument,
              _ = c || v.defaultView.getComputedStyle(l, null);

          return _ && (m = _.getPropertyValue(s) || _[s]), m;
        } : function _getComputedStyleIE(l, s) {
          var c = l.currentStyle && l.currentStyle[s];

          if (m.test(c) && !v.test(s)) {
            var _ = l.style,
                k = _.left,
                y = l.runtimeStyle.left;
            l.runtimeStyle.left = l.currentStyle.left, _.left = "fontSize" === s ? "1em" : c || 0, c = _.pixelLeft + "px", _.left = k, l.runtimeStyle.left = y;
          }

          return "" === c ? "auto" : c;
        });
        var k = ["margin", "border", "padding"];

        function swap(l, s, c) {
          var m = {},
              v = l.style,
              _ = void 0;

          for (_ in s) {
            s.hasOwnProperty(_) && (m[_] = v[_], v[_] = s[_]);
          }

          for (_ in c.call(l), s) {
            s.hasOwnProperty(_) && (v[_] = m[_]);
          }
        }

        function getPBMWidth(l, s, c) {
          var m = 0,
              v = void 0,
              k = void 0,
              y = void 0;

          for (k = 0; k < s.length; k++) {
            if (v = s[k]) for (y = 0; y < c.length; y++) {
              var E = void 0;
              E = "border" === v ? v + c[y] + "Width" : v + c[y], m += parseFloat(_(l, E)) || 0;
            }
          }

          return m;
        }

        function isWindow(l) {
          return null != l && l == l.window;
        }

        var y = {};

        function getWH(l, s, c) {
          if (isWindow(l)) return "width" === s ? y.viewportWidth(l) : y.viewportHeight(l);
          if (9 === l.nodeType) return "width" === s ? y.docWidth(l) : y.docHeight(l);
          var m = "width" === s ? ["Left", "Right"] : ["Top", "Bottom"],
              v = "width" === s ? l.offsetWidth : l.offsetHeight,
              E = (_(l), isBorderBoxFn(l)),
              w = 0;
          (null == v || v <= 0) && (v = void 0, (null == (w = _(l, s)) || Number(w) < 0) && (w = l.style[s] || 0), w = parseFloat(w) || 0), void 0 === c && (c = E ? 1 : -1);
          var C = void 0 !== v || E,
              S = v || w;
          if (-1 === c) return C ? S - getPBMWidth(l, ["border", "padding"], m) : w;

          if (C) {
            var B = 2 === c ? -getPBMWidth(l, ["border"], m) : getPBMWidth(l, ["margin"], m);
            return S + (1 === c ? 0 : B);
          }

          return w + getPBMWidth(l, k.slice(c), m);
        }

        each(["Width", "Height"], function (l) {
          y["doc" + l] = function (s) {
            var c = s.document;
            return Math.max(c.documentElement["scroll" + l], c.body["scroll" + l], y["viewport" + l](c));
          }, y["viewport" + l] = function (s) {
            var c = "client" + l,
                m = s.document,
                v = m.body,
                _ = m.documentElement[c];
            return "CSS1Compat" === m.compatMode && _ || v && v[c] || _;
          };
        });
        var E = {
          position: "absolute",
          visibility: "hidden",
          display: "block"
        };

        function getWHIgnoreDisplay(l) {
          var s = void 0,
              c = arguments;
          return 0 !== l.offsetWidth ? s = getWH.apply(void 0, c) : swap(l, E, function () {
            s = getWH.apply(void 0, c);
          }), s;
        }

        function css(l, s, m) {
          var v = m;
          if ("object" !== (void 0 === s ? "undefined" : c(s))) return void 0 !== v ? ("number" == typeof v && (v += "px"), void (l.style[s] = v)) : _(l, s);

          for (var k in s) {
            s.hasOwnProperty(k) && css(l, k, s[k]);
          }
        }

        each(["width", "height"], function (l) {
          var s = l.charAt(0).toUpperCase() + l.slice(1);

          y["outer" + s] = function (s, c) {
            return s && getWHIgnoreDisplay(s, l, c ? 0 : 1);
          };

          var c = "width" === l ? ["Left", "Right"] : ["Top", "Bottom"];

          y[l] = function (s, m) {
            if (void 0 === m) return s && getWHIgnoreDisplay(s, l, -1);

            if (s) {
              _(s);

              return isBorderBoxFn(s) && (m += getPBMWidth(s, ["padding", "border"], c)), css(s, l, m);
            }
          };
        }), l.exports = s({
          getWindow: function getWindow(l) {
            var s = l.ownerDocument || l;
            return s.defaultView || s.parentWindow;
          },
          offset: function offset(l, s) {
            if (void 0 === s) return getOffset(l);
            !function setOffset(l, s) {
              "static" === css(l, "position") && (l.style.position = "relative");

              var c = getOffset(l),
                  m = {},
                  v = void 0,
                  _ = void 0;

              for (_ in s) {
                s.hasOwnProperty(_) && (v = parseFloat(css(l, _)) || 0, m[_] = v + s[_] - c[_]);
              }

              css(l, m);
            }(l, s);
          },
          isWindow: isWindow,
          each: each,
          css: css,
          clone: function clone(l) {
            var s = {};

            for (var c in l) {
              l.hasOwnProperty(c) && (s[c] = l[c]);
            }

            if (l.overflow) for (var c in l) {
              l.hasOwnProperty(c) && (s.overflow[c] = l.overflow[c]);
            }
            return s;
          },
          scrollLeft: function scrollLeft(l, s) {
            if (isWindow(l)) {
              if (void 0 === s) return getScrollLeft(l);
              window.scrollTo(s, getScrollTop(l));
            } else {
              if (void 0 === s) return l.scrollLeft;
              l.scrollLeft = s;
            }
          },
          scrollTop: function scrollTop(l, s) {
            if (isWindow(l)) {
              if (void 0 === s) return getScrollTop(l);
              window.scrollTo(getScrollLeft(l), s);
            } else {
              if (void 0 === s) return l.scrollTop;
              l.scrollTop = s;
            }
          },
          viewportWidth: 0,
          viewportHeight: 0
        }, y);
      },
      5153: function _(l) {
        "function" == typeof Object.create ? l.exports = function inherits(l, s) {
          s && (l.super_ = s, l.prototype = Object.create(s.prototype, {
            constructor: {
              value: l,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }));
        } : l.exports = function inherits(l, s) {
          if (s) {
            l.super_ = s;

            var TempCtor = function TempCtor() {};

            TempCtor.prototype = s.prototype, l.prototype = new TempCtor(), l.prototype.constructor = l;
          }
        };
      },
      7792: function _(l, s, c) {
        var m = c(3147);

        l.exports = function lineHeight(l) {
          var s = m(l, "line-height"),
              c = parseFloat(s, 10);

          if (s === c + "") {
            var v = l.style.lineHeight;
            l.style.lineHeight = s + "em", s = m(l, "line-height"), c = parseFloat(s, 10), v ? l.style.lineHeight = v : delete l.style.lineHeight;
          }

          if (-1 !== s.indexOf("pt") ? (c *= 4, c /= 3) : -1 !== s.indexOf("mm") ? (c *= 96, c /= 25.4) : -1 !== s.indexOf("cm") ? (c *= 96, c /= 2.54) : -1 !== s.indexOf("in") ? c *= 96 : -1 !== s.indexOf("pc") && (c *= 16), c = Math.round(c), "normal" === s) {
            var _ = l.nodeName,
                k = document.createElement(_);
            k.innerHTML = "&nbsp;", "TEXTAREA" === _.toUpperCase() && k.setAttribute("rows", "1");
            var y = m(l, "font-size");
            k.style.fontSize = y, k.style.padding = "0px", k.style.border = "0px";
            var E = document.body;
            E.appendChild(k), c = k.offsetHeight, E.removeChild(k);
          }

          return c;
        };
      },
      7320: function _(l, s, c) {
        l.exports = c(1045);
      },
      7230: function _(l) {
        "use strict";

        var s = !("undefined" == typeof window || !window.document || !window.document.createElement),
            c = {
          canUseDOM: s,
          canUseWorkers: "undefined" != typeof Worker,
          canUseEventListeners: s && !(!window.addEventListener && !window.attachEvent),
          canUseViewport: s && !!window.screen,
          isInWorker: !s
        };
        l.exports = c;
      },
      2907: function _(l) {
        var s,
            c,
            m,
            v,
            _,
            k,
            y,
            E,
            w,
            C,
            S,
            B,
            P,
            O,
            L,
            V = !1;

        function _populate() {
          if (!V) {
            V = !0;
            var l = navigator.userAgent,
                R = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(l),
                A = /(Mac OS X)|(Windows)|(Linux)/.exec(l);

            if (B = /\b(iPhone|iP[ao]d)/.exec(l), P = /\b(iP[ao]d)/.exec(l), C = /Android/i.exec(l), O = /FBAN\/\w+;/i.exec(l), L = /Mobile/i.exec(l), S = !!/Win64/.exec(l), R) {
              (s = R[1] ? parseFloat(R[1]) : R[5] ? parseFloat(R[5]) : NaN) && document && document.documentMode && (s = document.documentMode);
              var z = /(?:Trident\/(\d+.\d+))/.exec(l);
              k = z ? parseFloat(z[1]) + 4 : s, c = R[2] ? parseFloat(R[2]) : NaN, m = R[3] ? parseFloat(R[3]) : NaN, (v = R[4] ? parseFloat(R[4]) : NaN) ? (R = /(?:Chrome\/(\d+\.\d+))/.exec(l), _ = R && R[1] ? parseFloat(R[1]) : NaN) : _ = NaN;
            } else s = c = m = _ = v = NaN;

            if (A) {
              if (A[1]) {
                var D = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(l);
                y = !D || parseFloat(D[1].replace("_", "."));
              } else y = !1;

              E = !!A[2], w = !!A[3];
            } else y = E = w = !1;
          }
        }

        var R = {
          ie: function ie() {
            return _populate() || s;
          },
          ieCompatibilityMode: function ieCompatibilityMode() {
            return _populate() || k > s;
          },
          ie64: function ie64() {
            return R.ie() && S;
          },
          firefox: function firefox() {
            return _populate() || c;
          },
          opera: function opera() {
            return _populate() || m;
          },
          webkit: function webkit() {
            return _populate() || v;
          },
          safari: function safari() {
            return R.webkit();
          },
          chrome: function chrome() {
            return _populate() || _;
          },
          windows: function windows() {
            return _populate() || E;
          },
          osx: function osx() {
            return _populate() || y;
          },
          linux: function linux() {
            return _populate() || w;
          },
          iphone: function iphone() {
            return _populate() || B;
          },
          mobile: function mobile() {
            return _populate() || B || P || C || L;
          },
          nativeApp: function nativeApp() {
            return _populate() || O;
          },
          android: function android() {
            return _populate() || C;
          },
          ipad: function ipad() {
            return _populate() || P;
          }
        };
        l.exports = R;
      },
      4480: function _(l, s, c) {
        "use strict";

        var m,
            v = c(7230);
        v.canUseDOM && (m = document.implementation && document.implementation.hasFeature && !0 !== document.implementation.hasFeature("", "")), l.exports = function isEventSupported(l, s) {
          if (!v.canUseDOM || s && !("addEventListener" in document)) return !1;

          var c = "on" + l,
              _ = (c in document);

          if (!_) {
            var k = document.createElement("div");
            k.setAttribute(c, "return;"), _ = "function" == typeof k[c];
          }

          return !_ && m && "wheel" === l && (_ = document.implementation.hasFeature("Events.wheel", "3.0")), _;
        };
      },
      1045: function _(l, s, c) {
        "use strict";

        var m = c(2907),
            v = c(4480);

        function normalizeWheel(l) {
          var s = 0,
              c = 0,
              m = 0,
              v = 0;
          return "detail" in l && (c = l.detail), "wheelDelta" in l && (c = -l.wheelDelta / 120), "wheelDeltaY" in l && (c = -l.wheelDeltaY / 120), "wheelDeltaX" in l && (s = -l.wheelDeltaX / 120), "axis" in l && l.axis === l.HORIZONTAL_AXIS && (s = c, c = 0), m = 10 * s, v = 10 * c, "deltaY" in l && (v = l.deltaY), "deltaX" in l && (m = l.deltaX), (m || v) && l.deltaMode && (1 == l.deltaMode ? (m *= 40, v *= 40) : (m *= 800, v *= 800)), m && !s && (s = m < 1 ? -1 : 1), v && !c && (c = v < 1 ? -1 : 1), {
            spinX: s,
            spinY: c,
            pixelX: m,
            pixelY: v
          };
        }

        normalizeWheel.getEventType = function () {
          return m.firefox() ? "DOMMouseScroll" : v("wheel") ? "wheel" : "mousewheel";
        }, l.exports = normalizeWheel;
      },
      3433: function _(l, s, c) {
        "use strict";

        var m = c(6642);

        function emptyFunction() {}

        function emptyFunctionWithReset() {}

        emptyFunctionWithReset.resetWarningCache = emptyFunction, l.exports = function () {
          function shim(l, s, c, v, _, k) {
            if (k !== m) {
              var y = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw y.name = "Invariant Violation", y;
            }
          }

          function getShim() {
            return shim;
          }

          shim.isRequired = shim;
          var l = {
            array: shim,
            bigint: shim,
            bool: shim,
            func: shim,
            number: shim,
            object: shim,
            string: shim,
            symbol: shim,
            any: shim,
            arrayOf: getShim,
            element: shim,
            elementType: shim,
            instanceOf: getShim,
            node: shim,
            objectOf: getShim,
            oneOf: getShim,
            oneOfType: getShim,
            shape: getShim,
            exact: getShim,
            checkPropTypes: emptyFunctionWithReset,
            resetWarningCache: emptyFunction
          };
          return l.PropTypes = l, l;
        };
      },
      3074: function _(l, s, c) {
        l.exports = c(3433)();
      },
      6642: function _(l) {
        "use strict";

        l.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      4428: function _(l, s, c) {
        "use strict";

        var m = c(755),
            v = c(9497),
            _ = c(7320);

        function _interopDefaultLegacy(l) {
          return l && "object" == typeof l && "default" in l ? l : {
            default: l
          };
        }

        var k = _interopDefaultLegacy(v),
            y = _interopDefaultLegacy(_);

        function getCropSize(l, s, c, m, v, _) {
          void 0 === _ && (_ = 0);
          var k = translateSize(l, s, _),
              y = k.width,
              E = k.height,
              w = Math.min(y, c),
              C = Math.min(E, m);
          return w > C * v ? {
            width: C * v,
            height: C
          } : {
            width: w,
            height: w / v
          };
        }

        function restrictPosition(l, s, c, m, v) {
          void 0 === v && (v = 0);

          var _ = translateSize(s.width, s.height, v),
              k = _.width,
              y = _.height;

          return {
            x: restrictPositionCoord(l.x, k, c.width, m),
            y: restrictPositionCoord(l.y, y, c.height, m)
          };
        }

        function restrictPositionCoord(l, s, c, m) {
          var v = s * m / 2 - c / 2;
          return Math.min(v, Math.max(l, -v));
        }

        function getDistanceBetweenPoints(l, s) {
          return Math.sqrt(Math.pow(l.y - s.y, 2) + Math.pow(l.x - s.x, 2));
        }

        function getRotationBetweenPoints(l, s) {
          return 180 * Math.atan2(s.y - l.y, s.x - l.x) / Math.PI;
        }

        function computeCroppedArea(l, s, c, v, _, k, y) {
          void 0 === k && (k = 0), void 0 === y && (y = !0);
          var E = y && 0 === k ? limitArea : noOp,
              w = {
            x: E(100, ((s.width - c.width / _) / 2 - l.x / _) / s.width * 100),
            y: E(100, ((s.height - c.height / _) / 2 - l.y / _) / s.height * 100),
            width: E(100, c.width / s.width * 100 / _),
            height: E(100, c.height / s.height * 100 / _)
          },
              C = Math.round(E(s.naturalWidth, w.width * s.naturalWidth / 100)),
              S = Math.round(E(s.naturalHeight, w.height * s.naturalHeight / 100)),
              B = s.naturalWidth >= s.naturalHeight * v ? {
            width: Math.round(S * v),
            height: S
          } : {
            width: C,
            height: Math.round(C / v)
          };
          return {
            croppedAreaPercentages: w,
            croppedAreaPixels: m.__assign(m.__assign({}, B), {
              x: Math.round(E(s.naturalWidth - B.width, w.x * s.naturalWidth / 100)),
              y: Math.round(E(s.naturalHeight - B.height, w.y * s.naturalHeight / 100))
            })
          };
        }

        function limitArea(l, s) {
          return Math.min(l, Math.max(0, s));
        }

        function noOp(l, s) {
          return s;
        }

        function getInitialCropFromCroppedAreaPixels(l, s, c) {
          var m = s.width / s.naturalWidth,
              v = function getZoomFromCroppedAreaPixels(l, s, c) {
            var m = s.width / s.naturalWidth;
            if (c) return c.height > c.width ? c.height / m / l.height : c.width / m / l.width;
            var v = l.width / l.height;
            return s.naturalWidth >= s.naturalHeight * v ? s.naturalHeight / l.height : s.naturalWidth / l.width;
          }(l, s, c),
              _ = m * v;

          return {
            crop: {
              x: ((s.naturalWidth - l.width) / 2 - l.x) * _,
              y: ((s.naturalHeight - l.height) / 2 - l.y) * _
            },
            zoom: v
          };
        }

        function getCenter(l, s) {
          return {
            x: (s.x + l.x) / 2,
            y: (s.y + l.y) / 2
          };
        }

        function rotateAroundMidPoint(l, s, c, m, v) {
          var _ = Math.cos,
              k = Math.sin,
              y = v * Math.PI / 180;
          return [(l - c) * _(y) - (s - m) * k(y) + c, (l - c) * k(y) + (s - m) * _(y) + m];
        }

        function translateSize(l, s, c) {
          var m = l / 2,
              v = s / 2,
              _ = [rotateAroundMidPoint(0, 0, m, v, c), rotateAroundMidPoint(l, 0, m, v, c), rotateAroundMidPoint(l, s, m, v, c), rotateAroundMidPoint(0, s, m, v, c)],
              k = Math.min.apply(Math, _.map(function (l) {
            return l[0];
          })),
              y = Math.max.apply(Math, _.map(function (l) {
            return l[0];
          })),
              E = Math.min.apply(Math, _.map(function (l) {
            return l[1];
          }));
          return {
            width: y - k,
            height: Math.max.apply(Math, _.map(function (l) {
              return l[1];
            })) - E
          };
        }

        function classNames() {
          for (var l = [], s = 0; s < arguments.length; s++) {
            l[s] = arguments[s];
          }

          return l.filter(function (l) {
            return "string" == typeof l && l.length > 0;
          }).join(" ").trim();
        }

        var E = function (l) {
          function Cropper() {
            var s = null !== l && l.apply(this, arguments) || this;
            return s.imageRef = null, s.videoRef = null, s.containerRef = null, s.styleRef = null, s.containerRect = null, s.mediaSize = {
              width: 0,
              height: 0,
              naturalWidth: 0,
              naturalHeight: 0
            }, s.dragStartPosition = {
              x: 0,
              y: 0
            }, s.dragStartCrop = {
              x: 0,
              y: 0
            }, s.lastPinchDistance = 0, s.lastPinchRotation = 0, s.rafDragTimeout = null, s.rafPinchTimeout = null, s.wheelTimer = null, s.state = {
              cropSize: null,
              hasWheelJustStarted: !1
            }, s.preventZoomSafari = function (l) {
              return l.preventDefault();
            }, s.cleanEvents = function () {
              document.removeEventListener("mousemove", s.onMouseMove), document.removeEventListener("mouseup", s.onDragStopped), document.removeEventListener("touchmove", s.onTouchMove), document.removeEventListener("touchend", s.onDragStopped);
            }, s.clearScrollEvent = function () {
              s.containerRef && s.containerRef.removeEventListener("wheel", s.onWheel), s.wheelTimer && clearTimeout(s.wheelTimer);
            }, s.onMediaLoad = function () {
              s.computeSizes(), s.emitCropData(), s.setInitialCrop(), s.props.onMediaLoaded && s.props.onMediaLoaded(s.mediaSize);
            }, s.setInitialCrop = function () {
              var l = s.props,
                  c = l.initialCroppedAreaPixels,
                  m = l.cropSize;

              if (c) {
                var v = getInitialCropFromCroppedAreaPixels(c, s.mediaSize, m),
                    _ = v.crop,
                    k = v.zoom;
                s.props.onCropChange(_), s.props.onZoomChange && s.props.onZoomChange(k);
              }
            }, s.computeSizes = function () {
              var l,
                  c,
                  m,
                  v,
                  _,
                  k,
                  y = s.imageRef || s.videoRef;

              if (y && s.containerRef) {
                s.containerRect = s.containerRef.getBoundingClientRect(), s.mediaSize = {
                  width: y.offsetWidth,
                  height: y.offsetHeight,
                  naturalWidth: (null === (l = s.imageRef) || void 0 === l ? void 0 : l.naturalWidth) || (null === (c = s.videoRef) || void 0 === c ? void 0 : c.videoWidth) || 0,
                  naturalHeight: (null === (m = s.imageRef) || void 0 === m ? void 0 : m.naturalHeight) || (null === (v = s.videoRef) || void 0 === v ? void 0 : v.videoHeight) || 0
                };
                var E = s.props.cropSize ? s.props.cropSize : getCropSize(y.offsetWidth, y.offsetHeight, s.containerRect.width, s.containerRect.height, s.props.aspect, s.props.rotation);
                (null === (_ = s.state.cropSize) || void 0 === _ ? void 0 : _.height) === E.height && (null === (k = s.state.cropSize) || void 0 === k ? void 0 : k.width) === E.width || s.props.onCropSizeChange && s.props.onCropSizeChange(E), s.setState({
                  cropSize: E
                }, s.recomputeCropPosition);
              }
            }, s.onMouseDown = function (l) {
              l.preventDefault(), document.addEventListener("mousemove", s.onMouseMove), document.addEventListener("mouseup", s.onDragStopped), s.onDragStart(Cropper.getMousePoint(l));
            }, s.onMouseMove = function (l) {
              return s.onDrag(Cropper.getMousePoint(l));
            }, s.onTouchStart = function (l) {
              document.addEventListener("touchmove", s.onTouchMove, {
                passive: !1
              }), document.addEventListener("touchend", s.onDragStopped), 2 === l.touches.length ? s.onPinchStart(l) : 1 === l.touches.length && s.onDragStart(Cropper.getTouchPoint(l.touches[0]));
            }, s.onTouchMove = function (l) {
              l.preventDefault(), 2 === l.touches.length ? s.onPinchMove(l) : 1 === l.touches.length && s.onDrag(Cropper.getTouchPoint(l.touches[0]));
            }, s.onDragStart = function (l) {
              var c,
                  v,
                  _ = l.x,
                  k = l.y;
              s.dragStartPosition = {
                x: _,
                y: k
              }, s.dragStartCrop = m.__assign({}, s.props.crop), null === (v = (c = s.props).onInteractionStart) || void 0 === v || v.call(c);
            }, s.onDrag = function (l) {
              var c = l.x,
                  m = l.y;
              s.rafDragTimeout && window.cancelAnimationFrame(s.rafDragTimeout), s.rafDragTimeout = window.requestAnimationFrame(function () {
                if (s.state.cropSize && void 0 !== c && void 0 !== m) {
                  var l = c - s.dragStartPosition.x,
                      v = m - s.dragStartPosition.y,
                      _ = {
                    x: s.dragStartCrop.x + l,
                    y: s.dragStartCrop.y + v
                  },
                      k = s.props.restrictPosition ? restrictPosition(_, s.mediaSize, s.state.cropSize, s.props.zoom, s.props.rotation) : _;
                  s.props.onCropChange(k);
                }
              });
            }, s.onDragStopped = function () {
              var l, c;
              s.cleanEvents(), s.emitCropData(), null === (c = (l = s.props).onInteractionEnd) || void 0 === c || c.call(l);
            }, s.onWheel = function (l) {
              l.preventDefault();
              var c = Cropper.getMousePoint(l),
                  m = y.default(l).pixelY,
                  v = s.props.zoom - m * s.props.zoomSpeed / 200;
              s.setNewZoom(v, c), s.state.hasWheelJustStarted || s.setState({
                hasWheelJustStarted: !0
              }, function () {
                var l, c;
                return null === (c = (l = s.props).onInteractionStart) || void 0 === c ? void 0 : c.call(l);
              }), s.wheelTimer && clearTimeout(s.wheelTimer), s.wheelTimer = window.setTimeout(function () {
                return s.setState({
                  hasWheelJustStarted: !1
                }, function () {
                  var l, c;
                  return null === (c = (l = s.props).onInteractionEnd) || void 0 === c ? void 0 : c.call(l);
                });
              }, 250);
            }, s.getPointOnContainer = function (l) {
              var c = l.x,
                  m = l.y;
              if (!s.containerRect) throw new Error("The Cropper is not mounted");
              return {
                x: s.containerRect.width / 2 - (c - s.containerRect.left),
                y: s.containerRect.height / 2 - (m - s.containerRect.top)
              };
            }, s.getPointOnMedia = function (l) {
              var c = l.x,
                  m = l.y,
                  v = s.props,
                  _ = v.crop,
                  k = v.zoom;
              return {
                x: (c + _.x) / k,
                y: (m + _.y) / k
              };
            }, s.setNewZoom = function (l, c) {
              if (s.state.cropSize && s.props.onZoomChange) {
                var m = s.getPointOnContainer(c),
                    v = s.getPointOnMedia(m),
                    _ = Math.min(s.props.maxZoom, Math.max(l, s.props.minZoom)),
                    k = {
                  x: v.x * _ - m.x,
                  y: v.y * _ - m.y
                },
                    y = s.props.restrictPosition ? restrictPosition(k, s.mediaSize, s.state.cropSize, _, s.props.rotation) : k;

                s.props.onCropChange(y), s.props.onZoomChange(_);
              }
            }, s.getCropData = function () {
              return s.state.cropSize ? computeCroppedArea(s.props.restrictPosition ? restrictPosition(s.props.crop, s.mediaSize, s.state.cropSize, s.props.zoom, s.props.rotation) : s.props.crop, s.mediaSize, s.state.cropSize, s.getAspect(), s.props.zoom, s.props.rotation, s.props.restrictPosition) : null;
            }, s.emitCropData = function () {
              var l = s.getCropData();

              if (l) {
                var c = l.croppedAreaPercentages,
                    m = l.croppedAreaPixels;
                s.props.onCropComplete && s.props.onCropComplete(c, m), s.props.onCropAreaChange && s.props.onCropAreaChange(c, m);
              }
            }, s.emitCropAreaChange = function () {
              var l = s.getCropData();

              if (l) {
                var c = l.croppedAreaPercentages,
                    m = l.croppedAreaPixels;
                s.props.onCropAreaChange && s.props.onCropAreaChange(c, m);
              }
            }, s.recomputeCropPosition = function () {
              if (s.state.cropSize) {
                var l = s.props.restrictPosition ? restrictPosition(s.props.crop, s.mediaSize, s.state.cropSize, s.props.zoom, s.props.rotation) : s.props.crop;
                s.props.onCropChange(l), s.emitCropData();
              }
            }, s;
          }

          return m.__extends(Cropper, l), Cropper.prototype.componentDidMount = function () {
            window.addEventListener("resize", this.computeSizes), this.containerRef && (this.props.zoomWithScroll && this.containerRef.addEventListener("wheel", this.onWheel, {
              passive: !1
            }), this.containerRef.addEventListener("gesturestart", this.preventZoomSafari), this.containerRef.addEventListener("gesturechange", this.preventZoomSafari)), this.props.disableAutomaticStylesInjection || (this.styleRef = document.createElement("style"), this.styleRef.setAttribute("type", "text/css"), this.styleRef.innerHTML = ".reactEasyCrop_Container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  user-select: none;\n  touch-action: none;\n  cursor: move;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.reactEasyCrop_Image,\n.reactEasyCrop_Video {\n  will-change: transform; /* this improves performances and prevent painting issues on iOS Chrome */\n}\n\n.reactEasyCrop_Contain {\n  max-width: 100%;\n  max-height: 100%;\n  margin: auto;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.reactEasyCrop_Cover_Horizontal {\n  width: 100%;\n  height: auto;\n}\n.reactEasyCrop_Cover_Vertical {\n  width: auto;\n  height: 100%;\n}\n\n.reactEasyCrop_CropArea {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-sizing: border-box;\n  box-shadow: 0 0 0 9999em;\n  color: rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n}\n\n.reactEasyCrop_CropAreaRound {\n  border-radius: 50%;\n}\n\n.reactEasyCrop_CropAreaGrid::before {\n  content: ' ';\n  box-sizing: border-box;\n  position: absolute;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  top: 0;\n  bottom: 0;\n  left: 33.33%;\n  right: 33.33%;\n  border-top: 0;\n  border-bottom: 0;\n}\n\n.reactEasyCrop_CropAreaGrid::after {\n  content: ' ';\n  box-sizing: border-box;\n  position: absolute;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  top: 33.33%;\n  bottom: 33.33%;\n  left: 0;\n  right: 0;\n  border-left: 0;\n  border-right: 0;\n}\n", document.head.appendChild(this.styleRef)), this.imageRef && this.imageRef.complete && this.onMediaLoad();
          }, Cropper.prototype.componentWillUnmount = function () {
            var l;
            window.removeEventListener("resize", this.computeSizes), this.containerRef && (this.containerRef.removeEventListener("gesturestart", this.preventZoomSafari), this.containerRef.removeEventListener("gesturechange", this.preventZoomSafari)), this.styleRef && (null === (l = this.styleRef.parentNode) || void 0 === l || l.removeChild(this.styleRef)), this.cleanEvents(), this.props.zoomWithScroll && this.clearScrollEvent();
          }, Cropper.prototype.componentDidUpdate = function (l) {
            var s, c, m, v, _, k, y, E, w;

            l.rotation !== this.props.rotation ? (this.computeSizes(), this.recomputeCropPosition()) : l.aspect !== this.props.aspect ? this.computeSizes() : l.zoom !== this.props.zoom ? this.recomputeCropPosition() : (null === (s = l.cropSize) || void 0 === s ? void 0 : s.height) !== (null === (c = this.props.cropSize) || void 0 === c ? void 0 : c.height) || (null === (m = l.cropSize) || void 0 === m ? void 0 : m.width) !== (null === (v = this.props.cropSize) || void 0 === v ? void 0 : v.width) ? this.computeSizes() : (null === (_ = l.crop) || void 0 === _ ? void 0 : _.x) === (null === (k = this.props.crop) || void 0 === k ? void 0 : k.x) && (null === (y = l.crop) || void 0 === y ? void 0 : y.y) === (null === (E = this.props.crop) || void 0 === E ? void 0 : E.y) || this.emitCropAreaChange(), l.zoomWithScroll !== this.props.zoomWithScroll && this.containerRef && (this.props.zoomWithScroll ? this.containerRef.addEventListener("wheel", this.onWheel, {
              passive: !1
            }) : this.clearScrollEvent()), l.video !== this.props.video && (null === (w = this.videoRef) || void 0 === w || w.load());
          }, Cropper.prototype.getAspect = function () {
            var l = this.props,
                s = l.cropSize,
                c = l.aspect;
            return s ? s.width / s.height : c;
          }, Cropper.prototype.onPinchStart = function (l) {
            var s = Cropper.getTouchPoint(l.touches[0]),
                c = Cropper.getTouchPoint(l.touches[1]);
            this.lastPinchDistance = getDistanceBetweenPoints(s, c), this.lastPinchRotation = getRotationBetweenPoints(s, c), this.onDragStart(getCenter(s, c));
          }, Cropper.prototype.onPinchMove = function (l) {
            var s = this,
                c = Cropper.getTouchPoint(l.touches[0]),
                m = Cropper.getTouchPoint(l.touches[1]),
                v = getCenter(c, m);
            this.onDrag(v), this.rafPinchTimeout && window.cancelAnimationFrame(this.rafPinchTimeout), this.rafPinchTimeout = window.requestAnimationFrame(function () {
              var l = getDistanceBetweenPoints(c, m),
                  _ = s.props.zoom * (l / s.lastPinchDistance);

              s.setNewZoom(_, v), s.lastPinchDistance = l;
              var k = getRotationBetweenPoints(c, m),
                  y = s.props.rotation + (k - s.lastPinchRotation);
              s.props.onRotationChange && s.props.onRotationChange(y), s.lastPinchRotation = k;
            });
          }, Cropper.prototype.render = function () {
            var l = this,
                s = this.props,
                c = s.image,
                v = s.video,
                _ = s.mediaProps,
                y = s.transform,
                E = s.crop,
                w = E.x,
                C = E.y,
                S = s.rotation,
                B = s.zoom,
                P = s.cropShape,
                O = s.showGrid,
                L = s.style,
                V = L.containerStyle,
                R = L.cropAreaStyle,
                A = L.mediaStyle,
                z = s.classes,
                D = z.containerClassName,
                F = z.cropAreaClassName,
                G = z.mediaClassName,
                U = s.objectFit;
            return k.default.createElement("div", {
              onMouseDown: this.onMouseDown,
              onTouchStart: this.onTouchStart,
              ref: function ref(s) {
                return l.containerRef = s;
              },
              "data-testid": "container",
              style: V,
              className: classNames("reactEasyCrop_Container", D)
            }, c ? k.default.createElement("img", m.__assign({
              alt: "",
              className: classNames("reactEasyCrop_Image", "contain" === U && "reactEasyCrop_Contain", "horizontal-cover" === U && "reactEasyCrop_Cover_Horizontal", "vertical-cover" === U && "reactEasyCrop_Cover_Vertical", G)
            }, _, {
              src: c,
              ref: function ref(s) {
                return l.imageRef = s;
              },
              style: m.__assign(m.__assign({}, A), {
                transform: y || "translate(" + w + "px, " + C + "px) rotate(" + S + "deg) scale(" + B + ")"
              }),
              onLoad: this.onMediaLoad
            })) : v && k.default.createElement("video", m.__assign({
              autoPlay: !0,
              loop: !0,
              muted: !0,
              className: classNames("reactEasyCrop_Video", "contain" === U && "reactEasyCrop_Contain", "horizontal-cover" === U && "reactEasyCrop_Cover_Horizontal", "vertical-cover" === U && "reactEasyCrop_Cover_Vertical", G)
            }, _, {
              ref: function ref(s) {
                return l.videoRef = s;
              },
              onLoadedMetadata: this.onMediaLoad,
              style: m.__assign(m.__assign({}, A), {
                transform: y || "translate(" + w + "px, " + C + "px) rotate(" + S + "deg) scale(" + B + ")"
              }),
              controls: !1
            }), (Array.isArray(v) ? v : [{
              src: v
            }]).map(function (l) {
              return k.default.createElement("source", m.__assign({
                key: l.src
              }, l));
            })), this.state.cropSize && k.default.createElement("div", {
              style: m.__assign(m.__assign({}, R), {
                width: this.state.cropSize.width,
                height: this.state.cropSize.height
              }),
              "data-testid": "cropper",
              className: classNames("reactEasyCrop_CropArea", "round" === P && "reactEasyCrop_CropAreaRound", O && "reactEasyCrop_CropAreaGrid", F)
            }));
          }, Cropper.defaultProps = {
            zoom: 1,
            rotation: 0,
            aspect: 4 / 3,
            maxZoom: 3,
            minZoom: 1,
            cropShape: "rect",
            objectFit: "contain",
            showGrid: !0,
            style: {},
            classes: {},
            mediaProps: {},
            zoomSpeed: 1,
            restrictPosition: !0,
            zoomWithScroll: !0
          }, Cropper.getMousePoint = function (l) {
            return {
              x: Number(l.clientX),
              y: Number(l.clientY)
            };
          }, Cropper.getTouchPoint = function (l) {
            return {
              x: Number(l.clientX),
              y: Number(l.clientY)
            };
          }, Cropper;
        }(k.default.Component);

        l.exports = E;
      },
      755: function _(l, s, c) {
        "use strict";

        c.r(s), c.d(s, {
          __extends: function __extends() {
            return _extends2;
          },
          __assign: function __assign() {
            return _assign2;
          },
          __rest: function __rest() {
            return _rest;
          },
          __decorate: function __decorate() {
            return _decorate;
          },
          __param: function __param() {
            return _param;
          },
          __metadata: function __metadata() {
            return _metadata;
          },
          __awaiter: function __awaiter() {
            return _awaiter;
          },
          __generator: function __generator() {
            return _generator;
          },
          __createBinding: function __createBinding() {
            return m;
          },
          __exportStar: function __exportStar() {
            return _exportStar;
          },
          __values: function __values() {
            return _values;
          },
          __read: function __read() {
            return _read;
          },
          __spread: function __spread() {
            return _spread;
          },
          __spreadArrays: function __spreadArrays() {
            return _spreadArrays;
          },
          __await: function __await() {
            return _await;
          },
          __asyncGenerator: function __asyncGenerator() {
            return _asyncGenerator;
          },
          __asyncDelegator: function __asyncDelegator() {
            return _asyncDelegator;
          },
          __asyncValues: function __asyncValues() {
            return _asyncValues;
          },
          __makeTemplateObject: function __makeTemplateObject() {
            return _makeTemplateObject;
          },
          __importStar: function __importStar() {
            return _importStar;
          },
          __importDefault: function __importDefault() {
            return _importDefault;
          },
          __classPrivateFieldGet: function __classPrivateFieldGet() {
            return _classPrivateFieldGet;
          },
          __classPrivateFieldSet: function __classPrivateFieldSet() {
            return _classPrivateFieldSet;
          }
        });

        var _extendStatics = function extendStatics(l, s) {
          return _extendStatics = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (l, s) {
            l.__proto__ = s;
          } || function (l, s) {
            for (var c in s) {
              Object.prototype.hasOwnProperty.call(s, c) && (l[c] = s[c]);
            }
          }, _extendStatics(l, s);
        };

        function _extends2(l, s) {
          function __() {
            this.constructor = l;
          }

          _extendStatics(l, s), l.prototype = null === s ? Object.create(s) : (__.prototype = s.prototype, new __());
        }

        var _assign2 = function _assign() {
          return _assign2 = Object.assign || function __assign(l) {
            for (var s, c = 1, m = arguments.length; c < m; c++) {
              for (var v in s = arguments[c]) {
                Object.prototype.hasOwnProperty.call(s, v) && (l[v] = s[v]);
              }
            }

            return l;
          }, _assign2.apply(this, arguments);
        };

        function _rest(l, s) {
          var c = {};

          for (var m in l) {
            Object.prototype.hasOwnProperty.call(l, m) && s.indexOf(m) < 0 && (c[m] = l[m]);
          }

          if (null != l && "function" == typeof Object.getOwnPropertySymbols) {
            var v = 0;

            for (m = Object.getOwnPropertySymbols(l); v < m.length; v++) {
              s.indexOf(m[v]) < 0 && Object.prototype.propertyIsEnumerable.call(l, m[v]) && (c[m[v]] = l[m[v]]);
            }
          }

          return c;
        }

        function _decorate(l, s, c, m) {
          var v,
              _ = arguments.length,
              k = _ < 3 ? s : null === m ? m = Object.getOwnPropertyDescriptor(s, c) : m;
          if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) k = Reflect.decorate(l, s, c, m);else for (var y = l.length - 1; y >= 0; y--) {
            (v = l[y]) && (k = (_ < 3 ? v(k) : _ > 3 ? v(s, c, k) : v(s, c)) || k);
          }
          return _ > 3 && k && Object.defineProperty(s, c, k), k;
        }

        function _param(l, s) {
          return function (c, m) {
            s(c, m, l);
          };
        }

        function _metadata(l, s) {
          if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(l, s);
        }

        function _awaiter(l, s, c, m) {
          return new (c || (c = Promise))(function (v, _) {
            function fulfilled(l) {
              try {
                step(m.next(l));
              } catch (l) {
                _(l);
              }
            }

            function rejected(l) {
              try {
                step(m.throw(l));
              } catch (l) {
                _(l);
              }
            }

            function step(l) {
              l.done ? v(l.value) : function adopt(l) {
                return l instanceof c ? l : new c(function (s) {
                  s(l);
                });
              }(l.value).then(fulfilled, rejected);
            }

            step((m = m.apply(l, s || [])).next());
          });
        }

        function _generator(l, s) {
          var c,
              m,
              v,
              _,
              k = {
            label: 0,
            sent: function sent() {
              if (1 & v[0]) throw v[1];
              return v[1];
            },
            trys: [],
            ops: []
          };

          return _ = {
            next: verb(0),
            throw: verb(1),
            return: verb(2)
          }, "function" == typeof Symbol && (_[Symbol.iterator] = function () {
            return this;
          }), _;

          function verb(_) {
            return function (y) {
              return function step(_) {
                if (c) throw new TypeError("Generator is already executing.");

                for (; k;) {
                  try {
                    if (c = 1, m && (v = 2 & _[0] ? m.return : _[0] ? m.throw || ((v = m.return) && v.call(m), 0) : m.next) && !(v = v.call(m, _[1])).done) return v;

                    switch (m = 0, v && (_ = [2 & _[0], v.value]), _[0]) {
                      case 0:
                      case 1:
                        v = _;
                        break;

                      case 4:
                        return k.label++, {
                          value: _[1],
                          done: !1
                        };

                      case 5:
                        k.label++, m = _[1], _ = [0];
                        continue;

                      case 7:
                        _ = k.ops.pop(), k.trys.pop();
                        continue;

                      default:
                        if (!(v = k.trys, (v = v.length > 0 && v[v.length - 1]) || 6 !== _[0] && 2 !== _[0])) {
                          k = 0;
                          continue;
                        }

                        if (3 === _[0] && (!v || _[1] > v[0] && _[1] < v[3])) {
                          k.label = _[1];
                          break;
                        }

                        if (6 === _[0] && k.label < v[1]) {
                          k.label = v[1], v = _;
                          break;
                        }

                        if (v && k.label < v[2]) {
                          k.label = v[2], k.ops.push(_);
                          break;
                        }

                        v[2] && k.ops.pop(), k.trys.pop();
                        continue;
                    }

                    _ = s.call(l, k);
                  } catch (l) {
                    _ = [6, l], m = 0;
                  } finally {
                    c = v = 0;
                  }
                }

                if (5 & _[0]) throw _[1];
                return {
                  value: _[0] ? _[1] : void 0,
                  done: !0
                };
              }([_, y]);
            };
          }
        }

        var m = Object.create ? function (l, s, c, m) {
          void 0 === m && (m = c), Object.defineProperty(l, m, {
            enumerable: !0,
            get: function get() {
              return s[c];
            }
          });
        } : function (l, s, c, m) {
          void 0 === m && (m = c), l[m] = s[c];
        };

        function _exportStar(l, s) {
          for (var c in l) {
            "default" === c || Object.prototype.hasOwnProperty.call(s, c) || m(s, l, c);
          }
        }

        function _values(l) {
          var s = "function" == typeof Symbol && Symbol.iterator,
              c = s && l[s],
              m = 0;
          if (c) return c.call(l);
          if (l && "number" == typeof l.length) return {
            next: function next() {
              return l && m >= l.length && (l = void 0), {
                value: l && l[m++],
                done: !l
              };
            }
          };
          throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }

        function _read(l, s) {
          var c = "function" == typeof Symbol && l[Symbol.iterator];
          if (!c) return l;

          var m,
              v,
              _ = c.call(l),
              k = [];

          try {
            for (; (void 0 === s || s-- > 0) && !(m = _.next()).done;) {
              k.push(m.value);
            }
          } catch (l) {
            v = {
              error: l
            };
          } finally {
            try {
              m && !m.done && (c = _.return) && c.call(_);
            } finally {
              if (v) throw v.error;
            }
          }

          return k;
        }

        function _spread() {
          for (var l = [], s = 0; s < arguments.length; s++) {
            l = l.concat(_read(arguments[s]));
          }

          return l;
        }

        function _spreadArrays() {
          for (var l = 0, s = 0, c = arguments.length; s < c; s++) {
            l += arguments[s].length;
          }

          var m = Array(l),
              v = 0;

          for (s = 0; s < c; s++) {
            for (var _ = arguments[s], k = 0, y = _.length; k < y; k++, v++) {
              m[v] = _[k];
            }
          }

          return m;
        }

        function _await(l) {
          return this instanceof _await ? (this.v = l, this) : new _await(l);
        }

        function _asyncGenerator(l, s, c) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var m,
              v = c.apply(l, s || []),
              _ = [];
          return m = {}, verb("next"), verb("throw"), verb("return"), m[Symbol.asyncIterator] = function () {
            return this;
          }, m;

          function verb(l) {
            v[l] && (m[l] = function (s) {
              return new Promise(function (c, m) {
                _.push([l, s, c, m]) > 1 || resume(l, s);
              });
            });
          }

          function resume(l, s) {
            try {
              !function step(l) {
                l.value instanceof _await ? Promise.resolve(l.value.v).then(fulfill, reject) : settle(_[0][2], l);
              }(v[l](s));
            } catch (l) {
              settle(_[0][3], l);
            }
          }

          function fulfill(l) {
            resume("next", l);
          }

          function reject(l) {
            resume("throw", l);
          }

          function settle(l, s) {
            l(s), _.shift(), _.length && resume(_[0][0], _[0][1]);
          }
        }

        function _asyncDelegator(l) {
          var s, c;
          return s = {}, verb("next"), verb("throw", function (l) {
            throw l;
          }), verb("return"), s[Symbol.iterator] = function () {
            return this;
          }, s;

          function verb(m, v) {
            s[m] = l[m] ? function (s) {
              return (c = !c) ? {
                value: _await(l[m](s)),
                done: "return" === m
              } : v ? v(s) : s;
            } : v;
          }
        }

        function _asyncValues(l) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var s,
              c = l[Symbol.asyncIterator];
          return c ? c.call(l) : (l = _values(l), s = {}, verb("next"), verb("throw"), verb("return"), s[Symbol.asyncIterator] = function () {
            return this;
          }, s);

          function verb(c) {
            s[c] = l[c] && function (s) {
              return new Promise(function (m, v) {
                (function settle(l, s, c, m) {
                  Promise.resolve(m).then(function (s) {
                    l({
                      value: s,
                      done: c
                    });
                  }, s);
                })(m, v, (s = l[c](s)).done, s.value);
              });
            };
          }
        }

        function _makeTemplateObject(l, s) {
          return Object.defineProperty ? Object.defineProperty(l, "raw", {
            value: s
          }) : l.raw = s, l;
        }

        var v = Object.create ? function (l, s) {
          Object.defineProperty(l, "default", {
            enumerable: !0,
            value: s
          });
        } : function (l, s) {
          l.default = s;
        };

        function _importStar(l) {
          if (l && l.__esModule) return l;
          var s = {};
          if (null != l) for (var c in l) {
            "default" !== c && Object.prototype.hasOwnProperty.call(l, c) && m(s, l, c);
          }
          return v(s, l), s;
        }

        function _importDefault(l) {
          return l && l.__esModule ? l : {
            default: l
          };
        }

        function _classPrivateFieldGet(l, s) {
          if (!s.has(l)) throw new TypeError("attempted to get private field on non-instance");
          return s.get(l);
        }

        function _classPrivateFieldSet(l, s, c) {
          if (!s.has(l)) throw new TypeError("attempted to set private field on non-instance");
          return s.set(l, c), c;
        }
      },
      8235: function _(l, s, c) {
        "use strict";

        var m, v;

        function arrayOf(l) {
          return [l];
        }

        function createCache() {
          var l = {
            clear: function clear() {
              l.head = null;
            }
          };
          return l;
        }

        function isShallowEqual(l, s, c) {
          var m;
          if (l.length !== s.length) return !1;

          for (m = c; m < l.length; m++) {
            if (l[m] !== s[m]) return !1;
          }

          return !0;
        }

        function __WEBPACK_DEFAULT_EXPORT__(l, s) {
          var c, _;

          function clear() {
            c = v ? new WeakMap() : createCache();
          }

          function callSelector() {
            var c,
                m,
                v,
                k,
                y,
                E = arguments.length;

            for (k = new Array(E), v = 0; v < E; v++) {
              k[v] = arguments[v];
            }

            for (y = s.apply(null, k), (c = _(y)).isUniqueByDependants || (c.lastDependants && !isShallowEqual(y, c.lastDependants, 0) && c.clear(), c.lastDependants = y), m = c.head; m;) {
              if (isShallowEqual(m.args, k, 1)) return m !== c.head && (m.prev.next = m.next, m.next && (m.next.prev = m.prev), m.next = c.head, m.prev = null, c.head.prev = m, c.head = m), m.val;
              m = m.next;
            }

            return m = {
              val: l.apply(null, k)
            }, k[0] = null, m.args = k, c.head && (c.head.prev = m, m.next = c.head), c.head = m, m.val;
          }

          return s || (s = arrayOf), _ = v ? function getWeakMapCache(l) {
            var s,
                v,
                _,
                k,
                y,
                E = c,
                w = !0;

            for (s = 0; s < l.length; s++) {
              if (v = l[s], !(y = v) || "object" != typeof y) {
                w = !1;
                break;
              }

              E.has(v) ? E = E.get(v) : (_ = new WeakMap(), E.set(v, _), E = _);
            }

            return E.has(m) || ((k = createCache()).isUniqueByDependants = w, E.set(m, k)), E.get(m);
          } : function getRootCache() {
            return c;
          }, callSelector.getDependants = s, callSelector.clear = clear, clear(), callSelector;
        }

        c.r(s), c.d(s, {
          default: function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
        }), m = {}, v = "undefined" != typeof WeakMap;
      },
      9004: function _(l) {
        var s = l.exports = function (l) {
          return new Traverse(l);
        };

        function Traverse(l) {
          this.value = l;
        }

        function walk(l, s, _) {
          var k = [],
              y = [],
              E = !0;
          return function walker(l) {
            var w = _ ? copy(l) : l,
                C = {},
                S = !0,
                B = {
              node: w,
              node_: l,
              path: [].concat(k),
              parent: y[y.length - 1],
              parents: y,
              key: k.slice(-1)[0],
              isRoot: 0 === k.length,
              level: k.length,
              circular: null,
              update: function update(l, s) {
                B.isRoot || (B.parent.node[B.key] = l), B.node = l, s && (S = !1);
              },
              delete: function _delete(l) {
                delete B.parent.node[B.key], l && (S = !1);
              },
              remove: function remove(l) {
                m(B.parent.node) ? B.parent.node.splice(B.key, 1) : delete B.parent.node[B.key], l && (S = !1);
              },
              keys: null,
              before: function before(l) {
                C.before = l;
              },
              after: function after(l) {
                C.after = l;
              },
              pre: function pre(l) {
                C.pre = l;
              },
              post: function post(l) {
                C.post = l;
              },
              stop: function stop() {
                E = !1;
              },
              block: function block() {
                S = !1;
              }
            };
            if (!E) return B;

            function updateState() {
              if ("object" == typeof B.node && null !== B.node) {
                B.keys && B.node_ === B.node || (B.keys = c(B.node)), B.isLeaf = 0 == B.keys.length;

                for (var s = 0; s < y.length; s++) {
                  if (y[s].node_ === l) {
                    B.circular = y[s];
                    break;
                  }
                }
              } else B.isLeaf = !0, B.keys = null;

              B.notLeaf = !B.isLeaf, B.notRoot = !B.isRoot;
            }

            updateState();
            var P = s.call(B, B.node);
            return void 0 !== P && B.update && B.update(P), C.before && C.before.call(B, B.node), S ? ("object" != typeof B.node || null === B.node || B.circular || (y.push(B), updateState(), forEach(B.keys, function (l, s) {
              k.push(l), C.pre && C.pre.call(B, B.node[l], l);
              var c = walker(B.node[l]);
              _ && v.call(B.node, l) && (B.node[l] = c.node), c.isLast = s == B.keys.length - 1, c.isFirst = 0 == s, C.post && C.post.call(B, c), k.pop();
            }), y.pop()), C.after && C.after.call(B, B.node), B) : B;
          }(l).node;
        }

        function copy(l) {
          if ("object" == typeof l && null !== l) {
            var s;
            if (m(l)) s = [];else if (function isDate(l) {
              return "[object Date]" === toS(l);
            }(l)) s = new Date(l.getTime ? l.getTime() : l);else if (function isRegExp(l) {
              return "[object RegExp]" === toS(l);
            }(l)) s = new RegExp(l);else if (function isError(l) {
              return "[object Error]" === toS(l);
            }(l)) s = {
              message: l.message
            };else if (function isBoolean(l) {
              return "[object Boolean]" === toS(l);
            }(l)) s = new Boolean(l);else if (function isNumber(l) {
              return "[object Number]" === toS(l);
            }(l)) s = new Number(l);else if (function isString(l) {
              return "[object String]" === toS(l);
            }(l)) s = new String(l);else if (Object.create && Object.getPrototypeOf) s = Object.create(Object.getPrototypeOf(l));else if (l.constructor === Object) s = {};else {
              var v = l.constructor && l.constructor.prototype || l.__proto__ || {},
                  T = function T() {};

              T.prototype = v, s = new T();
            }
            return forEach(c(l), function (c) {
              s[c] = l[c];
            }), s;
          }

          return l;
        }

        Traverse.prototype.get = function (l) {
          for (var s = this.value, c = 0; c < l.length; c++) {
            var m = l[c];

            if (!s || !v.call(s, m)) {
              s = void 0;
              break;
            }

            s = s[m];
          }

          return s;
        }, Traverse.prototype.has = function (l) {
          for (var s = this.value, c = 0; c < l.length; c++) {
            var m = l[c];
            if (!s || !v.call(s, m)) return !1;
            s = s[m];
          }

          return !0;
        }, Traverse.prototype.set = function (l, s) {
          for (var c = this.value, m = 0; m < l.length - 1; m++) {
            var _ = l[m];
            v.call(c, _) || (c[_] = {}), c = c[_];
          }

          return c[l[m]] = s, s;
        }, Traverse.prototype.map = function (l) {
          return walk(this.value, l, !0);
        }, Traverse.prototype.forEach = function (l) {
          return this.value = walk(this.value, l, !1), this.value;
        }, Traverse.prototype.reduce = function (l, s) {
          var c = 1 === arguments.length,
              m = c ? this.value : s;
          return this.forEach(function (s) {
            this.isRoot && c || (m = l.call(this, m, s));
          }), m;
        }, Traverse.prototype.paths = function () {
          var l = [];
          return this.forEach(function (s) {
            l.push(this.path);
          }), l;
        }, Traverse.prototype.nodes = function () {
          var l = [];
          return this.forEach(function (s) {
            l.push(this.node);
          }), l;
        }, Traverse.prototype.clone = function () {
          var l = [],
              s = [];
          return function clone(m) {
            for (var v = 0; v < l.length; v++) {
              if (l[v] === m) return s[v];
            }

            if ("object" == typeof m && null !== m) {
              var _ = copy(m);

              return l.push(m), s.push(_), forEach(c(m), function (l) {
                _[l] = clone(m[l]);
              }), l.pop(), s.pop(), _;
            }

            return m;
          }(this.value);
        };

        var c = Object.keys || function keys(l) {
          var s = [];

          for (var c in l) {
            s.push(c);
          }

          return s;
        };

        function toS(l) {
          return Object.prototype.toString.call(l);
        }

        var m = Array.isArray || function isArray(l) {
          return "[object Array]" === Object.prototype.toString.call(l);
        },
            forEach = function forEach(l, s) {
          if (l.forEach) return l.forEach(s);

          for (var c = 0; c < l.length; c++) {
            s(l[c], c, l);
          }
        };

        forEach(c(Traverse.prototype), function (l) {
          s[l] = function (s) {
            var c = [].slice.call(arguments, 1),
                m = new Traverse(s);
            return m[l].apply(m, c);
          };
        });

        var v = Object.hasOwnProperty || function (l, s) {
          return s in l;
        };
      },
      9773: function _(l) {
        "use strict";

        l.exports = require("@wordpress/a11y");
      },
      507: function _(l) {
        "use strict";

        l.exports = require("@wordpress/api-fetch");
      },
      9388: function _(l) {
        "use strict";

        l.exports = require("@wordpress/blob");
      },
      6700: function _(l) {
        "use strict";

        l.exports = require("@wordpress/blocks");
      },
      4892: function _(l) {
        "use strict";

        l.exports = require("@wordpress/components");
      },
      3200: function _(l) {
        "use strict";

        l.exports = require("@wordpress/compose");
      },
      8467: function _(l) {
        "use strict";

        l.exports = require("@wordpress/data");
      },
      3703: function _(l) {
        "use strict";

        l.exports = require("@wordpress/deprecated");
      },
      5480: function _(l) {
        "use strict";

        l.exports = require("@wordpress/dom");
      },
      1753: function _(l) {
        "use strict";

        l.exports = require("@wordpress/element");
      },
      1149: function _(l) {
        "use strict";

        l.exports = require("@wordpress/hooks");
      },
      3248: function _(l) {
        "use strict";

        l.exports = require("@wordpress/html-entities");
      },
      6756: function _(l) {
        "use strict";

        l.exports = require("@wordpress/i18n");
      },
      626: function _(l) {
        "use strict";

        l.exports = require("@wordpress/is-shallow-equal");
      },
      2470: function _(l) {
        "use strict";

        l.exports = require("@wordpress/keyboard-shortcuts");
      },
      9880: function _(l) {
        "use strict";

        l.exports = require("@wordpress/keycodes");
      },
      8448: function _(l) {
        "use strict";

        l.exports = require("@wordpress/notices");
      },
      7060: function _(l) {
        "use strict";

        l.exports = require("@wordpress/rich-text");
      },
      2063: function _(l) {
        "use strict";

        l.exports = require("@wordpress/shortcode");
      },
      410: function _(l) {
        "use strict";

        l.exports = require("@wordpress/token-list");
      },
      904: function _(l) {
        "use strict";

        l.exports = require("@wordpress/url");
      },
      2793: function _(l) {
        "use strict";

        l.exports = require("@wordpress/warning");
      },
      224: function _(l) {
        "use strict";

        l.exports = require("@wordpress/wordcount");
      },
      4793: function _(l) {
        "use strict";

        l.exports = require("lodash");
      },
      9497: function _(l) {
        "use strict";

        l.exports = require("react");
      },
      7137: function _(l) {
        "use strict";

        l.exports = require("react-dom");
      }
    },
        s = {};

    function __webpack_require__(c) {
      var m = s[c];
      if (void 0 !== m) return m.exports;
      var v = s[c] = {
        exports: {}
      };
      return l[c].call(v.exports, v, v.exports, __webpack_require__), v.exports;
    }

    return __webpack_require__.n = function (l) {
      var s = l && l.__esModule ? function () {
        return l.default;
      } : function () {
        return l;
      };
      return __webpack_require__.d(s, {
        a: s
      }), s;
    }, __webpack_require__.d = function (l, s) {
      for (var c in s) {
        __webpack_require__.o(s, c) && !__webpack_require__.o(l, c) && Object.defineProperty(l, c, {
          enumerable: !0,
          get: s[c]
        });
      }
    }, __webpack_require__.o = function (l, s) {
      return Object.prototype.hasOwnProperty.call(l, s);
    }, __webpack_require__.r = function (l) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(l, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(l, "__esModule", {
        value: !0
      });
    }, __webpack_require__(7686);
  }();
});